var cb = Object.defineProperty;
var hb = (t, e, r) => e in t ? cb(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var st = (t, e, r) => (hb(t, typeof e != "symbol" ? e + "" : e, r), r);
var Zi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function fb(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function uv(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      if (this instanceof n) {
        var i = [null];
        i.push.apply(i, arguments);
        var a = Function.bind.apply(e, i);
        return new a();
      }
      return e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
var ls;
typeof window < "u" ? ls = window : typeof Zi < "u" ? ls = Zi : typeof self < "u" ? ls = self : ls = {};
var M = ls;
const pb = {}, gb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pb
}, Symbol.toStringTag, { value: "Module" })), mb = /* @__PURE__ */ uv(gb);
var Xf = typeof Zi < "u" ? Zi : typeof window < "u" ? window : {}, vb = mb, ds;
typeof document < "u" ? ds = document : (ds = Xf["__GLOBAL_DOCUMENT_CACHE@4"], ds || (ds = Xf["__GLOBAL_DOCUMENT_CACHE@4"] = vb));
var oe = ds;
function Vi() {
  return Vi = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
    }
    return t;
  }, Vi.apply(this, arguments);
}
var Yo = {}, yb = {
  get exports() {
    return Yo;
  },
  set exports(t) {
    Yo = t;
  }
};
(function(t, e) {
  function r(u) {
    if (u && typeof u == "object") {
      var l = u.which || u.keyCode || u.charCode;
      l && (u = l);
    }
    if (typeof u == "number")
      return s[u];
    var d = String(u), h = n[d.toLowerCase()];
    if (h)
      return h;
    var h = i[d.toLowerCase()];
    if (h)
      return h;
    if (d.length === 1)
      return d.charCodeAt(0);
  }
  r.isEventKey = function(l, d) {
    if (l && typeof l == "object") {
      var h = l.which || l.keyCode || l.charCode;
      if (h == null)
        return !1;
      if (typeof d == "string") {
        var f = n[d.toLowerCase()];
        if (f)
          return f === h;
        var f = i[d.toLowerCase()];
        if (f)
          return f === h;
      } else if (typeof d == "number")
        return d === h;
      return !1;
    }
  }, e = t.exports = r;
  var n = e.code = e.codes = {
    backspace: 8,
    tab: 9,
    enter: 13,
    shift: 16,
    ctrl: 17,
    alt: 18,
    "pause/break": 19,
    "caps lock": 20,
    esc: 27,
    space: 32,
    "page up": 33,
    "page down": 34,
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    insert: 45,
    delete: 46,
    command: 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
  }, i = e.aliases = {
    windows: 91,
    "⇧": 16,
    "⌥": 18,
    "⌃": 17,
    "⌘": 91,
    ctl: 17,
    control: 17,
    option: 18,
    pause: 19,
    break: 19,
    caps: 20,
    return: 13,
    escape: 27,
    spc: 32,
    spacebar: 32,
    pgup: 33,
    pgdn: 34,
    ins: 45,
    del: 46,
    cmd: 91
  };
  /*!
   * Programatically add the following
   */
  for (a = 97; a < 123; a++)
    n[String.fromCharCode(a)] = a - 32;
  for (var a = 48; a < 58; a++)
    n[a - 48] = a;
  for (a = 1; a < 13; a++)
    n["f" + a] = a + 111;
  for (a = 0; a < 10; a++)
    n["numpad " + a] = a + 96;
  var s = e.names = e.title = {};
  for (a in n)
    s[n[a]] = a;
  for (var o in i)
    n[o] = i[o];
})(yb, Yo);
const De = Yo;
function Le(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function ya(t, e) {
  return ya = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, ya(t, e);
}
function le(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, ya(t, e);
}
var _b = Tb;
function Tb(t, e) {
  var r, n = null;
  try {
    r = JSON.parse(t, e);
  } catch (i) {
    n = i;
  }
  return [n, r];
}
var xs = {}, bb = {
  get exports() {
    return xs;
  },
  set exports(t) {
    xs = t;
  }
}, nc = {}, Sb = {
  get exports() {
    return nc;
  },
  set exports(t) {
    nc = t;
  }
};
(function(t) {
  function e() {
    return t.exports = e = Object.assign ? Object.assign.bind() : function(r) {
      for (var n = 1; n < arguments.length; n++) {
        var i = arguments[n];
        for (var a in i)
          Object.prototype.hasOwnProperty.call(i, a) && (r[a] = i[a]);
      }
      return r;
    }, t.exports.__esModule = !0, t.exports.default = t.exports, e.apply(this, arguments);
  }
  t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
})(Sb);
var Eb = Cb, xb = Object.prototype.toString;
function Cb(t) {
  if (!t)
    return !1;
  var e = xb.call(t);
  return e === "[object Function]" || typeof t == "function" && e !== "[object RegExp]" || typeof window < "u" && // IE8 and below
  (t === window.setTimeout || t === window.alert || t === window.confirm || t === window.prompt);
}
var Ab = M, wb = function(e, r) {
  return r === void 0 && (r = !1), function(n, i, a) {
    if (n) {
      e(n);
      return;
    }
    if (i.statusCode >= 400 && i.statusCode <= 599) {
      var s = a;
      if (r)
        if (Ab.TextDecoder) {
          var o = Pb(i.headers && i.headers["content-type"]);
          try {
            s = new TextDecoder(o).decode(a);
          } catch {
          }
        } else
          s = String.fromCharCode.apply(null, new Uint8Array(a));
      e({
        cause: s
      });
      return;
    }
    e(null, a);
  };
};
function Pb(t) {
  return t === void 0 && (t = ""), t.toLowerCase().split(";").reduce(function(e, r) {
    var n = r.split("="), i = n[0], a = n[1];
    return i.trim() === "charset" ? a.trim() : e;
  }, "utf-8");
}
var kb = wb, lv = M, Lb = nc, Ib = Eb;
rr.httpHandler = kb;
/**
 * @license
 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
 * Copyright (c) 2014 David Björklund
 * Available under the MIT license
 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
 */
var Db = function(e) {
  var r = {};
  return e && e.trim().split(`
`).forEach(function(n) {
    var i = n.indexOf(":"), a = n.slice(0, i).trim().toLowerCase(), s = n.slice(i + 1).trim();
    typeof r[a] > "u" ? r[a] = s : Array.isArray(r[a]) ? r[a].push(s) : r[a] = [r[a], s];
  }), r;
};
bb.exports = rr;
xs.default = rr;
rr.XMLHttpRequest = lv.XMLHttpRequest || Nb;
rr.XDomainRequest = "withCredentials" in new rr.XMLHttpRequest() ? rr.XMLHttpRequest : lv.XDomainRequest;
Rb(["get", "put", "post", "patch", "head", "delete"], function(t) {
  rr[t === "delete" ? "del" : t] = function(e, r, n) {
    return r = dv(e, r, n), r.method = t.toUpperCase(), cv(r);
  };
});
function Rb(t, e) {
  for (var r = 0; r < t.length; r++)
    e(t[r]);
}
function Ob(t) {
  for (var e in t)
    if (t.hasOwnProperty(e))
      return !1;
  return !0;
}
function dv(t, e, r) {
  var n = t;
  return Ib(e) ? (r = e, typeof t == "string" && (n = {
    uri: t
  })) : n = Lb({}, e, {
    uri: t
  }), n.callback = r, n;
}
function rr(t, e, r) {
  return e = dv(t, e, r), cv(e);
}
function cv(t) {
  if (typeof t.callback > "u")
    throw new Error("callback argument missing");
  var e = !1, r = function(D, C, w) {
    e || (e = !0, t.callback(D, C, w));
  };
  function n() {
    o.readyState === 4 && setTimeout(s, 0);
  }
  function i() {
    var R = void 0;
    if (o.response ? R = o.response : R = o.responseText || Mb(o), _)
      try {
        R = JSON.parse(R);
      } catch {
      }
    return R;
  }
  function a(R) {
    return clearTimeout(y), R instanceof Error || (R = new Error("" + (R || "Unknown XMLHttpRequest Error"))), R.statusCode = 0, r(R, E);
  }
  function s() {
    if (!l) {
      var R;
      clearTimeout(y), t.useXDR && o.status === void 0 ? R = 200 : R = o.status === 1223 ? 204 : o.status;
      var D = E, C = null;
      return R !== 0 ? (D = {
        body: i(),
        statusCode: R,
        method: h,
        headers: {},
        url: d,
        rawRequest: o
      }, o.getAllResponseHeaders && (D.headers = Db(o.getAllResponseHeaders()))) : C = new Error("Internal XMLHttpRequest Error"), r(C, D, D.body);
    }
  }
  var o = t.xhr || null;
  o || (t.cors || t.useXDR ? o = new rr.XDomainRequest() : o = new rr.XMLHttpRequest());
  var u, l, d = o.url = t.uri || t.url, h = o.method = t.method || "GET", f = t.body || t.data, v = o.headers = t.headers || {}, b = !!t.sync, _ = !1, y, E = {
    body: void 0,
    headers: {},
    statusCode: 0,
    method: h,
    url: d,
    rawRequest: o
  };
  if ("json" in t && t.json !== !1 && (_ = !0, v.accept || v.Accept || (v.Accept = "application/json"), h !== "GET" && h !== "HEAD" && (v["content-type"] || v["Content-Type"] || (v["Content-Type"] = "application/json"), f = JSON.stringify(t.json === !0 ? f : t.json))), o.onreadystatechange = n, o.onload = s, o.onerror = a, o.onprogress = function() {
  }, o.onabort = function() {
    l = !0;
  }, o.ontimeout = a, o.open(h, d, !b, t.username, t.password), b || (o.withCredentials = !!t.withCredentials), !b && t.timeout > 0 && (y = setTimeout(function() {
    if (!l) {
      l = !0, o.abort("timeout");
      var R = new Error("XMLHttpRequest timeout");
      R.code = "ETIMEDOUT", a(R);
    }
  }, t.timeout)), o.setRequestHeader)
    for (u in v)
      v.hasOwnProperty(u) && o.setRequestHeader(u, v[u]);
  else if (t.headers && !Ob(t.headers))
    throw new Error("Headers cannot be set on an XDomainRequest object");
  return "responseType" in t && (o.responseType = t.responseType), "beforeSend" in t && typeof t.beforeSend == "function" && t.beforeSend(o), o.send(f || null), o;
}
function Mb(t) {
  try {
    if (t.responseType === "document")
      return t.responseXML;
    var e = t.responseXML && t.responseXML.documentElement.nodeName === "parsererror";
    if (t.responseType === "" && !e)
      return t.responseXML;
  } catch {
  }
  return null;
}
function Nb() {
}
var Qo = {}, Bb = {
  get exports() {
    return Qo;
  },
  set exports(t) {
    Qo = t;
  }
}, Yf = oe, th = Object.create || function() {
  function t() {
  }
  return function(e) {
    if (arguments.length !== 1)
      throw new Error("Object.create shim only accepts one parameter.");
    return t.prototype = e, new t();
  };
}();
function Si(t, e) {
  this.name = "ParsingError", this.code = t.code, this.message = e || t.message;
}
Si.prototype = th(Error.prototype);
Si.prototype.constructor = Si;
Si.Errors = {
  BadSignature: {
    code: 0,
    message: "Malformed WebVTT signature."
  },
  BadTimeStamp: {
    code: 1,
    message: "Malformed time stamp."
  }
};
function ih(t) {
  function e(n, i, a, s) {
    return (n | 0) * 3600 + (i | 0) * 60 + (a | 0) + (s | 0) / 1e3;
  }
  var r = t.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
  return r ? r[3] ? e(r[1], r[2], r[3].replace(":", ""), r[4]) : r[1] > 59 ? e(r[1], r[2], 0, r[4]) : e(0, r[1], r[2], r[4]) : null;
}
function ys() {
  this.values = th(null);
}
ys.prototype = {
  // Only accept the first assignment to any key.
  set: function(t, e) {
    !this.get(t) && e !== "" && (this.values[t] = e);
  },
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get: function(t, e, r) {
    return r ? this.has(t) ? this.values[t] : e[r] : this.has(t) ? this.values[t] : e;
  },
  // Check whether we have a value for a key.
  has: function(t) {
    return t in this.values;
  },
  // Accept a setting if its one of the given alternatives.
  alt: function(t, e, r) {
    for (var n = 0; n < r.length; ++n)
      if (e === r[n]) {
        this.set(t, e);
        break;
      }
  },
  // Accept a setting if its a valid (signed) integer.
  integer: function(t, e) {
    /^-?\d+$/.test(e) && this.set(t, parseInt(e, 10));
  },
  // Accept a setting if its a valid percentage.
  percent: function(t, e) {
    return e.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (e = parseFloat(e), e >= 0 && e <= 100) ? (this.set(t, e), !0) : !1;
  }
};
function cs(t, e, r, n) {
  var i = n ? t.split(n) : [t];
  for (var a in i)
    if (typeof i[a] == "string") {
      var s = i[a].split(r);
      if (s.length === 2) {
        var o = s[0].trim(), u = s[1].trim();
        e(o, u);
      }
    }
}
function Fb(t, e, r) {
  var n = t;
  function i() {
    var o = ih(t);
    if (o === null)
      throw new Si(
        Si.Errors.BadTimeStamp,
        "Malformed timestamp: " + n
      );
    return t = t.replace(/^[^\sa-zA-Z-]+/, ""), o;
  }
  function a(o, u) {
    var l = new ys();
    cs(o, function(d, h) {
      switch (d) {
        case "region":
          for (var f = r.length - 1; f >= 0; f--)
            if (r[f].id === h) {
              l.set(d, r[f].region);
              break;
            }
          break;
        case "vertical":
          l.alt(d, h, ["rl", "lr"]);
          break;
        case "line":
          var v = h.split(","), b = v[0];
          l.integer(d, b), l.percent(d, b) && l.set("snapToLines", !1), l.alt(d, b, ["auto"]), v.length === 2 && l.alt("lineAlign", v[1], ["start", "center", "end"]);
          break;
        case "position":
          v = h.split(","), l.percent(d, v[0]), v.length === 2 && l.alt("positionAlign", v[1], ["start", "center", "end"]);
          break;
        case "size":
          l.percent(d, h);
          break;
        case "align":
          l.alt(d, h, ["start", "center", "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), u.region = l.get("region", null), u.vertical = l.get("vertical", "");
    try {
      u.line = l.get("line", "auto");
    } catch {
    }
    u.lineAlign = l.get("lineAlign", "start"), u.snapToLines = l.get("snapToLines", !0), u.size = l.get("size", 100);
    try {
      u.align = l.get("align", "center");
    } catch {
      u.align = l.get("align", "middle");
    }
    try {
      u.position = l.get("position", "auto");
    } catch {
      u.position = l.get("position", {
        start: 0,
        left: 0,
        center: 50,
        middle: 50,
        end: 100,
        right: 100
      }, u.align);
    }
    u.positionAlign = l.get("positionAlign", {
      start: "start",
      left: "start",
      center: "center",
      middle: "center",
      end: "end",
      right: "end"
    }, u.align);
  }
  function s() {
    t = t.replace(/^\s+/, "");
  }
  if (s(), e.startTime = i(), s(), t.substr(0, 3) !== "-->")
    throw new Si(
      Si.Errors.BadTimeStamp,
      "Malformed time stamp (time stamps must be separated by '-->'): " + n
    );
  t = t.substr(3), s(), e.endTime = i(), s(), a(t, e);
}
var Cl = Yf.createElement && Yf.createElement("textarea"), Ub = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span"
}, Qf = {
  white: "rgba(255,255,255,1)",
  lime: "rgba(0,255,0,1)",
  cyan: "rgba(0,255,255,1)",
  red: "rgba(255,0,0,1)",
  yellow: "rgba(255,255,0,1)",
  magenta: "rgba(255,0,255,1)",
  blue: "rgba(0,0,255,1)",
  black: "rgba(0,0,0,1)"
}, Vb = {
  v: "title",
  lang: "lang"
}, Jf = {
  rt: "ruby"
};
function hv(t, e) {
  function r() {
    if (!e)
      return null;
    function b(y) {
      return e = e.substr(y.length), y;
    }
    var _ = e.match(/^([^<]*)(<[^>]*>?)?/);
    return b(_[1] ? _[1] : _[2]);
  }
  function n(b) {
    return Cl.innerHTML = b, b = Cl.textContent, Cl.textContent = "", b;
  }
  function i(b, _) {
    return !Jf[_.localName] || Jf[_.localName] === b.localName;
  }
  function a(b, _) {
    var y = Ub[b];
    if (!y)
      return null;
    var E = t.document.createElement(y), R = Vb[b];
    return R && _ && (E[R] = _.trim()), E;
  }
  for (var s = t.document.createElement("div"), o = s, u, l = []; (u = r()) !== null; ) {
    if (u[0] === "<") {
      if (u[1] === "/") {
        l.length && l[l.length - 1] === u.substr(2).replace(">", "") && (l.pop(), o = o.parentNode);
        continue;
      }
      var d = ih(u.substr(1, u.length - 2)), h;
      if (d) {
        h = t.document.createProcessingInstruction("timestamp", d), o.appendChild(h);
        continue;
      }
      var f = u.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
      if (!f || (h = a(f[1], f[3]), !h) || !i(o, h))
        continue;
      if (f[2]) {
        var v = f[2].split(".");
        v.forEach(function(b) {
          var _ = /^bg_/.test(b), y = _ ? b.slice(3) : b;
          if (Qf.hasOwnProperty(y)) {
            var E = _ ? "background-color" : "color", R = Qf[y];
            h.style[E] = R;
          }
        }), h.className = v.join(" ");
      }
      l.push(f[1]), o.appendChild(h), o = h;
      continue;
    }
    o.appendChild(t.document.createTextNode(n(u)));
  }
  return s;
}
var Zf = [
  [1470, 1470],
  [1472, 1472],
  [1475, 1475],
  [1478, 1478],
  [1488, 1514],
  [1520, 1524],
  [1544, 1544],
  [1547, 1547],
  [1549, 1549],
  [1563, 1563],
  [1566, 1610],
  [1645, 1647],
  [1649, 1749],
  [1765, 1766],
  [1774, 1775],
  [1786, 1805],
  [1807, 1808],
  [1810, 1839],
  [1869, 1957],
  [1969, 1969],
  [1984, 2026],
  [2036, 2037],
  [2042, 2042],
  [2048, 2069],
  [2074, 2074],
  [2084, 2084],
  [2088, 2088],
  [2096, 2110],
  [2112, 2136],
  [2142, 2142],
  [2208, 2208],
  [2210, 2220],
  [8207, 8207],
  [64285, 64285],
  [64287, 64296],
  [64298, 64310],
  [64312, 64316],
  [64318, 64318],
  [64320, 64321],
  [64323, 64324],
  [64326, 64449],
  [64467, 64829],
  [64848, 64911],
  [64914, 64967],
  [65008, 65020],
  [65136, 65140],
  [65142, 65276],
  [67584, 67589],
  [67592, 67592],
  [67594, 67637],
  [67639, 67640],
  [67644, 67644],
  [67647, 67669],
  [67671, 67679],
  [67840, 67867],
  [67872, 67897],
  [67903, 67903],
  [67968, 68023],
  [68030, 68031],
  [68096, 68096],
  [68112, 68115],
  [68117, 68119],
  [68121, 68147],
  [68160, 68167],
  [68176, 68184],
  [68192, 68223],
  [68352, 68405],
  [68416, 68437],
  [68440, 68466],
  [68472, 68479],
  [68608, 68680],
  [126464, 126467],
  [126469, 126495],
  [126497, 126498],
  [126500, 126500],
  [126503, 126503],
  [126505, 126514],
  [126516, 126519],
  [126521, 126521],
  [126523, 126523],
  [126530, 126530],
  [126535, 126535],
  [126537, 126537],
  [126539, 126539],
  [126541, 126543],
  [126545, 126546],
  [126548, 126548],
  [126551, 126551],
  [126553, 126553],
  [126555, 126555],
  [126557, 126557],
  [126559, 126559],
  [126561, 126562],
  [126564, 126564],
  [126567, 126570],
  [126572, 126578],
  [126580, 126583],
  [126585, 126588],
  [126590, 126590],
  [126592, 126601],
  [126603, 126619],
  [126625, 126627],
  [126629, 126633],
  [126635, 126651],
  [1114109, 1114109]
];
function jb(t) {
  for (var e = 0; e < Zf.length; e++) {
    var r = Zf[e];
    if (t >= r[0] && t <= r[1])
      return !0;
  }
  return !1;
}
function Hb(t) {
  var e = [], r = "", n;
  if (!t || !t.childNodes)
    return "ltr";
  function i(o, u) {
    for (var l = u.childNodes.length - 1; l >= 0; l--)
      o.push(u.childNodes[l]);
  }
  function a(o) {
    if (!o || !o.length)
      return null;
    var u = o.pop(), l = u.textContent || u.innerText;
    if (l) {
      var d = l.match(/^.*(\n|\r)/);
      return d ? (o.length = 0, d[0]) : l;
    }
    if (u.tagName === "ruby")
      return a(o);
    if (u.childNodes)
      return i(o, u), a(o);
  }
  for (i(e, t); r = a(e); )
    for (var s = 0; s < r.length; s++)
      if (n = r.charCodeAt(s), jb(n))
        return "rtl";
  return "ltr";
}
function Wb(t) {
  if (typeof t.line == "number" && (t.snapToLines || t.line >= 0 && t.line <= 100))
    return t.line;
  if (!t.track || !t.track.textTrackList || !t.track.textTrackList.mediaElement)
    return -1;
  for (var e = t.track, r = e.textTrackList, n = 0, i = 0; i < r.length && r[i] !== e; i++)
    r[i].mode === "showing" && n++;
  return ++n * -1;
}
function Ru() {
}
Ru.prototype.applyStyles = function(t, e) {
  e = e || this.div;
  for (var r in t)
    t.hasOwnProperty(r) && (e.style[r] = t[r]);
};
Ru.prototype.formatStyle = function(t, e) {
  return t === 0 ? 0 : t + e;
};
function Jo(t, e, r) {
  Ru.call(this), this.cue = e, this.cueDiv = hv(t, e.text);
  var n = {
    color: "rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    position: "relative",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "inline",
    writingMode: e.vertical === "" ? "horizontal-tb" : e.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext"
  };
  this.applyStyles(n, this.cueDiv), this.div = t.document.createElement("div"), n = {
    direction: Hb(this.cueDiv),
    writingMode: e.vertical === "" ? "horizontal-tb" : e.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext",
    textAlign: e.align === "middle" ? "center" : e.align,
    font: r.font,
    whiteSpace: "pre-line",
    position: "absolute"
  }, this.applyStyles(n), this.div.appendChild(this.cueDiv);
  var i = 0;
  switch (e.positionAlign) {
    case "start":
      i = e.position;
      break;
    case "center":
      i = e.position - e.size / 2;
      break;
    case "end":
      i = e.position - e.size;
      break;
  }
  e.vertical === "" ? this.applyStyles({
    left: this.formatStyle(i, "%"),
    width: this.formatStyle(e.size, "%")
  }) : this.applyStyles({
    top: this.formatStyle(i, "%"),
    height: this.formatStyle(e.size, "%")
  }), this.move = function(a) {
    this.applyStyles({
      top: this.formatStyle(a.top, "px"),
      bottom: this.formatStyle(a.bottom, "px"),
      left: this.formatStyle(a.left, "px"),
      right: this.formatStyle(a.right, "px"),
      height: this.formatStyle(a.height, "px"),
      width: this.formatStyle(a.width, "px")
    });
  };
}
Jo.prototype = th(Ru.prototype);
Jo.prototype.constructor = Jo;
function ni(t) {
  var e, r, n, i;
  if (t.div) {
    r = t.div.offsetHeight, n = t.div.offsetWidth, i = t.div.offsetTop;
    var a = (a = t.div.childNodes) && (a = a[0]) && a.getClientRects && a.getClientRects();
    t = t.div.getBoundingClientRect(), e = a ? Math.max(a[0] && a[0].height || 0, t.height / a.length) : 0;
  }
  this.left = t.left, this.right = t.right, this.top = t.top || i, this.height = t.height || r, this.bottom = t.bottom || i + (t.height || r), this.width = t.width || n, this.lineHeight = e !== void 0 ? e : t.lineHeight;
}
ni.prototype.move = function(t, e) {
  switch (e = e !== void 0 ? e : this.lineHeight, t) {
    case "+x":
      this.left += e, this.right += e;
      break;
    case "-x":
      this.left -= e, this.right -= e;
      break;
    case "+y":
      this.top += e, this.bottom += e;
      break;
    case "-y":
      this.top -= e, this.bottom -= e;
      break;
  }
};
ni.prototype.overlaps = function(t) {
  return this.left < t.right && this.right > t.left && this.top < t.bottom && this.bottom > t.top;
};
ni.prototype.overlapsAny = function(t) {
  for (var e = 0; e < t.length; e++)
    if (this.overlaps(t[e]))
      return !0;
  return !1;
};
ni.prototype.within = function(t) {
  return this.top >= t.top && this.bottom <= t.bottom && this.left >= t.left && this.right <= t.right;
};
ni.prototype.overlapsOppositeAxis = function(t, e) {
  switch (e) {
    case "+x":
      return this.left < t.left;
    case "-x":
      return this.right > t.right;
    case "+y":
      return this.top < t.top;
    case "-y":
      return this.bottom > t.bottom;
  }
};
ni.prototype.intersectPercentage = function(t) {
  var e = Math.max(0, Math.min(this.right, t.right) - Math.max(this.left, t.left)), r = Math.max(0, Math.min(this.bottom, t.bottom) - Math.max(this.top, t.top)), n = e * r;
  return n / (this.height * this.width);
};
ni.prototype.toCSSCompatValues = function(t) {
  return {
    top: this.top - t.top,
    bottom: t.bottom - this.bottom,
    left: this.left - t.left,
    right: t.right - this.right,
    height: this.height,
    width: this.width
  };
};
ni.getSimpleBoxPosition = function(t) {
  var e = t.div ? t.div.offsetHeight : t.tagName ? t.offsetHeight : 0, r = t.div ? t.div.offsetWidth : t.tagName ? t.offsetWidth : 0, n = t.div ? t.div.offsetTop : t.tagName ? t.offsetTop : 0;
  t = t.div ? t.div.getBoundingClientRect() : t.tagName ? t.getBoundingClientRect() : t;
  var i = {
    left: t.left,
    right: t.right,
    top: t.top || n,
    height: t.height || e,
    bottom: t.bottom || n + (t.height || e),
    width: t.width || r
  };
  return i;
};
function qb(t, e, r, n) {
  function i(y, E) {
    for (var R, D = new ni(y), C = 1, w = 0; w < E.length; w++) {
      for (; y.overlapsOppositeAxis(r, E[w]) || y.within(r) && y.overlapsAny(n); )
        y.move(E[w]);
      if (y.within(r))
        return y;
      var k = y.intersectPercentage(r);
      C > k && (R = new ni(y), C = k), y = new ni(D);
    }
    return R || D;
  }
  var a = new ni(e), s = e.cue, o = Wb(s), u = [];
  if (s.snapToLines) {
    var l;
    switch (s.vertical) {
      case "":
        u = ["+y", "-y"], l = "height";
        break;
      case "rl":
        u = ["+x", "-x"], l = "width";
        break;
      case "lr":
        u = ["-x", "+x"], l = "width";
        break;
    }
    var d = a.lineHeight, h = d * Math.round(o), f = r[l] + d, v = u[0];
    Math.abs(h) > f && (h = h < 0 ? -1 : 1, h *= Math.ceil(f / d) * d), o < 0 && (h += s.vertical === "" ? r.height : r.width, u = u.reverse()), a.move(v, h);
  } else {
    var b = a.lineHeight / r.height * 100;
    switch (s.lineAlign) {
      case "center":
        o -= b / 2;
        break;
      case "end":
        o -= b;
        break;
    }
    switch (s.vertical) {
      case "":
        e.applyStyles({
          top: e.formatStyle(o, "%")
        });
        break;
      case "rl":
        e.applyStyles({
          left: e.formatStyle(o, "%")
        });
        break;
      case "lr":
        e.applyStyles({
          right: e.formatStyle(o, "%")
        });
        break;
    }
    u = ["+y", "-x", "+x", "-y"], a = new ni(e);
  }
  var _ = i(a, u);
  e.move(_.toCSSCompatValues(r));
}
function Ra() {
}
Ra.StringDecoder = function() {
  return {
    decode: function(t) {
      if (!t)
        return "";
      if (typeof t != "string")
        throw new Error("Error - expected string data.");
      return decodeURIComponent(encodeURIComponent(t));
    }
  };
};
Ra.convertCueToDOMTree = function(t, e) {
  return !t || !e ? null : hv(t, e);
};
var $b = 0.05, zb = "sans-serif", Gb = "1.5%";
Ra.processCues = function(t, e, r) {
  if (!t || !e || !r)
    return null;
  for (; r.firstChild; )
    r.removeChild(r.firstChild);
  var n = t.document.createElement("div");
  n.style.position = "absolute", n.style.left = "0", n.style.right = "0", n.style.top = "0", n.style.bottom = "0", n.style.margin = Gb, r.appendChild(n);
  function i(d) {
    for (var h = 0; h < d.length; h++)
      if (d[h].hasBeenReset || !d[h].displayState)
        return !0;
    return !1;
  }
  if (!i(e)) {
    for (var a = 0; a < e.length; a++)
      n.appendChild(e[a].displayState);
    return;
  }
  var s = [], o = ni.getSimpleBoxPosition(n), u = Math.round(o.height * $b * 100) / 100, l = {
    font: u + "px " + zb
  };
  (function() {
    for (var d, h, f = 0; f < e.length; f++)
      h = e[f], d = new Jo(t, h, l), n.appendChild(d.div), qb(t, d, o, s), h.displayState = d.div, s.push(ni.getSimpleBoxPosition(d));
  })();
};
Ra.Parser = function(t, e, r) {
  r || (r = e, e = {}), e || (e = {}), this.window = t, this.vttjs = e, this.state = "INITIAL", this.buffer = "", this.decoder = r || new TextDecoder("utf8"), this.regionList = [];
};
Ra.Parser.prototype = {
  // If the error is a ParsingError then report it to the consumer if
  // possible. If it's not a ParsingError then throw it like normal.
  reportOrThrowError: function(t) {
    if (t instanceof Si)
      this.onparsingerror && this.onparsingerror(t);
    else
      throw t;
  },
  parse: function(t) {
    var e = this;
    t && (e.buffer += e.decoder.decode(t, { stream: !0 }));
    function r() {
      for (var d = e.buffer, h = 0; h < d.length && d[h] !== "\r" && d[h] !== `
`; )
        ++h;
      var f = d.substr(0, h);
      return d[h] === "\r" && ++h, d[h] === `
` && ++h, e.buffer = d.substr(h), f;
    }
    function n(d) {
      var h = new ys();
      if (cs(d, function(v, b) {
        switch (v) {
          case "id":
            h.set(v, b);
            break;
          case "width":
            h.percent(v, b);
            break;
          case "lines":
            h.integer(v, b);
            break;
          case "regionanchor":
          case "viewportanchor":
            var _ = b.split(",");
            if (_.length !== 2)
              break;
            var y = new ys();
            if (y.percent("x", _[0]), y.percent("y", _[1]), !y.has("x") || !y.has("y"))
              break;
            h.set(v + "X", y.get("x")), h.set(v + "Y", y.get("y"));
            break;
          case "scroll":
            h.alt(v, b, ["up"]);
            break;
        }
      }, /=/, /\s/), h.has("id")) {
        var f = new (e.vttjs.VTTRegion || e.window.VTTRegion)();
        f.width = h.get("width", 100), f.lines = h.get("lines", 3), f.regionAnchorX = h.get("regionanchorX", 0), f.regionAnchorY = h.get("regionanchorY", 100), f.viewportAnchorX = h.get("viewportanchorX", 0), f.viewportAnchorY = h.get("viewportanchorY", 100), f.scroll = h.get("scroll", ""), e.onregion && e.onregion(f), e.regionList.push({
          id: h.get("id"),
          region: f
        });
      }
    }
    function i(d) {
      var h = new ys();
      cs(d, function(f, v) {
        switch (f) {
          case "MPEGT":
            h.integer(f + "S", v);
            break;
          case "LOCA":
            h.set(f + "L", ih(v));
            break;
        }
      }, /[^\d]:/, /,/), e.ontimestampmap && e.ontimestampmap({
        MPEGTS: h.get("MPEGTS"),
        LOCAL: h.get("LOCAL")
      });
    }
    function a(d) {
      d.match(/X-TIMESTAMP-MAP/) ? cs(d, function(h, f) {
        switch (h) {
          case "X-TIMESTAMP-MAP":
            i(f);
            break;
        }
      }, /=/) : cs(d, function(h, f) {
        switch (h) {
          case "Region":
            n(f);
            break;
        }
      }, /:/);
    }
    try {
      var s;
      if (e.state === "INITIAL") {
        if (!/\r\n|\n/.test(e.buffer))
          return this;
        s = r();
        var o = s.match(/^WEBVTT([ \t].*)?$/);
        if (!o || !o[0])
          throw new Si(Si.Errors.BadSignature);
        e.state = "HEADER";
      }
      for (var u = !1; e.buffer; ) {
        if (!/\r\n|\n/.test(e.buffer))
          return this;
        switch (u ? u = !1 : s = r(), e.state) {
          case "HEADER":
            /:/.test(s) ? a(s) : s || (e.state = "ID");
            continue;
          case "NOTE":
            s || (e.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(s)) {
              e.state = "NOTE";
              break;
            }
            if (!s)
              continue;
            e.cue = new (e.vttjs.VTTCue || e.window.VTTCue)(0, 0, "");
            try {
              e.cue.align = "center";
            } catch {
              e.cue.align = "middle";
            }
            if (e.state = "CUE", s.indexOf("-->") === -1) {
              e.cue.id = s;
              continue;
            }
          case "CUE":
            try {
              Fb(s, e.cue, e.regionList);
            } catch (d) {
              e.reportOrThrowError(d), e.cue = null, e.state = "BADCUE";
              continue;
            }
            e.state = "CUETEXT";
            continue;
          case "CUETEXT":
            var l = s.indexOf("-->") !== -1;
            if (!s || l && (u = !0)) {
              e.oncue && e.oncue(e.cue), e.cue = null, e.state = "ID";
              continue;
            }
            e.cue.text && (e.cue.text += `
`), e.cue.text += s.replace(/\u2028/g, `
`).replace(/u2029/g, `
`);
            continue;
          case "BADCUE":
            s || (e.state = "ID");
            continue;
        }
      }
    } catch (d) {
      e.reportOrThrowError(d), e.state === "CUETEXT" && e.cue && e.oncue && e.oncue(e.cue), e.cue = null, e.state = e.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  },
  flush: function() {
    var t = this;
    try {
      if (t.buffer += t.decoder.decode(), (t.cue || t.state === "HEADER") && (t.buffer += `

`, t.parse()), t.state === "INITIAL")
        throw new Si(Si.Errors.BadSignature);
    } catch (e) {
      t.reportOrThrowError(e);
    }
    return t.onflush && t.onflush(), this;
  }
};
var Kb = Ra, Xb = "auto", Yb = {
  "": 1,
  lr: 1,
  rl: 1
}, Qb = {
  start: 1,
  center: 1,
  end: 1,
  left: 1,
  right: 1,
  auto: 1,
  "line-left": 1,
  "line-right": 1
};
function Jb(t) {
  if (typeof t != "string")
    return !1;
  var e = Yb[t.toLowerCase()];
  return e ? t.toLowerCase() : !1;
}
function Al(t) {
  if (typeof t != "string")
    return !1;
  var e = Qb[t.toLowerCase()];
  return e ? t.toLowerCase() : !1;
}
function fv(t, e, r) {
  this.hasBeenReset = !1;
  var n = "", i = !1, a = t, s = e, o = r, u = null, l = "", d = !0, h = "auto", f = "start", v = "auto", b = "auto", _ = 100, y = "center";
  Object.defineProperties(this, {
    id: {
      enumerable: !0,
      get: function() {
        return n;
      },
      set: function(E) {
        n = "" + E;
      }
    },
    pauseOnExit: {
      enumerable: !0,
      get: function() {
        return i;
      },
      set: function(E) {
        i = !!E;
      }
    },
    startTime: {
      enumerable: !0,
      get: function() {
        return a;
      },
      set: function(E) {
        if (typeof E != "number")
          throw new TypeError("Start time must be set to a number.");
        a = E, this.hasBeenReset = !0;
      }
    },
    endTime: {
      enumerable: !0,
      get: function() {
        return s;
      },
      set: function(E) {
        if (typeof E != "number")
          throw new TypeError("End time must be set to a number.");
        s = E, this.hasBeenReset = !0;
      }
    },
    text: {
      enumerable: !0,
      get: function() {
        return o;
      },
      set: function(E) {
        o = "" + E, this.hasBeenReset = !0;
      }
    },
    region: {
      enumerable: !0,
      get: function() {
        return u;
      },
      set: function(E) {
        u = E, this.hasBeenReset = !0;
      }
    },
    vertical: {
      enumerable: !0,
      get: function() {
        return l;
      },
      set: function(E) {
        var R = Jb(E);
        if (R === !1)
          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
        l = R, this.hasBeenReset = !0;
      }
    },
    snapToLines: {
      enumerable: !0,
      get: function() {
        return d;
      },
      set: function(E) {
        d = !!E, this.hasBeenReset = !0;
      }
    },
    line: {
      enumerable: !0,
      get: function() {
        return h;
      },
      set: function(E) {
        if (typeof E != "number" && E !== Xb)
          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
        h = E, this.hasBeenReset = !0;
      }
    },
    lineAlign: {
      enumerable: !0,
      get: function() {
        return f;
      },
      set: function(E) {
        var R = Al(E);
        R ? (f = R, this.hasBeenReset = !0) : console.warn("lineAlign: an invalid or illegal string was specified.");
      }
    },
    position: {
      enumerable: !0,
      get: function() {
        return v;
      },
      set: function(E) {
        if (E < 0 || E > 100)
          throw new Error("Position must be between 0 and 100.");
        v = E, this.hasBeenReset = !0;
      }
    },
    positionAlign: {
      enumerable: !0,
      get: function() {
        return b;
      },
      set: function(E) {
        var R = Al(E);
        R ? (b = R, this.hasBeenReset = !0) : console.warn("positionAlign: an invalid or illegal string was specified.");
      }
    },
    size: {
      enumerable: !0,
      get: function() {
        return _;
      },
      set: function(E) {
        if (E < 0 || E > 100)
          throw new Error("Size must be between 0 and 100.");
        _ = E, this.hasBeenReset = !0;
      }
    },
    align: {
      enumerable: !0,
      get: function() {
        return y;
      },
      set: function(E) {
        var R = Al(E);
        if (!R)
          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
        y = R, this.hasBeenReset = !0;
      }
    }
  }), this.displayState = void 0;
}
fv.prototype.getCueAsHTML = function() {
  return WebVTT.convertCueToDOMTree(window, this.text);
};
var Zb = fv, eS = {
  "": !0,
  up: !0
};
function tS(t) {
  if (typeof t != "string")
    return !1;
  var e = eS[t.toLowerCase()];
  return e ? t.toLowerCase() : !1;
}
function Za(t) {
  return typeof t == "number" && t >= 0 && t <= 100;
}
function iS() {
  var t = 100, e = 3, r = 0, n = 100, i = 0, a = 100, s = "";
  Object.defineProperties(this, {
    width: {
      enumerable: !0,
      get: function() {
        return t;
      },
      set: function(o) {
        if (!Za(o))
          throw new Error("Width must be between 0 and 100.");
        t = o;
      }
    },
    lines: {
      enumerable: !0,
      get: function() {
        return e;
      },
      set: function(o) {
        if (typeof o != "number")
          throw new TypeError("Lines must be set to a number.");
        e = o;
      }
    },
    regionAnchorY: {
      enumerable: !0,
      get: function() {
        return n;
      },
      set: function(o) {
        if (!Za(o))
          throw new Error("RegionAnchorX must be between 0 and 100.");
        n = o;
      }
    },
    regionAnchorX: {
      enumerable: !0,
      get: function() {
        return r;
      },
      set: function(o) {
        if (!Za(o))
          throw new Error("RegionAnchorY must be between 0 and 100.");
        r = o;
      }
    },
    viewportAnchorY: {
      enumerable: !0,
      get: function() {
        return a;
      },
      set: function(o) {
        if (!Za(o))
          throw new Error("ViewportAnchorY must be between 0 and 100.");
        a = o;
      }
    },
    viewportAnchorX: {
      enumerable: !0,
      get: function() {
        return i;
      },
      set: function(o) {
        if (!Za(o))
          throw new Error("ViewportAnchorX must be between 0 and 100.");
        i = o;
      }
    },
    scroll: {
      enumerable: !0,
      get: function() {
        return s;
      },
      set: function(o) {
        var u = tS(o);
        u === !1 ? console.warn("Scroll: an invalid or illegal string was specified.") : s = u;
      }
    }
  });
}
var rS = iS, wr = M, wn = Bb.exports = {
  WebVTT: Kb,
  VTTCue: Zb,
  VTTRegion: rS
};
wr.vttjs = wn;
wr.WebVTT = wn.WebVTT;
var nS = wn.VTTCue, aS = wn.VTTRegion, sS = wr.VTTCue, oS = wr.VTTRegion;
wn.shim = function() {
  wr.VTTCue = nS, wr.VTTRegion = aS;
};
wn.restore = function() {
  wr.VTTCue = sS, wr.VTTRegion = oS;
};
wr.VTTCue || wn.shim();
function uS() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _s(t, e, r) {
  return uS() ? _s = Reflect.construct.bind() : _s = function(i, a, s) {
    var o = [null];
    o.push.apply(o, a);
    var u = Function.bind.apply(i, o), l = new u();
    return s && ya(l, s.prototype), l;
  }, _s.apply(null, arguments);
}
function lS(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && ya(t, e);
}
var ac = {}, dS = {
  get exports() {
    return ac;
  },
  set exports(t) {
    ac = t;
  }
};
(function(t, e) {
  (function(r) {
    var n = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, i = /^(?=([^\/?#]*))\1([^]*)$/, a = /(?:\/|^)\.(?=\/)/g, s = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, o = {
      // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
      // E.g
      // With opts.alwaysNormalize = false (default, spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
      // With opts.alwaysNormalize = true (not spec compliant)
      // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
      buildAbsoluteURL: function(u, l, d) {
        if (d = d || {}, u = u.trim(), l = l.trim(), !l) {
          if (!d.alwaysNormalize)
            return u;
          var h = o.parseURL(u);
          if (!h)
            throw new Error("Error trying to parse base URL.");
          return h.path = o.normalizePath(
            h.path
          ), o.buildURLFromParts(h);
        }
        var f = o.parseURL(l);
        if (!f)
          throw new Error("Error trying to parse relative URL.");
        if (f.scheme)
          return d.alwaysNormalize ? (f.path = o.normalizePath(f.path), o.buildURLFromParts(f)) : l;
        var v = o.parseURL(u);
        if (!v)
          throw new Error("Error trying to parse base URL.");
        if (!v.netLoc && v.path && v.path[0] !== "/") {
          var b = i.exec(v.path);
          v.netLoc = b[1], v.path = b[2];
        }
        v.netLoc && !v.path && (v.path = "/");
        var _ = {
          // 2c) Otherwise, the embedded URL inherits the scheme of
          // the base URL.
          scheme: v.scheme,
          netLoc: f.netLoc,
          path: null,
          params: f.params,
          query: f.query,
          fragment: f.fragment
        };
        if (!f.netLoc && (_.netLoc = v.netLoc, f.path[0] !== "/"))
          if (!f.path)
            _.path = v.path, f.params || (_.params = v.params, f.query || (_.query = v.query));
          else {
            var y = v.path, E = y.substring(0, y.lastIndexOf("/") + 1) + f.path;
            _.path = o.normalizePath(E);
          }
        return _.path === null && (_.path = d.alwaysNormalize ? o.normalizePath(f.path) : f.path), o.buildURLFromParts(_);
      },
      parseURL: function(u) {
        var l = n.exec(u);
        return l ? {
          scheme: l[1] || "",
          netLoc: l[2] || "",
          path: l[3] || "",
          params: l[4] || "",
          query: l[5] || "",
          fragment: l[6] || ""
        } : null;
      },
      normalizePath: function(u) {
        for (u = u.split("").reverse().join("").replace(a, ""); u.length !== (u = u.replace(s, "")).length; )
          ;
        return u.split("").reverse().join("");
      },
      buildURLFromParts: function(u) {
        return u.scheme + u.netLoc + u.path + u.params + u.query + u.fragment;
      }
    };
    t.exports = o;
  })();
})(dS);
const ep = ac;
var tp = "http://example.com", Ou = function(e, r) {
  if (/^[a-z]+:/i.test(r))
    return r;
  /^data:/.test(e) && (e = M.location && M.location.href || "");
  var n = typeof M.URL == "function", i = /^\/\//.test(e), a = !M.location && !/\/\//i.test(e);
  if (n ? e = new M.URL(e, M.location || tp) : /\/\//i.test(e) || (e = ep.buildAbsoluteURL(M.location && M.location.href || "", e)), n) {
    var s = new URL(r, e);
    return a ? s.href.slice(tp.length) : i ? s.href.slice(s.protocol.length) : s.href;
  }
  return ep.buildAbsoluteURL(e, r);
}, rh = /* @__PURE__ */ function() {
  function t() {
    this.listeners = {};
  }
  var e = t.prototype;
  return e.on = function(n, i) {
    this.listeners[n] || (this.listeners[n] = []), this.listeners[n].push(i);
  }, e.off = function(n, i) {
    if (!this.listeners[n])
      return !1;
    var a = this.listeners[n].indexOf(i);
    return this.listeners[n] = this.listeners[n].slice(0), this.listeners[n].splice(a, 1), a > -1;
  }, e.trigger = function(n) {
    var i = this.listeners[n];
    if (i)
      if (arguments.length === 2)
        for (var a = i.length, s = 0; s < a; ++s)
          i[s].call(this, arguments[1]);
      else
        for (var o = Array.prototype.slice.call(arguments, 1), u = i.length, l = 0; l < u; ++l)
          i[l].apply(this, o);
  }, e.dispose = function() {
    this.listeners = {};
  }, e.pipe = function(n) {
    this.on("data", function(i) {
      n.push(i);
    });
  }, t;
}(), cS = function(e) {
  return M.atob ? M.atob(e) : Buffer.from(e, "base64").toString("binary");
};
function pv(t) {
  for (var e = cS(t), r = new Uint8Array(e.length), n = 0; n < e.length; n++)
    r[n] = e.charCodeAt(n);
  return r;
}
/*! @name m3u8-parser @version 4.8.0 @license Apache-2.0 */
var hS = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    var n;
    return n = t.call(this) || this, n.buffer = "", n;
  }
  var r = e.prototype;
  return r.push = function(i) {
    var a;
    for (this.buffer += i, a = this.buffer.indexOf(`
`); a > -1; a = this.buffer.indexOf(`
`))
      this.trigger("data", this.buffer.substring(0, a)), this.buffer = this.buffer.substring(a + 1);
  }, e;
}(rh), fS = String.fromCharCode(9), wl = function(e) {
  var r = /([0-9.]*)?@?([0-9.]*)?/.exec(e || ""), n = {};
  return r[1] && (n.length = parseInt(r[1], 10)), r[2] && (n.offset = parseInt(r[2], 10)), n;
}, pS = function() {
  var e = "[^=]*", r = '"[^"]*"|[^,]*', n = "(?:" + e + ")=(?:" + r + ")";
  return new RegExp("(?:^|,)(" + n + ")");
}, Ri = function(e) {
  for (var r = e.split(pS()), n = {}, i = r.length, a; i--; )
    r[i] !== "" && (a = /([^=]*)=(.*)/.exec(r[i]).slice(1), a[0] = a[0].replace(/^\s+|\s+$/g, ""), a[1] = a[1].replace(/^\s+|\s+$/g, ""), a[1] = a[1].replace(/^['"](.*)['"]$/g, "$1"), n[a[0]] = a[1]);
  return n;
}, gS = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    var n;
    return n = t.call(this) || this, n.customParsers = [], n.tagMappers = [], n;
  }
  var r = e.prototype;
  return r.push = function(i) {
    var a = this, s, o;
    if (i = i.trim(), i.length !== 0) {
      if (i[0] !== "#") {
        this.trigger("data", {
          type: "uri",
          uri: i
        });
        return;
      }
      var u = this.tagMappers.reduce(function(l, d) {
        var h = d(i);
        return h === i ? l : l.concat([h]);
      }, [i]);
      u.forEach(function(l) {
        for (var d = 0; d < a.customParsers.length; d++)
          if (a.customParsers[d].call(a, l))
            return;
        if (l.indexOf("#EXT") !== 0) {
          a.trigger("data", {
            type: "comment",
            text: l.slice(1)
          });
          return;
        }
        if (l = l.replace("\r", ""), s = /^#EXTM3U/.exec(l), s) {
          a.trigger("data", {
            type: "tag",
            tagType: "m3u"
          });
          return;
        }
        if (s = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "inf"
          }, s[1] && (o.duration = parseFloat(s[1])), s[2] && (o.title = s[2]), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "targetduration"
          }, s[1] && (o.duration = parseInt(s[1], 10)), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "version"
          }, s[1] && (o.version = parseInt(s[1], 10)), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "media-sequence"
          }, s[1] && (o.number = parseInt(s[1], 10)), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "discontinuity-sequence"
          }, s[1] && (o.number = parseInt(s[1], 10)), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "playlist-type"
          }, s[1] && (o.playlistType = s[1]), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-BYTERANGE:?(.*)?$/.exec(l), s) {
          o = Vi(wl(s[1]), {
            type: "tag",
            tagType: "byterange"
          }), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "allow-cache"
          }, s[1] && (o.allowed = !/NO/.test(s[1])), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-MAP:?(.*)$/.exec(l), s) {
          if (o = {
            type: "tag",
            tagType: "map"
          }, s[1]) {
            var h = Ri(s[1]);
            h.URI && (o.uri = h.URI), h.BYTERANGE && (o.byterange = wl(h.BYTERANGE));
          }
          a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-STREAM-INF:?(.*)$/.exec(l), s) {
          if (o = {
            type: "tag",
            tagType: "stream-inf"
          }, s[1]) {
            if (o.attributes = Ri(s[1]), o.attributes.RESOLUTION) {
              var f = o.attributes.RESOLUTION.split("x"), v = {};
              f[0] && (v.width = parseInt(f[0], 10)), f[1] && (v.height = parseInt(f[1], 10)), o.attributes.RESOLUTION = v;
            }
            o.attributes.BANDWIDTH && (o.attributes.BANDWIDTH = parseInt(o.attributes.BANDWIDTH, 10)), o.attributes["FRAME-RATE"] && (o.attributes["FRAME-RATE"] = parseFloat(o.attributes["FRAME-RATE"])), o.attributes["PROGRAM-ID"] && (o.attributes["PROGRAM-ID"] = parseInt(o.attributes["PROGRAM-ID"], 10));
          }
          a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-MEDIA:?(.*)$/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "media"
          }, s[1] && (o.attributes = Ri(s[1])), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-ENDLIST/.exec(l), s) {
          a.trigger("data", {
            type: "tag",
            tagType: "endlist"
          });
          return;
        }
        if (s = /^#EXT-X-DISCONTINUITY/.exec(l), s) {
          a.trigger("data", {
            type: "tag",
            tagType: "discontinuity"
          });
          return;
        }
        if (s = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "program-date-time"
          }, s[1] && (o.dateTimeString = s[1], o.dateTimeObject = new Date(s[1])), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-KEY:?(.*)$/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "key"
          }, s[1] && (o.attributes = Ri(s[1]), o.attributes.IV && (o.attributes.IV.substring(0, 2).toLowerCase() === "0x" && (o.attributes.IV = o.attributes.IV.substring(2)), o.attributes.IV = o.attributes.IV.match(/.{8}/g), o.attributes.IV[0] = parseInt(o.attributes.IV[0], 16), o.attributes.IV[1] = parseInt(o.attributes.IV[1], 16), o.attributes.IV[2] = parseInt(o.attributes.IV[2], 16), o.attributes.IV[3] = parseInt(o.attributes.IV[3], 16), o.attributes.IV = new Uint32Array(o.attributes.IV))), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-START:?(.*)$/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "start"
          }, s[1] && (o.attributes = Ri(s[1]), o.attributes["TIME-OFFSET"] = parseFloat(o.attributes["TIME-OFFSET"]), o.attributes.PRECISE = /YES/.test(o.attributes.PRECISE)), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "cue-out-cont"
          }, s[1] ? o.data = s[1] : o.data = "", a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "cue-out"
          }, s[1] ? o.data = s[1] : o.data = "", a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-CUE-IN:?(.*)?$/.exec(l), s) {
          o = {
            type: "tag",
            tagType: "cue-in"
          }, s[1] ? o.data = s[1] : o.data = "", a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-SKIP:(.*)$/.exec(l), s && s[1]) {
          o = {
            type: "tag",
            tagType: "skip"
          }, o.attributes = Ri(s[1]), o.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (o.attributes["SKIPPED-SEGMENTS"] = parseInt(o.attributes["SKIPPED-SEGMENTS"], 10)), o.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (o.attributes["RECENTLY-REMOVED-DATERANGES"] = o.attributes["RECENTLY-REMOVED-DATERANGES"].split(fS)), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-PART:(.*)$/.exec(l), s && s[1]) {
          o = {
            type: "tag",
            tagType: "part"
          }, o.attributes = Ri(s[1]), ["DURATION"].forEach(function(b) {
            o.attributes.hasOwnProperty(b) && (o.attributes[b] = parseFloat(o.attributes[b]));
          }), ["INDEPENDENT", "GAP"].forEach(function(b) {
            o.attributes.hasOwnProperty(b) && (o.attributes[b] = /YES/.test(o.attributes[b]));
          }), o.attributes.hasOwnProperty("BYTERANGE") && (o.attributes.byterange = wl(o.attributes.BYTERANGE)), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(l), s && s[1]) {
          o = {
            type: "tag",
            tagType: "server-control"
          }, o.attributes = Ri(s[1]), ["CAN-SKIP-UNTIL", "PART-HOLD-BACK", "HOLD-BACK"].forEach(function(b) {
            o.attributes.hasOwnProperty(b) && (o.attributes[b] = parseFloat(o.attributes[b]));
          }), ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function(b) {
            o.attributes.hasOwnProperty(b) && (o.attributes[b] = /YES/.test(o.attributes[b]));
          }), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-PART-INF:(.*)$/.exec(l), s && s[1]) {
          o = {
            type: "tag",
            tagType: "part-inf"
          }, o.attributes = Ri(s[1]), ["PART-TARGET"].forEach(function(b) {
            o.attributes.hasOwnProperty(b) && (o.attributes[b] = parseFloat(o.attributes[b]));
          }), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(l), s && s[1]) {
          o = {
            type: "tag",
            tagType: "preload-hint"
          }, o.attributes = Ri(s[1]), ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function(b) {
            if (o.attributes.hasOwnProperty(b)) {
              o.attributes[b] = parseInt(o.attributes[b], 10);
              var _ = b === "BYTERANGE-LENGTH" ? "length" : "offset";
              o.attributes.byterange = o.attributes.byterange || {}, o.attributes.byterange[_] = o.attributes[b], delete o.attributes[b];
            }
          }), a.trigger("data", o);
          return;
        }
        if (s = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(l), s && s[1]) {
          o = {
            type: "tag",
            tagType: "rendition-report"
          }, o.attributes = Ri(s[1]), ["LAST-MSN", "LAST-PART"].forEach(function(b) {
            o.attributes.hasOwnProperty(b) && (o.attributes[b] = parseInt(o.attributes[b], 10));
          }), a.trigger("data", o);
          return;
        }
        a.trigger("data", {
          type: "tag",
          data: l.slice(4)
        });
      });
    }
  }, r.addParser = function(i) {
    var a = this, s = i.expression, o = i.customType, u = i.dataParser, l = i.segment;
    typeof u != "function" && (u = function(h) {
      return h;
    }), this.customParsers.push(function(d) {
      var h = s.exec(d);
      if (h)
        return a.trigger("data", {
          type: "custom",
          data: u(d),
          customType: o,
          segment: l
        }), !0;
    });
  }, r.addTagMapper = function(i) {
    var a = i.expression, s = i.map, o = function(l) {
      return a.test(l) ? s(l) : l;
    };
    this.tagMappers.push(o);
  }, e;
}(rh), mS = function(e) {
  return e.toLowerCase().replace(/-(\w)/g, function(r) {
    return r[1].toUpperCase();
  });
}, Gn = function(e) {
  var r = {};
  return Object.keys(e).forEach(function(n) {
    r[mS(n)] = e[n];
  }), r;
}, Pl = function(e) {
  var r = e.serverControl, n = e.targetDuration, i = e.partTargetDuration;
  if (r) {
    var a = "#EXT-X-SERVER-CONTROL", s = "holdBack", o = "partHoldBack", u = n && n * 3, l = i && i * 2;
    n && !r.hasOwnProperty(s) && (r[s] = u, this.trigger("info", {
      message: a + " defaulting HOLD-BACK to targetDuration * 3 (" + u + ")."
    })), u && r[s] < u && (this.trigger("warn", {
      message: a + " clamping HOLD-BACK (" + r[s] + ") to targetDuration * 3 (" + u + ")"
    }), r[s] = u), i && !r.hasOwnProperty(o) && (r[o] = i * 3, this.trigger("info", {
      message: a + " defaulting PART-HOLD-BACK to partTargetDuration * 3 (" + r[o] + ")."
    })), i && r[o] < l && (this.trigger("warn", {
      message: a + " clamping PART-HOLD-BACK (" + r[o] + ") to partTargetDuration * 2 (" + l + ")."
    }), r[o] = l);
  }
}, vS = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    var n;
    n = t.call(this) || this, n.lineStream = new hS(), n.parseStream = new gS(), n.lineStream.pipe(n.parseStream);
    var i = Le(n), a = [], s = {}, o, u, l = !1, d = function() {
    }, h = {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    }, f = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", v = 0;
    n.manifest = {
      allowCache: !0,
      discontinuityStarts: [],
      segments: []
    };
    var b = 0, _ = 0;
    return n.on("end", function() {
      s.uri || !s.parts && !s.preloadHints || (!s.map && o && (s.map = o), !s.key && u && (s.key = u), !s.timeline && typeof v == "number" && (s.timeline = v), n.manifest.preloadSegment = s);
    }), n.parseStream.on("data", function(y) {
      var E, R;
      ({
        tag: function() {
          ({
            version: function() {
              y.version && (this.manifest.version = y.version);
            },
            "allow-cache": function() {
              this.manifest.allowCache = y.allowed, "allowed" in y || (this.trigger("info", {
                message: "defaulting allowCache to YES"
              }), this.manifest.allowCache = !0);
            },
            byterange: function() {
              var w = {};
              "length" in y && (s.byterange = w, w.length = y.length, "offset" in y || (y.offset = b)), "offset" in y && (s.byterange = w, w.offset = y.offset), b = w.offset + w.length;
            },
            endlist: function() {
              this.manifest.endList = !0;
            },
            inf: function() {
              "mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", {
                message: "defaulting media sequence to zero"
              })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", {
                message: "defaulting discontinuity sequence to zero"
              })), y.duration > 0 && (s.duration = y.duration), y.duration === 0 && (s.duration = 0.01, this.trigger("info", {
                message: "updating zero segment duration to a small value"
              })), this.manifest.segments = a;
            },
            key: function() {
              if (!y.attributes) {
                this.trigger("warn", {
                  message: "ignoring key declaration without attribute list"
                });
                return;
              }
              if (y.attributes.METHOD === "NONE") {
                u = null;
                return;
              }
              if (!y.attributes.URI) {
                this.trigger("warn", {
                  message: "ignoring key declaration without URI"
                });
                return;
              }
              if (y.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.apple.fps.1_0"] = {
                  attributes: y.attributes
                };
                return;
              }
              if (y.attributes.KEYFORMAT === "com.microsoft.playready") {
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.microsoft.playready"] = {
                  uri: y.attributes.URI
                };
                return;
              }
              if (y.attributes.KEYFORMAT === f) {
                var w = ["SAMPLE-AES", "SAMPLE-AES-CTR", "SAMPLE-AES-CENC"];
                if (w.indexOf(y.attributes.METHOD) === -1) {
                  this.trigger("warn", {
                    message: "invalid key method provided for Widevine"
                  });
                  return;
                }
                if (y.attributes.METHOD === "SAMPLE-AES-CENC" && this.trigger("warn", {
                  message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                }), y.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
                  this.trigger("warn", {
                    message: "invalid key URI provided for Widevine"
                  });
                  return;
                }
                if (!(y.attributes.KEYID && y.attributes.KEYID.substring(0, 2) === "0x")) {
                  this.trigger("warn", {
                    message: "invalid key ID provided for Widevine"
                  });
                  return;
                }
                this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.widevine.alpha"] = {
                  attributes: {
                    schemeIdUri: y.attributes.KEYFORMAT,
                    // remove '0x' from the key id string
                    keyId: y.attributes.KEYID.substring(2)
                  },
                  // decode the base64-encoded PSSH box
                  pssh: pv(y.attributes.URI.split(",")[1])
                };
                return;
              }
              y.attributes.METHOD || this.trigger("warn", {
                message: "defaulting key method to AES-128"
              }), u = {
                method: y.attributes.METHOD || "AES-128",
                uri: y.attributes.URI
              }, typeof y.attributes.IV < "u" && (u.iv = y.attributes.IV);
            },
            "media-sequence": function() {
              if (!isFinite(y.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid media sequence: " + y.number
                });
                return;
              }
              this.manifest.mediaSequence = y.number;
            },
            "discontinuity-sequence": function() {
              if (!isFinite(y.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid discontinuity sequence: " + y.number
                });
                return;
              }
              this.manifest.discontinuitySequence = y.number, v = y.number;
            },
            "playlist-type": function() {
              if (!/VOD|EVENT/.test(y.playlistType)) {
                this.trigger("warn", {
                  message: "ignoring unknown playlist type: " + y.playlist
                });
                return;
              }
              this.manifest.playlistType = y.playlistType;
            },
            map: function() {
              o = {}, y.uri && (o.uri = y.uri), y.byterange && (o.byterange = y.byterange), u && (o.key = u);
            },
            "stream-inf": function() {
              if (this.manifest.playlists = a, this.manifest.mediaGroups = this.manifest.mediaGroups || h, !y.attributes) {
                this.trigger("warn", {
                  message: "ignoring empty stream-inf attributes"
                });
                return;
              }
              s.attributes || (s.attributes = {}), Vi(s.attributes, y.attributes);
            },
            media: function() {
              if (this.manifest.mediaGroups = this.manifest.mediaGroups || h, !(y.attributes && y.attributes.TYPE && y.attributes["GROUP-ID"] && y.attributes.NAME)) {
                this.trigger("warn", {
                  message: "ignoring incomplete or missing media group"
                });
                return;
              }
              var w = this.manifest.mediaGroups[y.attributes.TYPE];
              w[y.attributes["GROUP-ID"]] = w[y.attributes["GROUP-ID"]] || {}, E = w[y.attributes["GROUP-ID"]], R = {
                default: /yes/i.test(y.attributes.DEFAULT)
              }, R.default ? R.autoselect = !0 : R.autoselect = /yes/i.test(y.attributes.AUTOSELECT), y.attributes.LANGUAGE && (R.language = y.attributes.LANGUAGE), y.attributes.URI && (R.uri = y.attributes.URI), y.attributes["INSTREAM-ID"] && (R.instreamId = y.attributes["INSTREAM-ID"]), y.attributes.CHARACTERISTICS && (R.characteristics = y.attributes.CHARACTERISTICS), y.attributes.FORCED && (R.forced = /yes/i.test(y.attributes.FORCED)), E[y.attributes.NAME] = R;
            },
            discontinuity: function() {
              v += 1, s.discontinuity = !0, this.manifest.discontinuityStarts.push(a.length);
            },
            "program-date-time": function() {
              typeof this.manifest.dateTimeString > "u" && (this.manifest.dateTimeString = y.dateTimeString, this.manifest.dateTimeObject = y.dateTimeObject), s.dateTimeString = y.dateTimeString, s.dateTimeObject = y.dateTimeObject;
            },
            targetduration: function() {
              if (!isFinite(y.duration) || y.duration < 0) {
                this.trigger("warn", {
                  message: "ignoring invalid target duration: " + y.duration
                });
                return;
              }
              this.manifest.targetDuration = y.duration, Pl.call(this, this.manifest);
            },
            start: function() {
              if (!y.attributes || isNaN(y.attributes["TIME-OFFSET"])) {
                this.trigger("warn", {
                  message: "ignoring start declaration without appropriate attribute list"
                });
                return;
              }
              this.manifest.start = {
                timeOffset: y.attributes["TIME-OFFSET"],
                precise: y.attributes.PRECISE
              };
            },
            "cue-out": function() {
              s.cueOut = y.data;
            },
            "cue-out-cont": function() {
              s.cueOutCont = y.data;
            },
            "cue-in": function() {
              s.cueIn = y.data;
            },
            skip: function() {
              this.manifest.skip = Gn(y.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", y.attributes, ["SKIPPED-SEGMENTS"]);
            },
            part: function() {
              var w = this;
              l = !0;
              var k = this.manifest.segments.length, I = Gn(y.attributes);
              s.parts = s.parts || [], s.parts.push(I), I.byterange && (I.byterange.hasOwnProperty("offset") || (I.byterange.offset = _), _ = I.byterange.offset + I.byterange.length);
              var U = s.parts.length - 1;
              this.warnOnMissingAttributes_("#EXT-X-PART #" + U + " for segment #" + k, y.attributes, ["URI", "DURATION"]), this.manifest.renditionReports && this.manifest.renditionReports.forEach(function($, W) {
                $.hasOwnProperty("lastPart") || w.trigger("warn", {
                  message: "#EXT-X-RENDITION-REPORT #" + W + " lacks required attribute(s): LAST-PART"
                });
              });
            },
            "server-control": function() {
              var w = this.manifest.serverControl = Gn(y.attributes);
              w.hasOwnProperty("canBlockReload") || (w.canBlockReload = !1, this.trigger("info", {
                message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
              })), Pl.call(this, this.manifest), w.canSkipDateranges && !w.hasOwnProperty("canSkipUntil") && this.trigger("warn", {
                message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
              });
            },
            "preload-hint": function() {
              var w = this.manifest.segments.length, k = Gn(y.attributes), I = k.type && k.type === "PART";
              s.preloadHints = s.preloadHints || [], s.preloadHints.push(k), k.byterange && (k.byterange.hasOwnProperty("offset") || (k.byterange.offset = I ? _ : 0, I && (_ = k.byterange.offset + k.byterange.length)));
              var U = s.preloadHints.length - 1;
              if (this.warnOnMissingAttributes_("#EXT-X-PRELOAD-HINT #" + U + " for segment #" + w, y.attributes, ["TYPE", "URI"]), !!k.type)
                for (var $ = 0; $ < s.preloadHints.length - 1; $++) {
                  var W = s.preloadHints[$];
                  W.type && W.type === k.type && this.trigger("warn", {
                    message: "#EXT-X-PRELOAD-HINT #" + U + " for segment #" + w + " has the same TYPE " + k.type + " as preload hint #" + $
                  });
                }
            },
            "rendition-report": function() {
              var w = Gn(y.attributes);
              this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(w);
              var k = this.manifest.renditionReports.length - 1, I = ["LAST-MSN", "URI"];
              l && I.push("LAST-PART"), this.warnOnMissingAttributes_("#EXT-X-RENDITION-REPORT #" + k, y.attributes, I);
            },
            "part-inf": function() {
              this.manifest.partInf = Gn(y.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", y.attributes, ["PART-TARGET"]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), Pl.call(this, this.manifest);
            }
          }[y.tagType] || d).call(i);
        },
        uri: function() {
          s.uri = y.uri, a.push(s), this.manifest.targetDuration && !("duration" in s) && (this.trigger("warn", {
            message: "defaulting segment duration to the target duration"
          }), s.duration = this.manifest.targetDuration), u && (s.key = u), s.timeline = v, o && (s.map = o), _ = 0, s = {};
        },
        comment: function() {
        },
        custom: function() {
          y.segment ? (s.custom = s.custom || {}, s.custom[y.customType] = y.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[y.customType] = y.data);
        }
      })[y.type].call(i);
    }), n;
  }
  var r = e.prototype;
  return r.warnOnMissingAttributes_ = function(i, a, s) {
    var o = [];
    s.forEach(function(u) {
      a.hasOwnProperty(u) || o.push(u);
    }), o.length && this.trigger("warn", {
      message: i + " lacks required attribute(s): " + o.join(", ")
    });
  }, r.push = function(i) {
    this.lineStream.push(i);
  }, r.end = function() {
    this.lineStream.push(`
`), this.trigger("end");
  }, r.addParser = function(i) {
    this.parseStream.addParser(i);
  }, r.addTagMapper = function(i) {
    this.parseStream.addTagMapper(i);
  }, e;
}(rh), _n = {
  // to determine mime types
  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
  // to determine if a codec is audio or video
  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
  text: /^(stpp.ttml.im1t)/,
  // mux.js support regex
  muxerVideo: /^(avc0?1)/,
  muxerAudio: /^(mp4a)/,
  // match nothing as muxer does not support text right now.
  // there cannot never be a character before the start of a string
  // so this matches nothing.
  muxerText: /a^/
}, yS = ["video", "audio", "text"], ip = ["Video", "Audio", "Text"], gv = function(e) {
  return e && e.replace(/avc1\.(\d+)\.(\d+)/i, function(r, n, i) {
    var a = ("00" + Number(n).toString(16)).slice(-2), s = ("00" + Number(i).toString(16)).slice(-2);
    return "avc1." + a + "00" + s;
  });
}, Yi = function(e) {
  e === void 0 && (e = "");
  var r = e.split(","), n = [];
  return r.forEach(function(i) {
    i = i.trim();
    var a;
    yS.forEach(function(s) {
      var o = _n[s].exec(i.toLowerCase());
      if (!(!o || o.length <= 1)) {
        a = s;
        var u = i.substring(0, o[1].length), l = i.replace(u, "");
        n.push({
          type: u,
          details: l,
          mediaType: s
        });
      }
    }), a || n.push({
      type: i,
      details: "",
      mediaType: "unknown"
    });
  }), n;
}, _S = function(e, r) {
  if (!e.mediaGroups.AUDIO || !r)
    return null;
  var n = e.mediaGroups.AUDIO[r];
  if (!n)
    return null;
  for (var i in n) {
    var a = n[i];
    if (a.default && a.playlists)
      return Yi(a.playlists[0].attributes.CODECS);
  }
  return null;
}, mv = function(e) {
  return e === void 0 && (e = ""), _n.audio.test(e.trim().toLowerCase());
}, TS = function(e) {
  return e === void 0 && (e = ""), _n.text.test(e.trim().toLowerCase());
}, Cs = function(e) {
  if (!(!e || typeof e != "string")) {
    var r = e.toLowerCase().split(",").map(function(a) {
      return gv(a.trim());
    }), n = "video";
    r.length === 1 && mv(r[0]) ? n = "audio" : r.length === 1 && TS(r[0]) && (n = "application");
    var i = "mp4";
    return r.every(function(a) {
      return _n.mp4.test(a);
    }) ? i = "mp4" : r.every(function(a) {
      return _n.webm.test(a);
    }) ? i = "webm" : r.every(function(a) {
      return _n.ogg.test(a);
    }) && (i = "ogg"), n + "/" + i + ';codecs="' + e + '"';
  }
}, Uo = function(e) {
  return e === void 0 && (e = ""), M.MediaSource && M.MediaSource.isTypeSupported && M.MediaSource.isTypeSupported(Cs(e)) || !1;
}, kl = function(e) {
  return e === void 0 && (e = ""), e.toLowerCase().split(",").every(function(r) {
    r = r.trim();
    for (var n = 0; n < ip.length; n++) {
      var i = ip[n];
      if (_n["muxer" + i].test(r))
        return !0;
    }
    return !1;
  });
}, rp = "mp4a.40.2", bS = "avc1.4d400d", SS = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i, ES = /^application\/dash\+xml/i, vv = function(e) {
  return SS.test(e) ? "hls" : ES.test(e) ? "dash" : e === "application/vnd.videojs.vhs+json" ? "vhs-json" : null;
}, xS = function(e) {
  return e.toString(2).length;
}, CS = function(e) {
  return Math.ceil(xS(e) / 8);
}, yv = function(e) {
  return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer;
}, AS = function(e) {
  return yv(e);
}, Ae = function(e) {
  return e instanceof Uint8Array ? e : (!Array.isArray(e) && !AS(e) && !(e instanceof ArrayBuffer) && (typeof e != "number" || typeof e == "number" && e !== e ? e = 0 : e = [e]), new Uint8Array(e && e.buffer || e, e && e.byteOffset || 0, e && e.byteLength || 0));
}, Ht = M.BigInt || Number, sc = [Ht("0x1"), Ht("0x100"), Ht("0x10000"), Ht("0x1000000"), Ht("0x100000000"), Ht("0x10000000000"), Ht("0x1000000000000"), Ht("0x100000000000000"), Ht("0x10000000000000000")];
(function() {
  var t = new Uint16Array([65484]), e = new Uint8Array(t.buffer, t.byteOffset, t.byteLength);
  return e[0] === 255 ? "big" : e[0] === 204 ? "little" : "unknown";
})();
var wS = function(e, r) {
  var n = r === void 0 ? {} : r, i = n.signed, a = i === void 0 ? !1 : i, s = n.le, o = s === void 0 ? !1 : s;
  e = Ae(e);
  var u = o ? "reduce" : "reduceRight", l = e[u] ? e[u] : Array.prototype[u], d = l.call(e, function(f, v, b) {
    var _ = o ? b : Math.abs(b + 1 - e.length);
    return f + Ht(v) * sc[_];
  }, Ht(0));
  if (a) {
    var h = sc[e.length] / Ht(2) - Ht(1);
    d = Ht(d), d > h && (d -= h, d -= h, d -= Ht(2));
  }
  return Number(d);
}, PS = function(e, r) {
  var n = r === void 0 ? {} : r, i = n.le, a = i === void 0 ? !1 : i;
  (typeof e != "bigint" && typeof e != "number" || typeof e == "number" && e !== e) && (e = 0), e = Ht(e);
  for (var s = CS(e), o = new Uint8Array(new ArrayBuffer(s)), u = 0; u < s; u++) {
    var l = a ? u : Math.abs(u + 1 - o.length);
    o[l] = Number(e / sc[u] & Ht(255)), e < 0 && (o[l] = Math.abs(~o[l]), o[l] -= u === 0 ? 1 : 2);
  }
  return o;
}, _v = function(e, r) {
  if (typeof e != "string" && e && typeof e.toString == "function" && (e = e.toString()), typeof e != "string")
    return new Uint8Array();
  r || (e = unescape(encodeURIComponent(e)));
  for (var n = new Uint8Array(e.length), i = 0; i < e.length; i++)
    n[i] = e.charCodeAt(i);
  return n;
}, kS = function() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  if (r = r.filter(function(o) {
    return o && (o.byteLength || o.length) && typeof o != "string";
  }), r.length <= 1)
    return Ae(r[0]);
  var i = r.reduce(function(o, u, l) {
    return o + (u.byteLength || u.length);
  }, 0), a = new Uint8Array(i), s = 0;
  return r.forEach(function(o) {
    o = Ae(o), a.set(o, s), s += o.byteLength;
  }), a;
}, Tt = function(e, r, n) {
  var i = n === void 0 ? {} : n, a = i.offset, s = a === void 0 ? 0 : a, o = i.mask, u = o === void 0 ? [] : o;
  e = Ae(e), r = Ae(r);
  var l = r.every ? r.every : Array.prototype.every;
  return r.length && e.length - s >= r.length && // ie 11 doesn't support every on uin8
  l.call(r, function(d, h) {
    var f = u[h] ? u[h] & e[s + h] : e[s + h];
    return d === f;
  });
}, LS = function(e, r, n) {
  r.forEach(function(i) {
    for (var a in e.mediaGroups[i])
      for (var s in e.mediaGroups[i][a]) {
        var o = e.mediaGroups[i][a][s];
        n(o, i, a, s);
      }
  });
}, Qr = {}, Rr = {};
function IS(t, e, r) {
  if (r === void 0 && (r = Array.prototype), t && typeof r.find == "function")
    return r.find.call(t, e);
  for (var n = 0; n < t.length; n++)
    if (Object.prototype.hasOwnProperty.call(t, n)) {
      var i = t[n];
      if (e.call(void 0, i, n, t))
        return i;
    }
}
function nh(t, e) {
  return e === void 0 && (e = Object), e && typeof e.freeze == "function" ? e.freeze(t) : t;
}
function DS(t, e) {
  if (t === null || typeof t != "object")
    throw new TypeError("target is not an object");
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
  return t;
}
var Tv = nh({
  /**
   * `text/html`, the only mime type that triggers treating an XML document as HTML.
   *
   * @see DOMParser.SupportedType.isHTML
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
   */
  HTML: "text/html",
  /**
   * Helper method to check a mime type if it indicates an HTML document
   *
   * @param {string} [value]
   * @returns {boolean}
   *
   * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/HTML Wikipedia
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
   * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
  isHTML: function(t) {
    return t === Tv.HTML;
  },
  /**
   * `application/xml`, the standard mime type for XML documents.
   *
   * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
   * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_APPLICATION: "application/xml",
  /**
   * `text/html`, an alias for `application/xml`.
   *
   * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
   * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
   * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
   */
  XML_TEXT: "text/xml",
  /**
   * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
   * but is parsed as an XML document.
   *
   * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
   * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
   */
  XML_XHTML_APPLICATION: "application/xhtml+xml",
  /**
   * `image/svg+xml`,
   *
   * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
   * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
   * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
   */
  XML_SVG_IMAGE: "image/svg+xml"
}), bv = nh({
  /**
   * The XHTML namespace.
   *
   * @see http://www.w3.org/1999/xhtml
   */
  HTML: "http://www.w3.org/1999/xhtml",
  /**
   * Checks if `uri` equals `NAMESPACE.HTML`.
   *
   * @param {string} [uri]
   *
   * @see NAMESPACE.HTML
   */
  isHTML: function(t) {
    return t === bv.HTML;
  },
  /**
   * The SVG namespace.
   *
   * @see http://www.w3.org/2000/svg
   */
  SVG: "http://www.w3.org/2000/svg",
  /**
   * The `xml:` namespace.
   *
   * @see http://www.w3.org/XML/1998/namespace
   */
  XML: "http://www.w3.org/XML/1998/namespace",
  /**
   * The `xmlns:` namespace
   *
   * @see https://www.w3.org/2000/xmlns/
   */
  XMLNS: "http://www.w3.org/2000/xmlns/"
});
Rr.assign = DS;
Rr.find = IS;
Rr.freeze = nh;
Rr.MIME_TYPE = Tv;
Rr.NAMESPACE = bv;
var Sv = Rr, nr = Sv.find, As = Sv.NAMESPACE;
function RS(t) {
  return t !== "";
}
function OS(t) {
  return t ? t.split(/[\t\n\f\r ]+/).filter(RS) : [];
}
function MS(t, e) {
  return t.hasOwnProperty(e) || (t[e] = !0), t;
}
function np(t) {
  if (!t)
    return [];
  var e = OS(t);
  return Object.keys(e.reduce(MS, {}));
}
function NS(t) {
  return function(e) {
    return t && t.indexOf(e) !== -1;
  };
}
function js(t, e) {
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
}
function gi(t, e) {
  var r = t.prototype;
  if (!(r instanceof e)) {
    let n = function() {
    };
    n.prototype = e.prototype, n = new n(), js(r, n), t.prototype = r = n;
  }
  r.constructor != t && (typeof t != "function" && console.error("unknown Class:" + t), r.constructor = t);
}
var mi = {}, Fi = mi.ELEMENT_NODE = 1, _a = mi.ATTRIBUTE_NODE = 2, Zo = mi.TEXT_NODE = 3, Ev = mi.CDATA_SECTION_NODE = 4, xv = mi.ENTITY_REFERENCE_NODE = 5, BS = mi.ENTITY_NODE = 6, Cv = mi.PROCESSING_INSTRUCTION_NODE = 7, Av = mi.COMMENT_NODE = 8, wv = mi.DOCUMENT_NODE = 9, Pv = mi.DOCUMENT_TYPE_NODE = 10, Pr = mi.DOCUMENT_FRAGMENT_NODE = 11, FS = mi.NOTATION_NODE = 12, Yt = {}, Ut = {};
Yt.INDEX_SIZE_ERR = (Ut[1] = "Index size error", 1);
Yt.DOMSTRING_SIZE_ERR = (Ut[2] = "DOMString size error", 2);
var ci = Yt.HIERARCHY_REQUEST_ERR = (Ut[3] = "Hierarchy request error", 3);
Yt.WRONG_DOCUMENT_ERR = (Ut[4] = "Wrong document", 4);
Yt.INVALID_CHARACTER_ERR = (Ut[5] = "Invalid character", 5);
Yt.NO_DATA_ALLOWED_ERR = (Ut[6] = "No data allowed", 6);
Yt.NO_MODIFICATION_ALLOWED_ERR = (Ut[7] = "No modification allowed", 7);
var kv = Yt.NOT_FOUND_ERR = (Ut[8] = "Not found", 8);
Yt.NOT_SUPPORTED_ERR = (Ut[9] = "Not supported", 9);
var ap = Yt.INUSE_ATTRIBUTE_ERR = (Ut[10] = "Attribute in use", 10);
Yt.INVALID_STATE_ERR = (Ut[11] = "Invalid state", 11);
Yt.SYNTAX_ERR = (Ut[12] = "Syntax error", 12);
Yt.INVALID_MODIFICATION_ERR = (Ut[13] = "Invalid modification", 13);
Yt.NAMESPACE_ERR = (Ut[14] = "Invalid namespace", 14);
Yt.INVALID_ACCESS_ERR = (Ut[15] = "Invalid access", 15);
function Dt(t, e) {
  if (e instanceof Error)
    var r = e;
  else
    r = this, Error.call(this, Ut[t]), this.message = Ut[t], Error.captureStackTrace && Error.captureStackTrace(this, Dt);
  return r.code = t, e && (this.message = this.message + ": " + e), r;
}
Dt.prototype = Error.prototype;
js(Yt, Dt);
function xr() {
}
xr.prototype = {
  /**
   * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
   * @standard level1
   */
  length: 0,
  /**
   * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
   * @standard level1
   * @param index  unsigned long
   *   Index into the collection.
   * @return Node
   * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
   */
  item: function(t) {
    return this[t] || null;
  },
  toString: function(t, e) {
    for (var r = [], n = 0; n < this.length; n++)
      aa(this[n], r, t, e);
    return r.join("");
  },
  /**
   * @private
   * @param {function (Node):boolean} predicate
   * @returns {Node[]}
   */
  filter: function(t) {
    return Array.prototype.filter.call(this, t);
  },
  /**
   * @private
   * @param {Node} item
   * @returns {number}
   */
  indexOf: function(t) {
    return Array.prototype.indexOf.call(this, t);
  }
};
function Ta(t, e) {
  this._node = t, this._refresh = e, ah(this);
}
function ah(t) {
  var e = t._node._inc || t._node.ownerDocument._inc;
  if (t._inc != e) {
    var r = t._refresh(t._node);
    jv(t, "length", r.length), js(r, t), t._inc = e;
  }
}
Ta.prototype.item = function(t) {
  return ah(this), this[t];
};
gi(Ta, xr);
function eu() {
}
function Lv(t, e) {
  for (var r = t.length; r--; )
    if (t[r] === e)
      return r;
}
function sp(t, e, r, n) {
  if (n ? e[Lv(e, n)] = r : e[e.length++] = r, t) {
    r.ownerElement = t;
    var i = t.ownerDocument;
    i && (n && Rv(i, t, n), US(i, t, r));
  }
}
function op(t, e, r) {
  var n = Lv(e, r);
  if (n >= 0) {
    for (var i = e.length - 1; n < i; )
      e[n] = e[++n];
    if (e.length = i, t) {
      var a = t.ownerDocument;
      a && (Rv(a, t, r), r.ownerElement = null);
    }
  } else
    throw new Dt(kv, new Error(t.tagName + "@" + r));
}
eu.prototype = {
  length: 0,
  item: xr.prototype.item,
  getNamedItem: function(t) {
    for (var e = this.length; e--; ) {
      var r = this[e];
      if (r.nodeName == t)
        return r;
    }
  },
  setNamedItem: function(t) {
    var e = t.ownerElement;
    if (e && e != this._ownerElement)
      throw new Dt(ap);
    var r = this.getNamedItem(t.nodeName);
    return sp(this._ownerElement, this, t, r), r;
  },
  /* returns Node */
  setNamedItemNS: function(t) {
    var e = t.ownerElement, r;
    if (e && e != this._ownerElement)
      throw new Dt(ap);
    return r = this.getNamedItemNS(t.namespaceURI, t.localName), sp(this._ownerElement, this, t, r), r;
  },
  /* returns Node */
  removeNamedItem: function(t) {
    var e = this.getNamedItem(t);
    return op(this._ownerElement, this, e), e;
  },
  // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
  //for level2
  removeNamedItemNS: function(t, e) {
    var r = this.getNamedItemNS(t, e);
    return op(this._ownerElement, this, r), r;
  },
  getNamedItemNS: function(t, e) {
    for (var r = this.length; r--; ) {
      var n = this[r];
      if (n.localName == e && n.namespaceURI == t)
        return n;
    }
    return null;
  }
};
function Iv() {
}
Iv.prototype = {
  /**
   * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
   * The different implementations fairly diverged in what kind of features were reported.
   * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
   *
   * @deprecated It is deprecated and modern browsers return true in all cases.
   *
   * @param {string} feature
   * @param {string} [version]
   * @returns {boolean} always true
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
   * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
   */
  hasFeature: function(t, e) {
    return !0;
  },
  /**
   * Creates an XML Document object of the specified type with its document element.
   *
   * __It behaves slightly different from the description in the living standard__:
   * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
   * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string|null} namespaceURI
   * @param {string} qualifiedName
   * @param {DocumentType=null} doctype
   * @returns {Document}
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocument: function(t, e, r) {
    var n = new Hs();
    if (n.implementation = this, n.childNodes = new xr(), n.doctype = r || null, r && n.appendChild(r), e) {
      var i = n.createElementNS(t, e);
      n.appendChild(i);
    }
    return n;
  },
  /**
   * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
   *
   * __This behavior is slightly different from the in the specs__:
   * - this implementation is not validating names or qualified names
   *   (when parsing XML strings, the SAX parser takes care of that)
   *
   * @param {string} qualifiedName
   * @param {string} [publicId]
   * @param {string} [systemId]
   * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
   * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
   * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
   * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
   *
   * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
   * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
   * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
   */
  createDocumentType: function(t, e, r) {
    var n = new Mu();
    return n.name = t, n.nodeName = t, n.publicId = e || "", n.systemId = r || "", n;
  }
};
function rt() {
}
rt.prototype = {
  firstChild: null,
  lastChild: null,
  previousSibling: null,
  nextSibling: null,
  attributes: null,
  parentNode: null,
  childNodes: null,
  ownerDocument: null,
  nodeValue: null,
  namespaceURI: null,
  prefix: null,
  localName: null,
  // Modified in DOM Level 2:
  insertBefore: function(t, e) {
    return tu(this, t, e);
  },
  replaceChild: function(t, e) {
    tu(this, t, e, Mv), e && this.removeChild(e);
  },
  removeChild: function(t) {
    return Ov(this, t);
  },
  appendChild: function(t) {
    return this.insertBefore(t, null);
  },
  hasChildNodes: function() {
    return this.firstChild != null;
  },
  cloneNode: function(t) {
    return oc(this.ownerDocument || this, this, t);
  },
  // Modified in DOM Level 2:
  normalize: function() {
    for (var t = this.firstChild; t; ) {
      var e = t.nextSibling;
      e && e.nodeType == Zo && t.nodeType == Zo ? (this.removeChild(e), t.appendData(e.data)) : (t.normalize(), t = e);
    }
  },
  // Introduced in DOM Level 2:
  isSupported: function(t, e) {
    return this.ownerDocument.implementation.hasFeature(t, e);
  },
  // Introduced in DOM Level 2:
  hasAttributes: function() {
    return this.attributes.length > 0;
  },
  /**
   * Look up the prefix associated to the given namespace URI, starting from this node.
   * **The default namespace declarations are ignored by this method.**
   * See Namespace Prefix Lookup for details on the algorithm used by this method.
   *
   * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
   *
   * @param {string | null} namespaceURI
   * @returns {string | null}
   * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
   * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
   * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
   * @see https://github.com/xmldom/xmldom/issues/322
   */
  lookupPrefix: function(t) {
    for (var e = this; e; ) {
      var r = e._nsMap;
      if (r) {
        for (var n in r)
          if (Object.prototype.hasOwnProperty.call(r, n) && r[n] === t)
            return n;
      }
      e = e.nodeType == _a ? e.ownerDocument : e.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  lookupNamespaceURI: function(t) {
    for (var e = this; e; ) {
      var r = e._nsMap;
      if (r && Object.prototype.hasOwnProperty.call(r, t))
        return r[t];
      e = e.nodeType == _a ? e.ownerDocument : e.parentNode;
    }
    return null;
  },
  // Introduced in DOM Level 3:
  isDefaultNamespace: function(t) {
    var e = this.lookupPrefix(t);
    return e == null;
  }
};
function Dv(t) {
  return t == "<" && "&lt;" || t == ">" && "&gt;" || t == "&" && "&amp;" || t == '"' && "&quot;" || "&#" + t.charCodeAt() + ";";
}
js(mi, rt);
js(mi, rt.prototype);
function ws(t, e) {
  if (e(t))
    return !0;
  if (t = t.firstChild)
    do
      if (ws(t, e))
        return !0;
    while (t = t.nextSibling);
}
function Hs() {
  this.ownerDocument = this;
}
function US(t, e, r) {
  t && t._inc++;
  var n = r.namespaceURI;
  n === As.XMLNS && (e._nsMap[r.prefix ? r.localName : ""] = r.value);
}
function Rv(t, e, r, n) {
  t && t._inc++;
  var i = r.namespaceURI;
  i === As.XMLNS && delete e._nsMap[r.prefix ? r.localName : ""];
}
function sh(t, e, r) {
  if (t && t._inc) {
    t._inc++;
    var n = e.childNodes;
    if (r)
      n[n.length++] = r;
    else {
      for (var i = e.firstChild, a = 0; i; )
        n[a++] = i, i = i.nextSibling;
      n.length = a, delete n[n.length];
    }
  }
}
function Ov(t, e) {
  var r = e.previousSibling, n = e.nextSibling;
  return r ? r.nextSibling = n : t.firstChild = n, n ? n.previousSibling = r : t.lastChild = r, e.parentNode = null, e.previousSibling = null, e.nextSibling = null, sh(t.ownerDocument, t), e;
}
function VS(t) {
  return t && (t.nodeType === rt.DOCUMENT_NODE || t.nodeType === rt.DOCUMENT_FRAGMENT_NODE || t.nodeType === rt.ELEMENT_NODE);
}
function jS(t) {
  return t && (ar(t) || oh(t) || kr(t) || t.nodeType === rt.DOCUMENT_FRAGMENT_NODE || t.nodeType === rt.COMMENT_NODE || t.nodeType === rt.PROCESSING_INSTRUCTION_NODE);
}
function kr(t) {
  return t && t.nodeType === rt.DOCUMENT_TYPE_NODE;
}
function ar(t) {
  return t && t.nodeType === rt.ELEMENT_NODE;
}
function oh(t) {
  return t && t.nodeType === rt.TEXT_NODE;
}
function up(t, e) {
  var r = t.childNodes || [];
  if (nr(r, ar) || kr(e))
    return !1;
  var n = nr(r, kr);
  return !(e && n && r.indexOf(n) > r.indexOf(e));
}
function lp(t, e) {
  var r = t.childNodes || [];
  function n(a) {
    return ar(a) && a !== e;
  }
  if (nr(r, n))
    return !1;
  var i = nr(r, kr);
  return !(e && i && r.indexOf(i) > r.indexOf(e));
}
function HS(t, e, r) {
  if (!VS(t))
    throw new Dt(ci, "Unexpected parent node type " + t.nodeType);
  if (r && r.parentNode !== t)
    throw new Dt(kv, "child not in parent");
  if (
    // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !jS(e) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    kr(e) && t.nodeType !== rt.DOCUMENT_NODE
  )
    throw new Dt(
      ci,
      "Unexpected node type " + e.nodeType + " for parent node type " + t.nodeType
    );
}
function WS(t, e, r) {
  var n = t.childNodes || [], i = e.childNodes || [];
  if (e.nodeType === rt.DOCUMENT_FRAGMENT_NODE) {
    var a = i.filter(ar);
    if (a.length > 1 || nr(i, oh))
      throw new Dt(ci, "More than one element or text in fragment");
    if (a.length === 1 && !up(t, r))
      throw new Dt(ci, "Element in fragment can not be inserted before doctype");
  }
  if (ar(e) && !up(t, r))
    throw new Dt(ci, "Only one element can be added and only after doctype");
  if (kr(e)) {
    if (nr(n, kr))
      throw new Dt(ci, "Only one doctype is allowed");
    var s = nr(n, ar);
    if (r && n.indexOf(s) < n.indexOf(r))
      throw new Dt(ci, "Doctype can only be inserted before an element");
    if (!r && s)
      throw new Dt(ci, "Doctype can not be appended since element is present");
  }
}
function Mv(t, e, r) {
  var n = t.childNodes || [], i = e.childNodes || [];
  if (e.nodeType === rt.DOCUMENT_FRAGMENT_NODE) {
    var a = i.filter(ar);
    if (a.length > 1 || nr(i, oh))
      throw new Dt(ci, "More than one element or text in fragment");
    if (a.length === 1 && !lp(t, r))
      throw new Dt(ci, "Element in fragment can not be inserted before doctype");
  }
  if (ar(e) && !lp(t, r))
    throw new Dt(ci, "Only one element can be added and only after doctype");
  if (kr(e)) {
    if (nr(n, function(u) {
      return kr(u) && u !== r;
    }))
      throw new Dt(ci, "Only one doctype is allowed");
    var s = nr(n, ar);
    if (r && n.indexOf(s) < n.indexOf(r))
      throw new Dt(ci, "Doctype can only be inserted before an element");
  }
}
function tu(t, e, r, n) {
  HS(t, e, r), t.nodeType === rt.DOCUMENT_NODE && (n || WS)(t, e, r);
  var i = e.parentNode;
  if (i && i.removeChild(e), e.nodeType === Pr) {
    var a = e.firstChild;
    if (a == null)
      return e;
    var s = e.lastChild;
  } else
    a = s = e;
  var o = r ? r.previousSibling : t.lastChild;
  a.previousSibling = o, s.nextSibling = r, o ? o.nextSibling = a : t.firstChild = a, r == null ? t.lastChild = s : r.previousSibling = s;
  do
    a.parentNode = t;
  while (a !== s && (a = a.nextSibling));
  return sh(t.ownerDocument || t, t), e.nodeType == Pr && (e.firstChild = e.lastChild = null), e;
}
function qS(t, e) {
  return e.parentNode && e.parentNode.removeChild(e), e.parentNode = t, e.previousSibling = t.lastChild, e.nextSibling = null, e.previousSibling ? e.previousSibling.nextSibling = e : t.firstChild = e, t.lastChild = e, sh(t.ownerDocument, t, e), e;
}
Hs.prototype = {
  //implementation : null,
  nodeName: "#document",
  nodeType: wv,
  /**
   * The DocumentType node of the document.
   *
   * @readonly
   * @type DocumentType
   */
  doctype: null,
  documentElement: null,
  _inc: 1,
  insertBefore: function(t, e) {
    if (t.nodeType == Pr) {
      for (var r = t.firstChild; r; ) {
        var n = r.nextSibling;
        this.insertBefore(r, e), r = n;
      }
      return t;
    }
    return tu(this, t, e), t.ownerDocument = this, this.documentElement === null && t.nodeType === Fi && (this.documentElement = t), t;
  },
  removeChild: function(t) {
    return this.documentElement == t && (this.documentElement = null), Ov(this, t);
  },
  replaceChild: function(t, e) {
    tu(this, t, e, Mv), t.ownerDocument = this, e && this.removeChild(e), ar(t) && (this.documentElement = t);
  },
  // Introduced in DOM Level 2:
  importNode: function(t, e) {
    return Vv(this, t, e);
  },
  // Introduced in DOM Level 2:
  getElementById: function(t) {
    var e = null;
    return ws(this.documentElement, function(r) {
      if (r.nodeType == Fi && r.getAttribute("id") == t)
        return e = r, !0;
    }), e;
  },
  /**
   * The `getElementsByClassName` method of `Document` interface returns an array-like object
   * of all child elements which have **all** of the given class name(s).
   *
   * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
   *
   *
   * Warning: This is a live LiveNodeList.
   * Changes in the DOM will reflect in the array as the changes occur.
   * If an element selected by this array no longer qualifies for the selector,
   * it will automatically be removed. Be aware of this for iteration purposes.
   *
   * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
   * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
   */
  getElementsByClassName: function(t) {
    var e = np(t);
    return new Ta(this, function(r) {
      var n = [];
      return e.length > 0 && ws(r.documentElement, function(i) {
        if (i !== r && i.nodeType === Fi) {
          var a = i.getAttribute("class");
          if (a) {
            var s = t === a;
            if (!s) {
              var o = np(a);
              s = e.every(NS(o));
            }
            s && n.push(i);
          }
        }
      }), n;
    });
  },
  //document factory method:
  createElement: function(t) {
    var e = new xn();
    e.ownerDocument = this, e.nodeName = t, e.tagName = t, e.localName = t, e.childNodes = new xr();
    var r = e.attributes = new eu();
    return r._ownerElement = e, e;
  },
  createDocumentFragment: function() {
    var t = new Nu();
    return t.ownerDocument = this, t.childNodes = new xr(), t;
  },
  createTextNode: function(t) {
    var e = new uh();
    return e.ownerDocument = this, e.appendData(t), e;
  },
  createComment: function(t) {
    var e = new lh();
    return e.ownerDocument = this, e.appendData(t), e;
  },
  createCDATASection: function(t) {
    var e = new dh();
    return e.ownerDocument = this, e.appendData(t), e;
  },
  createProcessingInstruction: function(t, e) {
    var r = new hh();
    return r.ownerDocument = this, r.tagName = r.target = t, r.nodeValue = r.data = e, r;
  },
  createAttribute: function(t) {
    var e = new iu();
    return e.ownerDocument = this, e.name = t, e.nodeName = t, e.localName = t, e.specified = !0, e;
  },
  createEntityReference: function(t) {
    var e = new ch();
    return e.ownerDocument = this, e.nodeName = t, e;
  },
  // Introduced in DOM Level 2:
  createElementNS: function(t, e) {
    var r = new xn(), n = e.split(":"), i = r.attributes = new eu();
    return r.childNodes = new xr(), r.ownerDocument = this, r.nodeName = e, r.tagName = e, r.namespaceURI = t, n.length == 2 ? (r.prefix = n[0], r.localName = n[1]) : r.localName = e, i._ownerElement = r, r;
  },
  // Introduced in DOM Level 2:
  createAttributeNS: function(t, e) {
    var r = new iu(), n = e.split(":");
    return r.ownerDocument = this, r.nodeName = e, r.name = e, r.namespaceURI = t, r.specified = !0, n.length == 2 ? (r.prefix = n[0], r.localName = n[1]) : r.localName = e, r;
  }
};
gi(Hs, rt);
function xn() {
  this._nsMap = {};
}
xn.prototype = {
  nodeType: Fi,
  hasAttribute: function(t) {
    return this.getAttributeNode(t) != null;
  },
  getAttribute: function(t) {
    var e = this.getAttributeNode(t);
    return e && e.value || "";
  },
  getAttributeNode: function(t) {
    return this.attributes.getNamedItem(t);
  },
  setAttribute: function(t, e) {
    var r = this.ownerDocument.createAttribute(t);
    r.value = r.nodeValue = "" + e, this.setAttributeNode(r);
  },
  removeAttribute: function(t) {
    var e = this.getAttributeNode(t);
    e && this.removeAttributeNode(e);
  },
  //four real opeartion method
  appendChild: function(t) {
    return t.nodeType === Pr ? this.insertBefore(t, null) : qS(this, t);
  },
  setAttributeNode: function(t) {
    return this.attributes.setNamedItem(t);
  },
  setAttributeNodeNS: function(t) {
    return this.attributes.setNamedItemNS(t);
  },
  removeAttributeNode: function(t) {
    return this.attributes.removeNamedItem(t.nodeName);
  },
  //get real attribute name,and remove it by removeAttributeNode
  removeAttributeNS: function(t, e) {
    var r = this.getAttributeNodeNS(t, e);
    r && this.removeAttributeNode(r);
  },
  hasAttributeNS: function(t, e) {
    return this.getAttributeNodeNS(t, e) != null;
  },
  getAttributeNS: function(t, e) {
    var r = this.getAttributeNodeNS(t, e);
    return r && r.value || "";
  },
  setAttributeNS: function(t, e, r) {
    var n = this.ownerDocument.createAttributeNS(t, e);
    n.value = n.nodeValue = "" + r, this.setAttributeNode(n);
  },
  getAttributeNodeNS: function(t, e) {
    return this.attributes.getNamedItemNS(t, e);
  },
  getElementsByTagName: function(t) {
    return new Ta(this, function(e) {
      var r = [];
      return ws(e, function(n) {
        n !== e && n.nodeType == Fi && (t === "*" || n.tagName == t) && r.push(n);
      }), r;
    });
  },
  getElementsByTagNameNS: function(t, e) {
    return new Ta(this, function(r) {
      var n = [];
      return ws(r, function(i) {
        i !== r && i.nodeType === Fi && (t === "*" || i.namespaceURI === t) && (e === "*" || i.localName == e) && n.push(i);
      }), n;
    });
  }
};
Hs.prototype.getElementsByTagName = xn.prototype.getElementsByTagName;
Hs.prototype.getElementsByTagNameNS = xn.prototype.getElementsByTagNameNS;
gi(xn, rt);
function iu() {
}
iu.prototype.nodeType = _a;
gi(iu, rt);
function Ws() {
}
Ws.prototype = {
  data: "",
  substringData: function(t, e) {
    return this.data.substring(t, t + e);
  },
  appendData: function(t) {
    t = this.data + t, this.nodeValue = this.data = t, this.length = t.length;
  },
  insertData: function(t, e) {
    this.replaceData(t, 0, e);
  },
  appendChild: function(t) {
    throw new Error(Ut[ci]);
  },
  deleteData: function(t, e) {
    this.replaceData(t, e, "");
  },
  replaceData: function(t, e, r) {
    var n = this.data.substring(0, t), i = this.data.substring(t + e);
    r = n + r + i, this.nodeValue = this.data = r, this.length = r.length;
  }
};
gi(Ws, rt);
function uh() {
}
uh.prototype = {
  nodeName: "#text",
  nodeType: Zo,
  splitText: function(t) {
    var e = this.data, r = e.substring(t);
    e = e.substring(0, t), this.data = this.nodeValue = e, this.length = e.length;
    var n = this.ownerDocument.createTextNode(r);
    return this.parentNode && this.parentNode.insertBefore(n, this.nextSibling), n;
  }
};
gi(uh, Ws);
function lh() {
}
lh.prototype = {
  nodeName: "#comment",
  nodeType: Av
};
gi(lh, Ws);
function dh() {
}
dh.prototype = {
  nodeName: "#cdata-section",
  nodeType: Ev
};
gi(dh, Ws);
function Mu() {
}
Mu.prototype.nodeType = Pv;
gi(Mu, rt);
function Nv() {
}
Nv.prototype.nodeType = FS;
gi(Nv, rt);
function Bv() {
}
Bv.prototype.nodeType = BS;
gi(Bv, rt);
function ch() {
}
ch.prototype.nodeType = xv;
gi(ch, rt);
function Nu() {
}
Nu.prototype.nodeName = "#document-fragment";
Nu.prototype.nodeType = Pr;
gi(Nu, rt);
function hh() {
}
hh.prototype.nodeType = Cv;
gi(hh, rt);
function Fv() {
}
Fv.prototype.serializeToString = function(t, e, r) {
  return Uv.call(t, e, r);
};
rt.prototype.toString = Uv;
function Uv(t, e) {
  var r = [], n = this.nodeType == 9 && this.documentElement || this, i = n.prefix, a = n.namespaceURI;
  if (a && i == null) {
    var i = n.lookupPrefix(a);
    if (i == null)
      var s = [
        { namespace: a, prefix: null }
        //{namespace:uri,prefix:''}
      ];
  }
  return aa(this, r, t, e, s), r.join("");
}
function dp(t, e, r) {
  var n = t.prefix || "", i = t.namespaceURI;
  if (!i || n === "xml" && i === As.XML || i === As.XMLNS)
    return !1;
  for (var a = r.length; a--; ) {
    var s = r[a];
    if (s.prefix === n)
      return s.namespace !== i;
  }
  return !0;
}
function Ll(t, e, r) {
  t.push(" ", e, '="', r.replace(/[<>&"\t\n\r]/g, Dv), '"');
}
function aa(t, e, r, n, i) {
  if (i || (i = []), n)
    if (t = n(t), t) {
      if (typeof t == "string") {
        e.push(t);
        return;
      }
    } else
      return;
  switch (t.nodeType) {
    case Fi:
      var a = t.attributes, s = a.length, E = t.firstChild, o = t.tagName;
      r = As.isHTML(t.namespaceURI) || r;
      var u = o;
      if (!r && !t.prefix && t.namespaceURI) {
        for (var l, d = 0; d < a.length; d++)
          if (a.item(d).name === "xmlns") {
            l = a.item(d).value;
            break;
          }
        if (!l)
          for (var h = i.length - 1; h >= 0; h--) {
            var f = i[h];
            if (f.prefix === "" && f.namespace === t.namespaceURI) {
              l = f.namespace;
              break;
            }
          }
        if (l !== t.namespaceURI)
          for (var h = i.length - 1; h >= 0; h--) {
            var f = i[h];
            if (f.namespace === t.namespaceURI) {
              f.prefix && (u = f.prefix + ":" + o);
              break;
            }
          }
      }
      e.push("<", u);
      for (var v = 0; v < s; v++) {
        var b = a.item(v);
        b.prefix == "xmlns" ? i.push({ prefix: b.localName, namespace: b.value }) : b.nodeName == "xmlns" && i.push({ prefix: "", namespace: b.value });
      }
      for (var v = 0; v < s; v++) {
        var b = a.item(v);
        if (dp(b, r, i)) {
          var _ = b.prefix || "", y = b.namespaceURI;
          Ll(e, _ ? "xmlns:" + _ : "xmlns", y), i.push({ prefix: _, namespace: y });
        }
        aa(b, e, r, n, i);
      }
      if (o === u && dp(t, r, i)) {
        var _ = t.prefix || "", y = t.namespaceURI;
        Ll(e, _ ? "xmlns:" + _ : "xmlns", y), i.push({ prefix: _, namespace: y });
      }
      if (E || r && !/^(?:meta|link|img|br|hr|input)$/i.test(o)) {
        if (e.push(">"), r && /^script$/i.test(o))
          for (; E; )
            E.data ? e.push(E.data) : aa(E, e, r, n, i.slice()), E = E.nextSibling;
        else
          for (; E; )
            aa(E, e, r, n, i.slice()), E = E.nextSibling;
        e.push("</", u, ">");
      } else
        e.push("/>");
      return;
    case wv:
    case Pr:
      for (var E = t.firstChild; E; )
        aa(E, e, r, n, i.slice()), E = E.nextSibling;
      return;
    case _a:
      return Ll(e, t.name, t.value);
    case Zo:
      return e.push(
        t.data.replace(/[<&>]/g, Dv)
      );
    case Ev:
      return e.push("<![CDATA[", t.data, "]]>");
    case Av:
      return e.push("<!--", t.data, "-->");
    case Pv:
      var R = t.publicId, D = t.systemId;
      if (e.push("<!DOCTYPE ", t.name), R)
        e.push(" PUBLIC ", R), D && D != "." && e.push(" ", D), e.push(">");
      else if (D && D != ".")
        e.push(" SYSTEM ", D, ">");
      else {
        var C = t.internalSubset;
        C && e.push(" [", C, "]"), e.push(">");
      }
      return;
    case Cv:
      return e.push("<?", t.target, " ", t.data, "?>");
    case xv:
      return e.push("&", t.nodeName, ";");
    default:
      e.push("??", t.nodeName);
  }
}
function Vv(t, e, r) {
  var n;
  switch (e.nodeType) {
    case Fi:
      n = e.cloneNode(!1), n.ownerDocument = t;
    case Pr:
      break;
    case _a:
      r = !0;
      break;
  }
  if (n || (n = e.cloneNode(!1)), n.ownerDocument = t, n.parentNode = null, r)
    for (var i = e.firstChild; i; )
      n.appendChild(Vv(t, i, r)), i = i.nextSibling;
  return n;
}
function oc(t, e, r) {
  var n = new e.constructor();
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      var a = e[i];
      typeof a != "object" && a != n[i] && (n[i] = a);
    }
  switch (e.childNodes && (n.childNodes = new xr()), n.ownerDocument = t, n.nodeType) {
    case Fi:
      var s = e.attributes, o = n.attributes = new eu(), u = s.length;
      o._ownerElement = n;
      for (var l = 0; l < u; l++)
        n.setAttributeNode(oc(t, s.item(l), !0));
      break;
    case _a:
      r = !0;
  }
  if (r)
    for (var d = e.firstChild; d; )
      n.appendChild(oc(t, d, r)), d = d.nextSibling;
  return n;
}
function jv(t, e, r) {
  t[e] = r;
}
try {
  if (Object.defineProperty) {
    let t = function(e) {
      switch (e.nodeType) {
        case Fi:
        case Pr:
          var r = [];
          for (e = e.firstChild; e; )
            e.nodeType !== 7 && e.nodeType !== 8 && r.push(t(e)), e = e.nextSibling;
          return r.join("");
        default:
          return e.nodeValue;
      }
    };
    Object.defineProperty(Ta.prototype, "length", {
      get: function() {
        return ah(this), this.$$length;
      }
    }), Object.defineProperty(rt.prototype, "textContent", {
      get: function() {
        return t(this);
      },
      set: function(e) {
        switch (this.nodeType) {
          case Fi:
          case Pr:
            for (; this.firstChild; )
              this.removeChild(this.firstChild);
            (e || String(e)) && this.appendChild(this.ownerDocument.createTextNode(e));
            break;
          default:
            this.data = e, this.value = e, this.nodeValue = e;
        }
      }
    }), jv = function(e, r, n) {
      e["$$" + r] = n;
    };
  }
} catch {
}
Qr.DocumentType = Mu;
Qr.DOMException = Dt;
Qr.DOMImplementation = Iv;
Qr.Element = xn;
Qr.Node = rt;
Qr.NodeList = xr;
Qr.XMLSerializer = Fv;
var Bu = {}, Hv = {};
(function(t) {
  var e = Rr.freeze;
  t.XML_ENTITIES = e({ amp: "&", apos: "'", gt: ">", lt: "<", quot: '"' }), t.HTML_ENTITIES = e({
    lt: "<",
    gt: ">",
    amp: "&",
    quot: '"',
    apos: "'",
    Agrave: "À",
    Aacute: "Á",
    Acirc: "Â",
    Atilde: "Ã",
    Auml: "Ä",
    Aring: "Å",
    AElig: "Æ",
    Ccedil: "Ç",
    Egrave: "È",
    Eacute: "É",
    Ecirc: "Ê",
    Euml: "Ë",
    Igrave: "Ì",
    Iacute: "Í",
    Icirc: "Î",
    Iuml: "Ï",
    ETH: "Ð",
    Ntilde: "Ñ",
    Ograve: "Ò",
    Oacute: "Ó",
    Ocirc: "Ô",
    Otilde: "Õ",
    Ouml: "Ö",
    Oslash: "Ø",
    Ugrave: "Ù",
    Uacute: "Ú",
    Ucirc: "Û",
    Uuml: "Ü",
    Yacute: "Ý",
    THORN: "Þ",
    szlig: "ß",
    agrave: "à",
    aacute: "á",
    acirc: "â",
    atilde: "ã",
    auml: "ä",
    aring: "å",
    aelig: "æ",
    ccedil: "ç",
    egrave: "è",
    eacute: "é",
    ecirc: "ê",
    euml: "ë",
    igrave: "ì",
    iacute: "í",
    icirc: "î",
    iuml: "ï",
    eth: "ð",
    ntilde: "ñ",
    ograve: "ò",
    oacute: "ó",
    ocirc: "ô",
    otilde: "õ",
    ouml: "ö",
    oslash: "ø",
    ugrave: "ù",
    uacute: "ú",
    ucirc: "û",
    uuml: "ü",
    yacute: "ý",
    thorn: "þ",
    yuml: "ÿ",
    nbsp: " ",
    iexcl: "¡",
    cent: "¢",
    pound: "£",
    curren: "¤",
    yen: "¥",
    brvbar: "¦",
    sect: "§",
    uml: "¨",
    copy: "©",
    ordf: "ª",
    laquo: "«",
    not: "¬",
    shy: "­­",
    reg: "®",
    macr: "¯",
    deg: "°",
    plusmn: "±",
    sup2: "²",
    sup3: "³",
    acute: "´",
    micro: "µ",
    para: "¶",
    middot: "·",
    cedil: "¸",
    sup1: "¹",
    ordm: "º",
    raquo: "»",
    frac14: "¼",
    frac12: "½",
    frac34: "¾",
    iquest: "¿",
    times: "×",
    divide: "÷",
    forall: "∀",
    part: "∂",
    exist: "∃",
    empty: "∅",
    nabla: "∇",
    isin: "∈",
    notin: "∉",
    ni: "∋",
    prod: "∏",
    sum: "∑",
    minus: "−",
    lowast: "∗",
    radic: "√",
    prop: "∝",
    infin: "∞",
    ang: "∠",
    and: "∧",
    or: "∨",
    cap: "∩",
    cup: "∪",
    int: "∫",
    there4: "∴",
    sim: "∼",
    cong: "≅",
    asymp: "≈",
    ne: "≠",
    equiv: "≡",
    le: "≤",
    ge: "≥",
    sub: "⊂",
    sup: "⊃",
    nsub: "⊄",
    sube: "⊆",
    supe: "⊇",
    oplus: "⊕",
    otimes: "⊗",
    perp: "⊥",
    sdot: "⋅",
    Alpha: "Α",
    Beta: "Β",
    Gamma: "Γ",
    Delta: "Δ",
    Epsilon: "Ε",
    Zeta: "Ζ",
    Eta: "Η",
    Theta: "Θ",
    Iota: "Ι",
    Kappa: "Κ",
    Lambda: "Λ",
    Mu: "Μ",
    Nu: "Ν",
    Xi: "Ξ",
    Omicron: "Ο",
    Pi: "Π",
    Rho: "Ρ",
    Sigma: "Σ",
    Tau: "Τ",
    Upsilon: "Υ",
    Phi: "Φ",
    Chi: "Χ",
    Psi: "Ψ",
    Omega: "Ω",
    alpha: "α",
    beta: "β",
    gamma: "γ",
    delta: "δ",
    epsilon: "ε",
    zeta: "ζ",
    eta: "η",
    theta: "θ",
    iota: "ι",
    kappa: "κ",
    lambda: "λ",
    mu: "μ",
    nu: "ν",
    xi: "ξ",
    omicron: "ο",
    pi: "π",
    rho: "ρ",
    sigmaf: "ς",
    sigma: "σ",
    tau: "τ",
    upsilon: "υ",
    phi: "φ",
    chi: "χ",
    psi: "ψ",
    omega: "ω",
    thetasym: "ϑ",
    upsih: "ϒ",
    piv: "ϖ",
    OElig: "Œ",
    oelig: "œ",
    Scaron: "Š",
    scaron: "š",
    Yuml: "Ÿ",
    fnof: "ƒ",
    circ: "ˆ",
    tilde: "˜",
    ensp: " ",
    emsp: " ",
    thinsp: " ",
    zwnj: "‌",
    zwj: "‍",
    lrm: "‎",
    rlm: "‏",
    ndash: "–",
    mdash: "—",
    lsquo: "‘",
    rsquo: "’",
    sbquo: "‚",
    ldquo: "“",
    rdquo: "”",
    bdquo: "„",
    dagger: "†",
    Dagger: "‡",
    bull: "•",
    hellip: "…",
    permil: "‰",
    prime: "′",
    Prime: "″",
    lsaquo: "‹",
    rsaquo: "›",
    oline: "‾",
    euro: "€",
    trade: "™",
    larr: "←",
    uarr: "↑",
    rarr: "→",
    darr: "↓",
    harr: "↔",
    crarr: "↵",
    lceil: "⌈",
    rceil: "⌉",
    lfloor: "⌊",
    rfloor: "⌋",
    loz: "◊",
    spades: "♠",
    clubs: "♣",
    hearts: "♥",
    diams: "♦"
  }), t.entityMap = t.HTML_ENTITIES;
})(Hv);
var fh = {}, Ps = Rr.NAMESPACE, uc = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, cp = new RegExp("[\\-\\.0-9" + uc.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), hp = new RegExp("^" + uc.source + cp.source + "*(?::" + uc.source + cp.source + "*)?$"), es = 0, $r = 1, Kn = 2, ts = 3, Xn = 4, Yn = 5, is = 6, _o = 7;
function ba(t, e) {
  this.message = t, this.locator = e, Error.captureStackTrace && Error.captureStackTrace(this, ba);
}
ba.prototype = new Error();
ba.prototype.name = ba.name;
function Wv() {
}
Wv.prototype = {
  parse: function(t, e, r) {
    var n = this.domBuilder;
    n.startDocument(), qv(e, e = {}), $S(
      t,
      e,
      r,
      n,
      this.errorHandler
    ), n.endDocument();
  }
};
function $S(t, e, r, n, i) {
  function a(z) {
    if (z > 65535) {
      z -= 65536;
      var Q = 55296 + (z >> 10), te = 56320 + (z & 1023);
      return String.fromCharCode(Q, te);
    } else
      return String.fromCharCode(z);
  }
  function s(z) {
    var Q = z.slice(1, -1);
    return Object.hasOwnProperty.call(r, Q) ? r[Q] : Q.charAt(0) === "#" ? a(parseInt(Q.substr(1).replace("x", "0x"))) : (i.error("entity not found:" + z), z);
  }
  function o(z) {
    if (z > _) {
      var Q = t.substring(_, z).replace(/&#?\w+;/g, s);
      f && u(_), n.characters(Q, 0, z - _), _ = z;
    }
  }
  function u(z, Q) {
    for (; z >= d && (Q = h.exec(t)); )
      l = Q.index, d = l + Q[0].length, f.lineNumber++;
    f.columnNumber = z - l + 1;
  }
  for (var l = 0, d = 0, h = /.*(?:\r\n?|\n)|.*$/g, f = n.locator, v = [{ currentNSMap: e }], b = {}, _ = 0; ; ) {
    try {
      var y = t.indexOf("<", _);
      if (y < 0) {
        if (!t.substr(_).match(/^\s*$/)) {
          var E = n.doc, R = E.createTextNode(t.substr(_));
          E.appendChild(R), n.currentElement = R;
        }
        return;
      }
      switch (y > _ && o(y), t.charAt(y + 1)) {
        case "/":
          var G = t.indexOf(">", y + 3), D = t.substring(y + 2, G).replace(/[ \t\n\r]+$/g, ""), C = v.pop();
          G < 0 ? (D = t.substring(y + 2).replace(/[\s<].*/, ""), i.error("end tag name: " + D + " is not complete:" + C.tagName), G = y + 1 + D.length) : D.match(/\s</) && (D = D.replace(/[\s<].*/, ""), i.error("end tag name: " + D + " maybe not complete"), G = y + 1 + D.length);
          var w = C.localNSMap, k = C.tagName == D, I = k || C.tagName && C.tagName.toLowerCase() == D.toLowerCase();
          if (I) {
            if (n.endElement(C.uri, C.localName, D), w)
              for (var U in w)
                Object.prototype.hasOwnProperty.call(w, U) && n.endPrefixMapping(U);
            k || i.fatalError("end tag name: " + D + " is not match the current start tagName:" + C.tagName);
          } else
            v.push(C);
          G++;
          break;
        case "?":
          f && u(y), G = YS(t, y, n);
          break;
        case "!":
          f && u(y), G = XS(t, y, n, i);
          break;
        default:
          f && u(y);
          var $ = new $v(), W = v[v.length - 1].currentNSMap, G = zS(t, y, $, W, s, i), Y = $.length;
          if (!$.closed && KS(t, G, $.tagName, b) && ($.closed = !0, r.nbsp || i.warning("unclosed xml attribute")), f && Y) {
            for (var re = fp(f, {}), j = 0; j < Y; j++) {
              var J = $[j];
              u(J.offset), J.locator = fp(f, {});
            }
            n.locator = re, pp($, n, W) && v.push($), n.locator = f;
          } else
            pp($, n, W) && v.push($);
          Ps.isHTML($.uri) && !$.closed ? G = GS(t, G, $.tagName, s, n) : G++;
      }
    } catch (z) {
      if (z instanceof ba)
        throw z;
      i.error("element parse error: " + z), G = -1;
    }
    G > _ ? _ = G : o(Math.max(y, _) + 1);
  }
}
function fp(t, e) {
  return e.lineNumber = t.lineNumber, e.columnNumber = t.columnNumber, e;
}
function zS(t, e, r, n, i, a) {
  function s(f, v, b) {
    r.attributeNames.hasOwnProperty(f) && a.fatalError("Attribute " + f + " redefined"), r.addValue(
      f,
      // @see https://www.w3.org/TR/xml/#AVNormalize
      // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
      // - recursive replacement of (DTD) entity references
      // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
      v.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, i),
      b
    );
  }
  for (var o, u, l = ++e, d = es; ; ) {
    var h = t.charAt(l);
    switch (h) {
      case "=":
        if (d === $r)
          o = t.slice(e, l), d = ts;
        else if (d === Kn)
          d = ts;
        else
          throw new Error("attribute equal must after attrName");
        break;
      case "'":
      case '"':
        if (d === ts || d === $r)
          if (d === $r && (a.warning('attribute value must after "="'), o = t.slice(e, l)), e = l + 1, l = t.indexOf(h, e), l > 0)
            u = t.slice(e, l), s(o, u, e - 1), d = Yn;
          else
            throw new Error("attribute value no end '" + h + "' match");
        else if (d == Xn)
          u = t.slice(e, l), s(o, u, e), a.warning('attribute "' + o + '" missed start quot(' + h + ")!!"), e = l + 1, d = Yn;
        else
          throw new Error('attribute value must after "="');
        break;
      case "/":
        switch (d) {
          case es:
            r.setTagName(t.slice(e, l));
          case Yn:
          case is:
          case _o:
            d = _o, r.closed = !0;
          case Xn:
          case $r:
            break;
          case Kn:
            r.closed = !0;
            break;
          default:
            throw new Error("attribute invalid close char('/')");
        }
        break;
      case "":
        return a.error("unexpected end of input"), d == es && r.setTagName(t.slice(e, l)), l;
      case ">":
        switch (d) {
          case es:
            r.setTagName(t.slice(e, l));
          case Yn:
          case is:
          case _o:
            break;
          case Xn:
          case $r:
            u = t.slice(e, l), u.slice(-1) === "/" && (r.closed = !0, u = u.slice(0, -1));
          case Kn:
            d === Kn && (u = o), d == Xn ? (a.warning('attribute "' + u + '" missed quot(")!'), s(o, u, e)) : ((!Ps.isHTML(n[""]) || !u.match(/^(?:disabled|checked|selected)$/i)) && a.warning('attribute "' + u + '" missed value!! "' + u + '" instead!!'), s(u, u, e));
            break;
          case ts:
            throw new Error("attribute value missed!!");
        }
        return l;
      case "":
        h = " ";
      default:
        if (h <= " ")
          switch (d) {
            case es:
              r.setTagName(t.slice(e, l)), d = is;
              break;
            case $r:
              o = t.slice(e, l), d = Kn;
              break;
            case Xn:
              var u = t.slice(e, l);
              a.warning('attribute "' + u + '" missed quot(")!!'), s(o, u, e);
            case Yn:
              d = is;
              break;
          }
        else
          switch (d) {
            case Kn:
              r.tagName, (!Ps.isHTML(n[""]) || !o.match(/^(?:disabled|checked|selected)$/i)) && a.warning('attribute "' + o + '" missed value!! "' + o + '" instead2!!'), s(o, o, e), e = l, d = $r;
              break;
            case Yn:
              a.warning('attribute space is required"' + o + '"!!');
            case is:
              d = $r, e = l;
              break;
            case ts:
              d = Xn, e = l;
              break;
            case _o:
              throw new Error("elements closed character '/' and '>' must be connected to");
          }
    }
    l++;
  }
}
function pp(t, e, r) {
  for (var n = t.tagName, i = null, h = t.length; h--; ) {
    var a = t[h], s = a.qName, o = a.value, f = s.indexOf(":");
    if (f > 0)
      var u = a.prefix = s.slice(0, f), l = s.slice(f + 1), d = u === "xmlns" && l;
    else
      l = s, u = null, d = s === "xmlns" && "";
    a.localName = l, d !== !1 && (i == null && (i = {}, qv(r, r = {})), r[d] = i[d] = o, a.uri = Ps.XMLNS, e.startPrefixMapping(d, o));
  }
  for (var h = t.length; h--; ) {
    a = t[h];
    var u = a.prefix;
    u && (u === "xml" && (a.uri = Ps.XML), u !== "xmlns" && (a.uri = r[u || ""]));
  }
  var f = n.indexOf(":");
  f > 0 ? (u = t.prefix = n.slice(0, f), l = t.localName = n.slice(f + 1)) : (u = null, l = t.localName = n);
  var v = t.uri = r[u || ""];
  if (e.startElement(v, l, n, t), t.closed) {
    if (e.endElement(v, l, n), i)
      for (u in i)
        Object.prototype.hasOwnProperty.call(i, u) && e.endPrefixMapping(u);
  } else
    return t.currentNSMap = r, t.localNSMap = i, !0;
}
function GS(t, e, r, n, i) {
  if (/^(?:script|textarea)$/i.test(r)) {
    var a = t.indexOf("</" + r + ">", e), s = t.substring(e + 1, a);
    if (/[&<]/.test(s))
      return /^script$/i.test(r) ? (i.characters(s, 0, s.length), a) : (s = s.replace(/&#?\w+;/g, n), i.characters(s, 0, s.length), a);
  }
  return e + 1;
}
function KS(t, e, r, n) {
  var i = n[r];
  return i == null && (i = t.lastIndexOf("</" + r + ">"), i < e && (i = t.lastIndexOf("</" + r)), n[r] = i), i < e;
}
function qv(t, e) {
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
}
function XS(t, e, r, n) {
  var i = t.charAt(e + 2);
  switch (i) {
    case "-":
      if (t.charAt(e + 3) === "-") {
        var a = t.indexOf("-->", e + 4);
        return a > e ? (r.comment(t, e + 4, a - e - 4), a + 3) : (n.error("Unclosed comment"), -1);
      } else
        return -1;
    default:
      if (t.substr(e + 3, 6) == "CDATA[") {
        var a = t.indexOf("]]>", e + 9);
        return r.startCDATA(), r.characters(t, e + 9, a - e - 9), r.endCDATA(), a + 3;
      }
      var s = QS(t, e), o = s.length;
      if (o > 1 && /!doctype/i.test(s[0][0])) {
        var u = s[1][0], l = !1, d = !1;
        o > 3 && (/^public$/i.test(s[2][0]) ? (l = s[3][0], d = o > 4 && s[4][0]) : /^system$/i.test(s[2][0]) && (d = s[3][0]));
        var h = s[o - 1];
        return r.startDTD(u, l, d), r.endDTD(), h.index + h[0].length;
      }
  }
  return -1;
}
function YS(t, e, r) {
  var n = t.indexOf("?>", e);
  if (n) {
    var i = t.substring(e, n).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
    return i ? (i[0].length, r.processingInstruction(i[1], i[2]), n + 2) : -1;
  }
  return -1;
}
function $v() {
  this.attributeNames = {};
}
$v.prototype = {
  setTagName: function(t) {
    if (!hp.test(t))
      throw new Error("invalid tagName:" + t);
    this.tagName = t;
  },
  addValue: function(t, e, r) {
    if (!hp.test(t))
      throw new Error("invalid attribute:" + t);
    this.attributeNames[t] = this.length, this[this.length++] = { qName: t, value: e, offset: r };
  },
  length: 0,
  getLocalName: function(t) {
    return this[t].localName;
  },
  getLocator: function(t) {
    return this[t].locator;
  },
  getQName: function(t) {
    return this[t].qName;
  },
  getURI: function(t) {
    return this[t].uri;
  },
  getValue: function(t) {
    return this[t].value;
  }
  //	,getIndex:function(uri, localName)){
  //		if(localName){
  //
  //		}else{
  //			var qName = uri
  //		}
  //	},
  //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
  //	getType:function(uri,localName){}
  //	getType:function(i){},
};
function QS(t, e) {
  var r, n = [], i = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
  for (i.lastIndex = e, i.exec(t); r = i.exec(t); )
    if (n.push(r), r[1])
      return n;
}
fh.XMLReader = Wv;
fh.ParseError = ba;
var JS = Rr, ZS = Qr, gp = Hv, zv = fh, eE = ZS.DOMImplementation, mp = JS.NAMESPACE, tE = zv.ParseError, iE = zv.XMLReader;
function Gv(t) {
  return t.replace(/\r[\n\u0085]/g, `
`).replace(/[\r\u0085\u2028]/g, `
`);
}
function Kv(t) {
  this.options = t || { locator: {} };
}
Kv.prototype.parseFromString = function(t, e) {
  var r = this.options, n = new iE(), i = r.domBuilder || new qs(), a = r.errorHandler, s = r.locator, o = r.xmlns || {}, u = /\/x?html?$/.test(e), l = u ? gp.HTML_ENTITIES : gp.XML_ENTITIES;
  s && i.setDocumentLocator(s), n.errorHandler = rE(a, i, s), n.domBuilder = r.domBuilder || i, u && (o[""] = mp.HTML), o.xml = o.xml || mp.XML;
  var d = r.normalizeLineEndings || Gv;
  return t && typeof t == "string" ? n.parse(
    d(t),
    o,
    l
  ) : n.errorHandler.error("invalid doc source"), i.doc;
};
function rE(t, e, r) {
  if (!t) {
    if (e instanceof qs)
      return e;
    t = e;
  }
  var n = {}, i = t instanceof Function;
  r = r || {};
  function a(s) {
    var o = t[s];
    !o && i && (o = t.length == 2 ? function(u) {
      t(s, u);
    } : t), n[s] = o && function(u) {
      o("[xmldom " + s + "]	" + u + lc(r));
    } || function() {
    };
  }
  return a("warning"), a("error"), a("fatalError"), n;
}
function qs() {
  this.cdata = !1;
}
function Qn(t, e) {
  e.lineNumber = t.lineNumber, e.columnNumber = t.columnNumber;
}
qs.prototype = {
  startDocument: function() {
    this.doc = new eE().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
  },
  startElement: function(t, e, r, n) {
    var i = this.doc, a = i.createElementNS(t, r || e), s = n.length;
    To(this, a), this.currentElement = a, this.locator && Qn(this.locator, a);
    for (var o = 0; o < s; o++) {
      var t = n.getURI(o), u = n.getValue(o), r = n.getQName(o), l = i.createAttributeNS(t, r);
      this.locator && Qn(n.getLocator(o), l), l.value = l.nodeValue = u, a.setAttributeNode(l);
    }
  },
  endElement: function(t, e, r) {
    var n = this.currentElement;
    n.tagName, this.currentElement = n.parentNode;
  },
  startPrefixMapping: function(t, e) {
  },
  endPrefixMapping: function(t) {
  },
  processingInstruction: function(t, e) {
    var r = this.doc.createProcessingInstruction(t, e);
    this.locator && Qn(this.locator, r), To(this, r);
  },
  ignorableWhitespace: function(t, e, r) {
  },
  characters: function(t, e, r) {
    if (t = vp.apply(this, arguments), t) {
      if (this.cdata)
        var n = this.doc.createCDATASection(t);
      else
        var n = this.doc.createTextNode(t);
      this.currentElement ? this.currentElement.appendChild(n) : /^\s*$/.test(t) && this.doc.appendChild(n), this.locator && Qn(this.locator, n);
    }
  },
  skippedEntity: function(t) {
  },
  endDocument: function() {
    this.doc.normalize();
  },
  setDocumentLocator: function(t) {
    (this.locator = t) && (t.lineNumber = 0);
  },
  //LexicalHandler
  comment: function(t, e, r) {
    t = vp.apply(this, arguments);
    var n = this.doc.createComment(t);
    this.locator && Qn(this.locator, n), To(this, n);
  },
  startCDATA: function() {
    this.cdata = !0;
  },
  endCDATA: function() {
    this.cdata = !1;
  },
  startDTD: function(t, e, r) {
    var n = this.doc.implementation;
    if (n && n.createDocumentType) {
      var i = n.createDocumentType(t, e, r);
      this.locator && Qn(this.locator, i), To(this, i), this.doc.doctype = i;
    }
  },
  /**
   * @see org.xml.sax.ErrorHandler
   * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
   */
  warning: function(t) {
    console.warn("[xmldom warning]	" + t, lc(this.locator));
  },
  error: function(t) {
    console.error("[xmldom error]	" + t, lc(this.locator));
  },
  fatalError: function(t) {
    throw new tE(t, this.locator);
  }
};
function lc(t) {
  if (t)
    return `
@` + (t.systemId || "") + "#[line:" + t.lineNumber + ",col:" + t.columnNumber + "]";
}
function vp(t, e, r) {
  return typeof t == "string" ? t.substr(e, r) : t.length >= e + r || e ? new java.lang.String(t, e, r) + "" : t;
}
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(t) {
  qs.prototype[t] = function() {
    return null;
  };
});
function To(t, e) {
  t.currentElement ? t.currentElement.appendChild(e) : t.doc.appendChild(e);
}
Bu.__DOMHandler = qs;
Bu.normalizeLineEndings = Gv;
Bu.DOMParser = Kv;
var nE = Bu.DOMParser;
/*! @name mpd-parser @version 0.22.1 @license Apache-2.0 */
var yp = function(e) {
  return !!e && typeof e == "object";
}, ai = function t() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  return r.reduce(function(i, a) {
    return typeof a != "object" || Object.keys(a).forEach(function(s) {
      Array.isArray(i[s]) && Array.isArray(a[s]) ? i[s] = i[s].concat(a[s]) : yp(i[s]) && yp(a[s]) ? i[s] = t(i[s], a[s]) : i[s] = a[s];
    }), i;
  }, {});
}, Xv = function(e) {
  return Object.keys(e).map(function(r) {
    return e[r];
  });
}, aE = function(e, r) {
  for (var n = [], i = e; i < r; i++)
    n.push(i);
  return n;
}, Fu = function(e) {
  return e.reduce(function(r, n) {
    return r.concat(n);
  }, []);
}, Yv = function(e) {
  if (!e.length)
    return [];
  for (var r = [], n = 0; n < e.length; n++)
    r.push(e[n]);
  return r;
}, sE = function(e, r) {
  return e.reduce(function(n, i, a) {
    return i[r] && n.push(a), n;
  }, []);
}, dc = function(e, r) {
  for (var n = 0; n < e.length; n++)
    if (r(e[n]))
      return n;
  return -1;
}, oE = function(e, r) {
  return Xv(e.reduce(function(n, i) {
    return i.forEach(function(a) {
      n[r(a)] = a;
    }), n;
  }, {}));
}, Sa = {
  INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
  DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
  DASH_INVALID_XML: "DASH_INVALID_XML",
  NO_BASE_URL: "NO_BASE_URL",
  MISSING_SEGMENT_INFORMATION: "MISSING_SEGMENT_INFORMATION",
  SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
  UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
}, ks = function(e) {
  var r = e.baseUrl, n = r === void 0 ? "" : r, i = e.source, a = i === void 0 ? "" : i, s = e.range, o = s === void 0 ? "" : s, u = e.indexRange, l = u === void 0 ? "" : u, d = {
    uri: a,
    resolvedUri: Ou(n || "", a)
  };
  if (o || l) {
    var h = o || l, f = h.split("-"), v = M.BigInt ? M.BigInt(f[0]) : parseInt(f[0], 10), b = M.BigInt ? M.BigInt(f[1]) : parseInt(f[1], 10);
    v < Number.MAX_SAFE_INTEGER && typeof v == "bigint" && (v = Number(v)), b < Number.MAX_SAFE_INTEGER && typeof b == "bigint" && (b = Number(b));
    var _;
    typeof b == "bigint" || typeof v == "bigint" ? _ = M.BigInt(b) - M.BigInt(v) + M.BigInt(1) : _ = b - v + 1, typeof _ == "bigint" && _ < Number.MAX_SAFE_INTEGER && (_ = Number(_)), d.byterange = {
      length: _,
      offset: v
    };
  }
  return d;
}, uE = function(e) {
  var r;
  return typeof e.offset == "bigint" || typeof e.length == "bigint" ? r = M.BigInt(e.offset) + M.BigInt(e.length) - M.BigInt(1) : r = e.offset + e.length - 1, e.offset + "-" + r;
}, _p = function(e) {
  return e && typeof e != "number" && (e = parseInt(e, 10)), isNaN(e) ? null : e;
}, lE = {
  /**
   * Returns the entire range of available segments for a static MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  static: function(e) {
    var r = e.duration, n = e.timescale, i = n === void 0 ? 1 : n, a = e.sourceDuration, s = e.periodDuration, o = _p(e.endNumber), u = r / i;
    return typeof o == "number" ? {
      start: 0,
      end: o
    } : typeof s == "number" ? {
      start: 0,
      end: s / u
    } : {
      start: 0,
      end: a / u
    };
  },
  /**
   * Returns the current live window range of available segments for a dynamic MPD
   *
   * @param {Object} attributes
   *        Inheritied MPD attributes
   * @return {{ start: number, end: number }}
   *         The start and end numbers for available segments
   */
  dynamic: function(e) {
    var r = e.NOW, n = e.clientOffset, i = e.availabilityStartTime, a = e.timescale, s = a === void 0 ? 1 : a, o = e.duration, u = e.periodStart, l = u === void 0 ? 0 : u, d = e.minimumUpdatePeriod, h = d === void 0 ? 0 : d, f = e.timeShiftBufferDepth, v = f === void 0 ? 1 / 0 : f, b = _p(e.endNumber), _ = (r + n) / 1e3, y = i + l, E = _ + h, R = E - y, D = Math.ceil(R * s / o), C = Math.floor((_ - y - v) * s / o), w = Math.floor((_ - y) * s / o);
    return {
      start: Math.max(0, C),
      end: typeof b == "number" ? b : Math.min(D, w)
    };
  }
}, dE = function(e) {
  return function(r) {
    var n = e.duration, i = e.timescale, a = i === void 0 ? 1 : i, s = e.periodStart, o = e.startNumber, u = o === void 0 ? 1 : o;
    return {
      number: u + r,
      duration: n / a,
      timeline: s,
      time: r * n
    };
  };
}, ph = function(e) {
  var r = e.type, n = e.duration, i = e.timescale, a = i === void 0 ? 1 : i, s = e.periodDuration, o = e.sourceDuration, u = lE[r](e), l = u.start, d = u.end, h = aE(l, d).map(dE(e));
  if (r === "static") {
    var f = h.length - 1, v = typeof s == "number" ? s : o;
    h[f].duration = v - n / a * f;
  }
  return h;
}, Qv = function(e) {
  var r = e.baseUrl, n = e.initialization, i = n === void 0 ? {} : n, a = e.sourceDuration, s = e.indexRange, o = s === void 0 ? "" : s, u = e.periodStart, l = e.presentationTime, d = e.number, h = d === void 0 ? 0 : d, f = e.duration;
  if (!r)
    throw new Error(Sa.NO_BASE_URL);
  var v = ks({
    baseUrl: r,
    source: i.sourceURL,
    range: i.range
  }), b = ks({
    baseUrl: r,
    source: r,
    indexRange: o
  });
  if (b.map = v, f) {
    var _ = ph(e);
    _.length && (b.duration = _[0].duration, b.timeline = _[0].timeline);
  } else
    a && (b.duration = a, b.timeline = u);
  return b.presentationTime = l || u, b.number = h, [b];
}, gh = function(e, r, n) {
  var i = e.sidx.map ? e.sidx.map : null, a = e.sidx.duration, s = e.timeline || 0, o = e.sidx.byterange, u = o.offset + o.length, l = r.timescale, d = r.references.filter(function($) {
    return $.referenceType !== 1;
  }), h = [], f = e.endList ? "static" : "dynamic", v = e.sidx.timeline, b = v, _ = e.mediaSequence || 0, y;
  typeof r.firstOffset == "bigint" ? y = M.BigInt(u) + r.firstOffset : y = u + r.firstOffset;
  for (var E = 0; E < d.length; E++) {
    var R = r.references[E], D = R.referencedSize, C = R.subsegmentDuration, w = void 0;
    typeof y == "bigint" ? w = y + M.BigInt(D) - M.BigInt(1) : w = y + D - 1;
    var k = y + "-" + w, I = {
      baseUrl: n,
      timescale: l,
      timeline: s,
      periodStart: v,
      presentationTime: b,
      number: _,
      duration: C,
      sourceDuration: a,
      indexRange: k,
      type: f
    }, U = Qv(I)[0];
    i && (U.map = i), h.push(U), typeof y == "bigint" ? y += M.BigInt(D) : y += D, b += C / l, _++;
  }
  return e.segments = h, e;
}, cE = ["AUDIO", "SUBTITLES"], hE = 1 / 60, Jv = function(e) {
  return oE(e, function(r) {
    var n = r.timeline;
    return n;
  }).sort(function(r, n) {
    return r.timeline > n.timeline ? 1 : -1;
  });
}, fE = function(e, r) {
  for (var n = 0; n < e.length; n++)
    if (e[n].attributes.NAME === r)
      return e[n];
  return null;
}, Tp = function(e) {
  var r = [];
  return LS(e, cE, function(n, i, a, s) {
    r = r.concat(n.playlists || []);
  }), r;
}, bp = function(e) {
  var r = e.playlist, n = e.mediaSequence;
  r.mediaSequence = n, r.segments.forEach(function(i, a) {
    i.number = r.mediaSequence + a;
  });
}, pE = function(e) {
  var r = e.oldPlaylists, n = e.newPlaylists, i = e.timelineStarts;
  n.forEach(function(a) {
    a.discontinuitySequence = dc(i, function(d) {
      var h = d.timeline;
      return h === a.timeline;
    });
    var s = fE(r, a.attributes.NAME);
    if (s && !a.sidx) {
      var o = a.segments[0], u = dc(s.segments, function(d) {
        return Math.abs(d.presentationTime - o.presentationTime) < hE;
      });
      if (u === -1) {
        bp({
          playlist: a,
          mediaSequence: s.mediaSequence + s.segments.length
        }), a.segments[0].discontinuity = !0, a.discontinuityStarts.unshift(0), (!s.segments.length && a.timeline > s.timeline || s.segments.length && a.timeline > s.segments[s.segments.length - 1].timeline) && a.discontinuitySequence--;
        return;
      }
      var l = s.segments[u];
      l.discontinuity && !o.discontinuity && (o.discontinuity = !0, a.discontinuityStarts.unshift(0), a.discontinuitySequence--), bp({
        playlist: a,
        mediaSequence: s.segments[u].number
      });
    }
  });
}, gE = function(e) {
  var r = e.oldManifest, n = e.newManifest, i = r.playlists.concat(Tp(r)), a = n.playlists.concat(Tp(n));
  return n.timelineStarts = Jv([r.timelineStarts, n.timelineStarts]), pE({
    oldPlaylists: i,
    newPlaylists: a,
    timelineStarts: n.timelineStarts
  }), n;
}, Uu = function(e) {
  return e && e.uri + "-" + uE(e.byterange);
}, Il = function(e) {
  var r = Xv(e.reduce(function(n, i) {
    var a = i.attributes.id + (i.attributes.lang || "");
    if (!n[a])
      n[a] = i, n[a].attributes.timelineStarts = [];
    else {
      if (i.segments) {
        var s;
        i.segments[0] && (i.segments[0].discontinuity = !0), (s = n[a].segments).push.apply(s, i.segments);
      }
      i.attributes.contentProtection && (n[a].attributes.contentProtection = i.attributes.contentProtection);
    }
    return n[a].attributes.timelineStarts.push({
      // Although they represent the same number, it's important to have both to make it
      // compatible with HLS potentially having a similar attribute.
      start: i.attributes.periodStart,
      timeline: i.attributes.periodStart
    }), n;
  }, {}));
  return r.map(function(n) {
    return n.discontinuityStarts = sE(n.segments || [], "discontinuity"), n;
  });
}, mh = function(e, r) {
  var n = Uu(e.sidx), i = n && r[n] && r[n].sidx;
  return i && gh(e, i, e.sidx.resolvedUri), e;
}, mE = function(e, r) {
  if (r === void 0 && (r = {}), !Object.keys(r).length)
    return e;
  for (var n in e)
    e[n] = mh(e[n], r);
  return e;
}, vE = function(e, r) {
  var n, i = e.attributes, a = e.segments, s = e.sidx, o = e.mediaSequence, u = e.discontinuitySequence, l = e.discontinuityStarts, d = {
    attributes: (n = {
      NAME: i.id,
      BANDWIDTH: i.bandwidth,
      CODECS: i.codecs
    }, n["PROGRAM-ID"] = 1, n),
    uri: "",
    endList: i.type === "static",
    timeline: i.periodStart,
    resolvedUri: "",
    targetDuration: i.duration,
    discontinuitySequence: u,
    discontinuityStarts: l,
    timelineStarts: i.timelineStarts,
    mediaSequence: o,
    segments: a
  };
  return i.contentProtection && (d.contentProtection = i.contentProtection), s && (d.sidx = s), r && (d.attributes.AUDIO = "audio", d.attributes.SUBTITLES = "subs"), d;
}, yE = function(e) {
  var r, n = e.attributes, i = e.segments, a = e.mediaSequence, s = e.discontinuityStarts, o = e.discontinuitySequence;
  typeof i > "u" && (i = [{
    uri: n.baseUrl,
    timeline: n.periodStart,
    resolvedUri: n.baseUrl || "",
    duration: n.sourceDuration,
    number: 0
  }], n.duration = n.sourceDuration);
  var u = (r = {
    NAME: n.id,
    BANDWIDTH: n.bandwidth
  }, r["PROGRAM-ID"] = 1, r);
  return n.codecs && (u.CODECS = n.codecs), {
    attributes: u,
    uri: "",
    endList: n.type === "static",
    timeline: n.periodStart,
    resolvedUri: n.baseUrl || "",
    targetDuration: n.duration,
    timelineStarts: n.timelineStarts,
    discontinuityStarts: s,
    discontinuitySequence: o,
    mediaSequence: a,
    segments: i
  };
}, _E = function(e, r, n) {
  r === void 0 && (r = {}), n === void 0 && (n = !1);
  var i, a = e.reduce(function(o, u) {
    var l = u.attributes.role && u.attributes.role.value || "", d = u.attributes.lang || "", h = u.attributes.label || "main";
    if (d && !u.attributes.label) {
      var f = l ? " (" + l + ")" : "";
      h = "" + u.attributes.lang + f;
    }
    o[h] || (o[h] = {
      language: d,
      autoselect: !0,
      default: l === "main",
      playlists: [],
      uri: ""
    });
    var v = mh(vE(u, n), r);
    return o[h].playlists.push(v), typeof i > "u" && l === "main" && (i = u, i.default = !0), o;
  }, {});
  if (!i) {
    var s = Object.keys(a)[0];
    a[s].default = !0;
  }
  return a;
}, TE = function(e, r) {
  return r === void 0 && (r = {}), e.reduce(function(n, i) {
    var a = i.attributes.lang || "text";
    return n[a] || (n[a] = {
      language: a,
      default: !1,
      autoselect: !1,
      playlists: [],
      uri: ""
    }), n[a].playlists.push(mh(yE(i), r)), n;
  }, {});
}, bE = function(e) {
  return e.reduce(function(r, n) {
    return n && n.forEach(function(i) {
      var a = i.channel, s = i.language;
      r[s] = {
        autoselect: !1,
        default: !1,
        instreamId: a,
        language: s
      }, i.hasOwnProperty("aspectRatio") && (r[s].aspectRatio = i.aspectRatio), i.hasOwnProperty("easyReader") && (r[s].easyReader = i.easyReader), i.hasOwnProperty("3D") && (r[s]["3D"] = i["3D"]);
    }), r;
  }, {});
}, SE = function(e) {
  var r, n = e.attributes, i = e.segments, a = e.sidx, s = e.discontinuityStarts, o = {
    attributes: (r = {
      NAME: n.id,
      AUDIO: "audio",
      SUBTITLES: "subs",
      RESOLUTION: {
        width: n.width,
        height: n.height
      },
      CODECS: n.codecs,
      BANDWIDTH: n.bandwidth
    }, r["PROGRAM-ID"] = 1, r),
    uri: "",
    endList: n.type === "static",
    timeline: n.periodStart,
    resolvedUri: "",
    targetDuration: n.duration,
    discontinuityStarts: s,
    timelineStarts: n.timelineStarts,
    segments: i
  };
  return n.frameRate && (o.attributes["FRAME-RATE"] = n.frameRate), n.contentProtection && (o.contentProtection = n.contentProtection), a && (o.sidx = a), o;
}, EE = function(e) {
  var r = e.attributes;
  return r.mimeType === "video/mp4" || r.mimeType === "video/webm" || r.contentType === "video";
}, xE = function(e) {
  var r = e.attributes;
  return r.mimeType === "audio/mp4" || r.mimeType === "audio/webm" || r.contentType === "audio";
}, CE = function(e) {
  var r = e.attributes;
  return r.mimeType === "text/vtt" || r.contentType === "text";
}, AE = function(e, r) {
  e.forEach(function(n) {
    n.mediaSequence = 0, n.discontinuitySequence = dc(r, function(i) {
      var a = i.timeline;
      return a === n.timeline;
    }), n.segments && n.segments.forEach(function(i, a) {
      i.number = a;
    });
  });
}, Sp = function(e) {
  return e ? Object.keys(e).reduce(function(r, n) {
    var i = e[n];
    return r.concat(i.playlists);
  }, []) : [];
}, wE = function(e) {
  var r, n = e.dashPlaylists, i = e.locations, a = e.sidxMapping, s = a === void 0 ? {} : a, o = e.previousManifest;
  if (!n.length)
    return {};
  var u = n[0].attributes, l = u.sourceDuration, d = u.type, h = u.suggestedPresentationDelay, f = u.minimumUpdatePeriod, v = Il(n.filter(EE)).map(SE), b = Il(n.filter(xE)), _ = Il(n.filter(CE)), y = n.map(function(I) {
    return I.attributes.captionServices;
  }).filter(Boolean), E = {
    allowCache: !0,
    discontinuityStarts: [],
    segments: [],
    endList: !0,
    mediaGroups: (r = {
      AUDIO: {},
      VIDEO: {}
    }, r["CLOSED-CAPTIONS"] = {}, r.SUBTITLES = {}, r),
    uri: "",
    duration: l,
    playlists: mE(v, s)
  };
  f >= 0 && (E.minimumUpdatePeriod = f * 1e3), i && (E.locations = i), d === "dynamic" && (E.suggestedPresentationDelay = h);
  var R = E.playlists.length === 0, D = b.length ? _E(b, s, R) : null, C = _.length ? TE(_, s) : null, w = v.concat(Sp(D), Sp(C)), k = w.map(function(I) {
    var U = I.timelineStarts;
    return U;
  });
  return E.timelineStarts = Jv(k), AE(w, E.timelineStarts), D && (E.mediaGroups.AUDIO.audio = D), C && (E.mediaGroups.SUBTITLES.subs = C), y.length && (E.mediaGroups["CLOSED-CAPTIONS"].cc = bE(y)), o ? gE({
    oldManifest: o,
    newManifest: E
  }) : E;
}, PE = function(e, r, n) {
  var i = e.NOW, a = e.clientOffset, s = e.availabilityStartTime, o = e.timescale, u = o === void 0 ? 1 : o, l = e.periodStart, d = l === void 0 ? 0 : l, h = e.minimumUpdatePeriod, f = h === void 0 ? 0 : h, v = (i + a) / 1e3, b = s + d, _ = v + f, y = _ - b;
  return Math.ceil((y * u - r) / n);
}, Zv = function(e, r) {
  for (var n = e.type, i = e.minimumUpdatePeriod, a = i === void 0 ? 0 : i, s = e.media, o = s === void 0 ? "" : s, u = e.sourceDuration, l = e.timescale, d = l === void 0 ? 1 : l, h = e.startNumber, f = h === void 0 ? 1 : h, v = e.periodStart, b = [], _ = -1, y = 0; y < r.length; y++) {
    var E = r[y], R = E.d, D = E.r || 0, C = E.t || 0;
    _ < 0 && (_ = C), C && C > _ && (_ = C);
    var w = void 0;
    if (D < 0) {
      var k = y + 1;
      k === r.length ? n === "dynamic" && a > 0 && o.indexOf("$Number$") > 0 ? w = PE(e, _, R) : w = (u * d - _) / R : w = (r[k].t - _) / R;
    } else
      w = D + 1;
    for (var I = f + b.length + w, U = f + b.length; U < I; )
      b.push({
        number: U,
        duration: R / d,
        time: _,
        timeline: v
      }), _ += R, U++;
  }
  return b;
}, kE = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g, LE = function(e) {
  return function(r, n, i, a) {
    if (r === "$$")
      return "$";
    if (typeof e[n] > "u")
      return r;
    var s = "" + e[n];
    return n === "RepresentationID" || (i ? a = parseInt(a, 10) : a = 1, s.length >= a) ? s : "" + new Array(a - s.length + 1).join("0") + s;
  };
}, Ep = function(e, r) {
  return e.replace(kE, LE(r));
}, IE = function(e, r) {
  return !e.duration && !r ? [{
    number: e.startNumber || 1,
    duration: e.sourceDuration,
    time: 0,
    timeline: e.periodStart
  }] : e.duration ? ph(e) : Zv(e, r);
}, DE = function(e, r) {
  var n = {
    RepresentationID: e.id,
    Bandwidth: e.bandwidth || 0
  }, i = e.initialization, a = i === void 0 ? {
    sourceURL: "",
    range: ""
  } : i, s = ks({
    baseUrl: e.baseUrl,
    source: Ep(a.sourceURL, n),
    range: a.range
  }), o = IE(e, r);
  return o.map(function(u) {
    n.Number = u.number, n.Time = u.time;
    var l = Ep(e.media || "", n), d = e.timescale || 1, h = e.presentationTimeOffset || 0, f = (
      // Even if the @t attribute is not specified for the segment, segment.time is
      // calculated in mpd-parser prior to this, so it's assumed to be available.
      e.periodStart + (u.time - h) / d
    ), v = {
      uri: l,
      timeline: u.timeline,
      duration: u.duration,
      resolvedUri: Ou(e.baseUrl || "", l),
      map: s,
      number: u.number,
      presentationTime: f
    };
    return v;
  });
}, RE = function(e, r) {
  var n = e.baseUrl, i = e.initialization, a = i === void 0 ? {} : i, s = ks({
    baseUrl: n,
    source: a.sourceURL,
    range: a.range
  }), o = ks({
    baseUrl: n,
    source: r.media,
    range: r.mediaRange
  });
  return o.map = s, o;
}, OE = function(e, r) {
  var n = e.duration, i = e.segmentUrls, a = i === void 0 ? [] : i, s = e.periodStart;
  if (!n && !r || n && r)
    throw new Error(Sa.SEGMENT_TIME_UNSPECIFIED);
  var o = a.map(function(d) {
    return RE(e, d);
  }), u;
  n && (u = ph(e)), r && (u = Zv(e, r));
  var l = u.map(function(d, h) {
    if (o[h]) {
      var f = o[h], v = e.timescale || 1, b = e.presentationTimeOffset || 0;
      return f.timeline = d.timeline, f.duration = d.duration, f.number = d.number, f.presentationTime = s + (d.time - b) / v, f;
    }
  }).filter(function(d) {
    return d;
  });
  return l;
}, ME = function(e) {
  var r = e.attributes, n = e.segmentInfo, i, a;
  n.template ? (a = DE, i = ai(r, n.template)) : n.base ? (a = Qv, i = ai(r, n.base)) : n.list && (a = OE, i = ai(r, n.list));
  var s = {
    attributes: r
  };
  if (!a)
    return s;
  var o = a(i, n.segmentTimeline);
  if (i.duration) {
    var u = i, l = u.duration, d = u.timescale, h = d === void 0 ? 1 : d;
    i.duration = l / h;
  } else
    o.length ? i.duration = o.reduce(function(f, v) {
      return Math.max(f, Math.ceil(v.duration));
    }, 0) : i.duration = 0;
  return s.attributes = i, s.segments = o, n.base && i.indexRange && (s.sidx = o[0], s.segments = []), s;
}, NE = function(e) {
  return e.map(ME);
}, Lt = function(e, r) {
  return Yv(e.childNodes).filter(function(n) {
    var i = n.tagName;
    return i === r;
  });
}, vh = function(e) {
  return e.textContent.trim();
}, BE = function(e) {
  return parseFloat(e.split("/").reduce(function(r, n) {
    return r / n;
  }));
}, Jn = function(e) {
  var r = 31536e3, n = 30 * 24 * 60 * 60, i = 24 * 60 * 60, a = 60 * 60, s = 60, o = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/, u = o.exec(e);
  if (!u)
    return 0;
  var l = u.slice(1), d = l[0], h = l[1], f = l[2], v = l[3], b = l[4], _ = l[5];
  return parseFloat(d || 0) * r + parseFloat(h || 0) * n + parseFloat(f || 0) * i + parseFloat(v || 0) * a + parseFloat(b || 0) * s + parseFloat(_ || 0);
}, FE = function(e) {
  var r = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/;
  return r.test(e) && (e += "Z"), Date.parse(e);
}, xp = {
  /**
   * Specifies the duration of the entire Media Presentation. Format is a duration string
   * as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  mediaPresentationDuration: function(e) {
    return Jn(e);
  },
  /**
   * Specifies the Segment availability start time for all Segments referred to in this
   * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
   * time. Format is a date string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The date as seconds from unix epoch
   */
  availabilityStartTime: function(e) {
    return FE(e) / 1e3;
  },
  /**
   * Specifies the smallest period between potential changes to the MPD. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  minimumUpdatePeriod: function(e) {
    return Jn(e);
  },
  /**
   * Specifies the suggested presentation delay. Format is a
   * duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  suggestedPresentationDelay: function(e) {
    return Jn(e);
  },
  /**
   * specifices the type of mpd. Can be either "static" or "dynamic"
   *
   * @param {string} value
   *        value of attribute as a string
   *
   * @return {string}
   *         The type as a string
   */
  type: function(e) {
    return e;
  },
  /**
   * Specifies the duration of the smallest time shifting buffer for any Representation
   * in the MPD. Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  timeShiftBufferDepth: function(e) {
    return Jn(e);
  },
  /**
   * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
   * Format is a duration string as specified in ISO 8601
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The duration in seconds
   */
  start: function(e) {
    return Jn(e);
  },
  /**
   * Specifies the width of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed width
   */
  width: function(e) {
    return parseInt(e, 10);
  },
  /**
   * Specifies the height of the visual presentation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed height
   */
  height: function(e) {
    return parseInt(e, 10);
  },
  /**
   * Specifies the bitrate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed bandwidth
   */
  bandwidth: function(e) {
    return parseInt(e, 10);
  },
  /**
   * Specifies the frame rate of the representation
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed frame rate
   */
  frameRate: function(e) {
    return BE(e);
  },
  /**
   * Specifies the number of the first Media Segment in this Representation in the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  startNumber: function(e) {
    return parseInt(e, 10);
  },
  /**
   * Specifies the timescale in units per seconds
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed timescale
   */
  timescale: function(e) {
    return parseInt(e, 10);
  },
  /**
   * Specifies the presentationTimeOffset.
   *
   * @param {string} value
   *        value of the attribute as a string
   *
   * @return {number}
   *         The parsed presentationTimeOffset
   */
  presentationTimeOffset: function(e) {
    return parseInt(e, 10);
  },
  /**
   * Specifies the constant approximate Segment duration
   * NOTE: The <Period> element also contains an @duration attribute. This duration
   *       specifies the duration of the Period. This attribute is currently not
   *       supported by the rest of the parser, however we still check for it to prevent
   *       errors.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  duration: function(e) {
    var r = parseInt(e, 10);
    return isNaN(r) ? Jn(e) : r;
  },
  /**
   * Specifies the Segment duration, in units of the value of the @timescale.
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed duration
   */
  d: function(e) {
    return parseInt(e, 10);
  },
  /**
   * Specifies the MPD start time, in @timescale units, the first Segment in the series
   * starts relative to the beginning of the Period
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed time
   */
  t: function(e) {
    return parseInt(e, 10);
  },
  /**
   * Specifies the repeat count of the number of following contiguous Segments with the
   * same duration expressed by the value of @d
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {number}
   *         The parsed number
   */
  r: function(e) {
    return parseInt(e, 10);
  },
  /**
   * Default parser for all other attributes. Acts as a no-op and just returns the value
   * as a string
   *
   * @param {string} value
   *        value of attribute as a string
   * @return {string}
   *         Unparsed value
   */
  DEFAULT: function(e) {
    return e;
  }
}, Kt = function(e) {
  return e && e.attributes ? Yv(e.attributes).reduce(function(r, n) {
    var i = xp[n.name] || xp.DEFAULT;
    return r[n.name] = i(n.value), r;
  }, {}) : {};
}, UE = {
  "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
  "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
  "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
  "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime"
}, Vu = function(e, r) {
  return r.length ? Fu(e.map(function(n) {
    return r.map(function(i) {
      return Ou(n, vh(i));
    });
  })) : e;
}, yh = function(e) {
  var r = Lt(e, "SegmentTemplate")[0], n = Lt(e, "SegmentList")[0], i = n && Lt(n, "SegmentURL").map(function(f) {
    return ai({
      tag: "SegmentURL"
    }, Kt(f));
  }), a = Lt(e, "SegmentBase")[0], s = n || r, o = s && Lt(s, "SegmentTimeline")[0], u = n || a || r, l = u && Lt(u, "Initialization")[0], d = r && Kt(r);
  d && l ? d.initialization = l && Kt(l) : d && d.initialization && (d.initialization = {
    sourceURL: d.initialization
  });
  var h = {
    template: d,
    segmentTimeline: o && Lt(o, "S").map(function(f) {
      return Kt(f);
    }),
    list: n && ai(Kt(n), {
      segmentUrls: i,
      initialization: Kt(l)
    }),
    base: a && ai(Kt(a), {
      initialization: Kt(l)
    })
  };
  return Object.keys(h).forEach(function(f) {
    h[f] || delete h[f];
  }), h;
}, VE = function(e, r, n) {
  return function(i) {
    var a = Lt(i, "BaseURL"), s = Vu(r, a), o = ai(e, Kt(i)), u = yh(i);
    return s.map(function(l) {
      return {
        segmentInfo: ai(n, u),
        attributes: ai(o, {
          baseUrl: l
        })
      };
    });
  };
}, jE = function(e) {
  return e.reduce(function(r, n) {
    var i = Kt(n);
    i.schemeIdUri && (i.schemeIdUri = i.schemeIdUri.toLowerCase());
    var a = UE[i.schemeIdUri];
    if (a) {
      r[a] = {
        attributes: i
      };
      var s = Lt(n, "cenc:pssh")[0];
      if (s) {
        var o = vh(s);
        r[a].pssh = o && pv(o);
      }
    }
    return r;
  }, {});
}, HE = function(e) {
  if (e.schemeIdUri === "urn:scte:dash:cc:cea-608:2015") {
    var r = typeof e.value != "string" ? [] : e.value.split(";");
    return r.map(function(i) {
      var a, s;
      if (s = i, /^CC\d=/.test(i)) {
        var o = i.split("=");
        a = o[0], s = o[1];
      } else
        /^CC\d$/.test(i) && (a = i);
      return {
        channel: a,
        language: s
      };
    });
  } else if (e.schemeIdUri === "urn:scte:dash:cc:cea-708:2015") {
    var n = typeof e.value != "string" ? [] : e.value.split(";");
    return n.map(function(i) {
      var a = {
        // service or channel number 1-63
        channel: void 0,
        // language is a 3ALPHA per ISO 639.2/B
        // field is required
        language: void 0,
        // BIT 1/0 or ?
        // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
        aspectRatio: 1,
        // BIT 1/0
        // easy reader flag indicated the text is tailed to the needs of beginning readers
        // default 0, or off
        easyReader: 0,
        // BIT 1/0
        // If 3d metadata is present (CEA-708.1) then 1
        // default 0
        "3D": 0
      };
      if (/=/.test(i)) {
        var s = i.split("="), o = s[0], u = s[1], l = u === void 0 ? "" : u;
        a.channel = o, a.language = i, l.split(",").forEach(function(d) {
          var h = d.split(":"), f = h[0], v = h[1];
          f === "lang" ? a.language = v : f === "er" ? a.easyReader = Number(v) : f === "war" ? a.aspectRatio = Number(v) : f === "3D" && (a["3D"] = Number(v));
        });
      } else
        a.language = i;
      return a.channel && (a.channel = "SERVICE" + a.channel), a;
    });
  }
}, WE = function(e, r, n) {
  return function(i) {
    var a = Kt(i), s = Vu(r, Lt(i, "BaseURL")), o = Lt(i, "Role")[0], u = {
      role: Kt(o)
    }, l = ai(e, a, u), d = Lt(i, "Accessibility")[0], h = HE(Kt(d));
    h && (l = ai(l, {
      captionServices: h
    }));
    var f = Lt(i, "Label")[0];
    if (f && f.childNodes.length) {
      var v = f.childNodes[0].nodeValue.trim();
      l = ai(l, {
        label: v
      });
    }
    var b = jE(Lt(i, "ContentProtection"));
    Object.keys(b).length && (l = ai(l, {
      contentProtection: b
    }));
    var _ = yh(i), y = Lt(i, "Representation"), E = ai(n, _);
    return Fu(y.map(VE(l, s, E)));
  };
}, qE = function(e, r) {
  return function(n, i) {
    var a = Vu(r, Lt(n.node, "BaseURL")), s = ai(e, {
      periodStart: n.attributes.start
    });
    typeof n.attributes.duration == "number" && (s.periodDuration = n.attributes.duration);
    var o = Lt(n.node, "AdaptationSet"), u = yh(n.node);
    return Fu(o.map(WE(s, a, u)));
  };
}, $E = function(e) {
  var r = e.attributes, n = e.priorPeriodAttributes, i = e.mpdType;
  return typeof r.start == "number" ? r.start : n && typeof n.start == "number" && typeof n.duration == "number" ? n.start + n.duration : !n && i === "static" ? 0 : null;
}, zE = function(e, r) {
  r === void 0 && (r = {});
  var n = r, i = n.manifestUri, a = i === void 0 ? "" : i, s = n.NOW, o = s === void 0 ? Date.now() : s, u = n.clientOffset, l = u === void 0 ? 0 : u, d = Lt(e, "Period");
  if (!d.length)
    throw new Error(Sa.INVALID_NUMBER_OF_PERIOD);
  var h = Lt(e, "Location"), f = Kt(e), v = Vu([a], Lt(e, "BaseURL"));
  f.type = f.type || "static", f.sourceDuration = f.mediaPresentationDuration || 0, f.NOW = o, f.clientOffset = l, h.length && (f.locations = h.map(vh));
  var b = [];
  return d.forEach(function(_, y) {
    var E = Kt(_), R = b[y - 1];
    E.start = $E({
      attributes: E,
      priorPeriodAttributes: R ? R.attributes : null,
      mpdType: f.type
    }), b.push({
      node: _,
      attributes: E
    });
  }), {
    locations: f.locations,
    representationInfo: Fu(b.map(qE(f, v)))
  };
}, ey = function(e) {
  if (e === "")
    throw new Error(Sa.DASH_EMPTY_MANIFEST);
  var r = new nE(), n, i;
  try {
    n = r.parseFromString(e, "application/xml"), i = n && n.documentElement.tagName === "MPD" ? n.documentElement : null;
  } catch {
  }
  if (!i || i && i.getElementsByTagName("parsererror").length > 0)
    throw new Error(Sa.DASH_INVALID_XML);
  return i;
}, GE = function(e) {
  var r = Lt(e, "UTCTiming")[0];
  if (!r)
    return null;
  var n = Kt(r);
  switch (n.schemeIdUri) {
    case "urn:mpeg:dash:utc:http-head:2014":
    case "urn:mpeg:dash:utc:http-head:2012":
      n.method = "HEAD";
      break;
    case "urn:mpeg:dash:utc:http-xsdate:2014":
    case "urn:mpeg:dash:utc:http-iso:2014":
    case "urn:mpeg:dash:utc:http-xsdate:2012":
    case "urn:mpeg:dash:utc:http-iso:2012":
      n.method = "GET";
      break;
    case "urn:mpeg:dash:utc:direct:2014":
    case "urn:mpeg:dash:utc:direct:2012":
      n.method = "DIRECT", n.value = Date.parse(n.value);
      break;
    case "urn:mpeg:dash:utc:http-ntp:2014":
    case "urn:mpeg:dash:utc:ntp:2014":
    case "urn:mpeg:dash:utc:sntp:2014":
    default:
      throw new Error(Sa.UNSUPPORTED_UTC_TIMING_SCHEME);
  }
  return n;
}, KE = function(e, r) {
  r === void 0 && (r = {});
  var n = zE(ey(e), r), i = NE(n.representationInfo);
  return wE({
    dashPlaylists: i,
    locations: n.locations,
    sidxMapping: r.sidxMapping,
    previousManifest: r.previousManifest
  });
}, XE = function(e) {
  return GE(ey(e));
}, ty = Math.pow(2, 32), YE = function(t) {
  var e = new DataView(t.buffer, t.byteOffset, t.byteLength), r;
  return e.getBigUint64 ? (r = e.getBigUint64(0), r < Number.MAX_SAFE_INTEGER ? Number(r) : r) : e.getUint32(0) * ty + e.getUint32(4);
}, QE = {
  getUint64: YE,
  MAX_UINT32: ty
}, Cp = QE.getUint64, JE = function(t) {
  var e = new DataView(t.buffer, t.byteOffset, t.byteLength), r = {
    version: t[0],
    flags: new Uint8Array(t.subarray(1, 4)),
    references: [],
    referenceId: e.getUint32(4),
    timescale: e.getUint32(8)
  }, n = 12;
  r.version === 0 ? (r.earliestPresentationTime = e.getUint32(n), r.firstOffset = e.getUint32(n + 4), n += 8) : (r.earliestPresentationTime = Cp(t.subarray(n)), r.firstOffset = Cp(t.subarray(n + 8)), n += 16), n += 2;
  var i = e.getUint16(n);
  for (n += 2; i > 0; n += 12, i--)
    r.references.push({
      referenceType: (t[n] & 128) >>> 7,
      referencedSize: e.getUint32(n) & 2147483647,
      subsegmentDuration: e.getUint32(n + 4),
      startsWithSap: !!(t[n + 8] & 128),
      sapType: (t[n + 8] & 112) >>> 4,
      sapDeltaTime: e.getUint32(n + 8) & 268435455
    });
  return r;
}, ZE = JE, ex = Ae([73, 68, 51]), tx = function(e, r) {
  r === void 0 && (r = 0), e = Ae(e);
  var n = e[r + 5], i = e[r + 6] << 21 | e[r + 7] << 14 | e[r + 8] << 7 | e[r + 9], a = (n & 16) >> 4;
  return a ? i + 20 : i + 10;
}, hs = function t(e, r) {
  return r === void 0 && (r = 0), e = Ae(e), e.length - r < 10 || !Tt(e, ex, {
    offset: r
  }) ? r : (r += tx(e, r), t(e, r));
}, Ap = function(e) {
  return typeof e == "string" ? _v(e) : e;
}, ix = function(e) {
  return Array.isArray(e) ? e.map(function(r) {
    return Ap(r);
  }) : [Ap(e)];
}, rx = function t(e, r, n) {
  n === void 0 && (n = !1), r = ix(r), e = Ae(e);
  var i = [];
  if (!r.length)
    return i;
  for (var a = 0; a < e.length; ) {
    var s = (e[a] << 24 | e[a + 1] << 16 | e[a + 2] << 8 | e[a + 3]) >>> 0, o = e.subarray(a + 4, a + 8);
    if (s === 0)
      break;
    var u = a + s;
    if (u > e.length) {
      if (n)
        break;
      u = e.length;
    }
    var l = e.subarray(a + 8, u);
    Tt(o, r[0]) && (r.length === 1 ? i.push(l) : i.push.apply(i, t(l, r.slice(1), n))), a = u;
  }
  return i;
}, bo = {
  EBML: Ae([26, 69, 223, 163]),
  DocType: Ae([66, 130]),
  Segment: Ae([24, 83, 128, 103]),
  SegmentInfo: Ae([21, 73, 169, 102]),
  Tracks: Ae([22, 84, 174, 107]),
  Track: Ae([174]),
  TrackNumber: Ae([215]),
  DefaultDuration: Ae([35, 227, 131]),
  TrackEntry: Ae([174]),
  TrackType: Ae([131]),
  FlagDefault: Ae([136]),
  CodecID: Ae([134]),
  CodecPrivate: Ae([99, 162]),
  VideoTrack: Ae([224]),
  AudioTrack: Ae([225]),
  // Not used yet, but will be used for live webm/mkv
  // see https://www.matroska.org/technical/basics.html#block-structure
  // see https://www.matroska.org/technical/basics.html#simpleblock-structure
  Cluster: Ae([31, 67, 182, 117]),
  Timestamp: Ae([231]),
  TimestampScale: Ae([42, 215, 177]),
  BlockGroup: Ae([160]),
  BlockDuration: Ae([155]),
  Block: Ae([161]),
  SimpleBlock: Ae([163])
}, cc = [128, 64, 32, 16, 8, 4, 2, 1], nx = function(e) {
  for (var r = 1, n = 0; n < cc.length && !(e & cc[n]); n++)
    r++;
  return r;
}, ru = function(e, r, n, i) {
  n === void 0 && (n = !0), i === void 0 && (i = !1);
  var a = nx(e[r]), s = e.subarray(r, r + a);
  return n && (s = Array.prototype.slice.call(e, r, r + a), s[0] ^= cc[a - 1]), {
    length: a,
    value: wS(s, {
      signed: i
    }),
    bytes: s
  };
}, wp = function t(e) {
  return typeof e == "string" ? e.match(/.{1,2}/g).map(function(r) {
    return t(r);
  }) : typeof e == "number" ? PS(e) : e;
}, ax = function(e) {
  return Array.isArray(e) ? e.map(function(r) {
    return wp(r);
  }) : [wp(e)];
}, sx = function t(e, r, n) {
  if (n >= r.length)
    return r.length;
  var i = ru(r, n, !1);
  if (Tt(e.bytes, i.bytes))
    return n;
  var a = ru(r, n + i.length);
  return t(e, r, n + a.length + a.value + i.length);
}, Pp = function t(e, r) {
  r = ax(r), e = Ae(e);
  var n = [];
  if (!r.length)
    return n;
  for (var i = 0; i < e.length; ) {
    var a = ru(e, i, !1), s = ru(e, i + a.length), o = i + a.length + s.length;
    s.value === 127 && (s.value = sx(a, e, o), s.value !== e.length && (s.value -= o));
    var u = o + s.value > e.length ? e.length : o + s.value, l = e.subarray(o, u);
    Tt(r[0], a.bytes) && (r.length === 1 ? n.push(l) : n = n.concat(t(l, r.slice(1))));
    var d = a.length + s.length + l.length;
    i += d;
  }
  return n;
}, ox = Ae([0, 0, 0, 1]), ux = Ae([0, 0, 1]), lx = Ae([0, 0, 3]), dx = function(e) {
  for (var r = [], n = 1; n < e.length - 2; )
    Tt(e.subarray(n, n + 3), lx) && (r.push(n + 2), n++), n++;
  if (r.length === 0)
    return e;
  var i = e.length - r.length, a = new Uint8Array(i), s = 0;
  for (n = 0; n < i; s++, n++)
    s === r[0] && (s++, r.shift()), a[n] = e[s];
  return a;
}, iy = function(e, r, n, i) {
  i === void 0 && (i = 1 / 0), e = Ae(e), n = [].concat(n);
  for (var a = 0, s, o = 0; a < e.length && (o < i || s); ) {
    var u = void 0;
    if (Tt(e.subarray(a), ox) ? u = 4 : Tt(e.subarray(a), ux) && (u = 3), !u) {
      a++;
      continue;
    }
    if (o++, s)
      return dx(e.subarray(s, a));
    var l = void 0;
    r === "h264" ? l = e[a + u] & 31 : r === "h265" && (l = e[a + u] >> 1 & 63), n.indexOf(l) !== -1 && (s = a + u), a += u + (r === "h264" ? 1 : 2);
  }
  return e.subarray(0, 0);
}, cx = function(e, r, n) {
  return iy(e, "h264", r, n);
}, hx = function(e, r, n) {
  return iy(e, "h265", r, n);
}, ii = {
  // "webm" string literal in hex
  webm: Ae([119, 101, 98, 109]),
  // "matroska" string literal in hex
  matroska: Ae([109, 97, 116, 114, 111, 115, 107, 97]),
  // "fLaC" string literal in hex
  flac: Ae([102, 76, 97, 67]),
  // "OggS" string literal in hex
  ogg: Ae([79, 103, 103, 83]),
  // ac-3 sync byte, also works for ec-3 as that is simply a codec
  // of ac-3
  ac3: Ae([11, 119]),
  // "RIFF" string literal in hex used for wav and avi
  riff: Ae([82, 73, 70, 70]),
  // "AVI" string literal in hex
  avi: Ae([65, 86, 73]),
  // "WAVE" string literal in hex
  wav: Ae([87, 65, 86, 69]),
  // "ftyp3g" string literal in hex
  "3gp": Ae([102, 116, 121, 112, 51, 103]),
  // "ftyp" string literal in hex
  mp4: Ae([102, 116, 121, 112]),
  // "styp" string literal in hex
  fmp4: Ae([115, 116, 121, 112]),
  // "ftypqt" string literal in hex
  mov: Ae([102, 116, 121, 112, 113, 116]),
  // moov string literal in hex
  moov: Ae([109, 111, 111, 118]),
  // moof string literal in hex
  moof: Ae([109, 111, 111, 102])
}, Ea = {
  aac: function(e) {
    var r = hs(e);
    return Tt(e, [255, 16], {
      offset: r,
      mask: [255, 22]
    });
  },
  mp3: function(e) {
    var r = hs(e);
    return Tt(e, [255, 2], {
      offset: r,
      mask: [255, 6]
    });
  },
  webm: function(e) {
    var r = Pp(e, [bo.EBML, bo.DocType])[0];
    return Tt(r, ii.webm);
  },
  mkv: function(e) {
    var r = Pp(e, [bo.EBML, bo.DocType])[0];
    return Tt(r, ii.matroska);
  },
  mp4: function(e) {
    if (Ea["3gp"](e) || Ea.mov(e))
      return !1;
    if (Tt(e, ii.mp4, {
      offset: 4
    }) || Tt(e, ii.fmp4, {
      offset: 4
    }) || Tt(e, ii.moof, {
      offset: 4
    }) || Tt(e, ii.moov, {
      offset: 4
    }))
      return !0;
  },
  mov: function(e) {
    return Tt(e, ii.mov, {
      offset: 4
    });
  },
  "3gp": function(e) {
    return Tt(e, ii["3gp"], {
      offset: 4
    });
  },
  ac3: function(e) {
    var r = hs(e);
    return Tt(e, ii.ac3, {
      offset: r
    });
  },
  ts: function(e) {
    if (e.length < 189 && e.length >= 1)
      return e[0] === 71;
    for (var r = 0; r + 188 < e.length && r < 188; ) {
      if (e[r] === 71 && e[r + 188] === 71)
        return !0;
      r += 1;
    }
    return !1;
  },
  flac: function(e) {
    var r = hs(e);
    return Tt(e, ii.flac, {
      offset: r
    });
  },
  ogg: function(e) {
    return Tt(e, ii.ogg);
  },
  avi: function(e) {
    return Tt(e, ii.riff) && Tt(e, ii.avi, {
      offset: 8
    });
  },
  wav: function(e) {
    return Tt(e, ii.riff) && Tt(e, ii.wav, {
      offset: 8
    });
  },
  h264: function(e) {
    return cx(e, 7, 3).length;
  },
  h265: function(e) {
    return hx(e, [32, 33], 3).length;
  }
}, hc = Object.keys(Ea).filter(function(t) {
  return t !== "ts" && t !== "h264" && t !== "h265";
}).concat(["ts", "h264", "h265"]);
hc.forEach(function(t) {
  var e = Ea[t];
  Ea[t] = function(r) {
    return e(Ae(r));
  };
});
var fx = Ea, _h = function(e) {
  e = Ae(e);
  for (var r = 0; r < hc.length; r++) {
    var n = hc[r];
    if (fx[n](e))
      return n;
  }
  return "";
}, px = function(e) {
  return rx(e, ["moof"]).length > 0;
}, Th = 9e4, bh, Sh, ju, Eh, ry, ny, ay;
bh = function(t) {
  return t * Th;
};
Sh = function(t, e) {
  return t * e;
};
ju = function(t) {
  return t / Th;
};
Eh = function(t, e) {
  return t / e;
};
ry = function(t, e) {
  return bh(Eh(t, e));
};
ny = function(t, e) {
  return Sh(ju(t), e);
};
ay = function(t, e, r) {
  return ju(r ? t : t - e);
};
var nu = {
  ONE_SECOND_IN_TS: Th,
  secondsToVideoTs: bh,
  secondsToAudioTs: Sh,
  videoTsToSeconds: ju,
  audioTsToSeconds: Eh,
  audioTsToVideoTs: ry,
  videoTsToAudioTs: ny,
  metadataTsToSeconds: ay
};
function fc(t) {
  return fc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, fc(t);
}
function gx(t) {
  return Function.toString.call(t).indexOf("[native code]") !== -1;
}
function pc(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return pc = function(n) {
    if (n === null || !gx(n))
      return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof e < "u") {
      if (e.has(n))
        return e.get(n);
      e.set(n, i);
    }
    function i() {
      return _s(n, arguments, fc(this).constructor);
    }
    return i.prototype = Object.create(n.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), ya(i, n);
  }, pc(t);
}
/**
 * @license
 * Video.js 7.21.4 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */
var sy = "7.21.4", br = {}, Gr = function(e, r) {
  return br[e] = br[e] || [], r && (br[e] = br[e].concat(r)), br[e];
}, mx = function(e, r) {
  Gr(e, r);
}, oy = function(e, r) {
  var n = Gr(e).indexOf(r);
  return n <= -1 ? !1 : (br[e] = br[e].slice(), br[e].splice(n, 1), !0);
}, vx = function(e, r) {
  Gr(e, [].concat(r).map(function(n) {
    var i = function a() {
      return oy(e, a), n.apply(void 0, arguments);
    };
    return i;
  }));
}, au = {
  prefixed: !0
}, Vo = [
  ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror", "fullscreen"],
  // WebKit
  ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"],
  // Mozilla
  ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror", "-moz-full-screen"],
  // Microsoft
  ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError", "-ms-fullscreen"]
], kp = Vo[0], fs;
for (var So = 0; So < Vo.length; So++)
  if (Vo[So][1] in oe) {
    fs = Vo[So];
    break;
  }
if (fs) {
  for (var Eo = 0; Eo < fs.length; Eo++)
    au[kp[Eo]] = fs[Eo];
  au.prefixed = fs[0] !== kp[0];
}
var di = [], yx = function(e, r) {
  return function(n, i, a) {
    var s = r.levels[i], o = new RegExp("^(" + s + ")$");
    if (n !== "log" && a.unshift(n.toUpperCase() + ":"), a.unshift(e + ":"), di) {
      di.push([].concat(a));
      var u = di.length - 1e3;
      di.splice(0, u > 0 ? u : 0);
    }
    if (M.console) {
      var l = M.console[n];
      !l && n === "debug" && (l = M.console.info || M.console.log), !(!l || !s || !o.test(n)) && l[Array.isArray(a) ? "apply" : "call"](M.console, a);
    }
  };
};
function uy(t) {
  var e = "info", r, n = function() {
    for (var a = arguments.length, s = new Array(a), o = 0; o < a; o++)
      s[o] = arguments[o];
    r("log", e, s);
  };
  return r = yx(t, n), n.createLogger = function(i) {
    return uy(t + ": " + i);
  }, n.levels = {
    all: "debug|log|warn|error",
    off: "",
    debug: "debug|log|warn|error",
    info: "log|warn|error",
    warn: "warn|error",
    error: "error",
    DEFAULT: e
  }, n.level = function(i) {
    if (typeof i == "string") {
      if (!n.levels.hasOwnProperty(i))
        throw new Error('"' + i + '" in not a valid log level');
      e = i;
    }
    return e;
  }, n.history = function() {
    return di ? [].concat(di) : [];
  }, n.history.filter = function(i) {
    return (di || []).filter(function(a) {
      return new RegExp(".*" + i + ".*").test(a[0]);
    });
  }, n.history.clear = function() {
    di && (di.length = 0);
  }, n.history.disable = function() {
    di !== null && (di.length = 0, di = null);
  }, n.history.enable = function() {
    di === null && (di = []);
  }, n.error = function() {
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r("error", e, a);
  }, n.warn = function() {
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r("warn", e, a);
  }, n.debug = function() {
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r("debug", e, a);
  }, n;
}
var Fe = uy("VIDEOJS"), ly = Fe.createLogger, _x = Object.prototype.toString, dy = function(e) {
  return Lr(e) ? Object.keys(e) : [];
};
function fa(t, e) {
  dy(t).forEach(function(r) {
    return e(t[r], r);
  });
}
function Tx(t, e, r) {
  return r === void 0 && (r = 0), dy(t).reduce(function(n, i) {
    return e(n, t[i], i);
  }, r);
}
function At(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++)
    r[n - 1] = arguments[n];
  return Object.assign ? Vi.apply(void 0, [t].concat(r)) : (r.forEach(function(i) {
    i && fa(i, function(a, s) {
      t[s] = a;
    });
  }), t);
}
function Lr(t) {
  return !!t && typeof t == "object";
}
function Ls(t) {
  return Lr(t) && _x.call(t) === "[object Object]" && t.constructor === Object;
}
function Is(t, e) {
  if (!t || !e)
    return "";
  if (typeof M.getComputedStyle == "function") {
    var r;
    try {
      r = M.getComputedStyle(t);
    } catch {
      return "";
    }
    return r ? r.getPropertyValue(e) || r[e] : "";
  }
  return "";
}
var Ft = M.navigator && M.navigator.userAgent || "", Lp = /AppleWebKit\/([\d.]+)/i.exec(Ft), bx = Lp ? parseFloat(Lp.pop()) : null, cy = /iPod/i.test(Ft), Sx = function() {
  var t = Ft.match(/OS (\d+)_/i);
  return t && t[1] ? t[1] : null;
}(), Or = /Android/i.test(Ft), xh = function() {
  var t = Ft.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
  if (!t)
    return null;
  var e = t[1] && parseFloat(t[1]), r = t[2] && parseFloat(t[2]);
  return e && r ? parseFloat(t[1] + "." + t[2]) : e || null;
}(), hy = Or && xh < 5 && bx < 537, fy = /Firefox/i.test(Ft), $s = /Edg/i.test(Ft), Mr = !$s && (/Chrome/i.test(Ft) || /CriOS/i.test(Ft)), py = function() {
  var t = Ft.match(/(Chrome|CriOS)\/(\d+)/);
  return t && t[2] ? parseFloat(t[2]) : null;
}(), zs = function() {
  var t = /MSIE\s(\d+)\.\d/.exec(Ft), e = t && parseFloat(t[1]);
  return !e && /Trident\/7.0/i.test(Ft) && /rv:11.0/.test(Ft) && (e = 11), e;
}(), Ch = /Safari/i.test(Ft) && !Mr && !Or && !$s, gy = /Windows/i.test(Ft), xa = !!(Oa() && ("ontouchstart" in M || M.navigator.maxTouchPoints || M.DocumentTouch && M.document instanceof M.DocumentTouch)), Ah = /iPad/i.test(Ft) || Ch && xa && !/iPhone/i.test(Ft), wh = /iPhone/i.test(Ft) && !Ah, ui = wh || Ah || cy, Hu = (Ch || ui) && !Mr, Ex = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  IS_IPOD: cy,
  IOS_VERSION: Sx,
  IS_ANDROID: Or,
  ANDROID_VERSION: xh,
  IS_NATIVE_ANDROID: hy,
  IS_FIREFOX: fy,
  IS_EDGE: $s,
  IS_CHROME: Mr,
  CHROME_VERSION: py,
  IE_VERSION: zs,
  IS_SAFARI: Ch,
  IS_WINDOWS: gy,
  TOUCH_ENABLED: xa,
  IS_IPAD: Ah,
  IS_IPHONE: wh,
  IS_IOS: ui,
  IS_ANY_SAFARI: Hu
});
function Ip(t) {
  return typeof t == "string" && !!t.trim();
}
function my(t) {
  if (t.indexOf(" ") >= 0)
    throw new Error("class has illegal whitespace characters");
}
function xx(t) {
  return new RegExp("(^|\\s)" + t + "($|\\s)");
}
function Oa() {
  return oe === M.document;
}
function Ma(t) {
  return Lr(t) && t.nodeType === 1;
}
function vy() {
  try {
    return M.parent !== M.self;
  } catch {
    return !0;
  }
}
function yy(t) {
  return function(e, r) {
    if (!Ip(e))
      return oe[t](null);
    Ip(r) && (r = oe.querySelector(r));
    var n = Ma(r) ? r : oe;
    return n[t] && n[t](e);
  };
}
function Ge(t, e, r, n) {
  t === void 0 && (t = "div"), e === void 0 && (e = {}), r === void 0 && (r = {});
  var i = oe.createElement(t);
  return Object.getOwnPropertyNames(e).forEach(function(a) {
    var s = e[a];
    a.indexOf("aria-") !== -1 || a === "role" || a === "type" ? (Fe.warn(`Setting attributes in the second argument of createEl()
has been deprecated. Use the third argument instead.
` + ("createEl(type, properties, attributes). Attempting to set " + a + " to " + s + ".")), i.setAttribute(a, s)) : a === "textContent" ? Pn(i, s) : (i[a] !== s || a === "tabIndex") && (i[a] = s);
  }), Object.getOwnPropertyNames(r).forEach(function(a) {
    i.setAttribute(a, r[a]);
  }), n && kh(i, n), i;
}
function Pn(t, e) {
  return typeof t.textContent > "u" ? t.innerText = e : t.textContent = e, t;
}
function gc(t, e) {
  e.firstChild ? e.insertBefore(t, e.firstChild) : e.appendChild(t);
}
function Tn(t, e) {
  return my(e), t.classList ? t.classList.contains(e) : xx(e).test(t.className);
}
function Cr(t, e) {
  return t.classList ? t.classList.add(e) : Tn(t, e) || (t.className = (t.className + " " + e).trim()), t;
}
function Gs(t, e) {
  return t ? (t.classList ? t.classList.remove(e) : (my(e), t.className = t.className.split(/\s+/).filter(function(r) {
    return r !== e;
  }).join(" ")), t) : (Fe.warn("removeClass was called with an element that doesn't exist"), null);
}
function _y(t, e, r) {
  var n = Tn(t, e);
  if (typeof r == "function" && (r = r(t, e)), typeof r != "boolean" && (r = !n), r !== n)
    return r ? Cr(t, e) : Gs(t, e), t;
}
function Ty(t, e) {
  Object.getOwnPropertyNames(e).forEach(function(r) {
    var n = e[r];
    n === null || typeof n > "u" || n === !1 ? t.removeAttribute(r) : t.setAttribute(r, n === !0 ? "" : n);
  });
}
function _r(t) {
  var e = {}, r = ",autoplay,controls,playsinline,loop,muted,default,defaultMuted,";
  if (t && t.attributes && t.attributes.length > 0)
    for (var n = t.attributes, i = n.length - 1; i >= 0; i--) {
      var a = n[i].name, s = n[i].value;
      (typeof t[a] == "boolean" || r.indexOf("," + a + ",") !== -1) && (s = s !== null), e[a] = s;
    }
  return e;
}
function by(t, e) {
  return t.getAttribute(e);
}
function Ca(t, e, r) {
  t.setAttribute(e, r);
}
function Wu(t, e) {
  t.removeAttribute(e);
}
function Sy() {
  oe.body.focus(), oe.onselectstart = function() {
    return !1;
  };
}
function Ey() {
  oe.onselectstart = function() {
    return !0;
  };
}
function Aa(t) {
  if (t && t.getBoundingClientRect && t.parentNode) {
    var e = t.getBoundingClientRect(), r = {};
    return ["bottom", "height", "left", "right", "top", "width"].forEach(function(n) {
      e[n] !== void 0 && (r[n] = e[n]);
    }), r.height || (r.height = parseFloat(Is(t, "height"))), r.width || (r.width = parseFloat(Is(t, "width"))), r;
  }
}
function Ds(t) {
  if (!t || t && !t.offsetParent)
    return {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    };
  for (var e = t.offsetWidth, r = t.offsetHeight, n = 0, i = 0; t.offsetParent && t !== oe[au.fullscreenElement]; )
    n += t.offsetLeft, i += t.offsetTop, t = t.offsetParent;
  return {
    left: n,
    top: i,
    width: e,
    height: r
  };
}
function qu(t, e) {
  var r = {
    x: 0,
    y: 0
  };
  if (ui)
    for (var n = t; n && n.nodeName.toLowerCase() !== "html"; ) {
      var i = Is(n, "transform");
      if (/^matrix/.test(i)) {
        var a = i.slice(7, -1).split(/,\s/).map(Number);
        r.x += a[4], r.y += a[5];
      } else if (/^matrix3d/.test(i)) {
        var s = i.slice(9, -1).split(/,\s/).map(Number);
        r.x += s[12], r.y += s[13];
      }
      n = n.parentNode;
    }
  var o = {}, u = Ds(e.target), l = Ds(t), d = l.width, h = l.height, f = e.offsetY - (l.top - u.top), v = e.offsetX - (l.left - u.left);
  return e.changedTouches && (v = e.changedTouches[0].pageX - l.left, f = e.changedTouches[0].pageY + l.top, ui && (v -= r.x, f -= r.y)), o.y = 1 - Math.max(0, Math.min(1, f / h)), o.x = Math.max(0, Math.min(1, v / d)), o;
}
function xy(t) {
  return Lr(t) && t.nodeType === 3;
}
function Ph(t) {
  for (; t.firstChild; )
    t.removeChild(t.firstChild);
  return t;
}
function Cy(t) {
  return typeof t == "function" && (t = t()), (Array.isArray(t) ? t : [t]).map(function(e) {
    if (typeof e == "function" && (e = e()), Ma(e) || xy(e))
      return e;
    if (typeof e == "string" && /\S/.test(e))
      return oe.createTextNode(e);
  }).filter(function(e) {
    return e;
  });
}
function kh(t, e) {
  return Cy(e).forEach(function(r) {
    return t.appendChild(r);
  }), t;
}
function Ay(t, e) {
  return kh(Ph(t), e);
}
function Rs(t) {
  return t.button === void 0 && t.buttons === void 0 || t.button === 0 && t.buttons === void 0 || t.type === "mouseup" && t.button === 0 && t.buttons === 0 ? !0 : !(t.button !== 0 || t.buttons !== 1);
}
var Kr = yy("querySelector"), wy = yy("querySelectorAll"), Py = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isReal: Oa,
  isEl: Ma,
  isInFrame: vy,
  createEl: Ge,
  textContent: Pn,
  prependTo: gc,
  hasClass: Tn,
  addClass: Cr,
  removeClass: Gs,
  toggleClass: _y,
  setAttributes: Ty,
  getAttributes: _r,
  getAttribute: by,
  setAttribute: Ca,
  removeAttribute: Wu,
  blockTextSelection: Sy,
  unblockTextSelection: Ey,
  getBoundingClientRect: Aa,
  findPosition: Ds,
  getPointerPosition: qu,
  isTextNode: xy,
  emptyEl: Ph,
  normalizeContent: Cy,
  appendContent: kh,
  insertContent: Ay,
  isSingleLeftClick: Rs,
  $: Kr,
  $$: wy
}), ky = !1, mc, Cx = function() {
  if (mc.options.autoSetup !== !1) {
    var e = Array.prototype.slice.call(oe.getElementsByTagName("video")), r = Array.prototype.slice.call(oe.getElementsByTagName("audio")), n = Array.prototype.slice.call(oe.getElementsByTagName("video-js")), i = e.concat(r, n);
    if (i && i.length > 0)
      for (var a = 0, s = i.length; a < s; a++) {
        var o = i[a];
        if (o && o.getAttribute) {
          if (o.player === void 0) {
            var u = o.getAttribute("data-setup");
            u !== null && mc(o);
          }
        } else {
          vc(1);
          break;
        }
      }
    else
      ky || vc(1);
  }
};
function vc(t, e) {
  Oa() && (e && (mc = e), M.setTimeout(Cx, t));
}
function yc() {
  ky = !0, M.removeEventListener("load", yc);
}
Oa() && (oe.readyState === "complete" ? yc() : M.addEventListener("load", yc));
var Ly = function(e) {
  var r = oe.createElement("style");
  return r.className = e, r;
}, Iy = function(e, r) {
  e.styleSheet ? e.styleSheet.cssText = r : e.textContent = r;
}, Ax = 3, wx = Ax;
function Nr() {
  return wx++;
}
var Dy;
M.WeakMap || (Dy = /* @__PURE__ */ function() {
  function t() {
    this.vdata = "vdata" + Math.floor(M.performance && M.performance.now() || Date.now()), this.data = {};
  }
  var e = t.prototype;
  return e.set = function(n, i) {
    var a = n[this.vdata] || Nr();
    return n[this.vdata] || (n[this.vdata] = a), this.data[a] = i, this;
  }, e.get = function(n) {
    var i = n[this.vdata];
    if (i)
      return this.data[i];
    Fe("We have no data for this element", n);
  }, e.has = function(n) {
    var i = n[this.vdata];
    return i in this.data;
  }, e.delete = function(n) {
    var i = n[this.vdata];
    i && (delete this.data[i], delete n[this.vdata]);
  }, t;
}());
var si = M.WeakMap ? /* @__PURE__ */ new WeakMap() : new Dy();
function Dp(t, e) {
  if (si.has(t)) {
    var r = si.get(t);
    r.handlers[e].length === 0 && (delete r.handlers[e], t.removeEventListener ? t.removeEventListener(e, r.dispatcher, !1) : t.detachEvent && t.detachEvent("on" + e, r.dispatcher)), Object.getOwnPropertyNames(r.handlers).length <= 0 && (delete r.handlers, delete r.dispatcher, delete r.disabled), Object.getOwnPropertyNames(r).length === 0 && si.delete(t);
  }
}
function Lh(t, e, r, n) {
  r.forEach(function(i) {
    t(e, i, n);
  });
}
function $u(t) {
  if (t.fixed_)
    return t;
  function e() {
    return !0;
  }
  function r() {
    return !1;
  }
  if (!t || !t.isPropagationStopped || !t.isImmediatePropagationStopped) {
    var n = t || M.event;
    t = {};
    for (var i in n)
      i !== "layerX" && i !== "layerY" && i !== "keyLocation" && i !== "webkitMovementX" && i !== "webkitMovementY" && i !== "path" && (i === "returnValue" && n.preventDefault || (t[i] = n[i]));
    if (t.target || (t.target = t.srcElement || oe), t.relatedTarget || (t.relatedTarget = t.fromElement === t.target ? t.toElement : t.fromElement), t.preventDefault = function() {
      n.preventDefault && n.preventDefault(), t.returnValue = !1, n.returnValue = !1, t.defaultPrevented = !0;
    }, t.defaultPrevented = !1, t.stopPropagation = function() {
      n.stopPropagation && n.stopPropagation(), t.cancelBubble = !0, n.cancelBubble = !0, t.isPropagationStopped = e;
    }, t.isPropagationStopped = r, t.stopImmediatePropagation = function() {
      n.stopImmediatePropagation && n.stopImmediatePropagation(), t.isImmediatePropagationStopped = e, t.stopPropagation();
    }, t.isImmediatePropagationStopped = r, t.clientX !== null && t.clientX !== void 0) {
      var a = oe.documentElement, s = oe.body;
      t.pageX = t.clientX + (a && a.scrollLeft || s && s.scrollLeft || 0) - (a && a.clientLeft || s && s.clientLeft || 0), t.pageY = t.clientY + (a && a.scrollTop || s && s.scrollTop || 0) - (a && a.clientTop || s && s.clientTop || 0);
    }
    t.which = t.charCode || t.keyCode, t.button !== null && t.button !== void 0 && (t.button = t.button & 1 ? 0 : t.button & 4 ? 1 : t.button & 2 ? 2 : 0);
  }
  return t.fixed_ = !0, t;
}
var xo, Px = function() {
  if (typeof xo != "boolean") {
    xo = !1;
    try {
      var e = Object.defineProperty({}, "passive", {
        get: function() {
          xo = !0;
        }
      });
      M.addEventListener("test", null, e), M.removeEventListener("test", null, e);
    } catch {
    }
  }
  return xo;
}, kx = ["touchstart", "touchmove"];
function Ei(t, e, r) {
  if (Array.isArray(e))
    return Lh(Ei, t, e, r);
  si.has(t) || si.set(t, {});
  var n = si.get(t);
  if (n.handlers || (n.handlers = {}), n.handlers[e] || (n.handlers[e] = []), r.guid || (r.guid = Nr()), n.handlers[e].push(r), n.dispatcher || (n.disabled = !1, n.dispatcher = function(a, s) {
    if (!n.disabled) {
      a = $u(a);
      var o = n.handlers[a.type];
      if (o)
        for (var u = o.slice(0), l = 0, d = u.length; l < d && !a.isImmediatePropagationStopped(); l++)
          try {
            u[l].call(t, a, s);
          } catch (h) {
            Fe.error(h);
          }
    }
  }), n.handlers[e].length === 1)
    if (t.addEventListener) {
      var i = !1;
      Px() && kx.indexOf(e) > -1 && (i = {
        passive: !0
      }), t.addEventListener(e, n.dispatcher, i);
    } else
      t.attachEvent && t.attachEvent("on" + e, n.dispatcher);
}
function Xt(t, e, r) {
  if (si.has(t)) {
    var n = si.get(t);
    if (n.handlers) {
      if (Array.isArray(e))
        return Lh(Xt, t, e, r);
      var i = function(l, d) {
        n.handlers[d] = [], Dp(l, d);
      };
      if (e === void 0) {
        for (var a in n.handlers)
          Object.prototype.hasOwnProperty.call(n.handlers || {}, a) && i(t, a);
        return;
      }
      var s = n.handlers[e];
      if (s) {
        if (!r) {
          i(t, e);
          return;
        }
        if (r.guid)
          for (var o = 0; o < s.length; o++)
            s[o].guid === r.guid && s.splice(o--, 1);
        Dp(t, e);
      }
    }
  }
}
function Na(t, e, r) {
  var n = si.has(t) ? si.get(t) : {}, i = t.parentNode || t.ownerDocument;
  if (typeof e == "string" ? e = {
    type: e,
    target: t
  } : e.target || (e.target = t), e = $u(e), n.dispatcher && n.dispatcher.call(t, e, r), i && !e.isPropagationStopped() && e.bubbles === !0)
    Na.call(null, i, e, r);
  else if (!i && !e.defaultPrevented && e.target && e.target[e.type]) {
    si.has(e.target) || si.set(e.target, {});
    var a = si.get(e.target);
    e.target[e.type] && (a.disabled = !0, typeof e.target[e.type] == "function" && e.target[e.type](), a.disabled = !1);
  }
  return !e.defaultPrevented;
}
function zu(t, e, r) {
  if (Array.isArray(e))
    return Lh(zu, t, e, r);
  var n = function i() {
    Xt(t, e, i), r.apply(this, arguments);
  };
  n.guid = r.guid = r.guid || Nr(), Ei(t, e, n);
}
function Ry(t, e, r) {
  var n = function i() {
    Xt(t, e, i), r.apply(this, arguments);
  };
  n.guid = r.guid = r.guid || Nr(), Ei(t, e, n);
}
var Lx = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fixEvent: $u,
  on: Ei,
  off: Xt,
  trigger: Na,
  one: zu,
  any: Ry
}), ji = 30, vt = function(e, r, n) {
  r.guid || (r.guid = Nr());
  var i = r.bind(e);
  return i.guid = n ? n + "_" + r.guid : r.guid, i;
}, Ir = function(e, r) {
  var n = M.performance.now(), i = function() {
    var s = M.performance.now();
    s - n >= r && (e.apply(void 0, arguments), n = s);
  };
  return i;
}, Ix = function(e, r, n, i) {
  i === void 0 && (i = M);
  var a, s = function() {
    i.clearTimeout(a), a = null;
  }, o = function() {
    var l = this, d = arguments, h = function() {
      a = null, h = null, n || e.apply(l, d);
    };
    !a && n && e.apply(l, d), i.clearTimeout(a), a = i.setTimeout(h, r);
  };
  return o.cancel = s, o;
}, Vt = function() {
};
Vt.prototype.allowedEvents_ = {};
Vt.prototype.on = function(t, e) {
  var r = this.addEventListener;
  this.addEventListener = function() {
  }, Ei(this, t, e), this.addEventListener = r;
};
Vt.prototype.addEventListener = Vt.prototype.on;
Vt.prototype.off = function(t, e) {
  Xt(this, t, e);
};
Vt.prototype.removeEventListener = Vt.prototype.off;
Vt.prototype.one = function(t, e) {
  var r = this.addEventListener;
  this.addEventListener = function() {
  }, zu(this, t, e), this.addEventListener = r;
};
Vt.prototype.any = function(t, e) {
  var r = this.addEventListener;
  this.addEventListener = function() {
  }, Ry(this, t, e), this.addEventListener = r;
};
Vt.prototype.trigger = function(t) {
  var e = t.type || t;
  typeof t == "string" && (t = {
    type: e
  }), t = $u(t), this.allowedEvents_[e] && this["on" + e] && this["on" + e](t), Na(this, t);
};
Vt.prototype.dispatchEvent = Vt.prototype.trigger;
var rs;
Vt.prototype.queueTrigger = function(t) {
  var e = this;
  rs || (rs = /* @__PURE__ */ new Map());
  var r = t.type || t, n = rs.get(this);
  n || (n = /* @__PURE__ */ new Map(), rs.set(this, n));
  var i = n.get(r);
  n.delete(r), M.clearTimeout(i);
  var a = M.setTimeout(function() {
    n.delete(r), n.size === 0 && (n = null, rs.delete(e)), e.trigger(t);
  }, 0);
  n.set(r, a);
};
var Gu = function(e) {
  return typeof e.name == "function" ? e.name() : typeof e.name == "string" ? e.name : e.name_ ? e.name_ : e.constructor && e.constructor.name ? e.constructor.name : typeof e;
}, Ar = function(e) {
  return e instanceof Vt || !!e.eventBusEl_ && ["on", "one", "off", "trigger"].every(function(r) {
    return typeof e[r] == "function";
  });
}, Dx = function(e, r) {
  Ar(e) ? r() : (e.eventedCallbacks || (e.eventedCallbacks = []), e.eventedCallbacks.push(r));
}, _c = function(e) {
  return (
    // The regex here verifies that the `type` contains at least one non-
    // whitespace character.
    typeof e == "string" && /\S/.test(e) || Array.isArray(e) && !!e.length
  );
}, su = function(e, r, n) {
  if (!e || !e.nodeName && !Ar(e))
    throw new Error("Invalid target for " + Gu(r) + "#" + n + "; must be a DOM node or evented object.");
}, Oy = function(e, r, n) {
  if (!_c(e))
    throw new Error("Invalid event type for " + Gu(r) + "#" + n + "; must be a non-empty string or array.");
}, My = function(e, r, n) {
  if (typeof e != "function")
    throw new Error("Invalid listener for " + Gu(r) + "#" + n + "; must be a function.");
}, Dl = function(e, r, n) {
  var i = r.length < 3 || r[0] === e || r[0] === e.eventBusEl_, a, s, o;
  return i ? (a = e.eventBusEl_, r.length >= 3 && r.shift(), s = r[0], o = r[1]) : (a = r[0], s = r[1], o = r[2]), su(a, e, n), Oy(s, e, n), My(o, e, n), o = vt(e, o), {
    isTargetingSelf: i,
    target: a,
    type: s,
    listener: o
  };
}, cn = function(e, r, n, i) {
  su(e, e, r), e.nodeName ? Lx[r](e, n, i) : e[r](n, i);
}, Rx = {
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  on: function() {
    for (var e = this, r = arguments.length, n = new Array(r), i = 0; i < r; i++)
      n[i] = arguments[i];
    var a = Dl(this, n, "on"), s = a.isTargetingSelf, o = a.target, u = a.type, l = a.listener;
    if (cn(o, "on", u, l), !s) {
      var d = function() {
        return e.off(o, u, l);
      };
      d.guid = l.guid;
      var h = function() {
        return e.off("dispose", d);
      };
      h.guid = l.guid, cn(this, "on", "dispose", d), cn(o, "on", "dispose", h);
    }
  },
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will be called once per event and then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  one: function() {
    for (var e = this, r = arguments.length, n = new Array(r), i = 0; i < r; i++)
      n[i] = arguments[i];
    var a = Dl(this, n, "one"), s = a.isTargetingSelf, o = a.target, u = a.type, l = a.listener;
    if (s)
      cn(o, "one", u, l);
    else {
      var d = function h() {
        e.off(o, u, h);
        for (var f = arguments.length, v = new Array(f), b = 0; b < f; b++)
          v[b] = arguments[b];
        l.apply(null, v);
      };
      d.guid = l.guid, cn(o, "one", u, d);
    }
  },
  /**
   * Add a listener to an event (or events) on this object or another evented
   * object. The listener will only be called once for the first event that is triggered
   * then removed.
   *
   * @param  {string|Array|Element|Object} targetOrType
   *         If this is a string or array, it represents the event type(s)
   *         that will trigger the listener.
   *
   *         Another evented object can be passed here instead, which will
   *         cause the listener to listen for events on _that_ object.
   *
   *         In either case, the listener's `this` value will be bound to
   *         this object.
   *
   * @param  {string|Array|Function} typeOrListener
   *         If the first argument was a string or array, this should be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function.
   */
  any: function() {
    for (var e = this, r = arguments.length, n = new Array(r), i = 0; i < r; i++)
      n[i] = arguments[i];
    var a = Dl(this, n, "any"), s = a.isTargetingSelf, o = a.target, u = a.type, l = a.listener;
    if (s)
      cn(o, "any", u, l);
    else {
      var d = function h() {
        e.off(o, u, h);
        for (var f = arguments.length, v = new Array(f), b = 0; b < f; b++)
          v[b] = arguments[b];
        l.apply(null, v);
      };
      d.guid = l.guid, cn(o, "any", u, d);
    }
  },
  /**
   * Removes listener(s) from event(s) on an evented object.
   *
   * @param  {string|Array|Element|Object} [targetOrType]
   *         If this is a string or array, it represents the event type(s).
   *
   *         Another evented object can be passed here instead, in which case
   *         ALL 3 arguments are _required_.
   *
   * @param  {string|Array|Function} [typeOrListener]
   *         If the first argument was a string or array, this may be the
   *         listener function. Otherwise, this is a string or array of event
   *         type(s).
   *
   * @param  {Function} [listener]
   *         If the first argument was another evented object, this will be
   *         the listener function; otherwise, _all_ listeners bound to the
   *         event type(s) will be removed.
   */
  off: function(e, r, n) {
    if (!e || _c(e))
      Xt(this.eventBusEl_, e, r);
    else {
      var i = e, a = r;
      su(i, this, "off"), Oy(a, this, "off"), My(n, this, "off"), n = vt(this, n), this.off("dispose", n), i.nodeName ? (Xt(i, a, n), Xt(i, "dispose", n)) : Ar(i) && (i.off(a, n), i.off("dispose", n));
    }
  },
  /**
   * Fire an event on this evented object, causing its listeners to be called.
   *
   * @param   {string|Object} event
   *          An event type or an object with a type property.
   *
   * @param   {Object} [hash]
   *          An additional object to pass along to listeners.
   *
   * @return {boolean}
   *          Whether or not the default behavior was prevented.
   */
  trigger: function(e, r) {
    su(this.eventBusEl_, this, "trigger");
    var n = e && typeof e != "string" ? e.type : e;
    if (!_c(n)) {
      var i = "Invalid event type for " + Gu(this) + "#trigger; must be a non-empty string or object with a type key that has a non-empty value.";
      if (e)
        (this.log || Fe).error(i);
      else
        throw new Error(i);
    }
    return Na(this.eventBusEl_, e, r);
  }
};
function Ih(t, e) {
  e === void 0 && (e = {});
  var r = e, n = r.eventBusKey;
  if (n) {
    if (!t[n].nodeName)
      throw new Error('The eventBusKey "' + n + '" does not refer to an element.');
    t.eventBusEl_ = t[n];
  } else
    t.eventBusEl_ = Ge("span", {
      className: "vjs-event-bus"
    });
  return At(t, Rx), t.eventedCallbacks && t.eventedCallbacks.forEach(function(i) {
    i();
  }), t.on("dispose", function() {
    t.off(), [t, t.el_, t.eventBusEl_].forEach(function(i) {
      i && si.has(i) && si.delete(i);
    }), M.setTimeout(function() {
      t.eventBusEl_ = null;
    }, 0);
  }), t;
}
var Ox = {
  /**
   * A hash containing arbitrary keys and values representing the state of
   * the object.
   *
   * @type {Object}
   */
  state: {},
  /**
   * Set the state of an object by mutating its
   * {@link module:stateful~StatefulMixin.state|state} object in place.
   *
   * @fires   module:stateful~StatefulMixin#statechanged
   * @param   {Object|Function} stateUpdates
   *          A new set of properties to shallow-merge into the plugin state.
   *          Can be a plain object or a function returning a plain object.
   *
   * @return {Object|undefined}
   *          An object containing changes that occurred. If no changes
   *          occurred, returns `undefined`.
   */
  setState: function(e) {
    var r = this;
    typeof e == "function" && (e = e());
    var n;
    return fa(e, function(i, a) {
      r.state[a] !== i && (n = n || {}, n[a] = {
        from: r.state[a],
        to: i
      }), r.state[a] = i;
    }), n && Ar(this) && this.trigger({
      changes: n,
      type: "statechanged"
    }), n;
  }
};
function Ny(t, e) {
  return At(t, Ox), t.state = At({}, t.state, e), typeof t.handleStateChanged == "function" && Ar(t) && t.on("statechanged", t.handleStateChanged), t;
}
var jo = function(e) {
  return typeof e != "string" ? e : e.replace(/./, function(r) {
    return r.toLowerCase();
  });
}, It = function(e) {
  return typeof e != "string" ? e : e.replace(/./, function(r) {
    return r.toUpperCase();
  });
}, Mx = function(e, r) {
  return It(e) === It(r);
};
function mt() {
  for (var t = {}, e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  return r.forEach(function(i) {
    i && fa(i, function(a, s) {
      if (!Ls(a)) {
        t[s] = a;
        return;
      }
      Ls(t[s]) || (t[s] = {}), t[s] = mt(t[s], a);
    });
  }), t;
}
var Nx = /* @__PURE__ */ function() {
  function t() {
    this.map_ = {};
  }
  var e = t.prototype;
  return e.has = function(n) {
    return n in this.map_;
  }, e.delete = function(n) {
    var i = this.has(n);
    return delete this.map_[n], i;
  }, e.set = function(n, i) {
    return this.map_[n] = i, this;
  }, e.forEach = function(n, i) {
    for (var a in this.map_)
      n.call(i, this.map_[a], a, this);
  }, t;
}(), Bx = M.Map ? M.Map : Nx, Fx = /* @__PURE__ */ function() {
  function t() {
    this.set_ = {};
  }
  var e = t.prototype;
  return e.has = function(n) {
    return n in this.set_;
  }, e.delete = function(n) {
    var i = this.has(n);
    return delete this.set_[n], i;
  }, e.add = function(n) {
    return this.set_[n] = 1, this;
  }, e.forEach = function(n, i) {
    for (var a in this.set_)
      n.call(i, a, a, this);
  }, t;
}(), Rl = M.Set ? M.Set : Fx, ee = /* @__PURE__ */ function() {
  function t(r, n, i) {
    var a = this;
    if (!r && this.play ? this.player_ = r = this : this.player_ = r, this.isDisposed_ = !1, this.parentComponent_ = null, this.options_ = mt({}, this.options_), n = this.options_ = mt(this.options_, n), this.id_ = n.id || n.el && n.el.id, !this.id_) {
      var s = r && r.id && r.id() || "no_player";
      this.id_ = s + "_component_" + Nr();
    }
    this.name_ = n.name || null, n.el ? this.el_ = n.el : n.createEl !== !1 && (this.el_ = this.createEl()), n.className && this.el_ && n.className.split(" ").forEach(function(o) {
      return a.addClass(o);
    }), n.evented !== !1 && (Ih(this, {
      eventBusKey: this.el_ ? "el_" : null
    }), this.handleLanguagechange = this.handleLanguagechange.bind(this), this.on(this.player_, "languagechange", this.handleLanguagechange)), Ny(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {}, this.setTimeoutIds_ = new Rl(), this.setIntervalIds_ = new Rl(), this.rafIds_ = new Rl(), this.namedRafs_ = new Bx(), this.clearingTimersOnDispose_ = !1, n.initChildren !== !1 && this.initChildren(), this.ready(i), n.reportTouchActivity !== !1 && this.enableTouchActivity();
  }
  var e = t.prototype;
  return e.dispose = function(n) {
    if (n === void 0 && (n = {}), !this.isDisposed_) {
      if (this.readyQueue_ && (this.readyQueue_.length = 0), this.trigger({
        type: "dispose",
        bubbles: !1
      }), this.isDisposed_ = !0, this.children_)
        for (var i = this.children_.length - 1; i >= 0; i--)
          this.children_[i].dispose && this.children_[i].dispose();
      this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ && (this.el_.parentNode && (n.restoreEl ? this.el_.parentNode.replaceChild(n.restoreEl, this.el_) : this.el_.parentNode.removeChild(this.el_)), this.el_ = null), this.player_ = null;
    }
  }, e.isDisposed = function() {
    return !!this.isDisposed_;
  }, e.player = function() {
    return this.player_;
  }, e.options = function(n) {
    return n ? (this.options_ = mt(this.options_, n), this.options_) : this.options_;
  }, e.el = function() {
    return this.el_;
  }, e.createEl = function(n, i, a) {
    return Ge(n, i, a);
  }, e.localize = function(n, i, a) {
    a === void 0 && (a = n);
    var s = this.player_.language && this.player_.language(), o = this.player_.languages && this.player_.languages(), u = o && o[s], l = s && s.split("-")[0], d = o && o[l], h = a;
    return u && u[n] ? h = u[n] : d && d[n] && (h = d[n]), i && (h = h.replace(/\{(\d+)\}/g, function(f, v) {
      var b = i[v - 1], _ = b;
      return typeof b > "u" && (_ = f), _;
    })), h;
  }, e.handleLanguagechange = function() {
  }, e.contentEl = function() {
    return this.contentEl_ || this.el_;
  }, e.id = function() {
    return this.id_;
  }, e.name = function() {
    return this.name_;
  }, e.children = function() {
    return this.children_;
  }, e.getChildById = function(n) {
    return this.childIndex_[n];
  }, e.getChild = function(n) {
    if (n)
      return this.childNameIndex_[n];
  }, e.getDescendant = function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    i = i.reduce(function(u, l) {
      return u.concat(l);
    }, []);
    for (var s = this, o = 0; o < i.length; o++)
      if (s = s.getChild(i[o]), !s || !s.getChild)
        return;
    return s;
  }, e.addChild = function(n, i, a) {
    i === void 0 && (i = {}), a === void 0 && (a = this.children_.length);
    var s, o;
    if (typeof n == "string") {
      o = It(n);
      var u = i.componentClass || o;
      i.name = o;
      var l = t.getComponent(u);
      if (!l)
        throw new Error("Component " + u + " does not exist");
      if (typeof l != "function")
        return null;
      s = new l(this.player_ || this, i);
    } else
      s = n;
    if (s.parentComponent_ && s.parentComponent_.removeChild(s), this.children_.splice(a, 0, s), s.parentComponent_ = this, typeof s.id == "function" && (this.childIndex_[s.id()] = s), o = o || s.name && It(s.name()), o && (this.childNameIndex_[o] = s, this.childNameIndex_[jo(o)] = s), typeof s.el == "function" && s.el()) {
      var d = null;
      this.children_[a + 1] && (this.children_[a + 1].el_ ? d = this.children_[a + 1].el_ : Ma(this.children_[a + 1]) && (d = this.children_[a + 1])), this.contentEl().insertBefore(s.el(), d);
    }
    return s;
  }, e.removeChild = function(n) {
    if (typeof n == "string" && (n = this.getChild(n)), !(!n || !this.children_)) {
      for (var i = !1, a = this.children_.length - 1; a >= 0; a--)
        if (this.children_[a] === n) {
          i = !0, this.children_.splice(a, 1);
          break;
        }
      if (i) {
        n.parentComponent_ = null, this.childIndex_[n.id()] = null, this.childNameIndex_[It(n.name())] = null, this.childNameIndex_[jo(n.name())] = null;
        var s = n.el();
        s && s.parentNode === this.contentEl() && this.contentEl().removeChild(n.el());
      }
    }
  }, e.initChildren = function() {
    var n = this, i = this.options_.children;
    if (i) {
      var a = this.options_, s = function(d) {
        var h = d.name, f = d.opts;
        if (a[h] !== void 0 && (f = a[h]), f !== !1) {
          f === !0 && (f = {}), f.playerOptions = n.options_.playerOptions;
          var v = n.addChild(h, f);
          v && (n[h] = v);
        }
      }, o, u = t.getComponent("Tech");
      Array.isArray(i) ? o = i : o = Object.keys(i), o.concat(Object.keys(this.options_).filter(function(l) {
        return !o.some(function(d) {
          return typeof d == "string" ? l === d : l === d.name;
        });
      })).map(function(l) {
        var d, h;
        return typeof l == "string" ? (d = l, h = i[d] || n.options_[d] || {}) : (d = l.name, h = l), {
          name: d,
          opts: h
        };
      }).filter(function(l) {
        var d = t.getComponent(l.opts.componentClass || It(l.name));
        return d && !u.isTech(d);
      }).forEach(s);
    }
  }, e.buildCSSClass = function() {
    return "";
  }, e.ready = function(n, i) {
    if (i === void 0 && (i = !1), !!n) {
      if (!this.isReady_) {
        this.readyQueue_ = this.readyQueue_ || [], this.readyQueue_.push(n);
        return;
      }
      i ? n.call(this) : this.setTimeout(n, 1);
    }
  }, e.triggerReady = function() {
    this.isReady_ = !0, this.setTimeout(function() {
      var n = this.readyQueue_;
      this.readyQueue_ = [], n && n.length > 0 && n.forEach(function(i) {
        i.call(this);
      }, this), this.trigger("ready");
    }, 1);
  }, e.$ = function(n, i) {
    return Kr(n, i || this.contentEl());
  }, e.$$ = function(n, i) {
    return wy(n, i || this.contentEl());
  }, e.hasClass = function(n) {
    return Tn(this.el_, n);
  }, e.addClass = function(n) {
    Cr(this.el_, n);
  }, e.removeClass = function(n) {
    Gs(this.el_, n);
  }, e.toggleClass = function(n, i) {
    _y(this.el_, n, i);
  }, e.show = function() {
    this.removeClass("vjs-hidden");
  }, e.hide = function() {
    this.addClass("vjs-hidden");
  }, e.lockShowing = function() {
    this.addClass("vjs-lock-showing");
  }, e.unlockShowing = function() {
    this.removeClass("vjs-lock-showing");
  }, e.getAttribute = function(n) {
    return by(this.el_, n);
  }, e.setAttribute = function(n, i) {
    Ca(this.el_, n, i);
  }, e.removeAttribute = function(n) {
    Wu(this.el_, n);
  }, e.width = function(n, i) {
    return this.dimension("width", n, i);
  }, e.height = function(n, i) {
    return this.dimension("height", n, i);
  }, e.dimensions = function(n, i) {
    this.width(n, !0), this.height(i);
  }, e.dimension = function(n, i, a) {
    if (i !== void 0) {
      (i === null || i !== i) && (i = 0), ("" + i).indexOf("%") !== -1 || ("" + i).indexOf("px") !== -1 ? this.el_.style[n] = i : i === "auto" ? this.el_.style[n] = "" : this.el_.style[n] = i + "px", a || this.trigger("componentresize");
      return;
    }
    if (!this.el_)
      return 0;
    var s = this.el_.style[n], o = s.indexOf("px");
    return parseInt(o !== -1 ? s.slice(0, o) : this.el_["offset" + It(n)], 10);
  }, e.currentDimension = function(n) {
    var i = 0;
    if (n !== "width" && n !== "height")
      throw new Error("currentDimension only accepts width or height value");
    if (i = Is(this.el_, n), i = parseFloat(i), i === 0 || isNaN(i)) {
      var a = "offset" + It(n);
      i = this.el_[a];
    }
    return i;
  }, e.currentDimensions = function() {
    return {
      width: this.currentDimension("width"),
      height: this.currentDimension("height")
    };
  }, e.currentWidth = function() {
    return this.currentDimension("width");
  }, e.currentHeight = function() {
    return this.currentDimension("height");
  }, e.focus = function() {
    this.el_.focus();
  }, e.blur = function() {
    this.el_.blur();
  }, e.handleKeyDown = function(n) {
    this.player_ && (De.isEventKey(n, "Tab") || n.stopPropagation(), this.player_.handleKeyDown(n));
  }, e.handleKeyPress = function(n) {
    this.handleKeyDown(n);
  }, e.emitTapEvents = function() {
    var n = 0, i = null, a = 10, s = 200, o;
    this.on("touchstart", function(l) {
      l.touches.length === 1 && (i = {
        pageX: l.touches[0].pageX,
        pageY: l.touches[0].pageY
      }, n = M.performance.now(), o = !0);
    }), this.on("touchmove", function(l) {
      if (l.touches.length > 1)
        o = !1;
      else if (i) {
        var d = l.touches[0].pageX - i.pageX, h = l.touches[0].pageY - i.pageY, f = Math.sqrt(d * d + h * h);
        f > a && (o = !1);
      }
    });
    var u = function() {
      o = !1;
    };
    this.on("touchleave", u), this.on("touchcancel", u), this.on("touchend", function(l) {
      if (i = null, o === !0) {
        var d = M.performance.now() - n;
        d < s && (l.preventDefault(), this.trigger("tap"));
      }
    });
  }, e.enableTouchActivity = function() {
    if (!(!this.player() || !this.player().reportUserActivity)) {
      var n = vt(this.player(), this.player().reportUserActivity), i;
      this.on("touchstart", function() {
        n(), this.clearInterval(i), i = this.setInterval(n, 250);
      });
      var a = function(o) {
        n(), this.clearInterval(i);
      };
      this.on("touchmove", n), this.on("touchend", a), this.on("touchcancel", a);
    }
  }, e.setTimeout = function(n, i) {
    var a = this, s;
    return n = vt(this, n), this.clearTimersOnDispose_(), s = M.setTimeout(function() {
      a.setTimeoutIds_.has(s) && a.setTimeoutIds_.delete(s), n();
    }, i), this.setTimeoutIds_.add(s), s;
  }, e.clearTimeout = function(n) {
    return this.setTimeoutIds_.has(n) && (this.setTimeoutIds_.delete(n), M.clearTimeout(n)), n;
  }, e.setInterval = function(n, i) {
    n = vt(this, n), this.clearTimersOnDispose_();
    var a = M.setInterval(n, i);
    return this.setIntervalIds_.add(a), a;
  }, e.clearInterval = function(n) {
    return this.setIntervalIds_.has(n) && (this.setIntervalIds_.delete(n), M.clearInterval(n)), n;
  }, e.requestAnimationFrame = function(n) {
    var i = this;
    if (!this.supportsRaf_)
      return this.setTimeout(n, 1e3 / 60);
    this.clearTimersOnDispose_();
    var a;
    return n = vt(this, n), a = M.requestAnimationFrame(function() {
      i.rafIds_.has(a) && i.rafIds_.delete(a), n();
    }), this.rafIds_.add(a), a;
  }, e.requestNamedAnimationFrame = function(n, i) {
    var a = this;
    if (!this.namedRafs_.has(n)) {
      this.clearTimersOnDispose_(), i = vt(this, i);
      var s = this.requestAnimationFrame(function() {
        i(), a.namedRafs_.has(n) && a.namedRafs_.delete(n);
      });
      return this.namedRafs_.set(n, s), n;
    }
  }, e.cancelNamedAnimationFrame = function(n) {
    this.namedRafs_.has(n) && (this.cancelAnimationFrame(this.namedRafs_.get(n)), this.namedRafs_.delete(n));
  }, e.cancelAnimationFrame = function(n) {
    return this.supportsRaf_ ? (this.rafIds_.has(n) && (this.rafIds_.delete(n), M.cancelAnimationFrame(n)), n) : this.clearTimeout(n);
  }, e.clearTimersOnDispose_ = function() {
    var n = this;
    this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", function() {
      [["namedRafs_", "cancelNamedAnimationFrame"], ["rafIds_", "cancelAnimationFrame"], ["setTimeoutIds_", "clearTimeout"], ["setIntervalIds_", "clearInterval"]].forEach(function(i) {
        var a = i[0], s = i[1];
        n[a].forEach(function(o, u) {
          return n[s](u);
        });
      }), n.clearingTimersOnDispose_ = !1;
    }));
  }, t.registerComponent = function(n, i) {
    if (typeof n != "string" || !n)
      throw new Error('Illegal component name, "' + n + '"; must be a non-empty string.');
    var a = t.getComponent("Tech"), s = a && a.isTech(i), o = t === i || t.prototype.isPrototypeOf(i.prototype);
    if (s || !o) {
      var u;
      throw s ? u = "techs must be registered using Tech.registerTech()" : u = "must be a Component subclass", new Error('Illegal component, "' + n + '"; ' + u + ".");
    }
    n = It(n), t.components_ || (t.components_ = {});
    var l = t.getComponent("Player");
    if (n === "Player" && l && l.players) {
      var d = l.players, h = Object.keys(d);
      if (d && h.length > 0 && h.map(function(f) {
        return d[f];
      }).every(Boolean))
        throw new Error("Can not register Player component after player has been created.");
    }
    return t.components_[n] = i, t.components_[jo(n)] = i, i;
  }, t.getComponent = function(n) {
    if (!(!n || !t.components_))
      return t.components_[n];
  }, t;
}();
ee.prototype.supportsRaf_ = typeof M.requestAnimationFrame == "function" && typeof M.cancelAnimationFrame == "function";
ee.registerComponent("Component", ee);
function Ux(t, e, r) {
  if (typeof e != "number" || e < 0 || e > r)
    throw new Error("Failed to execute '" + t + "' on 'TimeRanges': The index provided (" + e + ") is non-numeric or out of bounds (0-" + r + ").");
}
function Rp(t, e, r, n) {
  return Ux(t, n, r.length - 1), r[n][e];
}
function Ol(t) {
  var e;
  return t === void 0 || t.length === 0 ? e = {
    length: 0,
    start: function() {
      throw new Error("This TimeRanges object is empty");
    },
    end: function() {
      throw new Error("This TimeRanges object is empty");
    }
  } : e = {
    length: t.length,
    start: Rp.bind(null, "start", 0, t),
    end: Rp.bind(null, "end", 1, t)
  }, M.Symbol && M.Symbol.iterator && (e[M.Symbol.iterator] = function() {
    return (t || []).values();
  }), e;
}
function bn(t, e) {
  return Array.isArray(t) ? Ol(t) : t === void 0 || e === void 0 ? Ol() : Ol([[t, e]]);
}
function By(t, e) {
  var r = 0, n, i;
  if (!e)
    return 0;
  (!t || !t.length) && (t = bn(0, 0));
  for (var a = 0; a < t.length; a++)
    n = t.start(a), i = t.end(a), i > e && (i = e), r += i - n;
  return r / e;
}
function oi(t) {
  if (t instanceof oi)
    return t;
  typeof t == "number" ? this.code = t : typeof t == "string" ? this.message = t : Lr(t) && (typeof t.code == "number" && (this.code = t.code), At(this, t)), this.message || (this.message = oi.defaultMessages[this.code] || "");
}
oi.prototype.code = 0;
oi.prototype.message = "";
oi.prototype.status = null;
oi.errorTypes = ["MEDIA_ERR_CUSTOM", "MEDIA_ERR_ABORTED", "MEDIA_ERR_NETWORK", "MEDIA_ERR_DECODE", "MEDIA_ERR_SRC_NOT_SUPPORTED", "MEDIA_ERR_ENCRYPTED"];
oi.defaultMessages = {
  1: "You aborted the media playback",
  2: "A network error caused the media download to fail part-way.",
  3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
  4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
  5: "The media is encrypted and we do not have the keys to decrypt it."
};
for (var Zn = 0; Zn < oi.errorTypes.length; Zn++)
  oi[oi.errorTypes[Zn]] = Zn, oi.prototype[oi.errorTypes[Zn]] = Zn;
function Ts(t) {
  return t != null && typeof t.then == "function";
}
function er(t) {
  Ts(t) && t.then(null, function(e) {
  });
}
var Tc = function(e) {
  var r = ["kind", "label", "language", "id", "inBandMetadataTrackDispatchType", "mode", "src"].reduce(function(n, i, a) {
    return e[i] && (n[i] = e[i]), n;
  }, {
    cues: e.cues && Array.prototype.map.call(e.cues, function(n) {
      return {
        startTime: n.startTime,
        endTime: n.endTime,
        text: n.text,
        id: n.id
      };
    })
  });
  return r;
}, Vx = function(e) {
  var r = e.$$("track"), n = Array.prototype.map.call(r, function(a) {
    return a.track;
  }), i = Array.prototype.map.call(r, function(a) {
    var s = Tc(a.track);
    return a.src && (s.src = a.src), s;
  });
  return i.concat(Array.prototype.filter.call(e.textTracks(), function(a) {
    return n.indexOf(a) === -1;
  }).map(Tc));
}, jx = function(e, r) {
  return e.forEach(function(n) {
    var i = r.addRemoteTextTrack(n).track;
    !n.src && n.cues && n.cues.forEach(function(a) {
      return i.addCue(a);
    });
  }), r.textTracks();
}, Op = {
  textTracksToJson: Vx,
  jsonToTextTracks: jx,
  trackToJson_: Tc
}, Ml = "vjs-modal-dialog", Ba = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.handleKeyDown_ = function(s) {
      return a.handleKeyDown(s);
    }, a.close_ = function(s) {
      return a.close(s);
    }, a.opened_ = a.hasBeenOpened_ = a.hasBeenFilled_ = !1, a.closeable(!a.options_.uncloseable), a.content(a.options_.content), a.contentEl_ = Ge("div", {
      className: Ml + "-content"
    }, {
      role: "document"
    }), a.descEl_ = Ge("p", {
      className: Ml + "-description vjs-control-text",
      id: a.el().getAttribute("aria-describedby")
    }), Pn(a.descEl_, a.description()), a.el_.appendChild(a.descEl_), a.el_.appendChild(a.contentEl_), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: this.buildCSSClass(),
      tabIndex: -1
    }, {
      "aria-describedby": this.id() + "_description",
      "aria-hidden": "true",
      "aria-label": this.label(),
      role: "dialog"
    });
  }, r.dispose = function() {
    this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, t.prototype.dispose.call(this);
  }, r.buildCSSClass = function() {
    return Ml + " vjs-hidden " + t.prototype.buildCSSClass.call(this);
  }, r.label = function() {
    return this.localize(this.options_.label || "Modal Window");
  }, r.description = function() {
    var i = this.options_.description || this.localize("This is a modal window.");
    return this.closeable() && (i += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), i;
  }, r.open = function() {
    if (!this.opened_) {
      var i = this.player();
      this.trigger("beforemodalopen"), this.opened_ = !0, (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) && this.fill(), this.wasPlaying_ = !i.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && i.pause(), this.on("keydown", this.handleKeyDown_), this.hadControls_ = i.controls(), i.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0;
    }
  }, r.opened = function(i) {
    return typeof i == "boolean" && this[i ? "open" : "close"](), this.opened_;
  }, r.close = function() {
    if (this.opened_) {
      var i = this.player();
      this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && i.play(), this.off("keydown", this.handleKeyDown_), this.hadControls_ && i.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger("modalclose"), this.conditionalBlur_(), this.options_.temporary && this.dispose();
    }
  }, r.closeable = function(i) {
    if (typeof i == "boolean") {
      var a = this.closeable_ = !!i, s = this.getChild("closeButton");
      if (a && !s) {
        var o = this.contentEl_;
        this.contentEl_ = this.el_, s = this.addChild("closeButton", {
          controlText: "Close Modal Dialog"
        }), this.contentEl_ = o, this.on(s, "close", this.close_);
      }
      !a && s && (this.off(s, "close", this.close_), this.removeChild(s), s.dispose());
    }
    return this.closeable_;
  }, r.fill = function() {
    this.fillWith(this.content());
  }, r.fillWith = function(i) {
    var a = this.contentEl(), s = a.parentNode, o = a.nextSibling;
    this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, s.removeChild(a), this.empty(), Ay(a, i), this.trigger("modalfill"), o ? s.insertBefore(a, o) : s.appendChild(a);
    var u = this.getChild("closeButton");
    u && s.appendChild(u.el_);
  }, r.empty = function() {
    this.trigger("beforemodalempty"), Ph(this.contentEl()), this.trigger("modalempty");
  }, r.content = function(i) {
    return typeof i < "u" && (this.content_ = i), this.content_;
  }, r.conditionalFocus_ = function() {
    var i = oe.activeElement, a = this.player_.el_;
    this.previouslyActiveEl_ = null, (a.contains(i) || a === i) && (this.previouslyActiveEl_ = i, this.focus());
  }, r.conditionalBlur_ = function() {
    this.previouslyActiveEl_ && (this.previouslyActiveEl_.focus(), this.previouslyActiveEl_ = null);
  }, r.handleKeyDown = function(i) {
    if (i.stopPropagation(), De.isEventKey(i, "Escape") && this.closeable()) {
      i.preventDefault(), this.close();
      return;
    }
    if (De.isEventKey(i, "Tab")) {
      for (var a = this.focusableEls_(), s = this.el_.querySelector(":focus"), o, u = 0; u < a.length; u++)
        if (s === a[u]) {
          o = u;
          break;
        }
      oe.activeElement === this.el_ && (o = 0), i.shiftKey && o === 0 ? (a[a.length - 1].focus(), i.preventDefault()) : !i.shiftKey && o === a.length - 1 && (a[0].focus(), i.preventDefault());
    }
  }, r.focusableEls_ = function() {
    var i = this.el_.querySelectorAll("*");
    return Array.prototype.filter.call(i, function(a) {
      return (a instanceof M.HTMLAnchorElement || a instanceof M.HTMLAreaElement) && a.hasAttribute("href") || (a instanceof M.HTMLInputElement || a instanceof M.HTMLSelectElement || a instanceof M.HTMLTextAreaElement || a instanceof M.HTMLButtonElement) && !a.hasAttribute("disabled") || a instanceof M.HTMLIFrameElement || a instanceof M.HTMLObjectElement || a instanceof M.HTMLEmbedElement || a.hasAttribute("tabindex") && a.getAttribute("tabindex") !== -1 || a.hasAttribute("contenteditable");
    });
  }, e;
}(ee);
Ba.prototype.options_ = {
  pauseOnOpen: !0,
  temporary: !0
};
ee.registerComponent("ModalDialog", Ba);
var wa = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n) {
    var i;
    n === void 0 && (n = []), i = t.call(this) || this, i.tracks_ = [], Object.defineProperty(Le(i), "length", {
      get: function() {
        return this.tracks_.length;
      }
    });
    for (var a = 0; a < n.length; a++)
      i.addTrack(n[a]);
    return i;
  }
  var r = e.prototype;
  return r.addTrack = function(i) {
    var a = this, s = this.tracks_.length;
    "" + s in this || Object.defineProperty(this, s, {
      get: function() {
        return this.tracks_[s];
      }
    }), this.tracks_.indexOf(i) === -1 && (this.tracks_.push(i), this.trigger({
      track: i,
      type: "addtrack",
      target: this
    })), i.labelchange_ = function() {
      a.trigger({
        track: i,
        type: "labelchange",
        target: a
      });
    }, Ar(i) && i.addEventListener("labelchange", i.labelchange_);
  }, r.removeTrack = function(i) {
    for (var a, s = 0, o = this.length; s < o; s++)
      if (this[s] === i) {
        a = this[s], a.off && a.off(), this.tracks_.splice(s, 1);
        break;
      }
    a && this.trigger({
      track: a,
      type: "removetrack",
      target: this
    });
  }, r.getTrackById = function(i) {
    for (var a = null, s = 0, o = this.length; s < o; s++) {
      var u = this[s];
      if (u.id === i) {
        a = u;
        break;
      }
    }
    return a;
  }, e;
}(Vt);
wa.prototype.allowedEvents_ = {
  change: "change",
  addtrack: "addtrack",
  removetrack: "removetrack",
  labelchange: "labelchange"
};
for (var Hx in wa.prototype.allowedEvents_)
  wa.prototype["on" + Hx] = null;
var Nl = function(e, r) {
  for (var n = 0; n < e.length; n++)
    !Object.keys(e[n]).length || r.id === e[n].id || (e[n].enabled = !1);
}, Wx = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n) {
    var i;
    n === void 0 && (n = []);
    for (var a = n.length - 1; a >= 0; a--)
      if (n[a].enabled) {
        Nl(n, n[a]);
        break;
      }
    return i = t.call(this, n) || this, i.changing_ = !1, i;
  }
  var r = e.prototype;
  return r.addTrack = function(i) {
    var a = this;
    i.enabled && Nl(this, i), t.prototype.addTrack.call(this, i), i.addEventListener && (i.enabledChange_ = function() {
      a.changing_ || (a.changing_ = !0, Nl(a, i), a.changing_ = !1, a.trigger("change"));
    }, i.addEventListener("enabledchange", i.enabledChange_));
  }, r.removeTrack = function(i) {
    t.prototype.removeTrack.call(this, i), i.removeEventListener && i.enabledChange_ && (i.removeEventListener("enabledchange", i.enabledChange_), i.enabledChange_ = null);
  }, e;
}(wa), Bl = function(e, r) {
  for (var n = 0; n < e.length; n++)
    !Object.keys(e[n]).length || r.id === e[n].id || (e[n].selected = !1);
}, qx = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n) {
    var i;
    n === void 0 && (n = []);
    for (var a = n.length - 1; a >= 0; a--)
      if (n[a].selected) {
        Bl(n, n[a]);
        break;
      }
    return i = t.call(this, n) || this, i.changing_ = !1, Object.defineProperty(Le(i), "selectedIndex", {
      get: function() {
        for (var o = 0; o < this.length; o++)
          if (this[o].selected)
            return o;
        return -1;
      },
      set: function() {
      }
    }), i;
  }
  var r = e.prototype;
  return r.addTrack = function(i) {
    var a = this;
    i.selected && Bl(this, i), t.prototype.addTrack.call(this, i), i.addEventListener && (i.selectedChange_ = function() {
      a.changing_ || (a.changing_ = !0, Bl(a, i), a.changing_ = !1, a.trigger("change"));
    }, i.addEventListener("selectedchange", i.selectedChange_));
  }, r.removeTrack = function(i) {
    t.prototype.removeTrack.call(this, i), i.removeEventListener && i.selectedChange_ && (i.removeEventListener("selectedchange", i.selectedChange_), i.selectedChange_ = null);
  }, e;
}(wa), Fy = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var r = e.prototype;
  return r.addTrack = function(i) {
    var a = this;
    t.prototype.addTrack.call(this, i), this.queueChange_ || (this.queueChange_ = function() {
      return a.queueTrigger("change");
    }), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = function() {
      return a.trigger("selectedlanguagechange");
    }), i.addEventListener("modechange", this.queueChange_);
    var s = ["metadata", "chapters"];
    s.indexOf(i.kind) === -1 && i.addEventListener("modechange", this.triggerSelectedlanguagechange_);
  }, r.removeTrack = function(i) {
    t.prototype.removeTrack.call(this, i), i.removeEventListener && (this.queueChange_ && i.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && i.removeEventListener("modechange", this.triggerSelectedlanguagechange_));
  }, e;
}(wa), $x = /* @__PURE__ */ function() {
  function t(r) {
    r === void 0 && (r = []), this.trackElements_ = [], Object.defineProperty(this, "length", {
      get: function() {
        return this.trackElements_.length;
      }
    });
    for (var n = 0, i = r.length; n < i; n++)
      this.addTrackElement_(r[n]);
  }
  var e = t.prototype;
  return e.addTrackElement_ = function(n) {
    var i = this.trackElements_.length;
    "" + i in this || Object.defineProperty(this, i, {
      get: function() {
        return this.trackElements_[i];
      }
    }), this.trackElements_.indexOf(n) === -1 && this.trackElements_.push(n);
  }, e.getTrackElementByTrack_ = function(n) {
    for (var i, a = 0, s = this.trackElements_.length; a < s; a++)
      if (n === this.trackElements_[a].track) {
        i = this.trackElements_[a];
        break;
      }
    return i;
  }, e.removeTrackElement_ = function(n) {
    for (var i = 0, a = this.trackElements_.length; i < a; i++)
      if (n === this.trackElements_[i]) {
        this.trackElements_[i].track && typeof this.trackElements_[i].track.off == "function" && this.trackElements_[i].track.off(), typeof this.trackElements_[i].off == "function" && this.trackElements_[i].off(), this.trackElements_.splice(i, 1);
        break;
      }
  }, t;
}(), Mp = /* @__PURE__ */ function() {
  function t(r) {
    t.prototype.setCues_.call(this, r), Object.defineProperty(this, "length", {
      get: function() {
        return this.length_;
      }
    });
  }
  var e = t.prototype;
  return e.setCues_ = function(n) {
    var i = this.length || 0, a = 0, s = n.length;
    this.cues_ = n, this.length_ = n.length;
    var o = function(l) {
      "" + l in this || Object.defineProperty(this, "" + l, {
        get: function() {
          return this.cues_[l];
        }
      });
    };
    if (i < s)
      for (a = i; a < s; a++)
        o.call(this, a);
  }, e.getCueById = function(n) {
    for (var i = null, a = 0, s = this.length; a < s; a++) {
      var o = this[a];
      if (o.id === n) {
        i = o;
        break;
      }
    }
    return i;
  }, t;
}(), zx = {
  alternative: "alternative",
  captions: "captions",
  main: "main",
  sign: "sign",
  subtitles: "subtitles",
  commentary: "commentary"
}, Gx = {
  alternative: "alternative",
  descriptions: "descriptions",
  main: "main",
  "main-desc": "main-desc",
  translation: "translation",
  commentary: "commentary"
}, Kx = {
  subtitles: "subtitles",
  captions: "captions",
  descriptions: "descriptions",
  chapters: "chapters",
  metadata: "metadata"
}, Np = {
  disabled: "disabled",
  hidden: "hidden",
  showing: "showing"
}, Dh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(r) {
    var n;
    r === void 0 && (r = {}), n = t.call(this) || this;
    var i = {
      id: r.id || "vjs_track_" + Nr(),
      kind: r.kind || "",
      language: r.language || ""
    }, a = r.label || "", s = function(l) {
      Object.defineProperty(Le(n), l, {
        get: function() {
          return i[l];
        },
        set: function() {
        }
      });
    };
    for (var o in i)
      s(o);
    return Object.defineProperty(Le(n), "label", {
      get: function() {
        return a;
      },
      set: function(l) {
        l !== a && (a = l, this.trigger("labelchange"));
      }
    }), n;
  }
  return e;
}(Vt), Rh = function(e) {
  var r = ["protocol", "hostname", "port", "pathname", "search", "hash", "host"], n = oe.createElement("a");
  n.href = e;
  for (var i = {}, a = 0; a < r.length; a++)
    i[r[a]] = n[r[a]];
  return i.protocol === "http:" && (i.host = i.host.replace(/:80$/, "")), i.protocol === "https:" && (i.host = i.host.replace(/:443$/, "")), i.protocol || (i.protocol = M.location.protocol), i.host || (i.host = M.location.host), i;
}, Uy = function(e) {
  if (!e.match(/^https?:\/\//)) {
    var r = oe.createElement("a");
    r.href = e, e = r.href;
  }
  return e;
}, Oh = function(e) {
  if (typeof e == "string") {
    var r = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/, n = r.exec(e);
    if (n)
      return n.pop().toLowerCase();
  }
  return "";
}, Ku = function(e, r) {
  r === void 0 && (r = M.location);
  var n = Rh(e), i = n.protocol === ":" ? r.protocol : n.protocol, a = i + n.host !== r.protocol + r.host;
  return a;
}, Xx = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  parseUrl: Rh,
  getAbsoluteURL: Uy,
  getFileExtension: Oh,
  isCrossOrigin: Ku
}), Bp = function(e, r) {
  var n = new M.WebVTT.Parser(M, M.vttjs, M.WebVTT.StringDecoder()), i = [];
  n.oncue = function(a) {
    r.addCue(a);
  }, n.onparsingerror = function(a) {
    i.push(a);
  }, n.onflush = function() {
    r.trigger({
      type: "loadeddata",
      target: r
    });
  }, n.parse(e), i.length > 0 && (M.console && M.console.groupCollapsed && M.console.groupCollapsed("Text Track parsing errors for " + r.src), i.forEach(function(a) {
    return Fe.error(a);
  }), M.console && M.console.groupEnd && M.console.groupEnd()), n.flush();
}, Fp = function(e, r) {
  var n = {
    uri: e
  }, i = Ku(e);
  i && (n.cors = i);
  var a = r.tech_.crossOrigin() === "use-credentials";
  a && (n.withCredentials = a), xs(n, vt(this, function(s, o, u) {
    if (s)
      return Fe.error(s, o);
    r.loaded_ = !0, typeof M.WebVTT != "function" ? r.tech_ && r.tech_.any(["vttjsloaded", "vttjserror"], function(l) {
      if (l.type === "vttjserror") {
        Fe.error("vttjs failed to load, stopping trying to process " + r.src);
        return;
      }
      return Bp(u, r);
    }) : Bp(u, r);
  }));
}, Ks = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n) {
    var i;
    if (n === void 0 && (n = {}), !n.tech)
      throw new Error("A tech was not provided.");
    var a = mt(n, {
      kind: Kx[n.kind] || "subtitles",
      language: n.language || n.srclang || ""
    }), s = Np[a.mode] || "disabled", o = a.default;
    (a.kind === "metadata" || a.kind === "chapters") && (s = "hidden"), i = t.call(this, a) || this, i.tech_ = a.tech, i.cues_ = [], i.activeCues_ = [], i.preload_ = i.tech_.preloadTextTracks !== !1;
    var u = new Mp(i.cues_), l = new Mp(i.activeCues_), d = !1;
    i.timeupdateHandler = vt(Le(i), function(f) {
      if (f === void 0 && (f = {}), !this.tech_.isDisposed()) {
        if (!this.tech_.isReady_) {
          f.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
          return;
        }
        this.activeCues = this.activeCues, d && (this.trigger("cuechange"), d = !1), f.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
      }
    });
    var h = function() {
      i.stopTracking();
    };
    return i.tech_.one("dispose", h), s !== "disabled" && i.startTracking(), Object.defineProperties(Le(i), {
      /**
       * @memberof TextTrack
       * @member {boolean} default
       *         If this track was set to be on or off by default. Cannot be changed after
       *         creation.
       * @instance
       *
       * @readonly
       */
      default: {
        get: function() {
          return o;
        },
        set: function() {
        }
      },
      /**
       * @memberof TextTrack
       * @member {string} mode
       *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
       *         not be set if setting to an invalid mode.
       * @instance
       *
       * @fires TextTrack#modechange
       */
      mode: {
        get: function() {
          return s;
        },
        set: function(v) {
          Np[v] && s !== v && (s = v, !this.preload_ && s !== "disabled" && this.cues.length === 0 && Fp(this.src, this), this.stopTracking(), s !== "disabled" && this.startTracking(), this.trigger("modechange"));
        }
      },
      /**
       * @memberof TextTrack
       * @member {TextTrackCueList} cues
       *         The text track cue list for this TextTrack.
       * @instance
       */
      cues: {
        get: function() {
          return this.loaded_ ? u : null;
        },
        set: function() {
        }
      },
      /**
       * @memberof TextTrack
       * @member {TextTrackCueList} activeCues
       *         The list text track cues that are currently active for this TextTrack.
       * @instance
       */
      activeCues: {
        get: function() {
          if (!this.loaded_)
            return null;
          if (this.cues.length === 0)
            return l;
          for (var v = this.tech_.currentTime(), b = [], _ = 0, y = this.cues.length; _ < y; _++) {
            var E = this.cues[_];
            (E.startTime <= v && E.endTime >= v || E.startTime === E.endTime && E.startTime <= v && E.startTime + 0.5 >= v) && b.push(E);
          }
          if (d = !1, b.length !== this.activeCues_.length)
            d = !0;
          else
            for (var R = 0; R < b.length; R++)
              this.activeCues_.indexOf(b[R]) === -1 && (d = !0);
          return this.activeCues_ = b, l.setCues_(this.activeCues_), l;
        },
        // /!\ Keep this setter empty (see the timeupdate handler above)
        set: function() {
        }
      }
    }), a.src ? (i.src = a.src, i.preload_ || (i.loaded_ = !0), (i.preload_ || a.kind !== "subtitles" && a.kind !== "captions") && Fp(i.src, Le(i))) : i.loaded_ = !0, i;
  }
  var r = e.prototype;
  return r.startTracking = function() {
    this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler), this.tech_.on("timeupdate", this.timeupdateHandler);
  }, r.stopTracking = function() {
    this.rvf_ && (this.tech_.cancelVideoFrameCallback(this.rvf_), this.rvf_ = void 0), this.tech_.off("timeupdate", this.timeupdateHandler);
  }, r.addCue = function(i) {
    var a = i;
    if (M.vttjs && !(i instanceof M.vttjs.VTTCue)) {
      a = new M.vttjs.VTTCue(i.startTime, i.endTime, i.text);
      for (var s in i)
        s in a || (a[s] = i[s]);
      a.id = i.id, a.originalCue_ = i;
    }
    for (var o = this.tech_.textTracks(), u = 0; u < o.length; u++)
      o[u] !== this && o[u].removeCue(a);
    this.cues_.push(a), this.cues.setCues_(this.cues_);
  }, r.removeCue = function(i) {
    for (var a = this.cues_.length; a--; ) {
      var s = this.cues_[a];
      if (s === i || s.originalCue_ && s.originalCue_ === i) {
        this.cues_.splice(a, 1), this.cues.setCues_(this.cues_);
        break;
      }
    }
  }, e;
}(Dh);
Ks.prototype.allowedEvents_ = {
  cuechange: "cuechange"
};
var Vy = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(r) {
    var n;
    r === void 0 && (r = {});
    var i = mt(r, {
      kind: Gx[r.kind] || ""
    });
    n = t.call(this, i) || this;
    var a = !1;
    return Object.defineProperty(Le(n), "enabled", {
      get: function() {
        return a;
      },
      set: function(o) {
        typeof o != "boolean" || o === a || (a = o, this.trigger("enabledchange"));
      }
    }), i.enabled && (n.enabled = i.enabled), n.loaded_ = !0, n;
  }
  return e;
}(Dh), jy = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(r) {
    var n;
    r === void 0 && (r = {});
    var i = mt(r, {
      kind: zx[r.kind] || ""
    });
    n = t.call(this, i) || this;
    var a = !1;
    return Object.defineProperty(Le(n), "selected", {
      get: function() {
        return a;
      },
      set: function(o) {
        typeof o != "boolean" || o === a || (a = o, this.trigger("selectedchange"));
      }
    }), i.selected && (n.selected = i.selected), n;
  }
  return e;
}(Dh), Hy = 0, Yx = 1, Wy = 2, Qx = 3, Fa = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(r) {
    var n;
    r === void 0 && (r = {}), n = t.call(this) || this;
    var i, a = new Ks(r);
    return n.kind = a.kind, n.src = a.src, n.srclang = a.language, n.label = a.label, n.default = a.default, Object.defineProperties(Le(n), {
      /**
       * @memberof HTMLTrackElement
       * @member {HTMLTrackElement~ReadyState} readyState
       *         The current ready state of the track element.
       * @instance
       */
      readyState: {
        get: function() {
          return i;
        }
      },
      /**
       * @memberof HTMLTrackElement
       * @member {TextTrack} track
       *         The underlying TextTrack object.
       * @instance
       *
       */
      track: {
        get: function() {
          return a;
        }
      }
    }), i = Hy, a.addEventListener("loadeddata", function() {
      i = Wy, n.trigger({
        type: "load",
        target: Le(n)
      });
    }), n;
  }
  return e;
}(Vt);
Fa.prototype.allowedEvents_ = {
  load: "load"
};
Fa.NONE = Hy;
Fa.LOADING = Yx;
Fa.LOADED = Wy;
Fa.ERROR = Qx;
var Pi = {
  audio: {
    ListClass: Wx,
    TrackClass: Vy,
    capitalName: "Audio"
  },
  video: {
    ListClass: qx,
    TrackClass: jy,
    capitalName: "Video"
  },
  text: {
    ListClass: Fy,
    TrackClass: Ks,
    capitalName: "Text"
  }
};
Object.keys(Pi).forEach(function(t) {
  Pi[t].getterName = t + "Tracks", Pi[t].privateName = t + "Tracks_";
});
var Pa = {
  remoteText: {
    ListClass: Fy,
    TrackClass: Ks,
    capitalName: "RemoteText",
    getterName: "remoteTextTracks",
    privateName: "remoteTextTracks_"
  },
  remoteTextEl: {
    ListClass: $x,
    TrackClass: Fa,
    capitalName: "RemoteTextTrackEls",
    getterName: "remoteTextTrackEls",
    privateName: "remoteTextTrackEls_"
  }
}, ri = Vi({}, Pi, Pa);
Pa.names = Object.keys(Pa);
Pi.names = Object.keys(Pi);
ri.names = [].concat(Pa.names).concat(Pi.names);
function Jx(t, e, r, n, i) {
  i === void 0 && (i = {});
  var a = t.textTracks();
  i.kind = e, r && (i.label = r), n && (i.language = n), i.tech = t;
  var s = new ri.text.TrackClass(i);
  return a.addTrack(s), s;
}
var ot = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return n === void 0 && (n = {}), i === void 0 && (i = function() {
    }), n.reportTouchActivity = !1, a = t.call(this, null, n, i) || this, a.onDurationChange_ = function(s) {
      return a.onDurationChange(s);
    }, a.trackProgress_ = function(s) {
      return a.trackProgress(s);
    }, a.trackCurrentTime_ = function(s) {
      return a.trackCurrentTime(s);
    }, a.stopTrackingCurrentTime_ = function(s) {
      return a.stopTrackingCurrentTime(s);
    }, a.disposeSourceHandler_ = function(s) {
      return a.disposeSourceHandler(s);
    }, a.queuedHanders_ = /* @__PURE__ */ new Set(), a.hasStarted_ = !1, a.on("playing", function() {
      this.hasStarted_ = !0;
    }), a.on("loadstart", function() {
      this.hasStarted_ = !1;
    }), ri.names.forEach(function(s) {
      var o = ri[s];
      n && n[o.getterName] && (a[o.privateName] = n[o.getterName]);
    }), a.featuresProgressEvents || a.manualProgressOn(), a.featuresTimeupdateEvents || a.manualTimeUpdatesOn(), ["Text", "Audio", "Video"].forEach(function(s) {
      n["native" + s + "Tracks"] === !1 && (a["featuresNative" + s + "Tracks"] = !1);
    }), n.nativeCaptions === !1 || n.nativeTextTracks === !1 ? a.featuresNativeTextTracks = !1 : (n.nativeCaptions === !0 || n.nativeTextTracks === !0) && (a.featuresNativeTextTracks = !0), a.featuresNativeTextTracks || a.emulateTextTracks(), a.preloadTextTracks = n.preloadTextTracks !== !1, a.autoRemoteTextTracks_ = new ri.text.ListClass(), a.initTrackListeners(), n.nativeControlsForTouch || a.emitTapEvents(), a.constructor && (a.name_ = a.constructor.name || "Unknown Tech"), a;
  }
  var r = e.prototype;
  return r.triggerSourceset = function(i) {
    var a = this;
    this.isReady_ || this.one("ready", function() {
      return a.setTimeout(function() {
        return a.triggerSourceset(i);
      }, 1);
    }), this.trigger({
      src: i,
      type: "sourceset"
    });
  }, r.manualProgressOn = function() {
    this.on("durationchange", this.onDurationChange_), this.manualProgress = !0, this.one("ready", this.trackProgress_);
  }, r.manualProgressOff = function() {
    this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange_);
  }, r.trackProgress = function(i) {
    this.stopTrackingProgress(), this.progressInterval = this.setInterval(vt(this, function() {
      var a = this.bufferedPercent();
      this.bufferedPercent_ !== a && this.trigger("progress"), this.bufferedPercent_ = a, a === 1 && this.stopTrackingProgress();
    }), 500);
  }, r.onDurationChange = function(i) {
    this.duration_ = this.duration();
  }, r.buffered = function() {
    return bn(0, 0);
  }, r.bufferedPercent = function() {
    return By(this.buffered(), this.duration_);
  }, r.stopTrackingProgress = function() {
    this.clearInterval(this.progressInterval);
  }, r.manualTimeUpdatesOn = function() {
    this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime_), this.on("pause", this.stopTrackingCurrentTime_);
  }, r.manualTimeUpdatesOff = function() {
    this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime_), this.off("pause", this.stopTrackingCurrentTime_);
  }, r.trackCurrentTime = function() {
    this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function() {
      this.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: !0
      });
    }, 250);
  }, r.stopTrackingCurrentTime = function() {
    this.clearInterval(this.currentTimeInterval), this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }, r.dispose = function() {
    this.clearTracks(Pi.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), t.prototype.dispose.call(this);
  }, r.clearTracks = function(i) {
    var a = this;
    i = [].concat(i), i.forEach(function(s) {
      for (var o = a[s + "Tracks"]() || [], u = o.length; u--; ) {
        var l = o[u];
        s === "text" && a.removeRemoteTextTrack(l), o.removeTrack(l);
      }
    });
  }, r.cleanupAutoTextTracks = function() {
    for (var i = this.autoRemoteTextTracks_ || [], a = i.length; a--; ) {
      var s = i[a];
      this.removeRemoteTextTrack(s);
    }
  }, r.reset = function() {
  }, r.crossOrigin = function() {
  }, r.setCrossOrigin = function() {
  }, r.error = function(i) {
    return i !== void 0 && (this.error_ = new oi(i), this.trigger("error")), this.error_;
  }, r.played = function() {
    return this.hasStarted_ ? bn(0, 0) : bn();
  }, r.play = function() {
  }, r.setScrubbing = function() {
  }, r.scrubbing = function() {
  }, r.setCurrentTime = function() {
    this.manualTimeUpdates && this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    });
  }, r.initTrackListeners = function() {
    var i = this;
    Pi.names.forEach(function(a) {
      var s = Pi[a], o = function() {
        i.trigger(a + "trackchange");
      }, u = i[s.getterName]();
      u.addEventListener("removetrack", o), u.addEventListener("addtrack", o), i.on("dispose", function() {
        u.removeEventListener("removetrack", o), u.removeEventListener("addtrack", o);
      });
    });
  }, r.addWebVttScript_ = function() {
    var i = this;
    if (!M.WebVTT)
      if (oe.body.contains(this.el())) {
        if (!this.options_["vtt.js"] && Ls(Qo) && Object.keys(Qo).length > 0) {
          this.trigger("vttjsloaded");
          return;
        }
        var a = oe.createElement("script");
        a.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", a.onload = function() {
          i.trigger("vttjsloaded");
        }, a.onerror = function() {
          i.trigger("vttjserror");
        }, this.on("dispose", function() {
          a.onload = null, a.onerror = null;
        }), M.WebVTT = !0, this.el().parentNode.appendChild(a);
      } else
        this.ready(this.addWebVttScript_);
  }, r.emulateTextTracks = function() {
    var i = this, a = this.textTracks(), s = this.remoteTextTracks(), o = function(f) {
      return a.addTrack(f.track);
    }, u = function(f) {
      return a.removeTrack(f.track);
    };
    s.on("addtrack", o), s.on("removetrack", u), this.addWebVttScript_();
    var l = function() {
      return i.trigger("texttrackchange");
    }, d = function() {
      l();
      for (var f = 0; f < a.length; f++) {
        var v = a[f];
        v.removeEventListener("cuechange", l), v.mode === "showing" && v.addEventListener("cuechange", l);
      }
    };
    d(), a.addEventListener("change", d), a.addEventListener("addtrack", d), a.addEventListener("removetrack", d), this.on("dispose", function() {
      s.off("addtrack", o), s.off("removetrack", u), a.removeEventListener("change", d), a.removeEventListener("addtrack", d), a.removeEventListener("removetrack", d);
      for (var h = 0; h < a.length; h++) {
        var f = a[h];
        f.removeEventListener("cuechange", l);
      }
    });
  }, r.addTextTrack = function(i, a, s) {
    if (!i)
      throw new Error("TextTrack kind is required but was not provided");
    return Jx(this, i, a, s);
  }, r.createRemoteTextTrack = function(i) {
    var a = mt(i, {
      tech: this
    });
    return new Pa.remoteTextEl.TrackClass(a);
  }, r.addRemoteTextTrack = function(i, a) {
    var s = this;
    i === void 0 && (i = {});
    var o = this.createRemoteTextTrack(i);
    return a !== !0 && a !== !1 && (Fe.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js'), a = !0), this.remoteTextTrackEls().addTrackElement_(o), this.remoteTextTracks().addTrack(o.track), a !== !0 && this.ready(function() {
      return s.autoRemoteTextTracks_.addTrack(o.track);
    }), o;
  }, r.removeRemoteTextTrack = function(i) {
    var a = this.remoteTextTrackEls().getTrackElementByTrack_(i);
    this.remoteTextTrackEls().removeTrackElement_(a), this.remoteTextTracks().removeTrack(i), this.autoRemoteTextTracks_.removeTrack(i);
  }, r.getVideoPlaybackQuality = function() {
    return {};
  }, r.requestPictureInPicture = function() {
    var i = this.options_.Promise || M.Promise;
    if (i)
      return i.reject();
  }, r.disablePictureInPicture = function() {
    return !0;
  }, r.setDisablePictureInPicture = function() {
  }, r.requestVideoFrameCallback = function(i) {
    var a = this, s = Nr();
    return !this.isReady_ || this.paused() ? (this.queuedHanders_.add(s), this.one("playing", function() {
      a.queuedHanders_.has(s) && (a.queuedHanders_.delete(s), i());
    })) : this.requestNamedAnimationFrame(s, i), s;
  }, r.cancelVideoFrameCallback = function(i) {
    this.queuedHanders_.has(i) ? this.queuedHanders_.delete(i) : this.cancelNamedAnimationFrame(i);
  }, r.setPoster = function() {
  }, r.playsinline = function() {
  }, r.setPlaysinline = function() {
  }, r.overrideNativeAudioTracks = function() {
  }, r.overrideNativeVideoTracks = function() {
  }, r.canPlayType = function() {
    return "";
  }, e.canPlayType = function() {
    return "";
  }, e.canPlaySource = function(i, a) {
    return e.canPlayType(i.type);
  }, e.isTech = function(i) {
    return i.prototype instanceof e || i instanceof e || i === e;
  }, e.registerTech = function(i, a) {
    if (e.techs_ || (e.techs_ = {}), !e.isTech(a))
      throw new Error("Tech " + i + " must be a Tech");
    if (!e.canPlayType)
      throw new Error("Techs must have a static canPlayType method on them");
    if (!e.canPlaySource)
      throw new Error("Techs must have a static canPlaySource method on them");
    return i = It(i), e.techs_[i] = a, e.techs_[jo(i)] = a, i !== "Tech" && e.defaultTechOrder_.push(i), a;
  }, e.getTech = function(i) {
    if (i) {
      if (e.techs_ && e.techs_[i])
        return e.techs_[i];
      if (i = It(i), M && M.videojs && M.videojs[i])
        return Fe.warn("The " + i + " tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)"), M.videojs[i];
    }
  }, e;
}(ee);
ri.names.forEach(function(t) {
  var e = ri[t];
  ot.prototype[e.getterName] = function() {
    return this[e.privateName] = this[e.privateName] || new e.ListClass(), this[e.privateName];
  };
});
ot.prototype.featuresVolumeControl = !0;
ot.prototype.featuresMuteControl = !0;
ot.prototype.featuresFullscreenResize = !1;
ot.prototype.featuresPlaybackRate = !1;
ot.prototype.featuresProgressEvents = !1;
ot.prototype.featuresSourceset = !1;
ot.prototype.featuresTimeupdateEvents = !1;
ot.prototype.featuresNativeTextTracks = !1;
ot.prototype.featuresVideoFrameCallback = !1;
ot.withSourceHandlers = function(t) {
  t.registerSourceHandler = function(r, n) {
    var i = t.sourceHandlers;
    i || (i = t.sourceHandlers = []), n === void 0 && (n = i.length), i.splice(n, 0, r);
  }, t.canPlayType = function(r) {
    for (var n = t.sourceHandlers || [], i, a = 0; a < n.length; a++)
      if (i = n[a].canPlayType(r), i)
        return i;
    return "";
  }, t.selectSourceHandler = function(r, n) {
    for (var i = t.sourceHandlers || [], a, s = 0; s < i.length; s++)
      if (a = i[s].canHandleSource(r, n), a)
        return i[s];
    return null;
  }, t.canPlaySource = function(r, n) {
    var i = t.selectSourceHandler(r, n);
    return i ? i.canHandleSource(r, n) : "";
  };
  var e = ["seekable", "seeking", "duration"];
  e.forEach(function(r) {
    var n = this[r];
    typeof n == "function" && (this[r] = function() {
      return this.sourceHandler_ && this.sourceHandler_[r] ? this.sourceHandler_[r].apply(this.sourceHandler_, arguments) : n.apply(this, arguments);
    });
  }, t.prototype), t.prototype.setSource = function(r) {
    var n = t.selectSourceHandler(r, this.options_);
    n || (t.nativeSourceHandler ? n = t.nativeSourceHandler : Fe.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler_), n !== t.nativeSourceHandler && (this.currentSource_ = r), this.sourceHandler_ = n.handleSource(r, this, this.options_), this.one("dispose", this.disposeSourceHandler_);
  }, t.prototype.disposeSourceHandler = function() {
    this.currentSource_ && (this.clearTracks(["audio", "video"]), this.currentSource_ = null), this.cleanupAutoTextTracks(), this.sourceHandler_ && (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), this.sourceHandler_ = null);
  };
};
ee.registerComponent("Tech", ot);
ot.registerTech("Tech", ot);
ot.defaultTechOrder_ = [];
var Sn = {}, bc = {}, ou = {};
function Zx(t, e) {
  Sn[t] = Sn[t] || [], Sn[t].push(e);
}
function eC(t, e, r) {
  t.setTimeout(function() {
    return fn(e, Sn[e.type], r, t);
  }, 1);
}
function tC(t, e) {
  t.forEach(function(r) {
    return r.setTech && r.setTech(e);
  });
}
function iC(t, e, r) {
  return t.reduceRight(Mh(r), e[r]());
}
function rC(t, e, r, n) {
  return e[r](t.reduce(Mh(r), n));
}
function Up(t, e, r, n) {
  n === void 0 && (n = null);
  var i = "call" + It(r), a = t.reduce(Mh(i), n), s = a === ou, o = s ? null : e[r](a);
  return sC(t, r, o, s), o;
}
var nC = {
  buffered: 1,
  currentTime: 1,
  duration: 1,
  muted: 1,
  played: 1,
  paused: 1,
  seekable: 1,
  volume: 1,
  ended: 1
}, aC = {
  setCurrentTime: 1,
  setMuted: 1,
  setVolume: 1
}, Vp = {
  play: 1,
  pause: 1
};
function Mh(t) {
  return function(e, r) {
    return e === ou ? ou : r[t] ? r[t](e) : e;
  };
}
function sC(t, e, r, n) {
  for (var i = t.length - 1; i >= 0; i--) {
    var a = t[i];
    a[e] && a[e](n, r);
  }
}
function oC(t) {
  bc[t.id()] = null;
}
function uC(t, e) {
  var r = bc[t.id()], n = null;
  if (r == null)
    return n = e(t), bc[t.id()] = [[e, n]], n;
  for (var i = 0; i < r.length; i++) {
    var a = r[i], s = a[0], o = a[1];
    s === e && (n = o);
  }
  return n === null && (n = e(t), r.push([e, n])), n;
}
function fn(t, e, r, n, i, a) {
  t === void 0 && (t = {}), e === void 0 && (e = []), i === void 0 && (i = []), a === void 0 && (a = !1);
  var s = e, o = s[0], u = s.slice(1);
  if (typeof o == "string")
    fn(t, Sn[o], r, n, i, a);
  else if (o) {
    var l = uC(n, o);
    if (!l.setSource)
      return i.push(l), fn(t, u, r, n, i, a);
    l.setSource(At({}, t), function(d, h) {
      if (d)
        return fn(t, u, r, n, i, a);
      i.push(l), fn(h, t.type === h.type ? u : Sn[h.type], r, n, i, a);
    });
  } else
    u.length ? fn(t, u, r, n, i, a) : a ? r(t, i) : fn(t, Sn["*"], r, n, i, !0);
}
var lC = {
  opus: "video/ogg",
  ogv: "video/ogg",
  mp4: "video/mp4",
  mov: "video/mp4",
  m4v: "video/mp4",
  mkv: "video/x-matroska",
  m4a: "audio/mp4",
  mp3: "audio/mpeg",
  aac: "audio/aac",
  caf: "audio/x-caf",
  flac: "audio/flac",
  oga: "audio/ogg",
  wav: "audio/wav",
  m3u8: "application/x-mpegURL",
  mpd: "application/dash+xml",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  png: "image/png",
  svg: "image/svg+xml",
  webp: "image/webp"
}, uu = function(e) {
  e === void 0 && (e = "");
  var r = Oh(e), n = lC[r.toLowerCase()];
  return n || "";
}, dC = function(e, r) {
  if (!r)
    return "";
  if (e.cache_.source.src === r && e.cache_.source.type)
    return e.cache_.source.type;
  var n = e.cache_.sources.filter(function(o) {
    return o.src === r;
  });
  if (n.length)
    return n[0].type;
  for (var i = e.$$("source"), a = 0; a < i.length; a++) {
    var s = i[a];
    if (s.type && s.src && s.src === r)
      return s.type;
  }
  return uu(r);
}, cC = function t(e) {
  if (Array.isArray(e)) {
    var r = [];
    e.forEach(function(n) {
      n = t(n), Array.isArray(n) ? r = r.concat(n) : Lr(n) && r.push(n);
    }), e = r;
  } else
    typeof e == "string" && e.trim() ? e = [jp({
      src: e
    })] : Lr(e) && typeof e.src == "string" && e.src && e.src.trim() ? e = [jp(e)] : e = [];
  return e;
};
function jp(t) {
  if (!t.type) {
    var e = uu(t.src);
    e && (t.type = e);
  }
  return t;
}
var hC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(r, n, i) {
    var a, s = mt({
      createEl: !1
    }, n);
    if (a = t.call(this, r, s, i) || this, !n.playerOptions.sources || n.playerOptions.sources.length === 0)
      for (var o = 0, u = n.playerOptions.techOrder; o < u.length; o++) {
        var l = It(u[o]), d = ot.getTech(l);
        if (l || (d = ee.getComponent(l)), d && d.isSupported()) {
          r.loadTech_(l);
          break;
        }
      }
    else
      r.src(n.playerOptions.sources);
    return a;
  }
  return e;
}(ee);
ee.registerComponent("MediaLoader", hC);
var Xu = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.options_.controlText && a.controlText(a.options_.controlText), a.handleMouseOver_ = function(s) {
      return a.handleMouseOver(s);
    }, a.handleMouseOut_ = function(s) {
      return a.handleMouseOut(s);
    }, a.handleClick_ = function(s) {
      return a.handleClick(s);
    }, a.handleKeyDown_ = function(s) {
      return a.handleKeyDown(s);
    }, a.emitTapEvents(), a.enable(), a;
  }
  var r = e.prototype;
  return r.createEl = function(i, a, s) {
    i === void 0 && (i = "div"), a === void 0 && (a = {}), s === void 0 && (s = {}), a = At({
      className: this.buildCSSClass(),
      tabIndex: 0
    }, a), i === "button" && Fe.error("Creating a ClickableComponent with an HTML element of " + i + " is not supported; use a Button instead."), s = At({
      role: "button"
    }, s), this.tabIndex_ = a.tabIndex;
    var o = Ge(i, a, s);
    return o.appendChild(Ge("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(o), o;
  }, r.dispose = function() {
    this.controlTextEl_ = null, t.prototype.dispose.call(this);
  }, r.createControlTextEl = function(i) {
    return this.controlTextEl_ = Ge("span", {
      className: "vjs-control-text"
    }, {
      // let the screen reader user know that the text of the element may change
      "aria-live": "polite"
    }), i && i.appendChild(this.controlTextEl_), this.controlText(this.controlText_, i), this.controlTextEl_;
  }, r.controlText = function(i, a) {
    if (a === void 0 && (a = this.el()), i === void 0)
      return this.controlText_ || "Need Text";
    var s = this.localize(i);
    this.controlText_ = i, Pn(this.controlTextEl_, s), !this.nonIconControl && !this.player_.options_.noUITitleAttributes && a.setAttribute("title", s);
  }, r.buildCSSClass = function() {
    return "vjs-control vjs-button " + t.prototype.buildCSSClass.call(this);
  }, r.enable = function() {
    this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), typeof this.tabIndex_ < "u" && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick_), this.on("keydown", this.handleKeyDown_));
  }, r.disable = function() {
    this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), typeof this.tabIndex_ < "u" && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver_), this.off("mouseout", this.handleMouseOut_), this.off(["tap", "click"], this.handleClick_), this.off("keydown", this.handleKeyDown_);
  }, r.handleLanguagechange = function() {
    this.controlText(this.controlText_);
  }, r.handleClick = function(i) {
    this.options_.clickHandler && this.options_.clickHandler.call(this, arguments);
  }, r.handleKeyDown = function(i) {
    De.isEventKey(i, "Space") || De.isEventKey(i, "Enter") ? (i.preventDefault(), i.stopPropagation(), this.trigger("click")) : t.prototype.handleKeyDown.call(this, i);
  }, e;
}(ee);
ee.registerComponent("ClickableComponent", Xu);
var fC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.update(), a.update_ = function(s) {
      return a.update(s);
    }, n.on("posterchange", a.update_), a;
  }
  var r = e.prototype;
  return r.dispose = function() {
    this.player().off("posterchange", this.update_), t.prototype.dispose.call(this);
  }, r.createEl = function() {
    var i = Ge("div", {
      className: "vjs-poster",
      // Don't want poster to be tabbable.
      tabIndex: -1
    });
    return i;
  }, r.update = function(i) {
    var a = this.player().poster();
    this.setSrc(a), a ? this.show() : this.hide();
  }, r.setSrc = function(i) {
    var a = "";
    i && (a = 'url("' + i + '")'), this.el_.style.backgroundImage = a;
  }, r.handleClick = function(i) {
    if (this.player_.controls()) {
      var a = this.player_.usingPlugin("eme") && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
      this.player_.tech(!0) && // We've observed a bug in IE and Edge when playing back DRM content where
      // calling .focus() on the video element causes the video to go black,
      // so we avoid it in that specific case
      !((zs || $s) && a) && this.player_.tech(!0).focus(), this.player_.paused() ? er(this.player_.play()) : this.player_.pause();
    }
  }, e;
}(Xu);
ee.registerComponent("PosterImage", fC);
var Ai = "#222", Hp = "#ccc", pC = {
  monospace: "monospace",
  sansSerif: "sans-serif",
  serif: "serif",
  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
  monospaceSerif: '"Courier New", monospace',
  proportionalSansSerif: "sans-serif",
  proportionalSerif: "serif",
  casual: '"Comic Sans MS", Impact, fantasy',
  script: '"Monotype Corsiva", cursive',
  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};
function Fl(t, e) {
  var r;
  if (t.length === 4)
    r = t[1] + t[1] + t[2] + t[2] + t[3] + t[3];
  else if (t.length === 7)
    r = t.slice(1);
  else
    throw new Error("Invalid color code provided, " + t + "; must be formatted as e.g. #f0e or #f604e2.");
  return "rgba(" + parseInt(r.slice(0, 2), 16) + "," + parseInt(r.slice(2, 4), 16) + "," + parseInt(r.slice(4, 6), 16) + "," + e + ")";
}
function Ul(t, e, r) {
  try {
    t.style[e] = r;
  } catch {
    return;
  }
}
var gC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i, a) {
    var s;
    s = t.call(this, n, i, a) || this;
    var o = function(l) {
      return s.updateDisplay(l);
    };
    return n.on("loadstart", function(u) {
      return s.toggleDisplay(u);
    }), n.on("texttrackchange", o), n.on("loadedmetadata", function(u) {
      return s.preselectTrack(u);
    }), n.ready(vt(Le(s), function() {
      if (n.tech_ && n.tech_.featuresNativeTextTracks) {
        this.hide();
        return;
      }
      n.on("fullscreenchange", o), n.on("playerresize", o), M.addEventListener("orientationchange", o), n.on("dispose", function() {
        return M.removeEventListener("orientationchange", o);
      });
      for (var u = this.options_.playerOptions.tracks || [], l = 0; l < u.length; l++)
        this.player_.addRemoteTextTrack(u[l], !0);
      this.preselectTrack();
    })), s;
  }
  var r = e.prototype;
  return r.preselectTrack = function() {
    for (var i = {
      captions: 1,
      subtitles: 1
    }, a = this.player_.textTracks(), s = this.player_.cache_.selectedLanguage, o, u, l, d = 0; d < a.length; d++) {
      var h = a[d];
      s && s.enabled && s.language && s.language === h.language && h.kind in i ? h.kind === s.kind ? l = h : l || (l = h) : s && !s.enabled ? (l = null, o = null, u = null) : h.default && (h.kind === "descriptions" && !o ? o = h : h.kind in i && !u && (u = h));
    }
    l ? l.mode = "showing" : u ? u.mode = "showing" : o && (o.mode = "showing");
  }, r.toggleDisplay = function() {
    this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show();
  }, r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: "vjs-text-track-display"
    }, {
      translate: "yes",
      "aria-live": "off",
      "aria-atomic": "true"
    });
  }, r.clearDisplay = function() {
    typeof M.WebVTT == "function" && M.WebVTT.processCues(M, [], this.el_);
  }, r.updateDisplay = function() {
    var i = this.player_.textTracks(), a = this.options_.allowMultipleShowingTracks;
    if (this.clearDisplay(), a) {
      for (var s = [], o = 0; o < i.length; ++o) {
        var u = i[o];
        u.mode === "showing" && s.push(u);
      }
      this.updateForTrack(s);
      return;
    }
    for (var l = null, d = null, h = i.length; h--; ) {
      var f = i[h];
      f.mode === "showing" && (f.kind === "descriptions" ? l = f : d = f);
    }
    d ? (this.getAttribute("aria-live") !== "off" && this.setAttribute("aria-live", "off"), this.updateForTrack(d)) : l && (this.getAttribute("aria-live") !== "assertive" && this.setAttribute("aria-live", "assertive"), this.updateForTrack(l));
  }, r.updateDisplayState = function(i) {
    for (var a = this.player_.textTrackSettings.getValues(), s = i.activeCues, o = s.length; o--; ) {
      var u = s[o];
      if (u) {
        var l = u.displayState;
        if (a.color && (l.firstChild.style.color = a.color), a.textOpacity && Ul(l.firstChild, "color", Fl(a.color || "#fff", a.textOpacity)), a.backgroundColor && (l.firstChild.style.backgroundColor = a.backgroundColor), a.backgroundOpacity && Ul(l.firstChild, "backgroundColor", Fl(a.backgroundColor || "#000", a.backgroundOpacity)), a.windowColor && (a.windowOpacity ? Ul(l, "backgroundColor", Fl(a.windowColor, a.windowOpacity)) : l.style.backgroundColor = a.windowColor), a.edgeStyle && (a.edgeStyle === "dropshadow" ? l.firstChild.style.textShadow = "2px 2px 3px " + Ai + ", 2px 2px 4px " + Ai + ", 2px 2px 5px " + Ai : a.edgeStyle === "raised" ? l.firstChild.style.textShadow = "1px 1px " + Ai + ", 2px 2px " + Ai + ", 3px 3px " + Ai : a.edgeStyle === "depressed" ? l.firstChild.style.textShadow = "1px 1px " + Hp + ", 0 1px " + Hp + ", -1px -1px " + Ai + ", 0 -1px " + Ai : a.edgeStyle === "uniform" && (l.firstChild.style.textShadow = "0 0 4px " + Ai + ", 0 0 4px " + Ai + ", 0 0 4px " + Ai + ", 0 0 4px " + Ai)), a.fontPercent && a.fontPercent !== 1) {
          var d = M.parseFloat(l.style.fontSize);
          l.style.fontSize = d * a.fontPercent + "px", l.style.height = "auto", l.style.top = "auto";
        }
        a.fontFamily && a.fontFamily !== "default" && (a.fontFamily === "small-caps" ? l.firstChild.style.fontVariant = "small-caps" : l.firstChild.style.fontFamily = pC[a.fontFamily]);
      }
    }
  }, r.updateForTrack = function(i) {
    if (Array.isArray(i) || (i = [i]), !(typeof M.WebVTT != "function" || i.every(function(v) {
      return !v.activeCues;
    }))) {
      for (var a = [], s = 0; s < i.length; ++s)
        for (var o = i[s], u = 0; u < o.activeCues.length; ++u)
          a.push(o.activeCues[u]);
      M.WebVTT.processCues(M, a, this.el_);
      for (var l = 0; l < i.length; ++l) {
        for (var d = i[l], h = 0; h < d.activeCues.length; ++h) {
          var f = d.activeCues[h].displayState;
          Cr(f, "vjs-text-track-cue"), Cr(f, "vjs-text-track-cue-" + (d.language ? d.language : l)), d.language && Ca(f, "lang", d.language);
        }
        this.player_.textTrackSettings && this.updateDisplayState(d);
      }
    }
  }, e;
}(ee);
ee.registerComponent("TextTrackDisplay", gC);
var mC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var r = e.prototype;
  return r.createEl = function() {
    var i = this.player_.isAudio(), a = this.localize(i ? "Audio Player" : "Video Player"), s = Ge("span", {
      className: "vjs-control-text",
      textContent: this.localize("{1} is loading.", [a])
    }), o = t.prototype.createEl.call(this, "div", {
      className: "vjs-loading-spinner",
      dir: "ltr"
    });
    return o.appendChild(s), o;
  }, e;
}(ee);
ee.registerComponent("LoadingSpinner", mC);
var Ui = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var r = e.prototype;
  return r.createEl = function(i, a, s) {
    a === void 0 && (a = {}), s === void 0 && (s = {}), i = "button", a = At({
      className: this.buildCSSClass()
    }, a), s = At({
      // Necessary since the default button type is "submit"
      type: "button"
    }, s);
    var o = Ge(i, a, s);
    return o.appendChild(Ge("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), this.createControlTextEl(o), o;
  }, r.addChild = function(i, a) {
    a === void 0 && (a = {});
    var s = this.constructor.name;
    return Fe.warn("Adding an actionable (user controllable) child to a Button (" + s + ") is not supported; use a ClickableComponent instead."), ee.prototype.addChild.call(this, i, a);
  }, r.enable = function() {
    t.prototype.enable.call(this), this.el_.removeAttribute("disabled");
  }, r.disable = function() {
    t.prototype.disable.call(this), this.el_.setAttribute("disabled", "disabled");
  }, r.handleKeyDown = function(i) {
    if (De.isEventKey(i, "Space") || De.isEventKey(i, "Enter")) {
      i.stopPropagation();
      return;
    }
    t.prototype.handleKeyDown.call(this, i);
  }, e;
}(Xu);
ee.registerComponent("Button", Ui);
var qy = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.mouseused_ = !1, a.on("mousedown", function(s) {
      return a.handleMouseDown(s);
    }), a;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-big-play-button";
  }, r.handleClick = function(i) {
    var a = this.player_.play();
    if (this.mouseused_ && i.clientX && i.clientY) {
      var s = this.player_.usingPlugin("eme") && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
      er(a), this.player_.tech(!0) && // We've observed a bug in IE and Edge when playing back DRM content where
      // calling .focus() on the video element causes the video to go black,
      // so we avoid it in that specific case
      !((zs || $s) && s) && this.player_.tech(!0).focus();
      return;
    }
    var o = this.player_.getChild("controlBar"), u = o && o.getChild("playToggle");
    if (!u) {
      this.player_.tech(!0).focus();
      return;
    }
    var l = function() {
      return u.focus();
    };
    Ts(a) ? a.then(l, function() {
    }) : this.setTimeout(l, 1);
  }, r.handleKeyDown = function(i) {
    this.mouseused_ = !1, t.prototype.handleKeyDown.call(this, i);
  }, r.handleMouseDown = function(i) {
    this.mouseused_ = !0;
  }, e;
}(Ui);
qy.prototype.controlText_ = "Play Video";
ee.registerComponent("BigPlayButton", qy);
var vC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.controlText(i && i.controlText || a.localize("Close")), a;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-close-button " + t.prototype.buildCSSClass.call(this);
  }, r.handleClick = function(i) {
    this.trigger({
      type: "close",
      bubbles: !1
    });
  }, r.handleKeyDown = function(i) {
    De.isEventKey(i, "Esc") ? (i.preventDefault(), i.stopPropagation(), this.trigger("click")) : t.prototype.handleKeyDown.call(this, i);
  }, e;
}(Ui);
ee.registerComponent("CloseButton", vC);
var $y = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return i === void 0 && (i = {}), a = t.call(this, n, i) || this, i.replay = i.replay === void 0 || i.replay, a.on(n, "play", function(s) {
      return a.handlePlay(s);
    }), a.on(n, "pause", function(s) {
      return a.handlePause(s);
    }), i.replay && a.on(n, "ended", function(s) {
      return a.handleEnded(s);
    }), a;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-play-control " + t.prototype.buildCSSClass.call(this);
  }, r.handleClick = function(i) {
    this.player_.paused() ? er(this.player_.play()) : this.player_.pause();
  }, r.handleSeeked = function(i) {
    this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(i) : this.handlePlay(i);
  }, r.handlePlay = function(i) {
    this.removeClass("vjs-ended"), this.removeClass("vjs-paused"), this.addClass("vjs-playing"), this.controlText("Pause");
  }, r.handlePause = function(i) {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.controlText("Play");
  }, r.handleEnded = function(i) {
    var a = this;
    this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.controlText("Replay"), this.one(this.player_, "seeked", function(s) {
      return a.handleSeeked(s);
    });
  }, e;
}(Ui);
$y.prototype.controlText_ = "Play";
ee.registerComponent("PlayToggle", $y);
var zy = function(e, r) {
  e = e < 0 ? 0 : e;
  var n = Math.floor(e % 60), i = Math.floor(e / 60 % 60), a = Math.floor(e / 3600), s = Math.floor(r / 60 % 60), o = Math.floor(r / 3600);
  return (isNaN(e) || e === 1 / 0) && (a = i = n = "-"), a = a > 0 || o > 0 ? a + ":" : "", i = ((a || s >= 10) && i < 10 ? "0" + i : i) + ":", n = n < 10 ? "0" + n : n, a + i + n;
}, Nh = zy;
function yC(t) {
  Nh = t;
}
function _C() {
  Nh = zy;
}
function ka(t, e) {
  return e === void 0 && (e = t), Nh(t, e);
}
var Ua = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.on(n, ["timeupdate", "ended"], function(s) {
      return a.updateContent(s);
    }), a.updateTextNode_(), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    var i = this.buildCSSClass(), a = t.prototype.createEl.call(this, "div", {
      className: i + " vjs-time-control vjs-control"
    }), s = Ge("span", {
      className: "vjs-control-text",
      textContent: this.localize(this.labelText_) + " "
    }, {
      role: "presentation"
    });
    return a.appendChild(s), this.contentEl_ = Ge("span", {
      className: i + "-display"
    }, {
      // tell screen readers not to automatically read the time as it changes
      "aria-live": "off",
      // span elements have no implicit role, but some screen readers (notably VoiceOver)
      // treat them as a break between items in the DOM when using arrow keys
      // (or left-to-right swipes on iOS) to read contents of a page. Using
      // role='presentation' causes VoiceOver to NOT treat this span as a break.
      role: "presentation"
    }), a.appendChild(this.contentEl_), a;
  }, r.dispose = function() {
    this.contentEl_ = null, this.textNode_ = null, t.prototype.dispose.call(this);
  }, r.updateTextNode_ = function(i) {
    var a = this;
    i === void 0 && (i = 0), i = ka(i), this.formattedTime_ !== i && (this.formattedTime_ = i, this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", function() {
      if (a.contentEl_) {
        var s = a.textNode_;
        s && a.contentEl_.firstChild !== s && (s = null, Fe.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.")), a.textNode_ = oe.createTextNode(a.formattedTime_), a.textNode_ && (s ? a.contentEl_.replaceChild(a.textNode_, s) : a.contentEl_.appendChild(a.textNode_));
      }
    }));
  }, r.updateContent = function(i) {
  }, e;
}(ee);
Ua.prototype.labelText_ = "Time";
Ua.prototype.controlText_ = "Time";
ee.registerComponent("TimeDisplay", Ua);
var Bh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-current-time";
  }, r.updateContent = function(i) {
    var a;
    this.player_.ended() ? a = this.player_.duration() : a = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime(), this.updateTextNode_(a);
  }, e;
}(Ua);
Bh.prototype.labelText_ = "Current Time";
Bh.prototype.controlText_ = "Current Time";
ee.registerComponent("CurrentTimeDisplay", Bh);
var Fh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    a = t.call(this, n, i) || this;
    var s = function(u) {
      return a.updateContent(u);
    };
    return a.on(n, "durationchange", s), a.on(n, "loadstart", s), a.on(n, "loadedmetadata", s), a;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-duration";
  }, r.updateContent = function(i) {
    var a = this.player_.duration();
    this.updateTextNode_(a);
  }, e;
}(Ua);
Fh.prototype.labelText_ = "Duration";
Fh.prototype.controlText_ = "Duration";
ee.registerComponent("DurationDisplay", Fh);
var TC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var r = e.prototype;
  return r.createEl = function() {
    var i = t.prototype.createEl.call(this, "div", {
      className: "vjs-time-control vjs-time-divider"
    }, {
      // this element and its contents can be hidden from assistive techs since
      // it is made extraneous by the announcement of the control text
      // for the current time and duration displays
      "aria-hidden": !0
    }), a = t.prototype.createEl.call(this, "div"), s = t.prototype.createEl.call(this, "span", {
      textContent: "/"
    });
    return a.appendChild(s), i.appendChild(a), i;
  }, e;
}(ee);
ee.registerComponent("TimeDivider", TC);
var Uh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.on(n, "durationchange", function(s) {
      return a.updateContent(s);
    }), a;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-remaining-time";
  }, r.createEl = function() {
    var i = t.prototype.createEl.call(this);
    return this.options_.displayNegative !== !1 && i.insertBefore(Ge("span", {}, {
      "aria-hidden": !0
    }, "-"), this.contentEl_), i;
  }, r.updateContent = function(i) {
    if (typeof this.player_.duration() == "number") {
      var a;
      this.player_.ended() ? a = 0 : this.player_.remainingTimeDisplay ? a = this.player_.remainingTimeDisplay() : a = this.player_.remainingTime(), this.updateTextNode_(a);
    }
  }, e;
}(Ua);
Uh.prototype.labelText_ = "Remaining Time";
Uh.prototype.controlText_ = "Remaining Time";
ee.registerComponent("RemainingTimeDisplay", Uh);
var bC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.updateShowing(), a.on(a.player(), "durationchange", function(s) {
      return a.updateShowing(s);
    }), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    var i = t.prototype.createEl.call(this, "div", {
      className: "vjs-live-control vjs-control"
    });
    return this.contentEl_ = Ge("div", {
      className: "vjs-live-display"
    }, {
      "aria-live": "off"
    }), this.contentEl_.appendChild(Ge("span", {
      className: "vjs-control-text",
      textContent: this.localize("Stream Type") + " "
    })), this.contentEl_.appendChild(oe.createTextNode(this.localize("LIVE"))), i.appendChild(this.contentEl_), i;
  }, r.dispose = function() {
    this.contentEl_ = null, t.prototype.dispose.call(this);
  }, r.updateShowing = function(i) {
    this.player().duration() === 1 / 0 ? this.show() : this.hide();
  }, e;
}(ee);
ee.registerComponent("LiveDisplay", bC);
var Gy = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.updateLiveEdgeStatus(), a.player_.liveTracker && (a.updateLiveEdgeStatusHandler_ = function(s) {
      return a.updateLiveEdgeStatus(s);
    }, a.on(a.player_.liveTracker, "liveedgechange", a.updateLiveEdgeStatusHandler_)), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    var i = t.prototype.createEl.call(this, "button", {
      className: "vjs-seek-to-live-control vjs-control"
    });
    return this.textEl_ = Ge("span", {
      className: "vjs-seek-to-live-text",
      textContent: this.localize("LIVE")
    }, {
      "aria-hidden": "true"
    }), i.appendChild(this.textEl_), i;
  }, r.updateLiveEdgeStatus = function() {
    !this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"));
  }, r.handleClick = function() {
    this.player_.liveTracker.seekToLiveEdge();
  }, r.dispose = function() {
    this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_), this.textEl_ = null, t.prototype.dispose.call(this);
  }, e;
}(Ui);
Gy.prototype.controlText_ = "Seek to live, currently playing live";
ee.registerComponent("SeekToLive", Gy);
var Yu = function(e, r, n) {
  return e = Number(e), Math.min(n, Math.max(r, isNaN(e) ? r : e));
}, Vh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.handleMouseDown_ = function(s) {
      return a.handleMouseDown(s);
    }, a.handleMouseUp_ = function(s) {
      return a.handleMouseUp(s);
    }, a.handleKeyDown_ = function(s) {
      return a.handleKeyDown(s);
    }, a.handleClick_ = function(s) {
      return a.handleClick(s);
    }, a.handleMouseMove_ = function(s) {
      return a.handleMouseMove(s);
    }, a.update_ = function(s) {
      return a.update(s);
    }, a.bar = a.getChild(a.options_.barName), a.vertical(!!a.options_.vertical), a.enable(), a;
  }
  var r = e.prototype;
  return r.enabled = function() {
    return this.enabled_;
  }, r.enable = function() {
    this.enabled() || (this.on("mousedown", this.handleMouseDown_), this.on("touchstart", this.handleMouseDown_), this.on("keydown", this.handleKeyDown_), this.on("click", this.handleClick_), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0);
  }, r.disable = function() {
    if (this.enabled()) {
      var i = this.bar.el_.ownerDocument;
      this.off("mousedown", this.handleMouseDown_), this.off("touchstart", this.handleMouseDown_), this.off("keydown", this.handleKeyDown_), this.off("click", this.handleClick_), this.off(this.player_, "controlsvisible", this.update_), this.off(i, "mousemove", this.handleMouseMove_), this.off(i, "mouseup", this.handleMouseUp_), this.off(i, "touchmove", this.handleMouseMove_), this.off(i, "touchend", this.handleMouseUp_), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1;
    }
  }, r.createEl = function(i, a, s) {
    return a === void 0 && (a = {}), s === void 0 && (s = {}), a.className = a.className + " vjs-slider", a = At({
      tabIndex: 0
    }, a), s = At({
      role: "slider",
      "aria-valuenow": 0,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      tabIndex: 0
    }, s), t.prototype.createEl.call(this, i, a, s);
  }, r.handleMouseDown = function(i) {
    var a = this.bar.el_.ownerDocument;
    i.type === "mousedown" && i.preventDefault(), i.type === "touchstart" && !Mr && i.preventDefault(), Sy(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(a, "mousemove", this.handleMouseMove_), this.on(a, "mouseup", this.handleMouseUp_), this.on(a, "touchmove", this.handleMouseMove_), this.on(a, "touchend", this.handleMouseUp_), this.handleMouseMove(i, !0);
  }, r.handleMouseMove = function(i) {
  }, r.handleMouseUp = function() {
    var i = this.bar.el_.ownerDocument;
    Ey(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(i, "mousemove", this.handleMouseMove_), this.off(i, "mouseup", this.handleMouseUp_), this.off(i, "touchmove", this.handleMouseMove_), this.off(i, "touchend", this.handleMouseUp_), this.update();
  }, r.update = function() {
    var i = this;
    if (!(!this.el_ || !this.bar)) {
      var a = this.getProgress();
      return a === this.progress_ || (this.progress_ = a, this.requestNamedAnimationFrame("Slider#update", function() {
        var s = i.vertical() ? "height" : "width";
        i.bar.el().style[s] = (a * 100).toFixed(2) + "%";
      })), a;
    }
  }, r.getProgress = function() {
    return Number(Yu(this.getPercent(), 0, 1).toFixed(4));
  }, r.calculateDistance = function(i) {
    var a = qu(this.el_, i);
    return this.vertical() ? a.y : a.x;
  }, r.handleKeyDown = function(i) {
    De.isEventKey(i, "Left") || De.isEventKey(i, "Down") ? (i.preventDefault(), i.stopPropagation(), this.stepBack()) : De.isEventKey(i, "Right") || De.isEventKey(i, "Up") ? (i.preventDefault(), i.stopPropagation(), this.stepForward()) : t.prototype.handleKeyDown.call(this, i);
  }, r.handleClick = function(i) {
    i.stopPropagation(), i.preventDefault();
  }, r.vertical = function(i) {
    if (i === void 0)
      return this.vertical_ || !1;
    this.vertical_ = !!i, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal");
  }, e;
}(ee);
ee.registerComponent("Slider", Vh);
var Vl = function(e, r) {
  return Yu(e / r * 100, 0, 100).toFixed(2) + "%";
}, SC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.partEls_ = [], a.on(n, "progress", function(s) {
      return a.update(s);
    }), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    var i = t.prototype.createEl.call(this, "div", {
      className: "vjs-load-progress"
    }), a = Ge("span", {
      className: "vjs-control-text"
    }), s = Ge("span", {
      textContent: this.localize("Loaded")
    }), o = oe.createTextNode(": ");
    return this.percentageEl_ = Ge("span", {
      className: "vjs-control-text-loaded-percentage",
      textContent: "0%"
    }), i.appendChild(a), a.appendChild(s), a.appendChild(o), a.appendChild(this.percentageEl_), i;
  }, r.dispose = function() {
    this.partEls_ = null, this.percentageEl_ = null, t.prototype.dispose.call(this);
  }, r.update = function(i) {
    var a = this;
    this.requestNamedAnimationFrame("LoadProgressBar#update", function() {
      var s = a.player_.liveTracker, o = a.player_.buffered(), u = s && s.isLive() ? s.seekableEnd() : a.player_.duration(), l = a.player_.bufferedEnd(), d = a.partEls_, h = Vl(l, u);
      a.percent_ !== h && (a.el_.style.width = h, Pn(a.percentageEl_, h), a.percent_ = h);
      for (var f = 0; f < o.length; f++) {
        var v = o.start(f), b = o.end(f), _ = d[f];
        _ || (_ = a.el_.appendChild(Ge()), d[f] = _), !(_.dataset.start === v && _.dataset.end === b) && (_.dataset.start = v, _.dataset.end = b, _.style.left = Vl(v, l), _.style.width = Vl(b - v, l));
      }
      for (var y = d.length; y > o.length; y--)
        a.el_.removeChild(d[y - 1]);
      d.length = o.length;
    });
  }, e;
}(ee);
ee.registerComponent("LoadProgressBar", SC);
var EC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.update = Ir(vt(Le(a), a.update), ji), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: "vjs-time-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }, r.update = function(i, a, s) {
    var o = Ds(this.el_), u = Aa(this.player_.el()), l = i.width * a;
    if (!(!u || !o)) {
      var d = i.left - u.left + l, h = i.width - l + (u.right - i.right), f = o.width / 2;
      d < f ? f += f - d : h < f && (f = h), f < 0 ? f = 0 : f > o.width && (f = o.width), f = Math.round(f), this.el_.style.right = "-" + f + "px", this.write(s);
    }
  }, r.write = function(i) {
    Pn(this.el_, i);
  }, r.updateTime = function(i, a, s, o) {
    var u = this;
    this.requestNamedAnimationFrame("TimeTooltip#updateTime", function() {
      var l, d = u.player_.duration();
      if (u.player_.liveTracker && u.player_.liveTracker.isLive()) {
        var h = u.player_.liveTracker.liveWindow(), f = h - a * h;
        l = (f < 1 ? "" : "-") + ka(f, h);
      } else
        l = ka(s, d);
      u.update(i, a, l), o && o();
    });
  }, e;
}(ee);
ee.registerComponent("TimeTooltip", EC);
var jh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.update = Ir(vt(Le(a), a.update), ji), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: "vjs-play-progress vjs-slider-bar"
    }, {
      "aria-hidden": "true"
    });
  }, r.update = function(i, a) {
    var s = this.getChild("timeTooltip");
    if (s) {
      var o = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
      s.updateTime(i, a, o);
    }
  }, e;
}(ee);
jh.prototype.options_ = {
  children: []
};
!ui && !Or && jh.prototype.options_.children.push("timeTooltip");
ee.registerComponent("PlayProgressBar", jh);
var Ky = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.update = Ir(vt(Le(a), a.update), ji), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: "vjs-mouse-display"
    });
  }, r.update = function(i, a) {
    var s = this, o = a * this.player_.duration();
    this.getChild("timeTooltip").updateTime(i, a, o, function() {
      s.el_.style.left = i.width * a + "px";
    });
  }, e;
}(ee);
Ky.prototype.options_ = {
  children: ["timeTooltip"]
};
ee.registerComponent("MouseTimeDisplay", Ky);
var Co = 5, Wp = 12, Hh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.setEventHandlers_(), a;
  }
  var r = e.prototype;
  return r.setEventHandlers_ = function() {
    var i = this;
    this.update_ = vt(this, this.update), this.update = Ir(this.update_, ji), this.on(this.player_, ["ended", "durationchange", "timeupdate"], this.update), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.enableIntervalHandler_ = function(a) {
      return i.enableInterval_(a);
    }, this.disableIntervalHandler_ = function(a) {
      return i.disableInterval_(a);
    }, this.on(this.player_, ["playing"], this.enableIntervalHandler_), this.on(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in oe && "visibilityState" in oe && this.on(oe, "visibilitychange", this.toggleVisibility_);
  }, r.toggleVisibility_ = function(i) {
    oe.visibilityState === "hidden" ? (this.cancelNamedAnimationFrame("SeekBar#update"), this.cancelNamedAnimationFrame("Slider#update"), this.disableInterval_(i)) : (!this.player_.ended() && !this.player_.paused() && this.enableInterval_(), this.update());
  }, r.enableInterval_ = function() {
    this.updateInterval || (this.updateInterval = this.setInterval(this.update, ji));
  }, r.disableInterval_ = function(i) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && i && i.type !== "ended" || this.updateInterval && (this.clearInterval(this.updateInterval), this.updateInterval = null);
  }, r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: "vjs-progress-holder"
    }, {
      "aria-label": this.localize("Progress Bar")
    });
  }, r.update = function(i) {
    var a = this;
    if (oe.visibilityState !== "hidden") {
      var s = t.prototype.update.call(this);
      return this.requestNamedAnimationFrame("SeekBar#update", function() {
        var o = a.player_.ended() ? a.player_.duration() : a.getCurrentTime_(), u = a.player_.liveTracker, l = a.player_.duration();
        u && u.isLive() && (l = a.player_.liveTracker.liveCurrentTime()), a.percent_ !== s && (a.el_.setAttribute("aria-valuenow", (s * 100).toFixed(2)), a.percent_ = s), (a.currentTime_ !== o || a.duration_ !== l) && (a.el_.setAttribute("aria-valuetext", a.localize("progress bar timing: currentTime={1} duration={2}", [ka(o, l), ka(l, l)], "{1} of {2}")), a.currentTime_ = o, a.duration_ = l), a.bar && a.bar.update(Aa(a.el()), a.getProgress());
      }), s;
    }
  }, r.userSeek_ = function(i) {
    this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(i);
  }, r.getCurrentTime_ = function() {
    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
  }, r.getPercent = function() {
    var i = this.getCurrentTime_(), a, s = this.player_.liveTracker;
    return s && s.isLive() ? (a = (i - s.seekableStart()) / s.liveWindow(), s.atLiveEdge() && (a = 1)) : a = i / this.player_.duration(), a;
  }, r.handleMouseDown = function(i) {
    Rs(i) && (i.stopPropagation(), this.videoWasPlaying = !this.player_.paused(), this.player_.pause(), t.prototype.handleMouseDown.call(this, i));
  }, r.handleMouseMove = function(i, a) {
    if (a === void 0 && (a = !1), !!Rs(i)) {
      !a && !this.player_.scrubbing() && this.player_.scrubbing(!0);
      var s, o = this.calculateDistance(i), u = this.player_.liveTracker;
      if (!u || !u.isLive())
        s = o * this.player_.duration(), s === this.player_.duration() && (s = s - 0.1);
      else {
        if (o >= 0.99) {
          u.seekToLiveEdge();
          return;
        }
        var l = u.seekableStart(), d = u.liveCurrentTime();
        if (s = l + o * u.liveWindow(), s >= d && (s = d), s <= l && (s = l + 0.1), s === 1 / 0)
          return;
      }
      this.userSeek_(s);
    }
  }, r.enable = function() {
    t.prototype.enable.call(this);
    var i = this.getChild("mouseTimeDisplay");
    i && i.show();
  }, r.disable = function() {
    t.prototype.disable.call(this);
    var i = this.getChild("mouseTimeDisplay");
    i && i.hide();
  }, r.handleMouseUp = function(i) {
    t.prototype.handleMouseUp.call(this, i), i && i.stopPropagation(), this.player_.scrubbing(!1), this.player_.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: !0
    }), this.videoWasPlaying ? er(this.player_.play()) : this.update_();
  }, r.stepForward = function() {
    this.userSeek_(this.player_.currentTime() + Co);
  }, r.stepBack = function() {
    this.userSeek_(this.player_.currentTime() - Co);
  }, r.handleAction = function(i) {
    this.player_.paused() ? this.player_.play() : this.player_.pause();
  }, r.handleKeyDown = function(i) {
    var a = this.player_.liveTracker;
    if (De.isEventKey(i, "Space") || De.isEventKey(i, "Enter"))
      i.preventDefault(), i.stopPropagation(), this.handleAction(i);
    else if (De.isEventKey(i, "Home"))
      i.preventDefault(), i.stopPropagation(), this.userSeek_(0);
    else if (De.isEventKey(i, "End"))
      i.preventDefault(), i.stopPropagation(), a && a.isLive() ? this.userSeek_(a.liveCurrentTime()) : this.userSeek_(this.player_.duration());
    else if (/^[0-9]$/.test(De(i))) {
      i.preventDefault(), i.stopPropagation();
      var s = (De.codes[De(i)] - De.codes[0]) * 10 / 100;
      a && a.isLive() ? this.userSeek_(a.seekableStart() + a.liveWindow() * s) : this.userSeek_(this.player_.duration() * s);
    } else
      De.isEventKey(i, "PgDn") ? (i.preventDefault(), i.stopPropagation(), this.userSeek_(this.player_.currentTime() - Co * Wp)) : De.isEventKey(i, "PgUp") ? (i.preventDefault(), i.stopPropagation(), this.userSeek_(this.player_.currentTime() + Co * Wp)) : t.prototype.handleKeyDown.call(this, i);
  }, r.dispose = function() {
    this.disableInterval_(), this.off(this.player_, ["ended", "durationchange", "timeupdate"], this.update), this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.update), this.off(this.player_, ["playing"], this.enableIntervalHandler_), this.off(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in oe && "visibilityState" in oe && this.off(oe, "visibilitychange", this.toggleVisibility_), t.prototype.dispose.call(this);
  }, e;
}(Vh);
Hh.prototype.options_ = {
  children: ["loadProgressBar", "playProgressBar"],
  barName: "playProgressBar"
};
!ui && !Or && Hh.prototype.options_.children.splice(1, 0, "mouseTimeDisplay");
ee.registerComponent("SeekBar", Hh);
var Xy = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.handleMouseMove = Ir(vt(Le(a), a.handleMouseMove), ji), a.throttledHandleMouseSeek = Ir(vt(Le(a), a.handleMouseSeek), ji), a.handleMouseUpHandler_ = function(s) {
      return a.handleMouseUp(s);
    }, a.handleMouseDownHandler_ = function(s) {
      return a.handleMouseDown(s);
    }, a.enable(), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: "vjs-progress-control vjs-control"
    });
  }, r.handleMouseMove = function(i) {
    var a = this.getChild("seekBar");
    if (a) {
      var s = a.getChild("playProgressBar"), o = a.getChild("mouseTimeDisplay");
      if (!(!s && !o)) {
        var u = a.el(), l = Ds(u), d = qu(u, i).x;
        d = Yu(d, 0, 1), o && o.update(l, d), s && s.update(l, a.getProgress());
      }
    }
  }, r.handleMouseSeek = function(i) {
    var a = this.getChild("seekBar");
    a && a.handleMouseMove(i);
  }, r.enabled = function() {
    return this.enabled_;
  }, r.disable = function() {
    if (this.children().forEach(function(a) {
      return a.disable && a.disable();
    }), !!this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.off(this.el_, "mousemove", this.handleMouseMove), this.removeListenersAddedOnMousedownAndTouchstart(), this.addClass("disabled"), this.enabled_ = !1, this.player_.scrubbing())) {
      var i = this.getChild("seekBar");
      this.player_.scrubbing(!1), i.videoWasPlaying && er(this.player_.play());
    }
  }, r.enable = function() {
    this.children().forEach(function(i) {
      return i.enable && i.enable();
    }), !this.enabled() && (this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.on(this.el_, "mousemove", this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0);
  }, r.removeListenersAddedOnMousedownAndTouchstart = function() {
    var i = this.el_.ownerDocument;
    this.off(i, "mousemove", this.throttledHandleMouseSeek), this.off(i, "touchmove", this.throttledHandleMouseSeek), this.off(i, "mouseup", this.handleMouseUpHandler_), this.off(i, "touchend", this.handleMouseUpHandler_);
  }, r.handleMouseDown = function(i) {
    var a = this.el_.ownerDocument, s = this.getChild("seekBar");
    s && s.handleMouseDown(i), this.on(a, "mousemove", this.throttledHandleMouseSeek), this.on(a, "touchmove", this.throttledHandleMouseSeek), this.on(a, "mouseup", this.handleMouseUpHandler_), this.on(a, "touchend", this.handleMouseUpHandler_);
  }, r.handleMouseUp = function(i) {
    var a = this.getChild("seekBar");
    a && a.handleMouseUp(i), this.removeListenersAddedOnMousedownAndTouchstart();
  }, e;
}(ee);
Xy.prototype.options_ = {
  children: ["seekBar"]
};
ee.registerComponent("ProgressControl", Xy);
var Yy = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.on(n, ["enterpictureinpicture", "leavepictureinpicture"], function(s) {
      return a.handlePictureInPictureChange(s);
    }), a.on(n, ["disablepictureinpicturechanged", "loadedmetadata"], function(s) {
      return a.handlePictureInPictureEnabledChange(s);
    }), a.on(n, ["loadedmetadata", "audioonlymodechange", "audiopostermodechange"], function() {
      var s = n.currentType().substring(0, 5) === "audio";
      s || n.audioPosterMode() || n.audioOnlyMode() ? (n.isInPictureInPicture() && n.exitPictureInPicture(), a.hide()) : a.show();
    }), a.disable(), a;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-picture-in-picture-control " + t.prototype.buildCSSClass.call(this);
  }, r.handlePictureInPictureEnabledChange = function() {
    oe.pictureInPictureEnabled && this.player_.disablePictureInPicture() === !1 ? this.enable() : this.disable();
  }, r.handlePictureInPictureChange = function(i) {
    this.player_.isInPictureInPicture() ? this.controlText("Exit Picture-in-Picture") : this.controlText("Picture-in-Picture"), this.handlePictureInPictureEnabledChange();
  }, r.handleClick = function(i) {
    this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture();
  }, e;
}(Ui);
Yy.prototype.controlText_ = "Picture-in-Picture";
ee.registerComponent("PictureInPictureToggle", Yy);
var Qy = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.on(n, "fullscreenchange", function(s) {
      return a.handleFullscreenChange(s);
    }), oe[n.fsApi_.fullscreenEnabled] === !1 && a.disable(), a;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-fullscreen-control " + t.prototype.buildCSSClass.call(this);
  }, r.handleFullscreenChange = function(i) {
    this.player_.isFullscreen() ? this.controlText("Non-Fullscreen") : this.controlText("Fullscreen");
  }, r.handleClick = function(i) {
    this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen();
  }, e;
}(Ui);
Qy.prototype.controlText_ = "Fullscreen";
ee.registerComponent("FullscreenToggle", Qy);
var xC = function(e, r) {
  r.tech_ && !r.tech_.featuresVolumeControl && e.addClass("vjs-hidden"), e.on(r, "loadstart", function() {
    r.tech_.featuresVolumeControl ? e.removeClass("vjs-hidden") : e.addClass("vjs-hidden");
  });
}, CC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var r = e.prototype;
  return r.createEl = function() {
    var i = t.prototype.createEl.call(this, "div", {
      className: "vjs-volume-level"
    });
    return i.appendChild(t.prototype.createEl.call(this, "span", {
      className: "vjs-control-text"
    })), i;
  }, e;
}(ee);
ee.registerComponent("VolumeLevel", CC);
var AC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.update = Ir(vt(Le(a), a.update), ji), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: "vjs-volume-tooltip"
    }, {
      "aria-hidden": "true"
    });
  }, r.update = function(i, a, s, o) {
    if (!s) {
      var u = Aa(this.el_), l = Aa(this.player_.el()), d = i.width * a;
      if (!l || !u)
        return;
      var h = i.left - l.left + d, f = i.width - d + (l.right - i.right), v = u.width / 2;
      h < v ? v += v - h : f < v && (v = f), v < 0 ? v = 0 : v > u.width && (v = u.width), this.el_.style.right = "-" + v + "px";
    }
    this.write(o + "%");
  }, r.write = function(i) {
    Pn(this.el_, i);
  }, r.updateVolume = function(i, a, s, o, u) {
    var l = this;
    this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", function() {
      l.update(i, a, s, o.toFixed(0)), u && u();
    });
  }, e;
}(ee);
ee.registerComponent("VolumeLevelTooltip", AC);
var Jy = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.update = Ir(vt(Le(a), a.update), ji), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: "vjs-mouse-display"
    });
  }, r.update = function(i, a, s) {
    var o = this, u = 100 * a;
    this.getChild("volumeLevelTooltip").updateVolume(i, a, s, u, function() {
      s ? o.el_.style.bottom = i.height * a + "px" : o.el_.style.left = i.width * a + "px";
    });
  }, e;
}(ee);
Jy.prototype.options_ = {
  children: ["volumeLevelTooltip"]
};
ee.registerComponent("MouseVolumeLevelDisplay", Jy);
var Qu = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.on("slideractive", function(s) {
      return a.updateLastVolume_(s);
    }), a.on(n, "volumechange", function(s) {
      return a.updateARIAAttributes(s);
    }), n.ready(function() {
      return a.updateARIAAttributes();
    }), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: "vjs-volume-bar vjs-slider-bar"
    }, {
      "aria-label": this.localize("Volume Level"),
      "aria-live": "polite"
    });
  }, r.handleMouseDown = function(i) {
    Rs(i) && t.prototype.handleMouseDown.call(this, i);
  }, r.handleMouseMove = function(i) {
    var a = this.getChild("mouseVolumeLevelDisplay");
    if (a) {
      var s = this.el(), o = Aa(s), u = this.vertical(), l = qu(s, i);
      l = u ? l.y : l.x, l = Yu(l, 0, 1), a.update(o, l, u);
    }
    Rs(i) && (this.checkMuted(), this.player_.volume(this.calculateDistance(i)));
  }, r.checkMuted = function() {
    this.player_.muted() && this.player_.muted(!1);
  }, r.getPercent = function() {
    return this.player_.muted() ? 0 : this.player_.volume();
  }, r.stepForward = function() {
    this.checkMuted(), this.player_.volume(this.player_.volume() + 0.1);
  }, r.stepBack = function() {
    this.checkMuted(), this.player_.volume(this.player_.volume() - 0.1);
  }, r.updateARIAAttributes = function(i) {
    var a = this.player_.muted() ? 0 : this.volumeAsPercentage_();
    this.el_.setAttribute("aria-valuenow", a), this.el_.setAttribute("aria-valuetext", a + "%");
  }, r.volumeAsPercentage_ = function() {
    return Math.round(this.player_.volume() * 100);
  }, r.updateLastVolume_ = function() {
    var i = this, a = this.player_.volume();
    this.one("sliderinactive", function() {
      i.player_.volume() === 0 && i.player_.lastVolume_(a);
    });
  }, e;
}(Vh);
Qu.prototype.options_ = {
  children: ["volumeLevel"],
  barName: "volumeLevel"
};
!ui && !Or && Qu.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay");
Qu.prototype.playerEvent = "volumechange";
ee.registerComponent("VolumeBar", Qu);
var Zy = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return i === void 0 && (i = {}), i.vertical = i.vertical || !1, (typeof i.volumeBar > "u" || Ls(i.volumeBar)) && (i.volumeBar = i.volumeBar || {}, i.volumeBar.vertical = i.vertical), a = t.call(this, n, i) || this, xC(Le(a), n), a.throttledHandleMouseMove = Ir(vt(Le(a), a.handleMouseMove), ji), a.handleMouseUpHandler_ = function(s) {
      return a.handleMouseUp(s);
    }, a.on("mousedown", function(s) {
      return a.handleMouseDown(s);
    }), a.on("touchstart", function(s) {
      return a.handleMouseDown(s);
    }), a.on("mousemove", function(s) {
      return a.handleMouseMove(s);
    }), a.on(a.volumeBar, ["focus", "slideractive"], function() {
      a.volumeBar.addClass("vjs-slider-active"), a.addClass("vjs-slider-active"), a.trigger("slideractive");
    }), a.on(a.volumeBar, ["blur", "sliderinactive"], function() {
      a.volumeBar.removeClass("vjs-slider-active"), a.removeClass("vjs-slider-active"), a.trigger("sliderinactive");
    }), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    var i = "vjs-volume-horizontal";
    return this.options_.vertical && (i = "vjs-volume-vertical"), t.prototype.createEl.call(this, "div", {
      className: "vjs-volume-control vjs-control " + i
    });
  }, r.handleMouseDown = function(i) {
    var a = this.el_.ownerDocument;
    this.on(a, "mousemove", this.throttledHandleMouseMove), this.on(a, "touchmove", this.throttledHandleMouseMove), this.on(a, "mouseup", this.handleMouseUpHandler_), this.on(a, "touchend", this.handleMouseUpHandler_);
  }, r.handleMouseUp = function(i) {
    var a = this.el_.ownerDocument;
    this.off(a, "mousemove", this.throttledHandleMouseMove), this.off(a, "touchmove", this.throttledHandleMouseMove), this.off(a, "mouseup", this.handleMouseUpHandler_), this.off(a, "touchend", this.handleMouseUpHandler_);
  }, r.handleMouseMove = function(i) {
    this.volumeBar.handleMouseMove(i);
  }, e;
}(ee);
Zy.prototype.options_ = {
  children: ["volumeBar"]
};
ee.registerComponent("VolumeControl", Zy);
var wC = function(e, r) {
  r.tech_ && !r.tech_.featuresMuteControl && e.addClass("vjs-hidden"), e.on(r, "loadstart", function() {
    r.tech_.featuresMuteControl ? e.removeClass("vjs-hidden") : e.addClass("vjs-hidden");
  });
}, e0 = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, wC(Le(a), n), a.on(n, ["loadstart", "volumechange"], function(s) {
      return a.update(s);
    }), a;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-mute-control " + t.prototype.buildCSSClass.call(this);
  }, r.handleClick = function(i) {
    var a = this.player_.volume(), s = this.player_.lastVolume_();
    if (a === 0) {
      var o = s < 0.1 ? 0.1 : s;
      this.player_.volume(o), this.player_.muted(!1);
    } else
      this.player_.muted(!this.player_.muted());
  }, r.update = function(i) {
    this.updateIcon_(), this.updateControlText_();
  }, r.updateIcon_ = function() {
    var i = this.player_.volume(), a = 3;
    ui && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), i === 0 || this.player_.muted() ? a = 0 : i < 0.33 ? a = 1 : i < 0.67 && (a = 2);
    for (var s = 0; s < 4; s++)
      Gs(this.el_, "vjs-vol-" + s);
    Cr(this.el_, "vjs-vol-" + a);
  }, r.updateControlText_ = function() {
    var i = this.player_.muted() || this.player_.volume() === 0, a = i ? "Unmute" : "Mute";
    this.controlText() !== a && this.controlText(a);
  }, e;
}(Ui);
e0.prototype.controlText_ = "Mute";
ee.registerComponent("MuteToggle", e0);
var t0 = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return i === void 0 && (i = {}), typeof i.inline < "u" ? i.inline = i.inline : i.inline = !0, (typeof i.volumeControl > "u" || Ls(i.volumeControl)) && (i.volumeControl = i.volumeControl || {}, i.volumeControl.vertical = !i.inline), a = t.call(this, n, i) || this, a.handleKeyPressHandler_ = function(s) {
      return a.handleKeyPress(s);
    }, a.on(n, ["loadstart"], function(s) {
      return a.volumePanelState_(s);
    }), a.on(a.muteToggle, "keyup", function(s) {
      return a.handleKeyPress(s);
    }), a.on(a.volumeControl, "keyup", function(s) {
      return a.handleVolumeControlKeyUp(s);
    }), a.on("keydown", function(s) {
      return a.handleKeyPress(s);
    }), a.on("mouseover", function(s) {
      return a.handleMouseOver(s);
    }), a.on("mouseout", function(s) {
      return a.handleMouseOut(s);
    }), a.on(a.volumeControl, ["slideractive"], a.sliderActive_), a.on(a.volumeControl, ["sliderinactive"], a.sliderInactive_), a;
  }
  var r = e.prototype;
  return r.sliderActive_ = function() {
    this.addClass("vjs-slider-active");
  }, r.sliderInactive_ = function() {
    this.removeClass("vjs-slider-active");
  }, r.volumePanelState_ = function() {
    this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only");
  }, r.createEl = function() {
    var i = "vjs-volume-panel-horizontal";
    return this.options_.inline || (i = "vjs-volume-panel-vertical"), t.prototype.createEl.call(this, "div", {
      className: "vjs-volume-panel vjs-control " + i
    });
  }, r.dispose = function() {
    this.handleMouseOut(), t.prototype.dispose.call(this);
  }, r.handleVolumeControlKeyUp = function(i) {
    De.isEventKey(i, "Esc") && this.muteToggle.focus();
  }, r.handleMouseOver = function(i) {
    this.addClass("vjs-hover"), Ei(oe, "keyup", this.handleKeyPressHandler_);
  }, r.handleMouseOut = function(i) {
    this.removeClass("vjs-hover"), Xt(oe, "keyup", this.handleKeyPressHandler_);
  }, r.handleKeyPress = function(i) {
    De.isEventKey(i, "Esc") && this.handleMouseOut();
  }, e;
}(ee);
t0.prototype.options_ = {
  children: ["muteToggle", "volumeControl"]
};
ee.registerComponent("VolumePanel", t0);
var i0 = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, i && (a.menuButton_ = i.menuButton), a.focusedChild_ = -1, a.on("keydown", function(s) {
      return a.handleKeyDown(s);
    }), a.boundHandleBlur_ = function(s) {
      return a.handleBlur(s);
    }, a.boundHandleTapClick_ = function(s) {
      return a.handleTapClick(s);
    }, a;
  }
  var r = e.prototype;
  return r.addEventListenerForItem = function(i) {
    i instanceof ee && (this.on(i, "blur", this.boundHandleBlur_), this.on(i, ["tap", "click"], this.boundHandleTapClick_));
  }, r.removeEventListenerForItem = function(i) {
    i instanceof ee && (this.off(i, "blur", this.boundHandleBlur_), this.off(i, ["tap", "click"], this.boundHandleTapClick_));
  }, r.removeChild = function(i) {
    typeof i == "string" && (i = this.getChild(i)), this.removeEventListenerForItem(i), t.prototype.removeChild.call(this, i);
  }, r.addItem = function(i) {
    var a = this.addChild(i);
    a && this.addEventListenerForItem(a);
  }, r.createEl = function() {
    var i = this.options_.contentElType || "ul";
    this.contentEl_ = Ge(i, {
      className: "vjs-menu-content"
    }), this.contentEl_.setAttribute("role", "menu");
    var a = t.prototype.createEl.call(this, "div", {
      append: this.contentEl_,
      className: "vjs-menu"
    });
    return a.appendChild(this.contentEl_), Ei(a, "click", function(s) {
      s.preventDefault(), s.stopImmediatePropagation();
    }), a;
  }, r.dispose = function() {
    this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, t.prototype.dispose.call(this);
  }, r.handleBlur = function(i) {
    var a = i.relatedTarget || oe.activeElement;
    if (!this.children().some(function(o) {
      return o.el() === a;
    })) {
      var s = this.menuButton_;
      s && s.buttonPressed_ && a !== s.el().firstChild && s.unpressButton();
    }
  }, r.handleTapClick = function(i) {
    if (this.menuButton_) {
      this.menuButton_.unpressButton();
      var a = this.children();
      if (!Array.isArray(a))
        return;
      var s = a.filter(function(o) {
        return o.el() === i.target;
      })[0];
      if (!s)
        return;
      s.name() !== "CaptionSettingsMenuItem" && this.menuButton_.focus();
    }
  }, r.handleKeyDown = function(i) {
    De.isEventKey(i, "Left") || De.isEventKey(i, "Down") ? (i.preventDefault(), i.stopPropagation(), this.stepForward()) : (De.isEventKey(i, "Right") || De.isEventKey(i, "Up")) && (i.preventDefault(), i.stopPropagation(), this.stepBack());
  }, r.stepForward = function() {
    var i = 0;
    this.focusedChild_ !== void 0 && (i = this.focusedChild_ + 1), this.focus(i);
  }, r.stepBack = function() {
    var i = 0;
    this.focusedChild_ !== void 0 && (i = this.focusedChild_ - 1), this.focus(i);
  }, r.focus = function(i) {
    i === void 0 && (i = 0);
    var a = this.children().slice(), s = a.length && a[0].hasClass("vjs-menu-title");
    s && a.shift(), a.length > 0 && (i < 0 ? i = 0 : i >= a.length && (i = a.length - 1), this.focusedChild_ = i, a[i].el_.focus());
  }, e;
}(ee);
ee.registerComponent("Menu", i0);
var Wh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    i === void 0 && (i = {}), a = t.call(this, n, i) || this, a.menuButton_ = new Ui(n, i), a.menuButton_.controlText(a.controlText_), a.menuButton_.el_.setAttribute("aria-haspopup", "true");
    var s = Ui.prototype.buildCSSClass();
    a.menuButton_.el_.className = a.buildCSSClass() + " " + s, a.menuButton_.removeClass("vjs-control"), a.addChild(a.menuButton_), a.update(), a.enabled_ = !0;
    var o = function(l) {
      return a.handleClick(l);
    };
    return a.handleMenuKeyUp_ = function(u) {
      return a.handleMenuKeyUp(u);
    }, a.on(a.menuButton_, "tap", o), a.on(a.menuButton_, "click", o), a.on(a.menuButton_, "keydown", function(u) {
      return a.handleKeyDown(u);
    }), a.on(a.menuButton_, "mouseenter", function() {
      a.addClass("vjs-hover"), a.menu.show(), Ei(oe, "keyup", a.handleMenuKeyUp_);
    }), a.on("mouseleave", function(u) {
      return a.handleMouseLeave(u);
    }), a.on("keydown", function(u) {
      return a.handleSubmenuKeyDown(u);
    }), a;
  }
  var r = e.prototype;
  return r.update = function() {
    var i = this.createMenu();
    this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = i, this.addChild(i), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? (this.hide(), this.menu.contentEl_.removeAttribute("role")) : (this.show(), this.menu.contentEl_.setAttribute("role", "menu"));
  }, r.createMenu = function() {
    var i = new i0(this.player_, {
      menuButton: this
    });
    if (this.hideThreshold_ = 0, this.options_.title) {
      var a = Ge("li", {
        className: "vjs-menu-title",
        textContent: It(this.options_.title),
        tabIndex: -1
      }), s = new ee(this.player_, {
        el: a
      });
      i.addItem(s);
    }
    if (this.items = this.createItems(), this.items)
      for (var o = 0; o < this.items.length; o++)
        i.addItem(this.items[o]);
    return i;
  }, r.createItems = function() {
  }, r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: this.buildWrapperCSSClass()
    }, {});
  }, r.buildWrapperCSSClass = function() {
    var i = "vjs-menu-button";
    this.options_.inline === !0 ? i += "-inline" : i += "-popup";
    var a = Ui.prototype.buildCSSClass();
    return "vjs-menu-button " + i + " " + a + " " + t.prototype.buildCSSClass.call(this);
  }, r.buildCSSClass = function() {
    var i = "vjs-menu-button";
    return this.options_.inline === !0 ? i += "-inline" : i += "-popup", "vjs-menu-button " + i + " " + t.prototype.buildCSSClass.call(this);
  }, r.controlText = function(i, a) {
    return a === void 0 && (a = this.menuButton_.el()), this.menuButton_.controlText(i, a);
  }, r.dispose = function() {
    this.handleMouseLeave(), t.prototype.dispose.call(this);
  }, r.handleClick = function(i) {
    this.buttonPressed_ ? this.unpressButton() : this.pressButton();
  }, r.handleMouseLeave = function(i) {
    this.removeClass("vjs-hover"), Xt(oe, "keyup", this.handleMenuKeyUp_);
  }, r.focus = function() {
    this.menuButton_.focus();
  }, r.blur = function() {
    this.menuButton_.blur();
  }, r.handleKeyDown = function(i) {
    De.isEventKey(i, "Esc") || De.isEventKey(i, "Tab") ? (this.buttonPressed_ && this.unpressButton(), De.isEventKey(i, "Tab") || (i.preventDefault(), this.menuButton_.focus())) : (De.isEventKey(i, "Up") || De.isEventKey(i, "Down")) && (this.buttonPressed_ || (i.preventDefault(), this.pressButton()));
  }, r.handleMenuKeyUp = function(i) {
    (De.isEventKey(i, "Esc") || De.isEventKey(i, "Tab")) && this.removeClass("vjs-hover");
  }, r.handleSubmenuKeyPress = function(i) {
    this.handleSubmenuKeyDown(i);
  }, r.handleSubmenuKeyDown = function(i) {
    (De.isEventKey(i, "Esc") || De.isEventKey(i, "Tab")) && (this.buttonPressed_ && this.unpressButton(), De.isEventKey(i, "Tab") || (i.preventDefault(), this.menuButton_.focus()));
  }, r.pressButton = function() {
    if (this.enabled_) {
      if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), ui && vy())
        return;
      this.menu.focus();
    }
  }, r.unpressButton = function() {
    this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"));
  }, r.disable = function() {
    this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable();
  }, r.enable = function() {
    this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable();
  }, e;
}(ee);
ee.registerComponent("MenuButton", Wh);
var qh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(r, n) {
    var i, a = n.tracks;
    if (i = t.call(this, r, n) || this, i.items.length <= 1 && i.hide(), !a)
      return Le(i);
    var s = vt(Le(i), i.update);
    return a.addEventListener("removetrack", s), a.addEventListener("addtrack", s), a.addEventListener("labelchange", s), i.player_.on("ready", s), i.player_.on("dispose", function() {
      a.removeEventListener("removetrack", s), a.removeEventListener("addtrack", s), a.removeEventListener("labelchange", s);
    }), i;
  }
  return e;
}(Wh);
ee.registerComponent("TrackButton", qh);
var PC = ["Tab", "Esc", "Up", "Down", "Right", "Left"], Xs = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.selectable = i.selectable, a.isSelected_ = i.selected || !1, a.multiSelectable = i.multiSelectable, a.selected(a.isSelected_), a.selectable ? a.multiSelectable ? a.el_.setAttribute("role", "menuitemcheckbox") : a.el_.setAttribute("role", "menuitemradio") : a.el_.setAttribute("role", "menuitem"), a;
  }
  var r = e.prototype;
  return r.createEl = function(i, a, s) {
    this.nonIconControl = !0;
    var o = t.prototype.createEl.call(this, "li", At({
      className: "vjs-menu-item",
      tabIndex: -1
    }, a), s);
    return o.replaceChild(Ge("span", {
      className: "vjs-menu-item-text",
      textContent: this.localize(this.options_.label)
    }), o.querySelector(".vjs-icon-placeholder")), o;
  }, r.handleKeyDown = function(i) {
    PC.some(function(a) {
      return De.isEventKey(i, a);
    }) || t.prototype.handleKeyDown.call(this, i);
  }, r.handleClick = function(i) {
    this.selected(!0);
  }, r.selected = function(i) {
    this.selectable && (i ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1));
  }, e;
}(Xu);
ee.registerComponent("MenuItem", Xs);
var Ys = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a, s = i.track, o = n.textTracks();
    i.label = s.label || s.language || "Unknown", i.selected = s.mode === "showing", a = t.call(this, n, i) || this, a.track = s, a.kinds = (i.kinds || [i.kind || a.track.kind]).filter(Boolean);
    var u = function() {
      for (var f = arguments.length, v = new Array(f), b = 0; b < f; b++)
        v[b] = arguments[b];
      a.handleTracksChange.apply(Le(a), v);
    }, l = function() {
      for (var f = arguments.length, v = new Array(f), b = 0; b < f; b++)
        v[b] = arguments[b];
      a.handleSelectedLanguageChange.apply(Le(a), v);
    };
    if (n.on(["loadstart", "texttrackchange"], u), o.addEventListener("change", u), o.addEventListener("selectedlanguagechange", l), a.on("dispose", function() {
      n.off(["loadstart", "texttrackchange"], u), o.removeEventListener("change", u), o.removeEventListener("selectedlanguagechange", l);
    }), o.onchange === void 0) {
      var d;
      a.on(["tap", "click"], function() {
        if (typeof M.Event != "object")
          try {
            d = new M.Event("change");
          } catch {
          }
        d || (d = oe.createEvent("Event"), d.initEvent("change", !0, !0)), o.dispatchEvent(d);
      });
    }
    return a.handleTracksChange(), a;
  }
  var r = e.prototype;
  return r.handleClick = function(i) {
    var a = this.track, s = this.player_.textTracks();
    if (t.prototype.handleClick.call(this, i), !!s)
      for (var o = 0; o < s.length; o++) {
        var u = s[o];
        this.kinds.indexOf(u.kind) !== -1 && (u === a ? u.mode !== "showing" && (u.mode = "showing") : u.mode !== "disabled" && (u.mode = "disabled"));
      }
  }, r.handleTracksChange = function(i) {
    var a = this.track.mode === "showing";
    a !== this.isSelected_ && this.selected(a);
  }, r.handleSelectedLanguageChange = function(i) {
    if (this.track.mode === "showing") {
      var a = this.player_.cache_.selectedLanguage;
      if (a && a.enabled && a.language === this.track.language && a.kind !== this.track.kind)
        return;
      this.player_.cache_.selectedLanguage = {
        enabled: !0,
        language: this.track.language,
        kind: this.track.kind
      };
    }
  }, r.dispose = function() {
    this.track = null, t.prototype.dispose.call(this);
  }, e;
}(Xs);
ee.registerComponent("TextTrackMenuItem", Ys);
var r0 = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    return i.track = {
      player: n,
      // it is no longer necessary to store `kind` or `kinds` on the track itself
      // since they are now stored in the `kinds` property of all instances of
      // TextTrackMenuItem, but this will remain for backwards compatibility
      kind: i.kind,
      kinds: i.kinds,
      default: !1,
      mode: "disabled"
    }, i.kinds || (i.kinds = [i.kind]), i.label ? i.track.label = i.label : i.track.label = i.kinds.join(" and ") + " off", i.selectable = !0, i.multiSelectable = !1, t.call(this, n, i) || this;
  }
  var r = e.prototype;
  return r.handleTracksChange = function(i) {
    for (var a = this.player().textTracks(), s = !0, o = 0, u = a.length; o < u; o++) {
      var l = a[o];
      if (this.options_.kinds.indexOf(l.kind) > -1 && l.mode === "showing") {
        s = !1;
        break;
      }
    }
    s !== this.isSelected_ && this.selected(s);
  }, r.handleSelectedLanguageChange = function(i) {
    for (var a = this.player().textTracks(), s = !0, o = 0, u = a.length; o < u; o++) {
      var l = a[o];
      if (["captions", "descriptions", "subtitles"].indexOf(l.kind) > -1 && l.mode === "showing") {
        s = !1;
        break;
      }
    }
    s && (this.player_.cache_.selectedLanguage = {
      enabled: !1
    });
  }, e;
}(Ys);
ee.registerComponent("OffTextTrackMenuItem", r0);
var Va = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    return i === void 0 && (i = {}), i.tracks = n.textTracks(), t.call(this, n, i) || this;
  }
  var r = e.prototype;
  return r.createItems = function(i, a) {
    i === void 0 && (i = []), a === void 0 && (a = Ys);
    var s;
    this.label_ && (s = this.label_ + " off"), i.push(new r0(this.player_, {
      kinds: this.kinds_,
      kind: this.kind_,
      label: s
    })), this.hideThreshold_ += 1;
    var o = this.player_.textTracks();
    Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);
    for (var u = 0; u < o.length; u++) {
      var l = o[u];
      if (this.kinds_.indexOf(l.kind) > -1) {
        var d = new a(this.player_, {
          track: l,
          kinds: this.kinds_,
          kind: this.kind_,
          // MenuItem is selectable
          selectable: !0,
          // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
          multiSelectable: !1
        });
        d.addClass("vjs-" + l.kind + "-menu-item"), i.push(d);
      }
    }
    return i;
  }, e;
}(qh);
ee.registerComponent("TextTrackButton", Va);
var n0 = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a, s = i.track, o = i.cue, u = n.currentTime();
    return i.selectable = !0, i.multiSelectable = !1, i.label = o.text, i.selected = o.startTime <= u && u < o.endTime, a = t.call(this, n, i) || this, a.track = s, a.cue = o, a;
  }
  var r = e.prototype;
  return r.handleClick = function(i) {
    t.prototype.handleClick.call(this), this.player_.currentTime(this.cue.startTime);
  }, e;
}(Xs);
ee.registerComponent("ChaptersTrackMenuItem", n0);
var $h = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i, a) {
    var s;
    return s = t.call(this, n, i, a) || this, s.selectCurrentItem_ = function() {
      s.items.forEach(function(o) {
        o.selected(s.track_.activeCues[0] === o.cue);
      });
    }, s;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-chapters-button " + t.prototype.buildCSSClass.call(this);
  }, r.buildWrapperCSSClass = function() {
    return "vjs-chapters-button " + t.prototype.buildWrapperCSSClass.call(this);
  }, r.update = function(i) {
    if (!(i && i.track && i.track.kind !== "chapters")) {
      var a = this.findChaptersTrack();
      a !== this.track_ ? (this.setTrack(a), t.prototype.update.call(this)) : (!this.items || a && a.cues && a.cues.length !== this.items.length) && t.prototype.update.call(this);
    }
  }, r.setTrack = function(i) {
    if (this.track_ !== i) {
      if (this.updateHandler_ || (this.updateHandler_ = this.update.bind(this)), this.track_) {
        var a = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        a && a.removeEventListener("load", this.updateHandler_), this.track_.removeEventListener("cuechange", this.selectCurrentItem_), this.track_ = null;
      }
      if (this.track_ = i, this.track_) {
        this.track_.mode = "hidden";
        var s = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
        s && s.addEventListener("load", this.updateHandler_), this.track_.addEventListener("cuechange", this.selectCurrentItem_);
      }
    }
  }, r.findChaptersTrack = function() {
    for (var i = this.player_.textTracks() || [], a = i.length - 1; a >= 0; a--) {
      var s = i[a];
      if (s.kind === this.kind_)
        return s;
    }
  }, r.getMenuCaption = function() {
    return this.track_ && this.track_.label ? this.track_.label : this.localize(It(this.kind_));
  }, r.createMenu = function() {
    return this.options_.title = this.getMenuCaption(), t.prototype.createMenu.call(this);
  }, r.createItems = function() {
    var i = [];
    if (!this.track_)
      return i;
    var a = this.track_.cues;
    if (!a)
      return i;
    for (var s = 0, o = a.length; s < o; s++) {
      var u = a[s], l = new n0(this.player_, {
        track: this.track_,
        cue: u
      });
      i.push(l);
    }
    return i;
  }, e;
}(Va);
$h.prototype.kind_ = "chapters";
$h.prototype.controlText_ = "Chapters";
ee.registerComponent("ChaptersButton", $h);
var zh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i, a) {
    var s;
    s = t.call(this, n, i, a) || this;
    var o = n.textTracks(), u = vt(Le(s), s.handleTracksChange);
    return o.addEventListener("change", u), s.on("dispose", function() {
      o.removeEventListener("change", u);
    }), s;
  }
  var r = e.prototype;
  return r.handleTracksChange = function(i) {
    for (var a = this.player().textTracks(), s = !1, o = 0, u = a.length; o < u; o++) {
      var l = a[o];
      if (l.kind !== this.kind_ && l.mode === "showing") {
        s = !0;
        break;
      }
    }
    s ? this.disable() : this.enable();
  }, r.buildCSSClass = function() {
    return "vjs-descriptions-button " + t.prototype.buildCSSClass.call(this);
  }, r.buildWrapperCSSClass = function() {
    return "vjs-descriptions-button " + t.prototype.buildWrapperCSSClass.call(this);
  }, e;
}(Va);
zh.prototype.kind_ = "descriptions";
zh.prototype.controlText_ = "Descriptions";
ee.registerComponent("DescriptionsButton", zh);
var Gh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i, a) {
    return t.call(this, n, i, a) || this;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-subtitles-button " + t.prototype.buildCSSClass.call(this);
  }, r.buildWrapperCSSClass = function() {
    return "vjs-subtitles-button " + t.prototype.buildWrapperCSSClass.call(this);
  }, e;
}(Va);
Gh.prototype.kind_ = "subtitles";
Gh.prototype.controlText_ = "Subtitles";
ee.registerComponent("SubtitlesButton", Gh);
var Kh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return i.track = {
      player: n,
      kind: i.kind,
      label: i.kind + " settings",
      selectable: !1,
      default: !1,
      mode: "disabled"
    }, i.selectable = !1, i.name = "CaptionSettingsMenuItem", a = t.call(this, n, i) || this, a.addClass("vjs-texttrack-settings"), a.controlText(", opens " + i.kind + " settings dialog"), a;
  }
  var r = e.prototype;
  return r.handleClick = function(i) {
    this.player().getChild("textTrackSettings").open();
  }, e;
}(Ys);
ee.registerComponent("CaptionSettingsMenuItem", Kh);
var Xh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i, a) {
    return t.call(this, n, i, a) || this;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-captions-button " + t.prototype.buildCSSClass.call(this);
  }, r.buildWrapperCSSClass = function() {
    return "vjs-captions-button " + t.prototype.buildWrapperCSSClass.call(this);
  }, r.createItems = function() {
    var i = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (i.push(new Kh(this.player_, {
      kind: this.kind_
    })), this.hideThreshold_ += 1), t.prototype.createItems.call(this, i);
  }, e;
}(Va);
Xh.prototype.kind_ = "captions";
Xh.prototype.controlText_ = "Captions";
ee.registerComponent("CaptionsButton", Xh);
var a0 = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var r = e.prototype;
  return r.createEl = function(i, a, s) {
    var o = t.prototype.createEl.call(this, i, a, s), u = o.querySelector(".vjs-menu-item-text");
    return this.options_.track.kind === "captions" && (u.appendChild(Ge("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), u.appendChild(Ge("span", {
      className: "vjs-control-text",
      // space added as the text will visually flow with the
      // label
      textContent: " " + this.localize("Captions")
    }))), o;
  }, e;
}(Ys);
ee.registerComponent("SubsCapsMenuItem", a0);
var Yh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return i === void 0 && (i = {}), a = t.call(this, n, i) || this, a.label_ = "subtitles", ["en", "en-us", "en-ca", "fr-ca"].indexOf(a.player_.language_) > -1 && (a.label_ = "captions"), a.menuButton_.controlText(It(a.label_)), a;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-subs-caps-button " + t.prototype.buildCSSClass.call(this);
  }, r.buildWrapperCSSClass = function() {
    return "vjs-subs-caps-button " + t.prototype.buildWrapperCSSClass.call(this);
  }, r.createItems = function() {
    var i = [];
    return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (i.push(new Kh(this.player_, {
      kind: this.label_
    })), this.hideThreshold_ += 1), i = t.prototype.createItems.call(this, i, a0), i;
  }, e;
}(Va);
Yh.prototype.kinds_ = ["captions", "subtitles"];
Yh.prototype.controlText_ = "Subtitles";
ee.registerComponent("SubsCapsButton", Yh);
var s0 = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a, s = i.track, o = n.audioTracks();
    i.label = s.label || s.language || "Unknown", i.selected = s.enabled, a = t.call(this, n, i) || this, a.track = s, a.addClass("vjs-" + s.kind + "-menu-item");
    var u = function() {
      for (var d = arguments.length, h = new Array(d), f = 0; f < d; f++)
        h[f] = arguments[f];
      a.handleTracksChange.apply(Le(a), h);
    };
    return o.addEventListener("change", u), a.on("dispose", function() {
      o.removeEventListener("change", u);
    }), a;
  }
  var r = e.prototype;
  return r.createEl = function(i, a, s) {
    var o = t.prototype.createEl.call(this, i, a, s), u = o.querySelector(".vjs-menu-item-text");
    return this.options_.track.kind === "main-desc" && (u.appendChild(Ge("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": !0
    })), u.appendChild(Ge("span", {
      className: "vjs-control-text",
      textContent: " " + this.localize("Descriptions")
    }))), o;
  }, r.handleClick = function(i) {
    if (t.prototype.handleClick.call(this, i), this.track.enabled = !0, this.player_.tech_.featuresNativeAudioTracks)
      for (var a = this.player_.audioTracks(), s = 0; s < a.length; s++) {
        var o = a[s];
        o !== this.track && (o.enabled = o === this.track);
      }
  }, r.handleTracksChange = function(i) {
    this.selected(this.track.enabled);
  }, e;
}(Xs);
ee.registerComponent("AudioTrackMenuItem", s0);
var o0 = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    return i === void 0 && (i = {}), i.tracks = n.audioTracks(), t.call(this, n, i) || this;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-audio-button " + t.prototype.buildCSSClass.call(this);
  }, r.buildWrapperCSSClass = function() {
    return "vjs-audio-button " + t.prototype.buildWrapperCSSClass.call(this);
  }, r.createItems = function(i) {
    i === void 0 && (i = []), this.hideThreshold_ = 1;
    for (var a = this.player_.audioTracks(), s = 0; s < a.length; s++) {
      var o = a[s];
      i.push(new s0(this.player_, {
        track: o,
        // MenuItem is selectable
        selectable: !0,
        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
        multiSelectable: !1
      }));
    }
    return i;
  }, e;
}(qh);
o0.prototype.controlText_ = "Audio Track";
ee.registerComponent("AudioTrackButton", o0);
var Qh = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a, s = i.rate, o = parseFloat(s, 10);
    return i.label = s, i.selected = o === n.playbackRate(), i.selectable = !0, i.multiSelectable = !1, a = t.call(this, n, i) || this, a.label = s, a.rate = o, a.on(n, "ratechange", function(u) {
      return a.update(u);
    }), a;
  }
  var r = e.prototype;
  return r.handleClick = function(i) {
    t.prototype.handleClick.call(this), this.player().playbackRate(this.rate);
  }, r.update = function(i) {
    this.selected(this.player().playbackRate() === this.rate);
  }, e;
}(Xs);
Qh.prototype.contentElType = "button";
ee.registerComponent("PlaybackRateMenuItem", Qh);
var u0 = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.menuButton_.el_.setAttribute("aria-describedby", a.labelElId_), a.updateVisibility(), a.updateLabel(), a.on(n, "loadstart", function(s) {
      return a.updateVisibility(s);
    }), a.on(n, "ratechange", function(s) {
      return a.updateLabel(s);
    }), a.on(n, "playbackrateschange", function(s) {
      return a.handlePlaybackRateschange(s);
    }), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    var i = t.prototype.createEl.call(this);
    return this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_, this.labelEl_ = Ge("div", {
      className: "vjs-playback-rate-value",
      id: this.labelElId_,
      textContent: "1x"
    }), i.appendChild(this.labelEl_), i;
  }, r.dispose = function() {
    this.labelEl_ = null, t.prototype.dispose.call(this);
  }, r.buildCSSClass = function() {
    return "vjs-playback-rate " + t.prototype.buildCSSClass.call(this);
  }, r.buildWrapperCSSClass = function() {
    return "vjs-playback-rate " + t.prototype.buildWrapperCSSClass.call(this);
  }, r.createItems = function() {
    for (var i = this.playbackRates(), a = [], s = i.length - 1; s >= 0; s--)
      a.push(new Qh(this.player(), {
        rate: i[s] + "x"
      }));
    return a;
  }, r.updateARIAAttributes = function() {
    this.el().setAttribute("aria-valuenow", this.player().playbackRate());
  }, r.handleClick = function(i) {
    var a = this.player().playbackRate(), s = this.playbackRates(), o = s.indexOf(a), u = (o + 1) % s.length;
    this.player().playbackRate(s[u]);
  }, r.handlePlaybackRateschange = function(i) {
    this.update();
  }, r.playbackRates = function() {
    var i = this.player();
    return i.playbackRates && i.playbackRates() || [];
  }, r.playbackRateSupported = function() {
    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
  }, r.updateVisibility = function(i) {
    this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden");
  }, r.updateLabel = function(i) {
    this.playbackRateSupported() && (this.labelEl_.textContent = this.player().playbackRate() + "x");
  }, e;
}(Wh);
u0.prototype.controlText_ = "Playback Rate";
ee.registerComponent("PlaybackRateMenuButton", u0);
var l0 = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-spacer " + t.prototype.buildCSSClass.call(this);
  }, r.createEl = function(i, a, s) {
    return i === void 0 && (i = "div"), a === void 0 && (a = {}), s === void 0 && (s = {}), a.className || (a.className = this.buildCSSClass()), t.prototype.createEl.call(this, i, a, s);
  }, e;
}(ee);
ee.registerComponent("Spacer", l0);
var kC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-custom-control-spacer " + t.prototype.buildCSSClass.call(this);
  }, r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: this.buildCSSClass(),
      // No-flex/table-cell mode requires there be some content
      // in the cell to fill the remaining space of the table.
      textContent: " "
    });
  }, e;
}(l0);
ee.registerComponent("CustomControlSpacer", kC);
var lu = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var r = e.prototype;
  return r.createEl = function() {
    return t.prototype.createEl.call(this, "div", {
      className: "vjs-control-bar",
      dir: "ltr"
    });
  }, e;
}(ee);
lu.prototype.options_ = {
  children: ["playToggle", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "liveDisplay", "seekToLive", "remainingTimeDisplay", "customControlSpacer", "playbackRateMenuButton", "chaptersButton", "descriptionsButton", "subsCapsButton", "audioTrackButton", "fullscreenToggle"]
};
"exitPictureInPicture" in oe && lu.prototype.options_.children.splice(lu.prototype.options_.children.length - 1, 0, "pictureInPictureToggle");
ee.registerComponent("ControlBar", lu);
var d0 = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return a = t.call(this, n, i) || this, a.on(n, "error", function(s) {
      return a.open(s);
    }), a;
  }
  var r = e.prototype;
  return r.buildCSSClass = function() {
    return "vjs-error-display " + t.prototype.buildCSSClass.call(this);
  }, r.content = function() {
    var i = this.player().error();
    return i ? this.localize(i.message) : "";
  }, e;
}(Ba);
d0.prototype.options_ = Vi({}, Ba.prototype.options_, {
  pauseOnOpen: !1,
  fillAlways: !0,
  temporary: !1,
  uncloseable: !0
});
ee.registerComponent("ErrorDisplay", d0);
var jl = "vjs-text-track-settings", qp = ["#000", "Black"], $p = ["#00F", "Blue"], zp = ["#0FF", "Cyan"], Gp = ["#0F0", "Green"], Kp = ["#F0F", "Magenta"], Xp = ["#F00", "Red"], Yp = ["#FFF", "White"], Qp = ["#FF0", "Yellow"], Hl = ["1", "Opaque"], Wl = ["0.5", "Semi-Transparent"], Jp = ["0", "Transparent"], gn = {
  backgroundColor: {
    selector: ".vjs-bg-color > select",
    id: "captions-background-color-%s",
    label: "Color",
    options: [qp, Yp, Xp, Gp, $p, Qp, Kp, zp]
  },
  backgroundOpacity: {
    selector: ".vjs-bg-opacity > select",
    id: "captions-background-opacity-%s",
    label: "Transparency",
    options: [Hl, Wl, Jp]
  },
  color: {
    selector: ".vjs-fg-color > select",
    id: "captions-foreground-color-%s",
    label: "Color",
    options: [Yp, qp, Xp, Gp, $p, Qp, Kp, zp]
  },
  edgeStyle: {
    selector: ".vjs-edge-style > select",
    id: "%s",
    label: "Text Edge Style",
    options: [["none", "None"], ["raised", "Raised"], ["depressed", "Depressed"], ["uniform", "Uniform"], ["dropshadow", "Dropshadow"]]
  },
  fontFamily: {
    selector: ".vjs-font-family > select",
    id: "captions-font-family-%s",
    label: "Font Family",
    options: [["proportionalSansSerif", "Proportional Sans-Serif"], ["monospaceSansSerif", "Monospace Sans-Serif"], ["proportionalSerif", "Proportional Serif"], ["monospaceSerif", "Monospace Serif"], ["casual", "Casual"], ["script", "Script"], ["small-caps", "Small Caps"]]
  },
  fontPercent: {
    selector: ".vjs-font-percent > select",
    id: "captions-font-size-%s",
    label: "Font Size",
    options: [["0.50", "50%"], ["0.75", "75%"], ["1.00", "100%"], ["1.25", "125%"], ["1.50", "150%"], ["1.75", "175%"], ["2.00", "200%"], ["3.00", "300%"], ["4.00", "400%"]],
    default: 2,
    parser: function(e) {
      return e === "1.00" ? null : Number(e);
    }
  },
  textOpacity: {
    selector: ".vjs-text-opacity > select",
    id: "captions-foreground-opacity-%s",
    label: "Transparency",
    options: [Hl, Wl]
  },
  // Options for this object are defined below.
  windowColor: {
    selector: ".vjs-window-color > select",
    id: "captions-window-color-%s",
    label: "Color"
  },
  // Options for this object are defined below.
  windowOpacity: {
    selector: ".vjs-window-opacity > select",
    id: "captions-window-opacity-%s",
    label: "Transparency",
    options: [Jp, Wl, Hl]
  }
};
gn.windowColor.options = gn.backgroundColor.options;
function c0(t, e) {
  if (e && (t = e(t)), t && t !== "none")
    return t;
}
function LC(t, e) {
  var r = t.options[t.options.selectedIndex].value;
  return c0(r, e);
}
function IC(t, e, r) {
  if (e) {
    for (var n = 0; n < t.options.length; n++)
      if (c0(t.options[n].value, r) === e) {
        t.selectedIndex = n;
        break;
      }
  }
}
var DC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return i.temporary = !1, a = t.call(this, n, i) || this, a.updateDisplay = a.updateDisplay.bind(Le(a)), a.fill(), a.hasBeenOpened_ = a.hasBeenFilled_ = !0, a.endDialog = Ge("p", {
      className: "vjs-control-text",
      textContent: a.localize("End of dialog window.")
    }), a.el().appendChild(a.endDialog), a.setDefaults(), i.persistTextTrackSettings === void 0 && (a.options_.persistTextTrackSettings = a.options_.playerOptions.persistTextTrackSettings), a.on(a.$(".vjs-done-button"), "click", function() {
      a.saveSettings(), a.close();
    }), a.on(a.$(".vjs-default-button"), "click", function() {
      a.setDefaults(), a.updateDisplay();
    }), fa(gn, function(s) {
      a.on(a.$(s.selector), "change", a.updateDisplay);
    }), a.options_.persistTextTrackSettings && a.restoreSettings(), a;
  }
  var r = e.prototype;
  return r.dispose = function() {
    this.endDialog = null, t.prototype.dispose.call(this);
  }, r.createElSelect_ = function(i, a, s) {
    var o = this;
    a === void 0 && (a = ""), s === void 0 && (s = "label");
    var u = gn[i], l = u.id.replace("%s", this.id_), d = [a, l].join(" ").trim();
    return ["<" + s + ' id="' + l + '" class="' + (s === "label" ? "vjs-label" : "") + '">', this.localize(u.label), "</" + s + ">", '<select aria-labelledby="' + d + '">'].concat(u.options.map(function(h) {
      var f = l + "-" + h[1].replace(/\W+/g, "");
      return ['<option id="' + f + '" value="' + h[0] + '" ', 'aria-labelledby="' + d + " " + f + '">', o.localize(h[1]), "</option>"].join("");
    })).concat("</select>").join("");
  }, r.createElFgColor_ = function() {
    var i = "captions-text-legend-" + this.id_;
    return ['<fieldset class="vjs-fg-color vjs-track-setting">', '<legend id="' + i + '">', this.localize("Text"), "</legend>", this.createElSelect_("color", i), '<span class="vjs-text-opacity vjs-opacity">', this.createElSelect_("textOpacity", i), "</span>", "</fieldset>"].join("");
  }, r.createElBgColor_ = function() {
    var i = "captions-background-" + this.id_;
    return ['<fieldset class="vjs-bg-color vjs-track-setting">', '<legend id="' + i + '">', this.localize("Background"), "</legend>", this.createElSelect_("backgroundColor", i), '<span class="vjs-bg-opacity vjs-opacity">', this.createElSelect_("backgroundOpacity", i), "</span>", "</fieldset>"].join("");
  }, r.createElWinColor_ = function() {
    var i = "captions-window-" + this.id_;
    return ['<fieldset class="vjs-window-color vjs-track-setting">', '<legend id="' + i + '">', this.localize("Window"), "</legend>", this.createElSelect_("windowColor", i), '<span class="vjs-window-opacity vjs-opacity">', this.createElSelect_("windowOpacity", i), "</span>", "</fieldset>"].join("");
  }, r.createElColors_ = function() {
    return Ge("div", {
      className: "vjs-track-settings-colors",
      innerHTML: [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()].join("")
    });
  }, r.createElFont_ = function() {
    return Ge("div", {
      className: "vjs-track-settings-font",
      innerHTML: ['<fieldset class="vjs-font-percent vjs-track-setting">', this.createElSelect_("fontPercent", "", "legend"), "</fieldset>", '<fieldset class="vjs-edge-style vjs-track-setting">', this.createElSelect_("edgeStyle", "", "legend"), "</fieldset>", '<fieldset class="vjs-font-family vjs-track-setting">', this.createElSelect_("fontFamily", "", "legend"), "</fieldset>"].join("")
    });
  }, r.createElControls_ = function() {
    var i = this.localize("restore all settings to the default values");
    return Ge("div", {
      className: "vjs-track-settings-controls",
      innerHTML: ['<button type="button" class="vjs-default-button" title="' + i + '">', this.localize("Reset"), '<span class="vjs-control-text"> ' + i + "</span>", "</button>", '<button type="button" class="vjs-done-button">' + this.localize("Done") + "</button>"].join("")
    });
  }, r.content = function() {
    return [this.createElColors_(), this.createElFont_(), this.createElControls_()];
  }, r.label = function() {
    return this.localize("Caption Settings Dialog");
  }, r.description = function() {
    return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
  }, r.buildCSSClass = function() {
    return t.prototype.buildCSSClass.call(this) + " vjs-text-track-settings";
  }, r.getValues = function() {
    var i = this;
    return Tx(gn, function(a, s, o) {
      var u = LC(i.$(s.selector), s.parser);
      return u !== void 0 && (a[o] = u), a;
    }, {});
  }, r.setValues = function(i) {
    var a = this;
    fa(gn, function(s, o) {
      IC(a.$(s.selector), i[o], s.parser);
    });
  }, r.setDefaults = function() {
    var i = this;
    fa(gn, function(a) {
      var s = a.hasOwnProperty("default") ? a.default : 0;
      i.$(a.selector).selectedIndex = s;
    });
  }, r.restoreSettings = function() {
    var i;
    try {
      i = JSON.parse(M.localStorage.getItem(jl));
    } catch (a) {
      Fe.warn(a);
    }
    i && this.setValues(i);
  }, r.saveSettings = function() {
    if (this.options_.persistTextTrackSettings) {
      var i = this.getValues();
      try {
        Object.keys(i).length ? M.localStorage.setItem(jl, JSON.stringify(i)) : M.localStorage.removeItem(jl);
      } catch (a) {
        Fe.warn(a);
      }
    }
  }, r.updateDisplay = function() {
    var i = this.player_.getChild("textTrackDisplay");
    i && i.updateDisplay();
  }, r.conditionalBlur_ = function() {
    this.previouslyActiveEl_ = null;
    var i = this.player_.controlBar, a = i && i.subsCapsButton, s = i && i.captionsButton;
    a ? a.focus() : s && s.focus();
  }, e;
}(Ba);
ee.registerComponent("TextTrackSettings", DC);
var RC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a, s = i.ResizeObserver || M.ResizeObserver;
    i.ResizeObserver === null && (s = !1);
    var o = mt({
      createEl: !s,
      reportTouchActivity: !1
    }, i);
    return a = t.call(this, n, o) || this, a.ResizeObserver = i.ResizeObserver || M.ResizeObserver, a.loadListener_ = null, a.resizeObserver_ = null, a.debouncedHandler_ = Ix(function() {
      a.resizeHandler();
    }, 100, !1, Le(a)), s ? (a.resizeObserver_ = new a.ResizeObserver(a.debouncedHandler_), a.resizeObserver_.observe(n.el())) : (a.loadListener_ = function() {
      if (!(!a.el_ || !a.el_.contentWindow)) {
        var u = a.debouncedHandler_, l = a.unloadListener_ = function() {
          Xt(this, "resize", u), Xt(this, "unload", l), l = null;
        };
        Ei(a.el_.contentWindow, "unload", l), Ei(a.el_.contentWindow, "resize", u);
      }
    }, a.one("load", a.loadListener_)), a;
  }
  var r = e.prototype;
  return r.createEl = function() {
    return t.prototype.createEl.call(this, "iframe", {
      className: "vjs-resize-manager",
      tabIndex: -1,
      title: this.localize("No content")
    }, {
      "aria-hidden": "true"
    });
  }, r.resizeHandler = function() {
    !this.player_ || !this.player_.trigger || this.player_.trigger("playerresize");
  }, r.dispose = function() {
    this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, t.prototype.dispose.call(this);
  }, e;
}(ee);
ee.registerComponent("ResizeManager", RC);
var OC = {
  trackingThreshold: 20,
  liveTolerance: 15
}, MC = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a, s = mt(OC, i, {
      createEl: !1
    });
    return a = t.call(this, n, s) || this, a.handleVisibilityChange_ = function(o) {
      return a.handleVisibilityChange(o);
    }, a.trackLiveHandler_ = function() {
      return a.trackLive_();
    }, a.handlePlay_ = function(o) {
      return a.handlePlay(o);
    }, a.handleFirstTimeupdate_ = function(o) {
      return a.handleFirstTimeupdate(o);
    }, a.handleSeeked_ = function(o) {
      return a.handleSeeked(o);
    }, a.seekToLiveEdge_ = function(o) {
      return a.seekToLiveEdge(o);
    }, a.reset_(), a.on(a.player_, "durationchange", function(o) {
      return a.handleDurationchange(o);
    }), a.on(a.player_, "canplay", function() {
      return a.toggleTracking();
    }), zs && "hidden" in oe && "visibilityState" in oe && a.on(oe, "visibilitychange", a.handleVisibilityChange_), a;
  }
  var r = e.prototype;
  return r.handleVisibilityChange = function() {
    this.player_.duration() === 1 / 0 && (oe.hidden ? this.stopTracking() : this.startTracking());
  }, r.trackLive_ = function() {
    var i = this.player_.seekable();
    if (!(!i || !i.length)) {
      var a = Number(M.performance.now().toFixed(4)), s = this.lastTime_ === -1 ? 0 : (a - this.lastTime_) / 1e3;
      this.lastTime_ = a, this.pastSeekEnd_ = this.pastSeekEnd() + s;
      var o = this.liveCurrentTime(), u = this.player_.currentTime(), l = this.player_.paused() || this.seekedBehindLive_ || Math.abs(o - u) > this.options_.liveTolerance;
      (!this.timeupdateSeen_ || o === 1 / 0) && (l = !1), l !== this.behindLiveEdge_ && (this.behindLiveEdge_ = l, this.trigger("liveedgechange"));
    }
  }, r.handleDurationchange = function() {
    this.toggleTracking();
  }, r.toggleTracking = function() {
    this.player_.duration() === 1 / 0 && this.liveWindow() >= this.options_.trackingThreshold ? (this.player_.options_.liveui && this.player_.addClass("vjs-liveui"), this.startTracking()) : (this.player_.removeClass("vjs-liveui"), this.stopTracking());
  }, r.startTracking = function() {
    this.isTracking() || (this.timeupdateSeen_ || (this.timeupdateSeen_ = this.player_.hasStarted()), this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, ji), this.trackLive_(), this.on(this.player_, ["play", "pause"], this.trackLiveHandler_), this.timeupdateSeen_ ? this.on(this.player_, "seeked", this.handleSeeked_) : (this.one(this.player_, "play", this.handlePlay_), this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_)));
  }, r.handleFirstTimeupdate = function() {
    this.timeupdateSeen_ = !0, this.on(this.player_, "seeked", this.handleSeeked_);
  }, r.handleSeeked = function() {
    var i = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
    this.seekedBehindLive_ = this.nextSeekedFromUser_ && i > 2, this.nextSeekedFromUser_ = !1, this.trackLive_();
  }, r.handlePlay = function() {
    this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
  }, r.reset_ = function() {
    this.lastTime_ = -1, this.pastSeekEnd_ = 0, this.lastSeekEnd_ = -1, this.behindLiveEdge_ = !0, this.timeupdateSeen_ = !1, this.seekedBehindLive_ = !1, this.nextSeekedFromUser_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.off(this.player_, ["play", "pause"], this.trackLiveHandler_), this.off(this.player_, "seeked", this.handleSeeked_), this.off(this.player_, "play", this.handlePlay_), this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_), this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
  }, r.nextSeekedFromUser = function() {
    this.nextSeekedFromUser_ = !0;
  }, r.stopTracking = function() {
    this.isTracking() && (this.reset_(), this.trigger("liveedgechange"));
  }, r.seekableEnd = function() {
    for (var i = this.player_.seekable(), a = [], s = i ? i.length : 0; s--; )
      a.push(i.end(s));
    return a.length ? a.sort()[a.length - 1] : 1 / 0;
  }, r.seekableStart = function() {
    for (var i = this.player_.seekable(), a = [], s = i ? i.length : 0; s--; )
      a.push(i.start(s));
    return a.length ? a.sort()[0] : 0;
  }, r.liveWindow = function() {
    var i = this.liveCurrentTime();
    return i === 1 / 0 ? 0 : i - this.seekableStart();
  }, r.isLive = function() {
    return this.isTracking();
  }, r.atLiveEdge = function() {
    return !this.behindLiveEdge();
  }, r.liveCurrentTime = function() {
    return this.pastSeekEnd() + this.seekableEnd();
  }, r.pastSeekEnd = function() {
    var i = this.seekableEnd();
    return this.lastSeekEnd_ !== -1 && i !== this.lastSeekEnd_ && (this.pastSeekEnd_ = 0), this.lastSeekEnd_ = i, this.pastSeekEnd_;
  }, r.behindLiveEdge = function() {
    return this.behindLiveEdge_;
  }, r.isTracking = function() {
    return typeof this.trackingInterval_ == "number";
  }, r.seekToLiveEdge = function() {
    this.seekedBehindLive_ = !1, !this.atLiveEdge() && (this.nextSeekedFromUser_ = !1, this.player_.currentTime(this.liveCurrentTime()));
  }, r.dispose = function() {
    this.off(oe, "visibilitychange", this.handleVisibilityChange_), this.stopTracking(), t.prototype.dispose.call(this);
  }, e;
}(ee);
ee.registerComponent("LiveTracker", MC);
var Sc = function(e) {
  var r = e.el();
  if (r.hasAttribute("src"))
    return e.triggerSourceset(r.src), !0;
  var n = e.$$("source"), i = [], a = "";
  if (!n.length)
    return !1;
  for (var s = 0; s < n.length; s++) {
    var o = n[s].src;
    o && i.indexOf(o) === -1 && i.push(o);
  }
  return i.length ? (i.length === 1 && (a = i[0]), e.triggerSourceset(a), !0) : !1;
}, NC = Object.defineProperty({}, "innerHTML", {
  get: function() {
    return this.cloneNode(!0).innerHTML;
  },
  set: function(e) {
    var r = oe.createElement(this.nodeName.toLowerCase());
    r.innerHTML = e;
    for (var n = oe.createDocumentFragment(); r.childNodes.length; )
      n.appendChild(r.childNodes[0]);
    return this.innerText = "", M.Element.prototype.appendChild.call(this, n), this.innerHTML;
  }
}), h0 = function(e, r) {
  for (var n = {}, i = 0; i < e.length && (n = Object.getOwnPropertyDescriptor(e[i], r), !(n && n.set && n.get)); i++)
    ;
  return n.enumerable = !0, n.configurable = !0, n;
}, BC = function(e) {
  return h0([e.el(), M.HTMLMediaElement.prototype, M.Element.prototype, NC], "innerHTML");
}, Zp = function(e) {
  var r = e.el();
  if (!r.resetSourceWatch_) {
    var n = {}, i = BC(e), a = function(o) {
      return function() {
        for (var u = arguments.length, l = new Array(u), d = 0; d < u; d++)
          l[d] = arguments[d];
        var h = o.apply(r, l);
        return Sc(e), h;
      };
    };
    ["append", "appendChild", "insertAdjacentHTML"].forEach(function(s) {
      r[s] && (n[s] = r[s], r[s] = a(n[s]));
    }), Object.defineProperty(r, "innerHTML", mt(i, {
      set: a(i.set)
    })), r.resetSourceWatch_ = function() {
      r.resetSourceWatch_ = null, Object.keys(n).forEach(function(s) {
        r[s] = n[s];
      }), Object.defineProperty(r, "innerHTML", i);
    }, e.one("sourceset", r.resetSourceWatch_);
  }
}, FC = Object.defineProperty({}, "src", {
  get: function() {
    return this.hasAttribute("src") ? Uy(M.Element.prototype.getAttribute.call(this, "src")) : "";
  },
  set: function(e) {
    return M.Element.prototype.setAttribute.call(this, "src", e), e;
  }
}), UC = function(e) {
  return h0([e.el(), M.HTMLMediaElement.prototype, FC], "src");
}, VC = function(e) {
  if (e.featuresSourceset) {
    var r = e.el();
    if (!r.resetSourceset_) {
      var n = UC(e), i = r.setAttribute, a = r.load;
      Object.defineProperty(r, "src", mt(n, {
        set: function(o) {
          var u = n.set.call(r, o);
          return e.triggerSourceset(r.src), u;
        }
      })), r.setAttribute = function(s, o) {
        var u = i.call(r, s, o);
        return /src/i.test(s) && e.triggerSourceset(r.src), u;
      }, r.load = function() {
        var s = a.call(r);
        return Sc(e) || (e.triggerSourceset(""), Zp(e)), s;
      }, r.currentSrc ? e.triggerSourceset(r.currentSrc) : Sc(e) || Zp(e), r.resetSourceset_ = function() {
        r.resetSourceset_ = null, r.load = a, r.setAttribute = i, Object.defineProperty(r, "src", n), r.resetSourceWatch_ && r.resetSourceWatch_();
      };
    }
  }
}, Jh = function(e, r, n, i) {
  i === void 0 && (i = !0);
  var a = function(u) {
    return Object.defineProperty(e, r, {
      value: u,
      enumerable: !0,
      writable: !0
    });
  }, s = {
    configurable: !0,
    enumerable: !0,
    get: function() {
      var u = n();
      return a(u), u;
    }
  };
  return i && (s.set = a), Object.defineProperty(e, r, s);
}, pe = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    a = t.call(this, n, i) || this;
    var s = n.source, o = !1;
    if (a.featuresVideoFrameCallback = a.featuresVideoFrameCallback && a.el_.tagName === "VIDEO", s && (a.el_.currentSrc !== s.src || n.tag && n.tag.initNetworkState_ === 3) ? a.setSource(s) : a.handleLateInit_(a.el_), n.enableSourceset && a.setupSourcesetHandling_(), a.isScrubbing_ = !1, a.el_.hasChildNodes()) {
      for (var u = a.el_.childNodes, l = u.length, d = []; l--; ) {
        var h = u[l], f = h.nodeName.toLowerCase();
        f === "track" && (a.featuresNativeTextTracks ? (a.remoteTextTrackEls().addTrackElement_(h), a.remoteTextTracks().addTrack(h.track), a.textTracks().addTrack(h.track), !o && !a.el_.hasAttribute("crossorigin") && Ku(h.src) && (o = !0)) : d.push(h));
      }
      for (var v = 0; v < d.length; v++)
        a.el_.removeChild(d[v]);
    }
    return a.proxyNativeTracks_(), a.featuresNativeTextTracks && o && Fe.warn(`Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.
This may prevent text tracks from loading.`), a.restoreMetadataTracksInIOSNativePlayer_(), (xa || wh || hy) && n.nativeControlsForTouch === !0 && a.setControls(!0), a.proxyWebkitFullscreen_(), a.triggerReady(), a;
  }
  var r = e.prototype;
  return r.dispose = function() {
    this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), e.disposeMediaElement(this.el_), this.options_ = null, t.prototype.dispose.call(this);
  }, r.setupSourcesetHandling_ = function() {
    VC(this);
  }, r.restoreMetadataTracksInIOSNativePlayer_ = function() {
    var i = this.textTracks(), a, s = function() {
      a = [];
      for (var l = 0; l < i.length; l++) {
        var d = i[l];
        d.kind === "metadata" && a.push({
          track: d,
          storedMode: d.mode
        });
      }
    };
    s(), i.addEventListener("change", s), this.on("dispose", function() {
      return i.removeEventListener("change", s);
    });
    var o = function u() {
      for (var l = 0; l < a.length; l++) {
        var d = a[l];
        d.track.mode === "disabled" && d.track.mode !== d.storedMode && (d.track.mode = d.storedMode);
      }
      i.removeEventListener("change", u);
    };
    this.on("webkitbeginfullscreen", function() {
      i.removeEventListener("change", s), i.removeEventListener("change", o), i.addEventListener("change", o);
    }), this.on("webkitendfullscreen", function() {
      i.removeEventListener("change", s), i.addEventListener("change", s), i.removeEventListener("change", o);
    });
  }, r.overrideNative_ = function(i, a) {
    var s = this;
    if (a === this["featuresNative" + i + "Tracks"]) {
      var o = i.toLowerCase();
      this[o + "TracksListeners_"] && Object.keys(this[o + "TracksListeners_"]).forEach(function(u) {
        var l = s.el()[o + "Tracks"];
        l.removeEventListener(u, s[o + "TracksListeners_"][u]);
      }), this["featuresNative" + i + "Tracks"] = !a, this[o + "TracksListeners_"] = null, this.proxyNativeTracksForType_(o);
    }
  }, r.overrideNativeAudioTracks = function(i) {
    this.overrideNative_("Audio", i);
  }, r.overrideNativeVideoTracks = function(i) {
    this.overrideNative_("Video", i);
  }, r.proxyNativeTracksForType_ = function(i) {
    var a = this, s = Pi[i], o = this.el()[s.getterName], u = this[s.getterName]();
    if (!(!this["featuresNative" + s.capitalName + "Tracks"] || !o || !o.addEventListener)) {
      var l = {
        change: function(f) {
          var v = {
            type: "change",
            target: u,
            currentTarget: u,
            srcElement: u
          };
          u.trigger(v), i === "text" && a[Pa.remoteText.getterName]().trigger(v);
        },
        addtrack: function(f) {
          u.addTrack(f.track);
        },
        removetrack: function(f) {
          u.removeTrack(f.track);
        }
      }, d = function() {
        for (var f = [], v = 0; v < u.length; v++) {
          for (var b = !1, _ = 0; _ < o.length; _++)
            if (o[_] === u[v]) {
              b = !0;
              break;
            }
          b || f.push(u[v]);
        }
        for (; f.length; )
          u.removeTrack(f.shift());
      };
      this[s.getterName + "Listeners_"] = l, Object.keys(l).forEach(function(h) {
        var f = l[h];
        o.addEventListener(h, f), a.on("dispose", function(v) {
          return o.removeEventListener(h, f);
        });
      }), this.on("loadstart", d), this.on("dispose", function(h) {
        return a.off("loadstart", d);
      });
    }
  }, r.proxyNativeTracks_ = function() {
    var i = this;
    Pi.names.forEach(function(a) {
      i.proxyNativeTracksForType_(a);
    });
  }, r.createEl = function() {
    var i = this.options_.tag;
    if (!i || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
      if (i) {
        var a = i.cloneNode(!0);
        i.parentNode && i.parentNode.insertBefore(a, i), e.disposeMediaElement(i), i = a;
      } else {
        i = oe.createElement("video");
        var s = this.options_.tag && _r(this.options_.tag), o = mt({}, s);
        (!xa || this.options_.nativeControlsForTouch !== !0) && delete o.controls, Ty(i, At(o, {
          id: this.options_.techId,
          class: "vjs-tech"
        }));
      }
      i.playerId = this.options_.playerId;
    }
    typeof this.options_.preload < "u" && Ca(i, "preload", this.options_.preload), this.options_.disablePictureInPicture !== void 0 && (i.disablePictureInPicture = this.options_.disablePictureInPicture);
    for (var u = ["loop", "muted", "playsinline", "autoplay"], l = 0; l < u.length; l++) {
      var d = u[l], h = this.options_[d];
      typeof h < "u" && (h ? Ca(i, d, d) : Wu(i, d), i[d] = h);
    }
    return i;
  }, r.handleLateInit_ = function(i) {
    if (!(i.networkState === 0 || i.networkState === 3)) {
      if (i.readyState === 0) {
        var a = !1, s = function() {
          a = !0;
        };
        this.on("loadstart", s);
        var o = function() {
          a || this.trigger("loadstart");
        };
        this.on("loadedmetadata", o), this.ready(function() {
          this.off("loadstart", s), this.off("loadedmetadata", o), a || this.trigger("loadstart");
        });
        return;
      }
      var u = ["loadstart"];
      u.push("loadedmetadata"), i.readyState >= 2 && u.push("loadeddata"), i.readyState >= 3 && u.push("canplay"), i.readyState >= 4 && u.push("canplaythrough"), this.ready(function() {
        u.forEach(function(l) {
          this.trigger(l);
        }, this);
      });
    }
  }, r.setScrubbing = function(i) {
    this.isScrubbing_ = i;
  }, r.scrubbing = function() {
    return this.isScrubbing_;
  }, r.setCurrentTime = function(i) {
    try {
      this.isScrubbing_ && this.el_.fastSeek && Hu ? this.el_.fastSeek(i) : this.el_.currentTime = i;
    } catch (a) {
      Fe(a, "Video is not ready. (Video.js)");
    }
  }, r.duration = function() {
    var i = this;
    if (this.el_.duration === 1 / 0 && Or && Mr && this.el_.currentTime === 0) {
      var a = function s() {
        i.el_.currentTime > 0 && (i.el_.duration === 1 / 0 && i.trigger("durationchange"), i.off("timeupdate", s));
      };
      return this.on("timeupdate", a), NaN;
    }
    return this.el_.duration || NaN;
  }, r.width = function() {
    return this.el_.offsetWidth;
  }, r.height = function() {
    return this.el_.offsetHeight;
  }, r.proxyWebkitFullscreen_ = function() {
    var i = this;
    if ("webkitDisplayingFullscreen" in this.el_) {
      var a = function() {
        this.trigger("fullscreenchange", {
          isFullscreen: !1
        }), this.el_.controls && !this.options_.nativeControlsForTouch && this.controls() && (this.el_.controls = !1);
      }, s = function() {
        "webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture" && (this.one("webkitendfullscreen", a), this.trigger("fullscreenchange", {
          isFullscreen: !0,
          // set a flag in case another tech triggers fullscreenchange
          nativeIOSFullscreen: !0
        }));
      };
      this.on("webkitbeginfullscreen", s), this.on("dispose", function() {
        i.off("webkitbeginfullscreen", s), i.off("webkitendfullscreen", a);
      });
    }
  }, r.supportsFullScreen = function() {
    if (typeof this.el_.webkitEnterFullScreen == "function") {
      var i = M.navigator && M.navigator.userAgent || "";
      if (/Android/.test(i) || !/Chrome|Mac OS X 10.5/.test(i))
        return !0;
    }
    return !1;
  }, r.enterFullScreen = function() {
    var i = this.el_;
    if (i.paused && i.networkState <= i.HAVE_METADATA)
      er(this.el_.play()), this.setTimeout(function() {
        i.pause();
        try {
          i.webkitEnterFullScreen();
        } catch (a) {
          this.trigger("fullscreenerror", a);
        }
      }, 0);
    else
      try {
        i.webkitEnterFullScreen();
      } catch (a) {
        this.trigger("fullscreenerror", a);
      }
  }, r.exitFullScreen = function() {
    if (!this.el_.webkitDisplayingFullscreen) {
      this.trigger("fullscreenerror", new Error("The video is not fullscreen"));
      return;
    }
    this.el_.webkitExitFullScreen();
  }, r.requestPictureInPicture = function() {
    return this.el_.requestPictureInPicture();
  }, r.requestVideoFrameCallback = function(i) {
    return this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.requestVideoFrameCallback(i) : t.prototype.requestVideoFrameCallback.call(this, i);
  }, r.cancelVideoFrameCallback = function(i) {
    this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.cancelVideoFrameCallback(i) : t.prototype.cancelVideoFrameCallback.call(this, i);
  }, r.src = function(i) {
    if (i === void 0)
      return this.el_.src;
    this.setSrc(i);
  }, r.reset = function() {
    e.resetMediaElement(this.el_);
  }, r.currentSrc = function() {
    return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc;
  }, r.setControls = function(i) {
    this.el_.controls = !!i;
  }, r.addTextTrack = function(i, a, s) {
    return this.featuresNativeTextTracks ? this.el_.addTextTrack(i, a, s) : t.prototype.addTextTrack.call(this, i, a, s);
  }, r.createRemoteTextTrack = function(i) {
    if (!this.featuresNativeTextTracks)
      return t.prototype.createRemoteTextTrack.call(this, i);
    var a = oe.createElement("track");
    return i.kind && (a.kind = i.kind), i.label && (a.label = i.label), (i.language || i.srclang) && (a.srclang = i.language || i.srclang), i.default && (a.default = i.default), i.id && (a.id = i.id), i.src && (a.src = i.src), a;
  }, r.addRemoteTextTrack = function(i, a) {
    var s = t.prototype.addRemoteTextTrack.call(this, i, a);
    return this.featuresNativeTextTracks && this.el().appendChild(s), s;
  }, r.removeRemoteTextTrack = function(i) {
    if (t.prototype.removeRemoteTextTrack.call(this, i), this.featuresNativeTextTracks)
      for (var a = this.$$("track"), s = a.length; s--; )
        (i === a[s] || i === a[s].track) && this.el().removeChild(a[s]);
  }, r.getVideoPlaybackQuality = function() {
    if (typeof this.el().getVideoPlaybackQuality == "function")
      return this.el().getVideoPlaybackQuality();
    var i = {};
    return typeof this.el().webkitDroppedFrameCount < "u" && typeof this.el().webkitDecodedFrameCount < "u" && (i.droppedVideoFrames = this.el().webkitDroppedFrameCount, i.totalVideoFrames = this.el().webkitDecodedFrameCount), M.performance && typeof M.performance.now == "function" ? i.creationTime = M.performance.now() : M.performance && M.performance.timing && typeof M.performance.timing.navigationStart == "number" && (i.creationTime = M.Date.now() - M.performance.timing.navigationStart), i;
  }, e;
}(ot);
Jh(pe, "TEST_VID", function() {
  if (Oa()) {
    var t = oe.createElement("video"), e = oe.createElement("track");
    return e.kind = "captions", e.srclang = "en", e.label = "English", t.appendChild(e), t;
  }
});
pe.isSupported = function() {
  try {
    pe.TEST_VID.volume = 0.5;
  } catch {
    return !1;
  }
  return !!(pe.TEST_VID && pe.TEST_VID.canPlayType);
};
pe.canPlayType = function(t) {
  return pe.TEST_VID.canPlayType(t);
};
pe.canPlaySource = function(t, e) {
  return pe.canPlayType(t.type);
};
pe.canControlVolume = function() {
  try {
    var t = pe.TEST_VID.volume;
    pe.TEST_VID.volume = t / 2 + 0.1;
    var e = t !== pe.TEST_VID.volume;
    return e && ui ? (M.setTimeout(function() {
      pe && pe.prototype && (pe.prototype.featuresVolumeControl = t !== pe.TEST_VID.volume);
    }), !1) : e;
  } catch {
    return !1;
  }
};
pe.canMuteVolume = function() {
  try {
    var t = pe.TEST_VID.muted;
    return pe.TEST_VID.muted = !t, pe.TEST_VID.muted ? Ca(pe.TEST_VID, "muted", "muted") : Wu(pe.TEST_VID, "muted", "muted"), t !== pe.TEST_VID.muted;
  } catch {
    return !1;
  }
};
pe.canControlPlaybackRate = function() {
  if (Or && Mr && py < 58)
    return !1;
  try {
    var t = pe.TEST_VID.playbackRate;
    return pe.TEST_VID.playbackRate = t / 2 + 0.1, t !== pe.TEST_VID.playbackRate;
  } catch {
    return !1;
  }
};
pe.canOverrideAttributes = function() {
  try {
    var t = function() {
    };
    Object.defineProperty(oe.createElement("video"), "src", {
      get: t,
      set: t
    }), Object.defineProperty(oe.createElement("audio"), "src", {
      get: t,
      set: t
    }), Object.defineProperty(oe.createElement("video"), "innerHTML", {
      get: t,
      set: t
    }), Object.defineProperty(oe.createElement("audio"), "innerHTML", {
      get: t,
      set: t
    });
  } catch {
    return !1;
  }
  return !0;
};
pe.supportsNativeTextTracks = function() {
  return Hu || ui && Mr;
};
pe.supportsNativeVideoTracks = function() {
  return !!(pe.TEST_VID && pe.TEST_VID.videoTracks);
};
pe.supportsNativeAudioTracks = function() {
  return !!(pe.TEST_VID && pe.TEST_VID.audioTracks);
};
pe.Events = ["loadstart", "suspend", "abort", "error", "emptied", "stalled", "loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing", "waiting", "seeking", "seeked", "ended", "durationchange", "timeupdate", "progress", "play", "pause", "ratechange", "resize", "volumechange"];
[["featuresMuteControl", "canMuteVolume"], ["featuresPlaybackRate", "canControlPlaybackRate"], ["featuresSourceset", "canOverrideAttributes"], ["featuresNativeTextTracks", "supportsNativeTextTracks"], ["featuresNativeVideoTracks", "supportsNativeVideoTracks"], ["featuresNativeAudioTracks", "supportsNativeAudioTracks"]].forEach(function(t) {
  var e = t[0], r = t[1];
  Jh(pe.prototype, e, function() {
    return pe[r]();
  }, !0);
});
pe.prototype.featuresVolumeControl = pe.canControlVolume();
pe.prototype.movingMediaElementInDOM = !ui;
pe.prototype.featuresFullscreenResize = !0;
pe.prototype.featuresProgressEvents = !0;
pe.prototype.featuresTimeupdateEvents = !0;
pe.prototype.featuresVideoFrameCallback = !!(pe.TEST_VID && pe.TEST_VID.requestVideoFrameCallback);
var du;
pe.patchCanPlayType = function() {
  xh >= 4 && !fy && !Mr && (du = pe.TEST_VID && pe.TEST_VID.constructor.prototype.canPlayType, pe.TEST_VID.constructor.prototype.canPlayType = function(t) {
    var e = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
    return t && e.test(t) ? "maybe" : du.call(this, t);
  });
};
pe.unpatchCanPlayType = function() {
  var t = pe.TEST_VID.constructor.prototype.canPlayType;
  return du && (pe.TEST_VID.constructor.prototype.canPlayType = du), t;
};
pe.patchCanPlayType();
pe.disposeMediaElement = function(t) {
  if (t) {
    for (t.parentNode && t.parentNode.removeChild(t); t.hasChildNodes(); )
      t.removeChild(t.firstChild);
    t.removeAttribute("src"), typeof t.load == "function" && function() {
      try {
        t.load();
      } catch {
      }
    }();
  }
};
pe.resetMediaElement = function(t) {
  if (t) {
    for (var e = t.querySelectorAll("source"), r = e.length; r--; )
      t.removeChild(e[r]);
    t.removeAttribute("src"), typeof t.load == "function" && function() {
      try {
        t.load();
      } catch {
      }
    }();
  }
};
[
  /**
   * Get the value of `muted` from the media element. `muted` indicates
   * that the volume for the media should be set to silent. This does not actually change
   * the `volume` attribute.
   *
   * @method Html5#muted
   * @return {boolean}
   *         - True if the value of `volume` should be ignored and the audio set to silent.
   *         - False if the value of `volume` should be used.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
   */
  "muted",
  /**
   * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
   * whether the media should start muted or not. Only changes the default state of the
   * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
   * current state.
   *
   * @method Html5#defaultMuted
   * @return {boolean}
   *         - The value of `defaultMuted` from the media element.
   *         - True indicates that the media should start muted.
   *         - False indicates that the media should not start muted
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
   */
  "defaultMuted",
  /**
   * Get the value of `autoplay` from the media element. `autoplay` indicates
   * that the media should start to play as soon as the page is ready.
   *
   * @method Html5#autoplay
   * @return {boolean}
   *         - The value of `autoplay` from the media element.
   *         - True indicates that the media should start as soon as the page loads.
   *         - False indicates that the media should not start as soon as the page loads.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
   */
  "autoplay",
  /**
   * Get the value of `controls` from the media element. `controls` indicates
   * whether the native media controls should be shown or hidden.
   *
   * @method Html5#controls
   * @return {boolean}
   *         - The value of `controls` from the media element.
   *         - True indicates that native controls should be showing.
   *         - False indicates that native controls should be hidden.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
   */
  "controls",
  /**
   * Get the value of `loop` from the media element. `loop` indicates
   * that the media should return to the start of the media and continue playing once
   * it reaches the end.
   *
   * @method Html5#loop
   * @return {boolean}
   *         - The value of `loop` from the media element.
   *         - True indicates that playback should seek back to start once
   *           the end of a media is reached.
   *         - False indicates that playback should not loop back to the start when the
   *           end of the media is reached.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
   */
  "loop",
  /**
   * Get the value of `playsinline` from the media element. `playsinline` indicates
   * to the browser that non-fullscreen playback is preferred when fullscreen
   * playback is the native default, such as in iOS Safari.
   *
   * @method Html5#playsinline
   * @return {boolean}
   *         - The value of `playsinline` from the media element.
   *         - True indicates that the media should play inline.
   *         - False indicates that the media should not play inline.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  "playsinline"
].forEach(function(t) {
  pe.prototype[t] = function() {
    return this.el_[t] || this.el_.hasAttribute(t);
  };
});
[
  /**
   * Set the value of `muted` on the media element. `muted` indicates that the current
   * audio level should be silent.
   *
   * @method Html5#setMuted
   * @param {boolean} muted
   *        - True if the audio should be set to silent
   *        - False otherwise
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
   */
  "muted",
  /**
   * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
   * audio level should be silent, but will only effect the muted level on initial playback..
   *
   * @method Html5.prototype.setDefaultMuted
   * @param {boolean} defaultMuted
   *        - True if the audio should be set to silent
   *        - False otherwise
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
   */
  "defaultMuted",
  /**
   * Set the value of `autoplay` on the media element. `autoplay` indicates
   * that the media should start to play as soon as the page is ready.
   *
   * @method Html5#setAutoplay
   * @param {boolean} autoplay
   *         - True indicates that the media should start as soon as the page loads.
   *         - False indicates that the media should not start as soon as the page loads.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
   */
  "autoplay",
  /**
   * Set the value of `loop` on the media element. `loop` indicates
   * that the media should return to the start of the media and continue playing once
   * it reaches the end.
   *
   * @method Html5#setLoop
   * @param {boolean} loop
   *         - True indicates that playback should seek back to start once
   *           the end of a media is reached.
   *         - False indicates that playback should not loop back to the start when the
   *           end of the media is reached.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
   */
  "loop",
  /**
   * Set the value of `playsinline` from the media element. `playsinline` indicates
   * to the browser that non-fullscreen playback is preferred when fullscreen
   * playback is the native default, such as in iOS Safari.
   *
   * @method Html5#setPlaysinline
   * @param {boolean} playsinline
   *         - True indicates that the media should play inline.
   *         - False indicates that the media should not play inline.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
   */
  "playsinline"
].forEach(function(t) {
  pe.prototype["set" + It(t)] = function(e) {
    this.el_[t] = e, e ? this.el_.setAttribute(t, t) : this.el_.removeAttribute(t);
  };
});
[
  /**
   * Get the value of `paused` from the media element. `paused` indicates whether the media element
   * is currently paused or not.
   *
   * @method Html5#paused
   * @return {boolean}
   *         The value of `paused` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
   */
  "paused",
  /**
   * Get the value of `currentTime` from the media element. `currentTime` indicates
   * the current second that the media is at in playback.
   *
   * @method Html5#currentTime
   * @return {number}
   *         The value of `currentTime` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
   */
  "currentTime",
  /**
   * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
   * object that represents the parts of the media that are already downloaded and
   * available for playback.
   *
   * @method Html5#buffered
   * @return {TimeRange}
   *         The value of `buffered` from the media element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
   */
  "buffered",
  /**
   * Get the value of `volume` from the media element. `volume` indicates
   * the current playback volume of audio for a media. `volume` will be a value from 0
   * (silent) to 1 (loudest and default).
   *
   * @method Html5#volume
   * @return {number}
   *         The value of `volume` from the media element. Value will be between 0-1.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
   */
  "volume",
  /**
   * Get the value of `poster` from the media element. `poster` indicates
   * that the url of an image file that can/will be shown when no media data is available.
   *
   * @method Html5#poster
   * @return {string}
   *         The value of `poster` from the media element. Value will be a url to an
   *         image.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
   */
  "poster",
  /**
   * Get the value of `preload` from the media element. `preload` indicates
   * what should download before the media is interacted with. It can have the following
   * values:
   * - none: nothing should be downloaded
   * - metadata: poster and the first few frames of the media may be downloaded to get
   *   media dimensions and other metadata
   * - auto: allow the media and metadata for the media to be downloaded before
   *    interaction
   *
   * @method Html5#preload
   * @return {string}
   *         The value of `preload` from the media element. Will be 'none', 'metadata',
   *         or 'auto'.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
   */
  "preload",
  /**
   * Get the value of the `error` from the media element. `error` indicates any
   * MediaError that may have occurred during playback. If error returns null there is no
   * current error.
   *
   * @method Html5#error
   * @return {MediaError|null}
   *         The value of `error` from the media element. Will be `MediaError` if there
   *         is a current error and null otherwise.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
   */
  "error",
  /**
   * Get the value of `seeking` from the media element. `seeking` indicates whether the
   * media is currently seeking to a new position or not.
   *
   * @method Html5#seeking
   * @return {boolean}
   *         - The value of `seeking` from the media element.
   *         - True indicates that the media is currently seeking to a new position.
   *         - False indicates that the media is not seeking to a new position at this time.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
   */
  "seeking",
  /**
   * Get the value of `seekable` from the media element. `seekable` returns a
   * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
   *
   * @method Html5#seekable
   * @return {TimeRange}
   *         The value of `seekable` from the media element. A `TimeRange` object
   *         indicating the current ranges of time that can be seeked to.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
   */
  "seekable",
  /**
   * Get the value of `ended` from the media element. `ended` indicates whether
   * the media has reached the end or not.
   *
   * @method Html5#ended
   * @return {boolean}
   *         - The value of `ended` from the media element.
   *         - True indicates that the media has ended.
   *         - False indicates that the media has not ended.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
   */
  "ended",
  /**
   * Get the value of `playbackRate` from the media element. `playbackRate` indicates
   * the rate at which the media is currently playing back. Examples:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5#playbackRate
   * @return {number}
   *         The value of `playbackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "playbackRate",
  /**
   * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
   * the rate at which the media is currently playing back. This value will not indicate the current
   * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
   *
   * Examples:
   *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
   *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5.prototype.defaultPlaybackRate
   * @return {number}
   *         The value of `defaultPlaybackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "defaultPlaybackRate",
  /**
   * Get the value of 'disablePictureInPicture' from the video element.
   *
   * @method Html5#disablePictureInPicture
   * @return {boolean} value
   *         - The value of `disablePictureInPicture` from the video element.
   *         - True indicates that the video can't be played in Picture-In-Picture mode
   *         - False indicates that the video can be played in Picture-In-Picture mode
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
   */
  "disablePictureInPicture",
  /**
   * Get the value of `played` from the media element. `played` returns a `TimeRange`
   * object representing points in the media timeline that have been played.
   *
   * @method Html5#played
   * @return {TimeRange}
   *         The value of `played` from the media element. A `TimeRange` object indicating
   *         the ranges of time that have been played.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
   */
  "played",
  /**
   * Get the value of `networkState` from the media element. `networkState` indicates
   * the current network state. It returns an enumeration from the following list:
   * - 0: NETWORK_EMPTY
   * - 1: NETWORK_IDLE
   * - 2: NETWORK_LOADING
   * - 3: NETWORK_NO_SOURCE
   *
   * @method Html5#networkState
   * @return {number}
   *         The value of `networkState` from the media element. This will be a number
   *         from the list in the description.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
   */
  "networkState",
  /**
   * Get the value of `readyState` from the media element. `readyState` indicates
   * the current state of the media element. It returns an enumeration from the
   * following list:
   * - 0: HAVE_NOTHING
   * - 1: HAVE_METADATA
   * - 2: HAVE_CURRENT_DATA
   * - 3: HAVE_FUTURE_DATA
   * - 4: HAVE_ENOUGH_DATA
   *
   * @method Html5#readyState
   * @return {number}
   *         The value of `readyState` from the media element. This will be a number
   *         from the list in the description.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
   */
  "readyState",
  /**
   * Get the value of `videoWidth` from the video element. `videoWidth` indicates
   * the current width of the video in css pixels.
   *
   * @method Html5#videoWidth
   * @return {number}
   *         The value of `videoWidth` from the video element. This will be a number
   *         in css pixels.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
   */
  "videoWidth",
  /**
   * Get the value of `videoHeight` from the video element. `videoHeight` indicates
   * the current height of the video in css pixels.
   *
   * @method Html5#videoHeight
   * @return {number}
   *         The value of `videoHeight` from the video element. This will be a number
   *         in css pixels.
   *
   * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
   */
  "videoHeight",
  /**
   * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
   * to the browser that should sent the cookies along with the requests for the
   * different assets/playlists
   *
   * @method Html5#crossOrigin
   * @return {string}
   *         - anonymous indicates that the media should not sent cookies.
   *         - use-credentials indicates that the media should sent cookies along the requests.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
   */
  "crossOrigin"
].forEach(function(t) {
  pe.prototype[t] = function() {
    return this.el_[t];
  };
});
[
  /**
   * Set the value of `volume` on the media element. `volume` indicates the current
   * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
   * so on.
   *
   * @method Html5#setVolume
   * @param {number} percentAsDecimal
   *        The volume percent as a decimal. Valid range is from 0-1.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
   */
  "volume",
  /**
   * Set the value of `src` on the media element. `src` indicates the current
   * {@link Tech~SourceObject} for the media.
   *
   * @method Html5#setSrc
   * @param {Tech~SourceObject} src
   *        The source object to set as the current source.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
   */
  "src",
  /**
   * Set the value of `poster` on the media element. `poster` is the url to
   * an image file that can/will be shown when no media data is available.
   *
   * @method Html5#setPoster
   * @param {string} poster
   *        The url to an image that should be used as the `poster` for the media
   *        element.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
   */
  "poster",
  /**
   * Set the value of `preload` on the media element. `preload` indicates
   * what should download before the media is interacted with. It can have the following
   * values:
   * - none: nothing should be downloaded
   * - metadata: poster and the first few frames of the media may be downloaded to get
   *   media dimensions and other metadata
   * - auto: allow the media and metadata for the media to be downloaded before
   *    interaction
   *
   * @method Html5#setPreload
   * @param {string} preload
   *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
   *         or 'auto'.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
   */
  "preload",
  /**
   * Set the value of `playbackRate` on the media element. `playbackRate` indicates
   * the rate at which the media should play back. Examples:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5#setPlaybackRate
   * @return {number}
   *         The value of `playbackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
   */
  "playbackRate",
  /**
   * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
   * the rate at which the media should play back upon initial startup. Changing this value
   * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
   *
   * Example Values:
   *   - if playbackRate is set to 2, media will play twice as fast.
   *   - if playbackRate is set to 0.5, media will play half as fast.
   *
   * @method Html5.prototype.setDefaultPlaybackRate
   * @return {number}
   *         The value of `defaultPlaybackRate` from the media element. A number indicating
   *         the current playback speed of the media, where 1 is normal speed.
   *
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
   */
  "defaultPlaybackRate",
  /**
   * Prevents the browser from suggesting a Picture-in-Picture context menu
   * or to request Picture-in-Picture automatically in some cases.
   *
   * @method Html5#setDisablePictureInPicture
   * @param {boolean} value
   *         The true value will disable Picture-in-Picture mode.
   *
   * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
   */
  "disablePictureInPicture",
  /**
   * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
   * to the browser that should sent the cookies along with the requests for the
   * different assets/playlists
   *
   * @method Html5#setCrossOrigin
   * @param {string} crossOrigin
   *         - anonymous indicates that the media should not sent cookies.
   *         - use-credentials indicates that the media should sent cookies along the requests.
   *
   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
   */
  "crossOrigin"
].forEach(function(t) {
  pe.prototype["set" + It(t)] = function(e) {
    this.el_[t] = e;
  };
});
[
  /**
   * A wrapper around the media elements `pause` function. This will call the `HTML5`
   * media elements `pause` function.
   *
   * @method Html5#pause
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
   */
  "pause",
  /**
   * A wrapper around the media elements `load` function. This will call the `HTML5`s
   * media element `load` function.
   *
   * @method Html5#load
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
   */
  "load",
  /**
   * A wrapper around the media elements `play` function. This will call the `HTML5`s
   * media element `play` function.
   *
   * @method Html5#play
   * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
   */
  "play"
].forEach(function(t) {
  pe.prototype[t] = function() {
    return this.el_[t]();
  };
});
ot.withSourceHandlers(pe);
pe.nativeSourceHandler = {};
pe.nativeSourceHandler.canPlayType = function(t) {
  try {
    return pe.TEST_VID.canPlayType(t);
  } catch {
    return "";
  }
};
pe.nativeSourceHandler.canHandleSource = function(t, e) {
  if (t.type)
    return pe.nativeSourceHandler.canPlayType(t.type);
  if (t.src) {
    var r = Oh(t.src);
    return pe.nativeSourceHandler.canPlayType("video/" + r);
  }
  return "";
};
pe.nativeSourceHandler.handleSource = function(t, e, r) {
  e.setSrc(t.src);
};
pe.nativeSourceHandler.dispose = function() {
};
pe.registerSourceHandler(pe.nativeSourceHandler);
ot.registerTech("Html5", pe);
var f0 = [
  /**
   * Fired while the user agent is downloading media data.
   *
   * @event Player#progress
   * @type {EventTarget~Event}
   */
  /**
   * Retrigger the `progress` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechProgress_
   * @fires Player#progress
   * @listens Tech#progress
   */
  "progress",
  /**
   * Fires when the loading of an audio/video is aborted.
   *
   * @event Player#abort
   * @type {EventTarget~Event}
   */
  /**
   * Retrigger the `abort` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechAbort_
   * @fires Player#abort
   * @listens Tech#abort
   */
  "abort",
  /**
   * Fires when the browser is intentionally not getting media data.
   *
   * @event Player#suspend
   * @type {EventTarget~Event}
   */
  /**
   * Retrigger the `suspend` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechSuspend_
   * @fires Player#suspend
   * @listens Tech#suspend
   */
  "suspend",
  /**
   * Fires when the current playlist is empty.
   *
   * @event Player#emptied
   * @type {EventTarget~Event}
   */
  /**
   * Retrigger the `emptied` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechEmptied_
   * @fires Player#emptied
   * @listens Tech#emptied
   */
  "emptied",
  /**
   * Fires when the browser is trying to get media data, but data is not available.
   *
   * @event Player#stalled
   * @type {EventTarget~Event}
   */
  /**
   * Retrigger the `stalled` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechStalled_
   * @fires Player#stalled
   * @listens Tech#stalled
   */
  "stalled",
  /**
   * Fires when the browser has loaded meta data for the audio/video.
   *
   * @event Player#loadedmetadata
   * @type {EventTarget~Event}
   */
  /**
   * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechLoadedmetadata_
   * @fires Player#loadedmetadata
   * @listens Tech#loadedmetadata
   */
  "loadedmetadata",
  /**
   * Fires when the browser has loaded the current frame of the audio/video.
   *
   * @event Player#loadeddata
   * @type {event}
   */
  /**
   * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechLoaddeddata_
   * @fires Player#loadeddata
   * @listens Tech#loadeddata
   */
  "loadeddata",
  /**
   * Fires when the current playback position has changed.
   *
   * @event Player#timeupdate
   * @type {event}
   */
  /**
   * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechTimeUpdate_
   * @fires Player#timeupdate
   * @listens Tech#timeupdate
   */
  "timeupdate",
  /**
   * Fires when the video's intrinsic dimensions change
   *
   * @event Player#resize
   * @type {event}
   */
  /**
   * Retrigger the `resize` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechResize_
   * @fires Player#resize
   * @listens Tech#resize
   */
  "resize",
  /**
   * Fires when the volume has been changed
   *
   * @event Player#volumechange
   * @type {event}
   */
  /**
   * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechVolumechange_
   * @fires Player#volumechange
   * @listens Tech#volumechange
   */
  "volumechange",
  /**
   * Fires when the text track has been changed
   *
   * @event Player#texttrackchange
   * @type {event}
   */
  /**
   * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
   *
   * @private
   * @method Player#handleTechTexttrackchange_
   * @fires Player#texttrackchange
   * @listens Tech#texttrackchange
   */
  "texttrackchange"
], ql = {
  canplay: "CanPlay",
  canplaythrough: "CanPlayThrough",
  playing: "Playing",
  seeked: "Seeked"
}, Ec = ["tiny", "xsmall", "small", "medium", "large", "xlarge", "huge"], Ho = {};
Ec.forEach(function(t) {
  var e = t.charAt(0) === "x" ? "x-" + t.substring(1) : t;
  Ho[t] = "vjs-layout-" + e;
});
var jC = {
  tiny: 210,
  xsmall: 320,
  small: 425,
  medium: 768,
  large: 1440,
  xlarge: 2560,
  huge: 1 / 0
}, Rt = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i, a) {
    var s;
    if (n.id = n.id || i.id || "vjs_video_" + Nr(), i = At(e.getTagSettings(n), i), i.initChildren = !1, i.createEl = !1, i.evented = !1, i.reportTouchActivity = !1, !i.language)
      if (typeof n.closest == "function") {
        var o = n.closest("[lang]");
        o && o.getAttribute && (i.language = o.getAttribute("lang"));
      } else
        for (var u = n; u && u.nodeType === 1; ) {
          if (_r(u).hasOwnProperty("lang")) {
            i.language = u.getAttribute("lang");
            break;
          }
          u = u.parentNode;
        }
    if (s = t.call(this, null, i, a) || this, s.boundDocumentFullscreenChange_ = function(f) {
      return s.documentFullscreenChange_(f);
    }, s.boundFullWindowOnEscKey_ = function(f) {
      return s.fullWindowOnEscKey(f);
    }, s.boundUpdateStyleEl_ = function(f) {
      return s.updateStyleEl_(f);
    }, s.boundApplyInitTime_ = function(f) {
      return s.applyInitTime_(f);
    }, s.boundUpdateCurrentBreakpoint_ = function(f) {
      return s.updateCurrentBreakpoint_(f);
    }, s.boundHandleTechClick_ = function(f) {
      return s.handleTechClick_(f);
    }, s.boundHandleTechDoubleClick_ = function(f) {
      return s.handleTechDoubleClick_(f);
    }, s.boundHandleTechTouchStart_ = function(f) {
      return s.handleTechTouchStart_(f);
    }, s.boundHandleTechTouchMove_ = function(f) {
      return s.handleTechTouchMove_(f);
    }, s.boundHandleTechTouchEnd_ = function(f) {
      return s.handleTechTouchEnd_(f);
    }, s.boundHandleTechTap_ = function(f) {
      return s.handleTechTap_(f);
    }, s.isFullscreen_ = !1, s.log = ly(s.id_), s.fsApi_ = au, s.isPosterFromTech_ = !1, s.queuedCallbacks_ = [], s.isReady_ = !1, s.hasStarted_ = !1, s.userActive_ = !1, s.debugEnabled_ = !1, s.audioOnlyMode_ = !1, s.audioPosterMode_ = !1, s.audioOnlyCache_ = {
      playerHeight: null,
      hiddenChildren: []
    }, !s.options_ || !s.options_.techOrder || !s.options_.techOrder.length)
      throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
    if (s.tag = n, s.tagAttributes = n && _r(n), s.language(s.options_.language), i.languages) {
      var l = {};
      Object.getOwnPropertyNames(i.languages).forEach(function(f) {
        l[f.toLowerCase()] = i.languages[f];
      }), s.languages_ = l;
    } else
      s.languages_ = e.prototype.options_.languages;
    s.resetCache_(), s.poster_ = i.poster || "", s.controls_ = !!i.controls, n.controls = !1, n.removeAttribute("controls"), s.changingSrc_ = !1, s.playCallbacks_ = [], s.playTerminatedQueue_ = [], n.hasAttribute("autoplay") ? s.autoplay(!0) : s.autoplay(s.options_.autoplay), i.plugins && Object.keys(i.plugins).forEach(function(f) {
      if (typeof s[f] != "function")
        throw new Error('plugin "' + f + '" does not exist');
    }), s.scrubbing_ = !1, s.el_ = s.createEl(), Ih(Le(s), {
      eventBusKey: "el_"
    }), s.fsApi_.requestFullscreen && (Ei(oe, s.fsApi_.fullscreenchange, s.boundDocumentFullscreenChange_), s.on(s.fsApi_.fullscreenchange, s.boundDocumentFullscreenChange_)), s.fluid_ && s.on(["playerreset", "resize"], s.boundUpdateStyleEl_);
    var d = mt(s.options_);
    i.plugins && Object.keys(i.plugins).forEach(function(f) {
      s[f](i.plugins[f]);
    }), i.debug && s.debug(!0), s.options_.playerOptions = d, s.middleware_ = [], s.playbackRates(i.playbackRates), s.initChildren(), s.isAudio(n.nodeName.toLowerCase() === "audio"), s.controls() ? s.addClass("vjs-controls-enabled") : s.addClass("vjs-controls-disabled"), s.el_.setAttribute("role", "region"), s.isAudio() ? s.el_.setAttribute("aria-label", s.localize("Audio Player")) : s.el_.setAttribute("aria-label", s.localize("Video Player")), s.isAudio() && s.addClass("vjs-audio"), s.flexNotSupported_() && s.addClass("vjs-no-flex"), xa && s.addClass("vjs-touch-enabled"), ui || s.addClass("vjs-workinghover"), e.players[s.id_] = Le(s);
    var h = sy.split(".")[0];
    return s.addClass("vjs-v" + h), s.userActive(!0), s.reportUserActivity(), s.one("play", function(f) {
      return s.listenForUserActivity_(f);
    }), s.on("stageclick", function(f) {
      return s.handleStageClick_(f);
    }), s.on("keydown", function(f) {
      return s.handleKeyDown(f);
    }), s.on("languagechange", function(f) {
      return s.handleLanguagechange(f);
    }), s.breakpoints(s.options_.breakpoints), s.responsive(s.options_.responsive), s.on("ready", function() {
      s.audioPosterMode(s.options_.audioPosterMode), s.audioOnlyMode(s.options_.audioOnlyMode);
    }), s;
  }
  var r = e.prototype;
  return r.dispose = function() {
    var i = this;
    this.trigger("dispose"), this.off("dispose"), Xt(oe, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), Xt(oe, "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), e.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ && (this.playerElIngest_ = null), this.tag && (this.tag = null), oC(this), ri.names.forEach(function(a) {
      var s = ri[a], o = i[s.getterName]();
      o && o.off && o.off();
    }), t.prototype.dispose.call(this, {
      restoreEl: this.options_.restoreEl
    });
  }, r.createEl = function() {
    var i = this.tag, a, s = this.playerElIngest_ = i.parentNode && i.parentNode.hasAttribute && i.parentNode.hasAttribute("data-vjs-player"), o = this.tag.tagName.toLowerCase() === "video-js";
    s ? a = this.el_ = i.parentNode : o || (a = this.el_ = t.prototype.createEl.call(this, "div"));
    var u = _r(i);
    if (o) {
      for (a = this.el_ = i, i = this.tag = oe.createElement("video"); a.children.length; )
        i.appendChild(a.firstChild);
      Tn(a, "video-js") || Cr(a, "video-js"), a.appendChild(i), s = this.playerElIngest_ = a, Object.keys(a).forEach(function(b) {
        try {
          i[b] = a[b];
        } catch {
        }
      });
    }
    if (i.setAttribute("tabindex", "-1"), u.tabindex = "-1", (zs || Mr && gy) && (i.setAttribute("role", "application"), u.role = "application"), i.removeAttribute("width"), i.removeAttribute("height"), "width" in u && delete u.width, "height" in u && delete u.height, Object.getOwnPropertyNames(u).forEach(function(b) {
      o && b === "class" || a.setAttribute(b, u[b]), o && i.setAttribute(b, u[b]);
    }), i.playerId = i.id, i.id += "_html5_api", i.className = "vjs-tech", i.player = a.player = this, this.addClass("vjs-paused"), M.VIDEOJS_NO_DYNAMIC_STYLE !== !0) {
      this.styleEl_ = Ly("vjs-styles-dimensions");
      var l = Kr(".vjs-styles-defaults"), d = Kr("head");
      d.insertBefore(this.styleEl_, l ? l.nextSibling : d.firstChild);
    }
    this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio), this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
    for (var h = i.getElementsByTagName("a"), f = 0; f < h.length; f++) {
      var v = h.item(f);
      Cr(v, "vjs-hidden"), v.setAttribute("hidden", "hidden");
    }
    return i.initNetworkState_ = i.networkState, i.parentNode && !s && i.parentNode.insertBefore(a, i), gc(i, a), this.children_.unshift(i), this.el_.setAttribute("lang", this.language_), this.el_.setAttribute("translate", "no"), this.el_ = a, a;
  }, r.crossOrigin = function(i) {
    if (!i)
      return this.techGet_("crossOrigin");
    if (i !== "anonymous" && i !== "use-credentials") {
      Fe.warn('crossOrigin must be "anonymous" or "use-credentials", given "' + i + '"');
      return;
    }
    this.techCall_("setCrossOrigin", i);
  }, r.width = function(i) {
    return this.dimension("width", i);
  }, r.height = function(i) {
    return this.dimension("height", i);
  }, r.dimension = function(i, a) {
    var s = i + "_";
    if (a === void 0)
      return this[s] || 0;
    if (a === "" || a === "auto") {
      this[s] = void 0, this.updateStyleEl_();
      return;
    }
    var o = parseFloat(a);
    if (isNaN(o)) {
      Fe.error('Improper value "' + a + '" supplied for for ' + i);
      return;
    }
    this[s] = o, this.updateStyleEl_();
  }, r.fluid = function(i) {
    var a = this;
    if (i === void 0)
      return !!this.fluid_;
    this.fluid_ = !!i, Ar(this) && this.off(["playerreset", "resize"], this.boundUpdateStyleEl_), i ? (this.addClass("vjs-fluid"), this.fill(!1), Dx(this, function() {
      a.on(["playerreset", "resize"], a.boundUpdateStyleEl_);
    })) : this.removeClass("vjs-fluid"), this.updateStyleEl_();
  }, r.fill = function(i) {
    if (i === void 0)
      return !!this.fill_;
    this.fill_ = !!i, i ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill");
  }, r.aspectRatio = function(i) {
    if (i === void 0)
      return this.aspectRatio_;
    if (!/^\d+\:\d+$/.test(i))
      throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
    this.aspectRatio_ = i, this.fluid(!0), this.updateStyleEl_();
  }, r.updateStyleEl_ = function() {
    if (M.VIDEOJS_NO_DYNAMIC_STYLE === !0) {
      var i = typeof this.width_ == "number" ? this.width_ : this.options_.width, a = typeof this.height_ == "number" ? this.height_ : this.options_.height, s = this.tech_ && this.tech_.el();
      s && (i >= 0 && (s.width = i), a >= 0 && (s.height = a));
      return;
    }
    var o, u, l, d;
    this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto" ? l = this.aspectRatio_ : this.videoWidth() > 0 ? l = this.videoWidth() + ":" + this.videoHeight() : l = "16:9";
    var h = l.split(":"), f = h[1] / h[0];
    this.width_ !== void 0 ? o = this.width_ : this.height_ !== void 0 ? o = this.height_ / f : o = this.videoWidth() || 300, this.height_ !== void 0 ? u = this.height_ : u = o * f, /^[^a-zA-Z]/.test(this.id()) ? d = "dimensions-" + this.id() : d = this.id() + "-dimensions", this.addClass(d), Iy(this.styleEl_, `
      .` + d + ` {
        width: ` + o + `px;
        height: ` + u + `px;
      }

      .` + d + `.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ` + f * 100 + `%;
      }
    `);
  }, r.loadTech_ = function(i, a) {
    var s = this;
    this.tech_ && this.unloadTech_();
    var o = It(i), u = i.charAt(0).toLowerCase() + i.slice(1);
    o !== "Html5" && this.tag && (ot.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = o, this.isReady_ = !1;
    var l = this.autoplay();
    (typeof this.autoplay() == "string" || this.autoplay() === !0 && this.options_.normalizeAutoplay) && (l = !1);
    var d = {
      source: a,
      autoplay: l,
      nativeControlsForTouch: this.options_.nativeControlsForTouch,
      playerId: this.id(),
      techId: this.id() + "_" + u + "_api",
      playsinline: this.options_.playsinline,
      preload: this.options_.preload,
      loop: this.options_.loop,
      disablePictureInPicture: this.options_.disablePictureInPicture,
      muted: this.options_.muted,
      poster: this.poster(),
      language: this.language(),
      playerElIngest: this.playerElIngest_ || !1,
      "vtt.js": this.options_["vtt.js"],
      canOverridePoster: !!this.options_.techCanOverridePoster,
      enableSourceset: this.options_.enableSourceset,
      Promise: this.options_.Promise
    };
    ri.names.forEach(function(f) {
      var v = ri[f];
      d[v.getterName] = s[v.privateName];
    }), At(d, this.options_[o]), At(d, this.options_[u]), At(d, this.options_[i.toLowerCase()]), this.tag && (d.tag = this.tag), a && a.src === this.cache_.src && this.cache_.currentTime > 0 && (d.startTime = this.cache_.currentTime);
    var h = ot.getTech(i);
    if (!h)
      throw new Error("No Tech named '" + o + "' exists! '" + o + "' should be registered using videojs.registerTech()'");
    this.tech_ = new h(d), this.tech_.ready(vt(this, this.handleTechReady_), !0), Op.jsonToTextTracks(this.textTracksJson_ || [], this.tech_), f0.forEach(function(f) {
      s.on(s.tech_, f, function(v) {
        return s["handleTech" + It(f) + "_"](v);
      });
    }), Object.keys(ql).forEach(function(f) {
      s.on(s.tech_, f, function(v) {
        if (s.tech_.playbackRate() === 0 && s.tech_.seeking()) {
          s.queuedCallbacks_.push({
            callback: s["handleTech" + ql[f] + "_"].bind(s),
            event: v
          });
          return;
        }
        s["handleTech" + ql[f] + "_"](v);
      });
    }), this.on(this.tech_, "loadstart", function(f) {
      return s.handleTechLoadStart_(f);
    }), this.on(this.tech_, "sourceset", function(f) {
      return s.handleTechSourceset_(f);
    }), this.on(this.tech_, "waiting", function(f) {
      return s.handleTechWaiting_(f);
    }), this.on(this.tech_, "ended", function(f) {
      return s.handleTechEnded_(f);
    }), this.on(this.tech_, "seeking", function(f) {
      return s.handleTechSeeking_(f);
    }), this.on(this.tech_, "play", function(f) {
      return s.handleTechPlay_(f);
    }), this.on(this.tech_, "firstplay", function(f) {
      return s.handleTechFirstPlay_(f);
    }), this.on(this.tech_, "pause", function(f) {
      return s.handleTechPause_(f);
    }), this.on(this.tech_, "durationchange", function(f) {
      return s.handleTechDurationChange_(f);
    }), this.on(this.tech_, "fullscreenchange", function(f, v) {
      return s.handleTechFullscreenChange_(f, v);
    }), this.on(this.tech_, "fullscreenerror", function(f, v) {
      return s.handleTechFullscreenError_(f, v);
    }), this.on(this.tech_, "enterpictureinpicture", function(f) {
      return s.handleTechEnterPictureInPicture_(f);
    }), this.on(this.tech_, "leavepictureinpicture", function(f) {
      return s.handleTechLeavePictureInPicture_(f);
    }), this.on(this.tech_, "error", function(f) {
      return s.handleTechError_(f);
    }), this.on(this.tech_, "posterchange", function(f) {
      return s.handleTechPosterChange_(f);
    }), this.on(this.tech_, "textdata", function(f) {
      return s.handleTechTextData_(f);
    }), this.on(this.tech_, "ratechange", function(f) {
      return s.handleTechRateChange_(f);
    }), this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode !== this.el() && (o !== "Html5" || !this.tag) && gc(this.tech_.el(), this.el()), this.tag && (this.tag.player = null, this.tag = null);
  }, r.unloadTech_ = function() {
    var i = this;
    ri.names.forEach(function(a) {
      var s = ri[a];
      i[s.privateName] = i[s.getterName]();
    }), this.textTracksJson_ = Op.textTracksToJson(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1;
  }, r.tech = function(i) {
    return i === void 0 && Fe.warn(`Using the tech directly can be dangerous. I hope you know what you're doing.
See https://github.com/videojs/video.js/issues/2617 for more info.
`), this.tech_;
  }, r.addTechControlsListeners_ = function() {
    this.removeTechControlsListeners_(), this.on(this.tech_, "click", this.boundHandleTechClick_), this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_), this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.on(this.tech_, "tap", this.boundHandleTechTap_);
  }, r.removeTechControlsListeners_ = function() {
    this.off(this.tech_, "tap", this.boundHandleTechTap_), this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.off(this.tech_, "click", this.boundHandleTechClick_), this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
  }, r.handleTechReady_ = function() {
    this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_();
  }, r.handleTechLoadStart_ = function() {
    this.removeClass("vjs-ended"), this.removeClass("vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() ? (this.hasStarted(!1), this.trigger("loadstart")) : (this.trigger("loadstart"), this.trigger("firstplay")), this.manualAutoplay_(this.autoplay() === !0 && this.options_.normalizeAutoplay ? "play" : this.autoplay());
  }, r.manualAutoplay_ = function(i) {
    var a = this;
    if (!(!this.tech_ || typeof i != "string")) {
      var s = function() {
        var l = a.muted();
        a.muted(!0);
        var d = function() {
          a.muted(l);
        };
        a.playTerminatedQueue_.push(d);
        var h = a.play();
        if (Ts(h))
          return h.catch(function(f) {
            throw d(), new Error("Rejection at manualAutoplay. Restoring muted value. " + (f || ""));
          });
      }, o;
      if (i === "any" && !this.muted() ? (o = this.play(), Ts(o) && (o = o.catch(s))) : i === "muted" && !this.muted() ? o = s() : o = this.play(), !!Ts(o))
        return o.then(function() {
          a.trigger({
            type: "autoplay-success",
            autoplay: i
          });
        }).catch(function() {
          a.trigger({
            type: "autoplay-failure",
            autoplay: i
          });
        });
    }
  }, r.updateSourceCaches_ = function(i) {
    i === void 0 && (i = "");
    var a = i, s = "";
    typeof a != "string" && (a = i.src, s = i.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], a && !s && (s = dC(this, a)), this.cache_.source = mt({}, i, {
      src: a,
      type: s
    });
    for (var o = this.cache_.sources.filter(function(v) {
      return v.src && v.src === a;
    }), u = [], l = this.$$("source"), d = [], h = 0; h < l.length; h++) {
      var f = _r(l[h]);
      u.push(f), f.src && f.src === a && d.push(f.src);
    }
    d.length && !o.length ? this.cache_.sources = u : o.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = a;
  }, r.handleTechSourceset_ = function(i) {
    var a = this;
    if (!this.changingSrc_) {
      var s = function(d) {
        return a.updateSourceCaches_(d);
      }, o = this.currentSource().src, u = i.src;
      o && !/^blob:/.test(o) && /^blob:/.test(u) && (!this.lastSource_ || this.lastSource_.tech !== u && this.lastSource_.player !== o) && (s = function() {
      }), s(u), i.src || this.tech_.any(["sourceset", "loadstart"], function(l) {
        if (l.type !== "sourceset") {
          var d = a.techGet("currentSrc");
          a.lastSource_.tech = d, a.updateSourceCaches_(d);
        }
      });
    }
    this.lastSource_ = {
      player: this.currentSource().src,
      tech: i.src
    }, this.trigger({
      src: i.src,
      type: "sourceset"
    });
  }, r.hasStarted = function(i) {
    if (i === void 0)
      return this.hasStarted_;
    i !== this.hasStarted_ && (this.hasStarted_ = i, this.hasStarted_ ? (this.addClass("vjs-has-started"), this.trigger("firstplay")) : this.removeClass("vjs-has-started"));
  }, r.handleTechPlay_ = function() {
    this.removeClass("vjs-ended"), this.removeClass("vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play");
  }, r.handleTechRateChange_ = function() {
    this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0 && (this.queuedCallbacks_.forEach(function(i) {
      return i.callback(i.event);
    }), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange");
  }, r.handleTechWaiting_ = function() {
    var i = this;
    this.addClass("vjs-waiting"), this.trigger("waiting");
    var a = this.currentTime(), s = function o() {
      a !== i.currentTime() && (i.removeClass("vjs-waiting"), i.off("timeupdate", o));
    };
    this.on("timeupdate", s);
  }, r.handleTechCanPlay_ = function() {
    this.removeClass("vjs-waiting"), this.trigger("canplay");
  }, r.handleTechCanPlayThrough_ = function() {
    this.removeClass("vjs-waiting"), this.trigger("canplaythrough");
  }, r.handleTechPlaying_ = function() {
    this.removeClass("vjs-waiting"), this.trigger("playing");
  }, r.handleTechSeeking_ = function() {
    this.addClass("vjs-seeking"), this.trigger("seeking");
  }, r.handleTechSeeked_ = function() {
    this.removeClass("vjs-seeking"), this.removeClass("vjs-ended"), this.trigger("seeked");
  }, r.handleTechFirstPlay_ = function() {
    this.options_.starttime && (Fe.warn("Passing the `starttime` option to the player will be deprecated in 6.0"), this.currentTime(this.options_.starttime)), this.addClass("vjs-has-started"), this.trigger("firstplay");
  }, r.handleTechPause_ = function() {
    this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause");
  }, r.handleTechEnded_ = function() {
    this.addClass("vjs-ended"), this.removeClass("vjs-waiting"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended");
  }, r.handleTechDurationChange_ = function() {
    this.duration(this.techGet_("duration"));
  }, r.handleTechClick_ = function(i) {
    this.controls_ && (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click == "function" ? this.options_.userActions.click.call(this, i) : this.paused() ? er(this.play()) : this.pause());
  }, r.handleTechDoubleClick_ = function(i) {
    if (this.controls_) {
      var a = Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), function(s) {
        return s.contains(i.target);
      });
      a || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick == "function" ? this.options_.userActions.doubleClick.call(this, i) : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen());
    }
  }, r.handleTechTap_ = function() {
    this.userActive(!this.userActive());
  }, r.handleTechTouchStart_ = function() {
    this.userWasActive = this.userActive();
  }, r.handleTechTouchMove_ = function() {
    this.userWasActive && this.reportUserActivity();
  }, r.handleTechTouchEnd_ = function(i) {
    i.cancelable && i.preventDefault();
  }, r.handleStageClick_ = function() {
    this.reportUserActivity();
  }, r.toggleFullscreenClass_ = function() {
    this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen");
  }, r.documentFullscreenChange_ = function(i) {
    var a = i.target.player;
    if (!(a && a !== this)) {
      var s = this.el(), o = oe[this.fsApi_.fullscreenElement] === s;
      !o && s.matches ? o = s.matches(":" + this.fsApi_.fullscreen) : !o && s.msMatchesSelector && (o = s.msMatchesSelector(":" + this.fsApi_.fullscreen)), this.isFullscreen(o);
    }
  }, r.handleTechFullscreenChange_ = function(i, a) {
    var s = this;
    a && (a.nativeIOSFullscreen && (this.addClass("vjs-ios-native-fs"), this.tech_.one("webkitendfullscreen", function() {
      s.removeClass("vjs-ios-native-fs");
    })), this.isFullscreen(a.isFullscreen));
  }, r.handleTechFullscreenError_ = function(i, a) {
    this.trigger("fullscreenerror", a);
  }, r.togglePictureInPictureClass_ = function() {
    this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture");
  }, r.handleTechEnterPictureInPicture_ = function(i) {
    this.isInPictureInPicture(!0);
  }, r.handleTechLeavePictureInPicture_ = function(i) {
    this.isInPictureInPicture(!1);
  }, r.handleTechError_ = function() {
    var i = this.tech_.error();
    this.error(i);
  }, r.handleTechTextData_ = function() {
    var i = null;
    arguments.length > 1 && (i = arguments[1]), this.trigger("textdata", i);
  }, r.getCache = function() {
    return this.cache_;
  }, r.resetCache_ = function() {
    this.cache_ = {
      // Right now, the currentTime is not _really_ cached because it is always
      // retrieved from the tech (see: currentTime). However, for completeness,
      // we set it to zero here to ensure that if we do start actually caching
      // it, we reset it along with everything else.
      currentTime: 0,
      initTime: 0,
      inactivityTimeout: this.options_.inactivityTimeout,
      duration: NaN,
      lastVolume: 1,
      lastPlaybackRate: this.defaultPlaybackRate(),
      media: null,
      src: "",
      source: {},
      sources: [],
      playbackRates: [],
      volume: 1
    };
  }, r.techCall_ = function(i, a) {
    this.ready(function() {
      if (i in aC)
        return rC(this.middleware_, this.tech_, i, a);
      if (i in Vp)
        return Up(this.middleware_, this.tech_, i, a);
      try {
        this.tech_ && this.tech_[i](a);
      } catch (s) {
        throw Fe(s), s;
      }
    }, !0);
  }, r.techGet_ = function(i) {
    if (!(!this.tech_ || !this.tech_.isReady_)) {
      if (i in nC)
        return iC(this.middleware_, this.tech_, i);
      if (i in Vp)
        return Up(this.middleware_, this.tech_, i);
      try {
        return this.tech_[i]();
      } catch (a) {
        throw this.tech_[i] === void 0 ? (Fe("Video.js: " + i + " method not defined for " + this.techName_ + " playback technology.", a), a) : a.name === "TypeError" ? (Fe("Video.js: " + i + " unavailable on " + this.techName_ + " playback technology element.", a), this.tech_.isReady_ = !1, a) : (Fe(a), a);
      }
    }
  }, r.play = function() {
    var i = this, a = this.options_.Promise || M.Promise;
    return a ? new a(function(s) {
      i.play_(s);
    }) : this.play_();
  }, r.play_ = function(i) {
    var a = this;
    i === void 0 && (i = er), this.playCallbacks_.push(i);
    var s = !!(!this.changingSrc_ && (this.src() || this.currentSrc())), o = !!(Hu || ui);
    if (this.waitToPlay_ && (this.off(["ready", "loadstart"], this.waitToPlay_), this.waitToPlay_ = null), !this.isReady_ || !s) {
      this.waitToPlay_ = function(d) {
        a.play_();
      }, this.one(["ready", "loadstart"], this.waitToPlay_), !s && o && this.load();
      return;
    }
    var u = this.techGet_("play"), l = o && this.hasClass("vjs-ended");
    l && this.resetProgressBar_(), u === null ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(u);
  }, r.runPlayTerminatedQueue_ = function() {
    var i = this.playTerminatedQueue_.slice(0);
    this.playTerminatedQueue_ = [], i.forEach(function(a) {
      a();
    });
  }, r.runPlayCallbacks_ = function(i) {
    var a = this.playCallbacks_.slice(0);
    this.playCallbacks_ = [], this.playTerminatedQueue_ = [], a.forEach(function(s) {
      s(i);
    });
  }, r.pause = function() {
    this.techCall_("pause");
  }, r.paused = function() {
    return this.techGet_("paused") !== !1;
  }, r.played = function() {
    return this.techGet_("played") || bn(0, 0);
  }, r.scrubbing = function(i) {
    if (typeof i > "u")
      return this.scrubbing_;
    this.scrubbing_ = !!i, this.techCall_("setScrubbing", this.scrubbing_), i ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing");
  }, r.currentTime = function(i) {
    if (typeof i < "u") {
      if (i < 0 && (i = 0), !this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
        this.cache_.initTime = i, this.off("canplay", this.boundApplyInitTime_), this.one("canplay", this.boundApplyInitTime_);
        return;
      }
      this.techCall_("setCurrentTime", i), this.cache_.initTime = 0;
      return;
    }
    return this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime;
  }, r.applyInitTime_ = function() {
    this.currentTime(this.cache_.initTime);
  }, r.duration = function(i) {
    if (i === void 0)
      return this.cache_.duration !== void 0 ? this.cache_.duration : NaN;
    i = parseFloat(i), i < 0 && (i = 1 / 0), i !== this.cache_.duration && (this.cache_.duration = i, i === 1 / 0 ? this.addClass("vjs-live") : this.removeClass("vjs-live"), isNaN(i) || this.trigger("durationchange"));
  }, r.remainingTime = function() {
    return this.duration() - this.currentTime();
  }, r.remainingTimeDisplay = function() {
    return Math.floor(this.duration()) - Math.floor(this.currentTime());
  }, r.buffered = function() {
    var i = this.techGet_("buffered");
    return (!i || !i.length) && (i = bn(0, 0)), i;
  }, r.bufferedPercent = function() {
    return By(this.buffered(), this.duration());
  }, r.bufferedEnd = function() {
    var i = this.buffered(), a = this.duration(), s = i.end(i.length - 1);
    return s > a && (s = a), s;
  }, r.volume = function(i) {
    var a;
    if (i !== void 0) {
      a = Math.max(0, Math.min(1, parseFloat(i))), this.cache_.volume = a, this.techCall_("setVolume", a), a > 0 && this.lastVolume_(a);
      return;
    }
    return a = parseFloat(this.techGet_("volume")), isNaN(a) ? 1 : a;
  }, r.muted = function(i) {
    if (i !== void 0) {
      this.techCall_("setMuted", i);
      return;
    }
    return this.techGet_("muted") || !1;
  }, r.defaultMuted = function(i) {
    return i !== void 0 ? this.techCall_("setDefaultMuted", i) : this.techGet_("defaultMuted") || !1;
  }, r.lastVolume_ = function(i) {
    if (i !== void 0 && i !== 0) {
      this.cache_.lastVolume = i;
      return;
    }
    return this.cache_.lastVolume;
  }, r.supportsFullScreen = function() {
    return this.techGet_("supportsFullScreen") || !1;
  }, r.isFullscreen = function(i) {
    if (i !== void 0) {
      var a = this.isFullscreen_;
      this.isFullscreen_ = !!i, this.isFullscreen_ !== a && this.fsApi_.prefixed && this.trigger("fullscreenchange"), this.toggleFullscreenClass_();
      return;
    }
    return this.isFullscreen_;
  }, r.requestFullscreen = function(i) {
    var a = this.options_.Promise || M.Promise;
    if (a) {
      var s = this;
      return new a(function(o, u) {
        function l() {
          s.off("fullscreenerror", h), s.off("fullscreenchange", d);
        }
        function d() {
          l(), o();
        }
        function h(v, b) {
          l(), u(b);
        }
        s.one("fullscreenchange", d), s.one("fullscreenerror", h);
        var f = s.requestFullscreenHelper_(i);
        f && (f.then(l, l), f.then(o, u));
      });
    }
    return this.requestFullscreenHelper_();
  }, r.requestFullscreenHelper_ = function(i) {
    var a = this, s;
    if (this.fsApi_.prefixed || (s = this.options_.fullscreen && this.options_.fullscreen.options || {}, i !== void 0 && (s = i)), this.fsApi_.requestFullscreen) {
      var o = this.el_[this.fsApi_.requestFullscreen](s);
      return o && o.then(function() {
        return a.isFullscreen(!0);
      }, function() {
        return a.isFullscreen(!1);
      }), o;
    } else
      this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("enterFullScreen") : this.enterFullWindow();
  }, r.exitFullscreen = function() {
    var i = this.options_.Promise || M.Promise;
    if (i) {
      var a = this;
      return new i(function(s, o) {
        function u() {
          a.off("fullscreenerror", d), a.off("fullscreenchange", l);
        }
        function l() {
          u(), s();
        }
        function d(f, v) {
          u(), o(v);
        }
        a.one("fullscreenchange", l), a.one("fullscreenerror", d);
        var h = a.exitFullscreenHelper_();
        h && (h.then(u, u), h.then(s, o));
      });
    }
    return this.exitFullscreenHelper_();
  }, r.exitFullscreenHelper_ = function() {
    var i = this;
    if (this.fsApi_.requestFullscreen) {
      var a = oe[this.fsApi_.exitFullscreen]();
      return a && er(a.then(function() {
        return i.isFullscreen(!1);
      })), a;
    } else
      this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("exitFullScreen") : this.exitFullWindow();
  }, r.enterFullWindow = function() {
    this.isFullscreen(!0), this.isFullWindow = !0, this.docOrigOverflow = oe.documentElement.style.overflow, Ei(oe, "keydown", this.boundFullWindowOnEscKey_), oe.documentElement.style.overflow = "hidden", Cr(oe.body, "vjs-full-window"), this.trigger("enterFullWindow");
  }, r.fullWindowOnEscKey = function(i) {
    De.isEventKey(i, "Esc") && this.isFullscreen() === !0 && (this.isFullWindow ? this.exitFullWindow() : this.exitFullscreen());
  }, r.exitFullWindow = function() {
    this.isFullscreen(!1), this.isFullWindow = !1, Xt(oe, "keydown", this.boundFullWindowOnEscKey_), oe.documentElement.style.overflow = this.docOrigOverflow, Gs(oe.body, "vjs-full-window"), this.trigger("exitFullWindow");
  }, r.disablePictureInPicture = function(i) {
    if (i === void 0)
      return this.techGet_("disablePictureInPicture");
    this.techCall_("setDisablePictureInPicture", i), this.options_.disablePictureInPicture = i, this.trigger("disablepictureinpicturechanged");
  }, r.isInPictureInPicture = function(i) {
    if (i !== void 0) {
      this.isInPictureInPicture_ = !!i, this.togglePictureInPictureClass_();
      return;
    }
    return !!this.isInPictureInPicture_;
  }, r.requestPictureInPicture = function() {
    if ("pictureInPictureEnabled" in oe && this.disablePictureInPicture() === !1)
      return this.techGet_("requestPictureInPicture");
  }, r.exitPictureInPicture = function() {
    if ("pictureInPictureEnabled" in oe)
      return oe.exitPictureInPicture();
  }, r.handleKeyDown = function(i) {
    var a = this.options_.userActions;
    if (!(!a || !a.hotkeys)) {
      var s = function(u) {
        var l = u.tagName.toLowerCase();
        if (u.isContentEditable)
          return !0;
        var d = ["button", "checkbox", "hidden", "radio", "reset", "submit"];
        if (l === "input")
          return d.indexOf(u.type) === -1;
        var h = ["textarea"];
        return h.indexOf(l) !== -1;
      };
      s(this.el_.ownerDocument.activeElement) || (typeof a.hotkeys == "function" ? a.hotkeys.call(this, i) : this.handleHotkeys(i));
    }
  }, r.handleHotkeys = function(i) {
    var a = this.options_.userActions ? this.options_.userActions.hotkeys : {}, s = a.fullscreenKey, o = s === void 0 ? function(_) {
      return De.isEventKey(_, "f");
    } : s, u = a.muteKey, l = u === void 0 ? function(_) {
      return De.isEventKey(_, "m");
    } : u, d = a.playPauseKey, h = d === void 0 ? function(_) {
      return De.isEventKey(_, "k") || De.isEventKey(_, "Space");
    } : d;
    if (o.call(this, i)) {
      i.preventDefault(), i.stopPropagation();
      var f = ee.getComponent("FullscreenToggle");
      oe[this.fsApi_.fullscreenEnabled] !== !1 && f.prototype.handleClick.call(this, i);
    } else if (l.call(this, i)) {
      i.preventDefault(), i.stopPropagation();
      var v = ee.getComponent("MuteToggle");
      v.prototype.handleClick.call(this, i);
    } else if (h.call(this, i)) {
      i.preventDefault(), i.stopPropagation();
      var b = ee.getComponent("PlayToggle");
      b.prototype.handleClick.call(this, i);
    }
  }, r.canPlayType = function(i) {
    for (var a, s = 0, o = this.options_.techOrder; s < o.length; s++) {
      var u = o[s], l = ot.getTech(u);
      if (l || (l = ee.getComponent(u)), !l) {
        Fe.error('The "' + u + '" tech is undefined. Skipped browser support check for that tech.');
        continue;
      }
      if (l.isSupported() && (a = l.canPlayType(i), a))
        return a;
    }
    return "";
  }, r.selectSource = function(i) {
    var a = this, s = this.options_.techOrder.map(function(h) {
      return [h, ot.getTech(h)];
    }).filter(function(h) {
      var f = h[0], v = h[1];
      return v ? v.isSupported() : (Fe.error('The "' + f + '" tech is undefined. Skipped browser support check for that tech.'), !1);
    }), o = function(f, v, b) {
      var _;
      return f.some(function(y) {
        return v.some(function(E) {
          if (_ = b(y, E), _)
            return !0;
        });
      }), _;
    }, u, l = function(f) {
      return function(v, b) {
        return f(b, v);
      };
    }, d = function(f, v) {
      var b = f[0], _ = f[1];
      if (_.canPlaySource(v, a.options_[b.toLowerCase()]))
        return {
          source: v,
          tech: b
        };
    };
    return this.options_.sourceOrder ? u = o(i, s, l(d)) : u = o(s, i, d), u || !1;
  }, r.handleSrc_ = function(i, a) {
    var s = this;
    if (typeof i > "u")
      return this.cache_.src || "";
    this.resetRetryOnError_ && this.resetRetryOnError_();
    var o = cC(i);
    if (!o.length) {
      this.setTimeout(function() {
        this.error({
          code: 4,
          message: this.options_.notSupportedMessage
        });
      }, 0);
      return;
    }
    if (this.changingSrc_ = !0, a || (this.cache_.sources = o), this.updateSourceCaches_(o[0]), eC(this, o[0], function(d, h) {
      s.middleware_ = h, a || (s.cache_.sources = o), s.updateSourceCaches_(d);
      var f = s.src_(d);
      if (f) {
        if (o.length > 1)
          return s.handleSrc_(o.slice(1));
        s.changingSrc_ = !1, s.setTimeout(function() {
          this.error({
            code: 4,
            message: this.options_.notSupportedMessage
          });
        }, 0), s.triggerReady();
        return;
      }
      tC(h, s.tech_);
    }), this.options_.retryOnError && o.length > 1) {
      var u = function() {
        s.error(null), s.handleSrc_(o.slice(1), !0);
      }, l = function() {
        s.off("error", u);
      };
      this.one("error", u), this.one("playing", l), this.resetRetryOnError_ = function() {
        s.off("error", u), s.off("playing", l);
      };
    }
  }, r.src = function(i) {
    return this.handleSrc_(i, !1);
  }, r.src_ = function(i) {
    var a = this, s = this.selectSource([i]);
    return s ? Mx(s.tech, this.techName_) ? (this.ready(function() {
      this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", i) : this.techCall_("src", i.src), this.changingSrc_ = !1;
    }, !0), !1) : (this.changingSrc_ = !0, this.loadTech_(s.tech, s.source), this.tech_.ready(function() {
      a.changingSrc_ = !1;
    }), !1) : !0;
  }, r.load = function() {
    this.techCall_("load");
  }, r.reset = function() {
    var i = this, a = this.options_.Promise || M.Promise;
    if (this.paused() || !a)
      this.doReset_();
    else {
      var s = this.play();
      er(s.then(function() {
        return i.doReset_();
      }));
    }
  }, r.doReset_ = function() {
    this.tech_ && this.tech_.clearTracks("text"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), Ar(this) && this.trigger("playerreset");
  }, r.resetControlBarUI_ = function() {
    this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_();
  }, r.resetProgressBar_ = function() {
    this.currentTime(0);
    var i = this.controlBar || {}, a = i.durationDisplay, s = i.remainingTimeDisplay;
    a && a.updateContent(), s && s.updateContent();
  }, r.resetPlaybackRate_ = function() {
    this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_();
  }, r.resetVolumeBar_ = function() {
    this.volume(1), this.trigger("volumechange");
  }, r.currentSources = function() {
    var i = this.currentSource(), a = [];
    return Object.keys(i).length !== 0 && a.push(i), this.cache_.sources || a;
  }, r.currentSource = function() {
    return this.cache_.source || {};
  }, r.currentSrc = function() {
    return this.currentSource() && this.currentSource().src || "";
  }, r.currentType = function() {
    return this.currentSource() && this.currentSource().type || "";
  }, r.preload = function(i) {
    if (i !== void 0) {
      this.techCall_("setPreload", i), this.options_.preload = i;
      return;
    }
    return this.techGet_("preload");
  }, r.autoplay = function(i) {
    if (i === void 0)
      return this.options_.autoplay || !1;
    var a;
    typeof i == "string" && /(any|play|muted)/.test(i) || i === !0 && this.options_.normalizeAutoplay ? (this.options_.autoplay = i, this.manualAutoplay_(typeof i == "string" ? i : "play"), a = !1) : i ? this.options_.autoplay = !0 : this.options_.autoplay = !1, a = typeof a > "u" ? this.options_.autoplay : a, this.tech_ && this.techCall_("setAutoplay", a);
  }, r.playsinline = function(i) {
    return i !== void 0 ? (this.techCall_("setPlaysinline", i), this.options_.playsinline = i, this) : this.techGet_("playsinline");
  }, r.loop = function(i) {
    if (i !== void 0) {
      this.techCall_("setLoop", i), this.options_.loop = i;
      return;
    }
    return this.techGet_("loop");
  }, r.poster = function(i) {
    if (i === void 0)
      return this.poster_;
    i || (i = ""), i !== this.poster_ && (this.poster_ = i, this.techCall_("setPoster", i), this.isPosterFromTech_ = !1, this.trigger("posterchange"));
  }, r.handleTechPosterChange_ = function() {
    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
      var i = this.tech_.poster() || "";
      i !== this.poster_ && (this.poster_ = i, this.isPosterFromTech_ = !0, this.trigger("posterchange"));
    }
  }, r.controls = function(i) {
    if (i === void 0)
      return !!this.controls_;
    i = !!i, this.controls_ !== i && (this.controls_ = i, this.usingNativeControls() && this.techCall_("setControls", i), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()));
  }, r.usingNativeControls = function(i) {
    if (i === void 0)
      return !!this.usingNativeControls_;
    i = !!i, this.usingNativeControls_ !== i && (this.usingNativeControls_ = i, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")));
  }, r.error = function(i) {
    var a = this;
    if (i === void 0)
      return this.error_ || null;
    if (Gr("beforeerror").forEach(function(o) {
      var u = o(a, i);
      if (!(Lr(u) && !Array.isArray(u) || typeof u == "string" || typeof u == "number" || u === null)) {
        a.log.error("please return a value that MediaError expects in beforeerror hooks");
        return;
      }
      i = u;
    }), this.options_.suppressNotSupportedError && i && i.code === 4) {
      var s = function() {
        this.error(i);
      };
      this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], s), this.one("loadstart", function() {
        this.off(["click", "touchstart"], s);
      });
      return;
    }
    if (i === null) {
      this.error_ = i, this.removeClass("vjs-error"), this.errorDisplay && this.errorDisplay.close();
      return;
    }
    this.error_ = new oi(i), this.addClass("vjs-error"), Fe.error("(CODE:" + this.error_.code + " " + oi.errorTypes[this.error_.code] + ")", this.error_.message, this.error_), this.trigger("error"), Gr("error").forEach(function(o) {
      return o(a, a.error_);
    });
  }, r.reportUserActivity = function(i) {
    this.userActivity_ = !0;
  }, r.userActive = function(i) {
    if (i === void 0)
      return this.userActive_;
    if (i = !!i, i !== this.userActive_) {
      if (this.userActive_ = i, this.userActive_) {
        this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), this.trigger("useractive");
        return;
      }
      this.tech_ && this.tech_.one("mousemove", function(a) {
        a.stopPropagation(), a.preventDefault();
      }), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive");
    }
  }, r.listenForUserActivity_ = function() {
    var i, a, s, o = vt(this, this.reportUserActivity), u = function(b) {
      (b.screenX !== a || b.screenY !== s) && (a = b.screenX, s = b.screenY, o());
    }, l = function() {
      o(), this.clearInterval(i), i = this.setInterval(o, 250);
    }, d = function(b) {
      o(), this.clearInterval(i);
    };
    this.on("mousedown", l), this.on("mousemove", u), this.on("mouseup", d), this.on("mouseleave", d);
    var h = this.getChild("controlBar");
    h && !ui && !Or && (h.on("mouseenter", function(v) {
      this.player().options_.inactivityTimeout !== 0 && (this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout), this.player().options_.inactivityTimeout = 0;
    }), h.on("mouseleave", function(v) {
      this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
    })), this.on("keydown", o), this.on("keyup", o);
    var f;
    this.setInterval(function() {
      if (this.userActivity_) {
        this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(f);
        var v = this.options_.inactivityTimeout;
        v <= 0 || (f = this.setTimeout(function() {
          this.userActivity_ || this.userActive(!1);
        }, v));
      }
    }, 250);
  }, r.playbackRate = function(i) {
    if (i !== void 0) {
      this.techCall_("setPlaybackRate", i);
      return;
    }
    return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
  }, r.defaultPlaybackRate = function(i) {
    return i !== void 0 ? this.techCall_("setDefaultPlaybackRate", i) : this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1;
  }, r.isAudio = function(i) {
    if (i !== void 0) {
      this.isAudio_ = !!i;
      return;
    }
    return !!this.isAudio_;
  }, r.enableAudioOnlyUI_ = function() {
    var i = this;
    this.addClass("vjs-audio-only-mode");
    var a = this.children(), s = this.getChild("ControlBar"), o = s && s.currentHeight();
    a.forEach(function(u) {
      u !== s && u.el_ && !u.hasClass("vjs-hidden") && (u.hide(), i.audioOnlyCache_.hiddenChildren.push(u));
    }), this.audioOnlyCache_.playerHeight = this.currentHeight(), this.height(o), this.trigger("audioonlymodechange");
  }, r.disableAudioOnlyUI_ = function() {
    this.removeClass("vjs-audio-only-mode"), this.audioOnlyCache_.hiddenChildren.forEach(function(i) {
      return i.show();
    }), this.height(this.audioOnlyCache_.playerHeight), this.trigger("audioonlymodechange");
  }, r.audioOnlyMode = function(i) {
    var a = this;
    if (typeof i != "boolean" || i === this.audioOnlyMode_)
      return this.audioOnlyMode_;
    this.audioOnlyMode_ = i;
    var s = this.options_.Promise || M.Promise;
    if (s) {
      if (i) {
        var o = [];
        return this.isInPictureInPicture() && o.push(this.exitPictureInPicture()), this.isFullscreen() && o.push(this.exitFullscreen()), this.audioPosterMode() && o.push(this.audioPosterMode(!1)), s.all(o).then(function() {
          return a.enableAudioOnlyUI_();
        });
      }
      return s.resolve().then(function() {
        return a.disableAudioOnlyUI_();
      });
    }
    i ? (this.isInPictureInPicture() && this.exitPictureInPicture(), this.isFullscreen() && this.exitFullscreen(), this.enableAudioOnlyUI_()) : this.disableAudioOnlyUI_();
  }, r.enablePosterModeUI_ = function() {
    var i = this.tech_ && this.tech_;
    i.hide(), this.addClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }, r.disablePosterModeUI_ = function() {
    var i = this.tech_ && this.tech_;
    i.show(), this.removeClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
  }, r.audioPosterMode = function(i) {
    var a = this;
    if (typeof i != "boolean" || i === this.audioPosterMode_)
      return this.audioPosterMode_;
    this.audioPosterMode_ = i;
    var s = this.options_.Promise || M.Promise;
    if (s) {
      if (i) {
        if (this.audioOnlyMode()) {
          var o = this.audioOnlyMode(!1);
          return o.then(function() {
            a.enablePosterModeUI_();
          });
        }
        return s.resolve().then(function() {
          a.enablePosterModeUI_();
        });
      }
      return s.resolve().then(function() {
        a.disablePosterModeUI_();
      });
    }
    if (i) {
      this.audioOnlyMode() && this.audioOnlyMode(!1), this.enablePosterModeUI_();
      return;
    }
    this.disablePosterModeUI_();
  }, r.addTextTrack = function(i, a, s) {
    if (this.tech_)
      return this.tech_.addTextTrack(i, a, s);
  }, r.addRemoteTextTrack = function(i, a) {
    if (this.tech_)
      return this.tech_.addRemoteTextTrack(i, a);
  }, r.removeRemoteTextTrack = function(i) {
    i === void 0 && (i = {});
    var a = i, s = a.track;
    if (s || (s = i), this.tech_)
      return this.tech_.removeRemoteTextTrack(s);
  }, r.getVideoPlaybackQuality = function() {
    return this.techGet_("getVideoPlaybackQuality");
  }, r.videoWidth = function() {
    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
  }, r.videoHeight = function() {
    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
  }, r.language = function(i) {
    if (i === void 0)
      return this.language_;
    this.language_ !== String(i).toLowerCase() && (this.language_ = String(i).toLowerCase(), Ar(this) && this.trigger("languagechange"));
  }, r.languages = function() {
    return mt(e.prototype.options_.languages, this.languages_);
  }, r.toJSON = function() {
    var i = mt(this.options_), a = i.tracks;
    i.tracks = [];
    for (var s = 0; s < a.length; s++) {
      var o = a[s];
      o = mt(o), o.player = void 0, i.tracks[s] = o;
    }
    return i;
  }, r.createModal = function(i, a) {
    var s = this;
    a = a || {}, a.content = i || "";
    var o = new Ba(this, a);
    return this.addChild(o), o.on("dispose", function() {
      s.removeChild(o);
    }), o.open(), o;
  }, r.updateCurrentBreakpoint_ = function() {
    if (this.responsive())
      for (var i = this.currentBreakpoint(), a = this.currentWidth(), s = 0; s < Ec.length; s++) {
        var o = Ec[s], u = this.breakpoints_[o];
        if (a <= u) {
          if (i === o)
            return;
          i && this.removeClass(Ho[i]), this.addClass(Ho[o]), this.breakpoint_ = o;
          break;
        }
      }
  }, r.removeCurrentBreakpoint_ = function() {
    var i = this.currentBreakpointClass();
    this.breakpoint_ = "", i && this.removeClass(i);
  }, r.breakpoints = function(i) {
    return i === void 0 ? At(this.breakpoints_) : (this.breakpoint_ = "", this.breakpoints_ = At({}, jC, i), this.updateCurrentBreakpoint_(), At(this.breakpoints_));
  }, r.responsive = function(i) {
    if (i === void 0)
      return this.responsive_;
    i = !!i;
    var a = this.responsive_;
    if (i !== a)
      return this.responsive_ = i, i ? (this.on("playerresize", this.boundUpdateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.boundUpdateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), i;
  }, r.currentBreakpoint = function() {
    return this.breakpoint_;
  }, r.currentBreakpointClass = function() {
    return Ho[this.breakpoint_] || "";
  }, r.loadMedia = function(i, a) {
    var s = this;
    if (!(!i || typeof i != "object")) {
      this.reset(), this.cache_.media = mt(i);
      var o = this.cache_.media, u = o.artwork, l = o.poster, d = o.src, h = o.textTracks;
      !u && l && (this.cache_.media.artwork = [{
        src: l,
        type: uu(l)
      }]), d && this.src(d), l && this.poster(l), Array.isArray(h) && h.forEach(function(f) {
        return s.addRemoteTextTrack(f, !1);
      }), this.ready(a);
    }
  }, r.getMedia = function() {
    if (!this.cache_.media) {
      var i = this.poster(), a = this.currentSources(), s = Array.prototype.map.call(this.remoteTextTracks(), function(u) {
        return {
          kind: u.kind,
          label: u.label,
          language: u.language,
          src: u.src
        };
      }), o = {
        src: a,
        textTracks: s
      };
      return i && (o.poster = i, o.artwork = [{
        src: o.poster,
        type: uu(o.poster)
      }]), o;
    }
    return mt(this.cache_.media);
  }, e.getTagSettings = function(i) {
    var a = {
      sources: [],
      tracks: []
    }, s = _r(i), o = s["data-setup"];
    if (Tn(i, "vjs-fill") && (s.fill = !0), Tn(i, "vjs-fluid") && (s.fluid = !0), o !== null) {
      var u = _b(o || "{}"), l = u[0], d = u[1];
      l && Fe.error(l), At(s, d);
    }
    if (At(a, s), i.hasChildNodes())
      for (var h = i.childNodes, f = 0, v = h.length; f < v; f++) {
        var b = h[f], _ = b.nodeName.toLowerCase();
        _ === "source" ? a.sources.push(_r(b)) : _ === "track" && a.tracks.push(_r(b));
      }
    return a;
  }, r.flexNotSupported_ = function() {
    var i = oe.createElement("i");
    return !("flexBasis" in i.style || "webkitFlexBasis" in i.style || "mozFlexBasis" in i.style || "msFlexBasis" in i.style || // IE10-specific (2012 flex spec), available for completeness
    "msFlexOrder" in i.style);
  }, r.debug = function(i) {
    if (i === void 0)
      return this.debugEnabled_;
    i ? (this.trigger("debugon"), this.previousLogLevel_ = this.log.level, this.log.level("debug"), this.debugEnabled_ = !0) : (this.trigger("debugoff"), this.log.level(this.previousLogLevel_), this.previousLogLevel_ = void 0, this.debugEnabled_ = !1);
  }, r.playbackRates = function(i) {
    if (i === void 0)
      return this.cache_.playbackRates;
    Array.isArray(i) && i.every(function(a) {
      return typeof a == "number";
    }) && (this.cache_.playbackRates = i, this.trigger("playbackrateschange"));
  }, e;
}(ee);
ri.names.forEach(function(t) {
  var e = ri[t];
  Rt.prototype[e.getterName] = function() {
    return this.tech_ ? this.tech_[e.getterName]() : (this[e.privateName] = this[e.privateName] || new e.ListClass(), this[e.privateName]);
  };
});
Rt.prototype.crossorigin = Rt.prototype.crossOrigin;
Rt.players = {};
var ns = M.navigator;
Rt.prototype.options_ = {
  // Default order of fallback technology
  techOrder: ot.defaultTechOrder_,
  html5: {},
  // default inactivity timeout
  inactivityTimeout: 2e3,
  // default playback rates
  playbackRates: [],
  // Add playback rate selection by adding rates
  // 'playbackRates': [0.5, 1, 1.5, 2],
  liveui: !1,
  // Included control sets
  children: ["mediaLoader", "posterImage", "textTrackDisplay", "loadingSpinner", "bigPlayButton", "liveTracker", "controlBar", "errorDisplay", "textTrackSettings", "resizeManager"],
  language: ns && (ns.languages && ns.languages[0] || ns.userLanguage || ns.language) || "en",
  // locales and their language translations
  languages: {},
  // Default message to show when a video cannot be played.
  notSupportedMessage: "No compatible source was found for this media.",
  normalizeAutoplay: !1,
  fullscreen: {
    options: {
      navigationUI: "hide"
    }
  },
  breakpoints: {},
  responsive: !1,
  audioOnlyMode: !1,
  audioPosterMode: !1
};
[
  /**
   * Returns whether or not the player is in the "ended" state.
   *
   * @return {Boolean} True if the player is in the ended state, false if not.
   * @method Player#ended
   */
  "ended",
  /**
   * Returns whether or not the player is in the "seeking" state.
   *
   * @return {Boolean} True if the player is in the seeking state, false if not.
   * @method Player#seeking
   */
  "seeking",
  /**
   * Returns the TimeRanges of the media that are currently available
   * for seeking to.
   *
   * @return {TimeRanges} the seekable intervals of the media timeline
   * @method Player#seekable
   */
  "seekable",
  /**
   * Returns the current state of network activity for the element, from
   * the codes in the list below.
   * - NETWORK_EMPTY (numeric value 0)
   *   The element has not yet been initialised. All attributes are in
   *   their initial states.
   * - NETWORK_IDLE (numeric value 1)
   *   The element's resource selection algorithm is active and has
   *   selected a resource, but it is not actually using the network at
   *   this time.
   * - NETWORK_LOADING (numeric value 2)
   *   The user agent is actively trying to download data.
   * - NETWORK_NO_SOURCE (numeric value 3)
   *   The element's resource selection algorithm is active, but it has
   *   not yet found a resource to use.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
   * @return {number} the current network activity state
   * @method Player#networkState
   */
  "networkState",
  /**
   * Returns a value that expresses the current state of the element
   * with respect to rendering the current playback position, from the
   * codes in the list below.
   * - HAVE_NOTHING (numeric value 0)
   *   No information regarding the media resource is available.
   * - HAVE_METADATA (numeric value 1)
   *   Enough of the resource has been obtained that the duration of the
   *   resource is available.
   * - HAVE_CURRENT_DATA (numeric value 2)
   *   Data for the immediate current playback position is available.
   * - HAVE_FUTURE_DATA (numeric value 3)
   *   Data for the immediate current playback position is available, as
   *   well as enough data for the user agent to advance the current
   *   playback position in the direction of playback.
   * - HAVE_ENOUGH_DATA (numeric value 4)
   *   The user agent estimates that enough data is available for
   *   playback to proceed uninterrupted.
   *
   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
   * @return {number} the current playback rendering state
   * @method Player#readyState
   */
  "readyState"
].forEach(function(t) {
  Rt.prototype[t] = function() {
    return this.techGet_(t);
  };
});
f0.forEach(function(t) {
  Rt.prototype["handleTech" + It(t) + "_"] = function() {
    return this.trigger(t);
  };
});
ee.registerComponent("Player", Rt);
var cu = "plugin", pa = "activePlugins_", sa = {}, hu = function(e) {
  return sa.hasOwnProperty(e);
}, Wo = function(e) {
  return hu(e) ? sa[e] : void 0;
}, p0 = function(e, r) {
  e[pa] = e[pa] || {}, e[pa][r] = !0;
}, fu = function(e, r, n) {
  var i = (n ? "before" : "") + "pluginsetup";
  e.trigger(i, r), e.trigger(i + ":" + r.name, r);
}, HC = function(e, r) {
  var n = function() {
    fu(this, {
      name: e,
      plugin: r,
      instance: null
    }, !0);
    var a = r.apply(this, arguments);
    return p0(this, e), fu(this, {
      name: e,
      plugin: r,
      instance: a
    }), a;
  };
  return Object.keys(r).forEach(function(i) {
    n[i] = r[i];
  }), n;
}, eg = function(e, r) {
  return r.prototype.name = e, function() {
    fu(this, {
      name: e,
      plugin: r,
      instance: null
    }, !0);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var s = _s(r, [this].concat(i));
    return this[e] = function() {
      return s;
    }, fu(this, s.getEventHash()), s;
  };
}, or = /* @__PURE__ */ function() {
  function t(r) {
    if (this.constructor === t)
      throw new Error("Plugin must be sub-classed; not directly instantiated.");
    this.player = r, this.log || (this.log = this.player.log.createLogger(this.name)), Ih(this), delete this.trigger, Ny(this, this.constructor.defaultState), p0(r, this.name), this.dispose = this.dispose.bind(this), r.on("dispose", this.dispose);
  }
  var e = t.prototype;
  return e.version = function() {
    return this.constructor.VERSION;
  }, e.getEventHash = function(n) {
    return n === void 0 && (n = {}), n.name = this.name, n.plugin = this.constructor, n.instance = this, n;
  }, e.trigger = function(n, i) {
    return i === void 0 && (i = {}), Na(this.eventBusEl_, n, this.getEventHash(i));
  }, e.handleStateChanged = function(n) {
  }, e.dispose = function() {
    var n = this.name, i = this.player;
    this.trigger("dispose"), this.off(), i.off("dispose", this.dispose), i[pa][n] = !1, this.player = this.state = null, i[n] = eg(n, sa[n]);
  }, t.isBasic = function(n) {
    var i = typeof n == "string" ? Wo(n) : n;
    return typeof i == "function" && !t.prototype.isPrototypeOf(i.prototype);
  }, t.registerPlugin = function(n, i) {
    if (typeof n != "string")
      throw new Error('Illegal plugin name, "' + n + '", must be a string, was ' + typeof n + ".");
    if (hu(n))
      Fe.warn('A plugin named "' + n + '" already exists. You may want to avoid re-registering plugins!');
    else if (Rt.prototype.hasOwnProperty(n))
      throw new Error('Illegal plugin name, "' + n + '", cannot share a name with an existing player method!');
    if (typeof i != "function")
      throw new Error('Illegal plugin for "' + n + '", must be a function, was ' + typeof i + ".");
    return sa[n] = i, n !== cu && (t.isBasic(i) ? Rt.prototype[n] = HC(n, i) : Rt.prototype[n] = eg(n, i)), i;
  }, t.deregisterPlugin = function(n) {
    if (n === cu)
      throw new Error("Cannot de-register base plugin.");
    hu(n) && (delete sa[n], delete Rt.prototype[n]);
  }, t.getPlugins = function(n) {
    n === void 0 && (n = Object.keys(sa));
    var i;
    return n.forEach(function(a) {
      var s = Wo(a);
      s && (i = i || {}, i[a] = s);
    }), i;
  }, t.getPluginVersion = function(n) {
    var i = Wo(n);
    return i && i.VERSION || "";
  }, t;
}();
or.getPlugin = Wo;
or.BASE_PLUGIN_NAME = cu;
or.registerPlugin(cu, or);
Rt.prototype.usingPlugin = function(t) {
  return !!this[pa] && this[pa][t] === !0;
};
Rt.prototype.hasPlugin = function(t) {
  return !!hu(t);
};
var tg = !1, WC = function(e, r) {
  r === void 0 && (r = {}), tg || (Fe.warn("videojs.extend is deprecated as of Video.js 7.22.0 and will be removed in Video.js 8.0.0"), tg = !0);
  var n = function() {
    e.apply(this, arguments);
  }, i = {};
  typeof r == "object" ? (r.constructor !== Object.prototype.constructor && (n = r.constructor), i = r) : typeof r == "function" && (n = r), lS(n, e), e && (n.super_ = e);
  for (var a in i)
    i.hasOwnProperty(a) && (n.prototype[a] = i[a]);
  return n;
}, g0 = function(e) {
  return e.indexOf("#") === 0 ? e.slice(1) : e;
};
function P(t, e, r) {
  var n = P.getPlayer(t);
  if (n)
    return e && Fe.warn('Player "' + t + '" is already initialised. Options will not be applied.'), r && n.ready(r), n;
  var i = typeof t == "string" ? Kr("#" + g0(t)) : t;
  if (!Ma(i))
    throw new TypeError("The element or ID supplied is not valid. (videojs)");
  (!i.ownerDocument.defaultView || !i.ownerDocument.body.contains(i)) && Fe.warn("The element supplied is not included in the DOM"), e = e || {}, e.restoreEl === !0 && (e.restoreEl = (i.parentNode && i.parentNode.hasAttribute("data-vjs-player") ? i.parentNode : i).cloneNode(!0)), Gr("beforesetup").forEach(function(s) {
    var o = s(i, mt(e));
    if (!Lr(o) || Array.isArray(o)) {
      Fe.error("please return an object in beforesetup hooks");
      return;
    }
    e = mt(e, o);
  });
  var a = ee.getComponent("Player");
  return n = new a(i, e, r), Gr("setup").forEach(function(s) {
    return s(n);
  }), n;
}
P.hooks_ = br;
P.hooks = Gr;
P.hook = mx;
P.hookOnce = vx;
P.removeHook = oy;
if (M.VIDEOJS_NO_DYNAMIC_STYLE !== !0 && Oa()) {
  var Ao = Kr(".vjs-styles-defaults");
  if (!Ao) {
    Ao = Ly("vjs-styles-defaults");
    var $l = Kr("head");
    $l && $l.insertBefore(Ao, $l.firstChild), Iy(Ao, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: 56.25%
      }
    `);
  }
}
vc(1, P);
P.VERSION = sy;
P.options = Rt.prototype.options_;
P.getPlayers = function() {
  return Rt.players;
};
P.getPlayer = function(t) {
  var e = Rt.players, r;
  if (typeof t == "string") {
    var n = g0(t), i = e[n];
    if (i)
      return i;
    r = Kr("#" + n);
  } else
    r = t;
  if (Ma(r)) {
    var a = r, s = a.player, o = a.playerId;
    if (s || e[o])
      return s || e[o];
  }
};
P.getAllPlayers = function() {
  return (
    // Disposed players leave a key with a `null` value, so we need to make sure
    // we filter those out.
    Object.keys(Rt.players).map(function(t) {
      return Rt.players[t];
    }).filter(Boolean)
  );
};
P.players = Rt.players;
P.getComponent = ee.getComponent;
P.registerComponent = function(t, e) {
  ot.isTech(e) && Fe.warn("The " + t + " tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)"), ee.registerComponent.call(ee, t, e);
};
P.getTech = ot.getTech;
P.registerTech = ot.registerTech;
P.use = Zx;
Object.defineProperty(P, "middleware", {
  value: {},
  writeable: !1,
  enumerable: !0
});
Object.defineProperty(P.middleware, "TERMINATOR", {
  value: ou,
  writeable: !1,
  enumerable: !0
});
P.browser = Ex;
P.TOUCH_ENABLED = xa;
P.extend = WC;
P.mergeOptions = mt;
P.bind = vt;
P.registerPlugin = or.registerPlugin;
P.deregisterPlugin = or.deregisterPlugin;
P.plugin = function(t, e) {
  return Fe.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), or.registerPlugin(t, e);
};
P.getPlugins = or.getPlugins;
P.getPlugin = or.getPlugin;
P.getPluginVersion = or.getPluginVersion;
P.addLanguage = function(t, e) {
  var r;
  return t = ("" + t).toLowerCase(), P.options.languages = mt(P.options.languages, (r = {}, r[t] = e, r)), P.options.languages[t];
};
P.log = Fe;
P.createLogger = ly;
P.createTimeRange = P.createTimeRanges = bn;
P.formatTime = ka;
P.setFormatTime = yC;
P.resetFormatTime = _C;
P.parseUrl = Rh;
P.isCrossOrigin = Ku;
P.EventTarget = Vt;
P.on = Ei;
P.one = zu;
P.off = Xt;
P.trigger = Na;
P.xhr = xs;
P.TextTrack = Ks;
P.AudioTrack = Vy;
P.VideoTrack = jy;
["isEl", "isTextNode", "createEl", "hasClass", "addClass", "removeClass", "toggleClass", "setAttributes", "getAttributes", "emptyEl", "appendContent", "insertContent"].forEach(function(t) {
  P[t] = function() {
    return Fe.warn("videojs." + t + "() is deprecated; use videojs.dom." + t + "() instead"), Py[t].apply(null, arguments);
  };
});
P.computedStyle = Is;
P.dom = Py;
P.url = Xx;
P.defineLazyProperty = Jh;
P.addLanguage("en", {
  "Non-Fullscreen": "Exit Fullscreen"
});
/*! @name @videojs/http-streaming @version 2.16.2 @license Apache-2.0 */
var Mi = Ou, pu = function(e, r, n) {
  return e && n && n.responseURL && r !== n.responseURL ? n.responseURL : r;
}, Hi = function(e) {
  return P.log.debug ? P.log.debug.bind(P, "VHS:", e + " >") : function() {
  };
}, Xr = 1 / 30, tr = Xr * 3, m0 = function(e, r) {
  var n = [], i;
  if (e && e.length)
    for (i = 0; i < e.length; i++)
      r(e.start(i), e.end(i)) && n.push([e.start(i), e.end(i)]);
  return P.createTimeRanges(n);
}, oa = function(e, r) {
  return m0(e, function(n, i) {
    return n - tr <= r && i + tr >= r;
  });
}, wo = function(e, r) {
  return m0(e, function(n) {
    return n - Xr >= r;
  });
}, qC = function(e) {
  if (e.length < 2)
    return P.createTimeRanges();
  for (var r = [], n = 1; n < e.length; n++) {
    var i = e.end(n - 1), a = e.start(n);
    r.push([i, a]);
  }
  return P.createTimeRanges(r);
}, $C = function(e, r) {
  var n = null, i = null, a = 0, s = [], o = [];
  if (!e || !e.length || !r || !r.length)
    return P.createTimeRange();
  for (var u = e.length; u--; )
    s.push({
      time: e.start(u),
      type: "start"
    }), s.push({
      time: e.end(u),
      type: "end"
    });
  for (u = r.length; u--; )
    s.push({
      time: r.start(u),
      type: "start"
    }), s.push({
      time: r.end(u),
      type: "end"
    });
  for (s.sort(function(l, d) {
    return l.time - d.time;
  }), u = 0; u < s.length; u++)
    s[u].type === "start" ? (a++, a === 2 && (n = s[u].time)) : s[u].type === "end" && (a--, a === 1 && (i = s[u].time)), n !== null && i !== null && (o.push([n, i]), n = null, i = null);
  return P.createTimeRanges(o);
}, v0 = function(e) {
  var r = [];
  if (!e || !e.length)
    return "";
  for (var n = 0; n < e.length; n++)
    r.push(e.start(n) + " => " + e.end(n));
  return r.join(", ");
}, zC = function(e, r, n) {
  n === void 0 && (n = 1);
  var i = e.length ? e.end(e.length - 1) : 0;
  return (i - r) / n;
}, vn = function(e) {
  for (var r = [], n = 0; n < e.length; n++)
    r.push({
      start: e.start(n),
      end: e.end(n)
    });
  return r;
}, GC = function(e, r) {
  if (e === r)
    return !1;
  if (!e && r || !r && e || e.length !== r.length)
    return !0;
  for (var n = 0; n < e.length; n++)
    if (e.start(n) !== r.start(n) || e.end(n) !== r.end(n))
      return !0;
  return !1;
}, ig = function(e) {
  if (!(!e || !e.length || !e.end))
    return e.end(e.length - 1);
}, Zh = function(e, r) {
  var n = 0;
  if (!e || !e.length)
    return n;
  for (var i = 0; i < e.length; i++) {
    var a = e.start(i), s = e.end(i);
    if (!(r > s)) {
      if (r > a && r <= s) {
        n += s - r;
        continue;
      }
      n += s - a;
    }
  }
  return n;
}, rg = P.createTimeRange, ef = function(e, r) {
  if (!r.preload)
    return r.duration;
  var n = 0;
  return (r.parts || []).forEach(function(i) {
    n += i.duration;
  }), (r.preloadHints || []).forEach(function(i) {
    i.type === "PART" && (n += e.partTargetDuration);
  }), n;
}, xc = function(e) {
  return (e.segments || []).reduce(function(r, n, i) {
    return n.parts ? n.parts.forEach(function(a, s) {
      r.push({
        duration: a.duration,
        segmentIndex: i,
        partIndex: s,
        part: a,
        segment: n
      });
    }) : r.push({
      duration: n.duration,
      segmentIndex: i,
      partIndex: null,
      segment: n,
      part: null
    }), r;
  }, []);
}, y0 = function(e) {
  var r = e.segments && e.segments.length && e.segments[e.segments.length - 1];
  return r && r.parts || [];
}, _0 = function(e) {
  var r = e.preloadSegment;
  if (r) {
    var n = r.parts, i = r.preloadHints, a = (i || []).reduce(function(s, o) {
      return s + (o.type === "PART" ? 1 : 0);
    }, 0);
    return a += n && n.length ? n.length : 0, a;
  }
}, T0 = function(e, r) {
  if (r.endList)
    return 0;
  if (e && e.suggestedPresentationDelay)
    return e.suggestedPresentationDelay;
  var n = y0(r).length > 0;
  return n && r.serverControl && r.serverControl.partHoldBack ? r.serverControl.partHoldBack : n && r.partTargetDuration ? r.partTargetDuration * 3 : r.serverControl && r.serverControl.holdBack ? r.serverControl.holdBack : r.targetDuration ? r.targetDuration * 3 : 0;
}, KC = function(e, r) {
  var n = 0, i = r - e.mediaSequence, a = e.segments[i];
  if (a) {
    if (typeof a.start < "u")
      return {
        result: a.start,
        precise: !0
      };
    if (typeof a.end < "u")
      return {
        result: a.end - a.duration,
        precise: !0
      };
  }
  for (; i--; ) {
    if (a = e.segments[i], typeof a.end < "u")
      return {
        result: n + a.end,
        precise: !0
      };
    if (n += ef(e, a), typeof a.start < "u")
      return {
        result: n + a.start,
        precise: !0
      };
  }
  return {
    result: n,
    precise: !1
  };
}, XC = function(e, r) {
  for (var n = 0, i, a = r - e.mediaSequence; a < e.segments.length; a++) {
    if (i = e.segments[a], typeof i.start < "u")
      return {
        result: i.start - n,
        precise: !0
      };
    if (n += ef(e, i), typeof i.end < "u")
      return {
        result: i.end - n,
        precise: !0
      };
  }
  return {
    result: -1,
    precise: !1
  };
}, b0 = function(e, r, n) {
  if (typeof r > "u" && (r = e.mediaSequence + e.segments.length), r < e.mediaSequence)
    return 0;
  var i = KC(e, r);
  if (i.precise)
    return i.result;
  var a = XC(e, r);
  return a.precise ? a.result : i.result + n;
}, S0 = function(e, r, n) {
  if (!e)
    return 0;
  if (typeof n != "number" && (n = 0), typeof r > "u") {
    if (e.totalDuration)
      return e.totalDuration;
    if (!e.endList)
      return M.Infinity;
  }
  return b0(e, r, n);
}, bs = function(e) {
  var r = e.defaultDuration, n = e.durationList, i = e.startIndex, a = e.endIndex, s = 0;
  if (i > a) {
    var o = [a, i];
    i = o[0], a = o[1];
  }
  if (i < 0) {
    for (var u = i; u < Math.min(0, a); u++)
      s += r;
    i = 0;
  }
  for (var l = i; l < a; l++)
    s += n[l].duration;
  return s;
}, E0 = function(e, r, n, i) {
  if (!e || !e.segments)
    return null;
  if (e.endList)
    return S0(e);
  if (r === null)
    return null;
  r = r || 0;
  var a = b0(e, e.mediaSequence + e.segments.length, r);
  return n && (i = typeof i == "number" ? i : T0(null, e), a -= i), Math.max(0, a);
}, YC = function(e, r, n) {
  var i = !0, a = r || 0, s = E0(e, r, i, n);
  return s === null ? rg() : rg(a, s);
}, QC = function(e) {
  for (var r = e.playlist, n = e.currentTime, i = e.startingSegmentIndex, a = e.startingPartIndex, s = e.startTime, o = e.experimentalExactManifestTimings, u = n - s, l = xc(r), d = 0, h = 0; h < l.length; h++) {
    var f = l[h];
    if (i === f.segmentIndex && !(typeof a == "number" && typeof f.partIndex == "number" && a !== f.partIndex)) {
      d = h;
      break;
    }
  }
  if (u < 0) {
    if (d > 0)
      for (var v = d - 1; v >= 0; v--) {
        var b = l[v];
        if (u += b.duration, o) {
          if (u < 0)
            continue;
        } else if (u + Xr <= 0)
          continue;
        return {
          partIndex: b.partIndex,
          segmentIndex: b.segmentIndex,
          startTime: s - bs({
            defaultDuration: r.targetDuration,
            durationList: l,
            startIndex: d,
            endIndex: v
          })
        };
      }
    return {
      partIndex: l[0] && l[0].partIndex || null,
      segmentIndex: l[0] && l[0].segmentIndex || 0,
      startTime: n
    };
  }
  if (d < 0) {
    for (var _ = d; _ < 0; _++)
      if (u -= r.targetDuration, u < 0)
        return {
          partIndex: l[0] && l[0].partIndex || null,
          segmentIndex: l[0] && l[0].segmentIndex || 0,
          startTime: n
        };
    d = 0;
  }
  for (var y = d; y < l.length; y++) {
    var E = l[y];
    if (u -= E.duration, o) {
      if (u > 0)
        continue;
    } else if (u - Xr >= 0)
      continue;
    return {
      partIndex: E.partIndex,
      segmentIndex: E.segmentIndex,
      startTime: s + bs({
        defaultDuration: r.targetDuration,
        durationList: l,
        startIndex: d,
        endIndex: y
      })
    };
  }
  return {
    segmentIndex: l[l.length - 1].segmentIndex,
    partIndex: l[l.length - 1].partIndex,
    startTime: n
  };
}, x0 = function(e) {
  return e.excludeUntil && e.excludeUntil > Date.now();
}, tf = function(e) {
  return e.excludeUntil && e.excludeUntil === 1 / 0;
}, Ju = function(e) {
  var r = x0(e);
  return !e.disabled && !r;
}, JC = function(e) {
  return e.disabled;
}, ZC = function(e) {
  for (var r = 0; r < e.segments.length; r++)
    if (e.segments[r].key)
      return !0;
  return !1;
}, C0 = function(e, r) {
  return r.attributes && r.attributes[e];
}, e1 = function(e, r, n, i) {
  if (i === void 0 && (i = 0), !C0("BANDWIDTH", n))
    return NaN;
  var a = e * n.attributes.BANDWIDTH;
  return (a - i * 8) / r;
}, Cc = function(e, r) {
  if (e.playlists.length === 1)
    return !0;
  var n = r.attributes.BANDWIDTH || Number.MAX_VALUE;
  return e.playlists.filter(function(i) {
    return Ju(i) ? (i.attributes.BANDWIDTH || 0) < n : !1;
  }).length === 0;
}, rf = function(e, r) {
  return !e && !r || !e && r || e && !r ? !1 : !!(e === r || e.id && r.id && e.id === r.id || e.resolvedUri && r.resolvedUri && e.resolvedUri === r.resolvedUri || e.uri && r.uri && e.uri === r.uri);
}, ng = function(e, r) {
  var n = e && e.mediaGroups && e.mediaGroups.AUDIO || {}, i = !1;
  for (var a in n) {
    for (var s in n[a])
      if (i = r(n[a][s]), i)
        break;
    if (i)
      break;
  }
  return !!i;
}, Qs = function(e) {
  if (!e || !e.playlists || !e.playlists.length) {
    var r = ng(e, function(s) {
      return s.playlists && s.playlists.length || s.uri;
    });
    return r;
  }
  for (var n = function(o) {
    var u = e.playlists[o], l = u.attributes && u.attributes.CODECS;
    if (l && l.split(",").every(function(h) {
      return mv(h);
    }))
      return "continue";
    var d = ng(e, function(h) {
      return rf(u, h);
    });
    return d ? "continue" : {
      v: !1
    };
  }, i = 0; i < e.playlists.length; i++) {
    var a = n(i);
    if (a !== "continue" && typeof a == "object")
      return a.v;
  }
  return !0;
}, hi = {
  liveEdgeDelay: T0,
  duration: S0,
  seekable: YC,
  getMediaInfoForTime: QC,
  isEnabled: Ju,
  isDisabled: JC,
  isBlacklisted: x0,
  isIncompatible: tf,
  playlistEnd: E0,
  isAes: ZC,
  hasAttribute: C0,
  estimateSegmentRequestTime: e1,
  isLowestEnabledRendition: Cc,
  isAudioOnly: Qs,
  playlistMatch: rf,
  segmentDurationWithParts: ef
}, A0 = P.log, nf = function(e, r) {
  return e + "-" + r;
}, t1 = function(e, r, n) {
  return "placeholder-uri-" + e + "-" + r + "-" + n;
}, i1 = function(e) {
  var r = e.onwarn, n = e.oninfo, i = e.manifestString, a = e.customTagParsers, s = a === void 0 ? [] : a, o = e.customTagMappers, u = o === void 0 ? [] : o, l = e.experimentalLLHLS, d = new vS();
  r && d.on("warn", r), n && d.on("info", n), s.forEach(function(_) {
    return d.addParser(_);
  }), u.forEach(function(_) {
    return d.addTagMapper(_);
  }), d.push(i), d.end();
  var h = d.manifest;
  if (l || (["preloadSegment", "skip", "serverControl", "renditionReports", "partInf", "partTargetDuration"].forEach(function(_) {
    h.hasOwnProperty(_) && delete h[_];
  }), h.segments && h.segments.forEach(function(_) {
    ["parts", "preloadHints"].forEach(function(y) {
      _.hasOwnProperty(y) && delete _[y];
    });
  })), !h.targetDuration) {
    var f = 10;
    h.segments && h.segments.length && (f = h.segments.reduce(function(_, y) {
      return Math.max(_, y.duration);
    }, 0)), r && r("manifest has no targetDuration defaulting to " + f), h.targetDuration = f;
  }
  var v = y0(h);
  if (v.length && !h.partTargetDuration) {
    var b = v.reduce(function(_, y) {
      return Math.max(_, y.duration);
    }, 0);
    r && (r("manifest has no partTargetDuration defaulting to " + b), A0.error("LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.")), h.partTargetDuration = b;
  }
  return h;
}, ja = function(e, r) {
  e.mediaGroups && ["AUDIO", "SUBTITLES"].forEach(function(n) {
    if (e.mediaGroups[n])
      for (var i in e.mediaGroups[n])
        for (var a in e.mediaGroups[n][i]) {
          var s = e.mediaGroups[n][i][a];
          r(s, n, i, a);
        }
  });
}, w0 = function(e) {
  var r = e.playlist, n = e.uri, i = e.id;
  r.id = i, r.playlistErrors_ = 0, n && (r.uri = n), r.attributes = r.attributes || {};
}, r1 = function(e) {
  for (var r = e.playlists.length; r--; ) {
    var n = e.playlists[r];
    w0({
      playlist: n,
      id: nf(r, n.uri)
    }), n.resolvedUri = Mi(e.uri, n.uri), e.playlists[n.id] = n, e.playlists[n.uri] = n, n.attributes.BANDWIDTH || A0.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.");
  }
}, n1 = function(e) {
  ja(e, function(r) {
    r.uri && (r.resolvedUri = Mi(e.uri, r.uri));
  });
}, a1 = function(e, r) {
  var n = nf(0, r), i = {
    mediaGroups: {
      AUDIO: {},
      VIDEO: {},
      "CLOSED-CAPTIONS": {},
      SUBTITLES: {}
    },
    uri: M.location.href,
    resolvedUri: M.location.href,
    playlists: [{
      uri: r,
      id: n,
      resolvedUri: r,
      // m3u8-parser does not attach an attributes property to media playlists so make
      // sure that the property is attached to avoid undefined reference errors
      attributes: {}
    }]
  };
  return i.playlists[n] = i.playlists[0], i.playlists[r] = i.playlists[0], i;
}, P0 = function(e, r, n) {
  n === void 0 && (n = t1), e.uri = r;
  for (var i = 0; i < e.playlists.length; i++)
    if (!e.playlists[i].uri) {
      var a = "placeholder-uri-" + i;
      e.playlists[i].uri = a;
    }
  var s = Qs(e);
  ja(e, function(o, u, l, d) {
    if (!o.playlists || !o.playlists.length) {
      if (s && u === "AUDIO" && !o.uri)
        for (var h = 0; h < e.playlists.length; h++) {
          var f = e.playlists[h];
          if (f.attributes && f.attributes.AUDIO && f.attributes.AUDIO === l)
            return;
        }
      o.playlists = [Vi({}, o)];
    }
    o.playlists.forEach(function(v, b) {
      var _ = n(u, l, d, v), y = nf(b, _);
      v.uri ? v.resolvedUri = v.resolvedUri || Mi(e.uri, v.uri) : (v.uri = b === 0 ? _ : y, v.resolvedUri = v.uri), v.id = v.id || y, v.attributes = v.attributes || {}, e.playlists[v.id] = v, e.playlists[v.uri] = v;
    });
  }), r1(e), n1(e);
}, gu = P.mergeOptions, s1 = P.EventTarget, o1 = function(e, r) {
  if (r.endList || !r.serverControl)
    return e;
  var n = {};
  if (r.serverControl.canBlockReload) {
    var i = r.preloadSegment, a = r.mediaSequence + r.segments.length;
    if (i) {
      var s = i.parts || [], o = _0(r) - 1;
      o > -1 && o !== s.length - 1 && (n._HLS_part = o), (o > -1 || s.length) && a--;
    }
    n._HLS_msn = a;
  }
  if (r.serverControl && r.serverControl.canSkipUntil && (n._HLS_skip = r.serverControl.canSkipDateranges ? "v2" : "YES"), Object.keys(n).length) {
    var u = new M.URL(e);
    ["_HLS_skip", "_HLS_msn", "_HLS_part"].forEach(function(l) {
      n.hasOwnProperty(l) && u.searchParams.set(l, n[l]);
    }), e = u.toString();
  }
  return e;
}, u1 = function(e, r) {
  if (!e)
    return r;
  var n = gu(e, r);
  if (e.preloadHints && !r.preloadHints && delete n.preloadHints, e.parts && !r.parts)
    delete n.parts;
  else if (e.parts && r.parts)
    for (var i = 0; i < r.parts.length; i++)
      e.parts && e.parts[i] && (n.parts[i] = gu(e.parts[i], r.parts[i]));
  return !e.skipped && r.skipped && (n.skipped = !1), e.preload && !r.preload && (n.preload = !1), n;
}, l1 = function(e, r, n) {
  var i = e.slice(), a = r.slice();
  n = n || 0;
  for (var s = [], o, u = 0; u < a.length; u++) {
    var l = i[u + n], d = a[u];
    l ? (o = l.map || o, s.push(u1(l, d))) : (o && !d.map && (d.map = o), s.push(d));
  }
  return s;
}, k0 = function(e, r) {
  !e.resolvedUri && e.uri && (e.resolvedUri = Mi(r, e.uri)), e.key && !e.key.resolvedUri && (e.key.resolvedUri = Mi(r, e.key.uri)), e.map && !e.map.resolvedUri && (e.map.resolvedUri = Mi(r, e.map.uri)), e.map && e.map.key && !e.map.key.resolvedUri && (e.map.key.resolvedUri = Mi(r, e.map.key.uri)), e.parts && e.parts.length && e.parts.forEach(function(n) {
    n.resolvedUri || (n.resolvedUri = Mi(r, n.uri));
  }), e.preloadHints && e.preloadHints.length && e.preloadHints.forEach(function(n) {
    n.resolvedUri || (n.resolvedUri = Mi(r, n.uri));
  });
}, L0 = function(e) {
  var r = e.segments || [], n = e.preloadSegment;
  if (n && n.parts && n.parts.length) {
    if (n.preloadHints) {
      for (var i = 0; i < n.preloadHints.length; i++)
        if (n.preloadHints[i].type === "MAP")
          return r;
    }
    n.duration = e.targetDuration, n.preload = !0, r.push(n);
  }
  return r;
}, I0 = function(e, r) {
  return e === r || e.segments && r.segments && e.segments.length === r.segments.length && e.endList === r.endList && e.mediaSequence === r.mediaSequence && e.preloadSegment === r.preloadSegment;
}, Ac = function(e, r, n) {
  n === void 0 && (n = I0);
  var i = gu(e, {}), a = i.playlists[r.id];
  if (!a || n(a, r))
    return null;
  r.segments = L0(r);
  var s = gu(a, r);
  if (s.preloadSegment && !r.preloadSegment && delete s.preloadSegment, a.segments) {
    if (r.skip) {
      r.segments = r.segments || [];
      for (var o = 0; o < r.skip.skippedSegments; o++)
        r.segments.unshift({
          skipped: !0
        });
    }
    s.segments = l1(a.segments, r.segments, r.mediaSequence - a.mediaSequence);
  }
  s.segments.forEach(function(l) {
    k0(l, s.resolvedUri);
  });
  for (var u = 0; u < i.playlists.length; u++)
    i.playlists[u].id === r.id && (i.playlists[u] = s);
  return i.playlists[r.id] = s, i.playlists[r.uri] = s, ja(e, function(l, d, h, f) {
    if (l.playlists)
      for (var v = 0; v < l.playlists.length; v++)
        r.id === l.playlists[v].id && (l.playlists[v] = s);
  }), i;
}, wc = function(e, r) {
  var n = e.segments || [], i = n[n.length - 1], a = i && i.parts && i.parts[i.parts.length - 1], s = a && a.duration || i && i.duration;
  return r && s ? s * 1e3 : (e.partTargetDuration || e.targetDuration || 10) * 500;
}, ua = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i, a) {
    var s;
    if (a === void 0 && (a = {}), s = t.call(this) || this, !n)
      throw new Error("A non-empty playlist URL or object is required");
    s.logger_ = Hi("PlaylistLoader");
    var o = a, u = o.withCredentials, l = u === void 0 ? !1 : u, d = o.handleManifestRedirects, h = d === void 0 ? !1 : d;
    s.src = n, s.vhs_ = i, s.withCredentials = l, s.handleManifestRedirects = h;
    var f = i.options_;
    return s.customTagParsers = f && f.customTagParsers || [], s.customTagMappers = f && f.customTagMappers || [], s.experimentalLLHLS = f && f.experimentalLLHLS || !1, P.browser.IE_VERSION && (s.experimentalLLHLS = !1), s.state = "HAVE_NOTHING", s.handleMediaupdatetimeout_ = s.handleMediaupdatetimeout_.bind(Le(s)), s.on("mediaupdatetimeout", s.handleMediaupdatetimeout_), s;
  }
  var r = e.prototype;
  return r.handleMediaupdatetimeout_ = function() {
    var i = this;
    if (this.state === "HAVE_METADATA") {
      var a = this.media(), s = Mi(this.master.uri, a.uri);
      this.experimentalLLHLS && (s = o1(s, a)), this.state = "HAVE_CURRENT_METADATA", this.request = this.vhs_.xhr({
        uri: s,
        withCredentials: this.withCredentials
      }, function(o, u) {
        if (i.request) {
          if (o)
            return i.playlistRequestError(i.request, i.media(), "HAVE_METADATA");
          i.haveMetadata({
            playlistString: i.request.responseText,
            url: i.media().uri,
            id: i.media().id
          });
        }
      });
    }
  }, r.playlistRequestError = function(i, a, s) {
    var o = a.uri, u = a.id;
    this.request = null, s && (this.state = s), this.error = {
      playlist: this.master.playlists[u],
      status: i.status,
      message: "HLS playlist request error at URL: " + o + ".",
      responseText: i.responseText,
      code: i.status >= 500 ? 4 : 2
    }, this.trigger("error");
  }, r.parseManifest_ = function(i) {
    var a = this, s = i.url, o = i.manifestString;
    return i1({
      onwarn: function(l) {
        var d = l.message;
        return a.logger_("m3u8-parser warn for " + s + ": " + d);
      },
      oninfo: function(l) {
        var d = l.message;
        return a.logger_("m3u8-parser info for " + s + ": " + d);
      },
      manifestString: o,
      customTagParsers: this.customTagParsers,
      customTagMappers: this.customTagMappers,
      experimentalLLHLS: this.experimentalLLHLS
    });
  }, r.haveMetadata = function(i) {
    var a = i.playlistString, s = i.playlistObject, o = i.url, u = i.id;
    this.request = null, this.state = "HAVE_METADATA";
    var l = s || this.parseManifest_({
      url: o,
      manifestString: a
    });
    l.lastRequest = Date.now(), w0({
      playlist: l,
      uri: o,
      id: u
    });
    var d = Ac(this.master, l);
    this.targetDuration = l.partTargetDuration || l.targetDuration, this.pendingMedia_ = null, d ? (this.master = d, this.media_ = this.master.playlists[u]) : this.trigger("playlistunchanged"), this.updateMediaUpdateTimeout_(wc(this.media(), !!d)), this.trigger("loadedplaylist");
  }, r.dispose = function() {
    this.trigger("dispose"), this.stopRequest(), M.clearTimeout(this.mediaUpdateTimeout), M.clearTimeout(this.finalRenditionTimeout), this.off();
  }, r.stopRequest = function() {
    if (this.request) {
      var i = this.request;
      this.request = null, i.onreadystatechange = null, i.abort();
    }
  }, r.media = function(i, a) {
    var s = this;
    if (!i)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    if (typeof i == "string") {
      if (!this.master.playlists[i])
        throw new Error("Unknown playlist URI: " + i);
      i = this.master.playlists[i];
    }
    if (M.clearTimeout(this.finalRenditionTimeout), a) {
      var o = (i.partTargetDuration || i.targetDuration) / 2 * 1e3 || 5e3;
      this.finalRenditionTimeout = M.setTimeout(this.media.bind(this, i, !1), o);
      return;
    }
    var u = this.state, l = !this.media_ || i.id !== this.media_.id, d = this.master.playlists[i.id];
    if (d && d.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
    // media playlist or, for the case of demuxed audio, a resolved audio media group)
    i.endList && i.segments.length) {
      this.request && (this.request.onreadystatechange = null, this.request.abort(), this.request = null), this.state = "HAVE_METADATA", this.media_ = i, l && (this.trigger("mediachanging"), u === "HAVE_MASTER" ? this.trigger("loadedmetadata") : this.trigger("mediachange"));
      return;
    }
    if (this.updateMediaUpdateTimeout_(wc(i, !0)), !!l) {
      if (this.state = "SWITCHING_MEDIA", this.request) {
        if (i.resolvedUri === this.request.url)
          return;
        this.request.onreadystatechange = null, this.request.abort(), this.request = null;
      }
      this.media_ && this.trigger("mediachanging"), this.pendingMedia_ = i, this.request = this.vhs_.xhr({
        uri: i.resolvedUri,
        withCredentials: this.withCredentials
      }, function(h, f) {
        if (s.request) {
          if (i.lastRequest = Date.now(), i.resolvedUri = pu(s.handleManifestRedirects, i.resolvedUri, f), h)
            return s.playlistRequestError(s.request, i, u);
          s.haveMetadata({
            playlistString: f.responseText,
            url: i.uri,
            id: i.id
          }), u === "HAVE_MASTER" ? s.trigger("loadedmetadata") : s.trigger("mediachange");
        }
      });
    }
  }, r.pause = function() {
    this.mediaUpdateTimeout && (M.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), this.stopRequest(), this.state === "HAVE_NOTHING" && (this.started = !1), this.state === "SWITCHING_MEDIA" ? this.media_ ? this.state = "HAVE_METADATA" : this.state = "HAVE_MASTER" : this.state === "HAVE_CURRENT_METADATA" && (this.state = "HAVE_METADATA");
  }, r.load = function(i) {
    var a = this;
    this.mediaUpdateTimeout && (M.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null);
    var s = this.media();
    if (i) {
      var o = s ? (s.partTargetDuration || s.targetDuration) / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = M.setTimeout(function() {
        a.mediaUpdateTimeout = null, a.load();
      }, o);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    s && !s.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist");
  }, r.updateMediaUpdateTimeout_ = function(i) {
    var a = this;
    this.mediaUpdateTimeout && (M.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), !(!this.media() || this.media().endList) && (this.mediaUpdateTimeout = M.setTimeout(function() {
      a.mediaUpdateTimeout = null, a.trigger("mediaupdatetimeout"), a.updateMediaUpdateTimeout_(i);
    }, i));
  }, r.start = function() {
    var i = this;
    if (this.started = !0, typeof this.src == "object") {
      this.src.uri || (this.src.uri = M.location.href), this.src.resolvedUri = this.src.uri, setTimeout(function() {
        i.setupInitialPlaylist(i.src);
      }, 0);
      return;
    }
    this.request = this.vhs_.xhr({
      uri: this.src,
      withCredentials: this.withCredentials
    }, function(a, s) {
      if (i.request) {
        if (i.request = null, a)
          return i.error = {
            status: s.status,
            message: "HLS playlist request error at URL: " + i.src + ".",
            responseText: s.responseText,
            // MEDIA_ERR_NETWORK
            code: 2
          }, i.state === "HAVE_NOTHING" && (i.started = !1), i.trigger("error");
        i.src = pu(i.handleManifestRedirects, i.src, s);
        var o = i.parseManifest_({
          manifestString: s.responseText,
          url: i.src
        });
        i.setupInitialPlaylist(o);
      }
    });
  }, r.srcUri = function() {
    return typeof this.src == "string" ? this.src : this.src.uri;
  }, r.setupInitialPlaylist = function(i) {
    if (this.state = "HAVE_MASTER", i.playlists) {
      this.master = i, P0(this.master, this.srcUri()), i.playlists.forEach(function(s) {
        s.segments = L0(s), s.segments.forEach(function(o) {
          k0(o, s.resolvedUri);
        });
      }), this.trigger("loadedplaylist"), this.request || this.media(this.master.playlists[0]);
      return;
    }
    var a = this.srcUri() || M.location.href;
    this.master = a1(i, a), this.haveMetadata({
      playlistObject: i,
      url: a,
      id: this.master.playlists[0].id
    }), this.trigger("loadedmetadata");
  }, e;
}(s1), d1 = P.xhr, c1 = P.mergeOptions, Pc = function(e, r, n, i) {
  var a = e.responseType === "arraybuffer" ? e.response : e.responseText;
  !r && a && (e.responseTime = Date.now(), e.roundTripTime = e.responseTime - e.requestTime, e.bytesReceived = a.byteLength || a.length, e.bandwidth || (e.bandwidth = Math.floor(e.bytesReceived / e.roundTripTime * 8 * 1e3))), n.headers && (e.responseHeaders = n.headers), r && r.code === "ETIMEDOUT" && (e.timedout = !0), !r && !e.aborted && n.statusCode !== 200 && n.statusCode !== 206 && n.statusCode !== 0 && (r = new Error("XHR Failed with a response of: " + (e && (a || e.responseText)))), i(r, e);
}, D0 = function() {
  var e = function r(n, i) {
    n = c1({
      timeout: 45e3
    }, n);
    var a = r.beforeRequest || P.Vhs.xhr.beforeRequest;
    if (a && typeof a == "function") {
      var s = a(n);
      s && (n = s);
    }
    var o = P.Vhs.xhr.original === !0 ? d1 : P.Vhs.xhr, u = o(n, function(d, h) {
      return Pc(u, d, h, i);
    }), l = u.abort;
    return u.abort = function() {
      return u.aborted = !0, l.apply(u, arguments);
    }, u.uri = n.uri, u.requestTime = Date.now(), u;
  };
  return e.original = !0, e;
}, h1 = function(e) {
  var r, n = e.offset;
  return typeof e.offset == "bigint" || typeof e.length == "bigint" ? r = M.BigInt(e.offset) + M.BigInt(e.length) - M.BigInt(1) : r = e.offset + e.length - 1, "bytes=" + n + "-" + r;
}, kc = function(e) {
  var r = {};
  return e.byterange && (r.Range = h1(e.byterange)), r;
}, f1 = function(e, r) {
  return e.start(r) + "-" + e.end(r);
}, p1 = function(e, r) {
  var n = e.toString(16);
  return "00".substring(0, 2 - n.length) + n + (r % 2 ? " " : "");
}, g1 = function(e) {
  return e >= 32 && e < 126 ? String.fromCharCode(e) : ".";
}, R0 = function(e) {
  var r = {};
  return Object.keys(e).forEach(function(n) {
    var i = e[n];
    yv(i) ? r[n] = {
      bytes: i.buffer,
      byteOffset: i.byteOffset,
      byteLength: i.byteLength
    } : r[n] = i;
  }), r;
}, mu = function(e) {
  var r = e.byterange || {
    length: 1 / 0,
    offset: 0
  };
  return [r.length, r.offset, e.resolvedUri].join(",");
}, O0 = function(e) {
  return e.resolvedUri;
}, M0 = function(e) {
  for (var r = Array.prototype.slice.call(e), n = 16, i = "", a, s, o = 0; o < r.length / n; o++)
    a = r.slice(o * n, o * n + n).map(p1).join(""), s = r.slice(o * n, o * n + n).map(g1).join(""), i += a + " " + s + `
`;
  return i;
}, m1 = function(e) {
  var r = e.bytes;
  return M0(r);
}, v1 = function(e) {
  var r = "", n;
  for (n = 0; n < e.length; n++)
    r += f1(e, n) + " ";
  return r;
}, y1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTransferableMessage: R0,
  initSegmentId: mu,
  segmentKeyId: O0,
  hexDump: M0,
  tagDump: m1,
  textRanges: v1
}), N0 = 0.25, _1 = function(e, r) {
  if (!r.dateTimeObject)
    return null;
  var n = r.videoTimingInfo.transmuxerPrependedSeconds, i = r.videoTimingInfo.transmuxedPresentationStart, a = i + n, s = e - a;
  return new Date(r.dateTimeObject.getTime() + s * 1e3);
}, T1 = function(e) {
  return e.transmuxedPresentationEnd - e.transmuxedPresentationStart - e.transmuxerPrependedSeconds;
}, b1 = function(e, r) {
  var n;
  try {
    n = new Date(e);
  } catch {
    return null;
  }
  if (!r || !r.segments || r.segments.length === 0)
    return null;
  var i = r.segments[0];
  if (n < i.dateTimeObject)
    return null;
  for (var a = 0; a < r.segments.length - 1; a++) {
    i = r.segments[a];
    var s = r.segments[a + 1].dateTimeObject;
    if (n < s)
      break;
  }
  var o = r.segments[r.segments.length - 1], u = o.dateTimeObject, l = o.videoTimingInfo ? T1(o.videoTimingInfo) : o.duration + o.duration * N0, d = new Date(u.getTime() + l * 1e3);
  return n > d ? null : (n > u && (i = o), {
    segment: i,
    estimatedStart: i.videoTimingInfo ? i.videoTimingInfo.transmuxedPresentationStart : hi.duration(r, r.mediaSequence + r.segments.indexOf(i)),
    // Although, given that all segments have accurate date time objects, the segment
    // selected should be accurate, unless the video has been transmuxed at some point
    // (determined by the presence of the videoTimingInfo object), the segment's "player
    // time" (the start time in the player) can't be considered accurate.
    type: i.videoTimingInfo ? "accurate" : "estimate"
  });
}, S1 = function(e, r) {
  if (!r || !r.segments || r.segments.length === 0)
    return null;
  for (var n = 0, i, a = 0; a < r.segments.length && (i = r.segments[a], n = i.videoTimingInfo ? i.videoTimingInfo.transmuxedPresentationEnd : n + i.duration, !(e <= n)); a++)
    ;
  var s = r.segments[r.segments.length - 1];
  if (s.videoTimingInfo && s.videoTimingInfo.transmuxedPresentationEnd < e)
    return null;
  if (e > n) {
    if (e > n + s.duration * N0)
      return null;
    i = s;
  }
  return {
    segment: i,
    estimatedStart: i.videoTimingInfo ? i.videoTimingInfo.transmuxedPresentationStart : n - i.duration,
    // Because videoTimingInfo is only set after transmux, it is the only way to get
    // accurate timing values.
    type: i.videoTimingInfo ? "accurate" : "estimate"
  };
}, E1 = function(e, r) {
  var n, i;
  try {
    n = new Date(e), i = new Date(r);
  } catch {
  }
  var a = n.getTime(), s = i.getTime();
  return (s - a) / 1e3;
}, x1 = function(e) {
  if (!e.segments || e.segments.length === 0)
    return !1;
  for (var r = 0; r < e.segments.length; r++) {
    var n = e.segments[r];
    if (!n.dateTimeObject)
      return !1;
  }
  return !0;
}, C1 = function(e) {
  var r = e.playlist, n = e.time, i = n === void 0 ? void 0 : n, a = e.callback;
  if (!a)
    throw new Error("getProgramTime: callback must be provided");
  if (!r || i === void 0)
    return a({
      message: "getProgramTime: playlist and time must be provided"
    });
  var s = S1(i, r);
  if (!s)
    return a({
      message: "valid programTime was not found"
    });
  if (s.type === "estimate")
    return a({
      message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
      seekTime: s.estimatedStart
    });
  var o = {
    mediaSeconds: i
  }, u = _1(i, s.segment);
  return u && (o.programDateTime = u.toISOString()), a(null, o);
}, A1 = function t(e) {
  var r = e.programTime, n = e.playlist, i = e.retryCount, a = i === void 0 ? 2 : i, s = e.seekTo, o = e.pauseAfterSeek, u = o === void 0 ? !0 : o, l = e.tech, d = e.callback;
  if (!d)
    throw new Error("seekToProgramTime: callback must be provided");
  if (typeof r > "u" || !n || !s)
    return d({
      message: "seekToProgramTime: programTime, seekTo and playlist must be provided"
    });
  if (!n.endList && !l.hasStarted_)
    return d({
      message: "player must be playing a live stream to start buffering"
    });
  if (!x1(n))
    return d({
      message: "programDateTime tags must be provided in the manifest " + n.resolvedUri
    });
  var h = b1(r, n);
  if (!h)
    return d({
      message: r + " was not found in the stream"
    });
  var f = h.segment, v = E1(f.dateTimeObject, r);
  if (h.type === "estimate") {
    if (a === 0)
      return d({
        message: r + " is not buffered yet. Try again"
      });
    s(h.estimatedStart + v), l.one("seeked", function() {
      t({
        programTime: r,
        playlist: n,
        retryCount: a - 1,
        seekTo: s,
        pauseAfterSeek: u,
        tech: l,
        callback: d
      });
    });
    return;
  }
  var b = f.start + v, _ = function() {
    return d(null, l.currentTime());
  };
  l.one("seeked", _), u && l.pause(), s(b);
}, zl = function(e, r) {
  if (e.readyState === 4)
    return r();
}, w1 = function(e, r, n) {
  var i = [], a, s = !1, o = function(f, v, b, _) {
    return v.abort(), s = !0, n(f, v, b, _);
  }, u = function(f, v) {
    if (!s) {
      if (f)
        return o(f, v, "", i);
      var b = v.responseText.substring(i && i.byteLength || 0, v.responseText.length);
      if (i = kS(i, _v(b, !0)), a = a || hs(i), i.length < 10 || a && i.length < a + 2)
        return zl(v, function() {
          return o(f, v, "", i);
        });
      var _ = _h(i);
      return _ === "ts" && i.length < 188 ? zl(v, function() {
        return o(f, v, "", i);
      }) : !_ && i.length < 376 ? zl(v, function() {
        return o(f, v, "", i);
      }) : o(null, v, _, i);
    }
  }, l = {
    uri: e,
    beforeSend: function(f) {
      f.overrideMimeType("text/plain; charset=x-user-defined"), f.addEventListener("progress", function(v) {
        return v.total, v.loaded, Pc(f, null, {
          statusCode: f.status
        }, u);
      });
    }
  }, d = r(l, function(h, f) {
    return Pc(d, h, f, u);
  });
  return d;
}, P1 = P.EventTarget, B0 = P.mergeOptions, ag = function(e, r) {
  if (!I0(e, r) || e.sidx && r.sidx && (e.sidx.offset !== r.sidx.offset || e.sidx.length !== r.sidx.length))
    return !1;
  if (!e.sidx && r.sidx || e.sidx && !r.sidx || e.segments && !r.segments || !e.segments && r.segments)
    return !1;
  if (!e.segments && !r.segments)
    return !0;
  for (var n = 0; n < e.segments.length; n++) {
    var i = e.segments[n], a = r.segments[n];
    if (i.uri !== a.uri)
      return !1;
    if (!(!i.byterange && !a.byterange)) {
      var s = i.byterange, o = a.byterange;
      if (s && !o || !s && o || s.offset !== o.offset || s.length !== o.length)
        return !1;
    }
  }
  return !0;
}, k1 = function(e, r, n, i) {
  var a = i.attributes.NAME || n;
  return "placeholder-uri-" + e + "-" + r + "-" + a;
}, L1 = function(e) {
  var r = e.masterXml, n = e.srcUrl, i = e.clientOffset, a = e.sidxMapping, s = e.previousManifest, o = KE(r, {
    manifestUri: n,
    clientOffset: i,
    sidxMapping: a,
    previousManifest: s
  });
  return P0(o, n, k1), o;
}, I1 = function(e, r) {
  ja(e, function(n, i, a, s) {
    s in r.mediaGroups[i][a] || delete e.mediaGroups[i][a][s];
  });
}, D1 = function(e, r, n) {
  for (var i = !0, a = B0(e, {
    // These are top level properties that can be updated
    duration: r.duration,
    minimumUpdatePeriod: r.minimumUpdatePeriod,
    timelineStarts: r.timelineStarts
  }), s = 0; s < r.playlists.length; s++) {
    var o = r.playlists[s];
    if (o.sidx) {
      var u = Uu(o.sidx);
      n && n[u] && n[u].sidx && gh(o, n[u].sidx, o.sidx.resolvedUri);
    }
    var l = Ac(a, o, ag);
    l && (a = l, i = !1);
  }
  return ja(r, function(d, h, f, v) {
    if (d.playlists && d.playlists.length) {
      var b = d.playlists[0].id, _ = Ac(a, d.playlists[0], ag);
      _ && (a = _, v in a.mediaGroups[h][f] || (a.mediaGroups[h][f][v] = d), a.mediaGroups[h][f][v].playlists[0] = a.playlists[b], i = !1);
    }
  }), I1(a, r), r.minimumUpdatePeriod !== e.minimumUpdatePeriod && (i = !1), i ? null : a;
}, R1 = function(e, r) {
  var n = !e.map && !r.map, i = n || !!(e.map && r.map && e.map.byterange.offset === r.map.byterange.offset && e.map.byterange.length === r.map.byterange.length);
  return i && e.uri === r.uri && e.byterange.offset === r.byterange.offset && e.byterange.length === r.byterange.length;
}, sg = function(e, r) {
  var n = {};
  for (var i in e) {
    var a = e[i], s = a.sidx;
    if (s) {
      var o = Uu(s);
      if (!r[o])
        break;
      var u = r[o].sidxInfo;
      R1(u, s) && (n[o] = r[o]);
    }
  }
  return n;
}, O1 = function(e, r) {
  var n = sg(e.playlists, r), i = n;
  return ja(e, function(a, s, o, u) {
    if (a.playlists && a.playlists.length) {
      var l = a.playlists;
      i = B0(i, sg(l, r));
    }
  }), i;
}, Lc = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i, a, s) {
    var o;
    a === void 0 && (a = {}), o = t.call(this) || this, o.masterPlaylistLoader_ = s || Le(o), s || (o.isMaster_ = !0);
    var u = a, l = u.withCredentials, d = l === void 0 ? !1 : l, h = u.handleManifestRedirects, f = h === void 0 ? !1 : h;
    if (o.vhs_ = i, o.withCredentials = d, o.handleManifestRedirects = f, !n)
      throw new Error("A non-empty playlist URL or object is required");
    return o.on("minimumUpdatePeriod", function() {
      o.refreshXml_();
    }), o.on("mediaupdatetimeout", function() {
      o.refreshMedia_(o.media().id);
    }), o.state = "HAVE_NOTHING", o.loadedPlaylists_ = {}, o.logger_ = Hi("DashPlaylistLoader"), o.isMaster_ ? (o.masterPlaylistLoader_.srcUrl = n, o.masterPlaylistLoader_.sidxMapping_ = {}) : o.childPlaylist_ = n, o;
  }
  var r = e.prototype;
  return r.requestErrored_ = function(i, a, s) {
    if (!this.request)
      return !0;
    if (this.request = null, i)
      return this.error = typeof i == "object" && !(i instanceof Error) ? i : {
        status: a.status,
        message: "DASH request error at URL: " + a.uri,
        response: a.response,
        // MEDIA_ERR_NETWORK
        code: 2
      }, s && (this.state = s), this.trigger("error"), !0;
  }, r.addSidxSegments_ = function(i, a, s) {
    var o = this, u = i.sidx && Uu(i.sidx);
    if (!i.sidx || !u || this.masterPlaylistLoader_.sidxMapping_[u]) {
      this.mediaRequest_ = M.setTimeout(function() {
        return s(!1);
      }, 0);
      return;
    }
    var l = pu(this.handleManifestRedirects, i.sidx.resolvedUri), d = function(f, v) {
      if (!o.requestErrored_(f, v, a)) {
        var b = o.masterPlaylistLoader_.sidxMapping_, _;
        try {
          _ = ZE(Ae(v.response).subarray(8));
        } catch (y) {
          o.requestErrored_(y, v, a);
          return;
        }
        return b[u] = {
          sidxInfo: i.sidx,
          sidx: _
        }, gh(i, _, i.sidx.resolvedUri), s(!0);
      }
    };
    this.request = w1(l, this.vhs_.xhr, function(h, f, v, b) {
      if (h)
        return d(h, f);
      if (!v || v !== "mp4")
        return d({
          status: f.status,
          message: "Unsupported " + (v || "unknown") + " container type for sidx segment at URL: " + l,
          // response is just bytes in this case
          // but we really don't want to return that.
          response: "",
          playlist: i,
          internal: !0,
          blacklistDuration: 1 / 0,
          // MEDIA_ERR_NETWORK
          code: 2
        }, f);
      var _ = i.sidx.byterange, y = _.offset, E = _.length;
      if (b.length >= E + y)
        return d(h, {
          response: b.subarray(y, y + E),
          status: f.status,
          uri: f.uri
        });
      o.request = o.vhs_.xhr({
        uri: l,
        responseType: "arraybuffer",
        headers: kc({
          byterange: i.sidx.byterange
        })
      }, d);
    });
  }, r.dispose = function() {
    this.trigger("dispose"), this.stopRequest(), this.loadedPlaylists_ = {}, M.clearTimeout(this.minimumUpdatePeriodTimeout_), M.clearTimeout(this.mediaRequest_), M.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.mediaRequest_ = null, this.minimumUpdatePeriodTimeout_ = null, this.masterPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.masterPlaylistLoader_.createMupOnMedia_), this.masterPlaylistLoader_.createMupOnMedia_ = null), this.off();
  }, r.hasPendingRequest = function() {
    return this.request || this.mediaRequest_;
  }, r.stopRequest = function() {
    if (this.request) {
      var i = this.request;
      this.request = null, i.onreadystatechange = null, i.abort();
    }
  }, r.media = function(i) {
    var a = this;
    if (!i)
      return this.media_;
    if (this.state === "HAVE_NOTHING")
      throw new Error("Cannot switch media playlist from " + this.state);
    var s = this.state;
    if (typeof i == "string") {
      if (!this.masterPlaylistLoader_.master.playlists[i])
        throw new Error("Unknown playlist URI: " + i);
      i = this.masterPlaylistLoader_.master.playlists[i];
    }
    var o = !this.media_ || i.id !== this.media_.id;
    if (o && this.loadedPlaylists_[i.id] && this.loadedPlaylists_[i.id].endList) {
      this.state = "HAVE_METADATA", this.media_ = i, o && (this.trigger("mediachanging"), this.trigger("mediachange"));
      return;
    }
    o && (this.media_ && this.trigger("mediachanging"), this.addSidxSegments_(i, s, function(u) {
      a.haveMetadata({
        startingState: s,
        playlist: i
      });
    }));
  }, r.haveMetadata = function(i) {
    var a = i.startingState, s = i.playlist;
    this.state = "HAVE_METADATA", this.loadedPlaylists_[s.id] = s, this.mediaRequest_ = null, this.refreshMedia_(s.id), a === "HAVE_MASTER" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
  }, r.pause = function() {
    this.masterPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.masterPlaylistLoader_.createMupOnMedia_), this.masterPlaylistLoader_.createMupOnMedia_ = null), this.stopRequest(), M.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.isMaster_ && (M.clearTimeout(this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_), this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_ = null), this.state === "HAVE_NOTHING" && (this.started = !1);
  }, r.load = function(i) {
    var a = this;
    M.clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null;
    var s = this.media();
    if (i) {
      var o = s ? s.targetDuration / 2 * 1e3 : 5e3;
      this.mediaUpdateTimeout = M.setTimeout(function() {
        return a.load();
      }, o);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    s && !s.endList ? (this.isMaster_ && !this.minimumUpdatePeriodTimeout_ && (this.trigger("minimumUpdatePeriod"), this.updateMinimumUpdatePeriodTimeout_()), this.trigger("mediaupdatetimeout")) : this.trigger("loadedplaylist");
  }, r.start = function() {
    var i = this;
    if (this.started = !0, !this.isMaster_) {
      this.mediaRequest_ = M.setTimeout(function() {
        return i.haveMaster_();
      }, 0);
      return;
    }
    this.requestMaster_(function(a, s) {
      i.haveMaster_(), !i.hasPendingRequest() && !i.media_ && i.media(i.masterPlaylistLoader_.master.playlists[0]);
    });
  }, r.requestMaster_ = function(i) {
    var a = this;
    this.request = this.vhs_.xhr({
      uri: this.masterPlaylistLoader_.srcUrl,
      withCredentials: this.withCredentials
    }, function(s, o) {
      if (a.requestErrored_(s, o)) {
        a.state === "HAVE_NOTHING" && (a.started = !1);
        return;
      }
      var u = o.responseText !== a.masterPlaylistLoader_.masterXml_;
      if (a.masterPlaylistLoader_.masterXml_ = o.responseText, o.responseHeaders && o.responseHeaders.date ? a.masterLoaded_ = Date.parse(o.responseHeaders.date) : a.masterLoaded_ = Date.now(), a.masterPlaylistLoader_.srcUrl = pu(a.handleManifestRedirects, a.masterPlaylistLoader_.srcUrl, o), u) {
        a.handleMaster_(), a.syncClientServerClock_(function() {
          return i(o, u);
        });
        return;
      }
      return i(o, u);
    });
  }, r.syncClientServerClock_ = function(i) {
    var a = this, s = XE(this.masterPlaylistLoader_.masterXml_);
    if (s === null)
      return this.masterPlaylistLoader_.clientOffset_ = this.masterLoaded_ - Date.now(), i();
    if (s.method === "DIRECT")
      return this.masterPlaylistLoader_.clientOffset_ = s.value - Date.now(), i();
    this.request = this.vhs_.xhr({
      uri: Mi(this.masterPlaylistLoader_.srcUrl, s.value),
      method: s.method,
      withCredentials: this.withCredentials
    }, function(o, u) {
      if (a.request) {
        if (o)
          return a.masterPlaylistLoader_.clientOffset_ = a.masterLoaded_ - Date.now(), i();
        var l;
        s.method === "HEAD" ? !u.responseHeaders || !u.responseHeaders.date ? l = a.masterLoaded_ : l = Date.parse(u.responseHeaders.date) : l = Date.parse(u.responseText), a.masterPlaylistLoader_.clientOffset_ = l - Date.now(), i();
      }
    });
  }, r.haveMaster_ = function() {
    this.state = "HAVE_MASTER", this.isMaster_ ? this.trigger("loadedplaylist") : this.media_ || this.media(this.childPlaylist_);
  }, r.handleMaster_ = function() {
    this.mediaRequest_ = null;
    var i = this.masterPlaylistLoader_.master, a = L1({
      masterXml: this.masterPlaylistLoader_.masterXml_,
      srcUrl: this.masterPlaylistLoader_.srcUrl,
      clientOffset: this.masterPlaylistLoader_.clientOffset_,
      sidxMapping: this.masterPlaylistLoader_.sidxMapping_,
      previousManifest: i
    });
    i && (a = D1(i, a, this.masterPlaylistLoader_.sidxMapping_)), this.masterPlaylistLoader_.master = a || i;
    var s = this.masterPlaylistLoader_.master.locations && this.masterPlaylistLoader_.master.locations[0];
    return s && s !== this.masterPlaylistLoader_.srcUrl && (this.masterPlaylistLoader_.srcUrl = s), (!i || a && a.minimumUpdatePeriod !== i.minimumUpdatePeriod) && this.updateMinimumUpdatePeriodTimeout_(), !!a;
  }, r.updateMinimumUpdatePeriodTimeout_ = function() {
    var i = this.masterPlaylistLoader_;
    i.createMupOnMedia_ && (i.off("loadedmetadata", i.createMupOnMedia_), i.createMupOnMedia_ = null), i.minimumUpdatePeriodTimeout_ && (M.clearTimeout(i.minimumUpdatePeriodTimeout_), i.minimumUpdatePeriodTimeout_ = null);
    var a = i.master && i.master.minimumUpdatePeriod;
    if (a === 0 && (i.media() ? a = i.media().targetDuration * 1e3 : (i.createMupOnMedia_ = i.updateMinimumUpdatePeriodTimeout_, i.one("loadedmetadata", i.createMupOnMedia_))), typeof a != "number" || a <= 0) {
      a < 0 && this.logger_("found invalid minimumUpdatePeriod of " + a + ", not setting a timeout");
      return;
    }
    this.createMUPTimeout_(a);
  }, r.createMUPTimeout_ = function(i) {
    var a = this.masterPlaylistLoader_;
    a.minimumUpdatePeriodTimeout_ = M.setTimeout(function() {
      a.minimumUpdatePeriodTimeout_ = null, a.trigger("minimumUpdatePeriod"), a.createMUPTimeout_(i);
    }, i);
  }, r.refreshXml_ = function() {
    var i = this;
    this.requestMaster_(function(a, s) {
      s && (i.media_ && (i.media_ = i.masterPlaylistLoader_.master.playlists[i.media_.id]), i.masterPlaylistLoader_.sidxMapping_ = O1(i.masterPlaylistLoader_.master, i.masterPlaylistLoader_.sidxMapping_), i.addSidxSegments_(i.media(), i.state, function(o) {
        i.refreshMedia_(i.media().id);
      }));
    });
  }, r.refreshMedia_ = function(i) {
    var a = this;
    if (!i)
      throw new Error("refreshMedia_ must take a media id");
    this.media_ && this.isMaster_ && this.handleMaster_();
    var s = this.masterPlaylistLoader_.master.playlists, o = !this.media_ || this.media_ !== s[i];
    if (o ? this.media_ = s[i] : this.trigger("playlistunchanged"), !this.mediaUpdateTimeout) {
      var u = function l() {
        a.media().endList || (a.mediaUpdateTimeout = M.setTimeout(function() {
          a.trigger("mediaupdatetimeout"), l();
        }, wc(a.media(), !!o)));
      };
      u();
    }
    this.trigger("loadedplaylist");
  }, e;
}(P1), Bt = {
  GOAL_BUFFER_LENGTH: 30,
  MAX_GOAL_BUFFER_LENGTH: 60,
  BACK_BUFFER_LENGTH: 30,
  GOAL_BUFFER_LENGTH_RATE: 1,
  // 0.5 MB/s
  INITIAL_BANDWIDTH: 4194304,
  // A fudge factor to apply to advertised playlist bitrates to account for
  // temporary flucations in client bandwidth
  BANDWIDTH_VARIANCE: 1.2,
  // How much of the buffer must be filled before we consider upswitching
  BUFFER_LOW_WATER_LINE: 0,
  MAX_BUFFER_LOW_WATER_LINE: 30,
  // TODO: Remove this when experimentalBufferBasedABR is removed
  EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
  BUFFER_LOW_WATER_LINE_RATE: 1,
  // If the buffer is greater than the high water line, we won't switch down
  BUFFER_HIGH_WATER_LINE: 30
}, M1 = function(e) {
  for (var r = new Uint8Array(new ArrayBuffer(e.length)), n = 0; n < e.length; n++)
    r[n] = e.charCodeAt(n);
  return r.buffer;
}, F0 = function(e) {
  return e.on = e.addEventListener, e.off = e.removeEventListener, e;
}, N1 = function(e) {
  try {
    return URL.createObjectURL(new Blob([e], {
      type: "application/javascript"
    }));
  } catch {
    var r = new BlobBuilder();
    return r.append(e), URL.createObjectURL(r.getBlob());
  }
}, U0 = function(e) {
  return function() {
    var r = N1(e), n = F0(new Worker(r));
    n.objURL = r;
    var i = n.terminate;
    return n.on = n.addEventListener, n.off = n.removeEventListener, n.terminate = function() {
      return URL.revokeObjectURL(r), i.call(this);
    }, n;
  };
}, V0 = function(e) {
  return "var browserWorkerPolyFill = " + F0.toString() + `;
browserWorkerPolyFill(self);
` + e;
}, j0 = function(e) {
  return e.toString().replace(/^function.+?{/, "").slice(0, -1);
}, B1 = V0(j0(function() {
  var t = function() {
    this.init = function() {
      var c = {};
      this.on = function(g, p) {
        c[g] || (c[g] = []), c[g] = c[g].concat(p);
      }, this.off = function(g, p) {
        var m;
        return c[g] ? (m = c[g].indexOf(p), c[g] = c[g].slice(), c[g].splice(m, 1), m > -1) : !1;
      }, this.trigger = function(g) {
        var p, m, T, S;
        if (p = c[g], !!p)
          if (arguments.length === 2)
            for (T = p.length, m = 0; m < T; ++m)
              p[m].call(this, arguments[1]);
          else {
            for (S = [], m = arguments.length, m = 1; m < arguments.length; ++m)
              S.push(arguments[m]);
            for (T = p.length, m = 0; m < T; ++m)
              p[m].apply(this, S);
          }
      }, this.dispose = function() {
        c = {};
      };
    };
  };
  t.prototype.pipe = function(x) {
    return this.on("data", function(c) {
      x.push(c);
    }), this.on("done", function(c) {
      x.flush(c);
    }), this.on("partialdone", function(c) {
      x.partialFlush(c);
    }), this.on("endedtimeline", function(c) {
      x.endTimeline(c);
    }), this.on("reset", function(c) {
      x.reset(c);
    }), x;
  }, t.prototype.push = function(x) {
    this.trigger("data", x);
  }, t.prototype.flush = function(x) {
    this.trigger("done", x);
  }, t.prototype.partialFlush = function(x) {
    this.trigger("partialdone", x);
  }, t.prototype.endTimeline = function(x) {
    this.trigger("endedtimeline", x);
  }, t.prototype.reset = function(x) {
    this.trigger("reset", x);
  };
  var e = t, r = Math.pow(2, 32), n = function(c) {
    var g = new DataView(c.buffer, c.byteOffset, c.byteLength), p;
    return g.getBigUint64 ? (p = g.getBigUint64(0), p < Number.MAX_SAFE_INTEGER ? Number(p) : p) : g.getUint32(0) * r + g.getUint32(4);
  }, i = {
    getUint64: n,
    MAX_UINT32: r
  }, a = i.MAX_UINT32, s, o, u, l, d, h, f, v, b, _, y, E, R, D, C, w, k, I, U, $, W, G, Y, re, j, J, z, Q, te, ae, ne, Se, Te, We, Be, ge;
  (function() {
    var x;
    if (Y = {
      avc1: [],
      // codingname
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      // codingname
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      smhd: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      styp: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: []
    }, !(typeof Uint8Array > "u")) {
      for (x in Y)
        Y.hasOwnProperty(x) && (Y[x] = [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3)]);
      re = new Uint8Array(["i".charCodeAt(0), "s".charCodeAt(0), "o".charCodeAt(0), "m".charCodeAt(0)]), J = new Uint8Array(["a".charCodeAt(0), "v".charCodeAt(0), "c".charCodeAt(0), "1".charCodeAt(0)]), j = new Uint8Array([0, 0, 0, 1]), z = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // pre_defined
        118,
        105,
        100,
        101,
        // handler_type: 'vide'
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        86,
        105,
        100,
        101,
        111,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
        // name: 'VideoHandler'
      ]), Q = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // pre_defined
        115,
        111,
        117,
        110,
        // handler_type: 'soun'
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        83,
        111,
        117,
        110,
        100,
        72,
        97,
        110,
        100,
        108,
        101,
        114,
        0
        // name: 'SoundHandler'
      ]), te = {
        video: z,
        audio: Q
      }, Se = new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        1,
        // entry_count
        0,
        0,
        0,
        12,
        // entry_size
        117,
        114,
        108,
        32,
        // 'url' type
        0,
        // version 0
        0,
        0,
        1
        // entry_flags
      ]), ne = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        // balance, 0 means centered
        0,
        0
        // reserved
      ]), Te = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0
        // entry_count
      ]), We = Te, Be = new Uint8Array([
        0,
        // version
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        0,
        // sample_size
        0,
        0,
        0,
        0
        // sample_count
      ]), ge = Te, ae = new Uint8Array([
        0,
        // version
        0,
        0,
        1,
        // flags
        0,
        0,
        // graphicsmode
        0,
        0,
        0,
        0,
        0,
        0
        // opcolor
      ]);
    }
  })(), s = function(c) {
    var g = [], p = 0, m, T, S;
    for (m = 1; m < arguments.length; m++)
      g.push(arguments[m]);
    for (m = g.length; m--; )
      p += g[m].byteLength;
    for (T = new Uint8Array(p + 8), S = new DataView(T.buffer, T.byteOffset, T.byteLength), S.setUint32(0, T.byteLength), T.set(c, 4), m = 0, p = 8; m < g.length; m++)
      T.set(g[m], p), p += g[m].byteLength;
    return T;
  }, o = function() {
    return s(Y.dinf, s(Y.dref, Se));
  }, u = function(c) {
    return s(Y.esds, new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      // ES_Descriptor
      3,
      // tag, ES_DescrTag
      25,
      // length
      0,
      0,
      // ES_ID
      0,
      // streamDependenceFlag, URL_flag, reserved, streamPriority
      // DecoderConfigDescriptor
      4,
      // tag, DecoderConfigDescrTag
      17,
      // length
      64,
      // object type
      21,
      // streamType
      0,
      6,
      0,
      // bufferSizeDB
      0,
      0,
      218,
      192,
      // maxBitrate
      0,
      0,
      218,
      192,
      // avgBitrate
      // DecoderSpecificInfo
      5,
      // tag, DecoderSpecificInfoTag
      2,
      // length
      // ISO/IEC 14496-3, AudioSpecificConfig
      // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
      c.audioobjecttype << 3 | c.samplingfrequencyindex >>> 1,
      c.samplingfrequencyindex << 7 | c.channelcount << 3,
      6,
      1,
      2
      // GASpecificConfig
    ]));
  }, l = function() {
    return s(Y.ftyp, re, j, re, J);
  }, w = function(c) {
    return s(Y.hdlr, te[c]);
  }, d = function(c) {
    return s(Y.mdat, c);
  }, C = function(c) {
    var g = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      3,
      // modification_time
      0,
      1,
      95,
      144,
      // timescale, 90,000 "ticks" per second
      c.duration >>> 24 & 255,
      c.duration >>> 16 & 255,
      c.duration >>> 8 & 255,
      c.duration & 255,
      // duration
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]);
    return c.samplerate && (g[12] = c.samplerate >>> 24 & 255, g[13] = c.samplerate >>> 16 & 255, g[14] = c.samplerate >>> 8 & 255, g[15] = c.samplerate & 255), s(Y.mdhd, g);
  }, D = function(c) {
    return s(Y.mdia, C(c), w(c.type), f(c));
  }, h = function(c) {
    return s(Y.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      (c & 4278190080) >> 24,
      (c & 16711680) >> 16,
      (c & 65280) >> 8,
      c & 255
      // sequence_number
    ]));
  }, f = function(c) {
    return s(Y.minf, c.type === "video" ? s(Y.vmhd, ae) : s(Y.smhd, ne), o(), I(c));
  }, v = function(c, g) {
    for (var p = [], m = g.length; m--; )
      p[m] = $(g[m]);
    return s.apply(null, [Y.moof, h(c)].concat(p));
  }, b = function(c) {
    for (var g = c.length, p = []; g--; )
      p[g] = E(c[g]);
    return s.apply(null, [Y.moov, y(4294967295)].concat(p).concat(_(c)));
  }, _ = function(c) {
    for (var g = c.length, p = []; g--; )
      p[g] = W(c[g]);
    return s.apply(null, [Y.mvex].concat(p));
  }, y = function(c) {
    var g = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // creation_time
      0,
      0,
      0,
      2,
      // modification_time
      0,
      1,
      95,
      144,
      // timescale, 90,000 "ticks" per second
      (c & 4278190080) >> 24,
      (c & 16711680) >> 16,
      (c & 65280) >> 8,
      c & 255,
      // duration
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return s(Y.mvhd, g);
  }, k = function(c) {
    var g = c.samples || [], p = new Uint8Array(4 + g.length), m, T;
    for (T = 0; T < g.length; T++)
      m = g[T].flags, p[T + 4] = m.dependsOn << 4 | m.isDependedOn << 2 | m.hasRedundancy;
    return s(Y.sdtp, p);
  }, I = function(c) {
    return s(Y.stbl, U(c), s(Y.stts, ge), s(Y.stsc, We), s(Y.stsz, Be), s(Y.stco, Te));
  }, function() {
    var x, c;
    U = function(p) {
      return s(Y.stsd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        0,
        0,
        0,
        1
      ]), p.type === "video" ? x(p) : c(p));
    }, x = function(p) {
      var m = p.sps || [], T = p.pps || [], S = [], L = [], O, V;
      for (O = 0; O < m.length; O++)
        S.push((m[O].byteLength & 65280) >>> 8), S.push(m[O].byteLength & 255), S = S.concat(Array.prototype.slice.call(m[O]));
      for (O = 0; O < T.length; O++)
        L.push((T[O].byteLength & 65280) >>> 8), L.push(T[O].byteLength & 255), L = L.concat(Array.prototype.slice.call(T[O]));
      if (V = [Y.avc1, new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        (p.width & 65280) >> 8,
        p.width & 255,
        // width
        (p.height & 65280) >> 8,
        p.height & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        19,
        118,
        105,
        100,
        101,
        111,
        106,
        115,
        45,
        99,
        111,
        110,
        116,
        114,
        105,
        98,
        45,
        104,
        108,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
        // pre_defined = -1
      ]), s(Y.avcC, new Uint8Array([
        1,
        // configurationVersion
        p.profileIdc,
        // AVCProfileIndication
        p.profileCompatibility,
        // profile_compatibility
        p.levelIdc,
        // AVCLevelIndication
        255
        // lengthSizeMinusOne, hard-coded to 4 bytes
      ].concat(
        [m.length],
        // numOfSequenceParameterSets
        S,
        // "SPS"
        [T.length],
        // numOfPictureParameterSets
        L
        // "PPS"
      ))), s(Y.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
        // avgBitrate
      ]))], p.sarRatio) {
        var B = p.sarRatio[0], H = p.sarRatio[1];
        V.push(s(Y.pasp, new Uint8Array([(B & 4278190080) >> 24, (B & 16711680) >> 16, (B & 65280) >> 8, B & 255, (H & 4278190080) >> 24, (H & 16711680) >> 16, (H & 65280) >> 8, H & 255])));
      }
      return s.apply(null, V);
    }, c = function(p) {
      return s(Y.mp4a, new Uint8Array([
        // SampleEntry, ISO/IEC 14496-12
        0,
        0,
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        // AudioSampleEntry, ISO/IEC 14496-12
        0,
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        // reserved
        (p.channelcount & 65280) >> 8,
        p.channelcount & 255,
        // channelcount
        (p.samplesize & 65280) >> 8,
        p.samplesize & 255,
        // samplesize
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        (p.samplerate & 65280) >> 8,
        p.samplerate & 255,
        0,
        0
        // samplerate, 16.16
        // MP4AudioSampleEntry, ISO/IEC 14496-14
      ]), u(p));
    };
  }(), R = function(c) {
    var g = new Uint8Array([
      0,
      // version 0
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      // creation_time
      0,
      0,
      0,
      0,
      // modification_time
      (c.id & 4278190080) >> 24,
      (c.id & 16711680) >> 16,
      (c.id & 65280) >> 8,
      c.id & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      (c.duration & 4278190080) >> 24,
      (c.duration & 16711680) >> 16,
      (c.duration & 65280) >> 8,
      c.duration & 255,
      // duration
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      1,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      (c.width & 65280) >> 8,
      c.width & 255,
      0,
      0,
      // width
      (c.height & 65280) >> 8,
      c.height & 255,
      0,
      0
      // height
    ]);
    return s(Y.tkhd, g);
  }, $ = function(c) {
    var g, p, m, T, S, L, O;
    return g = s(Y.tfhd, new Uint8Array([
      0,
      // version 0
      0,
      0,
      58,
      // flags
      (c.id & 4278190080) >> 24,
      (c.id & 16711680) >> 16,
      (c.id & 65280) >> 8,
      c.id & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      0,
      0,
      0
      // default_sample_flags
    ])), L = Math.floor(c.baseMediaDecodeTime / a), O = Math.floor(c.baseMediaDecodeTime % a), p = s(Y.tfdt, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      // baseMediaDecodeTime
      L >>> 24 & 255,
      L >>> 16 & 255,
      L >>> 8 & 255,
      L & 255,
      O >>> 24 & 255,
      O >>> 16 & 255,
      O >>> 8 & 255,
      O & 255
    ])), S = 32 + // tfhd
    20 + // tfdt
    8 + // traf header
    16 + // mfhd
    8 + // moof header
    8, c.type === "audio" ? (m = G(c, S), s(Y.traf, g, p, m)) : (T = k(c), m = G(c, T.length + S), s(Y.traf, g, p, m, T));
  }, E = function(c) {
    return c.duration = c.duration || 4294967295, s(Y.trak, R(c), D(c));
  }, W = function(c) {
    var g = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      (c.id & 4278190080) >> 24,
      (c.id & 16711680) >> 16,
      (c.id & 65280) >> 8,
      c.id & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]);
    return c.type !== "video" && (g[g.length - 1] = 0), s(Y.trex, g);
  }, function() {
    var x, c, g;
    g = function(m, T) {
      var S = 0, L = 0, O = 0, V = 0;
      return m.length && (m[0].duration !== void 0 && (S = 1), m[0].size !== void 0 && (L = 2), m[0].flags !== void 0 && (O = 4), m[0].compositionTimeOffset !== void 0 && (V = 8)), [
        0,
        // version 0
        0,
        S | L | O | V,
        1,
        // flags
        (m.length & 4278190080) >>> 24,
        (m.length & 16711680) >>> 16,
        (m.length & 65280) >>> 8,
        m.length & 255,
        // sample_count
        (T & 4278190080) >>> 24,
        (T & 16711680) >>> 16,
        (T & 65280) >>> 8,
        T & 255
        // data_offset
      ];
    }, c = function(m, T) {
      var S, L, O, V, B, H;
      for (V = m.samples || [], T += 8 + 12 + 16 * V.length, O = g(V, T), L = new Uint8Array(O.length + V.length * 16), L.set(O), S = O.length, H = 0; H < V.length; H++)
        B = V[H], L[S++] = (B.duration & 4278190080) >>> 24, L[S++] = (B.duration & 16711680) >>> 16, L[S++] = (B.duration & 65280) >>> 8, L[S++] = B.duration & 255, L[S++] = (B.size & 4278190080) >>> 24, L[S++] = (B.size & 16711680) >>> 16, L[S++] = (B.size & 65280) >>> 8, L[S++] = B.size & 255, L[S++] = B.flags.isLeading << 2 | B.flags.dependsOn, L[S++] = B.flags.isDependedOn << 6 | B.flags.hasRedundancy << 4 | B.flags.paddingValue << 1 | B.flags.isNonSyncSample, L[S++] = B.flags.degradationPriority & 240 << 8, L[S++] = B.flags.degradationPriority & 15, L[S++] = (B.compositionTimeOffset & 4278190080) >>> 24, L[S++] = (B.compositionTimeOffset & 16711680) >>> 16, L[S++] = (B.compositionTimeOffset & 65280) >>> 8, L[S++] = B.compositionTimeOffset & 255;
      return s(Y.trun, L);
    }, x = function(m, T) {
      var S, L, O, V, B, H;
      for (V = m.samples || [], T += 8 + 12 + 8 * V.length, O = g(V, T), S = new Uint8Array(O.length + V.length * 8), S.set(O), L = O.length, H = 0; H < V.length; H++)
        B = V[H], S[L++] = (B.duration & 4278190080) >>> 24, S[L++] = (B.duration & 16711680) >>> 16, S[L++] = (B.duration & 65280) >>> 8, S[L++] = B.duration & 255, S[L++] = (B.size & 4278190080) >>> 24, S[L++] = (B.size & 16711680) >>> 16, S[L++] = (B.size & 65280) >>> 8, S[L++] = B.size & 255;
      return s(Y.trun, S);
    }, G = function(m, T) {
      return m.type === "audio" ? x(m, T) : c(m, T);
    };
  }();
  var fe = {
    ftyp: l,
    mdat: d,
    moof: v,
    moov: b,
    initSegment: function(c) {
      var g = l(), p = b(c), m;
      return m = new Uint8Array(g.byteLength + p.byteLength), m.set(g), m.set(p, g.byteLength), m;
    }
  }, me = function(c) {
    var g, p, m = [], T = [];
    for (T.byteLength = 0, T.nalCount = 0, T.duration = 0, m.byteLength = 0, g = 0; g < c.length; g++)
      p = c[g], p.nalUnitType === "access_unit_delimiter_rbsp" ? (m.length && (m.duration = p.dts - m.dts, T.byteLength += m.byteLength, T.nalCount += m.length, T.duration += m.duration, T.push(m)), m = [p], m.byteLength = p.data.byteLength, m.pts = p.pts, m.dts = p.dts) : (p.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (m.keyFrame = !0), m.duration = p.dts - m.dts, m.byteLength += p.data.byteLength, m.push(p));
    return T.length && (!m.duration || m.duration <= 0) && (m.duration = T[T.length - 1].duration), T.byteLength += m.byteLength, T.nalCount += m.length, T.duration += m.duration, T.push(m), T;
  }, xe = function(c) {
    var g, p, m = [], T = [];
    for (m.byteLength = 0, m.nalCount = 0, m.duration = 0, m.pts = c[0].pts, m.dts = c[0].dts, T.byteLength = 0, T.nalCount = 0, T.duration = 0, T.pts = c[0].pts, T.dts = c[0].dts, g = 0; g < c.length; g++)
      p = c[g], p.keyFrame ? (m.length && (T.push(m), T.byteLength += m.byteLength, T.nalCount += m.nalCount, T.duration += m.duration), m = [p], m.nalCount = p.length, m.byteLength = p.byteLength, m.pts = p.pts, m.dts = p.dts, m.duration = p.duration) : (m.duration += p.duration, m.nalCount += p.length, m.byteLength += p.byteLength, m.push(p));
    return T.length && m.duration <= 0 && (m.duration = T[T.length - 1].duration), T.byteLength += m.byteLength, T.nalCount += m.nalCount, T.duration += m.duration, T.push(m), T;
  }, Ue = function(c) {
    var g;
    return !c[0][0].keyFrame && c.length > 1 && (g = c.shift(), c.byteLength -= g.byteLength, c.nalCount -= g.nalCount, c[0][0].dts = g.dts, c[0][0].pts = g.pts, c[0][0].duration += g.duration), c;
  }, Xe = function() {
    return {
      size: 0,
      flags: {
        isLeading: 0,
        dependsOn: 1,
        isDependedOn: 0,
        hasRedundancy: 0,
        degradationPriority: 0,
        isNonSyncSample: 1
      }
    };
  }, Ke = function(c, g) {
    var p = Xe();
    return p.dataOffset = g, p.compositionTimeOffset = c.pts - c.dts, p.duration = c.duration, p.size = 4 * c.length, p.size += c.byteLength, c.keyFrame && (p.flags.dependsOn = 2, p.flags.isNonSyncSample = 0), p;
  }, ke = function(c, g) {
    var p, m, T, S, L, O = g || 0, V = [];
    for (p = 0; p < c.length; p++)
      for (S = c[p], m = 0; m < S.length; m++)
        L = S[m], T = Ke(L, O), O += T.size, V.push(T);
    return V;
  }, Ce = function(c) {
    var g, p, m, T, S, L, O = 0, V = c.byteLength, B = c.nalCount, H = V + 4 * B, X = new Uint8Array(H), ce = new DataView(X.buffer);
    for (g = 0; g < c.length; g++)
      for (T = c[g], p = 0; p < T.length; p++)
        for (S = T[p], m = 0; m < S.length; m++)
          L = S[m], ce.setUint32(O, L.data.byteLength), O += 4, X.set(L.data, O), O += L.data.byteLength;
    return X;
  }, $e = function(c, g) {
    var p, m = g || 0, T = [];
    return p = Ke(c, m), T.push(p), T;
  }, Nt = function(c) {
    var g, p, m = 0, T = c.byteLength, S = c.length, L = T + 4 * S, O = new Uint8Array(L), V = new DataView(O.buffer);
    for (g = 0; g < c.length; g++)
      p = c[g], V.setUint32(m, p.data.byteLength), m += 4, O.set(p.data, m), m += p.data.byteLength;
    return O;
  }, dt = {
    groupNalsIntoFrames: me,
    groupFramesIntoGops: xe,
    extendFirstKeyFrame: Ue,
    generateSampleTable: ke,
    concatenateNalData: Ce,
    generateSampleTableForFrame: $e,
    concatenateNalDataForFrame: Nt
  }, Ee = [33, 16, 5, 32, 164, 27], Qe = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252], Re = function(c) {
    for (var g = []; c--; )
      g.push(0);
    return g;
  }, Qt = function(c) {
    return Object.keys(c).reduce(function(g, p) {
      return g[p] = new Uint8Array(c[p].reduce(function(m, T) {
        return m.concat(T);
      }, [])), g;
    }, {});
  }, Zr, qa = function() {
    if (!Zr) {
      var c = {
        96e3: [Ee, [227, 64], Re(154), [56]],
        88200: [Ee, [231], Re(170), [56]],
        64e3: [Ee, [248, 192], Re(240), [56]],
        48e3: [Ee, [255, 192], Re(268), [55, 148, 128], Re(54), [112]],
        44100: [Ee, [255, 192], Re(268), [55, 163, 128], Re(84), [112]],
        32e3: [Ee, [255, 192], Re(268), [55, 234], Re(226), [112]],
        24e3: [Ee, [255, 192], Re(268), [55, 255, 128], Re(268), [111, 112], Re(126), [224]],
        16e3: [Ee, [255, 192], Re(268), [55, 255, 128], Re(268), [111, 255], Re(269), [223, 108], Re(195), [1, 192]],
        12e3: [Qe, Re(268), [3, 127, 248], Re(268), [6, 255, 240], Re(268), [13, 255, 224], Re(268), [27, 253, 128], Re(259), [56]],
        11025: [Qe, Re(268), [3, 127, 248], Re(268), [6, 255, 240], Re(268), [13, 255, 224], Re(268), [27, 255, 192], Re(268), [55, 175, 128], Re(108), [112]],
        8e3: [Qe, Re(268), [3, 121, 16], Re(47), [7]]
      };
      Zr = Qt(c);
    }
    return Zr;
  }, Ci = 9e4, $a, Ln, In, F, A, ue, ve;
  $a = function(c) {
    return c * Ci;
  }, Ln = function(c, g) {
    return c * g;
  }, In = function(c) {
    return c / Ci;
  }, F = function(c, g) {
    return c / g;
  }, A = function(c, g) {
    return $a(F(c, g));
  }, ue = function(c, g) {
    return Ln(In(c), g);
  }, ve = function(c, g, p) {
    return In(p ? c : c - g);
  };
  var ie = {
    ONE_SECOND_IN_TS: Ci,
    secondsToVideoTs: $a,
    secondsToAudioTs: Ln,
    videoTsToSeconds: In,
    audioTsToSeconds: F,
    audioTsToVideoTs: A,
    videoTsToAudioTs: ue,
    metadataTsToSeconds: ve
  }, je = function(c) {
    var g, p, m = 0;
    for (g = 0; g < c.length; g++)
      p = c[g], m += p.data.byteLength;
    return m;
  }, Oe = function(c, g, p, m) {
    var T, S = 0, L = 0, O = 0, V = 0, B, H, X;
    if (g.length && (T = ie.audioTsToVideoTs(c.baseMediaDecodeTime, c.samplerate), S = Math.ceil(ie.ONE_SECOND_IN_TS / (c.samplerate / 1024)), p && m && (L = T - Math.max(p, m), O = Math.floor(L / S), V = O * S), !(O < 1 || V > ie.ONE_SECOND_IN_TS / 2))) {
      for (B = qa()[c.samplerate], B || (B = g[0].data), H = 0; H < O; H++)
        X = g[0], g.splice(0, 0, {
          data: B,
          dts: X.dts - S,
          pts: X.pts - S
        });
      return c.baseMediaDecodeTime -= Math.floor(ie.videoTsToAudioTs(V, c.samplerate)), V;
    }
  }, ct = function(c, g, p) {
    return g.minSegmentDts >= p ? c : (g.minSegmentDts = 1 / 0, c.filter(function(m) {
      return m.dts >= p ? (g.minSegmentDts = Math.min(g.minSegmentDts, m.dts), g.minSegmentPts = g.minSegmentDts, !0) : !1;
    }));
  }, Ie = function(c) {
    var g, p, m = [];
    for (g = 0; g < c.length; g++)
      p = c[g], m.push({
        size: p.data.byteLength,
        duration: 1024
        // For AAC audio, all samples contain 1024 samples
      });
    return m;
  }, jt = function(c) {
    var g, p, m = 0, T = new Uint8Array(je(c));
    for (g = 0; g < c.length; g++)
      p = c[g], T.set(p.data, m), m += p.data.byteLength;
    return T;
  }, $t = {
    prefixWithSilence: Oe,
    trimAdtsFramesByEarliestDts: ct,
    generateSampleTable: Ie,
    concatenateFrameData: jt
  }, Pt = ie.ONE_SECOND_IN_TS, ze = function(c, g) {
    typeof g.pts == "number" && (c.timelineStartInfo.pts === void 0 && (c.timelineStartInfo.pts = g.pts), c.minSegmentPts === void 0 ? c.minSegmentPts = g.pts : c.minSegmentPts = Math.min(c.minSegmentPts, g.pts), c.maxSegmentPts === void 0 ? c.maxSegmentPts = g.pts : c.maxSegmentPts = Math.max(c.maxSegmentPts, g.pts)), typeof g.dts == "number" && (c.timelineStartInfo.dts === void 0 && (c.timelineStartInfo.dts = g.dts), c.minSegmentDts === void 0 ? c.minSegmentDts = g.dts : c.minSegmentDts = Math.min(c.minSegmentDts, g.dts), c.maxSegmentDts === void 0 ? c.maxSegmentDts = g.dts : c.maxSegmentDts = Math.max(c.maxSegmentDts, g.dts));
  }, ki = function(c) {
    delete c.minSegmentDts, delete c.maxSegmentDts, delete c.minSegmentPts, delete c.maxSegmentPts;
  }, yt = function(c, g) {
    var p, m, T = c.minSegmentDts;
    return g || (T -= c.timelineStartInfo.dts), p = c.timelineStartInfo.baseMediaDecodeTime, p += T, p = Math.max(0, p), c.type === "audio" && (m = c.samplerate / Pt, p *= m, p = Math.floor(p)), p;
  }, ut = {
    clearDtsInfo: ki,
    calculateTrackBaseMediaDecodeTime: yt,
    collectDtsInfo: ze
  }, Dn = 4, Li = 128, Ur = function(c) {
    for (var g = 0, p = {
      payloadType: -1,
      payloadSize: 0
    }, m = 0, T = 0; g < c.byteLength && c[g] !== Li; ) {
      for (; c[g] === 255; )
        m += 255, g++;
      for (m += c[g++]; c[g] === 255; )
        T += 255, g++;
      if (T += c[g++], !p.payload && m === Dn) {
        var S = String.fromCharCode(c[g + 3], c[g + 4], c[g + 5], c[g + 6]);
        if (S === "GA94") {
          p.payloadType = m, p.payloadSize = T, p.payload = c.subarray(g, g + T);
          break;
        } else
          p.payload = void 0;
      }
      g += T, m = 0, T = 0;
    }
    return p;
  }, Rn = function(c) {
    return c.payload[0] !== 181 || (c.payload[1] << 8 | c.payload[2]) !== 49 || String.fromCharCode(c.payload[3], c.payload[4], c.payload[5], c.payload[6]) !== "GA94" || c.payload[7] !== 3 ? null : c.payload.subarray(8, c.payload.length - 1);
  }, On = function(c, g) {
    var p = [], m, T, S, L;
    if (!(g[0] & 64))
      return p;
    for (T = g[0] & 31, m = 0; m < T; m++)
      S = m * 3, L = {
        type: g[S + 2] & 3,
        pts: c
      }, g[S + 2] & 4 && (L.ccData = g[S + 3] << 8 | g[S + 4], p.push(L));
    return p;
  }, cl = function(c) {
    for (var g = c.byteLength, p = [], m = 1, T, S; m < g - 2; )
      c[m] === 0 && c[m + 1] === 0 && c[m + 2] === 3 ? (p.push(m + 2), m += 2) : m++;
    if (p.length === 0)
      return c;
    T = g - p.length, S = new Uint8Array(T);
    var L = 0;
    for (m = 0; m < T; L++, m++)
      L === p[0] && (L++, p.shift()), S[m] = c[L];
    return S;
  }, Jt = {
    parseSei: Ur,
    parseUserData: Rn,
    parseCaptionPackets: On,
    discardEmulationPreventionBytes: cl,
    USER_DATA_REGISTERED_ITU_T_T35: Dn
  }, Zt = function x(c) {
    c = c || {}, x.prototype.init.call(this), this.parse708captions_ = typeof c.parse708captions == "boolean" ? c.parse708captions : !0, this.captionPackets_ = [], this.ccStreams_ = [
      new ht(0, 0),
      // eslint-disable-line no-use-before-define
      new ht(0, 1),
      // eslint-disable-line no-use-before-define
      new ht(1, 0),
      // eslint-disable-line no-use-before-define
      new ht(1, 1)
      // eslint-disable-line no-use-before-define
    ], this.parse708captions_ && (this.cc708Stream_ = new Je({
      captionServices: c.captionServices
    })), this.reset(), this.ccStreams_.forEach(function(g) {
      g.on("data", this.trigger.bind(this, "data")), g.on("partialdone", this.trigger.bind(this, "partialdone")), g.on("done", this.trigger.bind(this, "done"));
    }, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")));
  };
  Zt.prototype = new e(), Zt.prototype.push = function(x) {
    var c, g, p;
    if (x.nalUnitType === "sei_rbsp" && (c = Jt.parseSei(x.escapedRBSP), !!c.payload && c.payloadType === Jt.USER_DATA_REGISTERED_ITU_T_T35 && (g = Jt.parseUserData(c), !!g))) {
      if (x.dts < this.latestDts_) {
        this.ignoreNextEqualDts_ = !0;
        return;
      } else if (x.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
        this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
        return;
      }
      p = Jt.parseCaptionPackets(x.pts, g), this.captionPackets_ = this.captionPackets_.concat(p), this.latestDts_ !== x.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = x.dts;
    }
  }, Zt.prototype.flushCCStreams = function(x) {
    this.ccStreams_.forEach(function(c) {
      return x === "flush" ? c.flush() : c.partialFlush();
    }, this);
  }, Zt.prototype.flushStream = function(x) {
    if (!this.captionPackets_.length) {
      this.flushCCStreams(x);
      return;
    }
    this.captionPackets_.forEach(function(c, g) {
      c.presortIndex = g;
    }), this.captionPackets_.sort(function(c, g) {
      return c.pts === g.pts ? c.presortIndex - g.presortIndex : c.pts - g.pts;
    }), this.captionPackets_.forEach(function(c) {
      c.type < 2 ? this.dispatchCea608Packet(c) : this.dispatchCea708Packet(c);
    }, this), this.captionPackets_.length = 0, this.flushCCStreams(x);
  }, Zt.prototype.flush = function() {
    return this.flushStream("flush");
  }, Zt.prototype.partialFlush = function() {
    return this.flushStream("partialFlush");
  }, Zt.prototype.reset = function() {
    this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function(x) {
      x.reset();
    });
  }, Zt.prototype.dispatchCea608Packet = function(x) {
    this.setsTextOrXDSActive(x) ? this.activeCea608Channel_[x.type] = null : this.setsChannel1Active(x) ? this.activeCea608Channel_[x.type] = 0 : this.setsChannel2Active(x) && (this.activeCea608Channel_[x.type] = 1), this.activeCea608Channel_[x.type] !== null && this.ccStreams_[(x.type << 1) + this.activeCea608Channel_[x.type]].push(x);
  }, Zt.prototype.setsChannel1Active = function(x) {
    return (x.ccData & 30720) === 4096;
  }, Zt.prototype.setsChannel2Active = function(x) {
    return (x.ccData & 30720) === 6144;
  }, Zt.prototype.setsTextOrXDSActive = function(x) {
    return (x.ccData & 28928) === 256 || (x.ccData & 30974) === 4138 || (x.ccData & 30974) === 6186;
  }, Zt.prototype.dispatchCea708Packet = function(x) {
    this.parse708captions_ && this.cc708Stream_.push(x);
  };
  var to = {
    127: 9834,
    // ♪
    4128: 32,
    // Transparent Space
    4129: 160,
    // Nob-breaking Transparent Space
    4133: 8230,
    // …
    4138: 352,
    // Š
    4140: 338,
    // Œ
    4144: 9608,
    // █
    4145: 8216,
    // ‘
    4146: 8217,
    // ’
    4147: 8220,
    // “
    4148: 8221,
    // ”
    4149: 8226,
    // •
    4153: 8482,
    // ™
    4154: 353,
    // š
    4156: 339,
    // œ
    4157: 8480,
    // ℠
    4159: 376,
    // Ÿ
    4214: 8539,
    // ⅛
    4215: 8540,
    // ⅜
    4216: 8541,
    // ⅝
    4217: 8542,
    // ⅞
    4218: 9168,
    // ⏐
    4219: 9124,
    // ⎤
    4220: 9123,
    // ⎣
    4221: 9135,
    // ⎯
    4222: 9126,
    // ⎦
    4223: 9121,
    // ⎡
    4256: 12600
    // ㄸ (CC char)
  }, hl = function(c) {
    var g = to[c] || c;
    return c & 4096 && c === g ? "" : String.fromCharCode(g);
  }, Mn = function(c) {
    return 32 <= c && c <= 127 || 160 <= c && c <= 255;
  }, Ii = function(c) {
    this.windowNum = c, this.reset();
  };
  Ii.prototype.reset = function() {
    this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0;
  }, Ii.prototype.getText = function() {
    return this.rows.join(`
`);
  }, Ii.prototype.clearText = function() {
    this.rows = [""], this.rowIdx = 0;
  }, Ii.prototype.newLine = function(x) {
    for (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow == "function" && this.beforeRowOverflow(x), this.rows.length > 0 && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount; )
      this.rows.shift(), this.rowIdx--;
  }, Ii.prototype.isEmpty = function() {
    return this.rows.length === 0 ? !0 : this.rows.length === 1 ? this.rows[0] === "" : !1;
  }, Ii.prototype.addText = function(x) {
    this.rows[this.rowIdx] += x;
  }, Ii.prototype.backspace = function() {
    if (!this.isEmpty()) {
      var x = this.rows[this.rowIdx];
      this.rows[this.rowIdx] = x.substr(0, x.length - 1);
    }
  };
  var en = function(c, g, p) {
    this.serviceNum = c, this.text = "", this.currentWindow = new Ii(-1), this.windows = [], this.stream = p, typeof g == "string" && this.createTextDecoder(g);
  };
  en.prototype.init = function(x, c) {
    this.startPts = x;
    for (var g = 0; g < 8; g++)
      this.windows[g] = new Ii(g), typeof c == "function" && (this.windows[g].beforeRowOverflow = c);
  }, en.prototype.setCurrentWindow = function(x) {
    this.currentWindow = this.windows[x];
  }, en.prototype.createTextDecoder = function(x) {
    if (typeof TextDecoder > "u")
      this.stream.trigger("log", {
        level: "warn",
        message: "The `encoding` option is unsupported without TextDecoder support"
      });
    else
      try {
        this.textDecoder_ = new TextDecoder(x);
      } catch (c) {
        this.stream.trigger("log", {
          level: "warn",
          message: "TextDecoder could not be created with " + x + " encoding. " + c
        });
      }
  };
  var Je = function x(c) {
    c = c || {}, x.prototype.init.call(this);
    var g = this, p = c.captionServices || {}, m = {}, T;
    Object.keys(p).forEach(function(S) {
      T = p[S], /^SERVICE/.test(S) && (m[S] = T.encoding);
    }), this.serviceEncodings = m, this.current708Packet = null, this.services = {}, this.push = function(S) {
      S.type === 3 ? (g.new708Packet(), g.add708Bytes(S)) : (g.current708Packet === null && g.new708Packet(), g.add708Bytes(S));
    };
  };
  Je.prototype = new e(), Je.prototype.new708Packet = function() {
    this.current708Packet !== null && this.push708Packet(), this.current708Packet = {
      data: [],
      ptsVals: []
    };
  }, Je.prototype.add708Bytes = function(x) {
    var c = x.ccData, g = c >>> 8, p = c & 255;
    this.current708Packet.ptsVals.push(x.pts), this.current708Packet.data.push(g), this.current708Packet.data.push(p);
  }, Je.prototype.push708Packet = function() {
    var x = this.current708Packet, c = x.data, g = null, p = null, m = 0, T = c[m++];
    for (x.seq = T >> 6, x.sizeCode = T & 63; m < c.length; m++)
      T = c[m++], g = T >> 5, p = T & 31, g === 7 && p > 0 && (T = c[m++], g = T), this.pushServiceBlock(g, m, p), p > 0 && (m += p - 1);
  }, Je.prototype.pushServiceBlock = function(x, c, g) {
    var p, m = c, T = this.current708Packet.data, S = this.services[x];
    for (S || (S = this.initService(x, m)); m < c + g && m < T.length; m++)
      p = T[m], Mn(p) ? m = this.handleText(m, S) : p === 24 ? m = this.multiByteCharacter(m, S) : p === 16 ? m = this.extendedCommands(m, S) : 128 <= p && p <= 135 ? m = this.setCurrentWindow(m, S) : 152 <= p && p <= 159 ? m = this.defineWindow(m, S) : p === 136 ? m = this.clearWindows(m, S) : p === 140 ? m = this.deleteWindows(m, S) : p === 137 ? m = this.displayWindows(m, S) : p === 138 ? m = this.hideWindows(m, S) : p === 139 ? m = this.toggleWindows(m, S) : p === 151 ? m = this.setWindowAttributes(m, S) : p === 144 ? m = this.setPenAttributes(m, S) : p === 145 ? m = this.setPenColor(m, S) : p === 146 ? m = this.setPenLocation(m, S) : p === 143 ? S = this.reset(m, S) : p === 8 ? S.currentWindow.backspace() : p === 12 ? S.currentWindow.clearText() : p === 13 ? S.currentWindow.pendingNewLine = !0 : p === 14 ? S.currentWindow.clearText() : p === 141 && m++;
  }, Je.prototype.extendedCommands = function(x, c) {
    var g = this.current708Packet.data, p = g[++x];
    return Mn(p) && (x = this.handleText(x, c, {
      isExtended: !0
    })), x;
  }, Je.prototype.getPts = function(x) {
    return this.current708Packet.ptsVals[Math.floor(x / 2)];
  }, Je.prototype.initService = function(x, c) {
    var p = "SERVICE" + x, g = this, p, m;
    return p in this.serviceEncodings && (m = this.serviceEncodings[p]), this.services[x] = new en(x, m, g), this.services[x].init(this.getPts(c), function(T) {
      g.flushDisplayed(T, g.services[x]);
    }), this.services[x];
  }, Je.prototype.handleText = function(x, c, g) {
    var p = g && g.isExtended, m = g && g.isMultiByte, T = this.current708Packet.data, S = p ? 4096 : 0, L = T[x], O = T[x + 1], V = c.currentWindow, B, H;
    return c.textDecoder_ && !p ? (m ? (H = [L, O], x++) : H = [L], B = c.textDecoder_.decode(new Uint8Array(H))) : B = hl(S | L), V.pendingNewLine && !V.isEmpty() && V.newLine(this.getPts(x)), V.pendingNewLine = !1, V.addText(B), x;
  }, Je.prototype.multiByteCharacter = function(x, c) {
    var g = this.current708Packet.data, p = g[x + 1], m = g[x + 2];
    return Mn(p) && Mn(m) && (x = this.handleText(++x, c, {
      isMultiByte: !0
    })), x;
  }, Je.prototype.setCurrentWindow = function(x, c) {
    var g = this.current708Packet.data, p = g[x], m = p & 7;
    return c.setCurrentWindow(m), x;
  }, Je.prototype.defineWindow = function(x, c) {
    var g = this.current708Packet.data, p = g[x], m = p & 7;
    c.setCurrentWindow(m);
    var T = c.currentWindow;
    return p = g[++x], T.visible = (p & 32) >> 5, T.rowLock = (p & 16) >> 4, T.columnLock = (p & 8) >> 3, T.priority = p & 7, p = g[++x], T.relativePositioning = (p & 128) >> 7, T.anchorVertical = p & 127, p = g[++x], T.anchorHorizontal = p, p = g[++x], T.anchorPoint = (p & 240) >> 4, T.rowCount = p & 15, p = g[++x], T.columnCount = p & 63, p = g[++x], T.windowStyle = (p & 56) >> 3, T.penStyle = p & 7, T.virtualRowCount = T.rowCount + 1, x;
  }, Je.prototype.setWindowAttributes = function(x, c) {
    var g = this.current708Packet.data, p = g[x], m = c.currentWindow.winAttr;
    return p = g[++x], m.fillOpacity = (p & 192) >> 6, m.fillRed = (p & 48) >> 4, m.fillGreen = (p & 12) >> 2, m.fillBlue = p & 3, p = g[++x], m.borderType = (p & 192) >> 6, m.borderRed = (p & 48) >> 4, m.borderGreen = (p & 12) >> 2, m.borderBlue = p & 3, p = g[++x], m.borderType += (p & 128) >> 5, m.wordWrap = (p & 64) >> 6, m.printDirection = (p & 48) >> 4, m.scrollDirection = (p & 12) >> 2, m.justify = p & 3, p = g[++x], m.effectSpeed = (p & 240) >> 4, m.effectDirection = (p & 12) >> 2, m.displayEffect = p & 3, x;
  }, Je.prototype.flushDisplayed = function(x, c) {
    for (var g = [], p = 0; p < 8; p++)
      c.windows[p].visible && !c.windows[p].isEmpty() && g.push(c.windows[p].getText());
    c.endPts = x, c.text = g.join(`

`), this.pushCaption(c), c.startPts = x;
  }, Je.prototype.pushCaption = function(x) {
    x.text !== "" && (this.trigger("data", {
      startPts: x.startPts,
      endPts: x.endPts,
      text: x.text,
      stream: "cc708_" + x.serviceNum
    }), x.text = "", x.startPts = x.endPts);
  }, Je.prototype.displayWindows = function(x, c) {
    var g = this.current708Packet.data, p = g[++x], m = this.getPts(x);
    this.flushDisplayed(m, c);
    for (var T = 0; T < 8; T++)
      p & 1 << T && (c.windows[T].visible = 1);
    return x;
  }, Je.prototype.hideWindows = function(x, c) {
    var g = this.current708Packet.data, p = g[++x], m = this.getPts(x);
    this.flushDisplayed(m, c);
    for (var T = 0; T < 8; T++)
      p & 1 << T && (c.windows[T].visible = 0);
    return x;
  }, Je.prototype.toggleWindows = function(x, c) {
    var g = this.current708Packet.data, p = g[++x], m = this.getPts(x);
    this.flushDisplayed(m, c);
    for (var T = 0; T < 8; T++)
      p & 1 << T && (c.windows[T].visible ^= 1);
    return x;
  }, Je.prototype.clearWindows = function(x, c) {
    var g = this.current708Packet.data, p = g[++x], m = this.getPts(x);
    this.flushDisplayed(m, c);
    for (var T = 0; T < 8; T++)
      p & 1 << T && c.windows[T].clearText();
    return x;
  }, Je.prototype.deleteWindows = function(x, c) {
    var g = this.current708Packet.data, p = g[++x], m = this.getPts(x);
    this.flushDisplayed(m, c);
    for (var T = 0; T < 8; T++)
      p & 1 << T && c.windows[T].reset();
    return x;
  }, Je.prototype.setPenAttributes = function(x, c) {
    var g = this.current708Packet.data, p = g[x], m = c.currentWindow.penAttr;
    return p = g[++x], m.textTag = (p & 240) >> 4, m.offset = (p & 12) >> 2, m.penSize = p & 3, p = g[++x], m.italics = (p & 128) >> 7, m.underline = (p & 64) >> 6, m.edgeType = (p & 56) >> 3, m.fontStyle = p & 7, x;
  }, Je.prototype.setPenColor = function(x, c) {
    var g = this.current708Packet.data, p = g[x], m = c.currentWindow.penColor;
    return p = g[++x], m.fgOpacity = (p & 192) >> 6, m.fgRed = (p & 48) >> 4, m.fgGreen = (p & 12) >> 2, m.fgBlue = p & 3, p = g[++x], m.bgOpacity = (p & 192) >> 6, m.bgRed = (p & 48) >> 4, m.bgGreen = (p & 12) >> 2, m.bgBlue = p & 3, p = g[++x], m.edgeRed = (p & 48) >> 4, m.edgeGreen = (p & 12) >> 2, m.edgeBlue = p & 3, x;
  }, Je.prototype.setPenLocation = function(x, c) {
    var g = this.current708Packet.data, p = g[x], m = c.currentWindow.penLoc;
    return c.currentWindow.pendingNewLine = !0, p = g[++x], m.row = p & 15, p = g[++x], m.column = p & 63, x;
  }, Je.prototype.reset = function(x, c) {
    var g = this.getPts(x);
    return this.flushDisplayed(g, c), this.initService(c.serviceNum, x);
  };
  var fl = {
    42: 225,
    // á
    92: 233,
    // é
    94: 237,
    // í
    95: 243,
    // ó
    96: 250,
    // ú
    123: 231,
    // ç
    124: 247,
    // ÷
    125: 209,
    // Ñ
    126: 241,
    // ñ
    127: 9608,
    // █
    304: 174,
    // ®
    305: 176,
    // °
    306: 189,
    // ½
    307: 191,
    // ¿
    308: 8482,
    // ™
    309: 162,
    // ¢
    310: 163,
    // £
    311: 9834,
    // ♪
    312: 224,
    // à
    313: 160,
    //
    314: 232,
    // è
    315: 226,
    // â
    316: 234,
    // ê
    317: 238,
    // î
    318: 244,
    // ô
    319: 251,
    // û
    544: 193,
    // Á
    545: 201,
    // É
    546: 211,
    // Ó
    547: 218,
    // Ú
    548: 220,
    // Ü
    549: 252,
    // ü
    550: 8216,
    // ‘
    551: 161,
    // ¡
    552: 42,
    // *
    553: 39,
    // '
    554: 8212,
    // —
    555: 169,
    // ©
    556: 8480,
    // ℠
    557: 8226,
    // •
    558: 8220,
    // “
    559: 8221,
    // ”
    560: 192,
    // À
    561: 194,
    // Â
    562: 199,
    // Ç
    563: 200,
    // È
    564: 202,
    // Ê
    565: 203,
    // Ë
    566: 235,
    // ë
    567: 206,
    // Î
    568: 207,
    // Ï
    569: 239,
    // ï
    570: 212,
    // Ô
    571: 217,
    // Ù
    572: 249,
    // ù
    573: 219,
    // Û
    574: 171,
    // «
    575: 187,
    // »
    800: 195,
    // Ã
    801: 227,
    // ã
    802: 205,
    // Í
    803: 204,
    // Ì
    804: 236,
    // ì
    805: 210,
    // Ò
    806: 242,
    // ò
    807: 213,
    // Õ
    808: 245,
    // õ
    809: 123,
    // {
    810: 125,
    // }
    811: 92,
    // \
    812: 94,
    // ^
    813: 95,
    // _
    814: 124,
    // |
    815: 126,
    // ~
    816: 196,
    // Ä
    817: 228,
    // ä
    818: 214,
    // Ö
    819: 246,
    // ö
    820: 223,
    // ß
    821: 165,
    // ¥
    822: 164,
    // ¤
    823: 9474,
    // │
    824: 197,
    // Å
    825: 229,
    // å
    826: 216,
    // Ø
    827: 248,
    // ø
    828: 9484,
    // ┌
    829: 9488,
    // ┐
    830: 9492,
    // └
    831: 9496
    // ┘
  }, Nn = function(c) {
    return c === null ? "" : (c = fl[c] || c, String.fromCharCode(c));
  }, Vr = 14, io = [4352, 4384, 4608, 4640, 5376, 5408, 5632, 5664, 5888, 5920, 4096, 4864, 4896, 5120, 5152], fr = function() {
    for (var c = [], g = Vr + 1; g--; )
      c.push("");
    return c;
  }, ht = function x(c, g) {
    x.prototype.init.call(this), this.field_ = c || 0, this.dataChannel_ = g || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(p) {
      var m, T, S, L, O;
      if (m = p.ccData & 32639, m === this.lastControlCode_) {
        this.lastControlCode_ = null;
        return;
      }
      if ((m & 61440) === 4096 ? this.lastControlCode_ = m : m !== this.PADDING_ && (this.lastControlCode_ = null), S = m >>> 8, L = m & 255, m !== this.PADDING_)
        if (m === this.RESUME_CAPTION_LOADING_)
          this.mode_ = "popOn";
        else if (m === this.END_OF_CAPTION_)
          this.mode_ = "popOn", this.clearFormatting(p.pts), this.flushDisplayed(p.pts), T = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = T, this.startPts_ = p.pts;
        else if (m === this.ROLL_UP_2_ROWS_)
          this.rollUpRows_ = 2, this.setRollUp(p.pts);
        else if (m === this.ROLL_UP_3_ROWS_)
          this.rollUpRows_ = 3, this.setRollUp(p.pts);
        else if (m === this.ROLL_UP_4_ROWS_)
          this.rollUpRows_ = 4, this.setRollUp(p.pts);
        else if (m === this.CARRIAGE_RETURN_)
          this.clearFormatting(p.pts), this.flushDisplayed(p.pts), this.shiftRowsUp_(), this.startPts_ = p.pts;
        else if (m === this.BACKSPACE_)
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
        else if (m === this.ERASE_DISPLAYED_MEMORY_)
          this.flushDisplayed(p.pts), this.displayed_ = fr();
        else if (m === this.ERASE_NON_DISPLAYED_MEMORY_)
          this.nonDisplayed_ = fr();
        else if (m === this.RESUME_DIRECT_CAPTIONING_)
          this.mode_ !== "paintOn" && (this.flushDisplayed(p.pts), this.displayed_ = fr()), this.mode_ = "paintOn", this.startPts_ = p.pts;
        else if (this.isSpecialCharacter(S, L))
          S = (S & 3) << 8, O = Nn(S | L), this[this.mode_](p.pts, O), this.column_++;
        else if (this.isExtCharacter(S, L))
          this.mode_ === "popOn" ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1), S = (S & 3) << 8, O = Nn(S | L), this[this.mode_](p.pts, O), this.column_++;
        else if (this.isMidRowCode(S, L))
          this.clearFormatting(p.pts), this[this.mode_](p.pts, " "), this.column_++, (L & 14) === 14 && this.addFormatting(p.pts, ["i"]), (L & 1) === 1 && this.addFormatting(p.pts, ["u"]);
        else if (this.isOffsetControlCode(S, L))
          this.column_ += L & 3;
        else if (this.isPAC(S, L)) {
          var V = io.indexOf(m & 7968);
          this.mode_ === "rollUp" && (V - this.rollUpRows_ + 1 < 0 && (V = this.rollUpRows_ - 1), this.setRollUp(p.pts, V)), V !== this.row_ && (this.clearFormatting(p.pts), this.row_ = V), L & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(p.pts, ["u"]), (m & 16) === 16 && (this.column_ = ((m & 14) >> 1) * 4), this.isColorPAC(L) && (L & 14) === 14 && this.addFormatting(p.pts, ["i"]);
        } else
          this.isNormalChar(S) && (L === 0 && (L = null), O = Nn(S), O += Nn(L), this[this.mode_](p.pts, O), this.column_ += O.length);
    };
  };
  ht.prototype = new e(), ht.prototype.flushDisplayed = function(x) {
    var c = this.displayed_.map(function(g, p) {
      try {
        return g.trim();
      } catch {
        return this.trigger("log", {
          level: "warn",
          message: "Skipping a malformed 608 caption at index " + p + "."
        }), "";
      }
    }, this).join(`
`).replace(/^\n+|\n+$/g, "");
    c.length && this.trigger("data", {
      startPts: this.startPts_,
      endPts: x,
      text: c,
      stream: this.name_
    });
  }, ht.prototype.reset = function() {
    this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = fr(), this.nonDisplayed_ = fr(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = Vr, this.rollUpRows_ = 2, this.formatting_ = [];
  }, ht.prototype.setConstants = function() {
    this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
  }, ht.prototype.isSpecialCharacter = function(x, c) {
    return x === this.EXT_ && c >= 48 && c <= 63;
  }, ht.prototype.isExtCharacter = function(x, c) {
    return (x === this.EXT_ + 1 || x === this.EXT_ + 2) && c >= 32 && c <= 63;
  }, ht.prototype.isMidRowCode = function(x, c) {
    return x === this.EXT_ && c >= 32 && c <= 47;
  }, ht.prototype.isOffsetControlCode = function(x, c) {
    return x === this.OFFSET_ && c >= 33 && c <= 35;
  }, ht.prototype.isPAC = function(x, c) {
    return x >= this.BASE_ && x < this.BASE_ + 8 && c >= 64 && c <= 127;
  }, ht.prototype.isColorPAC = function(x) {
    return x >= 64 && x <= 79 || x >= 96 && x <= 127;
  }, ht.prototype.isNormalChar = function(x) {
    return x >= 32 && x <= 127;
  }, ht.prototype.setRollUp = function(x, c) {
    if (this.mode_ !== "rollUp" && (this.row_ = Vr, this.mode_ = "rollUp", this.flushDisplayed(x), this.nonDisplayed_ = fr(), this.displayed_ = fr()), c !== void 0 && c !== this.row_)
      for (var g = 0; g < this.rollUpRows_; g++)
        this.displayed_[c - g] = this.displayed_[this.row_ - g], this.displayed_[this.row_ - g] = "";
    c === void 0 && (c = this.row_), this.topRow_ = c - this.rollUpRows_ + 1;
  }, ht.prototype.addFormatting = function(x, c) {
    this.formatting_ = this.formatting_.concat(c);
    var g = c.reduce(function(p, m) {
      return p + "<" + m + ">";
    }, "");
    this[this.mode_](x, g);
  }, ht.prototype.clearFormatting = function(x) {
    if (this.formatting_.length) {
      var c = this.formatting_.reverse().reduce(function(g, p) {
        return g + "</" + p + ">";
      }, "");
      this.formatting_ = [], this[this.mode_](x, c);
    }
  }, ht.prototype.popOn = function(x, c) {
    var g = this.nonDisplayed_[this.row_];
    g += c, this.nonDisplayed_[this.row_] = g;
  }, ht.prototype.rollUp = function(x, c) {
    var g = this.displayed_[this.row_];
    g += c, this.displayed_[this.row_] = g;
  }, ht.prototype.shiftRowsUp_ = function() {
    var x;
    for (x = 0; x < this.topRow_; x++)
      this.displayed_[x] = "";
    for (x = this.row_ + 1; x < Vr + 1; x++)
      this.displayed_[x] = "";
    for (x = this.topRow_; x < this.row_; x++)
      this.displayed_[x] = this.displayed_[x + 1];
    this.displayed_[this.row_] = "";
  }, ht.prototype.paintOn = function(x, c) {
    var g = this.displayed_[this.row_];
    g += c, this.displayed_[this.row_] = g;
  };
  var tn = {
    CaptionStream: Zt,
    Cea608Stream: ht,
    Cea708Stream: Je
  }, Ot = {
    H264_STREAM_TYPE: 27,
    ADTS_STREAM_TYPE: 15,
    METADATA_STREAM_TYPE: 21
  }, pl = 8589934592, za = 4294967296, Bn = "shared", Fn = function(c, g) {
    var p = 1;
    for (c > g && (p = -1); Math.abs(g - c) > za; )
      c += p * pl;
    return c;
  }, $i = function x(c) {
    var g, p;
    x.prototype.init.call(this), this.type_ = c || Bn, this.push = function(m) {
      this.type_ !== Bn && m.type !== this.type_ || (p === void 0 && (p = m.dts), m.dts = Fn(m.dts, p), m.pts = Fn(m.pts, p), g = m.dts, this.trigger("data", m));
    }, this.flush = function() {
      p = g, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.discontinuity = function() {
      p = void 0, g = void 0;
    }, this.reset = function() {
      this.discontinuity(), this.trigger("reset");
    };
  };
  $i.prototype = new e();
  var ro = {
    TimestampRolloverStream: $i,
    handleRollover: Fn
  }, Ga = function(c, g, p) {
    var m, T = "";
    for (m = g; m < p; m++)
      T += "%" + ("00" + c[m].toString(16)).slice(-2);
    return T;
  }, Un = function(c, g, p) {
    return decodeURIComponent(Ga(c, g, p));
  }, gl = function(c, g, p) {
    return unescape(Ga(c, g, p));
  }, Vn = function(c) {
    return c[0] << 21 | c[1] << 14 | c[2] << 7 | c[3];
  }, jn = {
    TXXX: function(c) {
      var g;
      if (c.data[0] === 3) {
        for (g = 1; g < c.data.length; g++)
          if (c.data[g] === 0) {
            c.description = Un(c.data, 1, g), c.value = Un(c.data, g + 1, c.data.length).replace(/\0*$/, "");
            break;
          }
        c.data = c.value;
      }
    },
    WXXX: function(c) {
      var g;
      if (c.data[0] === 3) {
        for (g = 1; g < c.data.length; g++)
          if (c.data[g] === 0) {
            c.description = Un(c.data, 1, g), c.url = Un(c.data, g + 1, c.data.length);
            break;
          }
      }
    },
    PRIV: function(c) {
      var g;
      for (g = 0; g < c.data.length; g++)
        if (c.data[g] === 0) {
          c.owner = gl(c.data, 0, g);
          break;
        }
      c.privateData = c.data.subarray(g + 1), c.data = c.privateData;
    }
  }, jr;
  jr = function(c) {
    var g = {
      // the bytes of the program-level descriptor field in MP2T
      // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
      // program element descriptors"
      descriptor: c && c.descriptor
    }, p = 0, m = [], T = 0, S;
    if (jr.prototype.init.call(this), this.dispatchType = Ot.METADATA_STREAM_TYPE.toString(16), g.descriptor)
      for (S = 0; S < g.descriptor.length; S++)
        this.dispatchType += ("00" + g.descriptor[S].toString(16)).slice(-2);
    this.push = function(L) {
      var O, V, B, H, X, ce;
      if (L.type === "timed-metadata") {
        if (L.dataAlignmentIndicator && (T = 0, m.length = 0), m.length === 0 && (L.data.length < 10 || L.data[0] !== "I".charCodeAt(0) || L.data[1] !== "D".charCodeAt(0) || L.data[2] !== "3".charCodeAt(0))) {
          this.trigger("log", {
            level: "warn",
            message: "Skipping unrecognized metadata packet"
          });
          return;
        }
        if (m.push(L), T += L.data.byteLength, m.length === 1 && (p = Vn(L.data.subarray(6, 10)), p += 10), !(T < p)) {
          for (O = {
            data: new Uint8Array(p),
            frames: [],
            pts: m[0].pts,
            dts: m[0].dts
          }, X = 0; X < p; )
            O.data.set(m[0].data.subarray(0, p - X), X), X += m[0].data.byteLength, T -= m[0].data.byteLength, m.shift();
          V = 10, O.data[5] & 64 && (V += 4, V += Vn(O.data.subarray(10, 14)), p -= Vn(O.data.subarray(16, 20)));
          do {
            if (B = Vn(O.data.subarray(V + 4, V + 8)), B < 1) {
              this.trigger("log", {
                level: "warn",
                message: "Malformed ID3 frame encountered. Skipping metadata parsing."
              });
              return;
            }
            if (ce = String.fromCharCode(O.data[V], O.data[V + 1], O.data[V + 2], O.data[V + 3]), H = {
              id: ce,
              data: O.data.subarray(V + 10, V + B + 10)
            }, H.key = H.id, jn[H.id] && (jn[H.id](H), H.owner === "com.apple.streaming.transportStreamTimestamp")) {
              var ye = H.data, se = (ye[3] & 1) << 30 | ye[4] << 22 | ye[5] << 14 | ye[6] << 6 | ye[7] >>> 2;
              se *= 4, se += ye[7] & 3, H.timeStamp = se, O.pts === void 0 && O.dts === void 0 && (O.pts = H.timeStamp, O.dts = H.timeStamp), this.trigger("timestamp", H);
            }
            O.frames.push(H), V += 10, V += B;
          } while (V < p);
          this.trigger("data", O);
        }
      }
    };
  }, jr.prototype = new e();
  var ml = jr, vl = ro.TimestampRolloverStream, Hn, rn, Hr, Wr = 188, pr = 71;
  Hn = function() {
    var c = new Uint8Array(Wr), g = 0;
    Hn.prototype.init.call(this), this.push = function(p) {
      var m = 0, T = Wr, S;
      for (g ? (S = new Uint8Array(p.byteLength + g), S.set(c.subarray(0, g)), S.set(p, g), g = 0) : S = p; T < S.byteLength; ) {
        if (S[m] === pr && S[T] === pr) {
          this.trigger("data", S.subarray(m, T)), m += Wr, T += Wr;
          continue;
        }
        m++, T++;
      }
      m < S.byteLength && (c.set(S.subarray(m), 0), g = S.byteLength - m);
    }, this.flush = function() {
      g === Wr && c[0] === pr && (this.trigger("data", c), g = 0), this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    }, this.reset = function() {
      g = 0, this.trigger("reset");
    };
  }, Hn.prototype = new e(), rn = function() {
    var c, g, p, m;
    rn.prototype.init.call(this), m = this, this.packetsWaitingForPmt = [], this.programMapTable = void 0, c = function(S, L) {
      var O = 0;
      L.payloadUnitStartIndicator && (O += S[O] + 1), L.type === "pat" ? g(S.subarray(O), L) : p(S.subarray(O), L);
    }, g = function(S, L) {
      L.section_number = S[7], L.last_section_number = S[8], m.pmtPid = (S[10] & 31) << 8 | S[11], L.pmtPid = m.pmtPid;
    }, p = function(S, L) {
      var O, V, B, H;
      if (S[5] & 1) {
        for (m.programMapTable = {
          video: null,
          audio: null,
          "timed-metadata": {}
        }, O = (S[1] & 15) << 8 | S[2], V = 3 + O - 4, B = (S[10] & 15) << 8 | S[11], H = 12 + B; H < V; ) {
          var X = S[H], ce = (S[H + 1] & 31) << 8 | S[H + 2];
          X === Ot.H264_STREAM_TYPE && m.programMapTable.video === null ? m.programMapTable.video = ce : X === Ot.ADTS_STREAM_TYPE && m.programMapTable.audio === null ? m.programMapTable.audio = ce : X === Ot.METADATA_STREAM_TYPE && (m.programMapTable["timed-metadata"][ce] = X), H += ((S[H + 3] & 15) << 8 | S[H + 4]) + 5;
        }
        L.programMapTable = m.programMapTable;
      }
    }, this.push = function(T) {
      var S = {}, L = 4;
      if (S.payloadUnitStartIndicator = !!(T[1] & 64), S.pid = T[1] & 31, S.pid <<= 8, S.pid |= T[2], (T[3] & 48) >>> 4 > 1 && (L += T[L] + 1), S.pid === 0)
        S.type = "pat", c(T.subarray(L), S), this.trigger("data", S);
      else if (S.pid === this.pmtPid)
        for (S.type = "pmt", c(T.subarray(L), S), this.trigger("data", S); this.packetsWaitingForPmt.length; )
          this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
      else
        this.programMapTable === void 0 ? this.packetsWaitingForPmt.push([T, L, S]) : this.processPes_(T, L, S);
    }, this.processPes_ = function(T, S, L) {
      L.pid === this.programMapTable.video ? L.streamType = Ot.H264_STREAM_TYPE : L.pid === this.programMapTable.audio ? L.streamType = Ot.ADTS_STREAM_TYPE : L.streamType = this.programMapTable["timed-metadata"][L.pid], L.type = "pes", L.data = T.subarray(S), this.trigger("data", L);
    };
  }, rn.prototype = new e(), rn.STREAM_TYPES = {
    h264: 27,
    adts: 15
  }, Hr = function() {
    var c = this, g = !1, p = {
      data: [],
      size: 0
    }, m = {
      data: [],
      size: 0
    }, T = {
      data: [],
      size: 0
    }, S, L = function(B, H) {
      var X, ce = B[0] << 16 | B[1] << 8 | B[2];
      H.data = new Uint8Array(), ce === 1 && (H.packetLength = 6 + (B[4] << 8 | B[5]), H.dataAlignmentIndicator = (B[6] & 4) !== 0, X = B[7], X & 192 && (H.pts = (B[9] & 14) << 27 | (B[10] & 255) << 20 | (B[11] & 254) << 12 | (B[12] & 255) << 5 | (B[13] & 254) >>> 3, H.pts *= 4, H.pts += (B[13] & 6) >>> 1, H.dts = H.pts, X & 64 && (H.dts = (B[14] & 14) << 27 | (B[15] & 255) << 20 | (B[16] & 254) << 12 | (B[17] & 255) << 5 | (B[18] & 254) >>> 3, H.dts *= 4, H.dts += (B[18] & 6) >>> 1)), H.data = B.subarray(9 + B[8]));
    }, O = function(B, H, X) {
      var ce = new Uint8Array(B.size), ye = {
        type: H
      }, se = 0, we = 0, Mt = !1, ti;
      if (!(!B.data.length || B.size < 9)) {
        for (ye.trackId = B.data[0].pid, se = 0; se < B.data.length; se++)
          ti = B.data[se], ce.set(ti.data, we), we += ti.data.byteLength;
        L(ce, ye), Mt = H === "video" || ye.packetLength <= B.size, (X || Mt) && (B.size = 0, B.data.length = 0), Mt && c.trigger("data", ye);
      }
    };
    Hr.prototype.init.call(this), this.push = function(V) {
      ({
        pat: function() {
        },
        pes: function() {
          var H, X;
          switch (V.streamType) {
            case Ot.H264_STREAM_TYPE:
              H = p, X = "video";
              break;
            case Ot.ADTS_STREAM_TYPE:
              H = m, X = "audio";
              break;
            case Ot.METADATA_STREAM_TYPE:
              H = T, X = "timed-metadata";
              break;
            default:
              return;
          }
          V.payloadUnitStartIndicator && O(H, X, !0), H.data.push(V), H.size += V.data.byteLength;
        },
        pmt: function() {
          var H = {
            type: "metadata",
            tracks: []
          };
          S = V.programMapTable, S.video !== null && H.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +S.video,
            codec: "avc",
            type: "video"
          }), S.audio !== null && H.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +S.audio,
            codec: "adts",
            type: "audio"
          }), g = !0, c.trigger("data", H);
        }
      })[V.type]();
    }, this.reset = function() {
      p.size = 0, p.data.length = 0, m.size = 0, m.data.length = 0, this.trigger("reset");
    }, this.flushStreams_ = function() {
      O(p, "video"), O(m, "audio"), O(T, "timed-metadata");
    }, this.flush = function() {
      if (!g && S) {
        var V = {
          type: "metadata",
          tracks: []
        };
        S.video !== null && V.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +S.video,
          codec: "avc",
          type: "video"
        }), S.audio !== null && V.tracks.push({
          timelineStartInfo: {
            baseMediaDecodeTime: 0
          },
          id: +S.audio,
          codec: "adts",
          type: "audio"
        }), c.trigger("data", V);
      }
      g = !1, this.flushStreams_(), this.trigger("done");
    };
  }, Hr.prototype = new e();
  var _t = {
    PAT_PID: 0,
    MP2T_PACKET_LENGTH: Wr,
    TransportPacketStream: Hn,
    TransportParseStream: rn,
    ElementaryStream: Hr,
    TimestampRolloverStream: vl,
    CaptionStream: tn.CaptionStream,
    Cea608Stream: tn.Cea608Stream,
    Cea708Stream: tn.Cea708Stream,
    MetadataStream: ml
  };
  for (var qr in Ot)
    Ot.hasOwnProperty(qr) && (_t[qr] = Ot[qr]);
  var _i = _t, no = ie.ONE_SECOND_IN_TS, nn, ao = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  nn = function(c) {
    var g, p = 0;
    nn.prototype.init.call(this), this.skipWarn_ = function(m, T) {
      this.trigger("log", {
        level: "warn",
        message: "adts skiping bytes " + m + " to " + T + " in frame " + p + " outside syncword"
      });
    }, this.push = function(m) {
      var T = 0, S, L, O, V, B;
      if (c || (p = 0), m.type === "audio") {
        g && g.length ? (O = g, g = new Uint8Array(O.byteLength + m.data.byteLength), g.set(O), g.set(m.data, O.byteLength)) : g = m.data;
        for (var H; T + 7 < g.length; ) {
          if (g[T] !== 255 || (g[T + 1] & 246) !== 240) {
            typeof H != "number" && (H = T), T++;
            continue;
          }
          if (typeof H == "number" && (this.skipWarn_(H, T), H = null), L = (~g[T + 1] & 1) * 2, S = (g[T + 3] & 3) << 11 | g[T + 4] << 3 | (g[T + 5] & 224) >> 5, V = ((g[T + 6] & 3) + 1) * 1024, B = V * no / ao[(g[T + 2] & 60) >>> 2], g.byteLength - T < S)
            break;
          this.trigger("data", {
            pts: m.pts + p * B,
            dts: m.dts + p * B,
            sampleCount: V,
            audioobjecttype: (g[T + 2] >>> 6 & 3) + 1,
            channelcount: (g[T + 2] & 1) << 2 | (g[T + 3] & 192) >>> 6,
            samplerate: ao[(g[T + 2] & 60) >>> 2],
            samplingfrequencyindex: (g[T + 2] & 60) >>> 2,
            // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
            samplesize: 16,
            // data is the frame without it's header
            data: g.subarray(T + 7 + L, T + S)
          }), p++, T += S;
        }
        typeof H == "number" && (this.skipWarn_(H, T), H = null), g = g.subarray(T);
      }
    }, this.flush = function() {
      p = 0, this.trigger("done");
    }, this.reset = function() {
      g = void 0, this.trigger("reset");
    }, this.endTimeline = function() {
      g = void 0, this.trigger("endedtimeline");
    };
  }, nn.prototype = new e();
  var Wn = nn, zi;
  zi = function(c) {
    var g = c.byteLength, p = 0, m = 0;
    this.length = function() {
      return 8 * g;
    }, this.bitsAvailable = function() {
      return 8 * g + m;
    }, this.loadWord = function() {
      var T = c.byteLength - g, S = new Uint8Array(4), L = Math.min(4, g);
      if (L === 0)
        throw new Error("no bytes available");
      S.set(c.subarray(T, T + L)), p = new DataView(S.buffer).getUint32(0), m = L * 8, g -= L;
    }, this.skipBits = function(T) {
      var S;
      m > T ? (p <<= T, m -= T) : (T -= m, S = Math.floor(T / 8), T -= S * 8, g -= S, this.loadWord(), p <<= T, m -= T);
    }, this.readBits = function(T) {
      var S = Math.min(m, T), L = p >>> 32 - S;
      return m -= S, m > 0 ? p <<= S : g > 0 && this.loadWord(), S = T - S, S > 0 ? L << S | this.readBits(S) : L;
    }, this.skipLeadingZeros = function() {
      var T;
      for (T = 0; T < m; ++T)
        if (p & 2147483648 >>> T)
          return p <<= T, m -= T, T;
      return this.loadWord(), T + this.skipLeadingZeros();
    }, this.skipUnsignedExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.skipExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    }, this.readUnsignedExpGolomb = function() {
      var T = this.skipLeadingZeros();
      return this.readBits(T + 1) - 1;
    }, this.readExpGolomb = function() {
      var T = this.readUnsignedExpGolomb();
      return 1 & T ? 1 + T >>> 1 : -1 * (T >>> 1);
    }, this.readBoolean = function() {
      return this.readBits(1) === 1;
    }, this.readUnsignedByte = function() {
      return this.readBits(8);
    }, this.loadWord();
  };
  var so = zi, an, Gi, oo;
  Gi = function() {
    var c = 0, g, p;
    Gi.prototype.init.call(this), this.push = function(m) {
      var T;
      p ? (T = new Uint8Array(p.byteLength + m.data.byteLength), T.set(p), T.set(m.data, p.byteLength), p = T) : p = m.data;
      for (var S = p.byteLength; c < S - 3; c++)
        if (p[c + 2] === 1) {
          g = c + 5;
          break;
        }
      for (; g < S; )
        switch (p[g]) {
          case 0:
            if (p[g - 1] !== 0) {
              g += 2;
              break;
            } else if (p[g - 2] !== 0) {
              g++;
              break;
            }
            c + 3 !== g - 2 && this.trigger("data", p.subarray(c + 3, g - 2));
            do
              g++;
            while (p[g] !== 1 && g < S);
            c = g - 2, g += 3;
            break;
          case 1:
            if (p[g - 1] !== 0 || p[g - 2] !== 0) {
              g += 3;
              break;
            }
            this.trigger("data", p.subarray(c + 3, g - 2)), c = g - 2, g += 3;
            break;
          default:
            g += 3;
            break;
        }
      p = p.subarray(c), g -= c, c = 0;
    }, this.reset = function() {
      p = null, c = 0, this.trigger("reset");
    }, this.flush = function() {
      p && p.byteLength > 3 && this.trigger("data", p.subarray(c + 3)), p = null, c = 0, this.trigger("done");
    }, this.endTimeline = function() {
      this.flush(), this.trigger("endedtimeline");
    };
  }, Gi.prototype = new e(), oo = {
    100: !0,
    110: !0,
    122: !0,
    244: !0,
    44: !0,
    83: !0,
    86: !0,
    118: !0,
    128: !0,
    // TODO: the three profiles below don't
    // appear to have sps data in the specificiation anymore?
    138: !0,
    139: !0,
    134: !0
  }, an = function() {
    var c = new Gi(), g, p, m, T, S, L, O;
    an.prototype.init.call(this), g = this, this.push = function(V) {
      V.type === "video" && (p = V.trackId, m = V.pts, T = V.dts, c.push(V));
    }, c.on("data", function(V) {
      var B = {
        trackId: p,
        pts: m,
        dts: T,
        data: V,
        nalUnitTypeCode: V[0] & 31
      };
      switch (B.nalUnitTypeCode) {
        case 5:
          B.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
          break;
        case 6:
          B.nalUnitType = "sei_rbsp", B.escapedRBSP = S(V.subarray(1));
          break;
        case 7:
          B.nalUnitType = "seq_parameter_set_rbsp", B.escapedRBSP = S(V.subarray(1)), B.config = L(B.escapedRBSP);
          break;
        case 8:
          B.nalUnitType = "pic_parameter_set_rbsp";
          break;
        case 9:
          B.nalUnitType = "access_unit_delimiter_rbsp";
          break;
      }
      g.trigger("data", B);
    }), c.on("done", function() {
      g.trigger("done");
    }), c.on("partialdone", function() {
      g.trigger("partialdone");
    }), c.on("reset", function() {
      g.trigger("reset");
    }), c.on("endedtimeline", function() {
      g.trigger("endedtimeline");
    }), this.flush = function() {
      c.flush();
    }, this.partialFlush = function() {
      c.partialFlush();
    }, this.reset = function() {
      c.reset();
    }, this.endTimeline = function() {
      c.endTimeline();
    }, O = function(B, H) {
      var X = 8, ce = 8, ye, se;
      for (ye = 0; ye < B; ye++)
        ce !== 0 && (se = H.readExpGolomb(), ce = (X + se + 256) % 256), X = ce === 0 ? X : ce;
    }, S = function(B) {
      for (var H = B.byteLength, X = [], ce = 1, ye, se; ce < H - 2; )
        B[ce] === 0 && B[ce + 1] === 0 && B[ce + 2] === 3 ? (X.push(ce + 2), ce += 2) : ce++;
      if (X.length === 0)
        return B;
      ye = H - X.length, se = new Uint8Array(ye);
      var we = 0;
      for (ce = 0; ce < ye; we++, ce++)
        we === X[0] && (we++, X.shift()), se[ce] = B[we];
      return se;
    }, L = function(B) {
      var H = 0, X = 0, ce = 0, ye = 0, se, we, Mt, ti, ln, El, qf, $f, zf, xl, Gf, kt = [1, 1], Kf, dn;
      if (se = new so(B), we = se.readUnsignedByte(), ti = se.readUnsignedByte(), Mt = se.readUnsignedByte(), se.skipUnsignedExpGolomb(), oo[we] && (ln = se.readUnsignedExpGolomb(), ln === 3 && se.skipBits(1), se.skipUnsignedExpGolomb(), se.skipUnsignedExpGolomb(), se.skipBits(1), se.readBoolean()))
        for (Gf = ln !== 3 ? 8 : 12, dn = 0; dn < Gf; dn++)
          se.readBoolean() && (dn < 6 ? O(16, se) : O(64, se));
      if (se.skipUnsignedExpGolomb(), El = se.readUnsignedExpGolomb(), El === 0)
        se.readUnsignedExpGolomb();
      else if (El === 1)
        for (se.skipBits(1), se.skipExpGolomb(), se.skipExpGolomb(), qf = se.readUnsignedExpGolomb(), dn = 0; dn < qf; dn++)
          se.skipExpGolomb();
      if (se.skipUnsignedExpGolomb(), se.skipBits(1), $f = se.readUnsignedExpGolomb(), zf = se.readUnsignedExpGolomb(), xl = se.readBits(1), xl === 0 && se.skipBits(1), se.skipBits(1), se.readBoolean() && (H = se.readUnsignedExpGolomb(), X = se.readUnsignedExpGolomb(), ce = se.readUnsignedExpGolomb(), ye = se.readUnsignedExpGolomb()), se.readBoolean() && se.readBoolean()) {
        switch (Kf = se.readUnsignedByte(), Kf) {
          case 1:
            kt = [1, 1];
            break;
          case 2:
            kt = [12, 11];
            break;
          case 3:
            kt = [10, 11];
            break;
          case 4:
            kt = [16, 11];
            break;
          case 5:
            kt = [40, 33];
            break;
          case 6:
            kt = [24, 11];
            break;
          case 7:
            kt = [20, 11];
            break;
          case 8:
            kt = [32, 11];
            break;
          case 9:
            kt = [80, 33];
            break;
          case 10:
            kt = [18, 11];
            break;
          case 11:
            kt = [15, 11];
            break;
          case 12:
            kt = [64, 33];
            break;
          case 13:
            kt = [160, 99];
            break;
          case 14:
            kt = [4, 3];
            break;
          case 15:
            kt = [3, 2];
            break;
          case 16:
            kt = [2, 1];
            break;
          case 255: {
            kt = [se.readUnsignedByte() << 8 | se.readUnsignedByte(), se.readUnsignedByte() << 8 | se.readUnsignedByte()];
            break;
          }
        }
        kt && kt[0] / kt[1];
      }
      return {
        profileIdc: we,
        levelIdc: Mt,
        profileCompatibility: ti,
        width: ($f + 1) * 16 - H * 2 - X * 2,
        height: (2 - xl) * (zf + 1) * 16 - ce * 2 - ye * 2,
        // sar is sample aspect ratio
        sarRatio: kt
      };
    };
  }, an.prototype = new e();
  var yl = {
    H264Stream: an,
    NalByteStream: Gi
  }, uo = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350], lo = function(c, g) {
    var p = c[g + 6] << 21 | c[g + 7] << 14 | c[g + 8] << 7 | c[g + 9], m = c[g + 5], T = (m & 16) >> 4;
    return p = p >= 0 ? p : 0, T ? p + 20 : p + 10;
  }, co = function x(c, g) {
    return c.length - g < 10 || c[g] !== "I".charCodeAt(0) || c[g + 1] !== "D".charCodeAt(0) || c[g + 2] !== "3".charCodeAt(0) ? g : (g += lo(c, g), x(c, g));
  }, _l = function(c) {
    var g = co(c, 0);
    return c.length >= g + 2 && (c[g] & 255) === 255 && (c[g + 1] & 240) === 240 && // verify that the 2 layer bits are 0, aka this
    // is not mp3 data but aac data.
    (c[g + 1] & 22) === 16;
  }, ho = function(c) {
    return c[0] << 21 | c[1] << 14 | c[2] << 7 | c[3];
  }, Tl = function(c, g, p) {
    var m, T = "";
    for (m = g; m < p; m++)
      T += "%" + ("00" + c[m].toString(16)).slice(-2);
    return T;
  }, qn = function(c, g, p) {
    return unescape(Tl(c, g, p));
  }, N = function(c, g) {
    var p = (c[g + 5] & 224) >> 5, m = c[g + 4] << 3, T = c[g + 3] & 3 << 11;
    return T | m | p;
  }, q = function(c, g) {
    return c[g] === "I".charCodeAt(0) && c[g + 1] === "D".charCodeAt(0) && c[g + 2] === "3".charCodeAt(0) ? "timed-metadata" : c[g] & !0 && (c[g + 1] & 240) === 240 ? "audio" : null;
  }, K = function(c) {
    for (var g = 0; g + 5 < c.length; ) {
      if (c[g] !== 255 || (c[g + 1] & 246) !== 240) {
        g++;
        continue;
      }
      return uo[(c[g + 2] & 60) >>> 2];
    }
    return null;
  }, Z = function(c) {
    var g, p, m, T;
    g = 10, c[5] & 64 && (g += 4, g += ho(c.subarray(10, 14)));
    do {
      if (p = ho(c.subarray(g + 4, g + 8)), p < 1)
        return null;
      if (T = String.fromCharCode(c[g], c[g + 1], c[g + 2], c[g + 3]), T === "PRIV") {
        m = c.subarray(g + 10, g + p + 10);
        for (var S = 0; S < m.byteLength; S++)
          if (m[S] === 0) {
            var L = qn(m, 0, S);
            if (L === "com.apple.streaming.transportStreamTimestamp") {
              var O = m.subarray(S + 1), V = (O[3] & 1) << 30 | O[4] << 22 | O[5] << 14 | O[6] << 6 | O[7] >>> 2;
              return V *= 4, V += O[7] & 3, V;
            }
            break;
          }
      }
      g += 10, g += p;
    } while (g < c.byteLength);
    return null;
  }, he = {
    isLikelyAacData: _l,
    parseId3TagSize: lo,
    parseAdtsSize: N,
    parseType: q,
    parseSampleRate: K,
    parseAacTimestamp: Z
  }, de;
  de = function() {
    var c = new Uint8Array(), g = 0;
    de.prototype.init.call(this), this.setTimestamp = function(p) {
      g = p;
    }, this.push = function(p) {
      var m = 0, T = 0, S, L, O, V;
      for (c.length ? (V = c.length, c = new Uint8Array(p.byteLength + V), c.set(c.subarray(0, V)), c.set(p, V)) : c = p; c.length - T >= 3; ) {
        if (c[T] === "I".charCodeAt(0) && c[T + 1] === "D".charCodeAt(0) && c[T + 2] === "3".charCodeAt(0)) {
          if (c.length - T < 10 || (m = he.parseId3TagSize(c, T), T + m > c.length))
            break;
          L = {
            type: "timed-metadata",
            data: c.subarray(T, T + m)
          }, this.trigger("data", L), T += m;
          continue;
        } else if ((c[T] & 255) === 255 && (c[T + 1] & 240) === 240) {
          if (c.length - T < 7 || (m = he.parseAdtsSize(c, T), T + m > c.length))
            break;
          O = {
            type: "audio",
            data: c.subarray(T, T + m),
            pts: g,
            dts: g
          }, this.trigger("data", O), T += m;
          continue;
        }
        T++;
      }
      S = c.length - T, S > 0 ? c = c.subarray(T) : c = new Uint8Array();
    }, this.reset = function() {
      c = new Uint8Array(), this.trigger("reset");
    }, this.endTimeline = function() {
      c = new Uint8Array(), this.trigger("endedtimeline");
    };
  }, de.prototype = new e();
  var Pe = de, be = ["audioobjecttype", "channelcount", "samplerate", "samplingfrequencyindex", "samplesize"], Ze = be, et = ["width", "height", "profileIdc", "levelIdc", "profileCompatibility", "sarRatio"], at = et, ft = yl.H264Stream, Ye = he.isLikelyAacData, Et = ie.ONE_SECOND_IN_TS, xt, pt, Ct, Di, Ka = function(c, g) {
    g.stream = c, this.trigger("log", g);
  }, $n = function(c, g) {
    for (var p = Object.keys(g), m = 0; m < p.length; m++) {
      var T = p[m];
      T === "headOfPipeline" || !g[T].on || g[T].on("log", Ka.bind(c, T));
    }
  }, Xa = function(c, g) {
    var p;
    if (c.length !== g.length)
      return !1;
    for (p = 0; p < c.length; p++)
      if (c[p] !== g[p])
        return !1;
    return !0;
  }, sn = function(c, g, p, m, T, S) {
    var L = p - g, O = m - g, V = T - p;
    return {
      start: {
        dts: c,
        pts: c + L
      },
      end: {
        dts: c + O,
        pts: c + V
      },
      prependedContentDuration: S,
      baseMediaDecodeTime: c
    };
  };
  pt = function(c, g) {
    var p = [], m, T = 0, S = 0, L = 1 / 0;
    g = g || {}, m = g.firstSequenceNumber || 0, pt.prototype.init.call(this), this.push = function(O) {
      ut.collectDtsInfo(c, O), c && Ze.forEach(function(V) {
        c[V] = O[V];
      }), p.push(O);
    }, this.setEarliestDts = function(O) {
      T = O;
    }, this.setVideoBaseMediaDecodeTime = function(O) {
      L = O;
    }, this.setAudioAppendStart = function(O) {
      S = O;
    }, this.flush = function() {
      var O, V, B, H, X, ce, ye;
      if (p.length === 0) {
        this.trigger("done", "AudioSegmentStream");
        return;
      }
      O = $t.trimAdtsFramesByEarliestDts(p, c, T), c.baseMediaDecodeTime = ut.calculateTrackBaseMediaDecodeTime(c, g.keepOriginalTimestamps), ye = $t.prefixWithSilence(c, O, S, L), c.samples = $t.generateSampleTable(O), B = fe.mdat($t.concatenateFrameData(O)), p = [], V = fe.moof(m, [c]), H = new Uint8Array(V.byteLength + B.byteLength), m++, H.set(V), H.set(B, V.byteLength), ut.clearDtsInfo(c), X = Math.ceil(Et * 1024 / c.samplerate), O.length && (ce = O.length * X, this.trigger("segmentTimingInfo", sn(
        // The audio track's baseMediaDecodeTime is in audio clock cycles, but the
        // frame info is in video clock cycles. Convert to match expectation of
        // listeners (that all timestamps will be based on video clock cycles).
        ie.audioTsToVideoTs(c.baseMediaDecodeTime, c.samplerate),
        // frame times are already in video clock, as is segment duration
        O[0].dts,
        O[0].pts,
        O[0].dts + ce,
        O[0].pts + ce,
        ye || 0
      )), this.trigger("timingInfo", {
        start: O[0].pts,
        end: O[0].pts + ce
      })), this.trigger("data", {
        track: c,
        boxes: H
      }), this.trigger("done", "AudioSegmentStream");
    }, this.reset = function() {
      ut.clearDtsInfo(c), p = [], this.trigger("reset");
    };
  }, pt.prototype = new e(), xt = function(c, g) {
    var p, m = [], T = [], S, L;
    g = g || {}, p = g.firstSequenceNumber || 0, xt.prototype.init.call(this), delete c.minPTS, this.gopCache_ = [], this.push = function(O) {
      ut.collectDtsInfo(c, O), O.nalUnitType === "seq_parameter_set_rbsp" && !S && (S = O.config, c.sps = [O.data], at.forEach(function(V) {
        c[V] = S[V];
      }, this)), O.nalUnitType === "pic_parameter_set_rbsp" && !L && (L = O.data, c.pps = [O.data]), m.push(O);
    }, this.flush = function() {
      for (var O, V, B, H, X, ce, ye = 0, se, we; m.length && m[0].nalUnitType !== "access_unit_delimiter_rbsp"; )
        m.shift();
      if (m.length === 0) {
        this.resetStream_(), this.trigger("done", "VideoSegmentStream");
        return;
      }
      if (O = dt.groupNalsIntoFrames(m), B = dt.groupFramesIntoGops(O), B[0][0].keyFrame || (V = this.getGopForFusion_(m[0], c), V ? (ye = V.duration, B.unshift(V), B.byteLength += V.byteLength, B.nalCount += V.nalCount, B.pts = V.pts, B.dts = V.dts, B.duration += V.duration) : B = dt.extendFirstKeyFrame(B)), T.length) {
        var Mt;
        if (g.alignGopsAtEnd ? Mt = this.alignGopsAtEnd_(B) : Mt = this.alignGopsAtStart_(B), !Mt) {
          this.gopCache_.unshift({
            gop: B.pop(),
            pps: c.pps,
            sps: c.sps
          }), this.gopCache_.length = Math.min(6, this.gopCache_.length), m = [], this.resetStream_(), this.trigger("done", "VideoSegmentStream");
          return;
        }
        ut.clearDtsInfo(c), B = Mt;
      }
      ut.collectDtsInfo(c, B), c.samples = dt.generateSampleTable(B), X = fe.mdat(dt.concatenateNalData(B)), c.baseMediaDecodeTime = ut.calculateTrackBaseMediaDecodeTime(c, g.keepOriginalTimestamps), this.trigger("processedGopsInfo", B.map(function(ti) {
        return {
          pts: ti.pts,
          dts: ti.dts,
          byteLength: ti.byteLength
        };
      })), se = B[0], we = B[B.length - 1], this.trigger("segmentTimingInfo", sn(c.baseMediaDecodeTime, se.dts, se.pts, we.dts + we.duration, we.pts + we.duration, ye)), this.trigger("timingInfo", {
        start: B[0].pts,
        end: B[B.length - 1].pts + B[B.length - 1].duration
      }), this.gopCache_.unshift({
        gop: B.pop(),
        pps: c.pps,
        sps: c.sps
      }), this.gopCache_.length = Math.min(6, this.gopCache_.length), m = [], this.trigger("baseMediaDecodeTime", c.baseMediaDecodeTime), this.trigger("timelineStartInfo", c.timelineStartInfo), H = fe.moof(p, [c]), ce = new Uint8Array(H.byteLength + X.byteLength), p++, ce.set(H), ce.set(X, H.byteLength), this.trigger("data", {
        track: c,
        boxes: ce
      }), this.resetStream_(), this.trigger("done", "VideoSegmentStream");
    }, this.reset = function() {
      this.resetStream_(), m = [], this.gopCache_.length = 0, T.length = 0, this.trigger("reset");
    }, this.resetStream_ = function() {
      ut.clearDtsInfo(c), S = void 0, L = void 0;
    }, this.getGopForFusion_ = function(O) {
      var V = 45e3, B = 1e4, H = 1 / 0, X, ce, ye, se, we;
      for (we = 0; we < this.gopCache_.length; we++)
        se = this.gopCache_[we], ye = se.gop, !(!(c.pps && Xa(c.pps[0], se.pps[0])) || !(c.sps && Xa(c.sps[0], se.sps[0]))) && (ye.dts < c.timelineStartInfo.dts || (X = O.dts - ye.dts - ye.duration, X >= -B && X <= V && (!ce || H > X) && (ce = se, H = X)));
      return ce ? ce.gop : null;
    }, this.alignGopsAtStart_ = function(O) {
      var V, B, H, X, ce, ye, se, we;
      for (ce = O.byteLength, ye = O.nalCount, se = O.duration, V = B = 0; V < T.length && B < O.length && (H = T[V], X = O[B], H.pts !== X.pts); ) {
        if (X.pts > H.pts) {
          V++;
          continue;
        }
        B++, ce -= X.byteLength, ye -= X.nalCount, se -= X.duration;
      }
      return B === 0 ? O : B === O.length ? null : (we = O.slice(B), we.byteLength = ce, we.duration = se, we.nalCount = ye, we.pts = we[0].pts, we.dts = we[0].dts, we);
    }, this.alignGopsAtEnd_ = function(O) {
      var V, B, H, X, ce, ye;
      for (V = T.length - 1, B = O.length - 1, ce = null, ye = !1; V >= 0 && B >= 0; ) {
        if (H = T[V], X = O[B], H.pts === X.pts) {
          ye = !0;
          break;
        }
        if (H.pts > X.pts) {
          V--;
          continue;
        }
        V === T.length - 1 && (ce = B), B--;
      }
      if (!ye && ce === null)
        return null;
      var se;
      if (ye ? se = B : se = ce, se === 0)
        return O;
      var we = O.slice(se), Mt = we.reduce(function(ti, ln) {
        return ti.byteLength += ln.byteLength, ti.duration += ln.duration, ti.nalCount += ln.nalCount, ti;
      }, {
        byteLength: 0,
        duration: 0,
        nalCount: 0
      });
      return we.byteLength = Mt.byteLength, we.duration = Mt.duration, we.nalCount = Mt.nalCount, we.pts = we[0].pts, we.dts = we[0].dts, we;
    }, this.alignGopsWith = function(O) {
      T = O;
    };
  }, xt.prototype = new e(), Di = function(c, g) {
    this.numberOfTracks = 0, this.metadataStream = g, c = c || {}, typeof c.remux < "u" ? this.remuxTracks = !!c.remux : this.remuxTracks = !0, typeof c.keepOriginalTimestamps == "boolean" ? this.keepOriginalTimestamps = c.keepOriginalTimestamps : this.keepOriginalTimestamps = !1, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, Di.prototype.init.call(this), this.push = function(p) {
      if (p.text)
        return this.pendingCaptions.push(p);
      if (p.frames)
        return this.pendingMetadata.push(p);
      this.pendingTracks.push(p.track), this.pendingBytes += p.boxes.byteLength, p.track.type === "video" && (this.videoTrack = p.track, this.pendingBoxes.push(p.boxes)), p.track.type === "audio" && (this.audioTrack = p.track, this.pendingBoxes.unshift(p.boxes));
    };
  }, Di.prototype = new e(), Di.prototype.flush = function(x) {
    var c = 0, g = {
      captions: [],
      captionStreams: {},
      metadata: [],
      info: {}
    }, p, m, T, S = 0, L;
    if (this.pendingTracks.length < this.numberOfTracks) {
      if (x !== "VideoSegmentStream" && x !== "AudioSegmentStream")
        return;
      if (this.remuxTracks)
        return;
      if (this.pendingTracks.length === 0) {
        this.emittedTracks++, this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
        return;
      }
    }
    if (this.videoTrack ? (S = this.videoTrack.timelineStartInfo.pts, at.forEach(function(O) {
      g.info[O] = this.videoTrack[O];
    }, this)) : this.audioTrack && (S = this.audioTrack.timelineStartInfo.pts, Ze.forEach(function(O) {
      g.info[O] = this.audioTrack[O];
    }, this)), this.videoTrack || this.audioTrack) {
      for (this.pendingTracks.length === 1 ? g.type = this.pendingTracks[0].type : g.type = "combined", this.emittedTracks += this.pendingTracks.length, T = fe.initSegment(this.pendingTracks), g.initSegment = new Uint8Array(T.byteLength), g.initSegment.set(T), g.data = new Uint8Array(this.pendingBytes), L = 0; L < this.pendingBoxes.length; L++)
        g.data.set(this.pendingBoxes[L], c), c += this.pendingBoxes[L].byteLength;
      for (L = 0; L < this.pendingCaptions.length; L++)
        p = this.pendingCaptions[L], p.startTime = ie.metadataTsToSeconds(p.startPts, S, this.keepOriginalTimestamps), p.endTime = ie.metadataTsToSeconds(p.endPts, S, this.keepOriginalTimestamps), g.captionStreams[p.stream] = !0, g.captions.push(p);
      for (L = 0; L < this.pendingMetadata.length; L++)
        m = this.pendingMetadata[L], m.cueTime = ie.metadataTsToSeconds(m.pts, S, this.keepOriginalTimestamps), g.metadata.push(m);
      for (g.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", g), L = 0; L < g.captions.length; L++)
        p = g.captions[L], this.trigger("caption", p);
      for (L = 0; L < g.metadata.length; L++)
        m = g.metadata[L], this.trigger("id3Frame", m);
    }
    this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
  }, Di.prototype.setRemux = function(x) {
    this.remuxTracks = x;
  }, Ct = function(c) {
    var g = this, p = !0, m, T;
    Ct.prototype.init.call(this), c = c || {}, this.baseMediaDecodeTime = c.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function() {
      var S = {};
      this.transmuxPipeline_ = S, S.type = "aac", S.metadataStream = new _i.MetadataStream(), S.aacStream = new Pe(), S.audioTimestampRolloverStream = new _i.TimestampRolloverStream("audio"), S.timedMetadataTimestampRolloverStream = new _i.TimestampRolloverStream("timed-metadata"), S.adtsStream = new Wn(), S.coalesceStream = new Di(c, S.metadataStream), S.headOfPipeline = S.aacStream, S.aacStream.pipe(S.audioTimestampRolloverStream).pipe(S.adtsStream), S.aacStream.pipe(S.timedMetadataTimestampRolloverStream).pipe(S.metadataStream).pipe(S.coalesceStream), S.metadataStream.on("timestamp", function(L) {
        S.aacStream.setTimestamp(L.timeStamp);
      }), S.aacStream.on("data", function(L) {
        L.type !== "timed-metadata" && L.type !== "audio" || S.audioSegmentStream || (T = T || {
          timelineStartInfo: {
            baseMediaDecodeTime: g.baseMediaDecodeTime
          },
          codec: "adts",
          type: "audio"
        }, S.coalesceStream.numberOfTracks++, S.audioSegmentStream = new pt(T, c), S.audioSegmentStream.on("log", g.getLogTrigger_("audioSegmentStream")), S.audioSegmentStream.on("timingInfo", g.trigger.bind(g, "audioTimingInfo")), S.adtsStream.pipe(S.audioSegmentStream).pipe(S.coalesceStream), g.trigger("trackinfo", {
          hasAudio: !!T,
          hasVideo: !!m
        }));
      }), S.coalesceStream.on("data", this.trigger.bind(this, "data")), S.coalesceStream.on("done", this.trigger.bind(this, "done")), $n(this, S);
    }, this.setupTsPipeline = function() {
      var S = {};
      this.transmuxPipeline_ = S, S.type = "ts", S.metadataStream = new _i.MetadataStream(), S.packetStream = new _i.TransportPacketStream(), S.parseStream = new _i.TransportParseStream(), S.elementaryStream = new _i.ElementaryStream(), S.timestampRolloverStream = new _i.TimestampRolloverStream(), S.adtsStream = new Wn(), S.h264Stream = new ft(), S.captionStream = new _i.CaptionStream(c), S.coalesceStream = new Di(c, S.metadataStream), S.headOfPipeline = S.packetStream, S.packetStream.pipe(S.parseStream).pipe(S.elementaryStream).pipe(S.timestampRolloverStream), S.timestampRolloverStream.pipe(S.h264Stream), S.timestampRolloverStream.pipe(S.adtsStream), S.timestampRolloverStream.pipe(S.metadataStream).pipe(S.coalesceStream), S.h264Stream.pipe(S.captionStream).pipe(S.coalesceStream), S.elementaryStream.on("data", function(L) {
        var O;
        if (L.type === "metadata") {
          for (O = L.tracks.length; O--; )
            !m && L.tracks[O].type === "video" ? (m = L.tracks[O], m.timelineStartInfo.baseMediaDecodeTime = g.baseMediaDecodeTime) : !T && L.tracks[O].type === "audio" && (T = L.tracks[O], T.timelineStartInfo.baseMediaDecodeTime = g.baseMediaDecodeTime);
          m && !S.videoSegmentStream && (S.coalesceStream.numberOfTracks++, S.videoSegmentStream = new xt(m, c), S.videoSegmentStream.on("log", g.getLogTrigger_("videoSegmentStream")), S.videoSegmentStream.on("timelineStartInfo", function(V) {
            T && !c.keepOriginalTimestamps && (T.timelineStartInfo = V, S.audioSegmentStream.setEarliestDts(V.dts - g.baseMediaDecodeTime));
          }), S.videoSegmentStream.on("processedGopsInfo", g.trigger.bind(g, "gopInfo")), S.videoSegmentStream.on("segmentTimingInfo", g.trigger.bind(g, "videoSegmentTimingInfo")), S.videoSegmentStream.on("baseMediaDecodeTime", function(V) {
            T && S.audioSegmentStream.setVideoBaseMediaDecodeTime(V);
          }), S.videoSegmentStream.on("timingInfo", g.trigger.bind(g, "videoTimingInfo")), S.h264Stream.pipe(S.videoSegmentStream).pipe(S.coalesceStream)), T && !S.audioSegmentStream && (S.coalesceStream.numberOfTracks++, S.audioSegmentStream = new pt(T, c), S.audioSegmentStream.on("log", g.getLogTrigger_("audioSegmentStream")), S.audioSegmentStream.on("timingInfo", g.trigger.bind(g, "audioTimingInfo")), S.audioSegmentStream.on("segmentTimingInfo", g.trigger.bind(g, "audioSegmentTimingInfo")), S.adtsStream.pipe(S.audioSegmentStream).pipe(S.coalesceStream)), g.trigger("trackinfo", {
            hasAudio: !!T,
            hasVideo: !!m
          });
        }
      }), S.coalesceStream.on("data", this.trigger.bind(this, "data")), S.coalesceStream.on("id3Frame", function(L) {
        L.dispatchType = S.metadataStream.dispatchType, g.trigger("id3Frame", L);
      }), S.coalesceStream.on("caption", this.trigger.bind(this, "caption")), S.coalesceStream.on("done", this.trigger.bind(this, "done")), $n(this, S);
    }, this.setBaseMediaDecodeTime = function(S) {
      var L = this.transmuxPipeline_;
      c.keepOriginalTimestamps || (this.baseMediaDecodeTime = S), T && (T.timelineStartInfo.dts = void 0, T.timelineStartInfo.pts = void 0, ut.clearDtsInfo(T), L.audioTimestampRolloverStream && L.audioTimestampRolloverStream.discontinuity()), m && (L.videoSegmentStream && (L.videoSegmentStream.gopCache_ = []), m.timelineStartInfo.dts = void 0, m.timelineStartInfo.pts = void 0, ut.clearDtsInfo(m), L.captionStream.reset()), L.timestampRolloverStream && L.timestampRolloverStream.discontinuity();
    }, this.setAudioAppendStart = function(S) {
      T && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(S);
    }, this.setRemux = function(S) {
      var L = this.transmuxPipeline_;
      c.remux = S, L && L.coalesceStream && L.coalesceStream.setRemux(S);
    }, this.alignGopsWith = function(S) {
      m && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(S);
    }, this.getLogTrigger_ = function(S) {
      var L = this;
      return function(O) {
        O.stream = S, L.trigger("log", O);
      };
    }, this.push = function(S) {
      if (p) {
        var L = Ye(S);
        L && this.transmuxPipeline_.type !== "aac" ? this.setupAacPipeline() : !L && this.transmuxPipeline_.type !== "ts" && this.setupTsPipeline(), p = !1;
      }
      this.transmuxPipeline_.headOfPipeline.push(S);
    }, this.flush = function() {
      p = !0, this.transmuxPipeline_.headOfPipeline.flush();
    }, this.endTimeline = function() {
      this.transmuxPipeline_.headOfPipeline.endTimeline();
    }, this.reset = function() {
      this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset();
    }, this.resetCaptions = function() {
      this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset();
    };
  }, Ct.prototype = new e();
  var fo = {
    Transmuxer: Ct,
    VideoSegmentStream: xt,
    AudioSegmentStream: pt,
    AUDIO_PROPERTIES: Ze,
    VIDEO_PROPERTIES: at,
    // exported for testing
    generateSegmentTimingInfo: sn
  }, po = function(c) {
    return c >>> 0;
  }, LT = function(c) {
    return ("00" + c.toString(16)).slice(-2);
  }, go = {
    toUnsigned: po,
    toHexString: LT
  }, IT = function(c) {
    var g = "";
    return g += String.fromCharCode(c[0]), g += String.fromCharCode(c[1]), g += String.fromCharCode(c[2]), g += String.fromCharCode(c[3]), g;
  }, on = IT, DT = go.toUnsigned, RT = function x(c, g) {
    var p = [], m, T, S, L, O;
    if (!g.length)
      return null;
    for (m = 0; m < c.byteLength; )
      T = DT(c[m] << 24 | c[m + 1] << 16 | c[m + 2] << 8 | c[m + 3]), S = on(c.subarray(m + 4, m + 8)), L = T > 1 ? m + T : c.byteLength, S === g[0] && (g.length === 1 ? p.push(c.subarray(m + 8, L)) : (O = x(c.subarray(m + 8, L), g.slice(1)), O.length && (p = p.concat(O)))), m = L;
    return p;
  }, gt = RT, OT = go.toUnsigned, MT = i.getUint64, NT = function(c) {
    var g = {
      version: c[0],
      flags: new Uint8Array(c.subarray(1, 4))
    };
    return g.version === 1 ? g.baseMediaDecodeTime = MT(c.subarray(4)) : g.baseMediaDecodeTime = OT(c[4] << 24 | c[5] << 16 | c[6] << 8 | c[7]), g;
  }, Lf = NT, BT = function(c) {
    return {
      isLeading: (c[0] & 12) >>> 2,
      dependsOn: c[0] & 3,
      isDependedOn: (c[1] & 192) >>> 6,
      hasRedundancy: (c[1] & 48) >>> 4,
      paddingValue: (c[1] & 14) >>> 1,
      isNonSyncSample: c[1] & 1,
      degradationPriority: c[2] << 8 | c[3]
    };
  }, If = BT, FT = function(c) {
    var g = {
      version: c[0],
      flags: new Uint8Array(c.subarray(1, 4)),
      samples: []
    }, p = new DataView(c.buffer, c.byteOffset, c.byteLength), m = g.flags[2] & 1, T = g.flags[2] & 4, S = g.flags[1] & 1, L = g.flags[1] & 2, O = g.flags[1] & 4, V = g.flags[1] & 8, B = p.getUint32(4), H = 8, X;
    for (m && (g.dataOffset = p.getInt32(H), H += 4), T && B && (X = {
      flags: If(c.subarray(H, H + 4))
    }, H += 4, S && (X.duration = p.getUint32(H), H += 4), L && (X.size = p.getUint32(H), H += 4), V && (g.version === 1 ? X.compositionTimeOffset = p.getInt32(H) : X.compositionTimeOffset = p.getUint32(H), H += 4), g.samples.push(X), B--); B--; )
      X = {}, S && (X.duration = p.getUint32(H), H += 4), L && (X.size = p.getUint32(H), H += 4), O && (X.flags = If(c.subarray(H, H + 4)), H += 4), V && (g.version === 1 ? X.compositionTimeOffset = p.getInt32(H) : X.compositionTimeOffset = p.getUint32(H), H += 4), g.samples.push(X);
    return g;
  }, Df = FT, UT = function(c) {
    var g = new DataView(c.buffer, c.byteOffset, c.byteLength), p = {
      version: c[0],
      flags: new Uint8Array(c.subarray(1, 4)),
      trackId: g.getUint32(4)
    }, m = p.flags[2] & 1, T = p.flags[2] & 2, S = p.flags[2] & 8, L = p.flags[2] & 16, O = p.flags[2] & 32, V = p.flags[0] & 65536, B = p.flags[0] & 131072, H;
    return H = 8, m && (H += 4, p.baseDataOffset = g.getUint32(12), H += 4), T && (p.sampleDescriptionIndex = g.getUint32(H), H += 4), S && (p.defaultSampleDuration = g.getUint32(H), H += 4), L && (p.defaultSampleSize = g.getUint32(H), H += 4), O && (p.defaultSampleFlags = g.getUint32(H)), V && (p.durationIsEmpty = !0), !m && B && (p.baseDataOffsetIsMoof = !0), p;
  }, Rf = UT, Of = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Ya;
  typeof window < "u" ? Ya = window : typeof Of < "u" ? Ya = Of : typeof self < "u" ? Ya = self : Ya = {};
  var Qa = Ya, VT = Jt.discardEmulationPreventionBytes, jT = tn.CaptionStream, HT = function(c, g) {
    for (var p = c, m = 0; m < g.length; m++) {
      var T = g[m];
      if (p < T.size)
        return T;
      p -= T.size;
    }
    return null;
  }, WT = function(c, g, p) {
    var m = new DataView(c.buffer, c.byteOffset, c.byteLength), T = {
      logs: [],
      seiNals: []
    }, S, L, O, V;
    for (L = 0; L + 4 < c.length; L += O)
      if (O = m.getUint32(L), L += 4, !(O <= 0))
        switch (c[L] & 31) {
          case 6:
            var B = c.subarray(L + 1, L + 1 + O), H = HT(L, g);
            if (S = {
              nalUnitType: "sei_rbsp",
              size: O,
              data: B,
              escapedRBSP: VT(B),
              trackId: p
            }, H)
              S.pts = H.pts, S.dts = H.dts, V = H;
            else if (V)
              S.pts = V.pts, S.dts = V.dts;
            else {
              T.logs.push({
                level: "warn",
                message: "We've encountered a nal unit without data at " + L + " for trackId " + p + ". See mux.js#223."
              });
              break;
            }
            T.seiNals.push(S);
            break;
        }
    return T;
  }, qT = function(c, g, p) {
    var m = g, T = p.defaultSampleDuration || 0, S = p.defaultSampleSize || 0, L = p.trackId, O = [];
    return c.forEach(function(V) {
      var B = Df(V), H = B.samples;
      H.forEach(function(X) {
        X.duration === void 0 && (X.duration = T), X.size === void 0 && (X.size = S), X.trackId = L, X.dts = m, X.compositionTimeOffset === void 0 && (X.compositionTimeOffset = 0), typeof m == "bigint" ? (X.pts = m + Qa.BigInt(X.compositionTimeOffset), m += Qa.BigInt(X.duration)) : (X.pts = m + X.compositionTimeOffset, m += X.duration);
      }), O = O.concat(H);
    }), O;
  }, $T = function(c, g) {
    var p = gt(c, ["moof", "traf"]), m = gt(c, ["mdat"]), T = {}, S = [];
    return m.forEach(function(L, O) {
      var V = p[O];
      S.push({
        mdat: L,
        traf: V
      });
    }), S.forEach(function(L) {
      var O = L.mdat, V = L.traf, B = gt(V, ["tfhd"]), H = Rf(B[0]), X = H.trackId, ce = gt(V, ["tfdt"]), ye = ce.length > 0 ? Lf(ce[0]).baseMediaDecodeTime : 0, se = gt(V, ["trun"]), we, Mt;
      g === X && se.length > 0 && (we = qT(se, ye, H), Mt = WT(O, we, X), T[X] || (T[X] = {
        seiNals: [],
        logs: []
      }), T[X].seiNals = T[X].seiNals.concat(Mt.seiNals), T[X].logs = T[X].logs.concat(Mt.logs));
    }), T;
  }, zT = function(c, g, p) {
    var m;
    if (g === null)
      return null;
    m = $T(c, g);
    var T = m[g] || {};
    return {
      seiNals: T.seiNals,
      logs: T.logs,
      timescale: p
    };
  }, GT = function() {
    var c = !1, g, p, m, T, S, L;
    this.isInitialized = function() {
      return c;
    }, this.init = function(O) {
      g = new jT(), c = !0, L = O ? O.isPartial : !1, g.on("data", function(V) {
        V.startTime = V.startPts / T, V.endTime = V.endPts / T, S.captions.push(V), S.captionStreams[V.stream] = !0;
      }), g.on("log", function(V) {
        S.logs.push(V);
      });
    }, this.isNewInit = function(O, V) {
      return O && O.length === 0 || V && typeof V == "object" && Object.keys(V).length === 0 ? !1 : m !== O[0] || T !== V[m];
    }, this.parse = function(O, V, B) {
      var H;
      if (this.isInitialized()) {
        if (!V || !B)
          return null;
        if (this.isNewInit(V, B))
          m = V[0], T = B[m];
        else if (m === null || !T)
          return p.push(O), null;
      } else
        return null;
      for (; p.length > 0; ) {
        var X = p.shift();
        this.parse(X, V, B);
      }
      return H = zT(O, m, T), H && H.logs && (S.logs = S.logs.concat(H.logs)), H === null || !H.seiNals ? S.logs.length ? {
        logs: S.logs,
        captions: [],
        captionStreams: []
      } : null : (this.pushNals(H.seiNals), this.flushStream(), S);
    }, this.pushNals = function(O) {
      if (!this.isInitialized() || !O || O.length === 0)
        return null;
      O.forEach(function(V) {
        g.push(V);
      });
    }, this.flushStream = function() {
      if (!this.isInitialized())
        return null;
      L ? g.partialFlush() : g.flush();
    }, this.clearParsedCaptions = function() {
      S.captions = [], S.captionStreams = {}, S.logs = [];
    }, this.resetCaptionStream = function() {
      if (!this.isInitialized())
        return null;
      g.reset();
    }, this.clearAllCaptions = function() {
      this.clearParsedCaptions(), this.resetCaptionStream();
    }, this.reset = function() {
      p = [], m = null, T = null, S ? this.clearParsedCaptions() : S = {
        captions: [],
        // CC1, CC2, CC3, CC4
        captionStreams: {},
        logs: []
      }, this.resetCaptionStream();
    }, this.reset();
  }, KT = GT, mo = go.toUnsigned, Ja = go.toHexString, XT = i.getUint64, Mf, Nf, Bf, Ff, Uf, bl;
  Mf = function(c) {
    var g = {}, p = gt(c, ["moov", "trak"]);
    return p.reduce(function(m, T) {
      var S, L, O, V, B;
      return S = gt(T, ["tkhd"])[0], !S || (L = S[0], O = L === 0 ? 12 : 20, V = mo(S[O] << 24 | S[O + 1] << 16 | S[O + 2] << 8 | S[O + 3]), B = gt(T, ["mdia", "mdhd"])[0], !B) ? null : (L = B[0], O = L === 0 ? 12 : 20, m[V] = mo(B[O] << 24 | B[O + 1] << 16 | B[O + 2] << 8 | B[O + 3]), m);
    }, g);
  }, Nf = function(c, g) {
    var p;
    p = gt(g, ["moof", "traf"]);
    var m = p.reduce(function(T, S) {
      var L = gt(S, ["tfhd"])[0], O = mo(L[4] << 24 | L[5] << 16 | L[6] << 8 | L[7]), V = c[O] || 9e4, B = gt(S, ["tfdt"])[0], H = new DataView(B.buffer, B.byteOffset, B.byteLength), X;
      B[0] === 1 ? X = XT(B.subarray(4, 12)) : X = H.getUint32(4);
      var ce;
      return typeof X == "bigint" ? ce = X / Qa.BigInt(V) : typeof X == "number" && !isNaN(X) && (ce = X / V), ce < Number.MAX_SAFE_INTEGER && (ce = Number(ce)), ce < T && (T = ce), T;
    }, 1 / 0);
    return typeof m == "bigint" || isFinite(m) ? m : 0;
  }, Bf = function(c, g) {
    var p = gt(g, ["moof", "traf"]), m = 0, T = 0, S;
    if (p && p.length) {
      var L = gt(p[0], ["tfhd"])[0], O = gt(p[0], ["trun"])[0], V = gt(p[0], ["tfdt"])[0];
      if (L) {
        var B = Rf(L);
        S = B.trackId;
      }
      if (V) {
        var H = Lf(V);
        m = H.baseMediaDecodeTime;
      }
      if (O) {
        var X = Df(O);
        X.samples && X.samples.length && (T = X.samples[0].compositionTimeOffset || 0);
      }
    }
    var ce = c[S] || 9e4;
    typeof m == "bigint" && (T = Qa.BigInt(T), ce = Qa.BigInt(ce));
    var ye = (m + T) / ce;
    return typeof ye == "bigint" && ye < Number.MAX_SAFE_INTEGER && (ye = Number(ye)), ye;
  }, Ff = function(c) {
    var g = gt(c, ["moov", "trak"]), p = [];
    return g.forEach(function(m) {
      var T = gt(m, ["mdia", "hdlr"]), S = gt(m, ["tkhd"]);
      T.forEach(function(L, O) {
        var V = on(L.subarray(8, 12)), B = S[O], H, X, ce;
        V === "vide" && (H = new DataView(B.buffer, B.byteOffset, B.byteLength), X = H.getUint8(0), ce = X === 0 ? H.getUint32(12) : H.getUint32(20), p.push(ce));
      });
    }), p;
  }, bl = function(c) {
    var g = c[0], p = g === 0 ? 12 : 20;
    return mo(c[p] << 24 | c[p + 1] << 16 | c[p + 2] << 8 | c[p + 3]);
  }, Uf = function(c) {
    var g = gt(c, ["moov", "trak"]), p = [];
    return g.forEach(function(m) {
      var T = {}, S = gt(m, ["tkhd"])[0], L, O;
      S && (L = new DataView(S.buffer, S.byteOffset, S.byteLength), O = L.getUint8(0), T.id = O === 0 ? L.getUint32(12) : L.getUint32(20));
      var V = gt(m, ["mdia", "hdlr"])[0];
      if (V) {
        var B = on(V.subarray(8, 12));
        B === "vide" ? T.type = "video" : B === "soun" ? T.type = "audio" : T.type = B;
      }
      var H = gt(m, ["mdia", "minf", "stbl", "stsd"])[0];
      if (H) {
        var X = H.subarray(8);
        T.codec = on(X.subarray(4, 8));
        var ce = gt(X, [T.codec])[0], ye, se;
        ce && (/^[asm]vc[1-9]$/i.test(T.codec) ? (ye = ce.subarray(78), se = on(ye.subarray(4, 8)), se === "avcC" && ye.length > 11 ? (T.codec += ".", T.codec += Ja(ye[9]), T.codec += Ja(ye[10]), T.codec += Ja(ye[11])) : T.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(T.codec) ? (ye = ce.subarray(28), se = on(ye.subarray(4, 8)), se === "esds" && ye.length > 20 && ye[19] !== 0 ? (T.codec += "." + Ja(ye[19]), T.codec += "." + Ja(ye[20] >>> 2 & 63).replace(/^0/, "")) : T.codec = "mp4a.40.2") : T.codec = T.codec.toLowerCase());
      }
      var we = gt(m, ["mdia", "mdhd"])[0];
      we && (T.timescale = bl(we)), p.push(T);
    }), p;
  };
  var Vf = {
    // export mp4 inspector's findBox and parseType for backwards compatibility
    findBox: gt,
    parseType: on,
    timescale: Mf,
    startTime: Nf,
    compositionStartTime: Bf,
    videoTrackIds: Ff,
    tracks: Uf,
    getTimescaleFromMediaHeader: bl
  }, jf = function(c) {
    var g = c[1] & 31;
    return g <<= 8, g |= c[2], g;
  }, vo = function(c) {
    return !!(c[1] & 64);
  }, yo = function(c) {
    var g = 0;
    return (c[3] & 48) >>> 4 > 1 && (g += c[4] + 1), g;
  }, YT = function(c, g) {
    var p = jf(c);
    return p === 0 ? "pat" : p === g ? "pmt" : g ? "pes" : null;
  }, QT = function(c) {
    var g = vo(c), p = 4 + yo(c);
    return g && (p += c[p] + 1), (c[p + 10] & 31) << 8 | c[p + 11];
  }, JT = function(c) {
    var g = {}, p = vo(c), m = 4 + yo(c);
    if (p && (m += c[m] + 1), !!(c[m + 5] & 1)) {
      var T, S, L;
      T = (c[m + 1] & 15) << 8 | c[m + 2], S = 3 + T - 4, L = (c[m + 10] & 15) << 8 | c[m + 11];
      for (var O = 12 + L; O < S; ) {
        var V = m + O;
        g[(c[V + 1] & 31) << 8 | c[V + 2]] = c[V], O += ((c[V + 3] & 15) << 8 | c[V + 4]) + 5;
      }
      return g;
    }
  }, ZT = function(c, g) {
    var p = jf(c), m = g[p];
    switch (m) {
      case Ot.H264_STREAM_TYPE:
        return "video";
      case Ot.ADTS_STREAM_TYPE:
        return "audio";
      case Ot.METADATA_STREAM_TYPE:
        return "timed-metadata";
      default:
        return null;
    }
  }, eb = function(c) {
    var g = vo(c);
    if (!g)
      return null;
    var p = 4 + yo(c);
    if (p >= c.byteLength)
      return null;
    var m = null, T;
    return T = c[p + 7], T & 192 && (m = {}, m.pts = (c[p + 9] & 14) << 27 | (c[p + 10] & 255) << 20 | (c[p + 11] & 254) << 12 | (c[p + 12] & 255) << 5 | (c[p + 13] & 254) >>> 3, m.pts *= 4, m.pts += (c[p + 13] & 6) >>> 1, m.dts = m.pts, T & 64 && (m.dts = (c[p + 14] & 14) << 27 | (c[p + 15] & 255) << 20 | (c[p + 16] & 254) << 12 | (c[p + 17] & 255) << 5 | (c[p + 18] & 254) >>> 3, m.dts *= 4, m.dts += (c[p + 18] & 6) >>> 1)), m;
  }, Sl = function(c) {
    switch (c) {
      case 5:
        return "slice_layer_without_partitioning_rbsp_idr";
      case 6:
        return "sei_rbsp";
      case 7:
        return "seq_parameter_set_rbsp";
      case 8:
        return "pic_parameter_set_rbsp";
      case 9:
        return "access_unit_delimiter_rbsp";
      default:
        return null;
    }
  }, tb = function(c) {
    for (var g = 4 + yo(c), p = c.subarray(g), m = 0, T = 0, S = !1, L; T < p.byteLength - 3; T++)
      if (p[T + 2] === 1) {
        m = T + 5;
        break;
      }
    for (; m < p.byteLength; )
      switch (p[m]) {
        case 0:
          if (p[m - 1] !== 0) {
            m += 2;
            break;
          } else if (p[m - 2] !== 0) {
            m++;
            break;
          }
          T + 3 !== m - 2 && (L = Sl(p[T + 3] & 31), L === "slice_layer_without_partitioning_rbsp_idr" && (S = !0));
          do
            m++;
          while (p[m] !== 1 && m < p.length);
          T = m - 2, m += 3;
          break;
        case 1:
          if (p[m - 1] !== 0 || p[m - 2] !== 0) {
            m += 3;
            break;
          }
          L = Sl(p[T + 3] & 31), L === "slice_layer_without_partitioning_rbsp_idr" && (S = !0), T = m - 2, m += 3;
          break;
        default:
          m += 3;
          break;
      }
    return p = p.subarray(T), m -= T, T = 0, p && p.byteLength > 3 && (L = Sl(p[T + 3] & 31), L === "slice_layer_without_partitioning_rbsp_idr" && (S = !0)), S;
  }, ib = {
    parseType: YT,
    parsePat: QT,
    parsePmt: JT,
    parsePayloadUnitStartIndicator: vo,
    parsePesType: ZT,
    parsePesTime: eb,
    videoPacketContainsKeyFrame: tb
  }, zn = ro.handleRollover, tt = {};
  tt.ts = ib, tt.aac = he;
  var un = ie.ONE_SECOND_IN_TS, ei = 188, Ki = 71, rb = function(c, g) {
    for (var p = 0, m = ei, T, S; m < c.byteLength; ) {
      if (c[p] === Ki && c[m] === Ki) {
        switch (T = c.subarray(p, m), S = tt.ts.parseType(T, g.pid), S) {
          case "pat":
            g.pid = tt.ts.parsePat(T);
            break;
          case "pmt":
            var L = tt.ts.parsePmt(T);
            g.table = g.table || {}, Object.keys(L).forEach(function(O) {
              g.table[O] = L[O];
            });
            break;
        }
        p += ei, m += ei;
        continue;
      }
      p++, m++;
    }
  }, Hf = function(c, g, p) {
    for (var m = 0, T = ei, S, L, O, V, B, H = !1; T <= c.byteLength; ) {
      if (c[m] === Ki && (c[T] === Ki || T === c.byteLength)) {
        switch (S = c.subarray(m, T), L = tt.ts.parseType(S, g.pid), L) {
          case "pes":
            O = tt.ts.parsePesType(S, g.table), V = tt.ts.parsePayloadUnitStartIndicator(S), O === "audio" && V && (B = tt.ts.parsePesTime(S), B && (B.type = "audio", p.audio.push(B), H = !0));
            break;
        }
        if (H)
          break;
        m += ei, T += ei;
        continue;
      }
      m++, T++;
    }
    for (T = c.byteLength, m = T - ei, H = !1; m >= 0; ) {
      if (c[m] === Ki && (c[T] === Ki || T === c.byteLength)) {
        switch (S = c.subarray(m, T), L = tt.ts.parseType(S, g.pid), L) {
          case "pes":
            O = tt.ts.parsePesType(S, g.table), V = tt.ts.parsePayloadUnitStartIndicator(S), O === "audio" && V && (B = tt.ts.parsePesTime(S), B && (B.type = "audio", p.audio.push(B), H = !0));
            break;
        }
        if (H)
          break;
        m -= ei, T -= ei;
        continue;
      }
      m--, T--;
    }
  }, nb = function(c, g, p) {
    for (var m = 0, T = ei, S, L, O, V, B, H, X, ce, ye = !1, se = {
      data: [],
      size: 0
    }; T < c.byteLength; ) {
      if (c[m] === Ki && c[T] === Ki) {
        switch (S = c.subarray(m, T), L = tt.ts.parseType(S, g.pid), L) {
          case "pes":
            if (O = tt.ts.parsePesType(S, g.table), V = tt.ts.parsePayloadUnitStartIndicator(S), O === "video" && (V && !ye && (B = tt.ts.parsePesTime(S), B && (B.type = "video", p.video.push(B), ye = !0)), !p.firstKeyFrame)) {
              if (V && se.size !== 0) {
                for (H = new Uint8Array(se.size), X = 0; se.data.length; )
                  ce = se.data.shift(), H.set(ce, X), X += ce.byteLength;
                if (tt.ts.videoPacketContainsKeyFrame(H)) {
                  var we = tt.ts.parsePesTime(H);
                  we ? (p.firstKeyFrame = we, p.firstKeyFrame.type = "video") : console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                }
                se.size = 0;
              }
              se.data.push(S), se.size += S.byteLength;
            }
            break;
        }
        if (ye && p.firstKeyFrame)
          break;
        m += ei, T += ei;
        continue;
      }
      m++, T++;
    }
    for (T = c.byteLength, m = T - ei, ye = !1; m >= 0; ) {
      if (c[m] === Ki && c[T] === Ki) {
        switch (S = c.subarray(m, T), L = tt.ts.parseType(S, g.pid), L) {
          case "pes":
            O = tt.ts.parsePesType(S, g.table), V = tt.ts.parsePayloadUnitStartIndicator(S), O === "video" && V && (B = tt.ts.parsePesTime(S), B && (B.type = "video", p.video.push(B), ye = !0));
            break;
        }
        if (ye)
          break;
        m -= ei, T -= ei;
        continue;
      }
      m--, T--;
    }
  }, ab = function(c, g) {
    if (c.audio && c.audio.length) {
      var p = g;
      (typeof p > "u" || isNaN(p)) && (p = c.audio[0].dts), c.audio.forEach(function(S) {
        S.dts = zn(S.dts, p), S.pts = zn(S.pts, p), S.dtsTime = S.dts / un, S.ptsTime = S.pts / un;
      });
    }
    if (c.video && c.video.length) {
      var m = g;
      if ((typeof m > "u" || isNaN(m)) && (m = c.video[0].dts), c.video.forEach(function(S) {
        S.dts = zn(S.dts, m), S.pts = zn(S.pts, m), S.dtsTime = S.dts / un, S.ptsTime = S.pts / un;
      }), c.firstKeyFrame) {
        var T = c.firstKeyFrame;
        T.dts = zn(T.dts, m), T.pts = zn(T.pts, m), T.dtsTime = T.dts / un, T.ptsTime = T.pts / un;
      }
    }
  }, sb = function(c) {
    for (var g = !1, p = 0, m = null, T = null, S = 0, L = 0, O; c.length - L >= 3; ) {
      var V = tt.aac.parseType(c, L);
      switch (V) {
        case "timed-metadata":
          if (c.length - L < 10) {
            g = !0;
            break;
          }
          if (S = tt.aac.parseId3TagSize(c, L), S > c.length) {
            g = !0;
            break;
          }
          T === null && (O = c.subarray(L, L + S), T = tt.aac.parseAacTimestamp(O)), L += S;
          break;
        case "audio":
          if (c.length - L < 7) {
            g = !0;
            break;
          }
          if (S = tt.aac.parseAdtsSize(c, L), S > c.length) {
            g = !0;
            break;
          }
          m === null && (O = c.subarray(L, L + S), m = tt.aac.parseSampleRate(O)), p++, L += S;
          break;
        default:
          L++;
          break;
      }
      if (g)
        return null;
    }
    if (m === null || T === null)
      return null;
    var B = un / m, H = {
      audio: [{
        type: "audio",
        dts: T,
        pts: T
      }, {
        type: "audio",
        dts: T + p * 1024 * B,
        pts: T + p * 1024 * B
      }]
    };
    return H;
  }, ob = function(c) {
    var g = {
      pid: null,
      table: null
    }, p = {};
    rb(c, g);
    for (var m in g.table)
      if (g.table.hasOwnProperty(m)) {
        var T = g.table[m];
        switch (T) {
          case Ot.H264_STREAM_TYPE:
            p.video = [], nb(c, g, p), p.video.length === 0 && delete p.video;
            break;
          case Ot.ADTS_STREAM_TYPE:
            p.audio = [], Hf(c, g, p), p.audio.length === 0 && delete p.audio;
            break;
        }
      }
    return p;
  }, ub = function(c, g) {
    var p = tt.aac.isLikelyAacData(c), m;
    return p ? m = sb(c) : m = ob(c), !m || !m.audio && !m.video ? null : (ab(m, g), m);
  }, lb = {
    inspect: ub,
    parseAudioPes_: Hf
  }, db = function(c, g) {
    g.on("data", function(p) {
      var m = p.initSegment;
      p.initSegment = {
        data: m.buffer,
        byteOffset: m.byteOffset,
        byteLength: m.byteLength
      };
      var T = p.data;
      p.data = T.buffer, c.postMessage({
        action: "data",
        segment: p,
        byteOffset: T.byteOffset,
        byteLength: T.byteLength
      }, [p.data]);
    }), g.on("done", function(p) {
      c.postMessage({
        action: "done"
      });
    }), g.on("gopInfo", function(p) {
      c.postMessage({
        action: "gopInfo",
        gopInfo: p
      });
    }), g.on("videoSegmentTimingInfo", function(p) {
      var m = {
        start: {
          decode: ie.videoTsToSeconds(p.start.dts),
          presentation: ie.videoTsToSeconds(p.start.pts)
        },
        end: {
          decode: ie.videoTsToSeconds(p.end.dts),
          presentation: ie.videoTsToSeconds(p.end.pts)
        },
        baseMediaDecodeTime: ie.videoTsToSeconds(p.baseMediaDecodeTime)
      };
      p.prependedContentDuration && (m.prependedContentDuration = ie.videoTsToSeconds(p.prependedContentDuration)), c.postMessage({
        action: "videoSegmentTimingInfo",
        videoSegmentTimingInfo: m
      });
    }), g.on("audioSegmentTimingInfo", function(p) {
      var m = {
        start: {
          decode: ie.videoTsToSeconds(p.start.dts),
          presentation: ie.videoTsToSeconds(p.start.pts)
        },
        end: {
          decode: ie.videoTsToSeconds(p.end.dts),
          presentation: ie.videoTsToSeconds(p.end.pts)
        },
        baseMediaDecodeTime: ie.videoTsToSeconds(p.baseMediaDecodeTime)
      };
      p.prependedContentDuration && (m.prependedContentDuration = ie.videoTsToSeconds(p.prependedContentDuration)), c.postMessage({
        action: "audioSegmentTimingInfo",
        audioSegmentTimingInfo: m
      });
    }), g.on("id3Frame", function(p) {
      c.postMessage({
        action: "id3Frame",
        id3Frame: p
      });
    }), g.on("caption", function(p) {
      c.postMessage({
        action: "caption",
        caption: p
      });
    }), g.on("trackinfo", function(p) {
      c.postMessage({
        action: "trackinfo",
        trackInfo: p
      });
    }), g.on("audioTimingInfo", function(p) {
      c.postMessage({
        action: "audioTimingInfo",
        audioTimingInfo: {
          start: ie.videoTsToSeconds(p.start),
          end: ie.videoTsToSeconds(p.end)
        }
      });
    }), g.on("videoTimingInfo", function(p) {
      c.postMessage({
        action: "videoTimingInfo",
        videoTimingInfo: {
          start: ie.videoTsToSeconds(p.start),
          end: ie.videoTsToSeconds(p.end)
        }
      });
    }), g.on("log", function(p) {
      c.postMessage({
        action: "log",
        log: p
      });
    });
  }, Wf = /* @__PURE__ */ function() {
    function x(g, p) {
      this.options = p || {}, this.self = g, this.init();
    }
    var c = x.prototype;
    return c.init = function() {
      this.transmuxer && this.transmuxer.dispose(), this.transmuxer = new fo.Transmuxer(this.options), db(this.self, this.transmuxer);
    }, c.pushMp4Captions = function(p) {
      this.captionParser || (this.captionParser = new KT(), this.captionParser.init());
      var m = new Uint8Array(p.data, p.byteOffset, p.byteLength), T = this.captionParser.parse(m, p.trackIds, p.timescales);
      this.self.postMessage({
        action: "mp4Captions",
        captions: T && T.captions || [],
        logs: T && T.logs || [],
        data: m.buffer
      }, [m.buffer]);
    }, c.probeMp4StartTime = function(p) {
      var m = p.timescales, T = p.data, S = Vf.startTime(m, T);
      this.self.postMessage({
        action: "probeMp4StartTime",
        startTime: S,
        data: T
      }, [T.buffer]);
    }, c.probeMp4Tracks = function(p) {
      var m = p.data, T = Vf.tracks(m);
      this.self.postMessage({
        action: "probeMp4Tracks",
        tracks: T,
        data: m
      }, [m.buffer]);
    }, c.probeTs = function(p) {
      var m = p.data, T = p.baseStartTime, S = typeof T == "number" && !isNaN(T) ? T * ie.ONE_SECOND_IN_TS : void 0, L = lb.inspect(m, S), O = null;
      L && (O = {
        // each type's time info comes back as an array of 2 times, start and end
        hasVideo: L.video && L.video.length === 2 || !1,
        hasAudio: L.audio && L.audio.length === 2 || !1
      }, O.hasVideo && (O.videoStart = L.video[0].ptsTime), O.hasAudio && (O.audioStart = L.audio[0].ptsTime)), this.self.postMessage({
        action: "probeTs",
        result: O,
        data: m
      }, [m.buffer]);
    }, c.clearAllMp4Captions = function() {
      this.captionParser && this.captionParser.clearAllCaptions();
    }, c.clearParsedMp4Captions = function() {
      this.captionParser && this.captionParser.clearParsedCaptions();
    }, c.push = function(p) {
      var m = new Uint8Array(p.data, p.byteOffset, p.byteLength);
      this.transmuxer.push(m);
    }, c.reset = function() {
      this.transmuxer.reset();
    }, c.setTimestampOffset = function(p) {
      var m = p.timestampOffset || 0;
      this.transmuxer.setBaseMediaDecodeTime(Math.round(ie.secondsToVideoTs(m)));
    }, c.setAudioAppendStart = function(p) {
      this.transmuxer.setAudioAppendStart(Math.ceil(ie.secondsToVideoTs(p.appendStart)));
    }, c.setRemux = function(p) {
      this.transmuxer.setRemux(p.remux);
    }, c.flush = function(p) {
      this.transmuxer.flush(), self.postMessage({
        action: "done",
        type: "transmuxed"
      });
    }, c.endTimeline = function() {
      this.transmuxer.endTimeline(), self.postMessage({
        action: "endedtimeline",
        type: "transmuxed"
      });
    }, c.alignGopsWith = function(p) {
      this.transmuxer.alignGopsWith(p.gopsToAlignWith.slice());
    }, x;
  }();
  self.onmessage = function(x) {
    if (x.data.action === "init" && x.data.options) {
      this.messageHandlers = new Wf(self, x.data.options);
      return;
    }
    this.messageHandlers || (this.messageHandlers = new Wf(self)), x.data && x.data.action && x.data.action !== "init" && this.messageHandlers[x.data.action] && this.messageHandlers[x.data.action](x.data);
  };
})), F1 = U0(B1), U1 = function(e, r, n) {
  var i = e.data.segment, a = i.type, s = i.initSegment, o = i.captions, u = i.captionStreams, l = i.metadata, d = i.videoFrameDtsTime, h = i.videoFramePtsTime;
  r.buffer.push({
    captions: o,
    captionStreams: u,
    metadata: l
  });
  var f = e.data.segment.boxes || {
    data: e.data.segment.data
  }, v = {
    type: a,
    // cast ArrayBuffer to TypedArray
    data: new Uint8Array(f.data, f.data.byteOffset, f.data.byteLength),
    initSegment: new Uint8Array(s.data, s.byteOffset, s.byteLength)
  };
  typeof d < "u" && (v.videoFrameDtsTime = d), typeof h < "u" && (v.videoFramePtsTime = h), n(v);
}, V1 = function(e) {
  var r = e.transmuxedData, n = e.callback;
  r.buffer = [], n(r);
}, j1 = function(e, r) {
  r.gopInfo = e.data.gopInfo;
}, H0 = function(e) {
  var r = e.transmuxer, n = e.bytes, i = e.audioAppendStart, a = e.gopsToAlignWith, s = e.remux, o = e.onData, u = e.onTrackInfo, l = e.onAudioTimingInfo, d = e.onVideoTimingInfo, h = e.onVideoSegmentTimingInfo, f = e.onAudioSegmentTimingInfo, v = e.onId3, b = e.onCaptions, _ = e.onDone, y = e.onEndedTimeline, E = e.onTransmuxerLog, R = e.isEndOfTimeline, D = {
    buffer: []
  }, C = R, w = function($) {
    r.currentTransmux === e && ($.data.action === "data" && U1($, D, o), $.data.action === "trackinfo" && u($.data.trackInfo), $.data.action === "gopInfo" && j1($, D), $.data.action === "audioTimingInfo" && l($.data.audioTimingInfo), $.data.action === "videoTimingInfo" && d($.data.videoTimingInfo), $.data.action === "videoSegmentTimingInfo" && h($.data.videoSegmentTimingInfo), $.data.action === "audioSegmentTimingInfo" && f($.data.audioSegmentTimingInfo), $.data.action === "id3Frame" && v([$.data.id3Frame], $.data.id3Frame.dispatchType), $.data.action === "caption" && b($.data.caption), $.data.action === "endedtimeline" && (C = !1, y()), $.data.action === "log" && E($.data.log), $.data.type === "transmuxed" && (C || (r.onmessage = null, V1({
      transmuxedData: D,
      callback: _
    }), W0(r))));
  };
  if (r.onmessage = w, i && r.postMessage({
    action: "setAudioAppendStart",
    appendStart: i
  }), Array.isArray(a) && r.postMessage({
    action: "alignGopsWith",
    gopsToAlignWith: a
  }), typeof s < "u" && r.postMessage({
    action: "setRemux",
    remux: s
  }), n.byteLength) {
    var k = n instanceof ArrayBuffer ? n : n.buffer, I = n instanceof ArrayBuffer ? 0 : n.byteOffset;
    r.postMessage({
      action: "push",
      // Send the typed-array of data as an ArrayBuffer so that
      // it can be sent as a "Transferable" and avoid the costly
      // memory copy
      data: k,
      // To recreate the original typed-array, we need information
      // about what portion of the ArrayBuffer it was a view into
      byteOffset: I,
      byteLength: n.byteLength
    }, [k]);
  }
  R && r.postMessage({
    action: "endTimeline"
  }), r.postMessage({
    action: "flush"
  });
}, W0 = function(e) {
  e.currentTransmux = null, e.transmuxQueue.length && (e.currentTransmux = e.transmuxQueue.shift(), typeof e.currentTransmux == "function" ? e.currentTransmux() : H0(e.currentTransmux));
}, og = function(e, r) {
  e.postMessage({
    action: r
  }), W0(e);
}, q0 = function(e, r) {
  if (!r.currentTransmux) {
    r.currentTransmux = e, og(r, e);
    return;
  }
  r.transmuxQueue.push(og.bind(null, r, e));
}, H1 = function(e) {
  q0("reset", e);
}, W1 = function(e) {
  q0("endTimeline", e);
}, $0 = function(e) {
  if (!e.transmuxer.currentTransmux) {
    e.transmuxer.currentTransmux = e, H0(e);
    return;
  }
  e.transmuxer.transmuxQueue.push(e);
}, q1 = function(e) {
  var r = new F1();
  r.currentTransmux = null, r.transmuxQueue = [];
  var n = r.terminate;
  return r.terminate = function() {
    return r.currentTransmux = null, r.transmuxQueue.length = 0, n.call(r);
  }, r.postMessage({
    action: "init",
    options: e
  }), r;
}, Gl = {
  reset: H1,
  endTimeline: W1,
  transmux: $0,
  createTransmuxer: q1
}, vu = function(e) {
  var r = e.transmuxer, n = e.endAction || e.action, i = e.callback, a = Vi({}, e, {
    endAction: null,
    transmuxer: null,
    callback: null
  }), s = function l(d) {
    d.data.action === n && (r.removeEventListener("message", l), d.data.data && (d.data.data = new Uint8Array(d.data.data, e.byteOffset || 0, e.byteLength || d.data.data.byteLength), e.data && (e.data = d.data.data)), i(d.data));
  };
  if (r.addEventListener("message", s), e.data) {
    var o = e.data instanceof ArrayBuffer;
    a.byteOffset = o ? 0 : e.data.byteOffset, a.byteLength = e.data.byteLength;
    var u = [o ? e.data : e.data.buffer];
    r.postMessage(a, u);
  } else
    r.postMessage(a);
}, ir = {
  FAILURE: 2,
  TIMEOUT: -101,
  ABORTED: -102
}, Ic = function(e) {
  e.forEach(function(r) {
    r.abort();
  });
}, $1 = function(e) {
  return {
    bandwidth: e.bandwidth,
    bytesReceived: e.bytesReceived || 0,
    roundTripTime: e.roundTripTime || 0
  };
}, z1 = function(e) {
  var r = e.target, n = Date.now() - r.requestTime, i = {
    bandwidth: 1 / 0,
    bytesReceived: 0,
    roundTripTime: n || 0
  };
  return i.bytesReceived = e.loaded, i.bandwidth = Math.floor(i.bytesReceived / i.roundTripTime * 8 * 1e3), i;
}, af = function(e, r) {
  return r.timedout ? {
    status: r.status,
    message: "HLS request timed-out at URL: " + r.uri,
    code: ir.TIMEOUT,
    xhr: r
  } : r.aborted ? {
    status: r.status,
    message: "HLS request aborted at URL: " + r.uri,
    code: ir.ABORTED,
    xhr: r
  } : e ? {
    status: r.status,
    message: "HLS request errored at URL: " + r.uri,
    code: ir.FAILURE,
    xhr: r
  } : r.responseType === "arraybuffer" && r.response.byteLength === 0 ? {
    status: r.status,
    message: "Empty HLS response at URL: " + r.uri,
    code: ir.FAILURE,
    xhr: r
  } : null;
}, ug = function(e, r, n) {
  return function(i, a) {
    var s = a.response, o = af(i, a);
    if (o)
      return n(o, e);
    if (s.byteLength !== 16)
      return n({
        status: a.status,
        message: "Invalid HLS key at URL: " + a.uri,
        code: ir.FAILURE,
        xhr: a
      }, e);
    for (var u = new DataView(s), l = new Uint32Array([u.getUint32(0), u.getUint32(4), u.getUint32(8), u.getUint32(12)]), d = 0; d < r.length; d++)
      r[d].bytes = l;
    return n(null, e);
  };
}, z0 = function(e, r) {
  var n = _h(e.map.bytes);
  if (n !== "mp4") {
    var i = e.map.resolvedUri || e.map.uri;
    return r({
      internal: !0,
      message: "Found unsupported " + (n || "unknown") + " container for initialization segment at URL: " + i,
      code: ir.FAILURE
    });
  }
  vu({
    action: "probeMp4Tracks",
    data: e.map.bytes,
    transmuxer: e.transmuxer,
    callback: function(s) {
      var o = s.tracks, u = s.data;
      return e.map.bytes = u, o.forEach(function(l) {
        e.map.tracks = e.map.tracks || {}, !e.map.tracks[l.type] && (e.map.tracks[l.type] = l, typeof l.id == "number" && l.timescale && (e.map.timescales = e.map.timescales || {}, e.map.timescales[l.id] = l.timescale));
      }), r(null);
    }
  });
}, G1 = function(e) {
  var r = e.segment, n = e.finishProcessingFn;
  return function(i, a) {
    var s = af(i, a);
    if (s)
      return n(s, r);
    var o = new Uint8Array(a.response);
    if (r.map.key)
      return r.map.encryptedBytes = o, n(null, r);
    r.map.bytes = o, z0(r, function(u) {
      if (u)
        return u.xhr = a, u.status = a.status, n(u, r);
      n(null, r);
    });
  };
}, K1 = function(e) {
  var r = e.segment, n = e.finishProcessingFn, i = e.responseType;
  return function(a, s) {
    var o = af(a, s);
    if (o)
      return n(o, r);
    var u = (
      // although responseText "should" exist, this guard serves to prevent an error being
      // thrown for two primary cases:
      // 1. the mime type override stops working, or is not implemented for a specific
      //    browser
      // 2. when using mock XHR libraries like sinon that do not allow the override behavior
      i === "arraybuffer" || !s.responseText ? s.response : M1(s.responseText.substring(r.lastReachedChar || 0))
    );
    return r.stats = $1(s), r.key ? r.encryptedBytes = new Uint8Array(u) : r.bytes = new Uint8Array(u), n(null, r);
  };
}, X1 = function(e) {
  var r = e.segment, n = e.bytes, i = e.trackInfoFn, a = e.timingInfoFn, s = e.videoSegmentTimingInfoFn, o = e.audioSegmentTimingInfoFn, u = e.id3Fn, l = e.captionsFn, d = e.isEndOfTimeline, h = e.endedTimelineFn, f = e.dataFn, v = e.doneFn, b = e.onTransmuxerLog, _ = r.map && r.map.tracks || {}, y = !!(_.audio && _.video), E = a.bind(null, r, "audio", "start"), R = a.bind(null, r, "audio", "end"), D = a.bind(null, r, "video", "start"), C = a.bind(null, r, "video", "end"), w = function() {
    return $0({
      bytes: n,
      transmuxer: r.transmuxer,
      audioAppendStart: r.audioAppendStart,
      gopsToAlignWith: r.gopsToAlignWith,
      remux: y,
      onData: function(U) {
        U.type = U.type === "combined" ? "video" : U.type, f(r, U);
      },
      onTrackInfo: function(U) {
        i && (y && (U.isMuxed = !0), i(r, U));
      },
      onAudioTimingInfo: function(U) {
        E && typeof U.start < "u" && (E(U.start), E = null), R && typeof U.end < "u" && R(U.end);
      },
      onVideoTimingInfo: function(U) {
        D && typeof U.start < "u" && (D(U.start), D = null), C && typeof U.end < "u" && C(U.end);
      },
      onVideoSegmentTimingInfo: function(U) {
        s(U);
      },
      onAudioSegmentTimingInfo: function(U) {
        o(U);
      },
      onId3: function(U, $) {
        u(r, U, $);
      },
      onCaptions: function(U) {
        l(r, [U]);
      },
      isEndOfTimeline: d,
      onEndedTimeline: function() {
        h();
      },
      onTransmuxerLog: b,
      onDone: function(U) {
        v && (U.type = U.type === "combined" ? "video" : U.type, v(null, r, U));
      }
    });
  };
  vu({
    action: "probeTs",
    transmuxer: r.transmuxer,
    data: n,
    baseStartTime: r.baseStartTime,
    callback: function(I) {
      r.bytes = n = I.data;
      var U = I.result;
      U && (i(r, {
        hasAudio: U.hasAudio,
        hasVideo: U.hasVideo,
        isMuxed: y
      }), i = null, U.hasAudio && !y && E(U.audioStart), U.hasVideo && D(U.videoStart), E = null, D = null), w();
    }
  });
}, G0 = function(e) {
  var r = e.segment, n = e.bytes, i = e.trackInfoFn, a = e.timingInfoFn, s = e.videoSegmentTimingInfoFn, o = e.audioSegmentTimingInfoFn, u = e.id3Fn, l = e.captionsFn, d = e.isEndOfTimeline, h = e.endedTimelineFn, f = e.dataFn, v = e.doneFn, b = e.onTransmuxerLog, _ = new Uint8Array(n);
  if (px(_)) {
    r.isFmp4 = !0;
    var y = r.map.tracks, E = {
      isFmp4: !0,
      hasVideo: !!y.video,
      hasAudio: !!y.audio
    };
    y.audio && y.audio.codec && y.audio.codec !== "enca" && (E.audioCodec = y.audio.codec), y.video && y.video.codec && y.video.codec !== "encv" && (E.videoCodec = y.video.codec), y.video && y.audio && (E.isMuxed = !0), i(r, E);
    var R = function(C) {
      f(r, {
        data: _,
        type: E.hasAudio && !E.isMuxed ? "audio" : "video"
      }), C && C.length && l(r, C), v(null, r, {});
    };
    vu({
      action: "probeMp4StartTime",
      timescales: r.map.timescales,
      data: _,
      transmuxer: r.transmuxer,
      callback: function(C) {
        var w = C.data, k = C.startTime;
        if (n = w.buffer, r.bytes = _ = w, E.hasAudio && !E.isMuxed && a(r, "audio", "start", k), E.hasVideo && a(r, "video", "start", k), !y.video || !w.byteLength || !r.transmuxer) {
          R();
          return;
        }
        vu({
          action: "pushMp4Captions",
          endAction: "mp4Captions",
          transmuxer: r.transmuxer,
          data: _,
          timescales: r.map.timescales,
          trackIds: [y.video.id],
          callback: function(U) {
            n = U.data.buffer, r.bytes = _ = U.data, U.logs.forEach(function($) {
              b(P.mergeOptions($, {
                stream: "mp4CaptionParser"
              }));
            }), R(U.captions);
          }
        });
      }
    });
    return;
  }
  if (!r.transmuxer) {
    v(null, r, {});
    return;
  }
  if (typeof r.container > "u" && (r.container = _h(_)), r.container !== "ts" && r.container !== "aac") {
    i(r, {
      hasAudio: !1,
      hasVideo: !1
    }), v(null, r, {});
    return;
  }
  X1({
    segment: r,
    bytes: n,
    trackInfoFn: i,
    timingInfoFn: a,
    videoSegmentTimingInfoFn: s,
    audioSegmentTimingInfoFn: o,
    id3Fn: u,
    captionsFn: l,
    isEndOfTimeline: d,
    endedTimelineFn: h,
    dataFn: f,
    doneFn: v,
    onTransmuxerLog: b
  });
}, K0 = function(e, r) {
  var n = e.id, i = e.key, a = e.encryptedBytes, s = e.decryptionWorker, o = function l(d) {
    if (d.data.source === n) {
      s.removeEventListener("message", l);
      var h = d.data.decrypted;
      r(new Uint8Array(h.bytes, h.byteOffset, h.byteLength));
    }
  };
  s.addEventListener("message", o);
  var u;
  i.bytes.slice ? u = i.bytes.slice() : u = new Uint32Array(Array.prototype.slice.call(i.bytes)), s.postMessage(R0({
    source: n,
    encrypted: a,
    key: u,
    iv: i.iv
  }), [a.buffer, u.buffer]);
}, Y1 = function(e) {
  var r = e.decryptionWorker, n = e.segment, i = e.trackInfoFn, a = e.timingInfoFn, s = e.videoSegmentTimingInfoFn, o = e.audioSegmentTimingInfoFn, u = e.id3Fn, l = e.captionsFn, d = e.isEndOfTimeline, h = e.endedTimelineFn, f = e.dataFn, v = e.doneFn, b = e.onTransmuxerLog;
  K0({
    id: n.requestId,
    key: n.key,
    encryptedBytes: n.encryptedBytes,
    decryptionWorker: r
  }, function(_) {
    n.bytes = _, G0({
      segment: n,
      bytes: n.bytes,
      trackInfoFn: i,
      timingInfoFn: a,
      videoSegmentTimingInfoFn: s,
      audioSegmentTimingInfoFn: o,
      id3Fn: u,
      captionsFn: l,
      isEndOfTimeline: d,
      endedTimelineFn: h,
      dataFn: f,
      doneFn: v,
      onTransmuxerLog: b
    });
  });
}, Q1 = function(e) {
  var r = e.activeXhrs, n = e.decryptionWorker, i = e.trackInfoFn, a = e.timingInfoFn, s = e.videoSegmentTimingInfoFn, o = e.audioSegmentTimingInfoFn, u = e.id3Fn, l = e.captionsFn, d = e.isEndOfTimeline, h = e.endedTimelineFn, f = e.dataFn, v = e.doneFn, b = e.onTransmuxerLog, _ = 0, y = !1;
  return function(E, R) {
    if (!y) {
      if (E)
        return y = !0, Ic(r), v(E, R);
      if (_ += 1, _ === r.length) {
        var D = function() {
          if (R.encryptedBytes)
            return Y1({
              decryptionWorker: n,
              segment: R,
              trackInfoFn: i,
              timingInfoFn: a,
              videoSegmentTimingInfoFn: s,
              audioSegmentTimingInfoFn: o,
              id3Fn: u,
              captionsFn: l,
              isEndOfTimeline: d,
              endedTimelineFn: h,
              dataFn: f,
              doneFn: v,
              onTransmuxerLog: b
            });
          G0({
            segment: R,
            bytes: R.bytes,
            trackInfoFn: i,
            timingInfoFn: a,
            videoSegmentTimingInfoFn: s,
            audioSegmentTimingInfoFn: o,
            id3Fn: u,
            captionsFn: l,
            isEndOfTimeline: d,
            endedTimelineFn: h,
            dataFn: f,
            doneFn: v,
            onTransmuxerLog: b
          });
        };
        if (R.endOfAllRequests = Date.now(), R.map && R.map.encryptedBytes && !R.map.bytes)
          return K0({
            decryptionWorker: n,
            // add -init to the "id" to differentiate between segment
            // and init segment decryption, just in case they happen
            // at the same time at some point in the future.
            id: R.requestId + "-init",
            encryptedBytes: R.map.encryptedBytes,
            key: R.map.key
          }, function(C) {
            R.map.bytes = C, z0(R, function(w) {
              if (w)
                return Ic(r), v(w, R);
              D();
            });
          });
        D();
      }
    }
  };
}, J1 = function(e) {
  var r = e.loadendState, n = e.abortFn;
  return function(i) {
    var a = i.target;
    a.aborted && n && !r.calledAbortFn && (n(), r.calledAbortFn = !0);
  };
}, Z1 = function(e) {
  var r = e.segment, n = e.progressFn;
  return e.trackInfoFn, e.timingInfoFn, e.videoSegmentTimingInfoFn, e.audioSegmentTimingInfoFn, e.id3Fn, e.captionsFn, e.isEndOfTimeline, e.endedTimelineFn, e.dataFn, function(i) {
    var a = i.target;
    if (!a.aborted)
      return r.stats = P.mergeOptions(r.stats, z1(i)), !r.stats.firstBytesReceivedAt && r.stats.bytesReceived && (r.stats.firstBytesReceivedAt = Date.now()), n(i, r);
  };
}, eA = function(e) {
  var r = e.xhr, n = e.xhrOptions, i = e.decryptionWorker, a = e.segment, s = e.abortFn, o = e.progressFn, u = e.trackInfoFn, l = e.timingInfoFn, d = e.videoSegmentTimingInfoFn, h = e.audioSegmentTimingInfoFn, f = e.id3Fn, v = e.captionsFn, b = e.isEndOfTimeline, _ = e.endedTimelineFn, y = e.dataFn, E = e.doneFn, R = e.onTransmuxerLog, D = [], C = Q1({
    activeXhrs: D,
    decryptionWorker: i,
    trackInfoFn: u,
    timingInfoFn: l,
    videoSegmentTimingInfoFn: d,
    audioSegmentTimingInfoFn: h,
    id3Fn: f,
    captionsFn: v,
    isEndOfTimeline: b,
    endedTimelineFn: _,
    dataFn: y,
    doneFn: E,
    onTransmuxerLog: R
  });
  if (a.key && !a.key.bytes) {
    var w = [a.key];
    a.map && !a.map.bytes && a.map.key && a.map.key.resolvedUri === a.key.resolvedUri && w.push(a.map.key);
    var k = P.mergeOptions(n, {
      uri: a.key.resolvedUri,
      responseType: "arraybuffer"
    }), I = ug(a, w, C), U = r(k, I);
    D.push(U);
  }
  if (a.map && !a.map.bytes) {
    var $ = a.map.key && (!a.key || a.key.resolvedUri !== a.map.key.resolvedUri);
    if ($) {
      var W = P.mergeOptions(n, {
        uri: a.map.key.resolvedUri,
        responseType: "arraybuffer"
      }), G = ug(a, [a.map.key], C), Y = r(W, G);
      D.push(Y);
    }
    var re = P.mergeOptions(n, {
      uri: a.map.resolvedUri,
      responseType: "arraybuffer",
      headers: kc(a.map)
    }), j = G1({
      segment: a,
      finishProcessingFn: C
    }), J = r(re, j);
    D.push(J);
  }
  var z = P.mergeOptions(n, {
    uri: a.part && a.part.resolvedUri || a.resolvedUri,
    responseType: "arraybuffer",
    headers: kc(a)
  }), Q = K1({
    segment: a,
    finishProcessingFn: C,
    responseType: z.responseType
  }), te = r(z, Q);
  te.addEventListener("progress", Z1({
    segment: a,
    progressFn: o,
    trackInfoFn: u,
    timingInfoFn: l,
    videoSegmentTimingInfoFn: d,
    audioSegmentTimingInfoFn: h,
    id3Fn: f,
    captionsFn: v,
    isEndOfTimeline: b,
    endedTimelineFn: _,
    dataFn: y
  })), D.push(te);
  var ae = {};
  return D.forEach(function(ne) {
    ne.addEventListener("loadend", J1({
      loadendState: ae,
      abortFn: s
    }));
  }), function() {
    return Ic(D);
  };
}, tA = Hi("CodecUtils"), iA = function(e) {
  var r = e.attributes || {};
  if (r.CODECS)
    return Yi(r.CODECS);
}, X0 = function(e, r) {
  var n = r.attributes || {};
  return e && e.mediaGroups && e.mediaGroups.AUDIO && n.AUDIO && e.mediaGroups.AUDIO[n.AUDIO];
}, rA = function(e, r) {
  if (!X0(e, r))
    return !0;
  var n = r.attributes || {}, i = e.mediaGroups.AUDIO[n.AUDIO];
  for (var a in i)
    if (!i[a].uri && !i[a].playlists)
      return !0;
  return !1;
}, yu = function(e) {
  var r = {};
  return e.forEach(function(n) {
    var i = n.mediaType, a = n.type, s = n.details;
    r[i] = r[i] || [], r[i].push(gv("" + a + s));
  }), Object.keys(r).forEach(function(n) {
    if (r[n].length > 1) {
      tA("multiple " + n + " codecs found as attributes: " + r[n].join(", ") + ". Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs."), r[n] = null;
      return;
    }
    r[n] = r[n][0];
  }), r;
}, lg = function(e) {
  var r = 0;
  return e.audio && r++, e.video && r++, r;
}, Ss = function(e, r) {
  var n = r.attributes || {}, i = yu(iA(r) || []);
  if (X0(e, r) && !i.audio && !rA(e, r)) {
    var a = yu(_S(e, n.AUDIO) || []);
    a.audio && (i.audio = a.audio);
  }
  return i;
}, Po = Hi("PlaylistSelector"), dg = function(e) {
  if (!(!e || !e.playlist)) {
    var r = e.playlist;
    return JSON.stringify({
      id: r.id,
      bandwidth: e.bandwidth,
      width: e.width,
      height: e.height,
      codecs: r.attributes && r.attributes.CODECS || ""
    });
  }
}, _u = function(e, r) {
  if (!e)
    return "";
  var n = M.getComputedStyle(e);
  return n ? n[r] : "";
}, ga = function(e, r) {
  var n = e.slice();
  e.sort(function(i, a) {
    var s = r(i, a);
    return s === 0 ? n.indexOf(i) - n.indexOf(a) : s;
  });
}, sf = function(e, r) {
  var n, i;
  return e.attributes.BANDWIDTH && (n = e.attributes.BANDWIDTH), n = n || M.Number.MAX_VALUE, r.attributes.BANDWIDTH && (i = r.attributes.BANDWIDTH), i = i || M.Number.MAX_VALUE, n - i;
}, nA = function(e, r) {
  var n, i;
  return e.attributes.RESOLUTION && e.attributes.RESOLUTION.width && (n = e.attributes.RESOLUTION.width), n = n || M.Number.MAX_VALUE, r.attributes.RESOLUTION && r.attributes.RESOLUTION.width && (i = r.attributes.RESOLUTION.width), i = i || M.Number.MAX_VALUE, n === i && e.attributes.BANDWIDTH && r.attributes.BANDWIDTH ? e.attributes.BANDWIDTH - r.attributes.BANDWIDTH : n - i;
}, Y0 = function(e, r, n, i, a, s) {
  if (e) {
    var o = {
      bandwidth: r,
      width: n,
      height: i,
      limitRenditionByPlayerDimensions: a
    }, u = e.playlists;
    hi.isAudioOnly(e) && (u = s.getAudioTrackPlaylists_(), o.audioOnly = !0);
    var l = u.map(function(W) {
      var G, Y = W.attributes && W.attributes.RESOLUTION && W.attributes.RESOLUTION.width, re = W.attributes && W.attributes.RESOLUTION && W.attributes.RESOLUTION.height;
      return G = W.attributes && W.attributes.BANDWIDTH, G = G || M.Number.MAX_VALUE, {
        bandwidth: G,
        width: Y,
        height: re,
        playlist: W
      };
    });
    ga(l, function(W, G) {
      return W.bandwidth - G.bandwidth;
    }), l = l.filter(function(W) {
      return !hi.isIncompatible(W.playlist);
    });
    var d = l.filter(function(W) {
      return hi.isEnabled(W.playlist);
    });
    d.length || (d = l.filter(function(W) {
      return !hi.isDisabled(W.playlist);
    }));
    var h = d.filter(function(W) {
      return W.bandwidth * Bt.BANDWIDTH_VARIANCE < r;
    }), f = h[h.length - 1], v = h.filter(function(W) {
      return W.bandwidth === f.bandwidth;
    })[0];
    if (a === !1) {
      var b = v || d[0] || l[0];
      if (b && b.playlist) {
        var _ = "sortedPlaylistReps";
        return v && (_ = "bandwidthBestRep"), d[0] && (_ = "enabledPlaylistReps"), Po("choosing " + dg(b) + " using " + _ + " with options", o), b.playlist;
      }
      return Po("could not choose a playlist with options", o), null;
    }
    var y = h.filter(function(W) {
      return W.width && W.height;
    });
    ga(y, function(W, G) {
      return W.width - G.width;
    });
    var E = y.filter(function(W) {
      return W.width === n && W.height === i;
    });
    f = E[E.length - 1];
    var R = E.filter(function(W) {
      return W.bandwidth === f.bandwidth;
    })[0], D, C, w;
    R || (D = y.filter(function(W) {
      return W.width > n || W.height > i;
    }), C = D.filter(function(W) {
      return W.width === D[0].width && W.height === D[0].height;
    }), f = C[C.length - 1], w = C.filter(function(W) {
      return W.bandwidth === f.bandwidth;
    })[0]);
    var k;
    if (s.experimentalLeastPixelDiffSelector) {
      var I = y.map(function(W) {
        return W.pixelDiff = Math.abs(W.width - n) + Math.abs(W.height - i), W;
      });
      ga(I, function(W, G) {
        return W.pixelDiff === G.pixelDiff ? G.bandwidth - W.bandwidth : W.pixelDiff - G.pixelDiff;
      }), k = I[0];
    }
    var U = k || w || R || v || d[0] || l[0];
    if (U && U.playlist) {
      var $ = "sortedPlaylistReps";
      return k ? $ = "leastPixelDiffRep" : w ? $ = "resolutionPlusOneRep" : R ? $ = "resolutionBestRep" : v ? $ = "bandwidthBestRep" : d[0] && ($ = "enabledPlaylistReps"), Po("choosing " + dg(U) + " using " + $ + " with options", o), U.playlist;
    }
    return Po("could not choose a playlist with options", o), null;
  }
}, cg = function() {
  var e = this.useDevicePixelRatio && M.devicePixelRatio || 1;
  return Y0(this.playlists.master, this.systemBandwidth, parseInt(_u(this.tech_.el(), "width"), 10) * e, parseInt(_u(this.tech_.el(), "height"), 10) * e, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
}, aA = function(e) {
  var r = -1, n = -1;
  if (e < 0 || e > 1)
    throw new Error("Moving average bandwidth decay must be between 0 and 1.");
  return function() {
    var i = this.useDevicePixelRatio && M.devicePixelRatio || 1;
    return r < 0 && (r = this.systemBandwidth, n = this.systemBandwidth), this.systemBandwidth > 0 && this.systemBandwidth !== n && (r = e * this.systemBandwidth + (1 - e) * r, n = this.systemBandwidth), Y0(this.playlists.master, r, parseInt(_u(this.tech_.el(), "width"), 10) * i, parseInt(_u(this.tech_.el(), "height"), 10) * i, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
  };
}, sA = function(e) {
  var r = e.master, n = e.currentTime, i = e.bandwidth, a = e.duration, s = e.segmentDuration, o = e.timeUntilRebuffer, u = e.currentTimeline, l = e.syncController, d = r.playlists.filter(function(_) {
    return !hi.isIncompatible(_);
  }), h = d.filter(hi.isEnabled);
  h.length || (h = d.filter(function(_) {
    return !hi.isDisabled(_);
  }));
  var f = h.filter(hi.hasAttribute.bind(null, "BANDWIDTH")), v = f.map(function(_) {
    var y = l.getSyncPoint(_, a, u, n), E = y ? 1 : 2, R = hi.estimateSegmentRequestTime(s, i, _), D = R * E - o;
    return {
      playlist: _,
      rebufferingImpact: D
    };
  }), b = v.filter(function(_) {
    return _.rebufferingImpact <= 0;
  });
  return ga(b, function(_, y) {
    return sf(y.playlist, _.playlist);
  }), b.length ? b[0] : (ga(v, function(_, y) {
    return _.rebufferingImpact - y.rebufferingImpact;
  }), v[0] || null);
}, oA = function() {
  var e = this, r = this.playlists.master.playlists.filter(hi.isEnabled);
  ga(r, function(i, a) {
    return sf(i, a);
  });
  var n = r.filter(function(i) {
    return !!Ss(e.playlists.master, i).video;
  });
  return n[0] || null;
}, uA = function(e) {
  var r = 0, n;
  return e.bytes && (n = new Uint8Array(e.bytes), e.segments.forEach(function(i) {
    n.set(i, r), r += i.byteLength;
  })), n;
}, lA = function(e, r, n) {
  if (!e[n]) {
    r.trigger({
      type: "usage",
      name: "vhs-608"
    }), r.trigger({
      type: "usage",
      name: "hls-608"
    });
    var i = n;
    /^cc708_/.test(n) && (i = "SERVICE" + n.split("_")[1]);
    var a = r.textTracks().getTrackById(i);
    if (a)
      e[n] = a;
    else {
      var s = r.options_.vhs && r.options_.vhs.captionServices || {}, o = n, u = n, l = !1, d = s[i];
      d && (o = d.label, u = d.language, l = d.default), e[n] = r.addRemoteTextTrack({
        kind: "captions",
        id: i,
        // TODO: investigate why this doesn't seem to turn the caption on by default
        default: l,
        label: o,
        language: u
      }, !1).track;
    }
  }
}, dA = function(e) {
  var r = e.inbandTextTracks, n = e.captionArray, i = e.timestampOffset;
  if (n) {
    var a = M.WebKitDataCue || M.VTTCue;
    n.forEach(function(s) {
      var o = s.stream;
      r[o].addCue(new a(s.startTime + i, s.endTime + i, s.text));
    });
  }
}, cA = function(e) {
  Object.defineProperties(e.frame, {
    id: {
      get: function() {
        return P.log.warn("cue.frame.id is deprecated. Use cue.value.key instead."), e.value.key;
      }
    },
    value: {
      get: function() {
        return P.log.warn("cue.frame.value is deprecated. Use cue.value.data instead."), e.value.data;
      }
    },
    privateData: {
      get: function() {
        return P.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead."), e.value.data;
      }
    }
  });
}, hA = function(e) {
  var r = e.inbandTextTracks, n = e.metadataArray, i = e.timestampOffset, a = e.videoDuration;
  if (n) {
    var s = M.WebKitDataCue || M.VTTCue, o = r.metadataTrack_;
    if (o && (n.forEach(function(v) {
      var b = v.cueTime + i;
      typeof b != "number" || M.isNaN(b) || b < 0 || !(b < 1 / 0) || v.frames.forEach(function(_) {
        var y = new s(b, b, _.value || _.url || _.data || "");
        y.frame = _, y.value = _, cA(y), o.addCue(y);
      });
    }), !(!o.cues || !o.cues.length))) {
      for (var u = o.cues, l = [], d = 0; d < u.length; d++)
        u[d] && l.push(u[d]);
      var h = l.reduce(function(v, b) {
        var _ = v[b.startTime] || [];
        return _.push(b), v[b.startTime] = _, v;
      }, {}), f = Object.keys(h).sort(function(v, b) {
        return Number(v) - Number(b);
      });
      f.forEach(function(v, b) {
        var _ = h[v], y = Number(f[b + 1]) || a;
        _.forEach(function(E) {
          E.endTime = y;
        });
      });
    }
  }
}, fA = function(e, r, n) {
  e.metadataTrack_ || (e.metadataTrack_ = n.addRemoteTextTrack({
    kind: "metadata",
    label: "Timed Metadata"
  }, !1).track, e.metadataTrack_.inBandMetadataTrackDispatchType = r);
}, ps = function(e, r, n) {
  var i, a;
  if (n && n.cues)
    for (i = n.cues.length; i--; )
      a = n.cues[i], a.startTime >= e && a.endTime <= r && n.removeCue(a);
}, pA = function(e) {
  var r = e.cues;
  if (r)
    for (var n = 0; n < r.length; n++) {
      for (var i = [], a = 0, s = 0; s < r.length; s++)
        r[n].startTime === r[s].startTime && r[n].endTime === r[s].endTime && r[n].text === r[s].text && (a++, a > 1 && i.push(r[s]));
      i.length && i.forEach(function(o) {
        return e.removeCue(o);
      });
    }
}, gA = function(e, r, n) {
  if (typeof r > "u" || r === null || !e.length)
    return [];
  var i = Math.ceil((r - n + 3) * nu.ONE_SECOND_IN_TS), a;
  for (a = 0; a < e.length && !(e[a].pts > i); a++)
    ;
  return e.slice(a);
}, mA = function(e, r, n) {
  if (!r.length)
    return e;
  if (n)
    return r.slice();
  var i = r[0].pts, a = 0;
  for (a; a < e.length && !(e[a].pts >= i); a++)
    ;
  return e.slice(0, a).concat(r);
}, vA = function(e, r, n, i) {
  for (var a = Math.ceil((r - i) * nu.ONE_SECOND_IN_TS), s = Math.ceil((n - i) * nu.ONE_SECOND_IN_TS), o = e.slice(), u = e.length; u-- && !(e[u].pts <= s); )
    ;
  if (u === -1)
    return o;
  for (var l = u + 1; l-- && !(e[l].pts <= a); )
    ;
  return l = Math.max(l, 0), o.splice(l, u - l + 1), o;
}, yA = function(e, r) {
  if (!e && !r || !e && r || e && !r)
    return !1;
  if (e === r)
    return !0;
  var n = Object.keys(e).sort(), i = Object.keys(r).sort();
  if (n.length !== i.length)
    return !1;
  for (var a = 0; a < n.length; a++) {
    var s = n[a];
    if (s !== i[a] || e[s] !== r[s])
      return !1;
  }
  return !0;
}, Q0 = 22, _A = function(e, r, n) {
  r = r || [];
  for (var i = [], a = 0, s = 0; s < r.length; s++) {
    var o = r[s];
    if (e === o.timeline && (i.push(s), a += o.duration, a > n))
      return s;
  }
  return i.length === 0 ? 0 : i[i.length - 1];
}, as = 1, TA = 500, hg = function(e) {
  return typeof e == "number" && isFinite(e);
}, ko = 1 / 60, bA = function(e, r, n) {
  return e !== "main" || !r || !n ? null : !n.hasAudio && !n.hasVideo ? "Neither audio nor video found in segment." : r.hasVideo && !n.hasVideo ? "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest." : !r.hasVideo && n.hasVideo ? "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest." : null;
}, SA = function(e, r, n) {
  var i = r - Bt.BACK_BUFFER_LENGTH;
  e.length && (i = Math.max(i, e.start(0)));
  var a = r - n;
  return Math.min(a, i);
}, ea = function(e) {
  var r = e.startOfSegment, n = e.duration, i = e.segment, a = e.part, s = e.playlist, o = s.mediaSequence, u = s.id, l = s.segments, d = l === void 0 ? [] : l, h = e.mediaIndex, f = e.partIndex, v = e.timeline, b = d.length - 1, _ = "mediaIndex/partIndex increment";
  e.getMediaInfoForTime ? _ = "getMediaInfoForTime (" + e.getMediaInfoForTime + ")" : e.isSyncRequest && (_ = "getSyncSegmentCandidate (isSyncRequest)"), e.independent && (_ += " with independent " + e.independent);
  var y = typeof f == "number", E = e.segment.uri ? "segment" : "pre-segment", R = y ? _0({
    preloadSegment: i
  }) - 1 : 0;
  return E + " [" + (o + h) + "/" + (o + b) + "]" + (y ? " part [" + f + "/" + R + "]" : "") + (" segment start/end [" + i.start + " => " + i.end + "]") + (y ? " part start/end [" + a.start + " => " + a.end + "]" : "") + (" startOfSegment [" + r + "]") + (" duration [" + n + "]") + (" timeline [" + v + "]") + (" selected by [" + _ + "]") + (" playlist [" + u + "]");
}, fg = function(e) {
  return e + "TimingInfo";
}, EA = function(e) {
  var r = e.segmentTimeline, n = e.currentTimeline, i = e.startOfSegment, a = e.buffered, s = e.overrideCheck;
  return !s && r === n ? null : r < n ? i : a.length ? a.end(a.length - 1) : i;
}, pg = function(e) {
  var r = e.timelineChangeController, n = e.currentTimeline, i = e.segmentTimeline, a = e.loaderType, s = e.audioDisabled;
  if (n === i)
    return !1;
  if (a === "audio") {
    var o = r.lastTimelineChange({
      type: "main"
    });
    return !o || o.to !== i;
  }
  if (a === "main" && s) {
    var u = r.pendingTimelineChange({
      type: "audio"
    });
    return !(u && u.to === i);
  }
  return !1;
}, xA = function(e) {
  var r = 0;
  return ["video", "audio"].forEach(function(n) {
    var i = e[n + "TimingInfo"];
    if (i) {
      var a = i.start, s = i.end, o;
      typeof a == "bigint" || typeof s == "bigint" ? o = M.BigInt(s) - M.BigInt(a) : typeof a == "number" && typeof s == "number" && (o = s - a), typeof o < "u" && o > r && (r = o);
    }
  }), typeof r == "bigint" && r < Number.MAX_SAFE_INTEGER && (r = Number(r)), r;
}, gg = function(e) {
  var r = e.segmentDuration, n = e.maxDuration;
  return r ? Math.round(r) > n + Xr : !1;
}, CA = function(e, r) {
  if (r !== "hls")
    return null;
  var n = xA({
    audioTimingInfo: e.audioTimingInfo,
    videoTimingInfo: e.videoTimingInfo
  });
  if (!n)
    return null;
  var i = e.playlist.targetDuration, a = gg({
    segmentDuration: n,
    maxDuration: i * 2
  }), s = gg({
    segmentDuration: n,
    maxDuration: i
  }), o = "Segment with index " + e.mediaIndex + " " + ("from playlist " + e.playlist.id + " ") + ("has a duration of " + n + " ") + ("when the reported duration is " + e.duration + " ") + ("and the target duration is " + i + ". ") + "For HLS content, a duration in excess of the target duration may result in playback issues. See the HLS specification section on EXT-X-TARGETDURATION for more details: https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1";
  return a || s ? {
    severity: a ? "warn" : "info",
    message: o
  } : null;
}, Dc = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    if (a = t.call(this) || this, !n)
      throw new TypeError("Initialization settings are required");
    if (typeof n.currentTime != "function")
      throw new TypeError("No currentTime getter specified");
    if (!n.mediaSource)
      throw new TypeError("No MediaSource specified");
    return a.bandwidth = n.bandwidth, a.throughput = {
      rate: 0,
      count: 0
    }, a.roundTrip = NaN, a.resetStats_(), a.mediaIndex = null, a.partIndex = null, a.hasPlayed_ = n.hasPlayed, a.currentTime_ = n.currentTime, a.seekable_ = n.seekable, a.seeking_ = n.seeking, a.duration_ = n.duration, a.mediaSource_ = n.mediaSource, a.vhs_ = n.vhs, a.loaderType_ = n.loaderType, a.currentMediaInfo_ = void 0, a.startingMediaInfo_ = void 0, a.segmentMetadataTrack_ = n.segmentMetadataTrack, a.goalBufferLength_ = n.goalBufferLength, a.sourceType_ = n.sourceType, a.sourceUpdater_ = n.sourceUpdater, a.inbandTextTracks_ = n.inbandTextTracks, a.state_ = "INIT", a.timelineChangeController_ = n.timelineChangeController, a.shouldSaveSegmentTimingInfo_ = !0, a.parse708captions_ = n.parse708captions, a.useDtsForTimestampOffset_ = n.useDtsForTimestampOffset, a.captionServices_ = n.captionServices, a.experimentalExactManifestTimings = n.experimentalExactManifestTimings, a.checkBufferTimeout_ = null, a.error_ = void 0, a.currentTimeline_ = -1, a.pendingSegment_ = null, a.xhrOptions_ = null, a.pendingSegments_ = [], a.audioDisabled_ = !1, a.isPendingTimestampOffset_ = !1, a.gopBuffer_ = [], a.timeMapping_ = 0, a.safeAppend_ = P.browser.IE_VERSION >= 11, a.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, a.playlistOfLastInitSegment_ = {
      audio: null,
      video: null
    }, a.callQueue_ = [], a.loadQueue_ = [], a.metadataQueue_ = {
      id3: [],
      caption: []
    }, a.waitingOnRemove_ = !1, a.quotaExceededErrorRetryTimeout_ = null, a.activeInitSegmentId_ = null, a.initSegments_ = {}, a.cacheEncryptionKeys_ = n.cacheEncryptionKeys, a.keyCache_ = {}, a.decrypter_ = n.decrypter, a.syncController_ = n.syncController, a.syncPoint_ = {
      segmentIndex: 0,
      time: 0
    }, a.transmuxer_ = a.createTransmuxer_(), a.triggerSyncInfoUpdate_ = function() {
      return a.trigger("syncinfoupdate");
    }, a.syncController_.on("syncinfoupdate", a.triggerSyncInfoUpdate_), a.mediaSource_.addEventListener("sourceopen", function() {
      a.isEndOfStream_() || (a.ended_ = !1);
    }), a.fetchAtBuffer_ = !1, a.logger_ = Hi("SegmentLoader[" + a.loaderType_ + "]"), Object.defineProperty(Le(a), "state", {
      get: function() {
        return this.state_;
      },
      set: function(o) {
        o !== this.state_ && (this.logger_(this.state_ + " -> " + o), this.state_ = o, this.trigger("statechange"));
      }
    }), a.sourceUpdater_.on("ready", function() {
      a.hasEnoughInfoToAppend_() && a.processCallQueue_();
    }), a.loaderType_ === "main" && a.timelineChangeController_.on("pendingtimelinechange", function() {
      a.hasEnoughInfoToAppend_() && a.processCallQueue_();
    }), a.loaderType_ === "audio" && a.timelineChangeController_.on("timelinechange", function() {
      a.hasEnoughInfoToLoad_() && a.processLoadQueue_(), a.hasEnoughInfoToAppend_() && a.processCallQueue_();
    }), a;
  }
  var r = e.prototype;
  return r.createTransmuxer_ = function() {
    return Gl.createTransmuxer({
      remux: !1,
      alignGopsAtEnd: this.safeAppend_,
      keepOriginalTimestamps: !0,
      parse708captions: this.parse708captions_,
      captionServices: this.captionServices_
    });
  }, r.resetStats_ = function() {
    this.mediaBytesTransferred = 0, this.mediaRequests = 0, this.mediaRequestsAborted = 0, this.mediaRequestsTimedout = 0, this.mediaRequestsErrored = 0, this.mediaTransferDuration = 0, this.mediaSecondsLoaded = 0, this.mediaAppends = 0;
  }, r.dispose = function() {
    this.trigger("dispose"), this.state = "DISPOSED", this.pause(), this.abort_(), this.transmuxer_ && this.transmuxer_.terminate(), this.resetStats_(), this.checkBufferTimeout_ && M.clearTimeout(this.checkBufferTimeout_), this.syncController_ && this.triggerSyncInfoUpdate_ && this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_), this.off();
  }, r.setAudio = function(i) {
    this.audioDisabled_ = !i, i ? this.appendInitSegment_.audio = !0 : this.sourceUpdater_.removeAudio(0, this.duration_());
  }, r.abort = function() {
    if (this.state !== "WAITING") {
      this.pendingSegment_ && (this.pendingSegment_ = null);
      return;
    }
    this.abort_(), this.state = "READY", this.paused() || this.monitorBuffer_();
  }, r.abort_ = function() {
    this.pendingSegment_ && this.pendingSegment_.abortRequests && this.pendingSegment_.abortRequests(), this.pendingSegment_ = null, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_), this.waitingOnRemove_ = !1, M.clearTimeout(this.quotaExceededErrorRetryTimeout_), this.quotaExceededErrorRetryTimeout_ = null;
  }, r.checkForAbort_ = function(i) {
    return this.state === "APPENDING" && !this.pendingSegment_ ? (this.state = "READY", !0) : !this.pendingSegment_ || this.pendingSegment_.requestId !== i;
  }, r.error = function(i) {
    return typeof i < "u" && (this.logger_("error occurred:", i), this.error_ = i), this.pendingSegment_ = null, this.error_;
  }, r.endOfStream = function() {
    this.ended_ = !0, this.transmuxer_ && Gl.reset(this.transmuxer_), this.gopBuffer_.length = 0, this.pause(), this.trigger("ended");
  }, r.buffered_ = function() {
    var i = this.getMediaInfo_();
    if (!this.sourceUpdater_ || !i)
      return P.createTimeRanges();
    if (this.loaderType_ === "main") {
      var a = i.hasAudio, s = i.hasVideo, o = i.isMuxed;
      if (s && a && !this.audioDisabled_ && !o)
        return this.sourceUpdater_.buffered();
      if (s)
        return this.sourceUpdater_.videoBuffered();
    }
    return this.sourceUpdater_.audioBuffered();
  }, r.initSegmentForMap = function(i, a) {
    if (a === void 0 && (a = !1), !i)
      return null;
    var s = mu(i), o = this.initSegments_[s];
    return a && !o && i.bytes && (this.initSegments_[s] = o = {
      resolvedUri: i.resolvedUri,
      byterange: i.byterange,
      bytes: i.bytes,
      tracks: i.tracks,
      timescales: i.timescales
    }), o || i;
  }, r.segmentKey = function(i, a) {
    if (a === void 0 && (a = !1), !i)
      return null;
    var s = O0(i), o = this.keyCache_[s];
    this.cacheEncryptionKeys_ && a && !o && i.bytes && (this.keyCache_[s] = o = {
      resolvedUri: i.resolvedUri,
      bytes: i.bytes
    });
    var u = {
      resolvedUri: (o || i).resolvedUri
    };
    return o && (u.bytes = o.bytes), u;
  }, r.couldBeginLoading_ = function() {
    return this.playlist_ && !this.paused();
  }, r.load = function() {
    if (this.monitorBuffer_(), !!this.playlist_) {
      if (this.state === "INIT" && this.couldBeginLoading_())
        return this.init_();
      !this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT" || (this.state = "READY");
    }
  }, r.init_ = function() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }, r.playlist = function(i, a) {
    if (a === void 0 && (a = {}), !!i) {
      var s = this.playlist_, o = this.pendingSegment_;
      this.playlist_ = i, this.xhrOptions_ = a, this.state === "INIT" && (i.syncInfo = {
        mediaSequence: i.mediaSequence,
        time: 0
      }, this.loaderType_ === "main" && this.syncController_.setDateTimeMappingForStart(i));
      var u = null;
      if (s && (s.id ? u = s.id : s.uri && (u = s.uri)), this.logger_("playlist update [" + u + " => " + (i.id || i.uri) + "]"), this.trigger("syncinfoupdate"), this.state === "INIT" && this.couldBeginLoading_())
        return this.init_();
      if (!s || s.uri !== i.uri) {
        this.mediaIndex !== null && (i.endList ? this.resyncLoader() : this.resetLoader()), this.currentMediaInfo_ = void 0, this.trigger("playlistupdate");
        return;
      }
      var l = i.mediaSequence - s.mediaSequence;
      if (this.logger_("live window shift [" + l + "]"), this.mediaIndex !== null)
        if (this.mediaIndex -= l, this.mediaIndex < 0)
          this.mediaIndex = null, this.partIndex = null;
        else {
          var d = this.playlist_.segments[this.mediaIndex];
          if (this.partIndex && (!d.parts || !d.parts.length || !d.parts[this.partIndex])) {
            var h = this.mediaIndex;
            this.logger_("currently processing part (index " + this.partIndex + ") no longer exists."), this.resetLoader(), this.mediaIndex = h;
          }
        }
      o && (o.mediaIndex -= l, o.mediaIndex < 0 ? (o.mediaIndex = null, o.partIndex = null) : (o.mediaIndex >= 0 && (o.segment = i.segments[o.mediaIndex]), o.partIndex >= 0 && o.segment.parts && (o.part = o.segment.parts[o.partIndex]))), this.syncController_.saveExpiredSegmentInfo(s, i);
    }
  }, r.pause = function() {
    this.checkBufferTimeout_ && (M.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = null);
  }, r.paused = function() {
    return this.checkBufferTimeout_ === null;
  }, r.resetEverything = function(i) {
    this.ended_ = !1, this.activeInitSegmentId_ = null, this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.resetLoader(), this.remove(0, 1 / 0, i), this.transmuxer_ && (this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), this.transmuxer_.postMessage({
      action: "reset"
    }));
  }, r.resetLoader = function() {
    this.fetchAtBuffer_ = !1, this.resyncLoader();
  }, r.resyncLoader = function() {
    this.transmuxer_ && Gl.reset(this.transmuxer_), this.mediaIndex = null, this.partIndex = null, this.syncPoint_ = null, this.isPendingTimestampOffset_ = !1, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.abort(), this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearParsedMp4Captions"
    });
  }, r.remove = function(i, a, s, o) {
    if (s === void 0 && (s = function() {
    }), o === void 0 && (o = !1), a === 1 / 0 && (a = this.duration_()), a <= i) {
      this.logger_("skipping remove because end ${end} is <= start ${start}");
      return;
    }
    if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
      this.logger_("skipping remove because no source updater or starting media info");
      return;
    }
    var u = 1, l = function() {
      u--, u === 0 && s();
    };
    (o || !this.audioDisabled_) && (u++, this.sourceUpdater_.removeAudio(i, a, l)), (o || this.loaderType_ === "main") && (this.gopBuffer_ = vA(this.gopBuffer_, i, a, this.timeMapping_), u++, this.sourceUpdater_.removeVideo(i, a, l));
    for (var d in this.inbandTextTracks_)
      ps(i, a, this.inbandTextTracks_[d]);
    ps(i, a, this.segmentMetadataTrack_), l();
  }, r.monitorBuffer_ = function() {
    this.checkBufferTimeout_ && M.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = M.setTimeout(this.monitorBufferTick_.bind(this), 1);
  }, r.monitorBufferTick_ = function() {
    this.state === "READY" && this.fillBuffer_(), this.checkBufferTimeout_ && M.clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = M.setTimeout(this.monitorBufferTick_.bind(this), TA);
  }, r.fillBuffer_ = function() {
    if (!this.sourceUpdater_.updating()) {
      var i = this.chooseNextRequest_();
      i && (typeof i.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !1, this.timelineChangeController_.pendingTimelineChange({
        type: this.loaderType_,
        from: this.currentTimeline_,
        to: i.timeline
      })), this.loadSegment_(i));
    }
  }, r.isEndOfStream_ = function(i, a, s) {
    if (i === void 0 && (i = this.mediaIndex), a === void 0 && (a = this.playlist_), s === void 0 && (s = this.partIndex), !a || !this.mediaSource_)
      return !1;
    var o = typeof i == "number" && a.segments[i], u = i + 1 === a.segments.length, l = !o || !o.parts || s + 1 === o.parts.length;
    return a.endList && this.mediaSource_.readyState === "open" && u && l;
  }, r.chooseNextRequest_ = function() {
    var i = this.buffered_(), a = ig(i) || 0, s = Zh(i, this.currentTime_()), o = !this.hasPlayed_() && s >= 1, u = s >= this.goalBufferLength_(), l = this.playlist_.segments;
    if (!l.length || o || u)
      return null;
    this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_());
    var d = {
      partIndex: null,
      mediaIndex: null,
      startOfSegment: null,
      playlist: this.playlist_,
      isSyncRequest: !this.syncPoint_
    };
    if (d.isSyncRequest)
      d.mediaIndex = _A(this.currentTimeline_, l, a);
    else if (this.mediaIndex !== null) {
      var h = l[this.mediaIndex], f = typeof this.partIndex == "number" ? this.partIndex : -1;
      d.startOfSegment = h.end ? h.end : a, h.parts && h.parts[f + 1] ? (d.mediaIndex = this.mediaIndex, d.partIndex = f + 1) : d.mediaIndex = this.mediaIndex + 1;
    } else {
      var v = hi.getMediaInfoForTime({
        experimentalExactManifestTimings: this.experimentalExactManifestTimings,
        playlist: this.playlist_,
        currentTime: this.fetchAtBuffer_ ? a : this.currentTime_(),
        startingPartIndex: this.syncPoint_.partIndex,
        startingSegmentIndex: this.syncPoint_.segmentIndex,
        startTime: this.syncPoint_.time
      }), b = v.segmentIndex, _ = v.startTime, y = v.partIndex;
      d.getMediaInfoForTime = this.fetchAtBuffer_ ? "bufferedEnd " + a : "currentTime " + this.currentTime_(), d.mediaIndex = b, d.startOfSegment = _, d.partIndex = y;
    }
    var E = l[d.mediaIndex], R = E && typeof d.partIndex == "number" && E.parts && E.parts[d.partIndex];
    if (!E || typeof d.partIndex == "number" && !R)
      return null;
    if (typeof d.partIndex != "number" && E.parts && (d.partIndex = 0, R = E.parts[0]), !s && R && !R.independent)
      if (d.partIndex === 0) {
        var D = l[d.mediaIndex - 1], C = D.parts && D.parts.length && D.parts[D.parts.length - 1];
        C && C.independent && (d.mediaIndex -= 1, d.partIndex = D.parts.length - 1, d.independent = "previous segment");
      } else
        E.parts[d.partIndex - 1].independent && (d.partIndex -= 1, d.independent = "previous part");
    var w = this.mediaSource_ && this.mediaSource_.readyState === "ended";
    return d.mediaIndex >= l.length - 1 && w && !this.seeking_() ? null : this.generateSegmentInfo_(d);
  }, r.generateSegmentInfo_ = function(i) {
    var a = i.independent, s = i.playlist, o = i.mediaIndex, u = i.startOfSegment, l = i.isSyncRequest, d = i.partIndex, h = i.forceTimestampOffset, f = i.getMediaInfoForTime, v = s.segments[o], b = typeof d == "number" && v.parts[d], _ = {
      requestId: "segment-loader-" + Math.random(),
      // resolve the segment URL relative to the playlist
      uri: b && b.resolvedUri || v.resolvedUri,
      // the segment's mediaIndex at the time it was requested
      mediaIndex: o,
      partIndex: b ? d : null,
      // whether or not to update the SegmentLoader's state with this
      // segment's mediaIndex
      isSyncRequest: l,
      startOfSegment: u,
      // the segment's playlist
      playlist: s,
      // unencrypted bytes of the segment
      bytes: null,
      // when a key is defined for this segment, the encrypted bytes
      encryptedBytes: null,
      // The target timestampOffset for this segment when we append it
      // to the source buffer
      timestampOffset: null,
      // The timeline that the segment is in
      timeline: v.timeline,
      // The expected duration of the segment in seconds
      duration: b && b.duration || v.duration,
      // retain the segment in case the playlist updates while doing an async process
      segment: v,
      part: b,
      byteLength: 0,
      transmuxer: this.transmuxer_,
      // type of getMediaInfoForTime that was used to get this segment
      getMediaInfoForTime: f,
      independent: a
    }, y = typeof h < "u" ? h : this.isPendingTimestampOffset_;
    _.timestampOffset = this.timestampOffsetForSegment_({
      segmentTimeline: v.timeline,
      currentTimeline: this.currentTimeline_,
      startOfSegment: u,
      buffered: this.buffered_(),
      overrideCheck: y
    });
    var E = ig(this.sourceUpdater_.audioBuffered());
    return typeof E == "number" && (_.audioAppendStart = E - this.sourceUpdater_.audioTimestampOffset()), this.sourceUpdater_.videoBuffered().length && (_.gopsToAlignWith = gA(
      this.gopBuffer_,
      // since the transmuxer is using the actual timing values, but the time is
      // adjusted by the timestmap offset, we must adjust the value here
      this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(),
      this.timeMapping_
    )), _;
  }, r.timestampOffsetForSegment_ = function(i) {
    return EA(i);
  }, r.earlyAbortWhenNeeded_ = function(i) {
    if (!(this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
    // TODO: Replace using timeout with a boolean indicating whether this playlist is
    //       the lowestEnabledRendition.
    !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
    !this.playlist_.attributes.BANDWIDTH) && !(Date.now() - (i.firstBytesReceivedAt || Date.now()) < 1e3)) {
      var a = this.currentTime_(), s = i.bandwidth, o = this.pendingSegment_.duration, u = hi.estimateSegmentRequestTime(o, s, this.playlist_, i.bytesReceived), l = zC(this.buffered_(), a, this.vhs_.tech_.playbackRate()) - 1;
      if (!(u <= l)) {
        var d = sA({
          master: this.vhs_.playlists.master,
          currentTime: a,
          bandwidth: s,
          duration: this.duration_(),
          segmentDuration: o,
          timeUntilRebuffer: l,
          currentTimeline: this.currentTimeline_,
          syncController: this.syncController_
        });
        if (d) {
          var h = u - l, f = h - d.rebufferingImpact, v = 0.5;
          l <= Xr && (v = 1), !(!d.playlist || d.playlist.uri === this.playlist_.uri || f < v) && (this.bandwidth = d.playlist.attributes.BANDWIDTH * Bt.BANDWIDTH_VARIANCE + 1, this.trigger("earlyabort"));
        }
      }
    }
  }, r.handleAbort_ = function(i) {
    this.logger_("Aborting " + ea(i)), this.mediaRequestsAborted += 1;
  }, r.handleProgress_ = function(i, a) {
    this.earlyAbortWhenNeeded_(a.stats), !this.checkForAbort_(a.requestId) && this.trigger("progress");
  }, r.handleTrackInfo_ = function(i, a) {
    this.earlyAbortWhenNeeded_(i.stats), !this.checkForAbort_(i.requestId) && (this.checkForIllegalMediaSwitch(a) || (a = a || {}, yA(this.currentMediaInfo_, a) || (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }, this.startingMediaInfo_ = a, this.currentMediaInfo_ = a, this.logger_("trackinfo update", a), this.trigger("trackinfo")), !this.checkForAbort_(i.requestId) && (this.pendingSegment_.trackInfo = a, this.hasEnoughInfoToAppend_() && this.processCallQueue_())));
  }, r.handleTimingInfo_ = function(i, a, s, o) {
    if (this.earlyAbortWhenNeeded_(i.stats), !this.checkForAbort_(i.requestId)) {
      var u = this.pendingSegment_, l = fg(a);
      u[l] = u[l] || {}, u[l][s] = o, this.logger_("timinginfo: " + a + " - " + s + " - " + o), this.hasEnoughInfoToAppend_() && this.processCallQueue_();
    }
  }, r.handleCaptions_ = function(i, a) {
    var s = this;
    if (this.earlyAbortWhenNeeded_(i.stats), !this.checkForAbort_(i.requestId)) {
      if (a.length === 0) {
        this.logger_("SegmentLoader received no captions from a caption event");
        return;
      }
      var o = this.pendingSegment_;
      if (!o.hasAppendedData_) {
        this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, i, a));
        return;
      }
      var u = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(), l = {};
      a.forEach(function(d) {
        l[d.stream] = l[d.stream] || {
          // Infinity, as any other value will be less than this
          startTime: 1 / 0,
          captions: [],
          // 0 as an other value will be more than this
          endTime: 0
        };
        var h = l[d.stream];
        h.startTime = Math.min(h.startTime, d.startTime + u), h.endTime = Math.max(h.endTime, d.endTime + u), h.captions.push(d);
      }), Object.keys(l).forEach(function(d) {
        var h = l[d], f = h.startTime, v = h.endTime, b = h.captions, _ = s.inbandTextTracks_;
        s.logger_("adding cues from " + f + " -> " + v + " for " + d), lA(_, s.vhs_.tech_, d), ps(f, v, _[d]), dA({
          captionArray: b,
          inbandTextTracks: _,
          timestampOffset: u
        });
      }), this.transmuxer_ && this.transmuxer_.postMessage({
        action: "clearParsedMp4Captions"
      });
    }
  }, r.handleId3_ = function(i, a, s) {
    if (this.earlyAbortWhenNeeded_(i.stats), !this.checkForAbort_(i.requestId)) {
      var o = this.pendingSegment_;
      if (!o.hasAppendedData_) {
        this.metadataQueue_.id3.push(this.handleId3_.bind(this, i, a, s));
        return;
      }
      var u = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
      fA(this.inbandTextTracks_, s, this.vhs_.tech_), hA({
        inbandTextTracks: this.inbandTextTracks_,
        metadataArray: a,
        timestampOffset: u,
        videoDuration: this.duration_()
      });
    }
  }, r.processMetadataQueue_ = function() {
    this.metadataQueue_.id3.forEach(function(i) {
      return i();
    }), this.metadataQueue_.caption.forEach(function(i) {
      return i();
    }), this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [];
  }, r.processCallQueue_ = function() {
    var i = this.callQueue_;
    this.callQueue_ = [], i.forEach(function(a) {
      return a();
    });
  }, r.processLoadQueue_ = function() {
    var i = this.loadQueue_;
    this.loadQueue_ = [], i.forEach(function(a) {
      return a();
    });
  }, r.hasEnoughInfoToLoad_ = function() {
    if (this.loaderType_ !== "audio")
      return !0;
    var i = this.pendingSegment_;
    return i ? this.getCurrentMediaInfo_() ? (
      // Technically, instead of waiting to load a segment on timeline changes, a segment
      // can be requested and downloaded and only wait before it is transmuxed or parsed.
      // But in practice, there are a few reasons why it is better to wait until a loader
      // is ready to append that segment before requesting and downloading:
      //
      // 1. Because audio and main loaders cross discontinuities together, if this loader
      //    is waiting for the other to catch up, then instead of requesting another
      //    segment and using up more bandwidth, by not yet loading, more bandwidth is
      //    allotted to the loader currently behind.
      // 2. media-segment-request doesn't have to have logic to consider whether a segment
      // is ready to be processed or not, isolating the queueing behavior to the loader.
      // 3. The audio loader bases some of its segment properties on timing information
      //    provided by the main loader, meaning that, if the logic for waiting on
      //    processing was in media-segment-request, then it would also need to know how
      //    to re-generate the segment information after the main loader caught up.
      !pg({
        timelineChangeController: this.timelineChangeController_,
        currentTimeline: this.currentTimeline_,
        segmentTimeline: i.timeline,
        loaderType: this.loaderType_,
        audioDisabled: this.audioDisabled_
      })
    ) : !0 : !1;
  }, r.getCurrentMediaInfo_ = function(i) {
    return i === void 0 && (i = this.pendingSegment_), i && i.trackInfo || this.currentMediaInfo_;
  }, r.getMediaInfo_ = function(i) {
    return i === void 0 && (i = this.pendingSegment_), this.getCurrentMediaInfo_(i) || this.startingMediaInfo_;
  }, r.getPendingSegmentPlaylist = function() {
    return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
  }, r.hasEnoughInfoToAppend_ = function() {
    if (!this.sourceUpdater_.ready() || this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_)
      return !1;
    var i = this.pendingSegment_, a = this.getCurrentMediaInfo_();
    if (!i || !a)
      return !1;
    var s = a.hasAudio, o = a.hasVideo, u = a.isMuxed;
    return !(o && !i.videoTimingInfo || s && !this.audioDisabled_ && !u && !i.audioTimingInfo || pg({
      timelineChangeController: this.timelineChangeController_,
      currentTimeline: this.currentTimeline_,
      segmentTimeline: i.timeline,
      loaderType: this.loaderType_,
      audioDisabled: this.audioDisabled_
    }));
  }, r.handleData_ = function(i, a) {
    if (this.earlyAbortWhenNeeded_(i.stats), !this.checkForAbort_(i.requestId)) {
      if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
        this.callQueue_.push(this.handleData_.bind(this, i, a));
        return;
      }
      var s = this.pendingSegment_;
      if (this.setTimeMapping_(s.timeline), this.updateMediaSecondsLoaded_(s.part || s.segment), this.mediaSource_.readyState !== "closed") {
        if (i.map && (i.map = this.initSegmentForMap(i.map, !0), s.segment.map = i.map), i.key && this.segmentKey(i.key, !0), s.isFmp4 = i.isFmp4, s.timingInfo = s.timingInfo || {}, s.isFmp4)
          this.trigger("fmp4"), s.timingInfo.start = s[fg(a.type)].start;
        else {
          var o = this.getCurrentMediaInfo_(), u = this.loaderType_ === "main" && o && o.hasVideo, l;
          u && (l = s.videoTimingInfo.start), s.timingInfo.start = this.trueSegmentStart_({
            currentStart: s.timingInfo.start,
            playlist: s.playlist,
            mediaIndex: s.mediaIndex,
            currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
            useVideoTimingInfo: u,
            firstVideoFrameTimeForData: l,
            videoTimingInfo: s.videoTimingInfo,
            audioTimingInfo: s.audioTimingInfo
          });
        }
        if (this.updateAppendInitSegmentStatus(s, a.type), this.updateSourceBufferTimestampOffset_(s), s.isSyncRequest) {
          this.updateTimingInfoEnd_(s), this.syncController_.saveSegmentTimingInfo({
            segmentInfo: s,
            shouldSaveTimelineMapping: this.loaderType_ === "main"
          });
          var d = this.chooseNextRequest_();
          if (d.mediaIndex !== s.mediaIndex || d.partIndex !== s.partIndex) {
            this.logger_("sync segment was incorrect, not appending");
            return;
          }
          this.logger_("sync segment was correct, appending");
        }
        s.hasAppendedData_ = !0, this.processMetadataQueue_(), this.appendData_(s, a);
      }
    }
  }, r.updateAppendInitSegmentStatus = function(i, a) {
    this.loaderType_ === "main" && typeof i.timestampOffset == "number" && // in the case that we're handling partial data, we don't want to append an init
    // segment for each chunk
    !i.changedTimestampOffset && (this.appendInitSegment_ = {
      audio: !0,
      video: !0
    }), this.playlistOfLastInitSegment_[a] !== i.playlist && (this.appendInitSegment_[a] = !0);
  }, r.getInitSegmentAndUpdateState_ = function(i) {
    var a = i.type, s = i.initSegment, o = i.map, u = i.playlist;
    if (o) {
      var l = mu(o);
      if (this.activeInitSegmentId_ === l)
        return null;
      s = this.initSegmentForMap(o, !0).bytes, this.activeInitSegmentId_ = l;
    }
    return s && this.appendInitSegment_[a] ? (this.playlistOfLastInitSegment_[a] = u, this.appendInitSegment_[a] = !1, this.activeInitSegmentId_ = null, s) : null;
  }, r.handleQuotaExceededError_ = function(i, a) {
    var s = this, o = i.segmentInfo, u = i.type, l = i.bytes, d = this.sourceUpdater_.audioBuffered(), h = this.sourceUpdater_.videoBuffered();
    d.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + vn(d).join(", ")), h.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + vn(h).join(", "));
    var f = d.length ? d.start(0) : 0, v = d.length ? d.end(d.length - 1) : 0, b = h.length ? h.start(0) : 0, _ = h.length ? h.end(h.length - 1) : 0;
    if (v - f <= as && _ - b <= as) {
      this.logger_("On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. " + ("Appended byte length: " + l.byteLength + ", ") + ("audio buffer: " + vn(d).join(", ") + ", ") + ("video buffer: " + vn(h).join(", ") + ", ")), this.error({
        message: "Quota exceeded error with append of a single segment of content",
        excludeUntil: 1 / 0
      }), this.trigger("error");
      return;
    }
    this.waitingOnRemove_ = !0, this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
      segmentInfo: o,
      type: u,
      bytes: l
    }));
    var y = this.currentTime_(), E = y - as;
    this.logger_("On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to " + E), this.remove(0, E, function() {
      s.logger_("On QUOTA_EXCEEDED_ERR, retrying append in " + as + "s"), s.waitingOnRemove_ = !1, s.quotaExceededErrorRetryTimeout_ = M.setTimeout(function() {
        s.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue"), s.quotaExceededErrorRetryTimeout_ = null, s.processCallQueue_();
      }, as * 1e3);
    }, !0);
  }, r.handleAppendError_ = function(i, a) {
    var s = i.segmentInfo, o = i.type, u = i.bytes;
    if (a) {
      if (a.code === Q0) {
        this.handleQuotaExceededError_({
          segmentInfo: s,
          type: o,
          bytes: u
        });
        return;
      }
      this.logger_("Received non QUOTA_EXCEEDED_ERR on append", a), this.error(o + " append of " + u.length + "b failed for segment " + ("#" + s.mediaIndex + " in playlist " + s.playlist.id)), this.trigger("appenderror");
    }
  }, r.appendToSourceBuffer_ = function(i) {
    var a = i.segmentInfo, s = i.type, o = i.initSegment, u = i.data, l = i.bytes;
    if (!l) {
      var d = [u], h = u.byteLength;
      o && (d.unshift(o), h += o.byteLength), l = uA({
        bytes: h,
        segments: d
      });
    }
    this.sourceUpdater_.appendBuffer({
      segmentInfo: a,
      type: s,
      bytes: l
    }, this.handleAppendError_.bind(this, {
      segmentInfo: a,
      type: s,
      bytes: l
    }));
  }, r.handleSegmentTimingInfo_ = function(i, a, s) {
    if (!(!this.pendingSegment_ || a !== this.pendingSegment_.requestId)) {
      var o = this.pendingSegment_.segment, u = i + "TimingInfo";
      o[u] || (o[u] = {}), o[u].transmuxerPrependedSeconds = s.prependedContentDuration || 0, o[u].transmuxedPresentationStart = s.start.presentation, o[u].transmuxedDecodeStart = s.start.decode, o[u].transmuxedPresentationEnd = s.end.presentation, o[u].transmuxedDecodeEnd = s.end.decode, o[u].baseMediaDecodeTime = s.baseMediaDecodeTime;
    }
  }, r.appendData_ = function(i, a) {
    var s = a.type, o = a.data;
    if (!(!o || !o.byteLength) && !(s === "audio" && this.audioDisabled_)) {
      var u = this.getInitSegmentAndUpdateState_({
        type: s,
        initSegment: a.initSegment,
        playlist: i.playlist,
        map: i.isFmp4 ? i.segment.map : null
      });
      this.appendToSourceBuffer_({
        segmentInfo: i,
        type: s,
        initSegment: u,
        data: o
      });
    }
  }, r.loadSegment_ = function(i) {
    var a = this;
    if (this.state = "WAITING", this.pendingSegment_ = i, this.trimBackBuffer_(i), typeof i.timestampOffset == "number" && this.transmuxer_ && this.transmuxer_.postMessage({
      action: "clearAllMp4Captions"
    }), !this.hasEnoughInfoToLoad_()) {
      this.loadQueue_.push(function() {
        var s = Vi({}, i, {
          forceTimestampOffset: !0
        });
        Vi(i, a.generateSegmentInfo_(s)), a.isPendingTimestampOffset_ = !1, a.updateTransmuxerAndRequestSegment_(i);
      });
      return;
    }
    this.updateTransmuxerAndRequestSegment_(i);
  }, r.updateTransmuxerAndRequestSegment_ = function(i) {
    var a = this;
    this.shouldUpdateTransmuxerTimestampOffset_(i.timestampOffset) && (this.gopBuffer_.length = 0, i.gopsToAlignWith = [], this.timeMapping_ = 0, this.transmuxer_.postMessage({
      action: "reset"
    }), this.transmuxer_.postMessage({
      action: "setTimestampOffset",
      timestampOffset: i.timestampOffset
    }));
    var s = this.createSimplifiedSegmentObj_(i), o = this.isEndOfStream_(i.mediaIndex, i.playlist, i.partIndex), u = this.mediaIndex !== null, l = i.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
    // the first timeline
    i.timeline > 0, d = o || u && l;
    this.logger_("Requesting " + ea(i)), s.map && !s.map.bytes && (this.logger_("going to request init segment."), this.appendInitSegment_ = {
      video: !0,
      audio: !0
    }), i.abortRequests = eA({
      xhr: this.vhs_.xhr,
      xhrOptions: this.xhrOptions_,
      decryptionWorker: this.decrypter_,
      segment: s,
      abortFn: this.handleAbort_.bind(this, i),
      progressFn: this.handleProgress_.bind(this),
      trackInfoFn: this.handleTrackInfo_.bind(this),
      timingInfoFn: this.handleTimingInfo_.bind(this),
      videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", i.requestId),
      audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", i.requestId),
      captionsFn: this.handleCaptions_.bind(this),
      isEndOfTimeline: d,
      endedTimelineFn: function() {
        a.logger_("received endedtimeline callback");
      },
      id3Fn: this.handleId3_.bind(this),
      dataFn: this.handleData_.bind(this),
      doneFn: this.segmentRequestFinished_.bind(this),
      onTransmuxerLog: function(f) {
        var v = f.message, b = f.level, _ = f.stream;
        a.logger_(ea(i) + " logged from transmuxer stream " + _ + " as a " + b + ": " + v);
      }
    });
  }, r.trimBackBuffer_ = function(i) {
    var a = SA(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
    a > 0 && this.remove(0, a);
  }, r.createSimplifiedSegmentObj_ = function(i) {
    var a = i.segment, s = i.part, o = {
      resolvedUri: s ? s.resolvedUri : a.resolvedUri,
      byterange: s ? s.byterange : a.byterange,
      requestId: i.requestId,
      transmuxer: i.transmuxer,
      audioAppendStart: i.audioAppendStart,
      gopsToAlignWith: i.gopsToAlignWith,
      part: i.part
    }, u = i.playlist.segments[i.mediaIndex - 1];
    if (u && u.timeline === a.timeline && (u.videoTimingInfo ? o.baseStartTime = u.videoTimingInfo.transmuxedDecodeEnd : u.audioTimingInfo && (o.baseStartTime = u.audioTimingInfo.transmuxedDecodeEnd)), a.key) {
      var l = a.key.iv || new Uint32Array([0, 0, 0, i.mediaIndex + i.playlist.mediaSequence]);
      o.key = this.segmentKey(a.key), o.key.iv = l;
    }
    return a.map && (o.map = this.initSegmentForMap(a.map)), o;
  }, r.saveTransferStats_ = function(i) {
    this.mediaRequests += 1, i && (this.mediaBytesTransferred += i.bytesReceived, this.mediaTransferDuration += i.roundTripTime);
  }, r.saveBandwidthRelatedStats_ = function(i, a) {
    if (this.pendingSegment_.byteLength = a.bytesReceived, i < ko) {
      this.logger_("Ignoring segment's bandwidth because its duration of " + i + (" is less than the min to record " + ko));
      return;
    }
    this.bandwidth = a.bandwidth, this.roundTrip = a.roundTripTime;
  }, r.handleTimeout_ = function() {
    this.mediaRequestsTimedout += 1, this.bandwidth = 1, this.roundTrip = NaN, this.trigger("bandwidthupdate"), this.trigger("timeout");
  }, r.segmentRequestFinished_ = function(i, a, s) {
    if (this.callQueue_.length) {
      this.callQueue_.push(this.segmentRequestFinished_.bind(this, i, a, s));
      return;
    }
    if (this.saveTransferStats_(a.stats), !!this.pendingSegment_ && a.requestId === this.pendingSegment_.requestId) {
      if (i) {
        if (this.pendingSegment_ = null, this.state = "READY", i.code === ir.ABORTED)
          return;
        if (this.pause(), i.code === ir.TIMEOUT) {
          this.handleTimeout_();
          return;
        }
        this.mediaRequestsErrored += 1, this.error(i), this.trigger("error");
        return;
      }
      var o = this.pendingSegment_;
      this.saveBandwidthRelatedStats_(o.duration, a.stats), o.endOfAllRequests = a.endOfAllRequests, s.gopInfo && (this.gopBuffer_ = mA(this.gopBuffer_, s.gopInfo, this.safeAppend_)), this.state = "APPENDING", this.trigger("appending"), this.waitForAppendsToComplete_(o);
    }
  }, r.setTimeMapping_ = function(i) {
    var a = this.syncController_.mappingForTimeline(i);
    a !== null && (this.timeMapping_ = a);
  }, r.updateMediaSecondsLoaded_ = function(i) {
    typeof i.start == "number" && typeof i.end == "number" ? this.mediaSecondsLoaded += i.end - i.start : this.mediaSecondsLoaded += i.duration;
  }, r.shouldUpdateTransmuxerTimestampOffset_ = function(i) {
    return i === null ? !1 : this.loaderType_ === "main" && i !== this.sourceUpdater_.videoTimestampOffset() || !this.audioDisabled_ && i !== this.sourceUpdater_.audioTimestampOffset();
  }, r.trueSegmentStart_ = function(i) {
    var a = i.currentStart, s = i.playlist, o = i.mediaIndex, u = i.firstVideoFrameTimeForData, l = i.currentVideoTimestampOffset, d = i.useVideoTimingInfo, h = i.videoTimingInfo, f = i.audioTimingInfo;
    if (typeof a < "u")
      return a;
    if (!d)
      return f.start;
    var v = s.segments[o - 1];
    return o === 0 || !v || typeof v.start > "u" || v.end !== u + l ? u : h.start;
  }, r.waitForAppendsToComplete_ = function(i) {
    var a = this.getCurrentMediaInfo_(i);
    if (!a) {
      this.error({
        message: "No starting media returned, likely due to an unsupported media format.",
        blacklistDuration: 1 / 0
      }), this.trigger("error");
      return;
    }
    var s = a.hasAudio, o = a.hasVideo, u = a.isMuxed, l = this.loaderType_ === "main" && o, d = !this.audioDisabled_ && s && !u;
    if (i.waitingOnAppends = 0, !i.hasAppendedData_) {
      !i.timingInfo && typeof i.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !0), i.timingInfo = {
        start: 0
      }, i.waitingOnAppends++, this.isPendingTimestampOffset_ || (this.updateSourceBufferTimestampOffset_(i), this.processMetadataQueue_()), this.checkAppendsDone_(i);
      return;
    }
    l && i.waitingOnAppends++, d && i.waitingOnAppends++, l && this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, i)), d && this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, i));
  }, r.checkAppendsDone_ = function(i) {
    this.checkForAbort_(i.requestId) || (i.waitingOnAppends--, i.waitingOnAppends === 0 && this.handleAppendsDone_());
  }, r.checkForIllegalMediaSwitch = function(i) {
    var a = bA(this.loaderType_, this.getCurrentMediaInfo_(), i);
    return a ? (this.error({
      message: a,
      blacklistDuration: 1 / 0
    }), this.trigger("error"), !0) : !1;
  }, r.updateSourceBufferTimestampOffset_ = function(i) {
    if (!(i.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
    // priority, timing-wise, so we must wait
    typeof i.timingInfo.start != "number" || // already updated the timestamp offset for this segment
    i.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
    this.loaderType_ !== "main")) {
      var a = !1;
      i.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
        videoTimingInfo: i.segment.videoTimingInfo,
        audioTimingInfo: i.segment.audioTimingInfo,
        timingInfo: i.timingInfo
      }), i.changedTimestampOffset = !0, i.timestampOffset !== this.sourceUpdater_.videoTimestampOffset() && (this.sourceUpdater_.videoTimestampOffset(i.timestampOffset), a = !0), i.timestampOffset !== this.sourceUpdater_.audioTimestampOffset() && (this.sourceUpdater_.audioTimestampOffset(i.timestampOffset), a = !0), a && this.trigger("timestampoffset");
    }
  }, r.getSegmentStartTimeForTimestampOffsetCalculation_ = function(i) {
    var a = i.videoTimingInfo, s = i.audioTimingInfo, o = i.timingInfo;
    return this.useDtsForTimestampOffset_ ? a && typeof a.transmuxedDecodeStart == "number" ? a.transmuxedDecodeStart : s && typeof s.transmuxedDecodeStart == "number" ? s.transmuxedDecodeStart : o.start : o.start;
  }, r.updateTimingInfoEnd_ = function(i) {
    i.timingInfo = i.timingInfo || {};
    var a = this.getMediaInfo_(), s = this.loaderType_ === "main" && a && a.hasVideo, o = s && i.videoTimingInfo ? i.videoTimingInfo : i.audioTimingInfo;
    o && (i.timingInfo.end = typeof o.end == "number" ? (
      // End time may not exist in a case where we aren't parsing the full segment (one
      // current example is the case of fmp4), so use the rough duration to calculate an
      // end time.
      o.end
    ) : o.start + i.duration);
  }, r.handleAppendsDone_ = function() {
    if (this.pendingSegment_ && this.trigger("appendsdone"), !this.pendingSegment_) {
      this.state = "READY", this.paused() || this.monitorBuffer_();
      return;
    }
    var i = this.pendingSegment_;
    this.updateTimingInfoEnd_(i), this.shouldSaveSegmentTimingInfo_ && this.syncController_.saveSegmentTimingInfo({
      segmentInfo: i,
      shouldSaveTimelineMapping: this.loaderType_ === "main"
    });
    var a = CA(i, this.sourceType_);
    if (a && (a.severity === "warn" ? P.log.warn(a.message) : this.logger_(a.message)), this.recordThroughput_(i), this.pendingSegment_ = null, this.state = "READY", i.isSyncRequest && (this.trigger("syncinfoupdate"), !i.hasAppendedData_)) {
      this.logger_("Throwing away un-appended sync request " + ea(i));
      return;
    }
    this.logger_("Appended " + ea(i)), this.addSegmentMetadataCue_(i), this.fetchAtBuffer_ = !0, this.currentTimeline_ !== i.timeline && (this.timelineChangeController_.lastTimelineChange({
      type: this.loaderType_,
      from: this.currentTimeline_,
      to: i.timeline
    }), this.loaderType_ === "main" && !this.audioDisabled_ && this.timelineChangeController_.lastTimelineChange({
      type: "audio",
      from: this.currentTimeline_,
      to: i.timeline
    })), this.currentTimeline_ = i.timeline, this.trigger("syncinfoupdate");
    var s = i.segment, o = i.part, u = s.end && this.currentTime_() - s.end > i.playlist.targetDuration * 3, l = o && o.end && this.currentTime_() - o.end > i.playlist.partTargetDuration * 3;
    if (u || l) {
      this.logger_("bad " + (u ? "segment" : "part") + " " + ea(i)), this.resetEverything();
      return;
    }
    var d = this.mediaIndex !== null;
    d && this.trigger("bandwidthupdate"), this.trigger("progress"), this.mediaIndex = i.mediaIndex, this.partIndex = i.partIndex, this.isEndOfStream_(i.mediaIndex, i.playlist, i.partIndex) && this.endOfStream(), this.trigger("appended"), i.hasAppendedData_ && this.mediaAppends++, this.paused() || this.monitorBuffer_();
  }, r.recordThroughput_ = function(i) {
    if (i.duration < ko) {
      this.logger_("Ignoring segment's throughput because its duration of " + i.duration + (" is less than the min to record " + ko));
      return;
    }
    var a = this.throughput.rate, s = Date.now() - i.endOfAllRequests + 1, o = Math.floor(i.byteLength / s * 8 * 1e3);
    this.throughput.rate += (o - a) / ++this.throughput.count;
  }, r.addSegmentMetadataCue_ = function(i) {
    if (this.segmentMetadataTrack_) {
      var a = i.segment, s = a.start, o = a.end;
      if (!(!hg(s) || !hg(o))) {
        ps(s, o, this.segmentMetadataTrack_);
        var u = M.WebKitDataCue || M.VTTCue, l = {
          custom: a.custom,
          dateTimeObject: a.dateTimeObject,
          dateTimeString: a.dateTimeString,
          bandwidth: i.playlist.attributes.BANDWIDTH,
          resolution: i.playlist.attributes.RESOLUTION,
          codecs: i.playlist.attributes.CODECS,
          byteLength: i.byteLength,
          uri: i.uri,
          timeline: i.timeline,
          playlist: i.playlist.id,
          start: s,
          end: o
        }, d = JSON.stringify(l), h = new u(s, o, d);
        h.value = l, this.segmentMetadataTrack_.addCue(h);
      }
    }
  }, e;
}(P.EventTarget);
function Sr() {
}
var J0 = function(e) {
  return typeof e != "string" ? e : e.replace(/./, function(r) {
    return r.toUpperCase();
  });
}, AA = ["video", "audio"], Rc = function(e, r) {
  var n = r[e + "Buffer"];
  return n && n.updating || r.queuePending[e];
}, wA = function(e, r) {
  for (var n = 0; n < r.length; n++) {
    var i = r[n];
    if (i.type === "mediaSource")
      return null;
    if (i.type === e)
      return n;
  }
  return null;
}, of = function t(e, r) {
  if (r.queue.length !== 0) {
    var n = 0, i = r.queue[n];
    if (i.type === "mediaSource") {
      !r.updating() && r.mediaSource.readyState !== "closed" && (r.queue.shift(), i.action(r), i.doneFn && i.doneFn(), t("audio", r), t("video", r));
      return;
    }
    if (e !== "mediaSource" && !(!r.ready() || r.mediaSource.readyState === "closed" || Rc(e, r))) {
      if (i.type !== e) {
        if (n = wA(e, r.queue), n === null)
          return;
        i = r.queue[n];
      }
      if (r.queue.splice(n, 1), r.queuePending[e] = i, i.action(e, r), !i.doneFn) {
        r.queuePending[e] = null, t(e, r);
        return;
      }
    }
  }
}, Z0 = function(e, r) {
  var n = r[e + "Buffer"], i = J0(e);
  n && (n.removeEventListener("updateend", r["on" + i + "UpdateEnd_"]), n.removeEventListener("error", r["on" + i + "Error_"]), r.codecs[e] = null, r[e + "Buffer"] = null);
}, Qi = function(e, r) {
  return e && r && Array.prototype.indexOf.call(e.sourceBuffers, r) !== -1;
}, Ti = {
  appendBuffer: function(e, r, n) {
    return function(i, a) {
      var s = a[i + "Buffer"];
      if (Qi(a.mediaSource, s)) {
        a.logger_("Appending segment " + r.mediaIndex + "'s " + e.length + " bytes to " + i + "Buffer");
        try {
          s.appendBuffer(e);
        } catch (o) {
          a.logger_("Error with code " + o.code + " " + (o.code === Q0 ? "(QUOTA_EXCEEDED_ERR) " : "") + ("when appending segment " + r.mediaIndex + " to " + i + "Buffer")), a.queuePending[i] = null, n(o);
        }
      }
    };
  },
  remove: function(e, r) {
    return function(n, i) {
      var a = i[n + "Buffer"];
      if (Qi(i.mediaSource, a)) {
        i.logger_("Removing " + e + " to " + r + " from " + n + "Buffer");
        try {
          a.remove(e, r);
        } catch {
          i.logger_("Remove " + e + " to " + r + " from " + n + "Buffer failed");
        }
      }
    };
  },
  timestampOffset: function(e) {
    return function(r, n) {
      var i = n[r + "Buffer"];
      Qi(n.mediaSource, i) && (n.logger_("Setting " + r + "timestampOffset to " + e), i.timestampOffset = e);
    };
  },
  callback: function(e) {
    return function(r, n) {
      e();
    };
  },
  endOfStream: function(e) {
    return function(r) {
      if (r.mediaSource.readyState === "open") {
        r.logger_("Calling mediaSource endOfStream(" + (e || "") + ")");
        try {
          r.mediaSource.endOfStream(e);
        } catch (n) {
          P.log.warn("Failed to call media source endOfStream", n);
        }
      }
    };
  },
  duration: function(e) {
    return function(r) {
      r.logger_("Setting mediaSource duration to " + e);
      try {
        r.mediaSource.duration = e;
      } catch (n) {
        P.log.warn("Failed to set media source duration", n);
      }
    };
  },
  abort: function() {
    return function(e, r) {
      if (r.mediaSource.readyState === "open") {
        var n = r[e + "Buffer"];
        if (Qi(r.mediaSource, n)) {
          r.logger_("calling abort on " + e + "Buffer");
          try {
            n.abort();
          } catch (i) {
            P.log.warn("Failed to abort on " + e + "Buffer", i);
          }
        }
      }
    };
  },
  addSourceBuffer: function(e, r) {
    return function(n) {
      var i = J0(e), a = Cs(r);
      n.logger_("Adding " + e + "Buffer with codec " + r + " to mediaSource");
      var s = n.mediaSource.addSourceBuffer(a);
      s.addEventListener("updateend", n["on" + i + "UpdateEnd_"]), s.addEventListener("error", n["on" + i + "Error_"]), n.codecs[e] = r, n[e + "Buffer"] = s;
    };
  },
  removeSourceBuffer: function(e) {
    return function(r) {
      var n = r[e + "Buffer"];
      if (Z0(e, r), !!Qi(r.mediaSource, n)) {
        r.logger_("Removing " + e + "Buffer with codec " + r.codecs[e] + " from mediaSource");
        try {
          r.mediaSource.removeSourceBuffer(n);
        } catch (i) {
          P.log.warn("Failed to removeSourceBuffer " + e + "Buffer", i);
        }
      }
    };
  },
  changeType: function(e) {
    return function(r, n) {
      var i = n[r + "Buffer"], a = Cs(e);
      Qi(n.mediaSource, i) && n.codecs[r] !== e && (n.logger_("changing " + r + "Buffer codec from " + n.codecs[r] + " to " + e), i.changeType(a), n.codecs[r] = e);
    };
  }
}, bi = function(e) {
  var r = e.type, n = e.sourceUpdater, i = e.action, a = e.doneFn, s = e.name;
  n.queue.push({
    type: r,
    action: i,
    doneFn: a,
    name: s
  }), of(r, n);
}, mg = function(e, r) {
  return function(n) {
    if (r.queuePending[e]) {
      var i = r.queuePending[e].doneFn;
      r.queuePending[e] = null, i && i(r[e + "Error_"]);
    }
    of(e, r);
  };
}, e_ = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n) {
    var i;
    return i = t.call(this) || this, i.mediaSource = n, i.sourceopenListener_ = function() {
      return of("mediaSource", Le(i));
    }, i.mediaSource.addEventListener("sourceopen", i.sourceopenListener_), i.logger_ = Hi("SourceUpdater"), i.audioTimestampOffset_ = 0, i.videoTimestampOffset_ = 0, i.queue = [], i.queuePending = {
      audio: null,
      video: null
    }, i.delayedAudioAppendQueue_ = [], i.videoAppendQueued_ = !1, i.codecs = {}, i.onVideoUpdateEnd_ = mg("video", Le(i)), i.onAudioUpdateEnd_ = mg("audio", Le(i)), i.onVideoError_ = function(a) {
      i.videoError_ = a;
    }, i.onAudioError_ = function(a) {
      i.audioError_ = a;
    }, i.createdSourceBuffers_ = !1, i.initializedEme_ = !1, i.triggeredReady_ = !1, i;
  }
  var r = e.prototype;
  return r.initializedEme = function() {
    this.initializedEme_ = !0, this.triggerReady();
  }, r.hasCreatedSourceBuffers = function() {
    return this.createdSourceBuffers_;
  }, r.hasInitializedAnyEme = function() {
    return this.initializedEme_;
  }, r.ready = function() {
    return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
  }, r.createSourceBuffers = function(i) {
    this.hasCreatedSourceBuffers() || (this.addOrChangeSourceBuffers(i), this.createdSourceBuffers_ = !0, this.trigger("createdsourcebuffers"), this.triggerReady());
  }, r.triggerReady = function() {
    this.ready() && !this.triggeredReady_ && (this.triggeredReady_ = !0, this.trigger("ready"));
  }, r.addSourceBuffer = function(i, a) {
    bi({
      type: "mediaSource",
      sourceUpdater: this,
      action: Ti.addSourceBuffer(i, a),
      name: "addSourceBuffer"
    });
  }, r.abort = function(i) {
    bi({
      type: i,
      sourceUpdater: this,
      action: Ti.abort(i),
      name: "abort"
    });
  }, r.removeSourceBuffer = function(i) {
    if (!this.canRemoveSourceBuffer()) {
      P.log.error("removeSourceBuffer is not supported!");
      return;
    }
    bi({
      type: "mediaSource",
      sourceUpdater: this,
      action: Ti.removeSourceBuffer(i),
      name: "removeSourceBuffer"
    });
  }, r.canRemoveSourceBuffer = function() {
    return !P.browser.IE_VERSION && !P.browser.IS_FIREFOX && M.MediaSource && M.MediaSource.prototype && typeof M.MediaSource.prototype.removeSourceBuffer == "function";
  }, e.canChangeType = function() {
    return M.SourceBuffer && M.SourceBuffer.prototype && typeof M.SourceBuffer.prototype.changeType == "function";
  }, r.canChangeType = function() {
    return this.constructor.canChangeType();
  }, r.changeType = function(i, a) {
    if (!this.canChangeType()) {
      P.log.error("changeType is not supported!");
      return;
    }
    bi({
      type: i,
      sourceUpdater: this,
      action: Ti.changeType(a),
      name: "changeType"
    });
  }, r.addOrChangeSourceBuffers = function(i) {
    var a = this;
    if (!i || typeof i != "object" || Object.keys(i).length === 0)
      throw new Error("Cannot addOrChangeSourceBuffers to undefined codecs");
    Object.keys(i).forEach(function(s) {
      var o = i[s];
      if (!a.hasCreatedSourceBuffers())
        return a.addSourceBuffer(s, o);
      a.canChangeType() && a.changeType(s, o);
    });
  }, r.appendBuffer = function(i, a) {
    var s = this, o = i.segmentInfo, u = i.type, l = i.bytes;
    if (this.processedAppend_ = !0, u === "audio" && this.videoBuffer && !this.videoAppendQueued_) {
      this.delayedAudioAppendQueue_.push([i, a]), this.logger_("delayed audio append of " + l.length + " until video append");
      return;
    }
    var d = a;
    if (bi({
      type: u,
      sourceUpdater: this,
      action: Ti.appendBuffer(l, o || {
        mediaIndex: -1
      }, d),
      doneFn: a,
      name: "appendBuffer"
    }), u === "video") {
      if (this.videoAppendQueued_ = !0, !this.delayedAudioAppendQueue_.length)
        return;
      var h = this.delayedAudioAppendQueue_.slice();
      this.logger_("queuing delayed audio " + h.length + " appendBuffers"), this.delayedAudioAppendQueue_.length = 0, h.forEach(function(f) {
        s.appendBuffer.apply(s, f);
      });
    }
  }, r.audioBuffered = function() {
    return Qi(this.mediaSource, this.audioBuffer) && this.audioBuffer.buffered ? this.audioBuffer.buffered : P.createTimeRange();
  }, r.videoBuffered = function() {
    return Qi(this.mediaSource, this.videoBuffer) && this.videoBuffer.buffered ? this.videoBuffer.buffered : P.createTimeRange();
  }, r.buffered = function() {
    var i = Qi(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null, a = Qi(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
    return a && !i ? this.audioBuffered() : i && !a ? this.videoBuffered() : $C(this.audioBuffered(), this.videoBuffered());
  }, r.setDuration = function(i, a) {
    a === void 0 && (a = Sr), bi({
      type: "mediaSource",
      sourceUpdater: this,
      action: Ti.duration(i),
      name: "duration",
      doneFn: a
    });
  }, r.endOfStream = function(i, a) {
    i === void 0 && (i = null), a === void 0 && (a = Sr), typeof i != "string" && (i = void 0), bi({
      type: "mediaSource",
      sourceUpdater: this,
      action: Ti.endOfStream(i),
      name: "endOfStream",
      doneFn: a
    });
  }, r.removeAudio = function(i, a, s) {
    if (s === void 0 && (s = Sr), !this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
      s();
      return;
    }
    bi({
      type: "audio",
      sourceUpdater: this,
      action: Ti.remove(i, a),
      doneFn: s,
      name: "remove"
    });
  }, r.removeVideo = function(i, a, s) {
    if (s === void 0 && (s = Sr), !this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
      s();
      return;
    }
    bi({
      type: "video",
      sourceUpdater: this,
      action: Ti.remove(i, a),
      doneFn: s,
      name: "remove"
    });
  }, r.updating = function() {
    return !!(Rc("audio", this) || Rc("video", this));
  }, r.audioTimestampOffset = function(i) {
    return typeof i < "u" && this.audioBuffer && // no point in updating if it's the same
    this.audioTimestampOffset_ !== i && (bi({
      type: "audio",
      sourceUpdater: this,
      action: Ti.timestampOffset(i),
      name: "timestampOffset"
    }), this.audioTimestampOffset_ = i), this.audioTimestampOffset_;
  }, r.videoTimestampOffset = function(i) {
    return typeof i < "u" && this.videoBuffer && // no point in updating if it's the same
    this.videoTimestampOffset !== i && (bi({
      type: "video",
      sourceUpdater: this,
      action: Ti.timestampOffset(i),
      name: "timestampOffset"
    }), this.videoTimestampOffset_ = i), this.videoTimestampOffset_;
  }, r.audioQueueCallback = function(i) {
    this.audioBuffer && bi({
      type: "audio",
      sourceUpdater: this,
      action: Ti.callback(i),
      name: "callback"
    });
  }, r.videoQueueCallback = function(i) {
    this.videoBuffer && bi({
      type: "video",
      sourceUpdater: this,
      action: Ti.callback(i),
      name: "callback"
    });
  }, r.dispose = function() {
    var i = this;
    this.trigger("dispose"), AA.forEach(function(a) {
      i.abort(a), i.canRemoveSourceBuffer() ? i.removeSourceBuffer(a) : i[a + "QueueCallback"](function() {
        return Z0(a, i);
      });
    }), this.videoAppendQueued_ = !1, this.delayedAudioAppendQueue_.length = 0, this.sourceopenListener_ && this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_), this.off();
  }, e;
}(P.EventTarget), vg = function(e) {
  return decodeURIComponent(escape(String.fromCharCode.apply(null, e)));
}, yg = new Uint8Array(`

`.split("").map(function(t) {
  return t.charCodeAt(0);
})), PA = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    return t.call(this, "Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.") || this;
  }
  return e;
}(/* @__PURE__ */ pc(Error)), kA = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i) {
    var a;
    return i === void 0 && (i = {}), a = t.call(this, n, i) || this, a.mediaSource_ = null, a.subtitlesTrack_ = null, a.loaderType_ = "subtitle", a.featuresNativeTextTracks_ = n.featuresNativeTextTracks, a.loadVttJs = n.loadVttJs, a.shouldSaveSegmentTimingInfo_ = !1, a;
  }
  var r = e.prototype;
  return r.createTransmuxer_ = function() {
    return null;
  }, r.buffered_ = function() {
    if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length)
      return P.createTimeRanges();
    var i = this.subtitlesTrack_.cues, a = i[0].startTime, s = i[i.length - 1].startTime;
    return P.createTimeRanges([[a, s]]);
  }, r.initSegmentForMap = function(i, a) {
    if (a === void 0 && (a = !1), !i)
      return null;
    var s = mu(i), o = this.initSegments_[s];
    if (a && !o && i.bytes) {
      var u = yg.byteLength + i.bytes.byteLength, l = new Uint8Array(u);
      l.set(i.bytes), l.set(yg, i.bytes.byteLength), this.initSegments_[s] = o = {
        resolvedUri: i.resolvedUri,
        byterange: i.byterange,
        bytes: l
      };
    }
    return o || i;
  }, r.couldBeginLoading_ = function() {
    return this.playlist_ && this.subtitlesTrack_ && !this.paused();
  }, r.init_ = function() {
    return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
  }, r.track = function(i) {
    return typeof i > "u" ? this.subtitlesTrack_ : (this.subtitlesTrack_ = i, this.state === "INIT" && this.couldBeginLoading_() && this.init_(), this.subtitlesTrack_);
  }, r.remove = function(i, a) {
    ps(i, a, this.subtitlesTrack_);
  }, r.fillBuffer_ = function() {
    var i = this, a = this.chooseNextRequest_();
    if (a) {
      if (this.syncController_.timestampOffsetForTimeline(a.timeline) === null) {
        var s = function() {
          i.state = "READY", i.paused() || i.monitorBuffer_();
        };
        this.syncController_.one("timestampoffset", s), this.state = "WAITING_ON_TIMELINE";
        return;
      }
      this.loadSegment_(a);
    }
  }, r.timestampOffsetForSegment_ = function() {
    return null;
  }, r.chooseNextRequest_ = function() {
    return this.skipEmptySegments_(t.prototype.chooseNextRequest_.call(this));
  }, r.skipEmptySegments_ = function(i) {
    for (; i && i.segment.empty; ) {
      if (i.mediaIndex + 1 >= i.playlist.segments.length) {
        i = null;
        break;
      }
      i = this.generateSegmentInfo_({
        playlist: i.playlist,
        mediaIndex: i.mediaIndex + 1,
        startOfSegment: i.startOfSegment + i.duration,
        isSyncRequest: i.isSyncRequest
      });
    }
    return i;
  }, r.stopForError = function(i) {
    this.error(i), this.state = "READY", this.pause(), this.trigger("error");
  }, r.segmentRequestFinished_ = function(i, a, s) {
    var o = this;
    if (!this.subtitlesTrack_) {
      this.state = "READY";
      return;
    }
    if (this.saveTransferStats_(a.stats), !this.pendingSegment_) {
      this.state = "READY", this.mediaRequestsAborted += 1;
      return;
    }
    if (i) {
      i.code === ir.TIMEOUT && this.handleTimeout_(), i.code === ir.ABORTED ? this.mediaRequestsAborted += 1 : this.mediaRequestsErrored += 1, this.stopForError(i);
      return;
    }
    var u = this.pendingSegment_;
    this.saveBandwidthRelatedStats_(u.duration, a.stats), a.key && this.segmentKey(a.key, !0), this.state = "APPENDING", this.trigger("appending");
    var l = u.segment;
    if (l.map && (l.map.bytes = a.map.bytes), u.bytes = a.bytes, typeof M.WebVTT != "function" && typeof this.loadVttJs == "function") {
      this.state = "WAITING_ON_VTTJS", this.loadVttJs().then(function() {
        return o.segmentRequestFinished_(i, a, s);
      }, function() {
        return o.stopForError({
          message: "Error loading vtt.js"
        });
      });
      return;
    }
    l.requested = !0;
    try {
      this.parseVTTCues_(u);
    } catch (d) {
      this.stopForError({
        message: d.message
      });
      return;
    }
    if (this.updateTimeMapping_(u, this.syncController_.timelines[u.timeline], this.playlist_), u.cues.length ? u.timingInfo = {
      start: u.cues[0].startTime,
      end: u.cues[u.cues.length - 1].endTime
    } : u.timingInfo = {
      start: u.startOfSegment,
      end: u.startOfSegment + u.duration
    }, u.isSyncRequest) {
      this.trigger("syncinfoupdate"), this.pendingSegment_ = null, this.state = "READY";
      return;
    }
    u.byteLength = u.bytes.byteLength, this.mediaSecondsLoaded += l.duration, u.cues.forEach(function(d) {
      o.subtitlesTrack_.addCue(o.featuresNativeTextTracks_ ? new M.VTTCue(d.startTime, d.endTime, d.text) : d);
    }), pA(this.subtitlesTrack_), this.handleAppendsDone_();
  }, r.handleData_ = function() {
  }, r.updateTimingInfoEnd_ = function() {
  }, r.parseVTTCues_ = function(i) {
    var a, s = !1;
    if (typeof M.WebVTT != "function")
      throw new PA();
    typeof M.TextDecoder == "function" ? a = new M.TextDecoder("utf8") : (a = M.WebVTT.StringDecoder(), s = !0);
    var o = new M.WebVTT.Parser(M, M.vttjs, a);
    if (i.cues = [], i.timestampmap = {
      MPEGTS: 0,
      LOCAL: 0
    }, o.oncue = i.cues.push.bind(i.cues), o.ontimestampmap = function(d) {
      i.timestampmap = d;
    }, o.onparsingerror = function(d) {
      P.log.warn("Error encountered when parsing cues: " + d.message);
    }, i.segment.map) {
      var u = i.segment.map.bytes;
      s && (u = vg(u)), o.parse(u);
    }
    var l = i.bytes;
    s && (l = vg(l)), o.parse(l), o.flush();
  }, r.updateTimeMapping_ = function(i, a, s) {
    var o = i.segment;
    if (a) {
      if (!i.cues.length) {
        o.empty = !0;
        return;
      }
      var u = i.timestampmap, l = u.MPEGTS / nu.ONE_SECOND_IN_TS - u.LOCAL + a.mapping;
      if (i.cues.forEach(function(f) {
        f.startTime += l, f.endTime += l;
      }), !s.syncInfo) {
        var d = i.cues[0].startTime, h = i.cues[i.cues.length - 1].startTime;
        s.syncInfo = {
          mediaSequence: s.mediaSequence + i.mediaIndex,
          time: Math.min(d, h - o.duration)
        };
      }
    }
  }, e;
}(Dc), LA = function(e, r) {
  for (var n = e.cues, i = 0; i < n.length; i++) {
    var a = n[i];
    if (r >= a.adStartTime && r <= a.adEndTime)
      return a;
  }
  return null;
}, IA = function(e, r, n) {
  if (n === void 0 && (n = 0), !!e.segments)
    for (var i = n, a, s = 0; s < e.segments.length; s++) {
      var o = e.segments[s];
      if (a || (a = LA(r, i + o.duration / 2)), a) {
        if ("cueIn" in o) {
          a.endTime = i, a.adEndTime = i, i += o.duration, a = null;
          continue;
        }
        if (i < a.endTime) {
          i += o.duration;
          continue;
        }
        a.endTime += o.duration;
      } else if ("cueOut" in o && (a = new M.VTTCue(i, i + o.duration, o.cueOut), a.adStartTime = i, a.adEndTime = i + parseFloat(o.cueOut), r.addCue(a)), "cueOutCont" in o) {
        var u = o.cueOutCont.split("/").map(parseFloat), l = u[0], d = u[1];
        a = new M.VTTCue(i, i + o.duration, ""), a.adStartTime = i - l, a.adEndTime = a.adStartTime + d, r.addCue(a);
      }
      i += o.duration;
    }
}, DA = 86400, _g = [
  // Stategy "VOD": Handle the VOD-case where the sync-point is *always*
  //                the equivalence display-time 0 === segment-index 0
  {
    name: "VOD",
    run: function(e, r, n, i, a) {
      if (n !== 1 / 0) {
        var s = {
          time: 0,
          segmentIndex: 0,
          partIndex: null
        };
        return s;
      }
      return null;
    }
  },
  // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
  {
    name: "ProgramDateTime",
    run: function(e, r, n, i, a) {
      if (!Object.keys(e.timelineToDatetimeMappings).length)
        return null;
      var s = null, o = null, u = xc(r);
      a = a || 0;
      for (var l = 0; l < u.length; l++) {
        var d = r.endList || a === 0 ? l : u.length - (l + 1), h = u[d], f = h.segment, v = e.timelineToDatetimeMappings[f.timeline];
        if (!(!v || !f.dateTimeObject)) {
          var b = f.dateTimeObject.getTime() / 1e3, _ = b + v;
          if (f.parts && typeof h.partIndex == "number")
            for (var y = 0; y < h.partIndex; y++)
              _ += f.parts[y].duration;
          var E = Math.abs(a - _);
          if (o !== null && (E === 0 || o < E))
            break;
          o = E, s = {
            time: _,
            segmentIndex: h.segmentIndex,
            partIndex: h.partIndex
          };
        }
      }
      return s;
    }
  },
  // Stategy "Segment": We have a known time mapping for a timeline and a
  //                    segment in the current timeline with timing data
  {
    name: "Segment",
    run: function(e, r, n, i, a) {
      var s = null, o = null;
      a = a || 0;
      for (var u = xc(r), l = 0; l < u.length; l++) {
        var d = r.endList || a === 0 ? l : u.length - (l + 1), h = u[d], f = h.segment, v = h.part && h.part.start || f && f.start;
        if (f.timeline === i && typeof v < "u") {
          var b = Math.abs(a - v);
          if (o !== null && o < b)
            break;
          (!s || o === null || o >= b) && (o = b, s = {
            time: v,
            segmentIndex: h.segmentIndex,
            partIndex: h.partIndex
          });
        }
      }
      return s;
    }
  },
  // Stategy "Discontinuity": We have a discontinuity with a known
  //                          display-time
  {
    name: "Discontinuity",
    run: function(e, r, n, i, a) {
      var s = null;
      if (a = a || 0, r.discontinuityStarts && r.discontinuityStarts.length)
        for (var o = null, u = 0; u < r.discontinuityStarts.length; u++) {
          var l = r.discontinuityStarts[u], d = r.discontinuitySequence + u + 1, h = e.discontinuities[d];
          if (h) {
            var f = Math.abs(a - h.time);
            if (o !== null && o < f)
              break;
            (!s || o === null || o >= f) && (o = f, s = {
              time: h.time,
              segmentIndex: l,
              partIndex: null
            });
          }
        }
      return s;
    }
  },
  // Stategy "Playlist": We have a playlist with a known mapping of
  //                     segment index to display time
  {
    name: "Playlist",
    run: function(e, r, n, i, a) {
      if (r.syncInfo) {
        var s = {
          time: r.syncInfo.time,
          segmentIndex: r.syncInfo.mediaSequence - r.mediaSequence,
          partIndex: null
        };
        return s;
      }
      return null;
    }
  }
], RA = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n) {
    var i;
    return i = t.call(this) || this, i.timelines = [], i.discontinuities = [], i.timelineToDatetimeMappings = {}, i.logger_ = Hi("SyncController"), i;
  }
  var r = e.prototype;
  return r.getSyncPoint = function(i, a, s, o) {
    var u = this.runStrategies_(i, a, s, o);
    return u.length ? this.selectSyncPoint_(u, {
      key: "time",
      value: o
    }) : null;
  }, r.getExpiredTime = function(i, a) {
    if (!i || !i.segments)
      return null;
    var s = this.runStrategies_(i, a, i.discontinuitySequence, 0);
    if (!s.length)
      return null;
    var o = this.selectSyncPoint_(s, {
      key: "segmentIndex",
      value: 0
    });
    return o.segmentIndex > 0 && (o.time *= -1), Math.abs(o.time + bs({
      defaultDuration: i.targetDuration,
      durationList: i.segments,
      startIndex: o.segmentIndex,
      endIndex: 0
    }));
  }, r.runStrategies_ = function(i, a, s, o) {
    for (var u = [], l = 0; l < _g.length; l++) {
      var d = _g[l], h = d.run(this, i, a, s, o);
      h && (h.strategy = d.name, u.push({
        strategy: d.name,
        syncPoint: h
      }));
    }
    return u;
  }, r.selectSyncPoint_ = function(i, a) {
    for (var s = i[0].syncPoint, o = Math.abs(i[0].syncPoint[a.key] - a.value), u = i[0].strategy, l = 1; l < i.length; l++) {
      var d = Math.abs(i[l].syncPoint[a.key] - a.value);
      d < o && (o = d, s = i[l].syncPoint, u = i[l].strategy);
    }
    return this.logger_("syncPoint for [" + a.key + ": " + a.value + "] chosen with strategy" + (" [" + u + "]: [time:" + s.time + ",") + (" segmentIndex:" + s.segmentIndex) + (typeof s.partIndex == "number" ? ",partIndex:" + s.partIndex : "") + "]"), s;
  }, r.saveExpiredSegmentInfo = function(i, a) {
    var s = a.mediaSequence - i.mediaSequence;
    if (s > DA) {
      P.log.warn("Not saving expired segment info. Media sequence gap " + s + " is too large.");
      return;
    }
    for (var o = s - 1; o >= 0; o--) {
      var u = i.segments[o];
      if (u && typeof u.start < "u") {
        a.syncInfo = {
          mediaSequence: i.mediaSequence + o,
          time: u.start
        }, this.logger_("playlist refresh sync: [time:" + a.syncInfo.time + "," + (" mediaSequence: " + a.syncInfo.mediaSequence + "]")), this.trigger("syncinfoupdate");
        break;
      }
    }
  }, r.setDateTimeMappingForStart = function(i) {
    if (this.timelineToDatetimeMappings = {}, i.segments && i.segments.length && i.segments[0].dateTimeObject) {
      var a = i.segments[0], s = a.dateTimeObject.getTime() / 1e3;
      this.timelineToDatetimeMappings[a.timeline] = -s;
    }
  }, r.saveSegmentTimingInfo = function(i) {
    var a = i.segmentInfo, s = i.shouldSaveTimelineMapping, o = this.calculateSegmentTimeMapping_(a, a.timingInfo, s), u = a.segment;
    o && (this.saveDiscontinuitySyncInfo_(a), a.playlist.syncInfo || (a.playlist.syncInfo = {
      mediaSequence: a.playlist.mediaSequence + a.mediaIndex,
      time: u.start
    }));
    var l = u.dateTimeObject;
    u.discontinuity && s && l && (this.timelineToDatetimeMappings[u.timeline] = -(l.getTime() / 1e3));
  }, r.timestampOffsetForTimeline = function(i) {
    return typeof this.timelines[i] > "u" ? null : this.timelines[i].time;
  }, r.mappingForTimeline = function(i) {
    return typeof this.timelines[i] > "u" ? null : this.timelines[i].mapping;
  }, r.calculateSegmentTimeMapping_ = function(i, a, s) {
    var o = i.segment, u = i.part, l = this.timelines[i.timeline], d, h;
    if (typeof i.timestampOffset == "number")
      l = {
        time: i.startOfSegment,
        mapping: i.startOfSegment - a.start
      }, s && (this.timelines[i.timeline] = l, this.trigger("timestampoffset"), this.logger_("time mapping for timeline " + i.timeline + ": " + ("[time: " + l.time + "] [mapping: " + l.mapping + "]"))), d = i.startOfSegment, h = a.end + l.mapping;
    else if (l)
      d = a.start + l.mapping, h = a.end + l.mapping;
    else
      return !1;
    return u && (u.start = d, u.end = h), (!o.start || d < o.start) && (o.start = d), o.end = h, !0;
  }, r.saveDiscontinuitySyncInfo_ = function(i) {
    var a = i.playlist, s = i.segment;
    if (s.discontinuity)
      this.discontinuities[s.timeline] = {
        time: s.start,
        accuracy: 0
      };
    else if (a.discontinuityStarts && a.discontinuityStarts.length)
      for (var o = 0; o < a.discontinuityStarts.length; o++) {
        var u = a.discontinuityStarts[o], l = a.discontinuitySequence + o + 1, d = u - i.mediaIndex, h = Math.abs(d);
        if (!this.discontinuities[l] || this.discontinuities[l].accuracy > h) {
          var f = void 0;
          d < 0 ? f = s.start - bs({
            defaultDuration: a.targetDuration,
            durationList: a.segments,
            startIndex: i.mediaIndex,
            endIndex: u
          }) : f = s.end + bs({
            defaultDuration: a.targetDuration,
            durationList: a.segments,
            startIndex: i.mediaIndex + 1,
            endIndex: u
          }), this.discontinuities[l] = {
            time: f,
            accuracy: h
          };
        }
      }
  }, r.dispose = function() {
    this.trigger("dispose"), this.off();
  }, e;
}(P.EventTarget), OA = /* @__PURE__ */ function(t) {
  le(e, t);
  function e() {
    var n;
    return n = t.call(this) || this, n.pendingTimelineChanges_ = {}, n.lastTimelineChanges_ = {}, n;
  }
  var r = e.prototype;
  return r.clearPendingTimelineChange = function(i) {
    this.pendingTimelineChanges_[i] = null, this.trigger("pendingtimelinechange");
  }, r.pendingTimelineChange = function(i) {
    var a = i.type, s = i.from, o = i.to;
    return typeof s == "number" && typeof o == "number" && (this.pendingTimelineChanges_[a] = {
      type: a,
      from: s,
      to: o
    }, this.trigger("pendingtimelinechange")), this.pendingTimelineChanges_[a];
  }, r.lastTimelineChange = function(i) {
    var a = i.type, s = i.from, o = i.to;
    return typeof s == "number" && typeof o == "number" && (this.lastTimelineChanges_[a] = {
      type: a,
      from: s,
      to: o
    }, delete this.pendingTimelineChanges_[a], this.trigger("timelinechange")), this.lastTimelineChanges_[a];
  }, r.dispose = function() {
    this.trigger("dispose"), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {}, this.off();
  }, e;
}(P.EventTarget), MA = V0(j0(function() {
  var t = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
  function e(C, w, k) {
    return k = {
      path: w,
      exports: {},
      require: function(U, $) {
        return r(U, $ ?? k.path);
      }
    }, C(k, k.exports), k.exports;
  }
  function r() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }
  var n = e(function(C) {
    function w(I, U) {
      for (var $ = 0; $ < U.length; $++) {
        var W = U[$];
        W.enumerable = W.enumerable || !1, W.configurable = !0, "value" in W && (W.writable = !0), Object.defineProperty(I, W.key, W);
      }
    }
    function k(I, U, $) {
      return U && w(I.prototype, U), $ && w(I, $), I;
    }
    C.exports = k, C.exports.default = C.exports, C.exports.__esModule = !0;
  }), i = e(function(C) {
    function w(k, I) {
      return C.exports = w = Object.setPrototypeOf || function($, W) {
        return $.__proto__ = W, $;
      }, C.exports.default = C.exports, C.exports.__esModule = !0, w(k, I);
    }
    C.exports = w, C.exports.default = C.exports, C.exports.__esModule = !0;
  }), a = e(function(C) {
    function w(k, I) {
      k.prototype = Object.create(I.prototype), k.prototype.constructor = k, i(k, I);
    }
    C.exports = w, C.exports.default = C.exports, C.exports.__esModule = !0;
  }), s = /* @__PURE__ */ function() {
    function C() {
      this.listeners = {};
    }
    var w = C.prototype;
    return w.on = function(I, U) {
      this.listeners[I] || (this.listeners[I] = []), this.listeners[I].push(U);
    }, w.off = function(I, U) {
      if (!this.listeners[I])
        return !1;
      var $ = this.listeners[I].indexOf(U);
      return this.listeners[I] = this.listeners[I].slice(0), this.listeners[I].splice($, 1), $ > -1;
    }, w.trigger = function(I) {
      var U = this.listeners[I];
      if (U)
        if (arguments.length === 2)
          for (var $ = U.length, W = 0; W < $; ++W)
            U[W].call(this, arguments[1]);
        else
          for (var G = Array.prototype.slice.call(arguments, 1), Y = U.length, re = 0; re < Y; ++re)
            U[re].apply(this, G);
    }, w.dispose = function() {
      this.listeners = {};
    }, w.pipe = function(I) {
      this.on("data", function(U) {
        I.push(U);
      });
    }, C;
  }();
  /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
  function o(C) {
    return C.subarray(0, C.byteLength - C[C.byteLength - 1]);
  }
  /*! @name aes-decrypter @version 3.1.3 @license Apache-2.0 */
  var u = function() {
    var w = [[[], [], [], [], []], [[], [], [], [], []]], k = w[0], I = w[1], U = k[4], $ = I[4], W, G, Y, re = [], j = [], J, z, Q, te, ae, ne;
    for (W = 0; W < 256; W++)
      j[(re[W] = W << 1 ^ (W >> 7) * 283) ^ W] = W;
    for (G = Y = 0; !U[G]; G ^= J || 1, Y = j[Y] || 1)
      for (te = Y ^ Y << 1 ^ Y << 2 ^ Y << 3 ^ Y << 4, te = te >> 8 ^ te & 255 ^ 99, U[G] = te, $[te] = G, Q = re[z = re[J = re[G]]], ne = Q * 16843009 ^ z * 65537 ^ J * 257 ^ G * 16843008, ae = re[te] * 257 ^ te * 16843008, W = 0; W < 4; W++)
        k[W][G] = ae = ae << 24 ^ ae >>> 8, I[W][te] = ne = ne << 24 ^ ne >>> 8;
    for (W = 0; W < 5; W++)
      k[W] = k[W].slice(0), I[W] = I[W].slice(0);
    return w;
  }, l = null, d = /* @__PURE__ */ function() {
    function C(k) {
      l || (l = u()), this._tables = [[l[0][0].slice(), l[0][1].slice(), l[0][2].slice(), l[0][3].slice(), l[0][4].slice()], [l[1][0].slice(), l[1][1].slice(), l[1][2].slice(), l[1][3].slice(), l[1][4].slice()]];
      var I, U, $, W = this._tables[0][4], G = this._tables[1], Y = k.length, re = 1;
      if (Y !== 4 && Y !== 6 && Y !== 8)
        throw new Error("Invalid aes key size");
      var j = k.slice(0), J = [];
      for (this._key = [j, J], I = Y; I < 4 * Y + 28; I++)
        $ = j[I - 1], (I % Y === 0 || Y === 8 && I % Y === 4) && ($ = W[$ >>> 24] << 24 ^ W[$ >> 16 & 255] << 16 ^ W[$ >> 8 & 255] << 8 ^ W[$ & 255], I % Y === 0 && ($ = $ << 8 ^ $ >>> 24 ^ re << 24, re = re << 1 ^ (re >> 7) * 283)), j[I] = j[I - Y] ^ $;
      for (U = 0; I; U++, I--)
        $ = j[U & 3 ? I : I - 4], I <= 4 || U < 4 ? J[U] = $ : J[U] = G[0][W[$ >>> 24]] ^ G[1][W[$ >> 16 & 255]] ^ G[2][W[$ >> 8 & 255]] ^ G[3][W[$ & 255]];
    }
    var w = C.prototype;
    return w.decrypt = function(I, U, $, W, G, Y) {
      var re = this._key[1], j = I ^ re[0], J = W ^ re[1], z = $ ^ re[2], Q = U ^ re[3], te, ae, ne, Se = re.length / 4 - 2, Te, We = 4, Be = this._tables[1], ge = Be[0], fe = Be[1], me = Be[2], xe = Be[3], Ue = Be[4];
      for (Te = 0; Te < Se; Te++)
        te = ge[j >>> 24] ^ fe[J >> 16 & 255] ^ me[z >> 8 & 255] ^ xe[Q & 255] ^ re[We], ae = ge[J >>> 24] ^ fe[z >> 16 & 255] ^ me[Q >> 8 & 255] ^ xe[j & 255] ^ re[We + 1], ne = ge[z >>> 24] ^ fe[Q >> 16 & 255] ^ me[j >> 8 & 255] ^ xe[J & 255] ^ re[We + 2], Q = ge[Q >>> 24] ^ fe[j >> 16 & 255] ^ me[J >> 8 & 255] ^ xe[z & 255] ^ re[We + 3], We += 4, j = te, J = ae, z = ne;
      for (Te = 0; Te < 4; Te++)
        G[(3 & -Te) + Y] = Ue[j >>> 24] << 24 ^ Ue[J >> 16 & 255] << 16 ^ Ue[z >> 8 & 255] << 8 ^ Ue[Q & 255] ^ re[We++], te = j, j = J, J = z, z = Q, Q = te;
    }, C;
  }(), h = /* @__PURE__ */ function(C) {
    a(w, C);
    function w() {
      var I;
      return I = C.call(this, s) || this, I.jobs = [], I.delay = 1, I.timeout_ = null, I;
    }
    var k = w.prototype;
    return k.processJob_ = function() {
      this.jobs.shift()(), this.jobs.length ? this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay) : this.timeout_ = null;
    }, k.push = function(U) {
      this.jobs.push(U), this.timeout_ || (this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay));
    }, w;
  }(s), f = function(w) {
    return w << 24 | (w & 65280) << 8 | (w & 16711680) >> 8 | w >>> 24;
  }, v = function(w, k, I) {
    var U = new Int32Array(w.buffer, w.byteOffset, w.byteLength >> 2), $ = new d(Array.prototype.slice.call(k)), W = new Uint8Array(w.byteLength), G = new Int32Array(W.buffer), Y, re, j, J, z, Q, te, ae, ne;
    for (Y = I[0], re = I[1], j = I[2], J = I[3], ne = 0; ne < U.length; ne += 4)
      z = f(U[ne]), Q = f(U[ne + 1]), te = f(U[ne + 2]), ae = f(U[ne + 3]), $.decrypt(z, Q, te, ae, G, ne), G[ne] = f(G[ne] ^ Y), G[ne + 1] = f(G[ne + 1] ^ re), G[ne + 2] = f(G[ne + 2] ^ j), G[ne + 3] = f(G[ne + 3] ^ J), Y = z, re = Q, j = te, J = ae;
    return W;
  }, b = /* @__PURE__ */ function() {
    function C(k, I, U, $) {
      var W = C.STEP, G = new Int32Array(k.buffer), Y = new Uint8Array(k.byteLength), re = 0;
      for (this.asyncStream_ = new h(), this.asyncStream_.push(this.decryptChunk_(G.subarray(re, re + W), I, U, Y)), re = W; re < G.length; re += W)
        U = new Uint32Array([f(G[re - 4]), f(G[re - 3]), f(G[re - 2]), f(G[re - 1])]), this.asyncStream_.push(this.decryptChunk_(G.subarray(re, re + W), I, U, Y));
      this.asyncStream_.push(function() {
        $(null, o(Y));
      });
    }
    var w = C.prototype;
    return w.decryptChunk_ = function(I, U, $, W) {
      return function() {
        var G = v(I, U, $);
        W.set(G, I.byteOffset);
      };
    }, n(C, null, [{
      key: "STEP",
      get: function() {
        return 32e3;
      }
    }]), C;
  }(), _;
  typeof window < "u" ? _ = window : typeof t < "u" ? _ = t : typeof self < "u" ? _ = self : _ = {};
  var y = _, E = function(w) {
    return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(w) : w && w.buffer instanceof ArrayBuffer;
  }, R = y.BigInt || Number;
  R("0x1"), R("0x100"), R("0x10000"), R("0x1000000"), R("0x100000000"), R("0x10000000000"), R("0x1000000000000"), R("0x100000000000000"), R("0x10000000000000000");
  var D = function(w) {
    var k = {};
    return Object.keys(w).forEach(function(I) {
      var U = w[I];
      E(U) ? k[I] = {
        bytes: U.buffer,
        byteOffset: U.byteOffset,
        byteLength: U.byteLength
      } : k[I] = U;
    }), k;
  };
  self.onmessage = function(C) {
    var w = C.data, k = new Uint8Array(w.encrypted.bytes, w.encrypted.byteOffset, w.encrypted.byteLength), I = new Uint32Array(w.key.bytes, w.key.byteOffset, w.key.byteLength / 4), U = new Uint32Array(w.iv.bytes, w.iv.byteOffset, w.iv.byteLength / 4);
    new b(k, I, U, function($, W) {
      self.postMessage(D({
        source: w.source,
        decrypted: W
      }), [W.buffer]);
    });
  };
})), NA = U0(MA), BA = function(e) {
  var r = e.default ? "main" : "alternative";
  return e.characteristics && e.characteristics.indexOf("public.accessibility.describes-video") >= 0 && (r = "main-desc"), r;
}, Tu = function(e, r) {
  e.abort(), e.pause(), r && r.activePlaylistLoader && (r.activePlaylistLoader.pause(), r.activePlaylistLoader = null);
}, Oc = function(e, r) {
  r.activePlaylistLoader = e, e.load();
}, FA = function(e, r) {
  return function() {
    var n = r.segmentLoaders, i = n[e], a = n.main, s = r.mediaTypes[e], o = s.activeTrack(), u = s.getActiveGroup(), l = s.activePlaylistLoader, d = s.lastGroup_;
    if (!(u && d && u.id === d.id) && (s.lastGroup_ = u, s.lastTrack_ = o, Tu(i, s), !(!u || u.isMasterPlaylist))) {
      if (!u.playlistLoader) {
        l && a.resetEverything();
        return;
      }
      i.resyncLoader(), Oc(u.playlistLoader, s);
    }
  };
}, UA = function(e, r) {
  return function() {
    var n = r.segmentLoaders[e], i = r.mediaTypes[e];
    i.lastGroup_ = null, n.abort(), n.pause();
  };
}, VA = function(e, r) {
  return function() {
    var n = r.masterPlaylistLoader, i = r.segmentLoaders, a = i[e], s = i.main, o = r.mediaTypes[e], u = o.activeTrack(), l = o.getActiveGroup(), d = o.activePlaylistLoader, h = o.lastTrack_;
    if (!(h && u && h.id === u.id) && (o.lastGroup_ = l, o.lastTrack_ = u, Tu(a, o), !!l)) {
      if (l.isMasterPlaylist) {
        if (!u || !h || u.id === h.id)
          return;
        var f = r.vhs.masterPlaylistController_, v = f.selectPlaylist();
        if (f.media() === v)
          return;
        o.logger_("track change. Switching master audio from " + h.id + " to " + u.id), n.pause(), s.resetEverything(), f.fastQualityChange_(v);
        return;
      }
      if (e === "AUDIO") {
        if (!l.playlistLoader) {
          s.setAudio(!0), s.resetEverything();
          return;
        }
        a.setAudio(!0), s.setAudio(!1);
      }
      if (d === l.playlistLoader) {
        Oc(l.playlistLoader, o);
        return;
      }
      a.track && a.track(u), a.resetEverything(), Oc(l.playlistLoader, o);
    }
  };
}, bu = {
  /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning (or error if the playlist is blacklisted) to
   *         console and switches back to default audio track.
   * @function onError.AUDIO
   */
  AUDIO: function(e, r) {
    return function() {
      var n = r.segmentLoaders[e], i = r.mediaTypes[e], a = r.blacklistCurrentPlaylist;
      Tu(n, i);
      var s = i.activeTrack(), o = i.activeGroup(), u = (o.filter(function(h) {
        return h.default;
      })[0] || o[0]).id, l = i.tracks[u];
      if (s === l) {
        a({
          message: "Problem encountered loading the default audio track."
        });
        return;
      }
      P.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
      for (var d in i.tracks)
        i.tracks[d].enabled = i.tracks[d] === l;
      i.onTrackChanged();
    };
  },
  /**
   * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
   * an error.
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Error handler. Logs warning to console and disables the active subtitle track
   * @function onError.SUBTITLES
   */
  SUBTITLES: function(e, r) {
    return function() {
      var n = r.segmentLoaders[e], i = r.mediaTypes[e];
      P.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track."), Tu(n, i);
      var a = i.activeTrack();
      a && (a.mode = "disabled"), i.onTrackChanged();
    };
  }
}, Tg = {
  /**
   * Setup event listeners for audio playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.AUDIO
   */
  AUDIO: function(e, r, n) {
    if (r) {
      var i = n.tech, a = n.requestOptions, s = n.segmentLoaders[e];
      r.on("loadedmetadata", function() {
        var o = r.media();
        s.playlist(o, a), (!i.paused() || o.endList && i.preload() !== "none") && s.load();
      }), r.on("loadedplaylist", function() {
        s.playlist(r.media(), a), i.paused() || s.load();
      }), r.on("error", bu[e](e, n));
    }
  },
  /**
   * Setup event listeners for subtitle playlist loader
   *
   * @param {string} type
   *        MediaGroup type
   * @param {PlaylistLoader|null} playlistLoader
   *        PlaylistLoader to register listeners on
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function setupListeners.SUBTITLES
   */
  SUBTITLES: function(e, r, n) {
    var i = n.tech, a = n.requestOptions, s = n.segmentLoaders[e], o = n.mediaTypes[e];
    r.on("loadedmetadata", function() {
      var u = r.media();
      s.playlist(u, a), s.track(o.activeTrack()), (!i.paused() || u.endList && i.preload() !== "none") && s.load();
    }), r.on("loadedplaylist", function() {
      s.playlist(r.media(), a), i.paused() || s.load();
    }), r.on("error", bu[e](e, n));
  }
}, jA = {
  /**
   * Setup PlaylistLoaders and AudioTracks for the audio groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.AUDIO
   */
  AUDIO: function(e, r) {
    var n = r.vhs, i = r.sourceType, a = r.segmentLoaders[e], s = r.requestOptions, o = r.master.mediaGroups, u = r.mediaTypes[e], l = u.groups, d = u.tracks, h = u.logger_, f = r.masterPlaylistLoader, v = Qs(f.master);
    (!o[e] || Object.keys(o[e]).length === 0) && (o[e] = {
      main: {
        default: {
          default: !0
        }
      }
    }, v && (o[e].main.default.playlists = f.master.playlists));
    for (var b in o[e]) {
      l[b] || (l[b] = []);
      for (var _ in o[e][b]) {
        var y = o[e][b][_], E = void 0;
        if (v ? (h("AUDIO group '" + b + "' label '" + _ + "' is a master playlist"), y.isMasterPlaylist = !0, E = null) : i === "vhs-json" && y.playlists ? E = new ua(y.playlists[0], n, s) : y.resolvedUri ? E = new ua(y.resolvedUri, n, s) : y.playlists && i === "dash" ? E = new Lc(y.playlists[0], n, s, f) : E = null, y = P.mergeOptions({
          id: _,
          playlistLoader: E
        }, y), Tg[e](e, y.playlistLoader, r), l[b].push(y), typeof d[_] > "u") {
          var R = new P.AudioTrack({
            id: _,
            kind: BA(y),
            enabled: !1,
            language: y.language,
            default: y.default,
            label: _
          });
          d[_] = R;
        }
      }
    }
    a.on("error", bu[e](e, r));
  },
  /**
   * Setup PlaylistLoaders and TextTracks for the subtitle groups
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize.SUBTITLES
   */
  SUBTITLES: function(e, r) {
    var n = r.tech, i = r.vhs, a = r.sourceType, s = r.segmentLoaders[e], o = r.requestOptions, u = r.master.mediaGroups, l = r.mediaTypes[e], d = l.groups, h = l.tracks, f = r.masterPlaylistLoader;
    for (var v in u[e]) {
      d[v] || (d[v] = []);
      for (var b in u[e][v])
        if (!u[e][v][b].forced) {
          var _ = u[e][v][b], y = void 0;
          if (a === "hls")
            y = new ua(_.resolvedUri, i, o);
          else if (a === "dash") {
            var E = _.playlists.filter(function(D) {
              return D.excludeUntil !== 1 / 0;
            });
            if (!E.length)
              return;
            y = new Lc(_.playlists[0], i, o, f);
          } else
            a === "vhs-json" && (y = new ua(
              // if the vhs-json object included the media playlist, use the media playlist
              // as provided, otherwise use the resolved URI to load the playlist
              _.playlists ? _.playlists[0] : _.resolvedUri,
              i,
              o
            ));
          if (_ = P.mergeOptions({
            id: b,
            playlistLoader: y
          }, _), Tg[e](e, _.playlistLoader, r), d[v].push(_), typeof h[b] > "u") {
            var R = n.addRemoteTextTrack({
              id: b,
              kind: "subtitles",
              default: _.default && _.autoselect,
              language: _.language,
              label: b
            }, !1).track;
            h[b] = R;
          }
        }
    }
    s.on("error", bu[e](e, r));
  },
  /**
   * Setup TextTracks for the closed-caption groups
   *
   * @param {String} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @function initialize['CLOSED-CAPTIONS']
   */
  "CLOSED-CAPTIONS": function(e, r) {
    var n = r.tech, i = r.master.mediaGroups, a = r.mediaTypes[e], s = a.groups, o = a.tracks;
    for (var u in i[e]) {
      s[u] || (s[u] = []);
      for (var l in i[e][u]) {
        var d = i[e][u][l];
        if (/^(?:CC|SERVICE)/.test(d.instreamId)) {
          var h = n.options_.vhs && n.options_.vhs.captionServices || {}, f = {
            label: l,
            language: d.language,
            instreamId: d.instreamId,
            default: d.default && d.autoselect
          };
          if (h[f.instreamId] && (f = P.mergeOptions(f, h[f.instreamId])), f.default === void 0 && delete f.default, s[u].push(P.mergeOptions({
            id: l
          }, d)), typeof o[l] > "u") {
            var v = n.addRemoteTextTrack({
              id: f.instreamId,
              kind: "captions",
              default: f.default,
              language: f.language,
              label: f.label
            }, !1).track;
            o[l] = v;
          }
        }
      }
    }
  }
}, HA = function t(e, r) {
  for (var n = 0; n < e.length; n++)
    if (rf(r, e[n]) || e[n].playlists && t(e[n].playlists, r))
      return !0;
  return !1;
}, WA = function(e, r) {
  return function(n) {
    var i = r.masterPlaylistLoader, a = r.mediaTypes[e].groups, s = i.media();
    if (!s)
      return null;
    var o = null;
    s.attributes[e] && (o = a[s.attributes[e]]);
    var u = Object.keys(a);
    if (!o)
      if (e === "AUDIO" && u.length > 1 && Qs(r.master))
        for (var l = 0; l < u.length; l++) {
          var d = a[u[l]];
          if (HA(d, s)) {
            o = d;
            break;
          }
        }
      else
        a.main ? o = a.main : u.length === 1 && (o = a[u[0]]);
    return typeof n > "u" ? o : n === null || !o ? null : o.filter(function(h) {
      return h.id === n.id;
    })[0] || null;
  };
}, qA = {
  /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.AUDIO
   */
  AUDIO: function(e, r) {
    return function() {
      var n = r.mediaTypes[e].tracks;
      for (var i in n)
        if (n[i].enabled)
          return n[i];
      return null;
    };
  },
  /**
   * Returns a function used to get the active track of type provided
   *
   * @param {string} type
   *        MediaGroup type
   * @param {Object} settings
   *        Object containing required information for media groups
   * @return {Function}
   *         Function that returns the active media track for the provided type. Returns
   *         null if no track is active
   * @function activeTrack.SUBTITLES
   */
  SUBTITLES: function(e, r) {
    return function() {
      var n = r.mediaTypes[e].tracks;
      for (var i in n)
        if (n[i].mode === "showing" || n[i].mode === "hidden")
          return n[i];
      return null;
    };
  }
}, $A = function(e, r) {
  var n = r.mediaTypes;
  return function() {
    var i = n[e].activeTrack();
    return i ? n[e].activeGroup(i) : null;
  };
}, zA = function(e) {
  ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach(function(b) {
    jA[b](b, e);
  });
  var r = e.mediaTypes, n = e.masterPlaylistLoader, i = e.tech, a = e.vhs, s = e.segmentLoaders, o = s.AUDIO, u = s.main;
  ["AUDIO", "SUBTITLES"].forEach(function(b) {
    r[b].activeGroup = WA(b, e), r[b].activeTrack = qA[b](b, e), r[b].onGroupChanged = FA(b, e), r[b].onGroupChanging = UA(b, e), r[b].onTrackChanged = VA(b, e), r[b].getActiveGroup = $A(b, e);
  });
  var l = r.AUDIO.activeGroup();
  if (l) {
    var d = (l.filter(function(b) {
      return b.default;
    })[0] || l[0]).id;
    r.AUDIO.tracks[d].enabled = !0, r.AUDIO.onGroupChanged(), r.AUDIO.onTrackChanged();
    var h = r.AUDIO.getActiveGroup();
    h.playlistLoader ? (u.setAudio(!1), o.setAudio(!0)) : u.setAudio(!0);
  }
  n.on("mediachange", function() {
    ["AUDIO", "SUBTITLES"].forEach(function(b) {
      return r[b].onGroupChanged();
    });
  }), n.on("mediachanging", function() {
    ["AUDIO", "SUBTITLES"].forEach(function(b) {
      return r[b].onGroupChanging();
    });
  });
  var f = function() {
    r.AUDIO.onTrackChanged(), i.trigger({
      type: "usage",
      name: "vhs-audio-change"
    }), i.trigger({
      type: "usage",
      name: "hls-audio-change"
    });
  };
  i.audioTracks().addEventListener("change", f), i.remoteTextTracks().addEventListener("change", r.SUBTITLES.onTrackChanged), a.on("dispose", function() {
    i.audioTracks().removeEventListener("change", f), i.remoteTextTracks().removeEventListener("change", r.SUBTITLES.onTrackChanged);
  }), i.clearTracks("audio");
  for (var v in r.AUDIO.tracks)
    i.audioTracks().addTrack(r.AUDIO.tracks[v]);
}, GA = function() {
  var e = {};
  return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach(function(r) {
    e[r] = {
      groups: {},
      tracks: {},
      activePlaylistLoader: null,
      activeGroup: Sr,
      activeTrack: Sr,
      getActiveGroup: Sr,
      onGroupChanged: Sr,
      onTrackChanged: Sr,
      lastTrack_: null,
      logger_: Hi("MediaGroups[" + r + "]")
    };
  }), e;
}, KA = 60 * 2, gr, XA = ["mediaRequests", "mediaRequestsAborted", "mediaRequestsTimedout", "mediaRequestsErrored", "mediaTransferDuration", "mediaBytesTransferred", "mediaAppends"], YA = function(e) {
  return this.audioSegmentLoader_[e] + this.mainSegmentLoader_[e];
}, QA = function(e) {
  var r = e.currentPlaylist, n = e.buffered, i = e.currentTime, a = e.nextPlaylist, s = e.bufferLowWaterLine, o = e.bufferHighWaterLine, u = e.duration, l = e.experimentalBufferBasedABR, d = e.log;
  if (!a)
    return P.log.warn("We received no playlist to switch to. Please check your stream."), !1;
  var h = "allowing switch " + (r && r.id || "null") + " -> " + a.id;
  if (!r)
    return d(h + " as current playlist is not set"), !0;
  if (a.id === r.id)
    return !1;
  var f = !!oa(n, i).length;
  if (!r.endList)
    return !f && typeof r.partTargetDuration == "number" ? (d("not " + h + " as current playlist is live llhls, but currentTime isn't in buffered."), !1) : (d(h + " as current playlist is live"), !0);
  var v = Zh(n, i), b = l ? Bt.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : Bt.MAX_BUFFER_LOW_WATER_LINE;
  if (u < b)
    return d(h + " as duration < max low water line (" + u + " < " + b + ")"), !0;
  var _ = a.attributes.BANDWIDTH, y = r.attributes.BANDWIDTH;
  if (_ < y && (!l || v < o)) {
    var E = h + " as next bandwidth < current bandwidth (" + _ + " < " + y + ")";
    return l && (E += " and forwardBuffer < bufferHighWaterLine (" + v + " < " + o + ")"), d(E), !0;
  }
  if ((!l || _ > y) && v >= s) {
    var R = h + " as forwardBuffer >= bufferLowWaterLine (" + v + " >= " + s + ")";
    return l && (R += " and next bandwidth > current bandwidth (" + _ + " > " + y + ")"), d(R), !0;
  }
  return d("not " + h + " as no switching criteria met"), !1;
}, JA = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n) {
    var i;
    i = t.call(this) || this;
    var a = n.src, s = n.handleManifestRedirects, o = n.withCredentials, u = n.tech, l = n.bandwidth, d = n.externVhs, h = n.useCueTags, f = n.blacklistDuration, v = n.enableLowInitialPlaylist, b = n.sourceType, _ = n.cacheEncryptionKeys, y = n.experimentalBufferBasedABR, E = n.experimentalLeastPixelDiffSelector, R = n.captionServices;
    if (!a)
      throw new Error("A non-empty playlist URL or JSON manifest string is required");
    var D = n.maxPlaylistRetries;
    (D === null || typeof D > "u") && (D = 1 / 0), gr = d, i.experimentalBufferBasedABR = !!y, i.experimentalLeastPixelDiffSelector = !!E, i.withCredentials = o, i.tech_ = u, i.vhs_ = u.vhs, i.sourceType_ = b, i.useCueTags_ = h, i.blacklistDuration = f, i.maxPlaylistRetries = D, i.enableLowInitialPlaylist = v, i.useCueTags_ && (i.cueTagsTrack_ = i.tech_.addTextTrack("metadata", "ad-cues"), i.cueTagsTrack_.inBandMetadataTrackDispatchType = ""), i.requestOptions_ = {
      withCredentials: o,
      handleManifestRedirects: s,
      maxPlaylistRetries: D,
      timeout: null
    }, i.on("error", i.pauseLoading), i.mediaTypes_ = GA(), i.mediaSource = new M.MediaSource(), i.handleDurationChange_ = i.handleDurationChange_.bind(Le(i)), i.handleSourceOpen_ = i.handleSourceOpen_.bind(Le(i)), i.handleSourceEnded_ = i.handleSourceEnded_.bind(Le(i)), i.mediaSource.addEventListener("durationchange", i.handleDurationChange_), i.mediaSource.addEventListener("sourceopen", i.handleSourceOpen_), i.mediaSource.addEventListener("sourceended", i.handleSourceEnded_), i.seekable_ = P.createTimeRanges(), i.hasPlayed_ = !1, i.syncController_ = new RA(n), i.segmentMetadataTrack_ = u.addRemoteTextTrack({
      kind: "metadata",
      label: "segment-metadata"
    }, !1).track, i.decrypter_ = new NA(), i.sourceUpdater_ = new e_(i.mediaSource), i.inbandTextTracks_ = {}, i.timelineChangeController_ = new OA();
    var C = {
      vhs: i.vhs_,
      parse708captions: n.parse708captions,
      useDtsForTimestampOffset: n.useDtsForTimestampOffset,
      captionServices: R,
      mediaSource: i.mediaSource,
      currentTime: i.tech_.currentTime.bind(i.tech_),
      seekable: function() {
        return i.seekable();
      },
      seeking: function() {
        return i.tech_.seeking();
      },
      duration: function() {
        return i.duration();
      },
      hasPlayed: function() {
        return i.hasPlayed_;
      },
      goalBufferLength: function() {
        return i.goalBufferLength();
      },
      bandwidth: l,
      syncController: i.syncController_,
      decrypter: i.decrypter_,
      sourceType: i.sourceType_,
      inbandTextTracks: i.inbandTextTracks_,
      cacheEncryptionKeys: _,
      sourceUpdater: i.sourceUpdater_,
      timelineChangeController: i.timelineChangeController_,
      experimentalExactManifestTimings: n.experimentalExactManifestTimings
    };
    i.masterPlaylistLoader_ = i.sourceType_ === "dash" ? new Lc(a, i.vhs_, i.requestOptions_) : new ua(a, i.vhs_, i.requestOptions_), i.setupMasterPlaylistLoaderListeners_(), i.mainSegmentLoader_ = new Dc(P.mergeOptions(C, {
      segmentMetadataTrack: i.segmentMetadataTrack_,
      loaderType: "main"
    }), n), i.audioSegmentLoader_ = new Dc(P.mergeOptions(C, {
      loaderType: "audio"
    }), n), i.subtitleSegmentLoader_ = new kA(P.mergeOptions(C, {
      loaderType: "vtt",
      featuresNativeTextTracks: i.tech_.featuresNativeTextTracks,
      loadVttJs: function() {
        return new Promise(function(I, U) {
          function $() {
            u.off("vttjserror", W), I();
          }
          function W() {
            u.off("vttjsloaded", $), U();
          }
          u.one("vttjsloaded", $), u.one("vttjserror", W), u.addWebVttScript_();
        });
      }
    }), n), i.setupSegmentLoaderListeners_(), i.experimentalBufferBasedABR && (i.masterPlaylistLoader_.one("loadedplaylist", function() {
      return i.startABRTimer_();
    }), i.tech_.on("pause", function() {
      return i.stopABRTimer_();
    }), i.tech_.on("play", function() {
      return i.startABRTimer_();
    })), XA.forEach(function(k) {
      i[k + "_"] = YA.bind(Le(i), k);
    }), i.logger_ = Hi("MPC"), i.triggeredFmp4Usage = !1, i.tech_.preload() === "none" ? (i.loadOnPlay_ = function() {
      i.loadOnPlay_ = null, i.masterPlaylistLoader_.load();
    }, i.tech_.one("play", i.loadOnPlay_)) : i.masterPlaylistLoader_.load(), i.timeToLoadedData__ = -1, i.mainAppendsToLoadedData__ = -1, i.audioAppendsToLoadedData__ = -1;
    var w = i.tech_.preload() === "none" ? "play" : "loadstart";
    return i.tech_.one(w, function() {
      var k = Date.now();
      i.tech_.one("loadeddata", function() {
        i.timeToLoadedData__ = Date.now() - k, i.mainAppendsToLoadedData__ = i.mainSegmentLoader_.mediaAppends, i.audioAppendsToLoadedData__ = i.audioSegmentLoader_.mediaAppends;
      });
    }), i;
  }
  var r = e.prototype;
  return r.mainAppendsToLoadedData_ = function() {
    return this.mainAppendsToLoadedData__;
  }, r.audioAppendsToLoadedData_ = function() {
    return this.audioAppendsToLoadedData__;
  }, r.appendsToLoadedData_ = function() {
    var i = this.mainAppendsToLoadedData_(), a = this.audioAppendsToLoadedData_();
    return i === -1 || a === -1 ? -1 : i + a;
  }, r.timeToLoadedData_ = function() {
    return this.timeToLoadedData__;
  }, r.checkABR_ = function(i) {
    i === void 0 && (i = "abr");
    var a = this.selectPlaylist();
    a && this.shouldSwitchToMedia_(a) && this.switchMedia_(a, i);
  }, r.switchMedia_ = function(i, a, s) {
    var o = this.media(), u = o && (o.id || o.uri), l = i.id || i.uri;
    u && u !== l && (this.logger_("switch media " + u + " -> " + l + " from " + a), this.tech_.trigger({
      type: "usage",
      name: "vhs-rendition-change-" + a
    })), this.masterPlaylistLoader_.media(i, s);
  }, r.startABRTimer_ = function() {
    var i = this;
    this.stopABRTimer_(), this.abrTimer_ = M.setInterval(function() {
      return i.checkABR_();
    }, 250);
  }, r.stopABRTimer_ = function() {
    this.tech_.scrubbing && this.tech_.scrubbing() || (M.clearInterval(this.abrTimer_), this.abrTimer_ = null);
  }, r.getAudioTrackPlaylists_ = function() {
    var i = this.master(), a = i && i.playlists || [];
    if (!i || !i.mediaGroups || !i.mediaGroups.AUDIO)
      return a;
    var s = i.mediaGroups.AUDIO, o = Object.keys(s), u;
    if (Object.keys(this.mediaTypes_.AUDIO.groups).length)
      u = this.mediaTypes_.AUDIO.activeTrack();
    else {
      var l = s.main || o.length && s[o[0]];
      for (var d in l)
        if (l[d].default) {
          u = {
            label: d
          };
          break;
        }
    }
    if (!u)
      return a;
    var h = [];
    for (var f in s)
      if (s[f][u.label]) {
        var v = s[f][u.label];
        if (v.playlists && v.playlists.length)
          h.push.apply(h, v.playlists);
        else if (v.uri)
          h.push(v);
        else if (i.playlists.length)
          for (var b = 0; b < i.playlists.length; b++) {
            var _ = i.playlists[b];
            _.attributes && _.attributes.AUDIO && _.attributes.AUDIO === f && h.push(_);
          }
      }
    return h.length ? h : a;
  }, r.setupMasterPlaylistLoaderListeners_ = function() {
    var i = this;
    this.masterPlaylistLoader_.on("loadedmetadata", function() {
      var a = i.masterPlaylistLoader_.media(), s = a.targetDuration * 1.5 * 1e3;
      Cc(i.masterPlaylistLoader_.master, i.masterPlaylistLoader_.media()) ? i.requestOptions_.timeout = 0 : i.requestOptions_.timeout = s, a.endList && i.tech_.preload() !== "none" && (i.mainSegmentLoader_.playlist(a, i.requestOptions_), i.mainSegmentLoader_.load()), zA({
        sourceType: i.sourceType_,
        segmentLoaders: {
          AUDIO: i.audioSegmentLoader_,
          SUBTITLES: i.subtitleSegmentLoader_,
          main: i.mainSegmentLoader_
        },
        tech: i.tech_,
        requestOptions: i.requestOptions_,
        masterPlaylistLoader: i.masterPlaylistLoader_,
        vhs: i.vhs_,
        master: i.master(),
        mediaTypes: i.mediaTypes_,
        blacklistCurrentPlaylist: i.blacklistCurrentPlaylist.bind(i)
      }), i.triggerPresenceUsage_(i.master(), a), i.setupFirstPlay(), !i.mediaTypes_.AUDIO.activePlaylistLoader || i.mediaTypes_.AUDIO.activePlaylistLoader.media() ? i.trigger("selectedinitialmedia") : i.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", function() {
        i.trigger("selectedinitialmedia");
      });
    }), this.masterPlaylistLoader_.on("loadedplaylist", function() {
      i.loadOnPlay_ && i.tech_.off("play", i.loadOnPlay_);
      var a = i.masterPlaylistLoader_.media();
      if (!a) {
        i.excludeUnsupportedVariants_();
        var s;
        if (i.enableLowInitialPlaylist && (s = i.selectInitialPlaylist()), s || (s = i.selectPlaylist()), !s || !i.shouldSwitchToMedia_(s))
          return;
        i.initialMedia_ = s, i.switchMedia_(i.initialMedia_, "initial");
        var o = i.sourceType_ === "vhs-json" && i.initialMedia_.segments;
        if (!o)
          return;
        a = i.initialMedia_;
      }
      i.handleUpdatedMediaPlaylist(a);
    }), this.masterPlaylistLoader_.on("error", function() {
      i.blacklistCurrentPlaylist(i.masterPlaylistLoader_.error);
    }), this.masterPlaylistLoader_.on("mediachanging", function() {
      i.mainSegmentLoader_.abort(), i.mainSegmentLoader_.pause();
    }), this.masterPlaylistLoader_.on("mediachange", function() {
      var a = i.masterPlaylistLoader_.media(), s = a.targetDuration * 1.5 * 1e3;
      Cc(i.masterPlaylistLoader_.master, i.masterPlaylistLoader_.media()) ? i.requestOptions_.timeout = 0 : i.requestOptions_.timeout = s, i.masterPlaylistLoader_.load(), i.mainSegmentLoader_.playlist(a, i.requestOptions_), i.mainSegmentLoader_.load(), i.tech_.trigger({
        type: "mediachange",
        bubbles: !0
      });
    }), this.masterPlaylistLoader_.on("playlistunchanged", function() {
      var a = i.masterPlaylistLoader_.media();
      if (a.lastExcludeReason_ !== "playlist-unchanged") {
        var s = i.stuckAtPlaylistEnd_(a);
        s && (i.blacklistCurrentPlaylist({
          message: "Playlist no longer updating.",
          reason: "playlist-unchanged"
        }), i.tech_.trigger("playliststuck"));
      }
    }), this.masterPlaylistLoader_.on("renditiondisabled", function() {
      i.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-disabled"
      }), i.tech_.trigger({
        type: "usage",
        name: "hls-rendition-disabled"
      });
    }), this.masterPlaylistLoader_.on("renditionenabled", function() {
      i.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-enabled"
      }), i.tech_.trigger({
        type: "usage",
        name: "hls-rendition-enabled"
      });
    });
  }, r.handleUpdatedMediaPlaylist = function(i) {
    this.useCueTags_ && this.updateAdCues_(i), this.mainSegmentLoader_.playlist(i, this.requestOptions_), this.updateDuration(!i.endList), this.tech_.paused() || (this.mainSegmentLoader_.load(), this.audioSegmentLoader_ && this.audioSegmentLoader_.load());
  }, r.triggerPresenceUsage_ = function(i, a) {
    var s = i.mediaGroups || {}, o = !0, u = Object.keys(s.AUDIO);
    for (var l in s.AUDIO)
      for (var d in s.AUDIO[l]) {
        var h = s.AUDIO[l][d];
        h.uri || (o = !1);
      }
    o && (this.tech_.trigger({
      type: "usage",
      name: "vhs-demuxed"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-demuxed"
    })), Object.keys(s.SUBTITLES).length && (this.tech_.trigger({
      type: "usage",
      name: "vhs-webvtt"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-webvtt"
    })), gr.Playlist.isAes(a) && (this.tech_.trigger({
      type: "usage",
      name: "vhs-aes"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-aes"
    })), u.length && Object.keys(s.AUDIO[u[0]]).length > 1 && (this.tech_.trigger({
      type: "usage",
      name: "vhs-alternate-audio"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-alternate-audio"
    })), this.useCueTags_ && (this.tech_.trigger({
      type: "usage",
      name: "vhs-playlist-cue-tags"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-playlist-cue-tags"
    }));
  }, r.shouldSwitchToMedia_ = function(i) {
    var a = this.masterPlaylistLoader_.media() || this.masterPlaylistLoader_.pendingMedia_, s = this.tech_.currentTime(), o = this.bufferLowWaterLine(), u = this.bufferHighWaterLine(), l = this.tech_.buffered();
    return QA({
      buffered: l,
      currentTime: s,
      currentPlaylist: a,
      nextPlaylist: i,
      bufferLowWaterLine: o,
      bufferHighWaterLine: u,
      duration: this.duration(),
      experimentalBufferBasedABR: this.experimentalBufferBasedABR,
      log: this.logger_
    });
  }, r.setupSegmentLoaderListeners_ = function() {
    var i = this;
    this.mainSegmentLoader_.on("bandwidthupdate", function() {
      i.checkABR_("bandwidthupdate"), i.tech_.trigger("bandwidthupdate");
    }), this.mainSegmentLoader_.on("timeout", function() {
      i.experimentalBufferBasedABR && i.mainSegmentLoader_.load();
    }), this.experimentalBufferBasedABR || this.mainSegmentLoader_.on("progress", function() {
      i.trigger("progress");
    }), this.mainSegmentLoader_.on("error", function() {
      i.blacklistCurrentPlaylist(i.mainSegmentLoader_.error());
    }), this.mainSegmentLoader_.on("appenderror", function() {
      i.error = i.mainSegmentLoader_.error_, i.trigger("error");
    }), this.mainSegmentLoader_.on("syncinfoupdate", function() {
      i.onSyncInfoUpdate_();
    }), this.mainSegmentLoader_.on("timestampoffset", function() {
      i.tech_.trigger({
        type: "usage",
        name: "vhs-timestamp-offset"
      }), i.tech_.trigger({
        type: "usage",
        name: "hls-timestamp-offset"
      });
    }), this.audioSegmentLoader_.on("syncinfoupdate", function() {
      i.onSyncInfoUpdate_();
    }), this.audioSegmentLoader_.on("appenderror", function() {
      i.error = i.audioSegmentLoader_.error_, i.trigger("error");
    }), this.mainSegmentLoader_.on("ended", function() {
      i.logger_("main segment loader ended"), i.onEndOfStream();
    }), this.mainSegmentLoader_.on("earlyabort", function(s) {
      i.experimentalBufferBasedABR || (i.delegateLoaders_("all", ["abort"]), i.blacklistCurrentPlaylist({
        message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
      }, KA));
    });
    var a = function() {
      if (!i.sourceUpdater_.hasCreatedSourceBuffers())
        return i.tryToCreateSourceBuffers_();
      var o = i.getCodecsOrExclude_();
      o && i.sourceUpdater_.addOrChangeSourceBuffers(o);
    };
    this.mainSegmentLoader_.on("trackinfo", a), this.audioSegmentLoader_.on("trackinfo", a), this.mainSegmentLoader_.on("fmp4", function() {
      i.triggeredFmp4Usage || (i.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), i.tech_.trigger({
        type: "usage",
        name: "hls-fmp4"
      }), i.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("fmp4", function() {
      i.triggeredFmp4Usage || (i.tech_.trigger({
        type: "usage",
        name: "vhs-fmp4"
      }), i.tech_.trigger({
        type: "usage",
        name: "hls-fmp4"
      }), i.triggeredFmp4Usage = !0);
    }), this.audioSegmentLoader_.on("ended", function() {
      i.logger_("audioSegmentLoader ended"), i.onEndOfStream();
    });
  }, r.mediaSecondsLoaded_ = function() {
    return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
  }, r.load = function() {
    this.mainSegmentLoader_.load(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.load(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.load();
  }, r.smoothQualityChange_ = function(i) {
    i === void 0 && (i = this.selectPlaylist()), this.fastQualityChange_(i);
  }, r.fastQualityChange_ = function(i) {
    var a = this;
    if (i === void 0 && (i = this.selectPlaylist()), i === this.masterPlaylistLoader_.media()) {
      this.logger_("skipping fastQualityChange because new media is same as old");
      return;
    }
    this.switchMedia_(i, "fast-quality"), this.mainSegmentLoader_.resetEverything(function() {
      P.browser.IE_VERSION || P.browser.IS_EDGE ? a.tech_.setCurrentTime(a.tech_.currentTime() + 0.04) : a.tech_.setCurrentTime(a.tech_.currentTime());
    });
  }, r.play = function() {
    if (!this.setupFirstPlay()) {
      this.tech_.ended() && this.tech_.setCurrentTime(0), this.hasPlayed_ && this.load();
      var i = this.tech_.seekable();
      if (this.tech_.duration() === 1 / 0 && this.tech_.currentTime() < i.start(0))
        return this.tech_.setCurrentTime(i.end(i.length - 1));
    }
  }, r.setupFirstPlay = function() {
    var i = this, a = this.masterPlaylistLoader_.media();
    if (!a || this.tech_.paused() || this.hasPlayed_)
      return !1;
    if (!a.endList) {
      var s = this.seekable();
      if (!s.length)
        return !1;
      if (P.browser.IE_VERSION && this.tech_.readyState() === 0)
        return this.tech_.one("loadedmetadata", function() {
          i.trigger("firstplay"), i.tech_.setCurrentTime(s.end(0)), i.hasPlayed_ = !0;
        }), !1;
      this.trigger("firstplay"), this.tech_.setCurrentTime(s.end(0));
    }
    return this.hasPlayed_ = !0, this.load(), !0;
  }, r.handleSourceOpen_ = function() {
    if (this.tryToCreateSourceBuffers_(), this.tech_.autoplay()) {
      var i = this.tech_.play();
      typeof i < "u" && typeof i.then == "function" && i.then(null, function(a) {
      });
    }
    this.trigger("sourceopen");
  }, r.handleSourceEnded_ = function() {
    if (this.inbandTextTracks_.metadataTrack_) {
      var i = this.inbandTextTracks_.metadataTrack_.cues;
      if (!(!i || !i.length)) {
        var a = this.duration();
        i[i.length - 1].endTime = isNaN(a) || Math.abs(a) === 1 / 0 ? Number.MAX_VALUE : a;
      }
    }
  }, r.handleDurationChange_ = function() {
    this.tech_.trigger("durationchange");
  }, r.onEndOfStream = function() {
    var i = this.mainSegmentLoader_.ended_;
    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
      var a = this.mainSegmentLoader_.getCurrentMediaInfo_();
      !a || a.hasVideo ? i = i && this.audioSegmentLoader_.ended_ : i = this.audioSegmentLoader_.ended_;
    }
    i && (this.stopABRTimer_(), this.sourceUpdater_.endOfStream());
  }, r.stuckAtPlaylistEnd_ = function(i) {
    var a = this.seekable();
    if (!a.length)
      return !1;
    var s = this.syncController_.getExpiredTime(i, this.duration());
    if (s === null)
      return !1;
    var o = gr.Playlist.playlistEnd(i, s), u = this.tech_.currentTime(), l = this.tech_.buffered();
    if (!l.length)
      return o - u <= tr;
    var d = l.end(l.length - 1);
    return d - u <= tr && o - d <= tr;
  }, r.blacklistCurrentPlaylist = function(i, a) {
    i === void 0 && (i = {});
    var s = i.playlist || this.masterPlaylistLoader_.media();
    if (a = a || i.blacklistDuration || this.blacklistDuration, !s) {
      this.error = i, this.mediaSource.readyState !== "open" ? this.trigger("error") : this.sourceUpdater_.endOfStream("network");
      return;
    }
    s.playlistErrors_++;
    var o = this.masterPlaylistLoader_.master.playlists, u = o.filter(Ju), l = u.length === 1 && u[0] === s;
    if (o.length === 1 && a !== 1 / 0)
      return P.log.warn("Problem encountered with playlist " + s.id + ". Trying again since it is the only playlist."), this.tech_.trigger("retryplaylist"), this.masterPlaylistLoader_.load(l);
    if (l) {
      var d = !1;
      o.forEach(function(E) {
        if (E !== s) {
          var R = E.excludeUntil;
          typeof R < "u" && R !== 1 / 0 && (d = !0, delete E.excludeUntil);
        }
      }), d && (P.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."), this.tech_.trigger("retryplaylist"));
    }
    var h;
    s.playlistErrors_ > this.maxPlaylistRetries ? h = 1 / 0 : h = Date.now() + a * 1e3, s.excludeUntil = h, i.reason && (s.lastExcludeReason_ = i.reason), this.tech_.trigger("blacklistplaylist"), this.tech_.trigger({
      type: "usage",
      name: "vhs-rendition-blacklisted"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-rendition-blacklisted"
    });
    var f = this.selectPlaylist();
    if (!f) {
      this.error = "Playback cannot continue. No available working or supported playlists.", this.trigger("error");
      return;
    }
    var v = i.internal ? this.logger_ : P.log.warn, b = i.message ? " " + i.message : "";
    v((i.internal ? "Internal problem" : "Problem") + " encountered with playlist " + s.id + "." + (b + " Switching to playlist " + f.id + ".")), f.attributes.AUDIO !== s.attributes.AUDIO && this.delegateLoaders_("audio", ["abort", "pause"]), f.attributes.SUBTITLES !== s.attributes.SUBTITLES && this.delegateLoaders_("subtitle", ["abort", "pause"]), this.delegateLoaders_("main", ["abort", "pause"]);
    var _ = f.targetDuration / 2 * 1e3 || 5 * 1e3, y = typeof f.lastRequest == "number" && Date.now() - f.lastRequest <= _;
    return this.switchMedia_(f, "exclude", l || y);
  }, r.pauseLoading = function() {
    this.delegateLoaders_("all", ["abort", "pause"]), this.stopABRTimer_();
  }, r.delegateLoaders_ = function(i, a) {
    var s = this, o = [], u = i === "all";
    (u || i === "main") && o.push(this.masterPlaylistLoader_);
    var l = [];
    (u || i === "audio") && l.push("AUDIO"), (u || i === "subtitle") && (l.push("CLOSED-CAPTIONS"), l.push("SUBTITLES")), l.forEach(function(d) {
      var h = s.mediaTypes_[d] && s.mediaTypes_[d].activePlaylistLoader;
      h && o.push(h);
    }), ["main", "audio", "subtitle"].forEach(function(d) {
      var h = s[d + "SegmentLoader_"];
      h && (i === d || i === "all") && o.push(h);
    }), o.forEach(function(d) {
      return a.forEach(function(h) {
        typeof d[h] == "function" && d[h]();
      });
    });
  }, r.setCurrentTime = function(i) {
    var a = oa(this.tech_.buffered(), i);
    if (!(this.masterPlaylistLoader_ && this.masterPlaylistLoader_.media()) || !this.masterPlaylistLoader_.media().segments)
      return 0;
    if (a && a.length)
      return i;
    this.mainSegmentLoader_.resetEverything(), this.mainSegmentLoader_.abort(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.resetEverything(), this.audioSegmentLoader_.abort()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.resetEverything(), this.subtitleSegmentLoader_.abort()), this.load();
  }, r.duration = function() {
    if (!this.masterPlaylistLoader_)
      return 0;
    var i = this.masterPlaylistLoader_.media();
    return i ? i.endList ? this.mediaSource ? this.mediaSource.duration : gr.Playlist.duration(i) : 1 / 0 : 0;
  }, r.seekable = function() {
    return this.seekable_;
  }, r.onSyncInfoUpdate_ = function() {
    var i;
    if (this.masterPlaylistLoader_) {
      var a = this.masterPlaylistLoader_.media();
      if (a) {
        var s = this.syncController_.getExpiredTime(a, this.duration());
        if (s !== null) {
          var o = this.masterPlaylistLoader_.master, u = gr.Playlist.seekable(a, s, gr.Playlist.liveEdgeDelay(o, a));
          if (u.length !== 0 && !(this.mediaTypes_.AUDIO.activePlaylistLoader && (a = this.mediaTypes_.AUDIO.activePlaylistLoader.media(), s = this.syncController_.getExpiredTime(a, this.duration()), s === null || (i = gr.Playlist.seekable(a, s, gr.Playlist.liveEdgeDelay(o, a)), i.length === 0)))) {
            var l, d;
            this.seekable_ && this.seekable_.length && (l = this.seekable_.end(0), d = this.seekable_.start(0)), i ? i.start(0) > u.end(0) || u.start(0) > i.end(0) ? this.seekable_ = u : this.seekable_ = P.createTimeRanges([[i.start(0) > u.start(0) ? i.start(0) : u.start(0), i.end(0) < u.end(0) ? i.end(0) : u.end(0)]]) : this.seekable_ = u, !(this.seekable_ && this.seekable_.length && this.seekable_.end(0) === l && this.seekable_.start(0) === d) && (this.logger_("seekable updated [" + v0(this.seekable_) + "]"), this.tech_.trigger("seekablechanged"));
          }
        }
      }
    }
  }, r.updateDuration = function(i) {
    if (this.updateDuration_ && (this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.updateDuration_ = null), this.mediaSource.readyState !== "open") {
      this.updateDuration_ = this.updateDuration.bind(this, i), this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
      return;
    }
    if (i) {
      var a = this.seekable();
      if (!a.length)
        return;
      (isNaN(this.mediaSource.duration) || this.mediaSource.duration < a.end(a.length - 1)) && this.sourceUpdater_.setDuration(a.end(a.length - 1));
      return;
    }
    var s = this.tech_.buffered(), o = gr.Playlist.duration(this.masterPlaylistLoader_.media());
    s.length > 0 && (o = Math.max(o, s.end(s.length - 1))), this.mediaSource.duration !== o && this.sourceUpdater_.setDuration(o);
  }, r.dispose = function() {
    var i = this;
    this.trigger("dispose"), this.decrypter_.terminate(), this.masterPlaylistLoader_.dispose(), this.mainSegmentLoader_.dispose(), this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_), ["AUDIO", "SUBTITLES"].forEach(function(a) {
      var s = i.mediaTypes_[a].groups;
      for (var o in s)
        s[o].forEach(function(u) {
          u.playlistLoader && u.playlistLoader.dispose();
        });
    }), this.audioSegmentLoader_.dispose(), this.subtitleSegmentLoader_.dispose(), this.sourceUpdater_.dispose(), this.timelineChangeController_.dispose(), this.stopABRTimer_(), this.updateDuration_ && this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_), this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_), this.off();
  }, r.master = function() {
    return this.masterPlaylistLoader_.master;
  }, r.media = function() {
    return this.masterPlaylistLoader_.media() || this.initialMedia_;
  }, r.areMediaTypesKnown_ = function() {
    var i = !!this.mediaTypes_.AUDIO.activePlaylistLoader, a = !!this.mainSegmentLoader_.getCurrentMediaInfo_(), s = i ? !!this.audioSegmentLoader_.getCurrentMediaInfo_() : !0;
    return !(!a || !s);
  }, r.getCodecsOrExclude_ = function() {
    var i = this, a = {
      main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
      audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
    }, s = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media();
    a.video = a.main;
    var o = Ss(this.master(), s), u = {}, l = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
    if (a.main.hasVideo && (u.video = o.video || a.main.videoCodec || bS), a.main.isMuxed && (u.video += "," + (o.audio || a.main.audioCodec || rp)), (a.main.hasAudio && !a.main.isMuxed || a.audio.hasAudio || l) && (u.audio = o.audio || a.main.audioCodec || a.audio.audioCodec || rp, a.audio.isFmp4 = a.main.hasAudio && !a.main.isMuxed ? a.main.isFmp4 : a.audio.isFmp4), !u.audio && !u.video) {
      this.blacklistCurrentPlaylist({
        playlist: s,
        message: "Could not determine codecs for playlist.",
        blacklistDuration: 1 / 0
      });
      return;
    }
    var d = function(E, R) {
      return E ? Uo(R) : kl(R);
    }, h = {}, f;
    if (["video", "audio"].forEach(function(y) {
      if (u.hasOwnProperty(y) && !d(a[y].isFmp4, u[y])) {
        var E = a[y].isFmp4 ? "browser" : "muxer";
        h[E] = h[E] || [], h[E].push(u[y]), y === "audio" && (f = E);
      }
    }), l && f && s.attributes.AUDIO) {
      var v = s.attributes.AUDIO;
      this.master().playlists.forEach(function(y) {
        var E = y.attributes && y.attributes.AUDIO;
        E === v && y !== s && (y.excludeUntil = 1 / 0);
      }), this.logger_("excluding audio group " + v + " as " + f + ' does not support codec(s): "' + u.audio + '"');
    }
    if (Object.keys(h).length) {
      var b = Object.keys(h).reduce(function(y, E) {
        return y && (y += ", "), y += E + ' does not support codec(s): "' + h[E].join(",") + '"', y;
      }, "") + ".";
      this.blacklistCurrentPlaylist({
        playlist: s,
        internal: !0,
        message: b,
        blacklistDuration: 1 / 0
      });
      return;
    }
    if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
      var _ = [];
      if (["video", "audio"].forEach(function(y) {
        var E = (Yi(i.sourceUpdater_.codecs[y] || "")[0] || {}).type, R = (Yi(u[y] || "")[0] || {}).type;
        E && R && E.toLowerCase() !== R.toLowerCase() && _.push('"' + i.sourceUpdater_.codecs[y] + '" -> "' + u[y] + '"');
      }), _.length) {
        this.blacklistCurrentPlaylist({
          playlist: s,
          message: "Codec switching not supported: " + _.join(", ") + ".",
          blacklistDuration: 1 / 0,
          internal: !0
        });
        return;
      }
    }
    return u;
  }, r.tryToCreateSourceBuffers_ = function() {
    if (!(this.mediaSource.readyState !== "open" || this.sourceUpdater_.hasCreatedSourceBuffers()) && this.areMediaTypesKnown_()) {
      var i = this.getCodecsOrExclude_();
      if (i) {
        this.sourceUpdater_.createSourceBuffers(i);
        var a = [i.video, i.audio].filter(Boolean).join(",");
        this.excludeIncompatibleVariants_(a);
      }
    }
  }, r.excludeUnsupportedVariants_ = function() {
    var i = this, a = this.master().playlists, s = [];
    Object.keys(a).forEach(function(o) {
      var u = a[o];
      if (s.indexOf(u.id) === -1) {
        s.push(u.id);
        var l = Ss(i.master, u), d = [];
        l.audio && !kl(l.audio) && !Uo(l.audio) && d.push("audio codec " + l.audio), l.video && !kl(l.video) && !Uo(l.video) && d.push("video codec " + l.video), l.text && l.text === "stpp.ttml.im1t" && d.push("text codec " + l.text), d.length && (u.excludeUntil = 1 / 0, i.logger_("excluding " + u.id + " for unsupported: " + d.join(", ")));
      }
    });
  }, r.excludeIncompatibleVariants_ = function(i) {
    var a = this, s = [], o = this.master().playlists, u = yu(Yi(i)), l = lg(u), d = u.video && Yi(u.video)[0] || null, h = u.audio && Yi(u.audio)[0] || null;
    Object.keys(o).forEach(function(f) {
      var v = o[f];
      if (!(s.indexOf(v.id) !== -1 || v.excludeUntil === 1 / 0)) {
        s.push(v.id);
        var b = [], _ = Ss(a.masterPlaylistLoader_.master, v), y = lg(_);
        if (!(!_.audio && !_.video)) {
          if (y !== l && b.push('codec count "' + y + '" !== "' + l + '"'), !a.sourceUpdater_.canChangeType()) {
            var E = _.video && Yi(_.video)[0] || null, R = _.audio && Yi(_.audio)[0] || null;
            E && d && E.type.toLowerCase() !== d.type.toLowerCase() && b.push('video codec "' + E.type + '" !== "' + d.type + '"'), R && h && R.type.toLowerCase() !== h.type.toLowerCase() && b.push('audio codec "' + R.type + '" !== "' + h.type + '"');
          }
          b.length && (v.excludeUntil = 1 / 0, a.logger_("blacklisting " + v.id + ": " + b.join(" && ")));
        }
      }
    });
  }, r.updateAdCues_ = function(i) {
    var a = 0, s = this.seekable();
    s.length && (a = s.start(0)), IA(i, this.cueTagsTrack_, a);
  }, r.goalBufferLength = function() {
    var i = this.tech_.currentTime(), a = Bt.GOAL_BUFFER_LENGTH, s = Bt.GOAL_BUFFER_LENGTH_RATE, o = Math.max(a, Bt.MAX_GOAL_BUFFER_LENGTH);
    return Math.min(a + i * s, o);
  }, r.bufferLowWaterLine = function() {
    var i = this.tech_.currentTime(), a = Bt.BUFFER_LOW_WATER_LINE, s = Bt.BUFFER_LOW_WATER_LINE_RATE, o = Math.max(a, Bt.MAX_BUFFER_LOW_WATER_LINE), u = Math.max(a, Bt.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
    return Math.min(a + i * s, this.experimentalBufferBasedABR ? u : o);
  }, r.bufferHighWaterLine = function() {
    return Bt.BUFFER_HIGH_WATER_LINE;
  }, e;
}(P.EventTarget), ZA = function(e, r, n) {
  return function(i) {
    var a = e.master.playlists[r], s = tf(a), o = Ju(a);
    return typeof i > "u" ? o : (i ? delete a.disabled : a.disabled = !0, i !== o && !s && (n(), i ? e.trigger("renditionenabled") : e.trigger("renditiondisabled")), i);
  };
}, ew = function(e, r, n) {
  var i = e.masterPlaylistController_, a = e.options_.smoothQualityChange, s = a ? "smooth" : "fast", o = i[s + "QualityChange_"].bind(i);
  if (r.attributes) {
    var u = r.attributes.RESOLUTION;
    this.width = u && u.width, this.height = u && u.height, this.bandwidth = r.attributes.BANDWIDTH, this.frameRate = r.attributes["FRAME-RATE"];
  }
  this.codecs = Ss(i.master(), r), this.playlist = r, this.id = n, this.enabled = ZA(e.playlists, r.id, o);
}, tw = function(e) {
  e.representations = function() {
    var r = e.masterPlaylistController_.master(), n = Qs(r) ? e.masterPlaylistController_.getAudioTrackPlaylists_() : r.playlists;
    return n ? n.filter(function(i) {
      return !tf(i);
    }).map(function(i, a) {
      return new ew(e, i, i.id);
    }) : [];
  };
}, bg = ["seeking", "seeked", "pause", "playing", "error"], iw = /* @__PURE__ */ function() {
  function t(r) {
    var n = this;
    this.masterPlaylistController_ = r.masterPlaylistController, this.tech_ = r.tech, this.seekable = r.seekable, this.allowSeeksWithinUnsafeLiveWindow = r.allowSeeksWithinUnsafeLiveWindow, this.liveRangeSafeTimeDelta = r.liveRangeSafeTimeDelta, this.media = r.media, this.consecutiveUpdates = 0, this.lastRecordedTime = null, this.timer_ = null, this.checkCurrentTimeTimeout_ = null, this.logger_ = Hi("PlaybackWatcher"), this.logger_("initialize");
    var i = function() {
      return n.monitorCurrentTime_();
    }, a = function() {
      return n.monitorCurrentTime_();
    }, s = function() {
      return n.techWaiting_();
    }, o = function() {
      return n.cancelTimer_();
    }, u = this.masterPlaylistController_, l = ["main", "subtitle", "audio"], d = {};
    l.forEach(function(f) {
      d[f] = {
        reset: function() {
          return n.resetSegmentDownloads_(f);
        },
        updateend: function() {
          return n.checkSegmentDownloads_(f);
        }
      }, u[f + "SegmentLoader_"].on("appendsdone", d[f].updateend), u[f + "SegmentLoader_"].on("playlistupdate", d[f].reset), n.tech_.on(["seeked", "seeking"], d[f].reset);
    });
    var h = function(v) {
      ["main", "audio"].forEach(function(b) {
        u[b + "SegmentLoader_"][v]("appended", n.seekingAppendCheck_);
      });
    };
    this.seekingAppendCheck_ = function() {
      n.fixesBadSeeks_() && (n.consecutiveUpdates = 0, n.lastRecordedTime = n.tech_.currentTime(), h("off"));
    }, this.clearSeekingAppendCheck_ = function() {
      return h("off");
    }, this.watchForBadSeeking_ = function() {
      n.clearSeekingAppendCheck_(), h("on");
    }, this.tech_.on("seeked", this.clearSeekingAppendCheck_), this.tech_.on("seeking", this.watchForBadSeeking_), this.tech_.on("waiting", s), this.tech_.on(bg, o), this.tech_.on("canplay", a), this.tech_.one("play", i), this.dispose = function() {
      n.clearSeekingAppendCheck_(), n.logger_("dispose"), n.tech_.off("waiting", s), n.tech_.off(bg, o), n.tech_.off("canplay", a), n.tech_.off("play", i), n.tech_.off("seeking", n.watchForBadSeeking_), n.tech_.off("seeked", n.clearSeekingAppendCheck_), l.forEach(function(f) {
        u[f + "SegmentLoader_"].off("appendsdone", d[f].updateend), u[f + "SegmentLoader_"].off("playlistupdate", d[f].reset), n.tech_.off(["seeked", "seeking"], d[f].reset);
      }), n.checkCurrentTimeTimeout_ && M.clearTimeout(n.checkCurrentTimeTimeout_), n.cancelTimer_();
    };
  }
  var e = t.prototype;
  return e.monitorCurrentTime_ = function() {
    this.checkCurrentTime_(), this.checkCurrentTimeTimeout_ && M.clearTimeout(this.checkCurrentTimeTimeout_), this.checkCurrentTimeTimeout_ = M.setTimeout(this.monitorCurrentTime_.bind(this), 250);
  }, e.resetSegmentDownloads_ = function(n) {
    var i = this.masterPlaylistController_[n + "SegmentLoader_"];
    this[n + "StalledDownloads_"] > 0 && this.logger_("resetting possible stalled download count for " + n + " loader"), this[n + "StalledDownloads_"] = 0, this[n + "Buffered_"] = i.buffered_();
  }, e.checkSegmentDownloads_ = function(n) {
    var i = this.masterPlaylistController_, a = i[n + "SegmentLoader_"], s = a.buffered_(), o = GC(this[n + "Buffered_"], s);
    if (this[n + "Buffered_"] = s, o) {
      this.resetSegmentDownloads_(n);
      return;
    }
    this[n + "StalledDownloads_"]++, this.logger_("found #" + this[n + "StalledDownloads_"] + " " + n + " appends that did not increase buffer (possible stalled download)", {
      playlistId: a.playlist_ && a.playlist_.id,
      buffered: vn(s)
    }), !(this[n + "StalledDownloads_"] < 10) && (this.logger_(n + " loader stalled download exclusion"), this.resetSegmentDownloads_(n), this.tech_.trigger({
      type: "usage",
      name: "vhs-" + n + "-download-exclusion"
    }), n !== "subtitle" && i.blacklistCurrentPlaylist({
      message: "Excessive " + n + " segment downloading detected."
    }, 1 / 0));
  }, e.checkCurrentTime_ = function() {
    if (!(this.tech_.paused() || this.tech_.seeking())) {
      var n = this.tech_.currentTime(), i = this.tech_.buffered();
      if (this.lastRecordedTime === n && (!i.length || n + tr >= i.end(i.length - 1)))
        return this.techWaiting_();
      this.consecutiveUpdates >= 5 && n === this.lastRecordedTime ? (this.consecutiveUpdates++, this.waiting_()) : n === this.lastRecordedTime ? this.consecutiveUpdates++ : (this.consecutiveUpdates = 0, this.lastRecordedTime = n);
    }
  }, e.cancelTimer_ = function() {
    this.consecutiveUpdates = 0, this.timer_ && (this.logger_("cancelTimer_"), clearTimeout(this.timer_)), this.timer_ = null;
  }, e.fixesBadSeeks_ = function() {
    var n = this.tech_.seeking();
    if (!n)
      return !1;
    var i = this.seekable(), a = this.tech_.currentTime(), s = this.afterSeekableWindow_(i, a, this.media(), this.allowSeeksWithinUnsafeLiveWindow), o;
    if (s) {
      var u = i.end(i.length - 1);
      o = u;
    }
    if (this.beforeSeekableWindow_(i, a)) {
      var l = i.start(0);
      o = l + // if the playlist is too short and the seekable range is an exact time (can
      // happen in live with a 3 segment playlist), then don't use a time delta
      (l === i.end(0) ? 0 : tr);
    }
    if (typeof o < "u")
      return this.logger_("Trying to seek outside of seekable at time " + a + " with " + ("seekable range " + v0(i) + ". Seeking to ") + (o + ".")), this.tech_.setCurrentTime(o), !0;
    for (var d = this.masterPlaylistController_.sourceUpdater_, h = this.tech_.buffered(), f = d.audioBuffer ? d.audioBuffered() : null, v = d.videoBuffer ? d.videoBuffered() : null, b = this.media(), _ = b.partTargetDuration ? b.partTargetDuration : (b.targetDuration - Xr) * 2, y = [f, v], E = 0; E < y.length; E++)
      if (y[E]) {
        var R = Zh(y[E], a);
        if (R < _)
          return !1;
      }
    var D = wo(h, a);
    return D.length === 0 ? !1 : (o = D.start(0) + tr, this.logger_("Buffered region starts (" + D.start(0) + ") " + (" just beyond seek point (" + a + "). Seeking to " + o + ".")), this.tech_.setCurrentTime(o), !0);
  }, e.waiting_ = function() {
    if (!this.techWaiting_()) {
      var n = this.tech_.currentTime(), i = this.tech_.buffered(), a = oa(i, n);
      if (a.length && n + 3 <= a.end(0)) {
        this.cancelTimer_(), this.tech_.setCurrentTime(n), this.logger_("Stopped at " + n + " while inside a buffered region " + ("[" + a.start(0) + " -> " + a.end(0) + "]. Attempting to resume ") + "playback by seeking to the current time."), this.tech_.trigger({
          type: "usage",
          name: "vhs-unknown-waiting"
        }), this.tech_.trigger({
          type: "usage",
          name: "hls-unknown-waiting"
        });
        return;
      }
    }
  }, e.techWaiting_ = function() {
    var n = this.seekable(), i = this.tech_.currentTime();
    if (this.tech_.seeking() || this.timer_ !== null)
      return !0;
    if (this.beforeSeekableWindow_(n, i)) {
      var a = n.end(n.length - 1);
      return this.logger_("Fell out of live window at time " + i + ". Seeking to " + ("live point (seekable end) " + a)), this.cancelTimer_(), this.tech_.setCurrentTime(a), this.tech_.trigger({
        type: "usage",
        name: "vhs-live-resync"
      }), this.tech_.trigger({
        type: "usage",
        name: "hls-live-resync"
      }), !0;
    }
    var s = this.tech_.vhs.masterPlaylistController_.sourceUpdater_, o = this.tech_.buffered(), u = this.videoUnderflow_({
      audioBuffered: s.audioBuffered(),
      videoBuffered: s.videoBuffered(),
      currentTime: i
    });
    if (u)
      return this.cancelTimer_(), this.tech_.setCurrentTime(i), this.tech_.trigger({
        type: "usage",
        name: "vhs-video-underflow"
      }), this.tech_.trigger({
        type: "usage",
        name: "hls-video-underflow"
      }), !0;
    var l = wo(o, i);
    if (l.length > 0) {
      var d = l.start(0) - i;
      return this.logger_("Stopped at " + i + ", setting timer for " + d + ", seeking " + ("to " + l.start(0))), this.cancelTimer_(), this.timer_ = setTimeout(this.skipTheGap_.bind(this), d * 1e3, i), !0;
    }
    return !1;
  }, e.afterSeekableWindow_ = function(n, i, a, s) {
    if (s === void 0 && (s = !1), !n.length)
      return !1;
    var o = n.end(n.length - 1) + tr, u = !a.endList;
    return u && s && (o = n.end(n.length - 1) + a.targetDuration * 3), i > o;
  }, e.beforeSeekableWindow_ = function(n, i) {
    return !!(n.length && // can't fall before 0 and 0 seekable start identifies VOD stream
    n.start(0) > 0 && i < n.start(0) - this.liveRangeSafeTimeDelta);
  }, e.videoUnderflow_ = function(n) {
    var i = n.videoBuffered, a = n.audioBuffered, s = n.currentTime;
    if (i) {
      var o;
      if (i.length && a.length) {
        var u = oa(i, s - 3), l = oa(i, s), d = oa(a, s);
        d.length && !l.length && u.length && (o = {
          start: u.end(0),
          end: d.end(0)
        });
      } else {
        var h = wo(i, s);
        h.length || (o = this.gapFromVideoUnderflow_(i, s));
      }
      return o ? (this.logger_("Encountered a gap in video from " + o.start + " to " + o.end + ". " + ("Seeking to current time " + s)), !0) : !1;
    }
  }, e.skipTheGap_ = function(n) {
    var i = this.tech_.buffered(), a = this.tech_.currentTime(), s = wo(i, a);
    this.cancelTimer_(), !(s.length === 0 || a !== n) && (this.logger_("skipTheGap_:", "currentTime:", a, "scheduled currentTime:", n, "nextRange start:", s.start(0)), this.tech_.setCurrentTime(s.start(0) + Xr), this.tech_.trigger({
      type: "usage",
      name: "vhs-gap-skip"
    }), this.tech_.trigger({
      type: "usage",
      name: "hls-gap-skip"
    }));
  }, e.gapFromVideoUnderflow_ = function(n, i) {
    for (var a = qC(n), s = 0; s < a.length; s++) {
      var o = a.start(s), u = a.end(s);
      if (i - o < 4 && i - o > 2)
        return {
          start: o,
          end: u
        };
    }
    return null;
  }, t;
}(), rw = {
  errorInterval: 30,
  getSource: function(e) {
    var r = this.tech({
      IWillNotUseThisInPlugins: !0
    }), n = r.currentSource_ || this.currentSource();
    return e(n);
  }
}, nw = function t(e, r) {
  var n = 0, i = 0, a = P.mergeOptions(rw, r);
  e.ready(function() {
    e.trigger({
      type: "usage",
      name: "vhs-error-reload-initialized"
    }), e.trigger({
      type: "usage",
      name: "hls-error-reload-initialized"
    });
  });
  var s = function() {
    i && e.currentTime(i);
  }, o = function(f) {
    f != null && (i = e.duration() !== 1 / 0 && e.currentTime() || 0, e.one("loadedmetadata", s), e.src(f), e.trigger({
      type: "usage",
      name: "vhs-error-reload"
    }), e.trigger({
      type: "usage",
      name: "hls-error-reload"
    }), e.play());
  }, u = function() {
    if (Date.now() - n < a.errorInterval * 1e3) {
      e.trigger({
        type: "usage",
        name: "vhs-error-reload-canceled"
      }), e.trigger({
        type: "usage",
        name: "hls-error-reload-canceled"
      });
      return;
    }
    if (!a.getSource || typeof a.getSource != "function") {
      P.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
      return;
    }
    return n = Date.now(), a.getSource.call(e, o);
  }, l = function h() {
    e.off("loadedmetadata", s), e.off("error", u), e.off("dispose", h);
  }, d = function(f) {
    l(), t(e, f);
  };
  e.on("error", u), e.on("dispose", l), e.reloadSourceOnError = d;
}, aw = function(e) {
  nw(this, e);
}, t_ = "2.16.2", sw = "6.0.1", ow = "0.22.1", uw = "4.8.0", lw = "3.1.3", qt = {
  PlaylistLoader: ua,
  Playlist: hi,
  utils: y1,
  STANDARD_PLAYLIST_SELECTOR: cg,
  INITIAL_PLAYLIST_SELECTOR: oA,
  lastBandwidthSelector: cg,
  movingAverageBandwidthSelector: aA,
  comparePlaylistBandwidth: sf,
  comparePlaylistResolution: nA,
  xhr: D0()
};
Object.keys(Bt).forEach(function(t) {
  Object.defineProperty(qt, t, {
    get: function() {
      return P.log.warn("using Vhs." + t + " is UNSAFE be sure you know what you are doing"), Bt[t];
    },
    set: function(r) {
      if (P.log.warn("using Vhs." + t + " is UNSAFE be sure you know what you are doing"), typeof r != "number" || r < 0) {
        P.log.warn("value of Vhs." + t + " must be greater than or equal to 0");
        return;
      }
      Bt[t] = r;
    }
  });
});
var i_ = "videojs-vhs", r_ = function(e, r) {
  for (var n = r.media(), i = -1, a = 0; a < e.length; a++)
    if (e[a].id === n.id) {
      i = a;
      break;
    }
  e.selectedIndex_ = i, e.trigger({
    selectedIndex: i,
    type: "change"
  });
}, dw = function(e, r) {
  r.representations().forEach(function(n) {
    e.addQualityLevel(n);
  }), r_(e, r.playlists);
};
qt.canPlaySource = function() {
  return P.log.warn("HLS is no longer a tech. Please remove it from your player's techOrder.");
};
var cw = function(e, r, n) {
  if (!e)
    return e;
  var i = {};
  r && r.attributes && r.attributes.CODECS && (i = yu(Yi(r.attributes.CODECS))), n && n.attributes && n.attributes.CODECS && (i.audio = n.attributes.CODECS);
  var a = Cs(i.video), s = Cs(i.audio), o = {};
  for (var u in e)
    o[u] = {}, s && (o[u].audioContentType = s), a && (o[u].videoContentType = a), r.contentProtection && r.contentProtection[u] && r.contentProtection[u].pssh && (o[u].pssh = r.contentProtection[u].pssh), typeof e[u] == "string" && (o[u].url = e[u]);
  return P.mergeOptions(e, o);
}, hw = function(e, r) {
  return e.reduce(function(n, i) {
    if (!i.contentProtection)
      return n;
    var a = r.reduce(function(s, o) {
      var u = i.contentProtection[o];
      return u && u.pssh && (s[o] = {
        pssh: u.pssh
      }), s;
    }, {});
    return Object.keys(a).length && n.push(a), n;
  }, []);
}, fw = function(e) {
  var r = e.player, n = e.sourceKeySystems, i = e.audioMedia, a = e.mainPlaylists;
  if (!r.eme.initializeMediaKeys)
    return Promise.resolve();
  var s = i ? a.concat([i]) : a, o = hw(s, Object.keys(n)), u = [], l = [];
  return o.forEach(function(d) {
    l.push(new Promise(function(h, f) {
      r.tech_.one("keysessioncreated", h);
    })), u.push(new Promise(function(h, f) {
      r.eme.initializeMediaKeys({
        keySystems: d
      }, function(v) {
        if (v) {
          f(v);
          return;
        }
        h();
      });
    }));
  }), Promise.race([
    // If a session was previously created, these will all finish resolving without
    // creating a new session, otherwise it will take until the end of all license
    // requests, which is why the key session check is used (to make setup much faster).
    Promise.all(u),
    // Once a single session is created, the browser knows DRM will be used.
    Promise.race(l)
  ]);
}, pw = function(e) {
  var r = e.player, n = e.sourceKeySystems, i = e.media, a = e.audioMedia, s = cw(n, i, a);
  return s ? (r.currentSource().keySystems = s, s && !r.eme ? (P.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin"), !1) : !0) : !1;
}, n_ = function() {
  if (!M.localStorage)
    return null;
  var e = M.localStorage.getItem(i_);
  if (!e)
    return null;
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}, gw = function(e) {
  if (!M.localStorage)
    return !1;
  var r = n_();
  r = r ? P.mergeOptions(r, e) : e;
  try {
    M.localStorage.setItem(i_, JSON.stringify(r));
  } catch {
    return !1;
  }
  return r;
}, mw = function(e) {
  return e.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") === 0 ? JSON.parse(e.substring(e.indexOf(",") + 1)) : e;
};
qt.supportsNativeHls = function() {
  if (!oe || !oe.createElement)
    return !1;
  var t = oe.createElement("video");
  if (!P.getTech("Html5").isSupported())
    return !1;
  var e = [
    // Apple santioned
    "application/vnd.apple.mpegurl",
    // Apple sanctioned for backwards compatibility
    "audio/mpegurl",
    // Very common
    "audio/x-mpegurl",
    // Very common
    "application/x-mpegurl",
    // Included for completeness
    "video/x-mpegurl",
    "video/mpegurl",
    "application/mpegurl"
  ];
  return e.some(function(r) {
    return /maybe|probably/i.test(t.canPlayType(r));
  });
}();
qt.supportsNativeDash = function() {
  return !oe || !oe.createElement || !P.getTech("Html5").isSupported() ? !1 : /maybe|probably/i.test(oe.createElement("video").canPlayType("application/dash+xml"));
}();
qt.supportsTypeNatively = function(t) {
  return t === "hls" ? qt.supportsNativeHls : t === "dash" ? qt.supportsNativeDash : !1;
};
qt.isSupported = function() {
  return P.log.warn("HLS is no longer a tech. Please remove it from your player's techOrder.");
};
var vw = P.getComponent("Component"), uf = /* @__PURE__ */ function(t) {
  le(e, t);
  function e(n, i, a) {
    var s;
    if (s = t.call(this, i, P.mergeOptions(a.hls, a.vhs)) || this, a.hls && Object.keys(a.hls).length && P.log.warn("Using hls options is deprecated. Please rename `hls` to `vhs` in your options object."), typeof a.initialBandwidth == "number" && (s.options_.bandwidth = a.initialBandwidth), s.logger_ = Hi("VhsHandler"), i.options_ && i.options_.playerId) {
      var o = P(i.options_.playerId);
      o.hasOwnProperty("hls") || Object.defineProperty(o, "hls", {
        get: function() {
          return P.log.warn("player.hls is deprecated. Use player.tech().vhs instead."), i.trigger({
            type: "usage",
            name: "hls-player-access"
          }), Le(s);
        },
        configurable: !0
      }), o.hasOwnProperty("vhs") || Object.defineProperty(o, "vhs", {
        get: function() {
          return P.log.warn("player.vhs is deprecated. Use player.tech().vhs instead."), i.trigger({
            type: "usage",
            name: "vhs-player-access"
          }), Le(s);
        },
        configurable: !0
      }), o.hasOwnProperty("dash") || Object.defineProperty(o, "dash", {
        get: function() {
          return P.log.warn("player.dash is deprecated. Use player.tech().vhs instead."), Le(s);
        },
        configurable: !0
      }), s.player_ = o;
    }
    if (s.tech_ = i, s.source_ = n, s.stats = {}, s.ignoreNextSeekingEvent_ = !1, s.setOptions_(), s.options_.overrideNative && i.overrideNativeAudioTracks && i.overrideNativeVideoTracks)
      i.overrideNativeAudioTracks(!0), i.overrideNativeVideoTracks(!0);
    else if (s.options_.overrideNative && (i.featuresNativeVideoTracks || i.featuresNativeAudioTracks))
      throw new Error("Overriding native HLS requires emulated tracks. See https://git.io/vMpjB");
    return s.on(oe, ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"], function(u) {
      var l = oe.fullscreenElement || oe.webkitFullscreenElement || oe.mozFullScreenElement || oe.msFullscreenElement;
      l && l.contains(s.tech_.el()) ? s.masterPlaylistController_.fastQualityChange_() : s.masterPlaylistController_.checkABR_();
    }), s.on(s.tech_, "seeking", function() {
      if (this.ignoreNextSeekingEvent_) {
        this.ignoreNextSeekingEvent_ = !1;
        return;
      }
      this.setCurrentTime(this.tech_.currentTime());
    }), s.on(s.tech_, "error", function() {
      this.tech_.error() && this.masterPlaylistController_ && this.masterPlaylistController_.pauseLoading();
    }), s.on(s.tech_, "play", s.play), s;
  }
  var r = e.prototype;
  return r.setOptions_ = function() {
    var i = this;
    if (this.options_.withCredentials = this.options_.withCredentials || !1, this.options_.handleManifestRedirects = this.options_.handleManifestRedirects !== !1, this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions !== !1, this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || !1, this.options_.smoothQualityChange = this.options_.smoothQualityChange || !1, this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage < "u" ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || !1, this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi || !1, this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || !1, this.options_.customTagParsers = this.options_.customTagParsers || [], this.options_.customTagMappers = this.options_.customTagMappers || [], this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || !1, typeof this.options_.blacklistDuration != "number" && (this.options_.blacklistDuration = 5 * 60), typeof this.options_.bandwidth != "number" && this.options_.useBandwidthFromLocalStorage) {
      var a = n_();
      a && a.bandwidth && (this.options_.bandwidth = a.bandwidth, this.tech_.trigger({
        type: "usage",
        name: "vhs-bandwidth-from-local-storage"
      }), this.tech_.trigger({
        type: "usage",
        name: "hls-bandwidth-from-local-storage"
      })), a && a.throughput && (this.options_.throughput = a.throughput, this.tech_.trigger({
        type: "usage",
        name: "vhs-throughput-from-local-storage"
      }), this.tech_.trigger({
        type: "usage",
        name: "hls-throughput-from-local-storage"
      }));
    }
    typeof this.options_.bandwidth != "number" && (this.options_.bandwidth = Bt.INITIAL_BANDWIDTH), this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === Bt.INITIAL_BANDWIDTH, ["withCredentials", "useDevicePixelRatio", "limitRenditionByPlayerDimensions", "bandwidth", "smoothQualityChange", "customTagParsers", "customTagMappers", "handleManifestRedirects", "cacheEncryptionKeys", "playlistSelector", "initialPlaylistSelector", "experimentalBufferBasedABR", "liveRangeSafeTimeDelta", "experimentalLLHLS", "useNetworkInformationApi", "useDtsForTimestampOffset", "experimentalExactManifestTimings", "experimentalLeastPixelDiffSelector"].forEach(function(s) {
      typeof i.source_[s] < "u" && (i.options_[s] = i.source_[s]);
    }), this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions, this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
  }, r.src = function(i, a) {
    var s = this;
    if (i) {
      this.setOptions_(), this.options_.src = mw(this.source_.src), this.options_.tech = this.tech_, this.options_.externVhs = qt, this.options_.sourceType = vv(a), this.options_.seekTo = function(l) {
        s.tech_.setCurrentTime(l);
      }, this.options_.smoothQualityChange && P.log.warn("smoothQualityChange is deprecated and will be removed in the next major version"), this.masterPlaylistController_ = new JA(this.options_);
      var o = P.mergeOptions({
        liveRangeSafeTimeDelta: tr
      }, this.options_, {
        seekable: function() {
          return s.seekable();
        },
        media: function() {
          return s.masterPlaylistController_.media();
        },
        masterPlaylistController: this.masterPlaylistController_
      });
      this.playbackWatcher_ = new iw(o), this.masterPlaylistController_.on("error", function() {
        var l = P.players[s.tech_.options_.playerId], d = s.masterPlaylistController_.error;
        typeof d == "object" && !d.code ? d.code = 3 : typeof d == "string" && (d = {
          message: d,
          code: 3
        }), l.error(d);
      });
      var u = this.options_.experimentalBufferBasedABR ? qt.movingAverageBandwidthSelector(0.55) : qt.STANDARD_PLAYLIST_SELECTOR;
      this.masterPlaylistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : u.bind(this), this.masterPlaylistController_.selectInitialPlaylist = qt.INITIAL_PLAYLIST_SELECTOR.bind(this), this.playlists = this.masterPlaylistController_.masterPlaylistLoader_, this.mediaSource = this.masterPlaylistController_.mediaSource, Object.defineProperties(this, {
        selectPlaylist: {
          get: function() {
            return this.masterPlaylistController_.selectPlaylist;
          },
          set: function(d) {
            this.masterPlaylistController_.selectPlaylist = d.bind(this);
          }
        },
        throughput: {
          get: function() {
            return this.masterPlaylistController_.mainSegmentLoader_.throughput.rate;
          },
          set: function(d) {
            this.masterPlaylistController_.mainSegmentLoader_.throughput.rate = d, this.masterPlaylistController_.mainSegmentLoader_.throughput.count = 1;
          }
        },
        bandwidth: {
          get: function() {
            var d = this.masterPlaylistController_.mainSegmentLoader_.bandwidth, h = M.navigator.connection || M.navigator.mozConnection || M.navigator.webkitConnection, f = 1e7;
            if (this.options_.useNetworkInformationApi && h) {
              var v = h.downlink * 1e3 * 1e3;
              v >= f && d >= f ? d = Math.max(d, v) : d = v;
            }
            return d;
          },
          set: function(d) {
            this.masterPlaylistController_.mainSegmentLoader_.bandwidth = d, this.masterPlaylistController_.mainSegmentLoader_.throughput = {
              rate: 0,
              count: 0
            };
          }
        },
        /**
         * `systemBandwidth` is a combination of two serial processes bit-rates. The first
         * is the network bitrate provided by `bandwidth` and the second is the bitrate of
         * the entire process after that - decryption, transmuxing, and appending - provided
         * by `throughput`.
         *
         * Since the two process are serial, the overall system bandwidth is given by:
         *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
         */
        systemBandwidth: {
          get: function() {
            var d = 1 / (this.bandwidth || 1), h;
            this.throughput > 0 ? h = 1 / this.throughput : h = 0;
            var f = Math.floor(1 / (d + h));
            return f;
          },
          set: function() {
            P.log.error('The "systemBandwidth" property is read-only');
          }
        }
      }), this.options_.bandwidth && (this.bandwidth = this.options_.bandwidth), this.options_.throughput && (this.throughput = this.options_.throughput), Object.defineProperties(this.stats, {
        bandwidth: {
          get: function() {
            return s.bandwidth || 0;
          },
          enumerable: !0
        },
        mediaRequests: {
          get: function() {
            return s.masterPlaylistController_.mediaRequests_() || 0;
          },
          enumerable: !0
        },
        mediaRequestsAborted: {
          get: function() {
            return s.masterPlaylistController_.mediaRequestsAborted_() || 0;
          },
          enumerable: !0
        },
        mediaRequestsTimedout: {
          get: function() {
            return s.masterPlaylistController_.mediaRequestsTimedout_() || 0;
          },
          enumerable: !0
        },
        mediaRequestsErrored: {
          get: function() {
            return s.masterPlaylistController_.mediaRequestsErrored_() || 0;
          },
          enumerable: !0
        },
        mediaTransferDuration: {
          get: function() {
            return s.masterPlaylistController_.mediaTransferDuration_() || 0;
          },
          enumerable: !0
        },
        mediaBytesTransferred: {
          get: function() {
            return s.masterPlaylistController_.mediaBytesTransferred_() || 0;
          },
          enumerable: !0
        },
        mediaSecondsLoaded: {
          get: function() {
            return s.masterPlaylistController_.mediaSecondsLoaded_() || 0;
          },
          enumerable: !0
        },
        mediaAppends: {
          get: function() {
            return s.masterPlaylistController_.mediaAppends_() || 0;
          },
          enumerable: !0
        },
        mainAppendsToLoadedData: {
          get: function() {
            return s.masterPlaylistController_.mainAppendsToLoadedData_() || 0;
          },
          enumerable: !0
        },
        audioAppendsToLoadedData: {
          get: function() {
            return s.masterPlaylistController_.audioAppendsToLoadedData_() || 0;
          },
          enumerable: !0
        },
        appendsToLoadedData: {
          get: function() {
            return s.masterPlaylistController_.appendsToLoadedData_() || 0;
          },
          enumerable: !0
        },
        timeToLoadedData: {
          get: function() {
            return s.masterPlaylistController_.timeToLoadedData_() || 0;
          },
          enumerable: !0
        },
        buffered: {
          get: function() {
            return vn(s.tech_.buffered());
          },
          enumerable: !0
        },
        currentTime: {
          get: function() {
            return s.tech_.currentTime();
          },
          enumerable: !0
        },
        currentSource: {
          get: function() {
            return s.tech_.currentSource_;
          },
          enumerable: !0
        },
        currentTech: {
          get: function() {
            return s.tech_.name_;
          },
          enumerable: !0
        },
        duration: {
          get: function() {
            return s.tech_.duration();
          },
          enumerable: !0
        },
        master: {
          get: function() {
            return s.playlists.master;
          },
          enumerable: !0
        },
        playerDimensions: {
          get: function() {
            return s.tech_.currentDimensions();
          },
          enumerable: !0
        },
        seekable: {
          get: function() {
            return vn(s.tech_.seekable());
          },
          enumerable: !0
        },
        timestamp: {
          get: function() {
            return Date.now();
          },
          enumerable: !0
        },
        videoPlaybackQuality: {
          get: function() {
            return s.tech_.getVideoPlaybackQuality();
          },
          enumerable: !0
        }
      }), this.tech_.one("canplay", this.masterPlaylistController_.setupFirstPlay.bind(this.masterPlaylistController_)), this.tech_.on("bandwidthupdate", function() {
        s.options_.useBandwidthFromLocalStorage && gw({
          bandwidth: s.bandwidth,
          throughput: Math.round(s.throughput)
        });
      }), this.masterPlaylistController_.on("selectedinitialmedia", function() {
        tw(s);
      }), this.masterPlaylistController_.sourceUpdater_.on("createdsourcebuffers", function() {
        s.setupEme_();
      }), this.on(this.masterPlaylistController_, "progress", function() {
        this.tech_.trigger("progress");
      }), this.on(this.masterPlaylistController_, "firstplay", function() {
        this.ignoreNextSeekingEvent_ = !0;
      }), this.setupQualityLevels_(), this.tech_.el() && (this.mediaSourceUrl_ = M.URL.createObjectURL(this.masterPlaylistController_.mediaSource), this.tech_.src(this.mediaSourceUrl_));
    }
  }, r.createKeySessions_ = function() {
    var i = this, a = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;
    this.logger_("waiting for EME key session creation"), fw({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      audioMedia: a && a.media(),
      mainPlaylists: this.playlists.master.playlists
    }).then(function() {
      i.logger_("created EME key session"), i.masterPlaylistController_.sourceUpdater_.initializedEme();
    }).catch(function(s) {
      i.logger_("error while creating EME key session", s), i.player_.error({
        message: "Failed to initialize media keys for EME",
        code: 3
      });
    });
  }, r.handleWaitingForKey_ = function() {
    this.logger_("waitingforkey fired, attempting to create any new key sessions"), this.createKeySessions_();
  }, r.setupEme_ = function() {
    var i = this, a = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader, s = pw({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      media: this.playlists.media(),
      audioMedia: a && a.media()
    });
    if (this.player_.tech_.on("keystatuschange", function(o) {
      if (o.status === "output-restricted") {
        var u = i.masterPlaylistController_.master();
        if (!(!u || !u.playlists)) {
          var l = [];
          if (u.playlists.forEach(function(h) {
            h && h.attributes && h.attributes.RESOLUTION && h.attributes.RESOLUTION.height >= 720 && (!h.excludeUntil || h.excludeUntil < 1 / 0) && (h.excludeUntil = 1 / 0, l.push(h));
          }), l.length) {
            var d;
            (d = P.log).warn.apply(d, ['DRM keystatus changed to "output-restricted." Removing the following HD playlists that will most likely fail to play and clearing the buffer. This may be due to HDCP restrictions on the stream and the capabilities of the current device.'].concat(l)), i.masterPlaylistController_.fastQualityChange_();
          }
        }
      }
    }), this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this), this.player_.tech_.on("waitingforkey", this.handleWaitingForKey_), P.browser.IE_VERSION === 11 || !s) {
      this.masterPlaylistController_.sourceUpdater_.initializedEme();
      return;
    }
    this.createKeySessions_();
  }, r.setupQualityLevels_ = function() {
    var i = this, a = P.players[this.tech_.options_.playerId];
    !a || !a.qualityLevels || this.qualityLevels_ || (this.qualityLevels_ = a.qualityLevels(), this.masterPlaylistController_.on("selectedinitialmedia", function() {
      dw(i.qualityLevels_, i);
    }), this.playlists.on("mediachange", function() {
      r_(i.qualityLevels_, i.playlists);
    }));
  }, e.version = function() {
    return {
      "@videojs/http-streaming": t_,
      "mux.js": sw,
      "mpd-parser": ow,
      "m3u8-parser": uw,
      "aes-decrypter": lw
    };
  }, r.version = function() {
    return this.constructor.version();
  }, r.canChangeType = function() {
    return e_.canChangeType();
  }, r.play = function() {
    this.masterPlaylistController_.play();
  }, r.setCurrentTime = function(i) {
    this.masterPlaylistController_.setCurrentTime(i);
  }, r.duration = function() {
    return this.masterPlaylistController_.duration();
  }, r.seekable = function() {
    return this.masterPlaylistController_.seekable();
  }, r.dispose = function() {
    this.playbackWatcher_ && this.playbackWatcher_.dispose(), this.masterPlaylistController_ && this.masterPlaylistController_.dispose(), this.qualityLevels_ && this.qualityLevels_.dispose(), this.player_ && (delete this.player_.vhs, delete this.player_.dash, delete this.player_.hls), this.tech_ && this.tech_.vhs && delete this.tech_.vhs, this.tech_ && delete this.tech_.hls, this.mediaSourceUrl_ && M.URL.revokeObjectURL && (M.URL.revokeObjectURL(this.mediaSourceUrl_), this.mediaSourceUrl_ = null), this.tech_ && this.tech_.off("waitingforkey", this.handleWaitingForKey_), t.prototype.dispose.call(this);
  }, r.convertToProgramTime = function(i, a) {
    return C1({
      playlist: this.masterPlaylistController_.media(),
      time: i,
      callback: a
    });
  }, r.seekToProgramTime = function(i, a, s, o) {
    return s === void 0 && (s = !0), o === void 0 && (o = 2), A1({
      programTime: i,
      playlist: this.masterPlaylistController_.media(),
      retryCount: o,
      pauseAfterSeek: s,
      seekTo: this.options_.seekTo,
      tech: this.options_.tech,
      callback: a
    });
  }, e;
}(vw), Os = {
  name: "videojs-http-streaming",
  VERSION: t_,
  canHandleSource: function(e, r) {
    r === void 0 && (r = {});
    var n = P.mergeOptions(P.options, r);
    return Os.canPlayType(e.type, n);
  },
  handleSource: function(e, r, n) {
    n === void 0 && (n = {});
    var i = P.mergeOptions(P.options, n);
    return r.vhs = new uf(e, r, i), P.hasOwnProperty("hls") || Object.defineProperty(r, "hls", {
      get: function() {
        return P.log.warn("player.tech().hls is deprecated. Use player.tech().vhs instead."), r.vhs;
      },
      configurable: !0
    }), r.vhs.xhr = D0(), r.vhs.src(e.src, e.type), r.vhs;
  },
  canPlayType: function(e, r) {
    var n = vv(e);
    if (!n)
      return "";
    var i = Os.getOverrideNative(r), a = qt.supportsTypeNatively(n), s = !a || i;
    return s ? "maybe" : "";
  },
  getOverrideNative: function(e) {
    e === void 0 && (e = {});
    var r = e, n = r.vhs, i = n === void 0 ? {} : n, a = r.hls, s = a === void 0 ? {} : a, o = !(P.browser.IS_ANY_SAFARI || P.browser.IS_IOS), u = i.overrideNative, l = u === void 0 ? o : u, d = s.overrideNative, h = d === void 0 ? !1 : d;
    return h || l;
  }
}, yw = function() {
  return Uo("avc1.4d400d,mp4a.40.2");
};
yw() && P.getTech("Html5").registerSourceHandler(Os, 0);
P.VhsHandler = uf;
Object.defineProperty(P, "HlsHandler", {
  get: function() {
    return P.log.warn("videojs.HlsHandler is deprecated. Use videojs.VhsHandler instead."), uf;
  },
  configurable: !0
});
P.VhsSourceHandler = Os;
Object.defineProperty(P, "HlsSourceHandler", {
  get: function() {
    return P.log.warn("videojs.HlsSourceHandler is deprecated. Use videojs.VhsSourceHandler instead."), Os;
  },
  configurable: !0
});
P.Vhs = qt;
Object.defineProperty(P, "Hls", {
  get: function() {
    return P.log.warn("videojs.Hls is deprecated. Use videojs.Vhs instead."), qt;
  },
  configurable: !0
});
P.use || (P.registerComponent("Hls", qt), P.registerComponent("Vhs", qt));
P.options.vhs = P.options.vhs || {};
P.options.hls = P.options.hls || {};
if (!P.getPlugin || !P.getPlugin("reloadSourceOnError")) {
  var _w = P.registerPlugin || P.plugin;
  _w("reloadSourceOnError", aw);
}
const Tw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: P
}, Symbol.toStringTag, { value: "Module" }));
var ov;
(ov = P.getComponent("ControlBar").prototype.options_.children) == null || ov.splice(16, 0, "SettingMenuButton");
P.hook("setup", (t) => {
  t.addClass("video-js"), t.addClass("vjs-theme-pxl"), t.utils = {
    // @ts-expect-error ...
    formatTime: P.formatTime
  };
});
class bw extends P.getComponent("Component") {
  constructor(r, n) {
    super(r, n);
    st(this, "title_");
    this.title_ = n.playerOptions.title || "", this.update(this.title_);
  }
  createEl() {
    const r = super.createEl("div", {
      className: "vjs-title"
    });
    return this.contentEl_ = P.dom.createEl("div", {
      className: "vjs-title-field"
    }), r.appendChild(this.contentEl_), r;
  }
  update(r) {
    r ? this.show() : this.hide(), this.player_.cache_.title = this.title_, this.title_ = r, this.contentEl_.innerHTML = r;
  }
}
P.registerComponent("VideoTitle", bw);
P.registerPlugin(
  "title",
  function(t) {
    const e = this.player_.getChild("VideoTitle");
    if (!e) {
      console.error("[PixellotWebSDK]: Couldn't find video title component!");
      return;
    }
    if (typeof t > "u")
      return e.title_;
    e.update(t);
  }
);
P.getComponent("Player").prototype.options_.children.splice(2, 0, "VideoTitle");
const Sw = P.getComponent("ClickableComponent");
class a_ extends Sw {
  buildCSSClass() {
    return "vjs-close-menu-layer vjs-close-setting-menu";
  }
  handleClick() {
    this.options_.menu.menuButton_.hideMenu();
  }
}
P.registerComponent("CloseSettingMenu", a_);
const Ew = P.getComponent("Menu");
class lf extends Ew {
  constructor(e, r) {
    super(e, {
      ...r,
      name: "SettingMenu"
    }), this.addClass("vjs-setting-menu");
  }
  init() {
    this.contentEl_ && (this.mainMenuItems = this.children().slice(0), this.transform(this.mainMenuItems), this.addClass("vjs-setting-menu-ready"));
  }
  createEl() {
    const e = super.createEl(), r = new a_(this.player_, {
      menu: this
    });
    return e.insertBefore(r.el_, e.firstElementChild), e;
  }
  update(e = []) {
    this.children().slice(0).forEach((n) => {
      this.removeChild(n);
    }), e.forEach((n) => {
      this.addChild(n);
    });
  }
  resize({ width: e, height: r }) {
    this.contentEl_.style.width = e + "px", this.contentEl_.style.height = r + "px";
  }
  getMenuDimension(e) {
    const r = this.player_, n = new xw(r);
    n.update(e), r.addChild(n);
    const i = n.contentEl_.getBoundingClientRect();
    return n.update(), n.dispose(), r.removeChild(n), i;
  }
  transform(e) {
    const r = this.getMenuDimension(e);
    this.update(e), this.resize(r);
  }
  restore() {
    this.transform(this.mainMenuItems);
  }
  removeStyle() {
    this.contentEl_.removeAttribute("style");
  }
  hide() {
  }
}
class xw extends lf {
  constructor(e) {
    super(e, {
      name: "SettingMenuTemp"
    });
  }
}
P.registerComponent("SettingMenu", lf);
const Cw = P.getComponent("MenuItem");
class Js extends Cw {
  constructor(e, r) {
    super(
      e,
      P.mergeOptions(
        {
          selectable: !1
        },
        r
      )
    ), this.menu = r.menu;
  }
}
P.registerComponent("SettingMenuItem", Js);
let Aw = class extends Js {
  createEl() {
    const e = this.options_;
    return P.dom.createEl("li", {
      className: "vjs-menu-item vjs-setting-onoff-item",
      innerHTML: `
        <div class="vjs-icon-placeholder ${this.options_.icon || ""}"></div>
        <div>${this.localize(e.label)}</div>
        <div class="vjs-spacer"></div>
        <div>
          <div class="vjs-onoff-button"></div>
        </div>
      `
    });
  }
  update(e) {
    this.active = typeof e > "u" ? !this.active : e, this.active ? this.addClass("vjs-active") : this.removeClass("vjs-active");
  }
  handleClick() {
    this.update();
  }
  selected() {
  }
};
P.registerComponent("SettingOnOffItem", Aw);
class s_ extends Js {
  constructor(e, r) {
    super(e, r), this.addChild("Component", {}, 0), this.addClass("vjs-settings-sub-menu-item"), this.addClass("vjs-settings-sub-menu-title");
  }
  handleClick() {
    this.options_.menu.restore();
  }
}
P.registerComponent("SettingSubOptionTitle", s_);
class o_ extends Js {
  constructor(e, r) {
    super(e, r), this.selectable = !0, Object.assign(this, r), this.addChild("Component", {}, 0), this.addClass("vjs-settings-sub-menu-item"), this.addClass("vjs-settings-sub-menu-option"), this.update();
  }
  update() {
    this.selected(this.value === this.parent.selected.value);
  }
  handleClick() {
    this.parent.onChange({ index: this.options_.index }), this.menu.restore();
  }
}
P.registerComponent("SettingSubOptionItem", o_);
function ww(t, e) {
  return t = t.map((r, n) => {
    r !== null && typeof r != "object" && (r = {
      value: r,
      label: r
    });
    let i = !1;
    return typeof e > "u" && r.default === !0 && (i = !0, e = n), {
      ...r,
      index: n,
      default: i
    };
  }), {
    entries: t,
    selected: t[e || 0]
  };
}
let u_ = class extends Js {
  constructor(e, r = {}) {
    super(e, r), this.setEntries(this.options_.entries), this.entries.length || this.hide();
  }
  createEl() {
    const { icon: e, label: r } = this.options_, n = P.dom.createEl("li", {
      className: "vjs-menu-item vjs-setting-menu-item",
      innerHTML: `
        <div class="vjs-icon-placeholder ${e || ""}"></div>
        <div class="vjs-setting-menu-label">${this.localize(r)}</div>
        <div class="vjs-spacer"></div>
      `
    });
    return this.selectedValueEl = P.dom.createEl("div", {
      className: "vjs-setting-menu-value"
    }), n.appendChild(this.selectedValueEl, 0), n;
  }
  setEntries(e = [], r) {
    Object.assign(this, ww(e, r)), this.updateSelectedValue();
    const n = P.getComponent(`${this.name_}Child`) || o_;
    this.subMenuItems = [
      new s_(this.player_, {
        label: this.options_.label,
        menu: this.menu
      }),
      ...this.entries.map(({ label: i, value: a }, s) => new n(this.player_, {
        index: s,
        label: i,
        value: a,
        parent: this,
        menu: this.menu
      }))
    ];
  }
  handleClick() {
    this.menu.transform(this.subMenuItems);
  }
  select(e) {
    this.selected = this.entries[e], this.updateSelectedValue();
  }
  update() {
    this.subMenuItems.forEach((e) => {
      e.update && e.update();
    });
  }
  onChange({ index: e }) {
    this.select(e), this.update(e);
  }
  updateSelectedValue() {
    this.selected && (this.selectedValueEl.innerHTML = this.localize(this.selected.label));
  }
};
P.registerComponent("SettingOptionItem", u_);
const Pw = P.getComponent("SettingOnOffItem");
class kw extends Pw {
  constructor(e, r) {
    super(e, {
      ...r,
      // you must assgin the options
      name: "ToggleAutoplay",
      // component name, optional
      label: "Autoplay",
      icon: "vjs-icon-circle"
      // videojs icon classname, optional, for small screen
    }), this.addClass("vjs-setting-annotation");
    const n = sessionStorage.getItem("enable-pixellot-video-autoplay");
    this.update(n === "true");
  }
  /**
   *  @param {Boolean} active
   */
  update(e) {
    super.update(e), sessionStorage.setItem("enable-pixellot-video-autoplay", this.active);
  }
}
P.registerComponent("ToggleAutoplay", kw);
class Lw extends u_ {
  constructor(e, r) {
    super(e, {
      ...r,
      label: "Speed",
      icon: "vjs-icon-play-circle",
      entries: [
        0.5,
        0.75,
        {
          label: "Normal",
          value: 1,
          default: !0
        },
        1.25,
        1.5,
        2
      ]
    }), this.addClass("vjs-setting-playback-rate"), e.on("ratechange", () => {
      const n = e.playbackRate(), i = this.entries.findIndex(({ value: a }) => n === a);
      i > -1 ? (this.select(i), this.update(i)) : P.log.warn("Incorrect playbackRate value, setting menu will not updated");
    });
  }
  onChange(...e) {
    super.onChange(...e), this.player_.playbackRate(this.selected.value);
  }
}
P.registerComponent("PlaybackRateSettingItem", Lw);
const Iw = P.getComponent("MenuButton");
class df extends Iw {
  constructor(e, r) {
    super(e, r), e.addChild(this.menu), e.SettingMenu = this.menu, this.removeChild(this.menu);
  }
  buildCSSClass() {
    return `vjs-setting-button ${super.buildCSSClass()}`;
  }
  buildWrapperCSSClass() {
    return `vjs-setting-button ${super.buildWrapperCSSClass()}`;
  }
  createMenu() {
    const e = new lf(this.player_, {
      menuButton: this
    });
    return (this.options_.entries || []).forEach((n) => {
      const i = e.addChild(n, {
        menu: e
      });
      e[n] = i;
    }), e;
  }
  hideMenu() {
    this.el_ && (this.unpressButton(), this.el_.blur());
  }
  pressButton() {
    super.pressButton(), this.menu.init();
  }
  unpressButton() {
    this.el_ && (super.unpressButton(), this.player_.removeClass("vjs-keep-control-showing"), this.menu.restore());
  }
  handleClick() {
    this.player_.addClass("vjs-keep-control-showing"), this.buttonPressed_ ? this.unpressButton() : this.pressButton(), this.off(document.body, "click", this.hideMenu), setTimeout(() => {
      this.one(document.body, "click", this.hideMenu);
    }, 0);
  }
}
df.prototype.controlText_ = "Settings";
df.prototype.options_ = {
  entries: ["ToggleAutoplay", "PlaybackRateSettingItem"]
};
P.registerComponent("SettingMenuButton", df);
const Dw = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.6601 4.16067C23.4407 3.9947 23.1532 3.952 22.8732 4.04287C15.7601 6.32009 8.24104 6.32009 1.12899 4.0435C0.846952 3.952 0.559628 3.99491 0.340201 4.16067C0.123877 4.32432 0 4.58789 0 4.88429V19.108C0 19.4044 0.123877 19.6681 0.340201 19.8316C0.483874 19.9403 0.656934 19.9961 0.837951 19.9961C0.933255 19.9961 1.0306 19.9805 1.12713 19.9494C8.23971 17.6722 15.7593 17.6722 22.8718 19.949C23.1535 20.0401 23.4406 19.9971 23.6598 19.8316C23.8759 19.6682 24 19.4044 24 19.108V4.88429C24 4.58791 23.8761 4.32437 23.66 4.16067L23.6601 4.16067ZM22.9715 18.872C19.4121 17.7553 15.7221 17.1894 12.0001 17.1894C8.27892 17.1894 4.58978 17.755 1.02879 18.872V5.12109C4.58816 6.23782 8.27825 6.80366 12.0001 6.80366C15.7214 6.80366 19.411 6.23782 22.9715 5.12109V18.872ZM12.0571 15.9517C8.75419 15.9517 5.47537 16.3838 2.28579 17.2378V6.75391C5.47532 7.60793 8.75419 8.03998 12.0571 8.03998C15.36 8.03998 18.6388 7.60768 21.8284 6.75391V17.2378C18.6368 16.3833 15.3591 15.9517 12.0571 15.9517Z" fill="white"/></svg>', Rw = P.getComponent("Button");
class l_ extends Rw {
  constructor(r, n) {
    super(r, n);
    st(this, "_onButtonClick");
    n != null && n.onClick && (this._onButtonClick = n == null ? void 0 : n.onClick);
    const i = this.el().querySelector(".vjs-icon-placeholder");
    i && (i.innerHTML = Dw);
  }
  buildCSSClass() {
    return `vjs-pano-button ${super.buildCSSClass()}`;
  }
  handleClick() {
    this._onButtonClick && this._onButtonClick();
  }
}
l_.prototype.controlText_ = "Pano";
P.registerComponent("PanoButton", l_);
P.registerPlugin(
  "panoBtn",
  function(t) {
    const e = P.mergeOptions({}, t), r = this.controlBar.getChild("PanoButton");
    if (e.show)
      if (r && e.onClick)
        r._onButtonClick = e.onClick;
      else {
        const n = this.controlBar.children_.length - 4;
        this.controlBar.addChild("PanoButton", e, n);
      }
    else
      r && this.controlBar.removeChild(r);
  }
);
const Ow = P.getComponent("MenuButton"), Mw = P.getComponent("MenuItem"), Nw = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.6601 4.16067C23.4407 3.9947 23.1532 3.952 22.8732 4.04287C15.7601 6.32009 8.24104 6.32009 1.12899 4.0435C0.846952 3.952 0.559628 3.99491 0.340201 4.16067C0.123877 4.32432 0 4.58789 0 4.88429V19.108C0 19.4044 0.123877 19.6681 0.340201 19.8316C0.483874 19.9403 0.656934 19.9961 0.837951 19.9961C0.933255 19.9961 1.0306 19.9805 1.12713 19.9494C8.23971 17.6722 15.7593 17.6722 22.8718 19.949C23.1535 20.0401 23.4406 19.9971 23.6598 19.8316C23.8759 19.6682 24 19.4044 24 19.108V4.88429C24 4.58791 23.8761 4.32437 23.66 4.16067L23.6601 4.16067ZM22.9715 18.872C19.4121 17.7553 15.7221 17.1894 12.0001 17.1894C8.27892 17.1894 4.58978 17.755 1.02879 18.872V5.12109C4.58816 6.23782 8.27825 6.80366 12.0001 6.80366C15.7214 6.80366 19.411 6.23782 22.9715 5.12109V18.872ZM12.0571 15.9517C8.75419 15.9517 5.47537 16.3838 2.28579 17.2378V6.75391C5.47532 7.60793 8.75419 8.03998 12.0571 8.03998C15.36 8.03998 18.6388 7.60768 21.8284 6.75391V17.2378C18.6368 16.3833 15.3591 15.9517 12.0571 15.9517Z" fill="currentColor"/></svg>', Bw = '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.56527 14.2895L3.33896 12.9598H12.661L13.4347 14.2895H14.9874L14.2137 12.9598H14.8079C15.4663 12.9598 16 12.4039 16 11.7182V3.74159C16 3.05588 15.4663 2.5 14.8079 2.5H1.19206C0.533703 2.5 0 3.05588 0 3.74159V11.7182C0 12.4039 0.533695 12.9598 1.19206 12.9598H1.78633L1.01264 14.2895H2.56527ZM15.1579 4.1421C15.1579 3.70028 14.7997 3.34211 14.3579 3.34211H1.6421C1.20028 3.34211 0.842105 3.70028 0.842105 4.14211V11.3168C0.842105 11.7587 1.20028 12.1168 1.64211 12.1168H14.3579C14.7997 12.1168 15.1579 11.7587 15.1579 11.3168V4.1421ZM2.5 4.5C2.22386 4.5 2 4.72386 2 5V10.4C2 10.6761 2.22386 10.9 2.5 10.9H13.5C13.7761 10.9 14 10.6761 14 10.4V5C14 4.72386 13.7761 4.5 13.5 4.5H2.5ZM12 5.82083L10.2857 9.88432H9.14286L7.86857 6.8367H6.85714V9.88432H5.71429V6.8367H4V5.82083H8.85714L9.71429 8.10654L10.5714 5.82083H12Z" fill="currentColor"/></svg>', Fw = '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.60474 4.16669L6.13807 5.69336L5.19141 6.64003L3.66474 5.10669L2.13807 6.64003L1.19141 5.69336L2.72474 4.16669L1.19141 2.64003L2.13807 1.69336L3.66474 3.22669L5.19141 1.69336L6.13807 2.64003M14.8047 11.3067L13.8581 10.36L12.3314 11.8934L10.8047 10.36L9.85807 11.3067L11.3914 12.8334L9.85807 14.36L10.8047 15.3067L12.3314 13.7734L13.8581 15.3067L14.8047 14.36L13.2714 12.8334M13.5981 5.05336L11.4514 7.83336L10.3981 6.98669L11.1781 5.98669C10.1832 6.18879 9.25511 6.63786 8.47923 7.29257C7.70336 7.94729 7.1046 8.78663 6.73807 9.73336C7.31833 10.1518 7.72996 10.7638 7.8987 11.459C8.06744 12.1543 7.98219 12.8869 7.65832 13.5248C7.33445 14.1627 6.79329 14.6638 6.13245 14.9379C5.47161 15.2119 4.73459 15.2407 4.05436 15.0192C3.37412 14.7977 2.79544 14.3403 2.42271 13.7297C2.04997 13.1191 1.90772 12.3954 2.0216 11.6891C2.13549 10.9828 2.49802 10.3405 3.0438 9.87795C3.58958 9.41543 4.28268 9.16318 4.99807 9.16669C5.17273 9.1674 5.3469 9.18526 5.51807 9.22003C5.97995 8.07378 6.71744 7.05916 7.66519 6.26607C8.61294 5.47299 9.74168 4.92592 10.9514 4.67336L9.99807 3.95336L10.8447 2.90003M6.66474 12.1667C6.66474 11.8371 6.56699 11.5148 6.38386 11.2407C6.20072 10.9667 5.94042 10.753 5.63588 10.6269C5.33134 10.5007 4.99622 10.4677 4.67292 10.5321C4.34962 10.5964 4.05265 10.7551 3.81956 10.9882C3.58647 11.2213 3.42774 11.5182 3.36343 11.8415C3.29912 12.1648 3.33213 12.5 3.45827 12.8045C3.58442 13.109 3.79804 13.3693 4.07212 13.5525C4.3462 13.7356 4.66844 13.8334 4.99807 13.8334C5.4401 13.8334 5.86402 13.6578 6.17658 13.3452C6.48914 13.0326 6.66474 12.6087 6.66474 12.1667Z" fill="currentColor"/></svg>', Uw = '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_6)"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.05033 3.5H1.75055C0.787746 3.5 0 4.29609 0 5.26909V11.2309C0 12.2039 0.787746 13 1.75055 13H9.05033C10.0131 13 10.8009 12.2039 10.8009 11.2309V5.26909C10.8009 4.2784 10.0131 3.5 9.05033 3.5ZM14.7046 4.473C14.5996 4.49069 14.4945 4.54376 14.407 4.59683L11.6761 6.18901V10.2933L14.4245 11.8855C14.9322 12.1862 15.5624 12.0093 15.86 11.4963C15.9475 11.3371 16 11.1601 16 10.9655V5.49907C16 4.84451 15.3873 4.31378 14.7046 4.473Z" fill="currentColor"/></g><defs><clipPath id="clip0_1_6"><rect width="16" height="16" fill="currentColor" transform="translate(0 0.5)"/></clipPath></defs></svg>', Sg = {
  pano: {
    icon: Nw,
    size: {
      width: 27,
      height: 27
    }
  },
  hd: {
    icon: Bw,
    size: {
      width: 27,
      height: 27
    }
  },
  tactical: {
    icon: Fw,
    size: {
      width: 24,
      height: 24
    }
  }
}, Eg = {
  pano: "Pano",
  hd: "TV (HD)",
  tactical: "Tactical view (HD)"
};
function d_(t) {
  return Sg[t] ? Sg[t] : {
    icon: Uw,
    size: {
      width: 27,
      height: 27
    }
  };
}
function c_(t) {
  return t.label ? t.label : Eg[t.type] ? Eg[t.type] : t.type ? `${t.type[0].toUpperCase()}${t.type.slice(1)}` : "Unknown";
}
class h_ extends Mw {
  constructor(r, n) {
    const i = c_(n.item);
    n.label = i, n.selected = r.src() === n.item.value;
    super(r, n);
    st(this, "value");
    st(this, "iconEl_");
    st(this, "onClick");
    this.value = n.item.value || "", this.iconEl_ = P.dom.createEl("span", {
      className: "vjs-icon-placeholder",
      ariaHidden: "true",
      innerHTML: d_(n.item.type).icon
    }), this.el().prepend(this.iconEl_), this.onClick = n.item.onClick || (() => null), this.on(r, "loadstart", () => this.update());
  }
  createEl() {
    const r = super.createEl("li");
    return r.style.display = "flex", r.style.alignItems = "center", r.style.gap = "12px", r;
  }
  handleClick(r) {
    super.handleClick(r), this.onClick(), this.update();
  }
  update() {
    this.selected(this.player().src() === this.value);
  }
}
class Vw extends Ow {
  constructor(e, r) {
    super(e, r), this.updateIcon(), this.on(e, "loadstart", () => this.updateIcon());
  }
  createEl() {
    const e = super.createEl();
    return e.style.zIndex = 50, e;
  }
  updateIcon() {
    const e = this.getSelectedItem(), r = c_(e);
    this.controlText(`Stream type: ${r}`);
    const n = this.el().querySelector(".vjs-icon-placeholder");
    if (n) {
      const i = d_(e.type);
      n.innerHTML = i.icon;
      const a = n.querySelector("svg");
      n.style.paddingTop = "3px", a && (a.setAttribute("width", i.size.width.toString()), a.setAttribute("height", i.size.height.toString()));
    }
  }
  createItems() {
    const e = this.options_.items, r = [];
    for (let n = 0; n < e.length; n++) {
      const i = new h_(this.player_, {
        item: e[n],
        selectable: !0,
        multiSelectable: !1
      });
      r.push(i);
    }
    return r;
  }
  getSelectedItem() {
    return this.options_.items.find((e) => this.player().src() === e.value) || { type: "hd", value: this.player().src() };
  }
}
P.registerComponent("SourceMenuButton", Vw);
P.registerComponent("SourceMenuItem", h_);
P.registerPlugin(
  "sourceSelector",
  function(t) {
    const e = P.mergeOptions({}, t), r = !!this.controlBar.getChild("SourceMenuButton");
    ((t == null ? void 0 : t.items) || []).length > 1 ? r || (() => this.controlBar.addChild("SourceMenuButton", e, this.controlBar.children_.length - 4))() : (() => this.controlBar.removeChild(this.controlBar.getChild("SourceMenuButton")))();
  }
);
const jw = P.getComponent("Button"), Hw = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.44255 8.47602C2.2836 8.38199 2.14984 8.2534 2.05203 8.1006C1.70693 7.56151 1.88178 6.85556 2.44255 6.52382L13.1829 0.170017C13.3708 0.0588557 13.5871 0 13.8078 0C14.4662 0 15 0.513134 15 1.14612V13.8537C15 14.0658 14.9388 14.2738 14.8231 14.4544C14.4781 14.9935 13.7437 15.1616 13.1829 14.8298L2.44255 8.47602ZM1.875 0H0V15H1.875V0Z" fill="white"/></svg>', Ww = '<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.5574 8.47602C12.7164 8.38199 12.8502 8.2534 12.948 8.1006C13.2931 7.56151 13.1182 6.85556 12.5574 6.52382L1.81708 0.170017C1.62917 0.0588557 1.41287 0 1.19223 0C0.53378 0 0 0.513134 0 1.14612V13.8537C0 14.0658 0.0612232 14.2738 0.176857 14.4544C0.52195 14.9935 1.2563 15.1616 1.81708 14.8298L12.5574 8.47602ZM13.125 0H15V15H13.125V0Z" fill="white"/></svg>';
class qw extends jw {
  constructor(r, n) {
    super(r, n);
    st(this, "_onButtonClick");
    const i = this.el().querySelector(".vjs-icon-placeholder"), a = (n == null ? void 0 : n.direction) === "forward";
    i && (i.innerHTML = a ? Ww : Hw), n != null && n.onClickNext && (n != null && n.onClickPrevious) && (this._onButtonClick = a ? n.onClickNext : n.onClickPrevious), n != null && n.isNextDisabled && a ? this.disable() : n != null && n.isPreviousDisabled && !a && this.disable();
  }
  buildCSSClass() {
    return `vjs-seek-button ${super.buildCSSClass()}`;
  }
  handleClick() {
    this._onButtonClick && this._onButtonClick();
  }
}
P.registerComponent("SeekButton", qw);
P.registerPlugin(
  "seekButtons",
  function(t) {
    this.ready(() => {
      if (!this.controlBar) {
        console.error("[PixellotWebSDK]: Seek buttons component can't be initialized when `controlBar` is not set up!");
        return;
      }
      const e = P.mergeOptions({}, t), r = this.controlBar.children(), n = [];
      r.forEach((i) => {
        i.name() === "SeekButton" && n.push(i);
      }), n.length && n.forEach((i) => this.controlBar.removeChild(i)), e.isActive && (this.controlBar.addChild("SeekButton", Object.assign({ direction: "back" }, e), 0).controlText("Previous (↑)"), this.controlBar.addChild("SeekButton", Object.assign({ direction: "forward" }, e), 2).controlText("Next (↓)"));
    });
  }
);
const $w = P.getComponent("Button");
class zw extends $w {
  constructor(r, n) {
    super(r, n);
    st(this, "controlLink_", null);
    n != null && n.label && (this.controlLink_ = {
      label: n.label,
      url: n.url,
      target: n.target
    }), this.update(this.controlLink_);
  }
  createEl() {
    return super.createEl("div", { className: "vjs-control-link" });
  }
  update(r) {
    r ? this.show() : this.hide(), this.controlLink_ = r || null, r && (this.el().innerHTML = r.label);
  }
  handleClick() {
    this.controlLink_ && window.open(this.controlLink_.url, this.controlLink_.target || "_blank");
  }
}
P.registerComponent("ControlLinkComponent", zw);
P.registerPlugin(
  "controlLink",
  function(t) {
    if (!this.controlBar) {
      console.error(
        "[PixellotWebSDK]: Control link component can't be initialized when `controlBar` is not set up!"
      );
      return;
    }
    const e = P.mergeOptions({}, t), r = this.controlBar.getChild("ControlLinkComponent");
    e ? r ? r.update(e) : this.controlBar.addChild("ControlLinkComponent", e, 7) : r && this.controlBar.removeChild(r);
  }
);
/*! @name videojs-contrib-quality-levels @version 2.2.1 @license Apache-2.0 */
function Gw(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
function Kl(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
var Kw = (
  /**
   * Creates a QualityLevel
   *
   * @param {Representation|Object} representation The representation of the quality level
   * @param {string}   representation.id        Unique id of the QualityLevel
   * @param {number=}  representation.width     Resolution width of the QualityLevel
   * @param {number=}  representation.height    Resolution height of the QualityLevel
   * @param {number}   representation.bandwidth Bitrate of the QualityLevel
   * @param {number=}  representation.frameRate Frame-rate of the QualityLevel
   * @param {Function} representation.enabled   Callback to enable/disable QualityLevel
   */
  function(e) {
    var r = this;
    return r.id = e.id, r.label = r.id, r.width = e.width, r.height = e.height, r.bitrate = e.bandwidth, r.frameRate = e.frameRate, r.enabled_ = e.enabled, Object.defineProperty(r, "enabled", {
      /**
       * Get whether the QualityLevel is enabled.
       *
       * @return {boolean} True if the QualityLevel is enabled.
       */
      get: function() {
        return r.enabled_();
      },
      /**
       * Enable or disable the QualityLevel.
       *
       * @param {boolean} enable true to enable QualityLevel, false to disable.
       */
      set: function(i) {
        r.enabled_(i);
      }
    }), r;
  }
), Su = /* @__PURE__ */ function(t) {
  Gw(e, t);
  function e() {
    var n;
    n = t.call(this) || this;
    var i = Kl(Kl(n));
    return i.levels_ = [], i.selectedIndex_ = -1, Object.defineProperty(i, "selectedIndex", {
      get: function() {
        return i.selectedIndex_;
      }
    }), Object.defineProperty(i, "length", {
      get: function() {
        return i.levels_.length;
      }
    }), i || Kl(n);
  }
  var r = e.prototype;
  return r.addQualityLevel = function(i) {
    var a = this.getQualityLevelById(i.id);
    if (a)
      return a;
    var s = this.levels_.length;
    return a = new Kw(i), "" + s in this || Object.defineProperty(this, s, {
      get: function() {
        return this.levels_[s];
      }
    }), this.levels_.push(a), this.trigger({
      qualityLevel: a,
      type: "addqualitylevel"
    }), a;
  }, r.removeQualityLevel = function(i) {
    for (var a = null, s = 0, o = this.length; s < o; s++)
      if (this[s] === i) {
        a = this.levels_.splice(s, 1)[0], this.selectedIndex_ === s ? this.selectedIndex_ = -1 : this.selectedIndex_ > s && this.selectedIndex_--;
        break;
      }
    return a && this.trigger({
      qualityLevel: i,
      type: "removequalitylevel"
    }), a;
  }, r.getQualityLevelById = function(i) {
    for (var a = 0, s = this.length; a < s; a++) {
      var o = this[a];
      if (o.id === i)
        return o;
    }
    return null;
  }, r.dispose = function() {
    this.selectedIndex_ = -1, this.levels_.length = 0;
  }, e;
}(P.EventTarget);
Su.prototype.allowedEvents_ = {
  change: "change",
  addqualitylevel: "addqualitylevel",
  removequalitylevel: "removequalitylevel"
};
for (var Xw in Su.prototype.allowedEvents_)
  Su.prototype["on" + Xw] = null;
var f_ = "2.2.1", Yw = P.registerPlugin || P.plugin, Qw = function(e, r) {
  var n = e.qualityLevels, i = new Su(), a = function s() {
    i.dispose(), e.qualityLevels = n, e.off("dispose", s);
  };
  return e.on("dispose", a), e.qualityLevels = function() {
    return i;
  }, e.qualityLevels.VERSION = f_, i;
}, p_ = function(e) {
  return Qw(this, P.mergeOptions({}, e));
};
Yw("qualityLevels", p_);
p_.VERSION = f_;
const Jw = P.getComponent("SettingOptionItem");
class Zw extends Jw {
  constructor(e, r) {
    super(e, {
      ...r,
      name: "QualityHlsSettingItem",
      label: "Quality",
      icon: "vjs-icon-hd"
    }), this.addClass("vjs-setting-quality"), this.levels = [], this.handleAllLevelsAdded();
  }
  handleAllLevelsAdded() {
    const e = this.player_;
    if (!e.qualityLevels)
      return P.log.error("plugin videojs-contrib-quality-levels do not exists"), !1;
    const r = e.qualityLevels();
    let n = [], i;
    r.on("addqualitylevel", ({ qualityLevel: a }) => {
      clearTimeout(i), n.push(a), i = setTimeout(() => {
        this.levels = n.slice(0), e.trigger("before-quality-setup", {
          levels: this.levels
        }), this.onAllLevelsAdded(), n = [];
      }, 10);
    });
  }
  onAllLevelsAdded() {
    const e = [
      ...this.levels.map(({ height: r, width: n }) => {
        const i = n < r ? n : r;
        return {
          label: this.localize(`${i}p`),
          value: r,
          default: !1
        };
      }).sort((r, n) => n.value - r.value),
      {
        label: "Auto",
        value: "auto",
        default: !0
      }
    ];
    this.levels.length > 1 ? (this.setEntries(e, e.length - 1), this.show(), this.player_.trigger("hls-quality", this.levels)) : this.hide();
  }
  onChange(...e) {
    super.onChange(...e);
    const { value: r } = this.selected;
    this.levels.forEach((n) => {
      n.enabled = n.height === r || r === "auto";
    }), this.player_.trigger(
      "hls-qualitychange",
      this.entries.reduce((n, i, a) => {
        if (i.value === r) {
          const s = this.levels.find((o) => o.height === r) || {};
          n = {
            index: a,
            level: s,
            ...i
          };
        }
        return n;
      }, {})
    );
  }
}
P.getComponent("SettingMenuButton").prototype.options_.entries.push("QualityHlsSettingItem");
P.registerComponent("QualityHlsSettingItem", Zw);
var xg = {}, eP = {
  get exports() {
    return xg;
  },
  set exports(t) {
    xg = t;
  }
};
const tP = /* @__PURE__ */ uv(Tw);
(function(t) {
  (function(e, r) {
    if (typeof window < "u" && window.videojs)
      r(window.videojs);
    else if (t.exports) {
      var n = tP;
      t.exports = r(n.default || n);
    }
  })(Zi, function(e) {
    typeof window < "u" && (window.videojs_hotkeys = { version: "0.2.28" });
    var r = function(i) {
      var a = this, s = a.el(), o = document, u = {
        volumeStep: 0.1,
        seekStep: 5,
        enableMute: !0,
        enableVolumeScroll: !0,
        enableHoverScroll: !1,
        enableFullscreen: !0,
        enableNumbers: !0,
        enableJogStyle: !1,
        alwaysCaptureHotkeys: !1,
        captureDocumentHotkeys: !1,
        documentHotkeysFocusElementFilter: function() {
          return !1;
        },
        enableModifiersForNumbers: !0,
        enableInactiveFocus: !0,
        skipInitialFocus: !1,
        playPauseKey: Te,
        rewindKey: We,
        forwardKey: Be,
        volumeUpKey: ge,
        volumeDownKey: fe,
        muteKey: me,
        fullscreenKey: xe,
        customKeys: {}
      }, l = 1, d = 2, h = 3, f = 4, v = 5, b = 6, _ = 7, y = e.mergeOptions || e.util.mergeOptions;
      i = y(u, i || {});
      var E = i.volumeStep, R = i.seekStep, D = i.enableMute, C = i.enableVolumeScroll, w = i.enableHoverScroll, k = i.enableFullscreen, I = i.enableNumbers, U = i.enableJogStyle, $ = i.alwaysCaptureHotkeys, W = i.captureDocumentHotkeys, G = i.documentHotkeysFocusElementFilter, Y = i.enableModifiersForNumbers, re = i.enableInactiveFocus, j = i.skipInitialFocus, J = e.VERSION;
      s.hasAttribute("tabIndex") || s.setAttribute("tabIndex", "-1"), s.style.outline = "none", ($ || !a.autoplay()) && (j || a.one("play", function() {
        s.focus();
      })), re && a.on("userinactive", function() {
        var ke = function() {
          clearTimeout(Ce);
        }, Ce = setTimeout(function() {
          a.off("useractive", ke);
          var $e = o.activeElement, Nt = s.querySelector(".vjs-control-bar");
          $e && $e.parentElement == Nt && s.focus();
        }, 10);
        a.one("useractive", ke);
      }), a.on("play", function() {
        var ke = s.querySelector(".iframeblocker");
        ke && ke.style.display === "" && (ke.style.display = "block", ke.style.bottom = "39px");
      });
      var z = function(Ce) {
        var $e = Ce.which, Nt, dt, Ee = Ce.preventDefault.bind(Ce), Qe = a.duration();
        if (a.controls()) {
          var Re = o.activeElement;
          if ($ || W && G(Re) || Re == s || Re == s.querySelector(".vjs-tech") || Re == s.querySelector(".vjs-control-bar") || Re == s.querySelector(".iframeblocker"))
            switch (Se(Ce, a)) {
              case l:
                Ee(), ($ || W) && Ce.stopPropagation(), a.paused() ? Xe(a.play()) : a.pause();
                break;
              case d:
                Nt = !a.paused(), Ee(), Nt && a.pause(), dt = a.currentTime() - Ue(Ce), dt <= 0 && (dt = 0), a.currentTime(dt), Nt && Xe(a.play());
                break;
              case h:
                Nt = !a.paused(), Ee(), Nt && a.pause(), dt = a.currentTime() + Ue(Ce), dt >= Qe && (dt = Nt ? Qe - 1e-3 : Qe), a.currentTime(dt), Nt && Xe(a.play());
                break;
              case v:
                Ee(), U ? (dt = a.currentTime() - 1, a.currentTime() <= 1 && (dt = 0), a.currentTime(dt)) : a.volume(a.volume() - E);
                break;
              case f:
                Ee(), U ? (dt = a.currentTime() + 1, dt >= Qe && (dt = Qe), a.currentTime(dt)) : a.volume(a.volume() + E);
                break;
              case b:
                D && a.muted(!a.muted());
                break;
              case _:
                k && (a.isFullscreen() ? a.exitFullscreen() : a.requestFullscreen());
                break;
              default:
                if (($e > 47 && $e < 59 || $e > 95 && $e < 106) && (Y || !(Ce.metaKey || Ce.ctrlKey || Ce.altKey)) && I) {
                  var Qt = 48;
                  $e > 95 && (Qt = 96);
                  var Zr = $e - Qt;
                  Ee(), a.currentTime(a.duration() * Zr * 0.1);
                }
                for (var qa in i.customKeys) {
                  var Ci = i.customKeys[qa];
                  Ci && Ci.key && Ci.handler && Ci.key(Ce) && (Ee(), Ci.handler(a, i, Ce));
                }
            }
        }
      }, Q = function(Ce) {
        if (J != null && J <= "7.1.0" && a.controls()) {
          var $e = Ce.relatedTarget || Ce.toElement || o.activeElement;
          ($e == s || $e == s.querySelector(".vjs-tech") || $e == s.querySelector(".iframeblocker")) && k && (a.isFullscreen() ? a.exitFullscreen() : a.requestFullscreen());
        }
      }, te = !1, ae = s.querySelector(".vjs-volume-menu-button") || s.querySelector(".vjs-volume-panel");
      ae != null && (ae.onmouseover = function() {
        te = !0;
      }, ae.onmouseout = function() {
        te = !1;
      });
      var ne = function(Ce) {
        if (w)
          var $e = 0;
        else
          var $e = o.activeElement;
        if (a.controls() && ($ || $e == s || $e == s.querySelector(".vjs-tech") || $e == s.querySelector(".iframeblocker") || $e == s.querySelector(".vjs-control-bar") || te) && C) {
          Ce = window.event || Ce;
          var Nt = Math.max(-1, Math.min(1, Ce.wheelDelta || -Ce.detail));
          Ce.preventDefault(), Nt == 1 ? a.volume(a.volume() + E) : Nt == -1 && a.volume(a.volume() - E);
        }
      }, Se = function(Ce, $e) {
        if (i.playPauseKey(Ce, $e))
          return l;
        if (i.rewindKey(Ce, $e))
          return d;
        if (i.forwardKey(Ce, $e))
          return h;
        if (i.volumeUpKey(Ce, $e))
          return f;
        if (i.volumeDownKey(Ce, $e))
          return v;
        if (i.muteKey(Ce, $e))
          return b;
        if (i.fullscreenKey(Ce, $e))
          return _;
      };
      function Te(ke) {
        return ke.which === 32 || ke.which === 179;
      }
      function We(ke) {
        return ke.which === 37 || ke.which === 177;
      }
      function Be(ke) {
        return ke.which === 39 || ke.which === 176;
      }
      function ge(ke) {
        return ke.which === 38;
      }
      function fe(ke) {
        return ke.which === 40;
      }
      function me(ke) {
        return ke.which === 77;
      }
      function xe(ke) {
        return ke.which === 70;
      }
      function Ue(ke) {
        return typeof R == "function" ? R(ke) : R;
      }
      function Xe(ke) {
        ke != null && typeof ke.then == "function" && ke.then(null, function(Ce) {
        });
      }
      if (W) {
        var Ke = function(ke) {
          z(ke);
        };
        document.addEventListener("keydown", Ke), this.dispose = function() {
          document.removeEventListener("keydown", Ke);
        };
      } else
        a.on("keydown", z);
      return a.on("dblclick", Q), a.on("mousewheel", ne), a.on("DOMMouseScroll", ne), this;
    }, n = e.registerPlugin || e.plugin;
    n("hotkeys", r);
  });
})(eP);
let Mc = !1;
P.use("*", function(e) {
  return {
    callPlay() {
      return Mc && P.middleware.TERMINATOR;
    },
    setSource: function(r, n) {
      n(null, r);
    }
  };
});
P.registerPlugin(
  "unload",
  function(t = {}) {
    Mc = !0, this.pause(), this.tech_.hide(), this.off("loadstart", e), this.on("loadstart", e);
    function e() {
      Mc = !1, this.tech_.show();
    }
    t.loading && this.addClass("vjs-seeking");
  }
);
const iP = "youboralib", rP = "lib", nP = "js", aP = "Jordi Aguilar", sP = "6.8.46", oP = "2023-03-24", uP = "https://bitbucket.org/npaw/lib-plugin-js.git", lP = {
  name: iP,
  type: rP,
  tech: nP,
  author: aP,
  version: sP,
  built: oP,
  repo: uP
};
var Zu = lP.version, dP = function() {
  Function.prototype.bind = Function.prototype.bind || function(t) {
    var e = Array.prototype.slice, r = this, n = e.call(arguments, 1);
    function i() {
      var a = r.prototype && this instanceof r;
      return r.apply(
        !a && t || this,
        n.concat(e.call(arguments))
        // eslint-disable-line no-mixed-operators
      );
    }
    return i.prototype = r.prototype, i;
  }, Array.prototype.forEach = Array.prototype.forEach || function(t, e) {
    if (typeof t != "function")
      throw new TypeError(t + " is not a function!");
    for (var r = this.length, n = 0; n < r; n++)
      t.call(e, this[n], n, this);
  }, Math.trunc = Math.trunc || function(t) {
    return isNaN(t) ? NaN : t > 0 ? Math.floor(t) : Math.ceil(t);
  };
}, cP = dP, g_ = function(t) {
  if (t == null)
    throw new TypeError("Cannot convert undefined or null to object");
  for (var e = Object(t), r = 1; r < arguments.length; r++) {
    var n = arguments[r];
    if (n != null)
      for (var i in n)
        n.hasOwnProperty(i) && (e[i] = n[i]);
  }
  return e;
}, Cg = function() {
}, hP = function(t) {
  if (arguments.length > 1)
    throw Error("Second argument not supported");
  if (t === null)
    throw Error("Cannot set a null [[Prototype]]");
  if (typeof t != "object")
    throw TypeError("Argument must be an object");
  return Cg.prototype = t, new Cg();
}, Ag = g_, fP = hP, cf = function() {
};
cf.prototype = {
  /**
   * A base class that other Classes should inherit from.
   * It has a no-op constructor intended to be overridden by classes that extend from this.
   *
   * @constructs YouboraObject
   * @abstract
   * @memberof youbora
   */
  constructor: function() {
  }
};
cf.extend = function(t, e) {
  var r = this, n;
  return t && t.hasOwnProperty("constructor") ? n = t.constructor : n = function() {
    return r.apply(this, arguments);
  }, Ag(n, r, e), n.prototype = fP(r.prototype), t && Ag(n.prototype, t), n.prototype.constructor = n, n.__super__ = r.prototype, n;
};
var wt = cf, hf = function(t) {
  return Object.prototype.toString.call(t) === "[object Array]";
}, pP = wt, wg = hf, gP = pP.extend(
  /** @lends youbora.Emitter.prototype */
  {
    /**
     * Sets a listener to a given event. Use {@link emit} to trigger those events.
     * Pass '*' to listen ALL events.
     *
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event. Receives event and data.
     * @return this
     */
    on: function(t, e) {
      if (this._listeners = this._listeners || {}, typeof e == "function")
        return this._listeners[t] = this._listeners[t] || [], this._listeners[t].push(e), this;
    },
    /**
     * Removes given callback from the listeners of this object.
     *
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event.
     * @return this
     */
    off: function(t, e) {
      if (this._listeners = this._listeners || {}, this._listeners[t]) {
        var r = this._listeners[t].indexOf(e);
        r !== -1 && this._listeners[t].splice(r, 1);
      }
      return this;
    },
    /**
     * Emits given event, triggering all the associated callbacks.
     *
     * @param {string} event Name of the event.
     * @param {object} [data] Custom data to be sent to the callbacks.
     * @return this
     */
    emit: function(t, e) {
      return this._listeners = this._listeners || {}, e = e || {}, wg(this._listeners[t]) && this._listeners[t].forEach(this._eachCallback.bind(this, t, e)), wg(this._listeners["*"]) && this._listeners["*"].forEach(this._eachCallback.bind(this, t, e)), this;
    },
    /**
     * Travels through the listener list and executes them them.
     *
     * @private
     */
    _eachCallback: function(t, e, r) {
      if (typeof r == "function") {
        var n = {
          type: t,
          data: e,
          target: this
        };
        r(n);
      }
    }
  }
), Br = gP, mP = Br, vP = hf, nt = {
  _emitter: new mP(),
  /** Exposes {@link youbora.EvenfulObject.on} */
  on: function() {
    nt._emitter.on.apply(nt._emitter, arguments);
  },
  /** Exposes {@link youbora.EvenfulObject.off} */
  off: function() {
    nt._emitter.off.apply(nt._emitter, arguments);
  },
  /** Exposes {@link youbora.EvenfulObject.emit} */
  emit: function() {
    nt._emitter.emit.apply(nt._emitter, arguments);
  },
  /**
   * Enum for log levels
   * @enum
   */
  Level: {
    /** No console outputs */
    SILENT: 6,
    /** Console will show errors */
    ERROR: 5,
    /** Console will show warnings */
    WARNING: 4,
    /** Console will show notices (ie: life-cyrcle logs) */
    NOTICE: 3,
    /** Console will show debug messages (ie: player events) */
    DEBUG: 2,
    /** Console will show verbose messages (ie: Http Requests) */
    VERBOSE: 1
  },
  /**
   * Enum for events
   * @enum
   */
  Event: {
    /** Sent each time a messaged is issued, even if log level does not handle it. */
    LOG: "log"
  },
  /**
   * Only logs of this imporance or higher will be shown.
   * @default youbora.Log.Levels.ERROR
   * @see {@link youbora.Log.Levels}
   */
  logLevel: 5,
  /**
   * If true, console logs will always be outputed without colors (for debbugin in devices).
   * @default false
   */
  plainLogs: !1,
  /**
   * Returns a console message
   *
   * @private
   * @param {(string|error|array)} msg Message string, error object or array of messages.
   * @param {Log.Levels} [level=Log.Levels.NOTICE] Defines the level of the error sent.
   * Only errors with higher or equal level than Log.logLevel will be displayed.
   * @param {string} [color=darkcyan] Color of the header
   * @see {@link Youbora.Log.debugLevel}
   */
  report: function(t, e, r) {
    if (typeof console < "u" && console.log && typeof document < "u") {
      e = e || nt.Level.NOTICE, r = r || "darkcyan";
      var n = {
        5: "e",
        // Error
        4: "w",
        // Warning
        3: "n",
        // Notice
        2: "d",
        // Debug
        1: "v"
        // Verbose
      }, i = n[e], a = "[Youbora]" + nt._getCurrentTime() + " " + i + ":";
      if (this.emit("log", { level: e, msg: t, prefix: a }), nt.logLevel <= e)
        if (nt.plainLogs || document.documentMode)
          nt._plainReport(t, a);
        else {
          var s;
          e === nt.Level.ERROR && console.error ? s = console.error : e === nt.Level.WARNING && console.warn ? s = console.warn : e === nt.Level.DEBUG && console.debug ? s = console.debug : s = console.log, a = "%c" + a, vP(t) ? (t.splice(0, 0, a, "color: " + r), s.apply(console, t)) : s.call(console, a, "color: " + r, t);
        }
    }
  },
  /**
   * Returns the current time in format hh:mm:ss.mmm (with trailing 0s)
   * @private
   * @return {string} Current time.
   */
  _getCurrentTime: function() {
    var t = /* @__PURE__ */ new Date(), e = ("0" + t.getDate()).slice(-2), r = ("0" + t.getMinutes()).slice(-2), n = ("0" + t.getSeconds()).slice(-2), i = ("00" + t.getMilliseconds()).slice(-3);
    return "[" + e + ":" + r + ":" + n + "." + i + "]";
  },
  /**
   * Returns a console message without style
   *
   * @private
   * @param {(string|object|array)} msg Message string, object or array of messages.
   * @param {string} prefix Prefix of the message.
   */
  _plainReport: function(t, e) {
    if (t instanceof Array)
      for (var r in t)
        nt._plainReport(t[r], e);
    else
      typeof t == "string" ? console.log(e + " " + t) : (console.log(e + " <next line>"), console.log(t));
  },
  /**
   * Sends an error (level 1) console log.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */
  error: function() {
    nt.report([].slice.call(arguments), nt.Level.ERROR, "darkred");
  },
  /**
   * Sends a warning (level 2) console log.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */
  warn: function() {
    nt.report([].slice.call(arguments), nt.Level.WARNING, "darkorange");
  },
  /**
   * Sends a notice (level 3) console log.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */
  notice: function() {
    nt.report([].slice.call(arguments), nt.Level.NOTICE, "darkgreen");
  },
  /**
   * Sends a debug message (level 4) to console.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */
  debug: function() {
    nt.report([].slice.call(arguments), nt.Level.DEBUG, "indigo");
  },
  /**
   * Sends a verbose message (level 5) to console.
   * Supports unlimited arguments: ("this", "is", "a", "message")
   * @memberof $YB
   * @see {@link $YB.report}
   */
  verbose: function() {
    nt.report([].slice.call(arguments), nt.Level.VERBOSE, "navy");
  },
  /**
   * This function is automatically executed at youboralib's init.
   * Will search inside window.location.search for attribute 'youbora-debug=X'.
   * X can have one of these values, that will modify LogLevel.
   * 6: SILENT,
   * 5: ERROR,
   * 4: WARNING,
   * 3: NOTICE,
   * 2: DEBUG,
   * 1: VERBOSE
   *
   * If youbora-console=plain is present, plainLogs will be set to true.
   */
  loadLevelFromUrl: function() {
    typeof window < "u" && window.location && this._parseLevelFromUrl(window.location.search);
  },
  _parseLevelFromUrl: function(t) {
    if (t) {
      var e = /\?.*&*youbora-debug=(.+)/i.exec(t);
      e !== null && (nt.logLevel = e[1]);
      var r = /\?.*&*youbora-debug=plain/i.exec(t);
      r !== null && (nt.plainLogs = !0);
    }
  }
}, bt = nt, ta = bt, yP = {
  /**
     * Strip {protocol}:// and // from the begining of the string.
     *
     * @param {string} url
     * @returns {string} stripped url
     */
  stripProtocol: function(t) {
    var e = t;
    try {
      e = t.replace(/^(.*?:\/\/|\/\/)/i, "");
    } catch (r) {
      ta.warn(r);
    }
    return e;
  },
  /**
     * Adds specific protocol. ie: [http://]nqs.nice264.com
     *
     * @param {string} url Domain of the service. Without protocol. ie: 'nqs.nice264.com'.
     * @param {boolean|null} [httpSecure]
     * If true will add https, if false http.
     * Otherwise will add //
     * @return Return the complete service URL.
     */
  addProtocol: function(t, e) {
    var r = "http://localhost/";
    try {
      r = "http://" + t, e || typeof window < "u" && window.location.protocol.indexOf("https") === 0 ? r = "https://" + t : typeof window < "u" && window.location.protocol.indexOf("http") === 0 && (r = "//" + t);
    } catch (n) {
      ta.warn(n);
    }
    return r;
  },
  /**
     * Return n if it isn't NaN, negative, Infinity, null or undefined.
     * In any other case, return def.
     *
     * @param {mixed} n Number to be parsed.
     * @param {number} def Number to return if n is not correct.
     */
  parseNumber: function(t, e) {
    return !isNaN(t) && t >= 0 && t !== 1 / 0 && t !== -1 / 0 && t !== null && typeof t < "u" ? t : e;
  },
  /**
     * This utility method will add most of the HTML5 common event listeners to the player sent.
     * This common events will be listened: 'canplay', 'buffering', 'waiting', 'ended', 'play',
     * 'playing', 'pause', 'resume', 'error', 'abort', 'seek', 'seeking', 'seeked', 'stalled',
     * 'dispose', 'loadeddata', 'loadstart'.
     *
     * Events will be reported as DEBUG level messages.
     *
     * @param {object|function} o Object to attach the events.
     * @param {array} [extraEvents]
     * An array of extra events to watch. ie:  ['timeupdate', 'progress'].
     * If the first item is null, no common events will be added.
     * @param {function} [report] Callback function called to report events.
     * Default calls Log.debug()
     */
  logAllEvents: function(t, e, r) {
    try {
      if (ta.logLevel <= ta.Level.DEBUG) {
        r = r || function(a) {
          ta.debug("Event: " + a.type);
        };
        var n = [
          "canplay",
          "buffering",
          "waiting",
          "ended",
          "play",
          "playing",
          "pause",
          "resume",
          "error",
          "abort",
          "seek",
          "seeking",
          "seeked",
          "stalled",
          "dispose",
          "loadeddata",
          "loadstart"
        ];
        e && (e[0] === null ? (e.shift(), n = e) : n = n.concat(e));
        for (var i = 0; i < n.length; i++)
          typeof t == "function" ? t.call(window, n[i], r) : t.on ? t.on(n[i], r) : t.addEventListener && t.addEventListener(n[i], r);
      }
    } catch (a) {
      ta.error(a);
    }
  },
  /**
     * Builds a string that represents the rendition.
     *
     * The returned string will have the following format: <width>x<height>@bitrate<suffix?>.
     * If either the width or height are < 1, only the bitrate will be returned.
     * If bitrate is < 1, only the dimensions will be returned.
     * If bitrate is < and there is no dimensions, a null will be returned.
     * The bitrate will also have one of the following suffixes dependin on its
     * magnitude: bps, Kbps, Mbps
     *
     * @param {any} width The width of the asset. If only 1 argument is sent, it will be treated
     * as bitrate.
     * @param {any} height The height of the asset.
     * @param {any} bitrate The indicated bitrate (in the manifest) of the asset.
     * @returns {string} A string with the following format: <width>x<height>@<bitrate><suffix>
     */
  buildRenditionString: function(t, e, r) {
    arguments.length === 1 && (r = t, t = null, e = null);
    var n = null;
    return t && e && (n = t + "x" + e), typeof r == "number" && !isNaN(r) && r >= 1 && (n ? n += "@" : n = "", r < 1e3 ? n += Math.round(r) + "bps" : r < 1e6 ? (r = Math.round(r / 1e3), n += r + "Kbps") : (r = Math.round(r / 1e4) / 100, n += r + "Mbps")), n;
  },
  /**
     * Returns a params dictionary with the error values.
     *
     * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
     * @param {String} [msg] Error Message
     * @param {Object} [metadata] Object defining error metadata
     * @param {String} [level] Level of the error. Currently supports 'error' and 'fatal'
     * @returns {Object} Key:value params.
     */
  buildErrorParams: function(t, e, r, n) {
    var i = {};
    return typeof t == "object" && t !== null ? i = t : (i.errorCode = t || "FAILURE", i.msg = e || i.errorCode, i.errorMetadata = r, i.errorLevel = n), i;
  },
  /**
     * Returns a boolean indicating if more than the desired % of pixels are on screen.
     *
     * @param {Object} [player] Player object
     * @param {Number} [screenPercent] Threshold % of pixels on screen to return true.
     * @returns {Boolean} Its on screen or not.
     */
  calculateAdViewability: function(t, e) {
    var r = !0;
    if (typeof window < "u" && t && typeof t.getBoundingClientRect == "function") {
      var n = t.getBoundingClientRect();
      if (n.top >= window.innerHeight || n.bottom <= 0 || n.right <= 0 || n.left >= window.innerWidth)
        r = !1;
      else {
        var i = Math.trunc(n.height * n.width), a = n.top > 0 ? n.top : 0, s = n.bottom > window.innerHeight ? window.innerHeight : n.bottom, o = n.left > 0 ? n.left : 0, u = n.right > window.innerWidth ? window.innerWidth : n.right, l = (u - o) * (s - a);
        r = l * 100 > i * (e || 50);
      }
    }
    return r;
  },
  getMetricsFrom: function(t, e) {
    var r = t || e;
    for (var n in r)
      if (typeof r[n] != "object" || !r[n].value) {
        var i = {};
        i.value = r[n], r[n] = i;
      }
    return r;
  },
  // The following methods replace core js functionallity to ensure compatibility in old versions.
  assign: g_,
  isArray: hf
}, li = yP, _P = wt, TP = _P.extend({
  /** Returns CDN traffic bytes using NPAW balancer, streamroot, peer5 or teltoo. Otherwise null */
  getCdnTraffic: function() {
    var t = null;
    if (typeof CdnBalancerStats < "u" && CdnBalancerStats.cdn)
      t = CdnBalancerStats.cdn.totalDownloadedBytes;
    else if (typeof Streamroot < "u")
      t = this._getStreamrootPeerObject("cdn", !1) || this._getStreamrootInstanceObject("cdnDownload");
    else if (typeof peer5 < "u" && peer5.getStats)
      t = peer5.getStats().totalHttpDownloaded;
    else if (typeof teltoo < "u" && teltoo.getStats) {
      var e = teltoo.getStats();
      t = e.totalReceivedBytes - e.p2pReceivedBytes;
    }
    return t;
  },
  /** Returns CDN traffic when using multiple cdns, available only for NPAW solution. Otherwise null */
  getMultiCdnInfo: function() {
    var t = null;
    if (typeof CdnBalancerStats < "u" && CdnBalancerStats.cdn && CdnBalancerStats.cdn.cdns) {
      var e = CdnBalancerStats.p2p;
      t = {
        P2P: {
          downloaded_bytes: e.downloadedBytes,
          uploaded_bytes: e.uploadedBytes,
          downloaded_chunks: e.downloadedSegments,
          uploaded_chunks: e.uploadedSegments,
          errors: e.failedRequests ? e.failedRequests.total : 0,
          missed_downloaded_chunks: e.failedRequests ? e.failedRequests.absent : 0,
          timeout_errors: e.failedRequests ? e.failedRequests.timeout : 0,
          other_errors: e.failedRequests ? e.failedRequests.error : 0,
          late_uploaded_chunks: e.discardedUploadedSegments,
          late_uploaded_bytes: e.discardedUploadedBytes,
          late_downloaded_bytes: e.discardedDownloadedBytes,
          time: e.downloadMillis,
          active_peers: e.activePeers,
          peers: e.totalPeers
        }
      }, CdnBalancerStats.cdn.cdns.forEach(function(r) {
        t[r.name] = {
          downloaded_bytes: r.bytes,
          downloaded_chunks: r.chunks,
          errors: r.failures,
          time: r.downloadMillis
        };
      });
    }
    return t;
  },
  /** Returns segment duration using NPAW balancer API. Otherwise null */
  getSegmentDuration: function() {
    var t = null;
    return typeof CdnBalancerStats < "u" && CdnBalancerStats.segmentDuration ? CdnBalancerStats.segmentDuration : t;
  },
  /** Returns CDN balancer API response id, available only for NPAW solution. Otherwise null */
  getBalancerResponseId: function() {
    var t = null;
    return typeof CdnBalancerStats < "u" && CdnBalancerStats.cdn ? CdnBalancerStats.cdn.responseUUID : t;
  },
  /** Returns P2P traffic bytes using NPAW balancer, streamroot, peer5 or teltoo. Otherwise null */
  getP2PTraffic: function() {
    var t = null;
    return typeof CdnBalancerStats < "u" && CdnBalancerStats.p2p ? t = CdnBalancerStats.p2p.downloadedBytes : typeof Streamroot < "u" ? t = this._getStreamrootPeerObject("p2p", !0) || this._getStreamrootInstanceObject("dnaDownload") : typeof peer5 < "u" && peer5.getStats ? t = peer5.getStats().totalP2PDownloaded : typeof teltoo < "u" && teltoo.getStats && (t = teltoo.getStats().p2pReceivedBytes), t;
  },
  /** Returns P2P traffic sent in bytes, using NPAW balancer, streamroot or peer5. Otherwise null */
  getUploadTraffic: function() {
    var t = null;
    return typeof CdnBalancerStats < "u" && CdnBalancerStats.p2p ? t = CdnBalancerStats.p2p.uploadedBytes : typeof Streamroot < "u" ? t = this._getStreamrootPeerObject("upload", !0) || this._getStreamrootInstanceObject("dnaUpload") : typeof peer5 < "u" && peer5.getStats && (t = peer5.getStats().totalP2PUploaded), t;
  },
  /** Returns if P2P is enabled, using NPAW balancer, streamroot or peer5. Otherwise null */
  getIsP2PEnabled: function() {
    var t = !1;
    if (typeof CdnBalancerStats < "u" && CdnBalancerStats.p2p)
      t = CdnBalancerStats.p2p.downloadEnabled;
    else if (typeof Streamroot < "u")
      if (Streamroot.p2pAvailable && Streamroot.peerAgents)
        for (var e in Streamroot.peerAgents)
          t = t || Streamroot.peerAgents[e].isP2PEnabled;
      else
        Streamroot.instances && Streamroot.instances.forEach(function(r) {
          t = t || r.dnaDownloadEnabled || r.dnaUploadEnabled;
        });
    else
      typeof peer5 < "u" && peer5.isEnabled ? t = peer5.isEnabled() : typeof teltoo < "u" && (t = !0);
    return t;
  },
  _getStreamrootPeerObject: function(t, e) {
    var r = null;
    if (Streamroot.p2pAvailable && Streamroot.peerAgents)
      for (var n in Streamroot.peerAgents) {
        var i = Streamroot.peerAgents[n];
        i.stats && (!e || i.isP2PEnabled) && (r += i.stats[t]);
      }
    return r;
  },
  _getStreamrootInstanceObject: function(t) {
    var e = null;
    return Streamroot.instances && Streamroot.instances.forEach(function(r) {
      r.stats && r.stats.currentContent && (e += r.stats.currentContent[t]);
    }), e;
  }
}), m_ = TP, bP = wt, v_ = bP.extend(
  /** @lends youbora.Chrono.prototype */
  {
    /**
     * This class calculates time lapses between two points in time.
     *
     * @constructs Chrono
     * @extends youbora.YouboraObject
     * @memberof youbora
     */
    constructor: function() {
      this.reset();
    },
    /** Reset chrono values. */
    reset: function() {
      this.startTime = 0, this.stopTime = 0, this.pauseTime = 0, this.offset = 0;
    },
    /**
     * Returns the time between start() and the last stop() in ms. Returns -1 if start wasn't
     * called.
     * @param {boolean} [stop=true] If true, it will force a stop() if it wasn't called before.
     * @return {number} Time lapse in ms.
     */
    getDeltaTime: function(t) {
      var e = -1, r = (/* @__PURE__ */ new Date()).getTime();
      if (this.startTime) {
        t && !this.stopTime && (this.stopTime = r);
        var n = this.pauseTime ? r - this.pauseTime : 0, i = this.stopTime ? this.stopTime : r;
        e = this.offset - n + (i - this.startTime);
      }
      return e;
    },
    /**
     * Starts the chrono.
     */
    start: function() {
      this.startTime = (/* @__PURE__ */ new Date()).getTime(), this.stopTime = 0, this.offset = 0;
    },
    /**
     * Stops the timer and returns current delta time.
     * @return {number} Returns the delta time
     */
    stop: function() {
      return this.pauseTime && this.resume(), this.stopTime = (/* @__PURE__ */ new Date()).getTime(), this.startTime ? this.offset + (this.stopTime - this.startTime) : -1;
    },
    pause: function() {
      this.pauseTime = (/* @__PURE__ */ new Date()).getTime();
    },
    resume: function() {
      this.offset -= (/* @__PURE__ */ new Date()).getTime() - this.pauseTime, this.pauseTime = 0;
    },
    /**
     * Creates a copy of the chrono.
     */
    clone: function() {
      var t = new v_();
      return t.startTime = this.startTime, t.stopTime = this.stopTime, t.offset = this.offset, t;
    }
  }
), Ha = v_, SP = wt, EP = Ha, xP = SP.extend(
  /** @lends youbora.Timer.prototype */
  {
    /**
     * An Utility class that provides timed events in a defined time interval.
     *
     * @param {function} callback The callback to call every due interval.
     * Callback will receive lapsed ms between calls.
     * @param {int} [interval=5000] Milliseconds between each call.
     *
     * @constructs Timer
     * @extends youbora.YouboraObject
     * @memberof youbora
     */
    constructor: function(t, e) {
      this.callback = t, this.interval = e || 5e3, this.isRunning = !1, this._timer = null, this.chrono = new EP();
    },
    /**
     * Starts the timer.
     */
    start: function() {
      this.isRunning || (this.isRunning = !0, this._setTick());
    },
    /**
     * Stops the timer.
     */
    stop: function() {
      if (this.isRunning = !1, this._timer)
        try {
          clearTimeout(this._timer), this._timer = null;
        } catch {
          typeof atv < "u" && (atv.clearTimeout(this._timer), this._timer = null);
        }
    },
    /**
     * Sets the next tick execution.
     * @private
     */
    _setTick: function() {
      if (this.isRunning) {
        this.chrono.start();
        try {
          this._timer = setTimeout(function() {
            this.callback(this.chrono.stop()), this._setTick();
          }.bind(this), this.interval);
        } catch {
          typeof atv < "u" && (this._timer = atv.setTimeout(function() {
            this.callback(this.chrono.stop()), this._setTick();
          }.bind(this), this.interval));
        }
      }
    }
  }
), ff = xP, CP = {
  Preroll: "pre",
  Midroll: "mid",
  Postroll: "post"
}, AP = CP, wP = {
  START: "start",
  JOIN: "join",
  PAUSE: "pause",
  RESUME: "resume",
  SEEK_BEGIN: "seek-begin",
  SEEK_END: "seek-end",
  BUFFER_BEGIN: "buffer-begin",
  BUFFER_END: "buffer-end",
  ERROR: "error",
  STOP: "stop",
  CLICK: "click",
  MANIFEST: "manifest",
  PODSTART: "break-start",
  PODSTOP: "break-stop",
  QUARTILE: "quartile",
  VIDEO_EVENT: "video-event"
}, PP = wP, kP = PP, LP = {
  Event: kP
}, el = LP, IP = {
  NO_RESPONSE: "NO_RESPONSE",
  EMPTY: "EMPTY_RESPONSE",
  WRONG: "WRONG_RESPONSE"
}, DP = IP, RP = {
  GET: "get",
  POST: "post"
}, pf = RP, OP = {
  DATA: "/data",
  // Video
  INIT: "/init",
  START: "/start",
  JOIN: "/joinTime",
  PAUSE: "/pause",
  RESUME: "/resume",
  SEEK: "/seek",
  BUFFER: "/bufferUnderrun",
  ERROR: "/error",
  STOP: "/stop",
  PING: "/ping",
  VIDEO_EVENT: "/infinity/video/event",
  // Ads
  AD_INIT: "/adInit",
  AD_START: "/adStart",
  AD_JOIN: "/adJoin",
  AD_PAUSE: "/adPause",
  AD_RESUME: "/adResume",
  AD_BUFFER: "/adBufferUnderrun",
  AD_STOP: "/adStop",
  AD_CLICK: "/adClick",
  AD_ERROR: "/adError",
  AD_MANIFEST: "/adManifest",
  AD_POD_START: "/adBreakStart",
  AD_POD_STOP: "/adBreakStop",
  AD_QUARTILE: "/adQuartile",
  // Infinity
  EVENT: "/infinity/session/event",
  SESSION_START: "/infinity/session/start",
  SESSION_STOP: "/infinity/session/stop",
  NAV: "/infinity/session/nav",
  BEAT: "/infinity/session/beat",
  // Offline
  OFFLINE_EVENTS: "/offlineEvents"
}, MP = OP, NP = {
  WILL_SEND_INIT: "will-send-init",
  WILL_SEND_START: "will-send-start",
  WILL_SEND_JOIN: "will-send-join",
  WILL_SEND_PAUSE: "will-send-pause",
  WILL_SEND_RESUME: "will-send-resume",
  WILL_SEND_SEEK: "will-send-seek",
  WILL_SEND_BUFFER: "will-send-buffer",
  WILL_SEND_ERROR: "will-send-error",
  WILL_SEND_FATAL_ERROR: "will-send-fatal-error",
  WILL_SEND_STOP: "will-send-stop",
  WILL_SEND_PING: "will-send-ping",
  WILL_SEND_VIDEO_EVENT: "will-send-video-event",
  WILL_SEND_AD_START: "will-send-ad-start",
  WILL_SEND_AD_JOIN: "will-send-ad-join",
  WILL_SEND_AD_PAUSE: "will-send-ad-pause",
  WILL_SEND_AD_RESUME: "will-send-ad-resume",
  WILL_SEND_AD_BUFFER: "will-send-ad-buffer",
  WILL_SEND_AD_STOP: "will-send-ad-stop",
  WILL_SEND_AD_CLICK: "will-send-ad-click",
  WILL_SEND_AD_ERROR: "will-send-ad-error",
  WILL_SEND_AD_MANIFEST: "will-send-ad-manifest",
  WILL_SEND_AD_POD_START: "will-send-ad-break-start",
  WILL_SEND_AD_POD_STOP: "will-send-ad-break-stop",
  WILL_SEND_AD_QUARTILE: "will-send-ad-quartile",
  WILL_SEND_SESSION_START: "will-send-session-start",
  WILL_SEND_SESSION_STOP: "will-send-session-stop",
  WILL_SEND_NAV: "will-send-nav",
  WILL_SEND_BEAT: "will-send-beat",
  WILL_SEND_EVENT: "will-send-event",
  WILL_SEND_OFFLINE_EVENTS: "will-send-offline-events"
}, BP = NP, FP = {
  ClientSide: "csai",
  ServerSide: "ssai"
}, UP = FP, VP = AP, jP = el, HP = DP, WP = pf, qP = MP, $P = BP, zP = UP, GP = {
  AdPosition: VP,
  ManifestError: HP,
  RequestMethod: WP,
  Service: qP,
  WillSendEvent: $P,
  AdInsertionType: zP,
  Adapter: jP
}, Wi = GP, KP = wt, Xi = bt, XP = li, wi = KP.extend(
  /** @lends youbora.YBRequest.prototype */
  {
    /**
     * YBYBRequest class will wrap XmlHttpRequest and extend its functionality, allowing youbora
     * to manage queues, blockers and retries.
     *
     * @constructs YBRequest
     * @extends youbora.Object
     * @memberof youbora
     *
     * @param {string} host URL of the request. ie: a-fds.youborafds01.com
     * @param {string} [service] Name of the service. ie '/start'
     * @param {Object} [params] Object of key:value params.
     * @param {Object} [options] Object with custom options.
     * @param {string} [options.method="GET"] Specifies the method of the request. ie: "GET", "HEAD".
     * @param {string} [options.requestHeaders] Object with options of requestHeaders.
     * ie: { header: value }.
     * @param {number} [options.retryAfter=5000] Time in ms before sending a failed request again.
     * 0 to disable.
     * @param {number} [options.maxRetries=3] Max number of retries. 0 to disable.
     * @param {bool} [options.cache=false] If false, timestamp will be added to each request to
     * prevent caching.
     */
    constructor: function(t, e, r, n) {
      this.xhr = this.createXHR(), this.host = t || "", this.service = e || "", this.params = r || {}, this.options = XP.assign({}, wi.defaultOptions, n), this.retries = 0, this.sendPostRequest = !1, this.preparedPostRequest = !1, this.options.cache || this.setParam("timemark", (/* @__PURE__ */ new Date()).getTime());
    },
    /**
     * Creates XMLHttpRequest if it is available in the browser.
     * If not, it tries to create an ActiveXObject XMLHTTP item.
     * Override this function for custom environments.
     *
     * @return YBRequest handler.
     */
    createXHR: function() {
      var t = {};
      try {
        XMLHttpRequest ? t = new XMLHttpRequest() : t = new ActiveXObject("Microsoft.XMLHTTP");
      } catch (e) {
        Xi.error(e);
      }
      return t;
    },
    /**
     * Returns xhr object.
     *
     * @return {XmlHttpRequest} object.
     */
    getXHR: function() {
      return this.xhr;
    },
    getResponse: function() {
      return this.xhr.response;
    },
    getResponseText: function() {
      return this.xhr.responseText;
    },
    getResponseHeaders: function() {
      return this.xhr.getAllResponseHeaders();
    },
    /** Returns the complete formed url of the request url+service+params. */
    getUrl: function() {
      return this.host + this.service + this.getParamString();
    },
    /**
     * Wraps this.getHXR.addEventListener.
     * Accepts a callback that receives (this YBRequest, event)
     */
    on: function(t, e, r) {
      return this.xhr.addEventListener ? this.xhr.addEventListener(t, e.bind(this, this, r)) : t === wi.Event.SUCCESS && (this.xhr.onreadystatechange = function() {
        this.xhr.readyState === 4 && e.bind(this, this, r);
      }.bind(this)), this;
    },
    /** Wraps this.getHXR.removeEventListener */
    off: function(t, e) {
      return this.xhr.removeEventListener(t, e), this;
    },
    /**
     * Returns the params of the request, stringified.
     * ie: '?pluginVersion=5.1.0&systemCode=nicetv'.
     * @return {string} Concatenated Params
     */
    getParamString: function() {
      try {
        var t = "?";
        for (var e in this.params) {
          var r = this.params[e];
          if (r !== null && typeof r == "object") {
            var n = JSON.stringify(r);
            n !== "{}" && (t += encodeURIComponent(e) + "=" + encodeURIComponent(n) + "&");
          } else
            r !== null && typeof r < "u" && r !== "" && (t += encodeURIComponent(e) + "=" + encodeURIComponent(r) + "&");
        }
        return t.slice(0, -1);
      } catch (i) {
        return Xi.error(i), "";
      }
    },
    /**
     * Returns the value of the given param, or undefined.
     * @param {string} key Name of the param.
     * @return {any}
     */
    getParam: function(t) {
      return this.params[t];
    },
    /**
     * Add or set a parameter for the request.
     * ie: if you want to add 'username=user' use setParam('username', 'user').
     * @param {string} key Name of the param.
     * @param {string} value Name of the param.
     * @return this
     */
    setParam: function(t, e) {
      return this.params[t] = e, this;
    },
    setBody: function(t) {
      this.body = t;
    },
    /**
     * Set if is enabled send requests with POST method
     * @param {boolean} sendPostRequest
     */
    setPostRequest: function(t) {
      this.sendPostRequest = t;
    },
    /**
     * Create Params object with the basic get params we need to send to the Data Collector nodes
     * @returns {{}}
     */
    getParamsForPostMessages: function() {
      var t = {};
      try {
        var e = this.getParam("timemark"), r = this.getParam("code"), n = this.getParam("sessionRoot"), i = this.getParam("sessionId");
        e && (t.timemark = e), r && (t.code = r), n && (t.sessionRoot = n), i && (t.sessionId = i);
      } catch (a) {
        Xi.error(a);
      }
      return t;
    },
    /**
     * Sends the request.
     *
     * @return returns xhr.send()
     */
    send: function() {
      try {
        try {
          this.sendPostRequest && !this.preparedPostRequest && (this.options.method = "POST", this.body = JSON.stringify(this.params), this.params = this.getParamsForPostMessages(), this.preparedPostRequest = !0);
        } catch {
        }
        if (this.xhr.open(this.options.method, this.getUrl(), !0), this.options.requestHeaders)
          for (var t in this.options.requestHeaders)
            this.options.requestHeaders.hasOwnProperty(t) && this.xhr.setRequestHeader(t, this.options.requestHeaders[t]);
        if (this.options.retryAfter > 0 && this.options.maxRetries > 0) {
          var e = function() {
            if (this.retries >= this.options.maxRetries)
              Xi.error('Aborting failed request "' + this.service + '". Max retries reached.');
            else {
              Xi.warn('YBRequest "' + this.service + '" failed. Retry ' + (this.retries + 1) + " of " + this.options.maxRetries + " in " + this.options.retryAfter + "ms.");
              try {
                setTimeout(function() {
                  this.retries += 1, this.send();
                }.bind(this), this.options.retryAfter);
              } catch (n) {
                typeof atv < "u" ? atv.setTimeout(function() {
                  this.retries += 1, this.send();
                }.bind(this), this.options.retryAfter) : Xi.error(n);
              }
            }
          };
          this.retries === 0 && this.on(wi.Event.ERROR, e.bind(this));
        }
        Xi.logLevel <= Xi.Level.VERBOSE && Xi.verbose("XHR Req: " + this.getUrl());
        for (var r in wi._globalListeners)
          wi._globalListeners[r].forEach(function(n) {
            this.on(r, n);
          }.bind(this));
        return this.xhr.send(this.body);
      } catch (n) {
        Xi.error(n);
      }
    }
  },
  /** @lends youbora.YBRequest */
  {
    /**
     * List of events that could be fired from XHR
     * @enum
     */
    Event: {
      /** Request successful */
      SUCCESS: "load",
      /** Request successful */
      LOAD: "load",
      // Native JS
      /** Request returned error */
      ERROR: "error",
      /** Request aborted */
      ABORT: "abort"
    },
    /**
     * This static property includes the default values for the options. In case you do not define
     * one of them in the constructor, these values will be used instead.
     *
     * @param {string} [defaultOptions.method="GET"] Specifies the method of the request.
     * ie: "GET", "HEAD".
     * @param {string} [defaultOptions.requestHeaders] Object with options of requestHeaders.
     * ie: { header: value }.
     * @param {number} [defaultOptions.retryAfter=5000] Time in ms before sending a failed request
     * again. 0 to disable.
     * @param {number} [defaultOptions.maxRetries=3] Max number of retries. 0 to disable.
     * @param {bool} [defaultOptions.cache=false] If false, timemark will be added to each request
     * to prevent caching.
     */
    defaultOptions: {
      method: "GET",
      requestHeaders: {},
      maxRetries: 3,
      retryAfter: 5e3,
      cache: !1
    },
    /** @private */
    _globalListeners: {},
    /**
     * Adds a callback to every instance.
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event.
     */
    onEvery: function(t, e) {
      wi._globalListeners[t] = wi._globalListeners[t] || [], wi._globalListeners[t].push(e);
    },
    /**
     * Removes a global callback
     * @param {string} event Name of the event.
     * @param {function} callback Callback of the event.
     */
    offEvery: function(t, e) {
      if (wi._globalListeners[t]) {
        var r = wi._globalListeners[t].indexOf(e);
        r !== -1 && wi._globalListeners[t].splice(r, 1);
      }
    }
  }
), lr = wi, YP = Br, y_ = YP.extend(
  /** @lends youbora.Transform.prototype */
  {
    /**
     * Transform classes in YOUBORA help the library parse and work with data.
     *
     * A Transform makes some kind of task that may block requests until it's done, or applies changes
     * to the requests right before they're finally sent.
     *
     * {@link ResourceTransform}, {@link ViewTransform}... all extend from this class.
     *
     * @constructs Transform
     * @extends youbora.Emitter
     * @memberof youbora
     * @abstract
     */
    constructor: function() {
      this._isBusy = !0, this._sendRequest = !0, this.transformName = "Transform";
    },
    /**
     * Override this method to transform info.
     *
     * @param {YBRequest} request Request to transform.
     */
    parse: function(t) {
    },
    /**
     * By default this will return true until {@link #done()} is called. This can be overridden
     * in order to block {@link Request}s based on any criteria. For instance its
     * {@link Request#getService()}.
     *
     * @param {YBRequest} request Request to transform.
     * @return {bool} True if queue shall be blocked.
     */
    isBlocking: function(t) {
      return this._isBusy;
    },
    /**
     * Emits DONE event
     */
    done: function() {
      this._isBusy = !1, this.emit(y_.Event.DONE);
    },
    // offline
    hasToSend: function(t) {
      return this._sendRequest;
    },
    getState: function() {
      return this._sendRequest ? this._isBusy ? this.STATE_BLOCKED : this.STATE_NO_BLOCKED : this.STATE_OFFLINE;
    }
  },
  /** @lends youbora.Transform */
  {
    // Static members
    STATE_OFFLINE: 2,
    STATE_BLOCKED: 1,
    STATE_NO_BLOCKED: 0,
    /**
     * List of events that could be fired from this class.
     * @enum
     */
    Event: {
      /** Notifies that this Transform is done processing. */
      DONE: "done"
    }
  }
), Jr = y_, QP = wt, Pg = bt, Xl = lr, hn = Jr, JP = QP.extend(
  /** @lends youbora.Communication.prototype */
  {
    /**
     * Youbora Communication implements an abstraction layer over API requests.
     * Internally, Communication implements queues of {@link Request} objects.
     * This queue can be blocked using {@link Transform}
     *
     * @constructs Communication
     * @extends youbora.YouboraObject
     * @memberof youbora
     *
     * @param {string} host The fastdata host address.
     * @param {boolean} httpSecure True for https, false for http, undefined for //.
     */
    constructor: function(t) {
      this.transforms = [], this.pluginRef = t, this._requests = [];
    },
    /**
     * Enqueues the request provided.
     *
     * @param {YBRequest} request Request to be enqueued
     * @param {function} [callback] The defined load callback to the Request
     */
    sendRequest: function(t, e, r) {
      t && (typeof e == "function" && t.on(Xl.Event.SUCCESS, e, r), this._registerRequest(t));
    },
    /**
     * Build a generic request to the given host.
     *
     * @param {string} host Host of the service called.
     * @param {string} service A string with the service to be called. ie: '/data', '/joinTime'...
     * @param {Object} [params] Object of key:value params.
     * @param {function} [callback] The defined load callback to the Request
     */
    buildRequest: function(t, e, r, n) {
      r = r || {};
      var i = new Xl(t, e, r);
      typeof n == "function" && i.on(Xl.Event.SUCCESS, n), this._registerRequest(i);
    },
    /**
     * Adds a Transform to the queue. See {@link Transform}.
     *
     * @param {RequestTransform} transform
     */
    addTransform: function(t) {
      t.parse && t.isBlocking ? (this.transforms.push(t), t.on(hn.Event.DONE, this._processRequests.bind(this))) : Pg.warn(t + " is not a valid RequestTransform.");
    },
    /**
     * Removes a {@link Transform}.
     *
     * @param {RequestTransform} transform Transform object to remove.
     */
    removeTransform: function(t) {
      var e = this.transforms.indexOf(t);
      e !== -1 ? this.transforms.splice(e, 1) : Pg.warn("Trying to remove unexisting Transform '" + t + "'.");
    },
    /**
     * Adds an {@link YBRequest} to the queue of requests.
     *
     * @private
     * @param {YBRequest} request The Request to be queued.
     */
    _registerRequest: function(t) {
      if (this.pluginRef) {
        var e = this.pluginRef.options;
        e.authToken && (t.options.requestHeaders.Authorization = e.authType + " " + e.authToken);
      }
      this._requests.push(t), this._processRequests();
    },
    /**
     * Execute pending requests in the queue. Returns rejected ones to the queue.
     * @private
     */
    _processRequests: function() {
      var t = this._requests;
      this._requests = [];
      for (var e = []; t.length; ) {
        var r = t.shift(), n = this._transform(r);
        n === hn.STATE_NO_BLOCKED ? (this.pluginRef && (r.host = this.pluginRef.getHost()), r.send()) : n === hn.STATE_BLOCKED && e.push(r);
      }
      for (; e.length; )
        this._requests.push(e.shift());
    },
    /**
     * Pass the given request to each transform.
     * @private
     * @returns {int} STATE_NO_BLOCKED if everything is right. STATE_BLOCKED if some parser rejected it.
     * STATE_OFFLINE if offline transform blocked it.
     */
    _transform: function(t) {
      var e = hn.STATE_NO_BLOCKED;
      return this.transforms.forEach(function(r) {
        if (r.isBlocking(t)) {
          e = hn.STATE_BLOCKED;
          return;
        } else
          r.parse(t);
        r.getState() === hn.STATE_OFFLINE && (e = hn.STATE_OFFLINE);
      }), e;
    }
  }
), gf = JP, Yl = lr, kg = Jr, Lo = bt, ZP = li, Oi = Wi, qo = kg.extend(
  /** @lends youbora.ViewTransform.prototype */
  {
    /**
     * This class manages Fastdata service and view index.
     *
     * @constructs
     * @extends youbora.Transform
     * @memberof youbora
     *
     * @param {Plugin} plugin Instance of {@link Plugin}
     * @param {string} session If provided, plugin will use this as a FD response.
     */
    constructor: function(t, e) {
      kg.prototype.constructor.apply(this, arguments), this.response = {}, this._viewIndex = (/* @__PURE__ */ new Date()).getTime(), this._session = e, this._httpSecure = t.options["app.https"], this._plugin = t, this.transformName = "View";
    },
    /**
     * Starts the 'FastData' fetching. This will send the initial request to YOUBORA in order to get
     * the needed info for the rest of the requests.
     *
     * This is an asynchronous process.
     *
     * When the fetch is complete, {@link #fastDataConfig} will contain the parsed info.
     * @see FastDataConfig
     */
    init: function() {
      if (this._plugin.options && this._plugin.options.offline)
        return this.response.host = "OFFLINE", this.response.code = "OFFLINE", this.response.pingTime = 60, this.response.beatTime = 60, this.done(), null;
      if (this._plugin.storage.isEnabled()) {
        var t = (/* @__PURE__ */ new Date()).getTime();
        if (t < this._plugin.sessionExpire + (Number(this._plugin.getDataTime()) || 0) && this._plugin.getStoredData())
          return this.setData(this._plugin.getStoredData()), null;
      }
      var e = Oi.Service.DATA, r = {
        outputformat: "json"
      };
      r = this._plugin.requestBuilder.buildParams(r, e), r !== null && (Lo.notice(e + " " + r.system), r.system === "nicetest" && Lo.error(
        "No accountCode has been set. Please set your accountCode inside plugin's options."
      ), new Yl(this._plugin.getHost(), e, r).on(Yl.Event.SUCCESS, this._receiveData.bind(this)).on(Yl.Event.ERROR, this._failedData.bind(this)).send());
    },
    /**
     * Uses given response to set fastdata response.
     *
     * @param {String} response Fastdata response as json string.
     */
    setData: function(t) {
      try {
        var e = JSON.parse(t);
        this._plugin.options["parse.fdsResponseHost"] && (t = t.replace(e.q.h, this._plugin.options["parse.fdsResponseHost"](e.q.h)), e = JSON.parse(t)), this.response.msg = t, this.response.host = ZP.addProtocol(e.q.h, this._httpSecure), this.response.code = e.q.c, this.response.pingTime = e.q.pt || 5, this.response.beatTime = e.q.i && e.q.i.bt || 30, this.response.sessionExpire = e.q.i && e.q.i.exp || 300, this._plugin.storage.setLocal("sessionExpire", this.response.sessionExpire), this.done();
      } catch {
        Lo.error("Fastdata response is invalid.");
      }
    },
    /**
     * Parse the response from the fastData service.
     *
     * @private
     */
    _receiveData: function(t, e) {
      var r = t.getResponse();
      this.setData(r);
    },
    _failedData: function(t, e) {
      Lo.error("Fastdata request has failed.");
    },
    /**
     * This method will increment the view index (timestamp values). The library handles this
     * automatically, but some error flow might need calling this manually.
     * @return {string} new viewcode
     */
    nextView: function() {
      return this._viewIndex = (/* @__PURE__ */ new Date()).getTime(), this.getViewCode();
    },
    /**
     * Returns current viewcode
     * @return {string} viewcode
     */
    getViewCode: function() {
      return this.response.code + "_" + this._viewIndex;
    },
    /**
     * Returns the current session
     *
     * @returns {string} Session
     */
    getSession: function() {
      return this._session;
    },
    /**
     * Sets the session
     *
     * @param {String} sessionId Sets the session
     */
    setSession: function(t) {
      this._session = t;
    },
    /** Sets the host url
    *
    * @param {String} host Sets the host
    */
    setHost: function(t) {
      this.response.host = t;
    },
    /**
     * Transform requests
     * @param {youbora.comm.YBRequest} request YBRequest to transform.
     */
    parse: function(t) {
      t.host = t.host || this.response.host, t.params.system = this._plugin.getAccountCode(), t.params.sessionRoot = t.params.sessionRoot || this.getSession(), qo.EventList.PingTime.indexOf(t.service) !== -1 && (t.params.pingTime = t.params.pingTime || this.response.pingTime), qo.EventList.Infinity.indexOf(t.service) === -1 ? t.params.code = t.params.code || this.getViewCode() : t.params.sessionId = t.params.sessionRoot, qo.EventList.CreateView.indexOf(t.service) !== -1 && (this._plugin.infinity.infinityStarted || this._plugin.storage.isEnabled() && this._plugin.storage.getLocal("infinityStarted")) && (t.params.parentId = t.params.sessionRoot, t.params.navContext = t.params.navContext || this._plugin.getContext());
    }
  },
  {
    // Static members
    EventList: {
      CreateView: [
        Oi.Service.START,
        Oi.Service.INIT,
        Oi.Service.ERROR
      ],
      Infinity: [
        Oi.Service.NAV,
        Oi.Service.SESSION_START,
        Oi.Service.SESSION_STOP,
        Oi.Service.EVENT,
        Oi.Service.BEAT
      ],
      PingTime: [
        Oi.Service.START,
        Oi.Service.PING
      ]
    }
  }
), __ = qo, ek = Br, T_ = ek.extend(
  /** @lends youbora.Parser.prototype */
  {
    /**
     * Class that asynchronously parses a resource in order to get to the URL.
     *
     * Since the CDN detection is performed with the resource url, it is essential that this
     * resource url is pointing to the CDN that is actually hosting the manifest.
     *
     * @constructs Parser
     * @extends youbora.Emitter
     * @memberof youbora
     */
    constructor: function(t) {
      this._realResource = null, this._lastManifest = null, this._transportFormat = null, this.iterations = 3, this._headers = t;
    },
    /**
     * Emits DONE event
     */
    done: function() {
      this.iterations = 3, this.emit(T_.Event.DONE);
    },
    /**
     * Starts the parsing from the given resource.
     *
     * @param {string} resource The resource url.
     * @param {object} lastManifest The manifest request response if parsed previously.
     */
    parse: function(t, e) {
    },
    /**
     * Get the parsed resource. Will be null/undefined if parsing is not yet started and can be a partial
     * (an intermediate manifest) result if the parser is still running.
     *
     * @return {string} The parsed resource.
     */
    getResource: function() {
      return this._realResource;
    },
    /**
     * Get the transport format. Will be null/undefined if parsing is not yet started or is still running.
     *
     * @return {string} The parsed resource.
     */
    getTransportFormat: function() {
      return this._transportFormat;
    },
    /**
     * Get the last request manifest response object used to parse the resource.
     * Will be null/undefined if parsing is not yet started and can be a partial
     * (an intermediate manifest) result if the parser is still running.
     *
     * @return {object} The last manifest request response used to parse the resource.
     */
    getLastManifest: function() {
      return this._lastManifest;
    },
    /**
     * Get the result of checking a previous manifest to detect if the parser should be used or not.
     *
     * @param {string} resource The resource url.
     * @return {object} The last manifest request response used to parse the resource.
     */
    shouldExecute: function(t) {
      return !0;
    }
  },
  /** @lends youbora.Parser */
  {
    // Static members
    /**
     * List of events that could be fired from this class.
     * @enum
     */
    Event: {
      /** Notifies that this DashParser is done processing. */
      DONE: "done"
    }
  }
), tl = T_, tk = {
  MP4: "MP4",
  MPEG2: "TS",
  CMF: "CMF"
}, il = tk, Ql = lr, ik = tl, rk = bt, Jl = il, nk = ik.extend(
  /** @lends youbora.HlsParser.prototype */
  {
    /**
     * Starts the HLS parsing from the given resource. The first (outside) call should set the
     * parentResource to null.
     *
     * @param {string} resource Either the resource url or the manifest body.
     * @param {string} parentResource Parent resource in case relative paths are sent.
     */
    parse: function(t, e, r) {
      r = r || "";
      var n = null;
      try {
        n = /((\S*?)(\.m3u8|\.m3u|\.ts|\.m4s|\.mp4|\.cmfv|\.m4a)((\?|;)\S*|\n|\r|$))/i.exec(t.replaceAll(",URI=", `
`).replaceAll('"', "").replaceAll(",", `
`));
      } catch (l) {
        rk.warn("Parse HLS Regex failed", l), this.done();
      }
      if (n !== null) {
        var i = n[1].trim(), a = "", s = r.lastIndexOf("/");
        if (i.indexOf("http") !== 0 && s !== -1) {
          if (i[0] === "/" && i[1] !== "/") {
            var o = r.indexOf("/") + 1;
            o += r.substr(o, r.length).indexOf("/") + 1, o += r.substr(o, r.length).indexOf("/"), i = r.slice(0, o) + i;
          } else
            i = r.slice(0, s) + "/" + i;
          a = r.slice(0, s) + "/";
        }
        if (n[3] === ".m3u8" || n[3] === ".m3u")
          if (e)
            this._parseWithManifest(e, a, n);
          else {
            var u = new Ql(i, null, null, { cache: !0, requestHeaders: this._headers });
            u.on(Ql.Event.SUCCESS, function(l) {
              this._parseWithManifest(l, a, n);
            }.bind(this)), u.on(Ql.Event.ERROR, function(l) {
              this.done();
            }.bind(this)), u.send();
          }
        else {
          switch (n[3]) {
            case ".mp4":
            case ".m4s":
            case ".m4a":
              this._transportFormat = Jl.MP4;
              break;
            case ".ts":
              this._transportFormat = Jl.MPEG2;
              break;
            case ".cmfv":
              this._transportFormat = Jl.CMF;
          }
          this._realResource = i, this.done();
        }
      } else
        this.done();
    },
    _parseWithManifest: function(t, e, r) {
      this._lastManifest = t, this.parse(t.getResponseText(), null, e + r[2]);
    },
    shouldExecute: function(t) {
      var e = !0;
      if (t) {
        var r = t.getResponseText();
        e = r.indexOf("#EXTM3U") !== -1;
      }
      return e;
    }
  }
), b_ = nk, Zl, Lg;
function ak() {
  return Lg || (Lg = 1, Zl = {
    cdnName: "LEVEL3",
    parsers: [{
      element: "host+type",
      headerName: "X-WR-Diag",
      regex: /Host:(.+)\sType:(.+)/
    }],
    requestHeaders: {
      "X-WR-Diag": "host"
    },
    parseType: function(t) {
      if (t) {
        if (t.indexOf("TCP_HIT") === 0 || t.indexOf("TCP_MEM_HIT") === 0 || t.indexOf("TCP_IMS_HIT") === 0)
          return 1;
        if (t.indexOf("TCP_MISS") === 0)
          return 2;
      }
      return 0;
    }
  }), Zl;
}
var ed, Ig;
function sk() {
  return Ig || (Ig = 1, ed = {
    cdnName: "CLOUDFRT",
    parsers: [{
      element: "host",
      headerName: "X-Amz-Cf-Id",
      regex: /(.+)/
    }, {
      element: "type",
      headerName: "X-Cache",
      regex: /(\S+)\s.+/
    }],
    parseType: function(t) {
      switch (t) {
        case "Hit":
          return 1;
        case "Miss":
          return 2;
        default:
          return 0;
      }
    }
  }), ed;
}
var td, Dg;
function ok() {
  return Dg || (Dg = 1, td = {
    cdnName: "AKAMAI",
    // requestMethod: 'GET',
    parsers: [{
      element: "type+host",
      headerName: "X-Cache",
      regex: /(.+)\sfrom.+AkamaiGHost\/(.+)\).+/
    }, {
      element: "host",
      headerName: "akamai-mon-iucid-del",
      regex: /(.*)/
    }, {
      element: "type",
      headerName: "akamai-cache-status",
      regex: /(.+)\sfrom\schild/
    }],
    requestHeaders: {
      Pragma: "akamai-x-cache-on"
    },
    parseType: function(t) {
      var e = t.toLowerCase();
      return e.indexOf("hit") !== -1 ? 1 : e.indexOf("miss") !== -1 ? 2 : 0;
    }
  }), td;
}
var id, Rg;
function uk() {
  return Rg || (Rg = 1, id = {
    cdnName: "HIGHNEGR",
    parsers: [{
      element: "host+type",
      headerName: "X-HW",
      regex: /.+,[0-9]+\.(.+)\.(.+)/
    }],
    parseType: function(t) {
      switch (t) {
        case "c":
        case "x":
          return 1;
        default:
          return 2;
      }
    }
  }), id;
}
var rd, Og;
function lk() {
  return Og || (Og = 1, rd = {
    cdnName: "FASTLY",
    parsers: [{
      element: "host",
      headerName: "X-Served-By",
      regex: /([^,\s]+)$/
    }, {
      element: "type",
      headerName: "X-Cache",
      regex: /([^,\s]+)$/
    }],
    parseType: function(t) {
      switch (t) {
        case "HIT":
          return 1;
        case "MISS":
          return 2;
        default:
          return 0;
      }
    }
  }), rd;
}
var nd, Mg;
function dk() {
  return Mg || (Mg = 1, nd = {
    cdnName: "TELEFO",
    parsers: [{
      element: "host+type",
      headerName: "x-tcdn",
      regex: /Host:(.+)\sType:(.+)/
    }],
    requestHeaders: {
      "x-tcdn": "host"
    },
    parseType: function(t) {
      if (t) {
        if (t.indexOf("p") !== -1 || t.indexOf("c") !== -1)
          return 1;
        if (t.indexOf("i") !== -1 || t.indexOf("m") !== -1)
          return 2;
      }
      return 0;
    }
  }), nd;
}
var ad, Ng;
function ck() {
  return Ng || (Ng = 1, ad = {
    cdnName: "AMAZON",
    parsers: [{
      element: "host",
      headerName: "x-amz-cf-pop",
      regex: /(.+)/
    }, {
      element: "type",
      headerName: "x-cache",
      regex: /(.+)\sfrom.+/
    }],
    parseType: function(t) {
      return t.toLowerCase().indexOf("hit") !== -1 ? 1 : t.toLowerCase().indexOf("miss") !== -1 ? 2 : 0;
    }
  }), ad;
}
var sd, Bg;
function hk() {
  return Bg || (Bg = 1, sd = {
    cdnName: "EDGECAST",
    parsers: [{
      element: "host",
      headerName: "Server",
      regex: /\((.+)\/.+\)/
    }, {
      element: "type",
      headerName: "X-Cache",
      regex: /(.+)/
    }],
    parseType: function(t) {
      switch (t) {
        case "HIT":
          return 1;
        case "MISS":
        default:
          return 2;
      }
    }
  }), sd;
}
var od, Fg;
function fk() {
  return Fg || (Fg = 1, od = {
    parsers: [
      {
        element: "name",
        headerName: null,
        regex: /(.+)/
      },
      {
        element: "host",
        headerName: null,
        regex: /(.+)/
      }
    ]
  }), od;
}
var ud, Ug;
function pk() {
  return Ug || (Ug = 1, ud = {
    cdnName: "NOSOTT",
    parsers: [{
      element: "host",
      headerName: "X-NOS-Server",
      regex: /(.+)/
    }, {
      element: "type",
      headerName: "X-Cache",
      regex: /(.*)/
    }],
    parseType: function(t) {
      switch (t) {
        case "Hit":
          return 1;
        case "Miss":
          return 2;
        default:
          return 0;
      }
    }
  }), ud;
}
var gk = Br, Vg = bt, mk = li, ld = lr, St = gk.extend(
  /** @lends youbora.CdnParser.prototype */
  {
    /**
         * Class that asynchronously tries to get information about the CDN where a given resource is
         * hosted.
         *
         * The info we care about is the CDN code itself, the node host and node type.
         *
         * The CDN is queried with http HEAD requests. This only will work if the CDN has been properly
         * configured.
         *
         * When HEAD requests are performed against the resources, the CDN returns a set of headers that
         * contain info about the cdn header and/or cdn type.
         *
         * Each CDN is different; some require special headers to be set when the HEAD request is
         * performed and others don't. Also, the info can come back in any fashion of ways, sometimes
         * both type and host come in the same response header while sometimes they're in different
         * headers. The format of these response headers is also different from CDN to CDN, so a
         * different regex is used for each CDN.
         *
         * Lastly, as the values indicating the CDN type are also different, we need a specific mapping
         * for each one.
         *
         * Every instance of this class will represent a 'way' of parsing the HEAD response. So an
         * instance should be created for Level3, Akamai, Highwinds, etc...
         *
         * @constructs CdnParser
         * @extends youbora.Emitter
         * @memberof youbora
         *
         * @param {object} options This object represents the configuration of a certain CDN parsing
         * methodology.
         * @param {string} options.cdnName see {@link CdnParser#setCdnName}.
         * @param {array} options.parsers see {@link CdnParser#addParser}.
         * @param {array} options.requestMethod see {@link CdnParser#setRequestMethod}.
         * @param {array} options.requestHeaders see {@link CdnParser#setRequestHeader}.
         * @param {function} options.parseType see {@link CdnParser#setParseType}.
         */
    constructor: function(t) {
      this._options = mk.assign({
        cdnName: null,
        parsers: [],
        requestMethod: "HEAD",
        requestHeaders: {},
        parseType: function() {
          return 0;
        }
      }, t), this._responses = {};
    },
    /**
         * Emits DONE event
         */
    done: function() {
      this.emit(St.Event.DONE);
    },
    /**
         * Adds an object that represents a parse step of the headers.
         *
         * Each parser item will define the element parsed (whether if it is a host, a type, both...)
         * a headerName to parse (ie: x-cache) and a regex to execute over that header.
         *
         * @param {object} parser
         * @param {string} parser.element Which element will be parsed from the request.
         * Use {@link CdnParser.ElementType} enum.
         * @param {string} parser.headerName Name of the header to parse.
         * @param {regex} parser.regex Regex to match against the header content.
         *
         * @return itself to chain method calls
         */
    addParser: function(t) {
      return this._options.parsers.push(t), this;
    },
    /**
         * Sets the cdn name. Note that this names are provided by Youbora and must coincede with the
         * ones offered here: {@link http://mapi.youbora.com:8081/cdns}.
         *
         * @return itself to chain method calls
         */
    setCdnName: function(t) {
      return this._options.cdnName = t, this;
    },
    /**
         * Sets the method of the request. HEAD by default.
         *
         * @return itself to chain method calls
         */
    setRequestMethod: function(t) {
      return this._options.requestMethod = t, this;
    },
    /**
         * if this CDN requires special headers to be set in order to respond with the info we want,
         * add them using this method.
         *
         * @param {string} key Name of the header.
         * @param {string} value Content of the header.
         *
         * @return itself to chain method calls
         */
    setRequestHeader: function(t, e) {
      return this._options.requestHeaders[t] = e, this;
    },
    /**
         * Adds a parsing function for parsing the type (hit or miss) of the request.
         *
         * Parser fucntion will receive a string parsed from a type header (see
         * {@link CdnParser#addParser}). Should return 1 in case of HIT, 2 in case of MISS and
         * 0 otherwise.
         *
         * @param {function} parser Parsing function
         *
         * @return itself to chain method calls
         */
    setParseType: function(t) {
      return this._options.parseType = t, this;
    },
    /**
         * Get parsed CDN name.
         *
         * @return {string} The CDN name or null if unknown
         */
    getParsedCdnName: function() {
      return this._cdnName;
    },
    /**
         * Get the parsed CDN node.
         *
         * @return {string} The CDN node or null if unknown
         */
    getParsedNodeHost: function() {
      return this._cdnNodeHost;
    },
    /**
         * Get the parsed CDN type string, as returned in the cdn header response.
         *
         * @return {string} The CDN type string
         */
    getParsedNodeTypeString: function() {
      return this._cdnNodeTypeString;
    },
    /**
         * Get the parsed CDN type, parsed from the type string.
         *
         * @return {string} The CDN type
         */
    getParsedNodeType: function() {
      return this._cdnNodeType;
    },
    /**
         * Returns the request responses from this CdnParser.
         * This is filled with the responses from the constructor, or created empty if null.
         * Then the performed request response (if any) is added to this map.
         * Call this method after "using" the CdnParser and pass the responses to the following
         * CdnParser so it can use the responses if it applies.
         * @return the request responses
         */
    getResponses: function() {
      return this._responses;
    },
    /**
         * Parses given headers to check for matches.
         */
    parse: function(t, e) {
      this._responses = e || {};
      var r = JSON.stringify(this._options.requestHeaders);
      this._responses[r] ? this._parseResponse(this._responses[r]) : this._requestResponse(t);
    },
    _requestResponse: function(t) {
      var e = JSON.stringify(this._options.requestHeaders), r = e !== "{}", n = new ld(t, null, null, {
        method: this._options.requestMethod,
        maxRetries: 0,
        requestHeaders: this._options.requestHeaders,
        cache: !0
      });
      n.on(ld.Event.SUCCESS, function(i) {
        this._responses[e] = i.getResponseHeaders(), this._parseResponse(this._responses[e]);
      }.bind(this)), n.on(ld.Event.ERROR, function(i) {
        r ? (this._options.requestHeaders = {}, this._requestResponse(t)) : this.done();
      }.bind(this)), n.send();
    },
    /**
     *
     * @param headers
     * @private
     */
    _parseResponse: function(t) {
      this._options.parsers.forEach(function(e) {
        if (typeof e.headerName == "string")
          this._parseHeaderResponse(t, e, e.headerName);
        else if (Array.isArray(e.headerName))
          for (var r = 0, n = e.headerName.length; r < n; r++) {
            var i = e.headerName[r];
            typeof i == "string" && this._parseHeaderResponse(t, e, i);
          }
      }.bind(this)), this.done();
    },
    /**
     *
     * @param headers
     * @param parser
     * @param parser
     * @private
     */
    _parseHeaderResponse: function(t, e, r) {
      r && (r = r ? r.toLowerCase() : "", t.split(`
`).forEach(function(n) {
        var i = n.indexOf(":");
        if (i !== -1) {
          var a = n.slice(0, i).toLowerCase();
          a === r && this._executeParser(e, n.slice(i + 1));
        }
      }.bind(this)));
    },
    _executeParser: function(t, e) {
      try {
        var r = t.regex.exec(e.trim());
        if (r !== null)
          switch (this._options.cdnName && (this._cdnName = this._options.cdnName), t.element) {
            case St.ElementType.HOST:
              this._cdnNodeHost = r[1];
              break;
            case St.ElementType.TYPE:
              this._cdnNodeTypeString = r[1], this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString);
              break;
            case St.ElementType.HOST_AND_TYPE:
              this._cdnNodeHost = r[1], this._cdnNodeTypeString = r[2], this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString);
              break;
            case St.ElementType.TYPE_AND_HOST:
              this._cdnNodeTypeString = r[1], this._cdnNodeType = this._options.parseType(this._cdnNodeTypeString), this._cdnNodeHost = r[2];
              break;
            case St.ElementType.NAME:
              this._cdnName = r[1].toUpperCase();
              break;
          }
      } catch {
        Vg.warn("CDN parsing for " + this._options.cdnName + " could not parse header value " + e);
      }
    },
    shouldExecute: function() {
      return !0;
    }
  },
  /** @lends youbora.CdnParser */
  {
    // Static members
    /**
         * List of events that could be fired from this class.
         *
         * @enum
         */
    Event: {
      /** Notifies that this CdnParser is done processing. */
      DONE: "done"
    },
    /**
         * Possible different bits of info we can get from a header.
         *
         * @enum
         */
    ElementType: {
      HOST: "host",
      TYPE: "type",
      HOST_AND_TYPE: "host+type",
      TYPE_AND_HOST: "type+host",
      NAME: "name"
    },
    /**
         * List of available CDN parsers.
         * @private
         */
    _cdnConfigs: {},
    /**
         * This is a special case. The BalancerCdnParser is a custom CDN definition
         * that tries to get the CDN name directly from one of the headers. This method can be used
         * as a shortcut to creating a new CDN definition.
         *
         * This is usually used with DNS-based load balance services, such as Cedexis.
         *
         * Youboralib will use this method by itself using the configuration passed in the
         * {@link Options}.
         *
         * @param {string} cdnNameHeader the header response name where to get the CDN name from.
         * @param {string} cdnNodeNameHeader the header response name where to get the host name from.
         */
    setBalancerHeaderName: function(t, e) {
      St._cdnConfigs.Balancer.parsers[0].headerName = t, St._cdnConfigs.Balancer.parsers[1].headerName = e;
    },
    /**
         * Create one of the pre-defined CDN parsers. This method will be called with the keys passed
         * to {@link Options#'parse.CdnNode.list'}.
         *
         * Before using this method, configs must be added first using {@link CdnParser.add}.
         *
         * @param {string} cdnName Name of the CDN
         * @return {CdnParser} An instance or undefined if the names does not match any CDN.
         */
    create: function(t) {
      if (St._cdnConfigs[t])
        return new St(St._cdnConfigs[t]);
      Vg.warn("Tried to create an unexisting CdnParser named " + t);
    },
    /**
         * Adds the given CdnParser's config to the available list. Objects sent must comply with
         * CdnParser constructor.
         *
         * @param {string} key The name that will identify the CDN.
         * @param {Object} config The parser that defines the CDN.
         */
    add: function(t, e) {
      St._cdnConfigs[t] = e;
    }
  }
);
St.add("Level3", ak());
St.add("Cloudfront", sk());
St.add("Akamai", ok());
St.add("Highwinds", uk());
St.add("Fastly", lk());
St.add("Telefonica", dk());
St.add("Amazon", ck());
St.add("Edgecast", hk());
St.add("Balancer", fk());
St.add("NosOtt", pk());
var S_ = St, vk = Br, yk = bt, dd = lr, Nc = vk.extend({
  constructor: function(t) {
    this.plugin = t, this.headerName = "x-cdn";
  },
  init: function() {
    var t = null;
    this.plugin && (this.plugin.getAdapter() && this.plugin.getAdapter().getURLToParse() ? t = this.plugin.getAdapter().getURLToParse() : t = this.plugin.getResource()), this.plugin && this.plugin.getAdapter() && this.plugin.getAdapter().flags.isStarted && this._request(t);
  },
  done: function(t) {
    this.emit(Nc.Events.DONE, t);
  },
  error: function() {
    this.emit(Nc.Events.ERROR);
  },
  _successfulRequest: function(t) {
    setTimeout(this.init.bind(this), parseInt(this.plugin.options["parse.cdnTTL"]) * 1e3);
    var e = t.getResponseHeaders().split(`
`), r = null;
    for (var n in e) {
      var i = e[n], a = i.indexOf(this.headerName);
      a > -1 && (r = i.substring(a + this.headerName.length + 1, i.length - 1).replace(" ", ""));
    }
    this.done(r);
  },
  _failedRequest: function() {
    setTimeout(this.init.bind(this), parseInt(this.plugin.options["parse.cdnTTL"]) * 1e3), yk.warn("CDN switch detection request failed"), this.error();
  },
  _request: function(t) {
    var e = new dd(t, null, null, { method: "HEAD", cache: !0 });
    e.on(dd.Event.SUCCESS, this._successfulRequest.bind(this)), e.on(dd.Event.ERROR, this._failedRequest.bind(this)), e.send();
  }
}, {
  Events: {
    DONE: "done",
    ERROR: "error"
  }
}), _k = Nc, cd = lr, Tk = tl, hd = bt, fd = il, bk = Tk.extend(
  /** @lends youbora.DashParser.prototype */
  {
    /**
     * Starts the Dash parsing from the given resource. The first (outside) call should set the
     * parentResource to null.
     *
     * @param {string} resource The resource url.
     */
    parse: function(t, e) {
      if (e)
        this.parseLocation(e, t);
      else {
        var r = new cd(t, null, null, { cache: !0, requestHeaders: this._headers });
        r.on(cd.Event.SUCCESS, function(n) {
          this.parseLocation(n, t);
        }.bind(this)), r.on(cd.Event.ERROR, function(n) {
          this.done();
        }.bind(this)), r.send();
      }
    },
    parseLocation: function(t, e) {
      this.iterations--;
      var r = new RegExp(/<Location>([\s\S]+)<\/Location>/);
      try {
        this._lastManifest = t;
        var n = t.getResponseText(), i = r.exec(n);
        if (i && i[1])
          var a = this._htmlDecode(i[1].replace(`
`, ""));
        a && a !== e && this.iterations > 0 ? this.parse(a) : this.parseFinalResource(n, e);
      } catch {
        hd.warn("Dash parse failed"), this.done();
      }
    },
    _htmlDecode: function(t) {
      if (typeof document < "u" && typeof document.createElement == "function") {
        var e = document.createElement("textarea");
        return e.innerHTML = t, e.childNodes && e.childNodes.length ? e.childNodes[0].nodeValue : t;
      }
      return t;
    },
    parseFinalResource: function(t, e) {
      var r = new RegExp(/<BaseURL>[\r\n]*(.*?)[\r\n]*<\/BaseURL>/), n = new RegExp(/<SegmentURL[\s\S]*media="([^"]+)/), i = new RegExp(/<SegmentTemplate[\s\S]*media="([^"]+)/), a = null;
      try {
        a = r.exec(t) || i.exec(t) || n.exec(t), this._getManifestMetadata(t), a && a[1] && this._isFullUrl(a[1]) ? a[1].indexOf('"') > 0 ? this._realResource = a[1].substr(0, a[1].indexOf('"')).replace(`
`, "") : this._realResource = a[1].replace(`
`, "") : this._realResource = e;
      } catch {
        hd.warn("Dash manifest parse failed");
      }
      this.done();
    },
    _getManifestMetadata: function(t) {
      try {
        var e = new RegExp(/<AdaptationSet[\s\S]*mimeType="video\/([^"]+)/), r = e.exec(t), n = null;
        switch (r[1]) {
          case "mp4":
          case "m4s":
            n = fd.MP4;
            break;
          case "mp2t":
            n = fd.MPEG2;
            break;
          case "cmfv":
            n = fd.CMF;
            break;
        }
        this._transportFormat = n;
      } catch {
        hd.warn("Couldnt find the transport format");
      }
    },
    _isFullUrl: function(t) {
      return t.indexOf("http") !== -1;
    },
    shouldExecute: function(t) {
      var e = !0;
      if (t) {
        var r = t.getResponseText();
        e = r.indexOf("<MPD") !== -1;
      }
      return e;
    }
  }
), E_ = bk, pd = lr, Sk = tl, Ek = Sk.extend(
  /** @lends youbora.LocationheaderParser.prototype */
  {
    /**
     * Parses given header to check.
     */
    parse: function(t, e) {
      if (e)
        this._parseWithManifest(e);
      else {
        this._realResource = t;
        var r = new pd(t, null, null, {
          cache: !0,
          requestHeaders: this._headers
        });
        r.on(pd.Event.SUCCESS, function(n) {
          this._parseWithManifest(n);
        }.bind(this)), r.on(pd.Event.ERROR, function(n) {
          this.done();
        }.bind(this)), r.send();
      }
    },
    _parseWithManifest: function(t) {
      this._lastManifest = t;
      var e = t.getResponseHeaders(), r = !1;
      t && t.xhr && t.xhr.responseURL && t.xhr.responseURL !== this._realResource ? (this._realResource = t.xhr.responseURL, this.parse(this._realResource), r = !0) : e.split(`
`).forEach(function(n) {
        n.startsWith("Location:") && (this._realResource = n.slice(10), this.parse(this._realResource), r = !0);
      }.bind(this)), r || this.done();
    }
  }
), x_ = Ek, xk = Jr, Ck = b_, gd = S_, md = _k, Ak = E_, wk = tl, Pk = x_, jg = bt, kk = Wi, C_ = xk.extend(
  /** @lends youbora.ResourceTransform.prototype */
  {
    /**
     * This class parses resource to fetch HLS transportstreams and CDN-related info.
     *
     * @constructs ResourceTransform
     * @extends youbora.Transform
     * @memberof youbora
     *
     * @param {Plugin} plugin Instance of {@link Plugin}
     */
    constructor: function(t) {
      C_.__super__.constructor.apply(this, arguments), this._plugin = t, this._realResource = null, this._transportFormat = null, this._initResource = null, this._cdnName = null, this._cdnNodeHost = null, this._cdnNodeTypeString = null, this._cdnNodeType = null, this._responses = {}, this._isBusy = !1, this.transformName = "Resource";
    },
    /**
     * Get the resource. If the transform is done, the real (parsed) resource will be returned
     * Otherwise the initial one is returned.
     *
     * @return {string} The initial or parsed resource
     */
    getResource: function() {
      return this._realResource;
    },
    _getInitialCdnResource: function() {
      return this._realResource || this._initResource;
    },
    /**
     * Get the transport format. If the transform detected the chunk format it will be returned, if not, null.
     *
     * @return {string} The streaming protocol
     */
    getTransportFormat: function() {
      return this._transportFormat;
    },
    /**
     * Get the parsed CDN name.
     *
     * @return {string} The CDN name or null if unknown
     */
    getCdnName: function() {
      return this._cdnName;
    },
    /**
     * Get the parsed CDN node.
     *
     * @return {string} The CDN node or null if unknown
     */
    getNodeHost: function() {
      return this._cdnNodeHost;
    },
    /**
     * Get the parsed CDN type string, as returned in the cdn header response.
     *
     * @return {string} The CDN type string
     */
    getNodeTypeString: function() {
      return this._cdnNodeTypeString;
    },
    /**
     * Get the parsed CDN type, parsed from the type string.
     *
     * @return {string} The CDN type
     */
    getNodeType: function() {
      return this._cdnNodeType;
    },
    /**
     * Start the execution. Can be called more than once. If already running, it will be ignored,
     * if ended it will restart.
     * @param {string} resource the original resource
     */
    init: function(t) {
      if (!t) {
        this.done();
        return;
      }
      this._isBusy || (this._isBusy = !0, this._initResource = t, this._parseManifestEnabled = this._plugin.isParseManifest(), this._cdnEnabled = this._plugin.isParseCdnNode(), this._cdnList = this._plugin.getParseCdnNodeList().slice(), gd.setBalancerHeaderName(this._plugin.getParseCdnNodeNameHeader(), this._plugin.getParseNodeHeader()), this._setTimeout(), this._parseManifestEnabled ? this._isFinalUrl(this._initResource) ? (this._realResource = this._initResource, this.done()) : this.parseManifest() : this._parseCDN());
    },
    _isFinalUrl: function(t) {
      var e = [".ts", ".mp4", ".m4s", ".cmfv"];
      t = t || "";
      for (var r in e) {
        var n = e[r];
        if (t.lastIndexOf(n) === t.length - n.length)
          return !0;
      }
      return !1;
    },
    // done: function () {
    //  Transform.prototype.done.apply(this, arguments) // super
    // },
    _setTimeout: function() {
      var t = function() {
        this._isBusy && (this.done(), jg.warn("ResourceTransform has exceeded the maximum execution time (3s) and will be aborted."));
      }.bind(this);
      try {
        this._parseTimeout = setTimeout(t, 3e3);
      } catch (e) {
        typeof atv < "u" ? this._parseTimeout = atv.setTimeout(t, 3e3) : jg.error(e);
      }
    },
    parseManifest: function(t, e) {
      var r = this._plugin.options["parse.manifest.auth"], n = [new Pk(r), new Ak(r), new Ck(r)];
      this._parseManifest(n, t, e || this._initResource);
    },
    _parseManifest: function(t, e, r, n) {
      if (t.length > 0) {
        var i = t[0];
        i.shouldExecute(e) ? (i.on(wk.Event.DONE, function() {
          this._parseManifest(t.slice(1, t.length), i.getLastManifest(), i.getResource(), i.getTransportFormat() || n);
        }.bind(this)), i.parse(r, e)) : this._parseManifest(t.slice(1, t.length), e, r, n);
      } else
        this._transportFormat = n, this._realResource = r, this._parseCDN();
    },
    _parseCDN: function() {
      if (this._plugin.isCdnSwitch())
        this.switchDetector = new md(this._plugin), this.switchDetector.on(md.Events.DONE, function(r) {
          this._cdnName = r.data, this.done();
        }.bind(this)), this.switchDetector.on(md.Events.ERROR, function() {
          this.done();
        }.bind(this)), this.switchDetector.init();
      else if (this._cdnEnabled && this._cdnList.length > 0) {
        var t = this._cdnList.shift();
        if (this.getNodeHost())
          return;
        var e = gd.create(t);
        e ? (e.on(gd.Event.DONE, function() {
          this._responses = e.getResponses(), this._cdnName = e.getParsedCdnName(), this._cdnNodeHost = e.getParsedNodeHost(), this._cdnNodeTypeString = e.getParsedNodeTypeString(), this._cdnNodeType = e.getParsedNodeType(), this.getNodeHost() ? this.done() : this._parseCDN();
        }.bind(this)), e.parse(this._getInitialCdnResource(), this._responses)) : this._parseCDN();
      } else
        this.done();
    },
    /**
     * Replaces the resource and/or Cdn info for the /start service.
     *
     * @param {YBRequest} request YBRequest to transform.
     */
    parse: function(t) {
      if (t.service === kk.Service.START) {
        var e = this._plugin.requestBuilder.lastSent;
        e.parsedResource = t.params.parsedResource = this.getResource() || t.params.parsedResource, e.transportFormat = t.params.transportFormat = this.getTransportFormat() || t.params.transportFormat, this._cdnEnabled && (e.cdn = t.params.cdn = t.params.cdn || this.getCdnName(), e.nodeHost = t.params.nodeHost = this.getNodeHost() || t.params.nodeHost, e.nodeType = t.params.nodeType = this.getNodeType() || t.params.nodeType, e.nodeTypeString = t.params.nodeTypeString = this.getNodeTypeString() || t.params.nodeTypeString);
      }
    }
  }
), A_ = C_, Hg = Jr, Lk = Hg.extend(
  /** @lends youbora.OfflineTransform.prototype */
  {
    /**
     * This class manages Fastdata service and view index.
     *
     * @constructs
     * @extends youbora.Transform
     * @memberof youbora
     *
     * @param {Plugin} plugin Instance of {@link Plugin}
     * @param {string} session If provided, plugin will use this as a FD response.
     */
    constructor: function(t, e) {
      this._sendRequest = !1, this._isBusy = !1, this.plugin = t, this.session = e, this.transformName = "Offline";
    },
    /**
     * Transform requests
     * @param {youbora.comm.YBRequest} request YBRequest to transform.
     */
    parse: function(t) {
      t && this.plugin.offlineStorage && this.plugin.offlineStorage.addEvent(t.service, t.params);
    },
    hasToSend: function(t) {
      return !1;
    },
    getState: function() {
      return Hg.STATE_OFFLINE;
    }
  }
), w_ = Lk, Ik = wt, Dk = bt, Bc = Ik.extend({
  exists: function(t) {
    return Bc.Dictionary.hasOwnProperty(t);
  },
  getNewName: function(t) {
    var e = Bc.Dictionary[t];
    return Dk.warn('The option "' + t + '" is deprecated, use "' + e + '" instead'), e;
  }
}, {
  // Keys are old option names
  // Values are new option names
  Dictionary: {
    httpSecure: "app.https",
    username: "user.name",
    anonymousUser: "user.anonymousId",
    obfuscateIp: "user.obfuscateIp",
    userType: "user.type",
    "content.title2": "content.program",
    "background.settings.iphone": "background.settings.iOS",
    "parse.hls": "parse.manifest",
    "parse.dash": "parse.manifest",
    "parse.locationHeader": "parse.manifest",
    "extraparam.1": "content.customDimension.1",
    "extraparam.2": "content.customDimension.2",
    "extraparam.3": "content.customDimension.3",
    "extraparam.4": "content.customDimension.4",
    "extraparam.5": "content.customDimension.5",
    "extraparam.6": "content.customDimension.6",
    "extraparam.7": "content.customDimension.7",
    "extraparam.8": "content.customDimension.8",
    "extraparam.9": "content.customDimension.9",
    "extraparam.10": "content.customDimension.10",
    "extraparam.11": "content.customDimension.11",
    "extraparam.12": "content.customDimension.12",
    "extraparam.13": "content.customDimension.13",
    "extraparam.14": "content.customDimension.14",
    "extraparam.15": "content.customDimension.15",
    "extraparam.16": "content.customDimension.16",
    "extraparam.17": "content.customDimension.17",
    "extraparam.18": "content.customDimension.18",
    "extraparam.19": "content.customDimension.19",
    "extraparam.20": "content.customDimension.20",
    "ad.extraparam.1": "ad.customDimension.1",
    "ad.extraparam.2": "ad.customDimension.2",
    "ad.extraparam.3": "ad.customDimension.3",
    "ad.extraparam.4": "ad.customDimension.4",
    "ad.extraparam.5": "ad.customDimension.5",
    "ad.extraparam.6": "ad.customDimension.6",
    "ad.extraparam.7": "ad.customDimension.7",
    "ad.extraparam.8": "ad.customDimension.8",
    "ad.extraparam.9": "ad.customDimension.9",
    "ad.extraparam.10": "ad.customDimension.10"
  }
}), Rk = Bc, Ok = {
  HDS: "HDS",
  HLS: "HLS",
  MSS: "MSS",
  DASH: "DASH",
  RTMP: "RTMP",
  RTP: "RTP",
  RTSP: "RTSP",
  DVB: "DVB",
  DVBC: "DVB-C",
  DVBT: "DVB-T",
  DVBT2: "DVB-T2",
  MULTICAST: "MULTICAST"
}, P_ = Ok, Mk = wt, Nk = Rk, Bk = bt, Fk = il, Uk = P_, Wg = pf, Fc = Mk.extend(
  /** @lends youbora.Options.prototype */
  {
    /**
     * This Class store youbora configuration settings.
     * Any value specified in this class, if set, will override the info the plugin is able to get
     * on its own.
     *
     * @constructs Options
     * @param {Object|Options} [options] A literal containing values.
     * @extends youbora.YouboraObject
     * @memberof youbora
     */
    constructor: function(t) {
      this.enabled = !0, this.host = "a-fds.youborafds01.com", this.accountCode = "nicetest", this.authToken = null, this.authType = "Bearer", this.preventZombieViews = !0, this.offline = !1, this.referer = null, this.referral = null, this.disableCookies = !0, this.forceCookies = !1, this.disableStorage = !1, this["user.email"] = null, this["user.type"] = null, this["user.name"] = null, this["user.obfuscateIp"] = !1, this["user.anonymousId"] = null, this["user.privacyProtocol"] = null, this["parse.manifest"] = !1, this["parse.manifest.auth"] = {}, this["parse.cdnNameHeader"] = ["x-cdn-forward"], this["parse.cdnNodeHeader"] = "", this["parse.cdnNode"] = !1, this["parse.cdnNode.list"] = ["Akamai", "Amazon", "Cloudfront", "Level3", "Fastly", "Highwinds", "Telefonica", "Edgecast", "NosOtt"], this["parse.fdsResponseHost"] = null, this["parse.cdnSwitchHeader"] = !1, this["parse.cdnTTL"] = 60, this["network.ip"] = null, this["network.isp"] = null, this["network.connectionType"] = null, this["device.id"] = null, this["device.code"] = null, this["device.model"] = null, this["device.brand"] = null, this["device.type"] = null, this["device.name"] = null, this["device.osName"] = null, this["device.osVersion"] = null, this["device.browserName"] = null, this["device.browserVersion"] = null, this["device.browserType"] = null, this["device.browserEngine"] = null, this["device.EDID"] = null, this["device.isAnonymous"] = !1, this["content.transactionCode"] = null, this["content.resource"] = null, this["content.isLive"] = null, this["content.isLive.noSeek"] = !1, this["content.isLive.noMonitor"] = !1, this["content.title"] = null, this["content.program"] = null, this["content.duration"] = null, this["content.fps"] = null, this["content.segmentDuration"] = null, this["content.bitrate"] = null, this["content.totalBytes"] = null, this["content.sendTotalBytes"] = !1, this["content.throughput"] = null, this["content.rendition"] = null, this["content.cdn"] = null, this["content.cdnNode"] = null, this["content.cdnType"] = null, this["content.metadata"] = {}, this["content.metrics"] = {}, this["content.streamingProtocol"] = null, this["content.transportFormat"] = null, this["content.package"] = null, this["content.saga"] = null, this["content.tvShow"] = null, this["content.season"] = null, this["content.episodeTitle"] = null, this["content.channel"] = null, this["content.id"] = null, this["content.imdbId"] = null, this["content.gracenoteId"] = null, this["content.type"] = null, this["content.genre"] = null, this["content.language"] = null, this["content.autodetect.language"] = !0, this["content.subtitles"] = null, this["content.autodetect.subtitles"] = !0, this["content.contractedResolution"] = null, this["content.cost"] = null, this["content.price"] = null, this["content.playbackType"] = null, this["content.drm"] = null, this["content.encoding.videoCodec"] = null, this["content.encoding.audioCodec"] = null, this["content.encoding.codecSettings"] = null, this["content.encoding.codecProfile"] = null, this["content.encoding.containerFormat"] = null, this["ad.metadata"] = {}, this["ad.campaign"] = null, this["ad.creativeId"] = null, this["ad.provider"] = null, this["ad.resource"] = null, this["ad.title"] = null, this["ad.duration"] = null, this["ad.expectedPattern"] = null, this["ad.givenAds"] = null, this["ad.breaksTime"] = null, this["ad.expectedBreaks"] = null, this["ad.givenBreaks"] = null, this["ad.ignore"] = !1, this["ad.blockerDetected"] = null, this["app.name"] = null, this["app.releaseVersion"] = null, this["app.https"] = !1, this["background.enabled"] = !0, this["background.settings"] = null, this["background.settings.android"] = "stop", this["background.settings.iOS"] = "stop", this["background.settings.desktop"] = null, this["background.settings.tv"] = "stop", this["background.settings.playstation"] = "stop", this["smartswitch.configCode"] = null, this["smartswitch.groupCode"] = null, this["smartswitch.contractCode"] = null, this["content.customDimensions"] = {}, this["content.customDimension.1"] = null, this["content.customDimension.2"] = null, this["content.customDimension.3"] = null, this["content.customDimension.4"] = null, this["content.customDimension.5"] = null, this["content.customDimension.6"] = null, this["content.customDimension.7"] = null, this["content.customDimension.8"] = null, this["content.customDimension.9"] = null, this["content.customDimension.10"] = null, this["content.customDimension.11"] = null, this["content.customDimension.12"] = null, this["content.customDimension.13"] = null, this["content.customDimension.14"] = null, this["content.customDimension.15"] = null, this["content.customDimension.16"] = null, this["content.customDimension.17"] = null, this["content.customDimension.18"] = null, this["content.customDimension.19"] = null, this["content.customDimension.20"] = null, this["ad.customDimension.1"] = null, this["ad.customDimension.2"] = null, this["ad.customDimension.3"] = null, this["ad.customDimension.4"] = null, this["ad.customDimension.5"] = null, this["ad.customDimension.6"] = null, this["ad.customDimension.7"] = null, this["ad.customDimension.8"] = null, this["ad.customDimension.9"] = null, this["ad.customDimension.10"] = null, this.forceInit = !1, this["session.metrics"] = {}, this["session.context"] = !1, this["errors.fatal"] = [], this["errors.nonFatal"] = [], this["errors.ignore"] = [], this.linkedViewId = null, this.waitForMetadata = !1, this.pendingMetadata = [], this.method = Wg.GET, this["playhead.monitor"] = !0, this["readyState.monitor"] = !0, this.setOptions(t);
    },
    /**
    * Recursively sets the properties present in the params object.
    * ie: this.username = params.username.
    *
    * @param {Object} options A literal or another Data containing values.
    * @param {Object} [base=this] Start point for recursion.
    */
    setOptions: function(t, e) {
      var r = !1;
      if (e === void 0) {
        e = this, r = !0;
        var n = new Nk();
      }
      if (typeof t < "u")
        for (var i in t) {
          var a = !1, s = null;
          r && (this.hasOwnProperty(i) || (n.exists(i) ? (s = n.getNewName(i), a = !0) : Bk.warn('The option "' + i + '" does not exist, so it cannot be set'))), typeof e[i] == "object" && e[i] !== null && !Array.isArray(e[i]) && i === "parse.cdnNode.list" ? this.setOptions(t[i], e[i]) : a ? e[s] = t[i] : e[i] = t[i];
        }
    },
    /**
    * Sets all the values given in an array as extraparams. Limit is 20
    * @param {array<string>} paramsArray array of extraparam strings
    * */
    setExtraParams: function(t) {
      var e = 20;
      if (!(typeof t != "object" || !t.length)) {
        for (t.length >= e && (t = t.slice(0, e)); t.length < e; )
          t.push(null);
        t.forEach(function(r, n) {
          this["content.customDimension." + (n + 1).toString()] = r;
        }.bind(this));
      }
    },
    /**
    * @alias youbora.options.prototype.setExtraParams.
    */
    setCustomDimensions: function() {
      Fc.prototype.setExtraParams.apply(this, arguments);
    },
    /**
    * Sets all the values given in an array as extraparams. Limit is 10
    * @param {array<string>} paramsArray array of extraparam strings
    * */
    setAdExtraParams: function(t) {
      var e = 10;
      if (!(typeof t != "object" || !t.length)) {
        for (t.length >= e && (t = t.slice(0, e)); t.length < e; )
          t.push(null);
        t.forEach(function(r, n) {
          this["ad.customDimension." + (n + 1).toString()] = r;
        }.bind(this));
      }
    },
    /**
    * @alias youbora.options.prototype.setAdExtraParams.
    */
    setAdCustomDimensions: function() {
      Fc.prototype.setAdExtraParams.apply(this, arguments);
    }
  },
  {
    // Constants
    StreamingProtocol: Uk,
    TransportFormat: Fk,
    RequestMethod: Wg
  }
), k_ = Fc, qg = Jr, Io = Wi, Vk = qg.extend(
  /** @lends youbora.FlowTransform.prototype */
  {
    _services: [Io.Service.INIT, Io.Service.START, Io.Service.OFFLINE_EVENTS],
    /**
     * Returns if transform is blocking.
     *
     * @param {YBRequest} request Request to transform.
     * @return {bool} True if queue shall be blocked.
     */
    isBlocking: function(t) {
      if (this._isBusy && t != null) {
        if (this._services.indexOf(t.service) !== -1)
          this.done();
        else if (t.service === Io.Service.ERROR)
          return !1;
      }
      return qg.prototype.isBlocking.apply(this, arguments);
    }
  }
), jk = Vk, Hk = wt, Do = bt, Wk = Hk.extend(
  /** @lends youbora.YouboraStorage.prototype */
  {
    /**
     *
     * @constructs YouboraStorage
     * @extends YouboraObject
     * @memberof youbora
     *
     * @param {String} [prefix] Optional. Sets the prefix for saved objects in storages or cookies. 'youbora' by default.
     * @param {Boolean} [disableCookies] Optional. Set to true to disable cookies fallback. True by default.
     */
    constructor: function(t, e, r, n) {
      this.prefix = t || "youbora", this.disableCookies = e, this.forceCookies = r, this.disabled = n;
    },
    /**
     * Returns if storages are available or not
     *
     */
    isEnabled: function() {
      if (this.disabled)
        return !1;
      var t = !0;
      if (!this.forceCookies)
        try {
          localStorage.setItem(this.prefix + ".test", "true"), localStorage.removeItem(this.prefix + ".test");
        } catch {
          t = !1;
        }
      return t;
    },
    /**
     * Saves in localStorage or equivalent
     *
     * @param {string} key Key of the value. Prefix will be appended.
     * @param {string} value Value.
     */
    setLocal: function(t, e) {
      if (this.disabled)
        return null;
      var r = null;
      try {
        this.forceCookies || (typeof localStorage > "u" || !localStorage) && !this.disableCookies ? r = this._setCookie(this.prefix + ".local." + t, e) : r = localStorage.setItem(this.prefix + "." + t, e);
      } catch {
        Do.error("Youbora Infinity needs localStorage or cookies, not supported by your browser.");
      }
      return r;
    },
    /**
     * Reads from localStorage or equivalent
     *
     * @param {string} key Key of the value. prefix will be appended.
     */
    getLocal: function(t) {
      return this.disabled ? null : this._localGetRemove("getItem", "_getCookie", t);
    },
    /**
     * Removes from localStorage or equivalent
     *
     * @param {string} key Key of the value. prefix will be appended.
     */
    removeLocal: function(t) {
      return this.disabled ? null : this._localGetRemove("removeItem", "_removeCookie", t);
    },
    _localGetRemove: function(t, e, r) {
      var n = null;
      try {
        this.forceCookies || (typeof localStorage > "u" || !localStorage) && !this.disableCookies ? n = this[e](this.prefix + ".local." + r) : n = localStorage[t](this.prefix + "." + r);
      } catch {
        Do.error("Youbora Infinity needs localStorage or cookies, not supported by your browser.");
      }
      return n;
    },
    /**
     * Saves in sessionStorage or equivalent
     *
     * @param {string} key Key of the value. prefix will be appended.
     * @param {string} value Value.
     */
    setSession: function(t, e) {
      if (this.disabled)
        return null;
      var r = null;
      try {
        this.forceCookies || (typeof sessionStorage > "u" || !sessionStorage) && !this.disableCookies ? r = this._setCookie(this.prefix + ".session." + t, e) : r = sessionStorage.setItem(this.prefix + "." + t, e);
      } catch {
        Do.error("Youbora Infinity needs sessionStorage or cookies, not supported by your browser.");
      }
      return r;
    },
    /**
     * Reads from sessionStorage or equivalent
     *
     * @param {string} key Key of the value. prefix will be appended.
     */
    getSession: function(t) {
      return this.disabled ? null : this._sessionGetRemove("getItem", "_getCookie", t);
    },
    /**
    * Removes from sessionStorage or equivalent
    *
    * @param {string} key Key of the value. prefix will be appended.
    */
    removeSession: function(t) {
      return this.disabled ? null : this._sessionGetRemove("removeItem", "_removeCookie", t);
    },
    _sessionGetRemove: function(t, e, r) {
      var n = null;
      try {
        this.forceCookies || (typeof sessionStorage > "u" || !sessionStorage) && !this.disableCookies ? n = this[e](this.prefix + ".session." + r) : n = sessionStorage[t](this.prefix + "." + r);
      } catch {
        Do.error("Youbora Infinity needs sessionStorage or cookies, not supported by your browser.");
      }
      return n;
    },
    /**
     * Calls getSession and getLocal for the same key
     * @param {string} key Key of the value. prefix will be appended.
     */
    getStorages: function(t) {
      return this.getSession(t) || this.getLocal(t);
    },
    /**
     * Calls getSession and getLocal with the same key and value
     * @param {string} key Key of the value. prefix will be appended.
     * @param {string} value Value.
     */
    setStorages: function(t, e) {
      this.setSession(t, e), this.setLocal(t, e);
    },
    /**
     * Calls getSession and getLocal for the same key
     * @param {string} key Key of the value. prefix will be appended.
     */
    removeStorages: function(t) {
      this.removeSession(t), this.removeLocal(t);
    },
    // Private cookies methods
    /**
    * Sets a cookie value
    *
    * @param {string} cname Key of the value.
    * @param {Object} cvalue Value.
    */
    _setCookie: function(t, e) {
      if (typeof document < "u") {
        var r = ";";
        typeof location < "u" && (r += "domain=" + location.host.split(".").reverse().splice(0, 2).reverse().join(".") + ";path=/;"), document.cookie = t + "=" + e + r;
      }
    },
    /**
    * Gets a cookie value
    *
    * @param {string} cname Key of the value.
    */
    _getCookie: function(t) {
      if (typeof document < "u")
        for (var e = t + "=", r = decodeURIComponent(document.cookie), n = r.split(";"), i = 0; i < n.length; i++) {
          for (var a = n[i]; a.charAt(0) === " "; )
            a = a.substring(1);
          if (a.indexOf(e) === 0)
            return a.substring(e.length, a.length);
        }
      return null;
    },
    /**
    * Removes a cookie
    *
    * @param {string} cname Key of the value.
    */
    _removeCookie: function(t) {
      this._setCookie(t, "");
    }
  }
), mf = Wk, qk = wt, $k = mf, zk = qk.extend({
  constructor: function() {
    this.storage = new $k("youboraOffline", !0), this.actualView = null, this.viewList = [], this.givenIds = [], this._getOldViewList();
  },
  _newView: function() {
    var t = this._getValidId();
    this.storage.setLocal(t, ""), this.viewList.push(t), this.storage.setLocal("views", this.viewList), this.actualView = t;
  },
  addEvent: function(t, e) {
    if (t === "/start" && this._newView(), t === "/init" || !this.actualView)
      return null;
    var r = '{"request":"' + t.slice(1) + '",';
    r += '"unixtime":' + Date.now() + ",";
    for (var n in e) {
      if (e[n] === void 0)
        break;
      r += '"' + n + '":', n === "code" ? r += '"CODE_PLACEHOLDER",' : n === "sessionId" ? r += '"SESSION_PLACEHOLDER",' : n === "sessionRoot" ? r += '"ROOT_PLACEHOLDER",' : typeof e[n] == "string" ? r += '"' + e[n] + '",' : typeof e[n] == "object" ? r += '"' + JSON.stringify(e[n]).replace(/"/g, '\\"') + '",' : r += e[n] + ",";
    }
    r = r.slice(0, -1), r += "}";
    var i = this.storage.getLocal(this.actualView);
    i !== "" && (i = i + ","), this.storage.setLocal(this.actualView, i + r);
  },
  getView: function() {
    if (this.viewList.length > this.givenIds.length)
      for (var t = 0; ; ) {
        var e = this.viewList[t];
        if (this.givenIds.indexOf(e) < 0)
          return this.givenIds.push(e), ["[" + this.storage.getLocal(e) + "]", e];
        t++;
      }
    return [null, null];
  },
  removeView: function(t) {
    this.storage.removeLocal(t);
    var e = this.viewList.indexOf(t);
    e !== -1 && this.viewList.splice(e, 1), e = this.givenIds.indexOf(t), e !== -1 && this.givenIds.splice(e, 1), this.storage.setLocal("views", this.viewList.toString()), t === this.actualView && (this.actualView = null);
  },
  _getOldViewList: function() {
    var t = "";
    this.storage.getLocal("views") ? t = this.storage.getLocal("views") : this.storage.setLocal("views", ""), t === "" ? this.viewList = [] : typeof t.split == "function" && (this.viewList = t.split(","));
  },
  _getValidId: function() {
    var t = Math.floor(Math.random() * 1e8).toString();
    return this.viewList.indexOf(t) >= 0 ? this._getValidId() : t;
  },
  sent: function() {
    this.givenIds = [];
  }
}), Gk = zk, Kk = wt, Xk = bt, vd = [
  "accountCode",
  "username",
  "anonymousUser",
  "rendition",
  "deviceInfo",
  "player",
  "title",
  "title2",
  "live",
  "segmentDuration",
  "mediaDuration",
  "mediaResource",
  "parsedResource",
  "transactionCode",
  "properties",
  "cdn",
  "playerVersion",
  "param1",
  "param2",
  "param3",
  "param4",
  "param5",
  "param6",
  "param7",
  "param8",
  "param9",
  "param10",
  "param11",
  "param12",
  "param13",
  "param14",
  "param15",
  "param16",
  "param17",
  "param18",
  "param19",
  "param20",
  "dimensions",
  "playerStartupTime",
  "obfuscateIp",
  "privacyProtocol",
  "p2pEnabled",
  "pluginVersion",
  "pluginInfo",
  "isp",
  "connectionType",
  "ip",
  "referer",
  "userType",
  "streamingProtocol",
  "transportFormat",
  "householdId",
  "adsBlocked",
  "adsExpected",
  "deviceUUID",
  "smartswitchConfigCode",
  "smartswitchGroupCode",
  "smartswitchContractCode",
  "libVersion",
  "nodeHost",
  "nodeType",
  "appName",
  "appReleaseVersion",
  "package",
  "saga",
  "tvshow",
  "season",
  "titleEpisode",
  "channel",
  "imdbID",
  "gracenoteID",
  "contentType",
  "genre",
  "contentLanguage",
  "subtitles",
  "cost",
  "price",
  "playbackType",
  "email",
  "drm",
  "videoCodec",
  "audioCodec",
  "codecSettings",
  "codecProfile",
  "containerFormat",
  "contentId",
  "contractedResolution",
  "linkedViewId",
  "edid",
  "cdnBalancerResponseUUID",
  "triggeredEvents"
], yd = [
  "player",
  "playhead",
  "adTitle",
  "position",
  "adDuration",
  "adCampaign",
  "adCreativeId",
  "adProvider",
  "adResource",
  "adPlayerVersion",
  "adProperties",
  "adAdapterVersion",
  "adInsertionType",
  "extraparam1",
  "extraparam2",
  "extraparam3",
  "extraparam4",
  "extraparam5",
  "extraparam6",
  "extraparam7",
  "extraparam8",
  "extraparam9",
  "extraparam10",
  "fullscreen",
  "audio",
  "skippable",
  "adNumber",
  "adNumberInBreak",
  "breakNumber"
], pn = Kk.extend(
  /** @lends youbora.RequestBuilder.prototype */
  {
    /**
     * This class helps building params associated with each event: /start, /joinTime...
     *
     * @constructs RequestBuilder
     * @extends youbora.YouboraObject
     * @memberof youbora
     *
     * @param {Plugin} plugin A Plugin instance
     */
    constructor: function(t) {
      this._plugin = t, this._adNumber = 0, this._adNumberInBreak = 0, this.lastSent = {};
    },
    /**
     * Adds to params all the entities specified in paramList, unless they are already set.
     *
     * @param {Object} params Object of params key:value.
     * @param {Array.string} paramList A list of params to fetch.
     * @param {bool} onlyDifferent If true, only fetches params that have changed
     */
    fetchParams: function(t, e, r) {
      t = t || {}, e = e || [];
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        if (!t[i]) {
          var a = pn.getters[i];
          if (this._plugin[a]) {
            var s = this._plugin[a]();
            s !== null && (!r || this.lastSent[i] !== s) && (t[i] = s, this.lastSent[i] = s);
          } else
            Xk.warn("Trying to call undefined getter " + i + ":" + a);
        }
      }
      return t;
    },
    getGetters: function() {
      return pn.getters;
    },
    buildBody: function(t) {
      var e = null;
      return this.fetchParams(e, pn.bodyParams[t], !1);
    },
    /**
     * Adds to params object all the entities specified in paramList, unless they are already set.
     *
     * @param {Object} params Object of params key:value.
     * @param {string} service The name of the service. Use {@link Plugin.Service} enum.
     */
    buildParams: function(t, e) {
      return t = t || {}, this.fetchParams(t, pn.params[e], !1), this.fetchParams(t, pn.differentParams[e], !0), t;
    },
    /**
     * Creates an adnumber if it does not exist and stores it in lastSent. If it already exists,
     * it is incremented by 1.
     *
     * @returns {number} adNumber
     */
    getNewAdNumber: function() {
      var t = this.lastSent.adNumber;
      return t && this.lastSent.position === this._plugin.getAdPosition() ? t += 1 : t = 1, this.lastSent.adNumber = t, t;
    },
    /**
     * Creates an adnumberinbreak incrementing by 1.
     *
     * @returns {number} adNumber
     */
    getNewAdNumberInBreak: function() {
      return this._adNumberInBreak++, this.lastSent.adNumberInBreak = this._adNumberInBreak, this._adNumberInBreak;
    },
    /**
     * Creates an breaknumber if it does not exist and stores it in lastSent. If it already exists,
     * it is incremented by 1.
     * Also resets adnumberinbreak
     * @returns {number} breakNumber
     */
    getNewBreakNumber: function() {
      var t = 1;
      return this._adNumberInBreak = 0, this.lastSent.breakNumber && (t = this.lastSent.breakNumber + 1), this.lastSent.breakNumber = t, t;
    },
    /**
     * Return changed entities since last check
     *
     * @returns {Object} params
     */
    getChangedEntities: function() {
      return this.fetchParams({}, pn.differentParams.entities, !0);
    }
  },
  /** @lends youbora.RequestBuilder */
  {
    // Static Members
    /** List of params used by each service */
    params: {
      "/data": ["system", "pluginVersion", "requestNumber", "username"],
      "/init": vd,
      "/start": vd,
      "/joinTime": ["joinDuration", "playhead", "bitrate", "triggeredEvents"],
      "/pause": ["playhead", "triggeredEvents"],
      "/resume": ["pauseDuration", "playhead", "triggeredEvents"],
      "/seek": ["seekDuration", "playhead", "triggeredEvents"],
      "/bufferUnderrun": ["bufferDuration", "playhead", "triggeredEvents"],
      "/error": ["player", "playhead", "triggeredEvents"].concat(vd),
      "/stop": ["bitrate", "totalBytes", "playhead", "pauseDuration", "metrics", "cdnDownloadedTraffic", "multiCdnInfo", "p2pDownloadedTraffic", "uploadTraffic", "triggeredEvents"],
      "/infinity/video/event": [],
      "/adInit": yd,
      "/adStart": yd,
      "/adJoin": ["playhead", "position", "adJoinDuration", "adPlayhead", "adNumber", "adNumberInBreak", "breakNumber"],
      "/adPause": ["playhead", "position", "adPlayhead", "adNumber", "adNumberInBreak", "breakNumber"],
      "/adResume": ["playhead", "position", "adPlayhead", "adPauseDuration", "adNumber", "adNumberInBreak", "breakNumber"],
      "/adBufferUnderrun": ["playhead", "position", "adPlayhead", "adBufferDuration", "adNumber", "adNumberInBreak", "breakNumber"],
      "/adStop": ["playhead", "position", "adPlayhead", "adBitrate", "adTotalDuration", "pauseDuration", "adViewedDuration", "adViewability", "adNumber", "adNumberInBreak", "breakNumber"],
      "/adClick": ["playhead", "position", "adPlayhead", "adNumber", "adNumberInBreak", "breakNumber"],
      "/adError": ["playhead"].concat(yd),
      "/adManifest": ["givenBreaks", "expectedBreaks", "expectedPattern", "breaksTime"],
      "/adBreakStart": ["position", "givenAds", "expectedAds", "breakNumber", "adInsertionType"],
      "/adBreakStop": ["position", "breakNumber"],
      "/adQuartile": ["position", "adViewedDuration", "adViewability", "adNumber", "adNumberInBreak", "breakNumber"],
      "/ping": ["droppedFrames", "playrate", "cdnDownloadedTraffic", "multiCdnInfo", "p2pDownloadedTraffic", "uploadTraffic", "latency", "packetLoss", "packetSent", "metrics", "totalBytes", "segmentDuration"],
      "/infinity/session/start": [
        "accountCode",
        "username",
        "userType",
        "anonymousUser",
        "route",
        "page",
        "referer",
        "referral",
        "screenResolution",
        "language",
        "deviceInfo",
        "adsBlocked",
        "deviceUUID",
        "libVersion",
        "appName",
        "appReleaseVersion",
        "isp",
        "connectionType",
        "ip",
        "obfuscateIp",
        "privacyProtocol",
        "dimensions",
        "param1",
        "param2",
        "param3",
        "param4",
        "param5",
        "param6",
        "param7",
        "param8",
        "param9",
        "param10",
        "param11",
        "param12",
        "param13",
        "param14",
        "param15",
        "param16",
        "param17",
        "param18",
        "param19",
        "param20",
        "edid"
      ],
      "/infinity/session/stop": ["sessionMetrics"],
      "/infinity/session/nav": ["route", "page", "scrollDepth"],
      "/infinity/session/beat": ["sessionMetrics"],
      "/infinity/session/event": ["accountCode"],
      "/offlineEvents": {}
    },
    /** Values for request body */
    bodyParams: {
      "/offlineEvents": ["viewJson"]
    },
    /** List of params used by each service (only if they are different) */
    differentParams: {
      entities: [
        "rendition",
        "title",
        "title2",
        "param1",
        "param2",
        "param3",
        "param4",
        "param5",
        "param6",
        "param7",
        "param8",
        "param9",
        "param10",
        "param11",
        "param12",
        "param13",
        "param14",
        "param15",
        "param16",
        "param17",
        "param18",
        "param19",
        "param20",
        "cdn",
        "nodeHost",
        "nodeType",
        "nodeTypeString",
        "subtitles",
        "contentLanguage"
      ]
    },
    /** List of params and its related getter */
    getters: {
      requestNumber: "getRequestNumber",
      playhead: "getPlayhead",
      playrate: "getPlayrate",
      fps: "getFramesPerSecond",
      segmentDuration: "getSegmentDuration",
      droppedFrames: "getDroppedFrames",
      mediaDuration: "getDuration",
      bitrate: "getBitrate",
      totalBytes: "getTotalBytes",
      throughput: "getThroughput",
      rendition: "getRendition",
      title: "getTitle",
      title2: "getTitle2",
      live: "getIsLive",
      mediaResource: "getResource",
      parsedResource: "getParsedResource",
      transactionCode: "getTransactionCode",
      properties: "getMetadata",
      playerVersion: "getPlayerVersion",
      player: "getPlayerName",
      cdn: "getCdn",
      pluginVersion: "getPluginVersion",
      libVersion: "getLibVersion",
      userType: "getUserType",
      streamingProtocol: "getStreamingProtocol",
      transportFormat: "getTransportFormat",
      obfuscateIp: "getObfuscateIp",
      privacyProtocol: "getPrivacyProtocol",
      householdId: "getHouseholdId",
      latency: "getLatency",
      packetLoss: "getPacketLoss",
      packetSent: "getPacketSent",
      metrics: "getVideoMetrics",
      dimensions: "getCustomDimensions",
      param1: "getExtraparam1",
      param2: "getExtraparam2",
      param3: "getExtraparam3",
      param4: "getExtraparam4",
      param5: "getExtraparam5",
      param6: "getExtraparam6",
      param7: "getExtraparam7",
      param8: "getExtraparam8",
      param9: "getExtraparam9",
      param10: "getExtraparam10",
      param11: "getExtraparam11",
      param12: "getExtraparam12",
      param13: "getExtraparam13",
      param14: "getExtraparam14",
      param15: "getExtraparam15",
      param16: "getExtraparam16",
      param17: "getExtraparam17",
      param18: "getExtraparam18",
      param19: "getExtraparam19",
      param20: "getExtraparam20",
      extraparam1: "getAdExtraparam1",
      extraparam2: "getAdExtraparam2",
      extraparam3: "getAdExtraparam3",
      extraparam4: "getAdExtraparam4",
      extraparam5: "getAdExtraparam5",
      extraparam6: "getAdExtraparam6",
      extraparam7: "getAdExtraparam7",
      extraparam8: "getAdExtraparam8",
      extraparam9: "getAdExtraparam9",
      extraparam10: "getAdExtraparam10",
      position: "getAdPosition",
      adNumber: "getAdNumber",
      adNumberInBreak: "getAdNumberInBreak",
      breakNumber: "getBreakNumber",
      adPlayhead: "getAdPlayhead",
      adDuration: "getAdDuration",
      adCampaign: "getAdCampaign",
      adCreativeId: "getAdCreativeId",
      adBitrate: "getAdBitrate",
      adTitle: "getAdTitle",
      adResource: "getAdResource",
      adPlayerVersion: "getAdPlayerVersion",
      adProperties: "getAdMetadata",
      adAdapterVersion: "getAdAdapterVersion",
      givenBreaks: "getGivenBreaks",
      expectedBreaks: "getExpectedBreaks",
      expectedPattern: "getExpectedPattern",
      breaksTime: "getBreaksTime",
      givenAds: "getGivenAds",
      expectedAds: "getExpectedAds",
      adsExpected: "getAdsExpected",
      adViewedDuration: "getAdViewedDuration",
      adViewability: "getAdViewability",
      fullscreen: "getIsFullscreen",
      audio: "getAudioEnabled",
      skippable: "getIsSkippable",
      adProvider: "getAdProvider",
      adInsertionType: "getAdInsertionType",
      pluginInfo: "getPluginInfo",
      isp: "getIsp",
      connectionType: "getConnectionType",
      ip: "getIp",
      deviceInfo: "getDeviceInfo",
      edid: "getEDID",
      system: "getAccountCode",
      accountCode: "getAccountCode",
      username: "getUsername",
      anonymousUser: "getAnonymousUser",
      joinDuration: "getJoinDuration",
      bufferDuration: "getBufferDuration",
      seekDuration: "getSeekDuration",
      pauseDuration: "getPauseDuration",
      adJoinDuration: "getAdJoinDuration",
      adBufferDuration: "getAdBufferDuration",
      adPauseDuration: "getAdPauseDuration",
      adTotalDuration: "getAdTotalDuration",
      referer: "getReferer",
      referral: "getReferral",
      language: "getLanguage",
      screenResolution: "getScreenResolution",
      nodeHost: "getNodeHost",
      nodeType: "getNodeType",
      nodeTypeString: "getNodeTypeString",
      route: "getReferer",
      page: "getPageName",
      playerStartupTime: "getPlayerStartupTime",
      pageLoadTime: "getPageLoadTime",
      cdnDownloadedTraffic: "getCdnTraffic",
      multiCdnInfo: "getMultiCdnInfo",
      p2pDownloadedTraffic: "getP2PTraffic",
      p2pEnabled: "getIsP2PEnabled",
      uploadTraffic: "getUploadTraffic",
      cdnBalancerResponseUUID: "getBalancerResponseId",
      viewJson: "getOfflineView",
      deviceUUID: "getDeviceUUID",
      sessionMetrics: "getSessionMetrics",
      scrollDepth: "getScrollDepth",
      adsBlocked: "getIsBlocked",
      linkedViewId: "getLinkedViewId",
      smartswitchConfigCode: "getSmartswitchConfigCode",
      smartswitchGroupCode: "getSmartswitchGroupCode",
      smartswitchContractCode: "getSmartswitchContractCode",
      appName: "getAppName",
      appReleaseVersion: "getAppReleaseVersion",
      package: "getPackage",
      saga: "getSaga",
      tvshow: "getTvShow",
      season: "getSeason",
      titleEpisode: "getEpisodeTitle",
      channel: "getChannel",
      drm: "getDRM",
      videoCodec: "getVideoCodec",
      audioCodec: "getAudioCodec",
      codecSettings: "getCodecSettings",
      codecProfile: "getCodecProfile",
      containerFormat: "getContainerFormat",
      contentId: "getID",
      imdbID: "getImdbId",
      gracenoteID: "getGracenoteID",
      contentType: "getType",
      genre: "getGenre",
      contentLanguage: "getVideoLanguage",
      subtitles: "getSubtitles",
      contractedResolution: "getContractedResolution",
      cost: "getCost",
      price: "getPrice",
      playbackType: "getPlaybackType",
      email: "getEmail"
    }
  }
), L_ = pn, Yk = Jr, Qk = Yk.extend(
  /** @lends youbora.WrongTransform.prototype */
  {
    /**
    * Returns if transform is blocking.
    *
    * @param {YBRequest} request Request to transform.
    * @return {bool} True if queue shall be blocked.
    */
    isBlocking: function(t) {
      return !t.params.sessionId;
    }
  }
), Jk = Qk, Zk = Br, $g = gf, zg = Jk, eL = li, na = Zk.extend(
  /** @lends youbora.Infinity.prototype */
  {
    /**
     * This class is the base of youbora infinity. Every plugin will have an instance.
     *
     * @param {youbora.Plugin} plugin Parent plugin.
     *
     * @constructs youbora.Infinity
     * @extends youbora.Emitter
     * @memberof youbora
     */
    constructor: function(t) {
      this._plugin = t, this.infinityStopped = !1, this.infinityStarted = !1;
    },
    /**
     * @alias youbora.Infinity.prototype.begin.
     */
    andBeyond: function() {
      na.prototype.begin.apply(this, arguments);
    },
    /**
     * This method will start infinity logic, setting storage as needed.
     * Will call fireSessionStart the first time and fireNav for every subsequent route change.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {boolean} [forceNewSession] boolean to force open a new session.
     */
    begin: function(t, e) {
      e = e || !1, e && (this._plugin.storage.removeStorages("infinityStarted"), this._plugin.storage.removeStorages("data"), this._plugin.restartViewTransform()), this._comm = new $g(this._plugin), this._comm.addTransform(this._plugin.viewTransform), this._comm.addTransform(new zg(this._plugin)), this._plugin && this._plugin.storage && typeof this._plugin.storage.getLocal == "function" && (this._registeredProperties = this._plugin.storage.getLocal("inifnityRegisteredProperties")), this.fireSessionStart(t);
    },
    _setLastActive: function() {
      this._firstActive || (this._firstActive = this.getFirstActive()), this._plugin.storage.setStorages("lastactive", (/* @__PURE__ */ new Date()).getTime());
    },
    getFirstActive: function() {
      return Number(this._plugin.getLastActive()) || 0;
    },
    /**
     * Returns the current {@link youbora.Communication} instance.
     *
     * @returns {youbora.Communication} communication instance
     */
    getComm: function() {
      return this._comm;
    },
    // Fire
    /**
     * Emits session start request.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */
    fireSessionStart: function(t) {
      this.infinityStopped && (this._plugin.restartViewTransform(), this._comm = new $g(this._plugin), this._comm.addTransform(this._plugin.viewTransform), this._comm.addTransform(new zg(this._plugin)), this.infinityStopped = !1), this.infinityStarted || (this._plugin.storage.setLocal("infinityStarted", "true"), this.infinityStarted = !0, this.emit(na.Event.SESSION_START, this._getParamsJson(t, null, null, !0, !0)), this._setLastActive());
    },
    /**
     * Emits session start request.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */
    fireSessionStop: function(t) {
      this.infinityStarted && (this.infinityStopped = !0, this.infinityStarted = !1, this._plugin.storage.removeStorages("infinityStarted"), this.emit(na.Event.SESSION_STOP, t), this._plugin.storage.removeStorages("data"), this._plugin.storage.removeStorages("session"), this._plugin.storage.removeStorages("lastactive"));
    },
    /**
     * Stops the session and creates a new one
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */
    newSession: function(t, e) {
      this.isActive() && (this.infinityStarted ? this.fireSessionStop() : (this._plugin.storage.removeStorages("infinityStarted"), this._plugin.storage.removeStorages("data"), this._comm && this._comm.removeTransform(this._plugin.viewTransform), this._plugin.restartViewTransform(), this._comm && this._comm.addTransform(this._plugin.viewTransform))), this._plugin.setOptions(t), this.begin(e);
    },
    /**
     * Emits session start request.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */
    fireNav: function(t) {
      this.isActive() && (this.infinityStarted = !0, this.emit(na.Event.NAV, this._getParamsJson(t, null, null, !0)));
    },
    _sendExtraBeat: function() {
      if (this._plugin && this._plugin._beat) {
        var t = (/* @__PURE__ */ new Date()).getTime(), e = this._plugin._beat.chrono.startTime ? t - this._plugin._beat.chrono.startTime : 0;
        this._plugin._sendBeat(e), this._plugin._beat.chrono.startTime = t;
      }
      this._setLastActive();
    },
    /**
     * Emits session start request.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */
    fireEvent: function(t, e, r, n) {
      if (this.infinityStarted) {
        var i = this._getParamsJson(e, r, t);
        eL.assign(i.params, n || {}), this.emit(na.Event.EVENT, i), this._setLastActive();
      }
    },
    /** Register properties sent by the User, to send in all the events
    *
    * @memberof youbora.Infinity.prototype
    */
    register: function(t, e) {
      this._registeredProperties = { dimensions: t, values: e }, this._plugin.storage.setLocal("inifnityRegisteredProperties", JSON.stringify(this._registeredProperties));
    },
    /** Calls register if registeredProperties is empty
    *
    * @memberof youbora.Infinity.prototype
    */
    registerOnce: function(t, e) {
      this._registeredProperties || this.register(t, e);
    },
    /** Unregister properties registered with register()
    *
    * @memberof youbora.Infinity.prototype
    */
    unregister: function() {
      this._registeredProperties = null, this._plugin.storage.removeLocal("inifnityRegisteredProperties");
    },
    /**
     * Splits params in dimensions (strings) and values (numbers)
     *
     * @param {Object} [params] Object of key:value params to split before adding to request.
     */
    _getParamsJson: function(t, e, r, n, i) {
      var a = {};
      if (r && (a.name = r), a.dimensions = t || {}, a.values = e || {}, this._registeredProperties) {
        for (var s in this._registeredProperties.dimensions)
          a.dimensions[s] = this._registeredProperties.dimensions[s];
        for (var o in this._registeredProperties.values)
          a.values[o] = this._registeredProperties.values[o];
      }
      var u = { params: a };
      return n && (u.params.dimensions.page && (u.params.page = u.params.dimensions.page, delete u.params.dimensions.page), u.params.dimensions.route && (u.params.route = u.params.dimensions.route, delete u.params.dimensions.route), i || delete u.params.dimensions, delete u.params.values), u;
    },
    isActive: function() {
      var t = this._plugin.storage.getLocal("infinityStarted");
      if (this.infinityStarted || t && t !== "false")
        return !0;
      var e = (/* @__PURE__ */ new Date()).getTime();
      return Number(this._plugin.getLastActive()) + this._plugin.sessionExpire > e;
    }
  },
  /** @lends youbora.Plugin */
  {
    // Static Memebers //
    /**
     * List of events that could be fired
     * @enum
     * @event
     */
    Event: {
      NAV: "nav",
      SESSION_START: "sessionStart",
      SESSION_STOP: "sessionStop",
      BEAT: "beat",
      EVENT: "event"
    }
  }
), vf = na, I_ = function(t) {
  t = t || window;
  var e = t.document, r = function(_) {
    var y = !1;
    if (_.getBoundingClientRect) {
      var E = _.getBoundingClientRect();
      y = {
        top: Math.max(E.top, 0),
        left: Math.max(E.left, 0),
        bottom: Math.min(E.bottom, t.innerHeight || e.documentElement.clientHeight),
        right: Math.min(E.right, t.innerWidth || e.documentElement.clientWidth)
      }, y.bottom <= y.top || y.right <= y.left ? y = !1 : y.area = (y.bottom - y.top) * (y.right - y.left);
    }
    return y;
  }, n = function(_, y) {
    if (y) {
      var E = r(_);
      E && l.push({
        url: y,
        area: E.area,
        rect: E
      });
    }
  }, i = function() {
    for (var _ = e.getElementsByTagName("*"), y = /url\(.*(http.*)\)/ig, E = 0; E < _.length; E++) {
      var R = _[E], D = t.getComputedStyle(R);
      if (R.tagName === "IMG" && n(R, R.src), D["background-image"]) {
        y.lastIndex = 0;
        var C = y.exec(D["background-image"]);
        C && C.length > 1 && n(R, C[1].replace('"', ""));
      }
      if (R.tagName === "IFRAME")
        try {
          var w = r(R);
          if (w) {
            var k = I_(R.contentWindow);
            k && l.push({
              tm: k,
              area: w.area,
              rect: w
            });
          }
        } catch {
        }
    }
  }, a = function() {
    for (var _ = {}, y = t.performance.getEntriesByType("resource"), E = 0; E < y.length; E++)
      _[y[E].name] = y[E].responseEnd;
    for (var R = 0; R < l.length; R++)
      "tm" in l[R] || (l[R].tm = _[l[R].url] !== void 0 ? _[l[R].url] : 0);
  }, s = function() {
    "msFirstPaint" in t.performance.timing && (h = t.performance.timing.msFirstPaint - b);
    for (var _ = t.performance.getEntriesByType("paint"), y = 0; y < _.length; y++)
      _[y].name === "first-paint" && (h = _[y].startTime);
    if (h === void 0 || h < 0 || h > 12e4) {
      h = t.performance.timing.responseStart - b;
      for (var E = {}, R = e.getElementsByTagName("head")[0].children, D = 0; D < R.length; D++) {
        var C = R[D];
        C.tagName === "SCRIPT" && C.src && !C.async && (E[C.src] = !0), C.tagName === "LINK" && C.rel === "stylesheet" && C.href && (E[C.href] = !0);
      }
      for (var w = t.performance.getEntriesByType("resource"), k = !1, I = 0; I < w.length; I++)
        if (!k && E[w[I].name] && (w[I].initiatorType === "script" || w[I].initiatorType === "link")) {
          var U = w[I].responseEnd;
          (h === void 0 || U > h) && (h = U);
        } else
          k = !0;
    }
    h = Math.max(h, 0);
  }, o = function() {
    for (var _ = { 0: 0 }, y = 0, E = 0; E < l.length; E++) {
      var R = h;
      "tm" in l[E] && l[E].tm > h && (R = l[E].tm), _[R] === void 0 && (_[R] = 0), _[R] += l[E].area, y += l[E].area;
    }
    var D = Math.max(e.documentElement.clientWidth, t.innerWidth || 0) * Math.max(e.documentElement.clientHeight, t.innerHeight || 0);
    if (D > 0 && (D = Math.max(D - y, 0) * v, _[h] === void 0 && (_[h] = 0), _[h] += D, y += D), y) {
      for (var C in _)
        _.hasOwnProperty(C) && d.push({ tm: C, area: _[C] });
      d.sort(function(I, U) {
        return I.tm - U.tm;
      });
      for (var w = 0, k = 0; k < d.length; k++)
        w += d[k].area, d[k].progress = w / y;
    }
  }, u = function() {
    if (d.length) {
      f = 0;
      for (var _ = 0, y = 0, E = 0; E < d.length; E++) {
        var R = d[E].tm - _;
        R > 0 && y < 1 && (f += (1 - y) * R), _ = d[E].tm, y = d[E].progress;
      }
    } else
      f = h;
  }, l = [], d = [], h, f, v = 0.1;
  try {
    var b = t.performance.timing.navigationStart;
    i(), a(), s(), o(), u();
  } catch {
  }
  return f;
}, tL = I_, iL = wt, rL = tL, nL = iL.extend({
  constructor: function(t) {
    if (this.infinity = t.infinity, this.timeObject = null, this.playerSetup = null, this.perfObject = null, this.myTimesObject = {}, typeof window < "u" && typeof window.addEventListener == "function" && (window.addEventListener("load", this._windowLoaded.bind(this)), window.performance && window.performance.timing)) {
      try {
        typeof window.performance.getEntriesByType == "function" && (this.perfObject = window.performance);
      } catch {
      }
      this.timeObject = window.performance.timing;
    }
    try {
      if (typeof PerformanceObserver == "function") {
        var e = new PerformanceObserver(function(r, n) {
          var i = r.getEntries();
          this.myTimesObject.largestContentfulPaint = i[i.length - 1].renderTime;
        }.bind(this));
        PerformanceObserver.supportedEntryTypes.indexOf("largest-contentful-paint") > -1 && e.observe({ entryTypes: ["largest-contentful-paint"] });
      }
    } catch {
    }
  },
  _windowLoaded: function() {
    this.myTimesObject.onLoad = (/* @__PURE__ */ new Date()).getTime(), this._getEnoughFPS(), setTimeout(this._fireLoadTimesEvent.bind(this), 1e3);
  },
  _fireLoadTimesEvent: function() {
    this._getLastMetrics(), this.infinity.fireEvent("loadTimes", {}, this._getAllValues());
  },
  _getAllValues: function() {
    var t = {
      // Time between the navigation starts and the page loadEventEnd
      PageLoadTime: this.getPageLoadTime(),
      // Domain lookup time
      DNSTime: this.getDnsTime(),
      // Connection time
      TCPTime: this.getTcpTime(),
      // Handshake (https) connection time
      HandshakeTime: this.getHandshakeTime(),
      // Time between navigation starts and DOM is ready
      DomReadyTime: this.getDomReadyTime(),
      // Time between navigation start and beginning of the backend response
      BackendTime: this.getBackendTime(),
      // Time between navigation starts and page load event
      FrontendTime: this.getFrontendTime(),
      // The maximum of First Paint / First Contentful Paint and domContentLoadedEventEnd
      VisualReady: this.getTimeToVisuallyReady(),
      // https://developer.mozilla.org/en-US/docs/Glossary/Time_to_interactive
      TimeToInteractive: this.getTimeToInteractive(),
      // Accumulated time to download all the JS files
      JsTime: this.getJSTime(),
      // Accumulated time to download all the CSS files
      CssTime: this.getCSSTime(),
      // Accumulated time to download all the images
      ImageTime: this.getImageTime(),
      // Accumulated time to download all the fonts
      FontTime: this.getFontTime(),
      // Average latency of all the file requests
      AvgReqLatency: this.getAvgReqLatency(),
      // Highest latency of all the file requests
      MaxReqLatency: this.getMaxReqLatency(),
      // https://developer.mozilla.org/en-US/docs/Glossary/First_paint
      FirstPaint: this.getFirstPaint(),
      // https://developer.mozilla.org/en-US/docs/Glossary/First_contentful_paint
      FirstContentfulPaint: this.getFirstContentfulPaint(),
      // https://rockcontent.com/blog/largest-contentful-paint/
      LargestContentfulPaint: this.getLargestContentfulPaint(),
      // https://developer.mozilla.org/en-US/docs/Glossary/Speed_index
      SpeedIndex: this.getSpeedIndex()
    };
    for (var e in t)
      t[e] === null || t[e] === void 0 || t[e] < 0 ? delete t[e] : t[e] = Math.round(t[e]);
    return t;
  },
  // Getters
  getPageLoadTime: function() {
    var t = null;
    return this.timeObject && (t = this.timeObject.loadEventEnd - this.timeObject.navigationStart), t;
  },
  getPlayerStartupTime: function() {
    var t = null;
    return this.timeObject && this.playerSetup && (t = this.playerSetup - this.timeObject.navigationStart), t;
  },
  getDnsTime: function() {
    var t = null;
    return this.timeObject && (t = this.timeObject.domainLookupEnd - this.timeObject.domainLookupStart), t;
  },
  getTcpTime: function() {
    var t = null;
    return this.timeObject && (t = this.timeObject.connectEnd - this.timeObject.connectStart), t;
  },
  getHandshakeTime: function() {
    var t = null;
    return this.timeObject && this.timeObject.secureConnectionStart && (t = this.timeObject.connectEnd - this.timeObject.secureConnectionStart), t;
  },
  getDomReadyTime: function() {
    var t = null;
    return this.timeObject && (t = this.timeObject.domComplete - this.timeObject.navigationStart), t;
  },
  getBackendTime: function() {
    var t = null;
    return this.timeObject && (t = this.timeObject.responseStart - this.timeObject.navigationStart), t;
  },
  getFrontendTime: function() {
    var t = null;
    return this.timeObject && (t = this.myTimesObject.onLoad - this.timeObject.responseStart), t;
  },
  getTimeToVisuallyReady: function() {
    var t = this.myTimesObject.firstPaint || 0;
    return this.timeObject ? Math.max(
      t,
      this.timeObject.domContentLoadedEventEnd - this.timeObject.navigationStart || 0
      // this.myTimesObject.heroImages - this.timeObject.navigationStart || 0
    ) : t || null;
  },
  getTimeToInteractive: function() {
    if (this.myTimesObject.fps && this.getTimeToVisuallyReady())
      return Math.max(this.myTimesObject.fps, this.getTimeToVisuallyReady());
    setTimeout(function() {
      this.getTimeToInteractive();
    }.bind(this), 500);
  },
  getJSTime: function() {
    return this._getXTime("script");
  },
  getCSSTime: function() {
    return this._getXTime("css");
  },
  getImageTime: function() {
    return this._getXTime("img");
  },
  getFontTime: function() {
    return this._getXTime("css", [".woff", ".otf", ".ttf"]);
  },
  getAvgReqLatency: function() {
    try {
      if (this.perfObject && typeof this.perfObject.getEntriesByType == "function") {
        var t = 0, e = 0, r = this.perfObject.getEntriesByType("resource");
        for (var n in r)
          r[n].requestStart && r[n].responseStart && (e += r[n].responseStart - r[n].requestStart), t++;
        return e / t;
      }
    } catch {
    }
    return null;
  },
  getFirstPaint: function() {
    return this.myTimesObject ? this.myTimesObject.firstPaint : null;
  },
  getFirstContentfulPaint: function() {
    return this.myTimesObject ? this.myTimesObject.firstContentfulPaint : null;
  },
  getLargestContentfulPaint: function() {
    return this.myTimesObject ? this.myTimesObject.largestContentfulPaint : null;
  },
  getMaxReqLatency: function() {
    try {
      if (this.perfObject && typeof this.perfObject.getEntriesByType == "function") {
        var t = this.perfObject.getEntriesByType("resource"), e = 0;
        for (var r in t)
          t[r].requestStart && t[r].responseStart && (e = Math.max(e, t[r].responseStart - t[r].requestStart));
        return e;
      }
    } catch {
    }
    return null;
  },
  getSpeedIndex: function() {
    var t = null;
    if (typeof window < "u" && window.performance && typeof window.performance.getEntriesByType == "function")
      try {
        t = rL();
      } catch {
      }
    return t;
  },
  _getXTime: function(t, e) {
    var r = 0;
    try {
      if (this.perfObject && typeof this.perfObject.getEntriesByType == "function") {
        var n = this.perfObject.getEntriesByType("resource");
        for (var i in n)
          if (n[i].initiatorType === t)
            if (!e)
              r += n[i].duration;
            else {
              var a = !1;
              for (var s in e)
                n[i].name.indexOf(e[s] > 0) && (a = !0);
              a && (r += n[i].duration);
            }
      }
    } catch {
    }
    return Math.round(r) || null;
  },
  _getLastMetrics: function() {
    var t = null, e = null;
    try {
      if (this.perfObject && typeof this.perfObject.getEntriesByType == "function") {
        var r = this.perfObject.getEntriesByType("paint");
        for (var n in r)
          r[n].name === "first-paint" ? t = r[n].startTime : r[n].name === "first-contentful-paint" && (e = r[n].startTime);
      }
    } catch {
    }
    !t && this.timeObject && (t = this.timeObject.msFirstPaint - this.timeObject.navigationStart), this.myTimesObject.firstPaint = t, this.myTimesObject.firstContentfulPaint = e, this.getTimeToInteractive();
  },
  _getEnoughFPS: function() {
    if (this.timeObject && typeof window < "u") {
      var t = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function() {
      };
      this.preFPS = (/* @__PURE__ */ new Date()).getTime(), t(function() {
        var e = (/* @__PURE__ */ new Date()).getTime();
        e < this.preFPS + 50 ? this.myTimesObject.fps = e - this.timeObject.navigationStart : setTimeout(function() {
          return this._getEnoughFPS();
        }.bind(this), 50);
      }.bind(this));
    } else
      return !0;
  },
  // Setters
  setPlayerSetupTime: function() {
    this.playerSetup = this.playerSetup || (/* @__PURE__ */ new Date()).getTime();
  }
}), aL = nL, sL = wt, oL = sL.extend({
  constructor: function(t) {
    this.plugin = t, this.isInBackground = !1, this.listenerReference = this._visibilityListener.bind(this), this._reset();
  },
  startDetection: function() {
    !this.isBackgroundDetectorStarted && typeof document < "u" && (this.isBackgroundDetectorStarted = !0, document.addEventListener("visibilitychange", this.listenerReference));
  },
  stopDetection: function() {
    this.isBackgroundDetectorStarted && typeof document < "u" && (document.removeEventListener("visibilitychange", this.listenerReference), this._reset());
  },
  _reset: function() {
    this.isBackgroundDetectorStarted = !1;
  },
  _visibilityListener: function(t) {
    if (typeof document < "u") {
      var e = this._getSettings();
      document.visibilityState === "hidden" ? this._toBackground(e) : document.visibilityState === "visible" && this._toForeground(e);
    }
  },
  _toBackground: function(t) {
    if (this.isInBackground = !0, this.plugin && this.plugin._adsAdapter && this.plugin._adsAdapter.stopChronoView(), typeof t == "string") {
      switch (t) {
        case "stop":
          this._fireStop();
          break;
        case "pause":
          this._firePause();
          break;
      }
      if (this.plugin.infinity.infinityStarted) {
        this.lastBeatTime = (/* @__PURE__ */ new Date()).getTime();
        var e = this.plugin._beat.chrono.startTime ? this.lastBeatTime - this.plugin._beat.chrono.startTime : 0;
        this.plugin._sendBeat(e), this.plugin._beat.stop();
      }
    }
  },
  _toForeground: function(t) {
    if (this.isInBackground = !1, this.plugin && this.plugin._adsAdapter && this.plugin._adsAdapter.startChronoView(), typeof t == "string" && t && this.plugin.infinity.infinityStarted) {
      var e = (/* @__PURE__ */ new Date()).getTime();
      e - this.lastBeatTime < this.plugin.sessionExpire ? (this.plugin._sendBeat(e - this.lastBeatTime), this.plugin._beat.start()) : this.plugin.infinity.newSession();
    }
  },
  _getSettings: function() {
    if (typeof this.plugin.options["background.settings"] == "string" && this.plugin.options["background.settings"])
      return this.plugin.options["background.settings"];
    if (this.plugin.deviceDetector.isSmartTV())
      return this.plugin.options["background.settings.tv"];
    if (this.plugin.deviceDetector.isDesktop())
      return this.plugin.options["background.settings.desktop"];
    if (this.plugin.deviceDetector.isAndroid())
      return this.plugin.options["background.settings.android"];
    if (this.plugin.deviceDetector.isIphone())
      return this.plugin.options["background.settings.iOS"];
    if (this.plugin.deviceDetector.isPlayStation())
      return this.plugin.options["background.settings.playstation"];
  },
  _firePause: function() {
    this._fireX("firePause");
  },
  _fireStop: function() {
    this._fireX("fireStop"), this.plugin.fireStop();
  },
  _fireX: function(t) {
    this.adsAdapter = this.plugin.getAdsAdapter(), this.adsAdapter && this.adsAdapter[t](), this.contentAdapter = this.plugin.getAdapter(), this.contentAdapter && this.contentAdapter[t]();
  },
  canBlockStartCalls: function() {
    return this.isInBackground && this.plugin.options["background.enabled"] === !0 && this._getSettings();
  }
}), D_ = oL, uL = wt, lL = uL.extend({
  constructor: function() {
    typeof navigator < "u" && navigator.userAgent && (this._isSmartTVDevice = navigator.userAgent.toLowerCase().match(/smarttv/) || navigator.userAgent.toLowerCase().match(/smart-tv/) || navigator.userAgent.toLowerCase().match(/appletv/) || navigator.userAgent.toLowerCase().match(/apple tv/), this._isPlaystationDevice = navigator.userAgent.match(/PlayStation/) !== null, this._isIphoneDevice = navigator.userAgent.match(/iPhone|iPad|iPod/i) !== null, this._isAndroidDevice = navigator.userAgent.match(/Android/) !== null, this._isSmartphoneDevice = !this._isSmartTVDevice && !this._isPlaystationDevice && (this._isIphoneDevice || this._isAndroidDevice), this._isDesktopDevice = !this._isSmartphoneDevice && !this._isSmartTVDevice && !this._isPlaystationDevice);
  },
  isIphone: function() {
    return this._isIphoneDevice;
  },
  isAndroid: function() {
    return this._isAndroidDevice;
  },
  isSmartphone: function() {
    return this._isSmartphoneDevice;
  },
  isDesktop: function() {
    return this._isDesktopDevice;
  },
  isSmartTV: function() {
    return this._isSmartTVDevice;
  },
  isPlayStation: function() {
    return this._isPlaystationDevice;
  }
}), R_ = lL, dL = wt, cL = dL.extend({
  constructor: function(t) {
    this.pluginref = t, this.listenerReference = this._changeListener.bind(this), this.loadReference = this._loadListener.bind(this), this.isEnabled = !1, this.pageHeight = 0, this.maxHeight = 0, this.startDetection();
  },
  startDetection: function() {
    !this.isEnabled && typeof window < "u" && typeof window.addEventListener == "function" && (window.addEventListener("scroll", this.listenerReference), window.addEventListener("resize", this.listenerReference), window.addEventListener("load", this.loadReference), this.isEnabled = !0);
  },
  stopDetection: function() {
    this.isEnabled && typeof window < "u" && typeof window.removeEventListener == "function" && (window.removeEventListener("scroll", this.listenerReference), window.removeEventListener("resize", this.listenerReference), window.removeEventListener("load", this.loadReference), this.isEnabled = !1);
  },
  getScrollDepth: function() {
    var t = null;
    return this.maxHeight && this.pageHeight && (t = Math.min(Math.trunc(this.maxHeight / this.pageHeight * 100), 100)), t;
  },
  _loadListener: function() {
    if (typeof document < "u") {
      var t = document.documentElement;
      t && (this.pageHeight = Math.round(t.scrollHeight, t.clientHeight, t.offsetHeight), this.maxHeight = window.innerHeight, this._updateCompletionRate());
    }
  },
  _changeListener: function() {
    if (this.pageHeight) {
      var t = this.maxHeight;
      this.maxHeight = Math.max(this.maxHeight, window.pageYOffset + window.innerHeight), t !== this.maxHeight && this._updateCompletionRate();
    }
    var e = this.pluginref.getAdsAdapter();
    e && e.flags.isStarted && (e.getIsVisible() ? e.startChronoView() : e.stopChronoView());
  },
  _updateCompletionRate: function() {
    setTimeout(function() {
      this.pluginref.storage.setSession("pageScrollDepth", this.getScrollDepth());
    }.bind(this), 3e3);
  }
}), hL = cL, fL = wt, pL = fL.extend({
  constructor: function(t) {
    this.plugin = t;
  },
  getAllData: function() {
    var t = this.getNonRandomData();
    return t.timestamp = this.getTimestamp(), t;
  },
  getNonRandomData: function() {
    var t = {};
    return t.userAgent = this.getUserAgent(), t.threads = this.getVirtualCores(), t.language = this.getLanguage(), t.langList = this.getAvailableLanguages(), t.resolution = this.getResolution(), t.colorDepth = this.getColorDepth(), t.deviceMemory = this.getMemory(), t.touchscreen = this.getTouchscreen(), t.localStorage = this.getLocalStorage(), t.sessionStorage = this.getSessionStorage(), t.cookiesAvailable = this.getCookiesAvailable(), t.flashAvailable = this.getHasFlash(), t.timeZone = this.getTimeZone(), t.plugins = this.getPluginList(), t;
  },
  // Getters
  getUserAgent: function() {
    return this._getNavigatorValue("userAgent");
  },
  getVirtualCores: function() {
    return this._getNavigatorValue("hardwareConcurrency");
  },
  getLanguage: function() {
    return this._getNavigatorValue("language");
  },
  getAvailableLanguages: function() {
    return this._getNavigatorValue("languages");
  },
  getResolution: function() {
    var t = null;
    try {
      this._getNavigatorValue("screen") && (t = navigator.screen.width.toString() + navigator.screen.height.toString());
    } catch {
    }
    return t;
  },
  getColorDepth: function() {
    var t = null;
    try {
      this._getNavigatorValue("screen") && (t = navigator.screen.colorDepth);
    } catch {
    }
    return t;
  },
  getMemory: function() {
    return this._getNavigatorValue("deviceMemory");
  },
  getTouchscreen: function() {
    return this._getNavigatorValue("maxTouchPoints") || !1;
  },
  getLocalStorage: function() {
    var t = !1;
    try {
      t = typeof localStorage < "u";
    } catch {
    }
    return t;
  },
  getSessionStorage: function() {
    var t = !1;
    try {
      t = typeof sessionStorage < "u";
    } catch {
    }
    return t;
  },
  getCookiesAvailable: function() {
    return this._getNavigatorValue("cookieEnabled") || !1;
  },
  getHasFlash: function() {
    var t = !1;
    try {
      var e = this._getNavigatorValue("plugins");
      t = e && typeof e["Shockwave Flash"] == "object" || typeof window < "u" && window.ActiveXObject && new ActiveXObject("ShockwaveFlash.ShockwaveFlash") !== !1;
    } catch {
    }
    return t;
  },
  getPluginList: function() {
    var t = null;
    try {
      var e = this._getNavigatorValue("plugins");
      if (e && e.length !== 0) {
        for (var r = "", n = 0; n < navigator.plugins.length; n++)
          r += navigator.plugins[n].description + " " + navigator.plugins[n].filename + " " + navigator.plugins[n].name + " ";
        t = r;
      }
    } catch {
    }
    return t;
  },
  getTimeZone: function() {
    var t = null;
    try {
      var e = /* @__PURE__ */ new Date();
      t = e.getTimezoneOffset().toString();
    } catch {
    }
    return t;
  },
  getTimestamp: function() {
    return (/* @__PURE__ */ new Date()).getTime();
  },
  _navigatorCheck: function() {
    return typeof navigator < "u";
  },
  _getNavigatorValue: function(t) {
    var e = null;
    try {
      this._navigatorCheck() && (e = navigator[t]);
    } catch {
    }
    return e;
  }
}), gL = pL, mL = function(t) {
  function e(ge, fe) {
    return ge << fe | ge >>> 32 - fe;
  }
  function r(ge, fe) {
    var me, xe, Ue, Xe, Ke;
    return Ue = ge & 2147483648, Xe = fe & 2147483648, me = ge & 1073741824, xe = fe & 1073741824, Ke = (ge & 1073741823) + (fe & 1073741823), me & xe ? Ke ^ 2147483648 ^ Ue ^ Xe : me | xe ? Ke & 1073741824 ? Ke ^ 3221225472 ^ Ue ^ Xe : Ke ^ 1073741824 ^ Ue ^ Xe : Ke ^ Ue ^ Xe;
  }
  function n(ge, fe, me) {
    return ge & fe | ~ge & me;
  }
  function i(ge, fe, me) {
    return ge & me | fe & ~me;
  }
  function a(ge, fe, me) {
    return ge ^ fe ^ me;
  }
  function s(ge, fe, me) {
    return fe ^ (ge | ~me);
  }
  function o(ge, fe, me, xe, Ue, Xe, Ke) {
    return ge = r(ge, r(r(n(fe, me, xe), Ue), Ke)), r(e(ge, Xe), fe);
  }
  function u(ge, fe, me, xe, Ue, Xe, Ke) {
    return ge = r(ge, r(r(i(fe, me, xe), Ue), Ke)), r(e(ge, Xe), fe);
  }
  function l(ge, fe, me, xe, Ue, Xe, Ke) {
    return ge = r(ge, r(r(a(fe, me, xe), Ue), Ke)), r(e(ge, Xe), fe);
  }
  function d(ge, fe, me, xe, Ue, Xe, Ke) {
    return ge = r(ge, r(r(s(fe, me, xe), Ue), Ke)), r(e(ge, Xe), fe);
  }
  function h(ge) {
    for (var fe, me = ge.length, xe = me + 8, Ue = (xe - xe % 64) / 64, Xe = (Ue + 1) * 16, Ke = Array(Xe - 1), ke = 0, Ce = 0; Ce < me; )
      fe = (Ce - Ce % 4) / 4, ke = Ce % 4 * 8, Ke[fe] = Ke[fe] | ge.charCodeAt(Ce) << ke, Ce++;
    return fe = (Ce - Ce % 4) / 4, ke = Ce % 4 * 8, Ke[fe] = Ke[fe] | 128 << ke, Ke[Xe - 2] = me << 3, Ke[Xe - 1] = me >>> 29, Ke;
  }
  function f(ge) {
    var fe = "", me = "", xe, Ue;
    for (Ue = 0; Ue <= 3; Ue++)
      xe = ge >>> Ue * 8 & 255, me = "0" + xe.toString(16), fe = fe + me.substr(me.length - 2, 2);
    return fe;
  }
  function v(ge) {
    ge = ge.replace(/rn/g, "n");
    for (var fe = "", me = 0; me < ge.length; me++) {
      var xe = ge.charCodeAt(me);
      xe < 128 ? fe += String.fromCharCode(xe) : xe > 127 && xe < 2048 ? (fe += String.fromCharCode(xe >> 6 | 192), fe += String.fromCharCode(xe & 63 | 128)) : (fe += String.fromCharCode(xe >> 12 | 224), fe += String.fromCharCode(xe >> 6 & 63 | 128), fe += String.fromCharCode(xe & 63 | 128));
    }
    return fe;
  }
  var b = Array(), _, y, E, R, D, C, w, k, I, U = 7, $ = 12, W = 17, G = 22, Y = 5, re = 9, j = 14, J = 20, z = 4, Q = 11, te = 16, ae = 23, ne = 6, Se = 10, Te = 15, We = 21;
  for (t = v(t), b = h(t), C = 1732584193, w = 4023233417, k = 2562383102, I = 271733878, _ = 0; _ < b.length; _ += 16)
    y = C, E = w, R = k, D = I, C = o(C, w, k, I, b[_ + 0], U, 3614090360), I = o(I, C, w, k, b[_ + 1], $, 3905402710), k = o(k, I, C, w, b[_ + 2], W, 606105819), w = o(w, k, I, C, b[_ + 3], G, 3250441966), C = o(C, w, k, I, b[_ + 4], U, 4118548399), I = o(I, C, w, k, b[_ + 5], $, 1200080426), k = o(k, I, C, w, b[_ + 6], W, 2821735955), w = o(w, k, I, C, b[_ + 7], G, 4249261313), C = o(C, w, k, I, b[_ + 8], U, 1770035416), I = o(I, C, w, k, b[_ + 9], $, 2336552879), k = o(k, I, C, w, b[_ + 10], W, 4294925233), w = o(w, k, I, C, b[_ + 11], G, 2304563134), C = o(C, w, k, I, b[_ + 12], U, 1804603682), I = o(I, C, w, k, b[_ + 13], $, 4254626195), k = o(k, I, C, w, b[_ + 14], W, 2792965006), w = o(w, k, I, C, b[_ + 15], G, 1236535329), C = u(C, w, k, I, b[_ + 1], Y, 4129170786), I = u(I, C, w, k, b[_ + 6], re, 3225465664), k = u(k, I, C, w, b[_ + 11], j, 643717713), w = u(w, k, I, C, b[_ + 0], J, 3921069994), C = u(C, w, k, I, b[_ + 5], Y, 3593408605), I = u(I, C, w, k, b[_ + 10], re, 38016083), k = u(k, I, C, w, b[_ + 15], j, 3634488961), w = u(w, k, I, C, b[_ + 4], J, 3889429448), C = u(C, w, k, I, b[_ + 9], Y, 568446438), I = u(I, C, w, k, b[_ + 14], re, 3275163606), k = u(k, I, C, w, b[_ + 3], j, 4107603335), w = u(w, k, I, C, b[_ + 8], J, 1163531501), C = u(C, w, k, I, b[_ + 13], Y, 2850285829), I = u(I, C, w, k, b[_ + 2], re, 4243563512), k = u(k, I, C, w, b[_ + 7], j, 1735328473), w = u(w, k, I, C, b[_ + 12], J, 2368359562), C = l(C, w, k, I, b[_ + 5], z, 4294588738), I = l(I, C, w, k, b[_ + 8], Q, 2272392833), k = l(k, I, C, w, b[_ + 11], te, 1839030562), w = l(w, k, I, C, b[_ + 14], ae, 4259657740), C = l(C, w, k, I, b[_ + 1], z, 2763975236), I = l(I, C, w, k, b[_ + 4], Q, 1272893353), k = l(k, I, C, w, b[_ + 7], te, 4139469664), w = l(w, k, I, C, b[_ + 10], ae, 3200236656), C = l(C, w, k, I, b[_ + 13], z, 681279174), I = l(I, C, w, k, b[_ + 0], Q, 3936430074), k = l(k, I, C, w, b[_ + 3], te, 3572445317), w = l(w, k, I, C, b[_ + 6], ae, 76029189), C = l(C, w, k, I, b[_ + 9], z, 3654602809), I = l(I, C, w, k, b[_ + 12], Q, 3873151461), k = l(k, I, C, w, b[_ + 15], te, 530742520), w = l(w, k, I, C, b[_ + 2], ae, 3299628645), C = d(C, w, k, I, b[_ + 0], ne, 4096336452), I = d(I, C, w, k, b[_ + 7], Se, 1126891415), k = d(k, I, C, w, b[_ + 14], Te, 2878612391), w = d(w, k, I, C, b[_ + 5], We, 4237533241), C = d(C, w, k, I, b[_ + 12], ne, 1700485571), I = d(I, C, w, k, b[_ + 3], Se, 2399980690), k = d(k, I, C, w, b[_ + 10], Te, 4293915773), w = d(w, k, I, C, b[_ + 1], We, 2240044497), C = d(C, w, k, I, b[_ + 8], ne, 1873313359), I = d(I, C, w, k, b[_ + 15], Se, 4264355552), k = d(k, I, C, w, b[_ + 6], Te, 2734768916), w = d(w, k, I, C, b[_ + 13], We, 1309151649), C = d(C, w, k, I, b[_ + 4], ne, 4149444226), I = d(I, C, w, k, b[_ + 11], Se, 3174756917), k = d(k, I, C, w, b[_ + 2], Te, 718787259), w = d(w, k, I, C, b[_ + 9], We, 3951481745), C = r(C, y), w = r(w, E), k = r(k, R), I = r(I, D);
  var Be = f(C) + f(w) + f(k) + f(I);
  return Be.toLowerCase();
}, vL = mL, yL = gL, _L = wt, TL = vL, bL = _L.extend({
  constructor: function(t) {
    this.plugin = t, this.dataExtractor = new yL(), this.key = this.getPreviousKey();
  },
  generateHashKey: function() {
    if (!this.key) {
      var t = this.dataExtractor.getAllData();
      this.key = this._hashFunction(t), this.plugin.storage.setLocal("youboraDeviceUUID", this.key);
    }
  },
  getKey: function() {
    return this.key || this.generateHashKey(), this.key;
  },
  _hashFunction: function(t) {
    var e = t;
    return typeof t != "string" && (e = JSON.stringify(t)), TL(e);
  },
  _reset: function() {
    this.key = void 0;
  },
  getPreviousKey: function() {
    return this.plugin.storage.getLocal("youboraDeviceUUID");
  }
}), O_ = bL, SL = wt, ss = Ha, EL = SL.extend(
  /** @lends youbora.PlaybackChronos.prototype */
  {
    /**
     * This class contains all the {@link Chrono}s related to view status.
     * Chronos measure time lapses between events.
     * ie: between start and join, between seek-begin and seek-end, etc.
     * Each plugin will have an instance of this class.
     *
     * @constructs PlaybackChronos
     * @extends youbora.YouboraObject
     * @memberof youbora
     */
    constructor: function() {
      this.reset();
    },
    /** Reset flag values */
    reset: function() {
      this.join = new ss(), this.seek = new ss(), this.pause = new ss(), this.buffer = new ss(), this.total = new ss(), this.viewedMax = [];
    }
  }
), xL = EL, CL = wt, AL = CL.extend(
  /** @lends youbora.PlaybackFlags.prototype */
  {
    /**
     * This class contains all the flags related to view status.
     * Each plugin will have an instance of this class.
     *
     * @constructs PlaybackFlags
     * @extends youbora.YouboraObject
     * @memberof youbora
     */
    constructor: function() {
      this.reset();
    },
    /** Reset flag values */
    reset: function() {
      this.isStarted = !1, this.isJoined = !1, this.isPaused = !1, this.isSeeking = !1, this.isBuffering = !1, this.isVideoStateBuffering = !1, this.isEnded = !1, this.isStopped = !1, this.lastQuartileSent = 0;
    }
  }
), wL = AL, PL = wt, kL = ff, LL = Ha, gs = PL.extend(
  /** @lends youbora.PlayheadMonitor.prototype */
  {
    /**
     * This class periodically checks the player's playhead in order to infer buffer and/or seek
     * events.
     *
     * Instances of this class are bounded to an {@link Adapter} and fires its buffer and seek
     * start and end methods.
     *
     * In order to use this feature, {@link Adapter#monitorPlayhead} should be used.
     *
     * @constructs PlayheadMonitor
     * @extends youbora.YouboraObject
     * @memberof youbora
     *
     * @param {Adapter} adapter Adapter to monitor. Must have getPlayhead defined.
     * @param {PlayheadMonitor.Type} [type=NONE]
     * Which metric to monitor seek and/or buffer.
     * Use bitwise operators to join both values (Type.BUFFER | Type.SEEK)
     * @param {int} [interval=800] How many ms will wait between progress. -1 to disable.
     */
    constructor: function(t, e, r) {
      this._adapter = t, this._seekEnabled = e & gs.Type.SEEK, this._bufferEnabled = e & gs.Type.BUFFER, r = r || 800, this._chrono = new LL(), this._lastPlayhead = 0, r > 0 && (this._timer = new kL(this.progress.bind(this), r));
    },
    /**
     * Start interval checks.
     */
    start: function() {
      this.stop(), this.canBeUsed() && this._timer.start();
    },
    /**
     * Stop interval checks.
     */
    stop: function() {
      this._lastPlayhead = 0, this._timer && this._timer.stop();
    },
    skipNextTick: function() {
      this._lastPlayhead = 0;
    },
    /**
     * Call this method at every tick of timeupdate/progress.
     * If you defined an interval, do not fire this method manually.
     */
    progress: function() {
      var t = this._chrono.stop();
      this._chrono.start();
      var e = t * gs.kBUFFER_THRESHOLD_RATIO, r = t * gs.kSEEK_THRESHOLD_RATIO;
      this._adapter.getPlayrate && this._adapter.getPlayrate() && this._adapter.getPlayrate() !== 1 && (e *= this._adapter.getPlayrate(), r *= this._adapter.getPlayrate());
      var n = this._getPlayhead(), i = Math.abs(this._lastPlayhead - n) * 1e3;
      i < e ? this._bufferEnabled && this._lastPlayhead > 0 && !this._adapter.flags.isPaused && !this._adapter.flags.isSeeking && this._adapter.fireBufferBegin(null, !1, "playheadMonitor") : i > r ? this._seekEnabled && this._lastPlayhead > 0 && this._adapter.fireSeekBegin(null, !1, "playheadMonitor") : (this._seekEnabled && this._adapter.fireSeekEnd(null, "playheadMonitor"), this._bufferEnabled && this._adapter.fireBufferEnd(null, "playheadMonitor")), this._lastPlayhead = n;
    },
    /**
     * Returns if the monitor can be used or not.
     * Enabled by default, except the case where the content is live and the option 'content.isLive.noMonitor' is true.
     * @public
     * @returns {boolean} If the monitor can be used or not.
     */
    canBeUsed: function() {
      var t = this._adapter.plugin;
      return t && t.getPlayheadMonitorEnabled() && (this._seekEnabled || this._bufferEnabled) ? t.getIsLive() ? !t.options["content.isLive.noMonitor"] : !0 : !1;
    },
    /**
     * Returns adapter's playhead. Override to add a custom playhead getter.
     * @private
     * @returns {double} Playhead in seconds
     */
    _getPlayhead: function() {
      return this._adapter.getPlayhead();
    }
  },
  /** @lends youbora.PlayheadMonitor */
  {
    // Static methods
    /**
     * Enum for monitoring type
     * @enum
     */
    Type: {
      /** Would not monitor */
      NONE: 0,
      /** Sends buffer-begin/end */
      BUFFER: 1,
      /** Sends seek-begin/end */
      SEEK: 2
    },
    /** Buffer threshold */
    kBUFFER_THRESHOLD_RATIO: 0.5,
    /** Seek threshold */
    kSEEK_THRESHOLD_RATIO: 2
  }
), M_ = gs, IL = wt, DL = bt, RL = IL.extend(
  /** @lends youbora.NetworkMonitor.prototype */
  {
    /**
     * @constructs StateMonitor
     * @extends youbora.YouboraObject
     * @memberof youbora
     *
     * @param {Adapter} adapter Adapter to monitor. Must have getVideoObject defined.
     * @param {int} [intervalMilliseconds=300] How many ms will wait between progress. -1 to disable.
     */
    constructor: function(t, e) {
      this._adapter = t, this._videoElement = t.getVideoObject(), this._startedStateCheck = !1, this._intervalCheckId = null, this._intervalMilliseconds = e || 300;
    },
    /**
     * Start Network monitor
     */
    start: function() {
      var t = this._adapter.plugin;
      t && t.getReadyStateMonitorEnabled() && this._videoElement && !this._startedStateCheck && (this._intervalCheckId = setInterval(this.checkStateProperty.bind(this), this._intervalMilliseconds), this._startedStateCheck = !0);
    },
    /**
     * Stop Network monitor
     */
    stop: function() {
      try {
        this._startedStateCheck && this._intervalCheckId && clearInterval(this._intervalCheckId), this._intervalCheckId = null, this._startedStateCheck = !1;
      } catch {
        DL.error("Produced error stopping the network monitor");
      }
    },
    /**
     * Check ReadyState properties values
     * @param e
     */
    checkStateProperty: function(t) {
      try {
        this._videoElement && this._adapter && this._videoElement.readyState && (this._videoElement.readyState > 3 && !this._adapter.flags.isSeeking ? this._adapter.flags.isBuffering ? this.fireBufferEnd({}, "stateMonitor") : this._adapter.flags.isJoined || this.fireJoin({}, "stateMonitor") : this._videoElement.readyState < 4 && !this._adapter.flags.isBuffering && this.fireBufferBegin({}, !1, "stateMonitor", !0));
      } catch {
      }
    }
  }
), OL = RL, _d, Gg;
function ML() {
  if (Gg)
    return _d;
  Gg = 1;
  var t = el, e = Ha, r = {
    /** Override to return current ad position */
    getPosition: function() {
      return null;
    },
    /** Override to return the given ad structure (list with number of pre, mid, and post breaks) */
    getGivenBreaks: function() {
      return null;
    },
    /** Override to return the ad structure requested (list with number of pre, mid, and post breaks) */
    getExpectedBreaks: function() {
      return null;
    },
    /** Override to return the structure of ads requested */
    getExpectedPattern: function() {
      return null;
    },
    /** Override to return a list of playheads of ad breaks begin time */
    getBreaksTime: function() {
      return null;
    },
    /** Override to return the number of ads given for the break */
    getGivenAds: function() {
      return null;
    },
    /** Override to return the number of ads requested for the break */
    getExpectedAds: function() {
      return null;
    },
    /** Override to return if the ad is being shown in the screen or not
     * The standard definition is: more than 50% of the pixels of the ad are on the screen
     */
    getIsVisible: function() {
      return !0;
    },
    /** Override to return a boolean showing if the audio is enabled when the ad begins */
    getAudioEnabled: function() {
      return null;
    },
    /** Override to return if the ad is skippable */
    getIsSkippable: function() {
      return null;
    },
    /** Override to return a boolean showing if the player is in fullscreen mode when the ad begins */
    getIsFullscreen: function() {
      return null;
    },
    /** Override to return the ad campaign */
    getCampaign: function() {
      return null;
    },
    /** Override to return the ad creative id */
    getCreativeId: function() {
      return null;
    },
    /** Override to return the ad provider name */
    getProvider: function() {
      return null;
    },
    /** Override to return the ad insertion type
     * Use constants:
     * youbora.Constants.AdInsertionType.ClientSide
     * youbora.Constants.AdInsertionType.ServerSide
    */
    getAdInsertionType: function() {
      return null;
    },
    /**
    * Emits related event and set flags if current status is valid.
    * ie: won't sent start if isStarted is already true.
    *
    * @param {Object} [params] Object of key:value params to add to the request.
    */
    fireClick: function(n) {
      typeof n == "string" && (n = { url: n }), this.emit(t.Event.CLICK, { params: n });
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */
    fireQuartile: function(n) {
      this.flags.isStarted && typeof n == "number" && n > this.flags.lastQuartileSent && n < 4 && (this.flags.lastQuartileSent++, this.emit(t.Event.QUARTILE, { params: { quartile: n } }));
    },
    /**
    * Starts a new chrono for viewedMax and restarts viewedAcum
    */
    startChronoView: function() {
      if (this.getIsVisible() && !this.plugin.backgroundDetector.isInBackground) {
        var n = this.chronos.viewedMax;
        (n.length === 0 || n[n.length - 1].stopTime !== 0) && (n.push(new e()), n[n.length - 1].start());
      }
    },
    /**
    * Stops a new chrono for viewedMax and restarts viewedAcum
    */
    stopChronoView: function() {
      var n = this.chronos.viewedMax;
      n[0] && n.length > 0 && n[n.length - 1].stopTime === 0 && n[n.length - 1].stop();
    },
    /**
    * @param {Object} [params] Object of key:value params to add to the request.
    */
    fireManifest: function(n, i) {
      var a = { params: n };
      typeof n == "string" && (a = { params: { errorType: n, errorMessage: i } }), this.emit(t.Event.MANIFEST, a);
    },
    /*
    * Emits related event and set flags if current status is valid.
    * ie: won't sent start if isStarted is already true.
    *
    * @param {Object} [params] Object of key:value params to add to the request.
    */
    fireSkip: function(n) {
      n === void 0 && (n = {}), n.skipped = !0, this.fireStop(n);
    },
    /**
    * Emits related event and set flags if current status is valid.
    * ie: won't sent start if isStarted is already true.
    *
    * @param {Object} [params] Object of key:value params to add to the request.
    */
    fireBreakStart: function(n) {
      this.emit(t.Event.PODSTART, { params: n });
    },
    /**
    * Emits related event and set flags if current status is valid.
    * ie: won't sent start if isStarted is already true.
    *
    * @param {Object} [params] Object of key:value params to add to the request.
    */
    fireBreakStop: function(n) {
      this.emit(t.Event.PODSTOP, { params: n });
    }
  };
  return _d = r, _d;
}
var Td, Kg;
function NL() {
  if (Kg)
    return Td;
  Kg = 1;
  var t = el, e = bt, r = {
    /** Override to return current playrate */
    getPlayrate: function() {
      return this.flags.isPaused ? 0 : 1;
    },
    /** Override to return Frames Per Secon (FPS) */
    getFramesPerSecond: function() {
      return null;
    },
    /** Override to return dropped frames since start */
    getDroppedFrames: function() {
      return null;
    },
    /** Override to return user bandwidth throughput */
    getThroughput: function() {
      return null;
    },
    /** Override to return rendition */
    getRendition: function() {
      return null;
    },
    /** Override to return title2 */
    getTitle2: function() {
      return null;
    },
    /** Override to recurn true if live and false if VOD */
    getIsLive: function() {
      return null;
    },
    /** Override to return CDN traffic bytes not using streamroot or peer5. */
    getCdnTraffic: function() {
      return null;
    },
    /** Override to return P2P traffic bytes not using streamroot or peer5. */
    getP2PTraffic: function() {
      return null;
    },
    /** Override to return P2P traffic sent in bytes, not using streamroot or peer5. */
    getUploadTraffic: function() {
      return null;
    },
    /** Override to return if P2P is enabled not using streamroot or peer5. */
    getIsP2PEnabled: function() {
      return null;
    },
    /** Override to return video segment duration. */
    getSegmentDuration: function() {
      return null;
    },
    /** Override to return household id */
    getHouseholdId: function() {
      return null;
    },
    /** Override to return the latency */
    getLatency: function() {
      return null;
    },
    /** Override to return the number of packets lost */
    getPacketLoss: function() {
      return null;
    },
    /** Override to return the number of packets sent */
    getPacketSent: function() {
      return null;
    },
    /** Override to return a json with metrics */
    getMetrics: function() {
      return null;
    },
    /** Override to return the audio codec */
    getAudioCodec: function() {
      return null;
    },
    /** Override to return the video codec */
    getVideoCodec: function() {
      return null;
    },
    /** Override to return a chunk or intermediate manifest url */
    getURLToParse: function() {
      return null;
    },
    /**
    * Emits related event and set flags if current status is valid.
    * ie: won't sent start if isStarted is already true.
    *
    * @param {Object} [params] Object of key:value params to add to the request.
    * @param {bool} [convertFromBuffer=true] If false, will convert current buffer to seek.
    * @param {string} [triggeredEvent]
    */
    fireSeekBegin: function(n, i, a) {
      if (this._discardFalseBuffers(), this.plugin && this.plugin.getIsLive() && this.plugin.options["content.isLive.noSeek"])
        return null;
      if (this.flags.isJoined && !this.flags.isSeeking) {
        if (this.flags.isBuffering)
          if (i !== !1)
            e.notice("Converting current buffer to seek"), this.chronos.seek = this.chronos.buffer.clone(), this.chronos.buffer.reset(), this.flags.isBuffering = !1;
          else
            return;
        else
          this.chronos.seek.start();
        try {
          this.fireEventsStruct.seek = [], a ? this.fireEventsStruct.seek.push(a) : this.fireEventsStruct.seek.push("undefinedEvent");
        } catch {
        }
        this.flags.isSeeking = !0, this.emit(t.Event.SEEK_BEGIN, { params: n });
      }
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */
    fireSeekEnd: function(n, i) {
      if (this.plugin && this.plugin.getIsLive() && this.plugin.options["content.isLive.noSeek"])
        return null;
      if (this.flags.isJoined && this.flags.isSeeking) {
        try {
          i ? this.fireEventsStruct.seek.push(i) : this.fireEventsStruct.seek.push("undefinedEvent");
        } catch {
        }
        n = n || {}, n.triggeredEvents = this.fireEventsStruct.seek, this.cancelSeek(), this.emit(t.Event.SEEK_END, { params: n });
      }
    },
    /**
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */
    cancelSeek: function(n) {
      this.flags.isJoined && this.flags.isSeeking && (this.flags.isSeeking = !1, this.chronos.seek.stop(), this.monitor && this.monitor.skipNextTick());
    },
    /**
    * Emits event request.
    *
    * @param {Object} [params] Object of key:value params to add to the request.
    */
    fireEvent: function(n, i, a, s) {
      var o = s || {};
      o.name = n || "", o.dimensions = i || {}, o.values = a || {}, this.emit(t.Event.VIDEO_EVENT, { params: o });
    }
  };
  return Td = r, Td;
}
var BL = Br, bd = bt, yf = li, Xg = Zu, FL = xL, UL = wL, Sd = M_, VL = OL, mr = el, _f = BL.extend(
  /** @lends youbora.this.prototype */
  {
    /**
     * Main Adapter class. All specific player adapters should extend this class specifying a player
     * class.
     *
     * The Adapter works as the 'glue' between the player and YOUBORA acting both as event
     * translator and as proxy for the {@link Plugin} to get info from the player.
     *
     * @constructs Adapter
     * @extends youbora.Emitter
     * @memberof youbora
     *
     * @param {object|string} player Either an instance of the player or a string containing an ID.
     */
    constructor: function(t) {
      this.flags = new UL(), this.chronos = new FL(), this.fireEventsStruct = {}, this.fireEventsStruct.buffer = [], this.fireEventsStruct.seek = [], this.monitor = null, this.plugin = null, this.player = null, this._isAdsAdapter = null, this.setPlayer(t), this.tag = this.player, bd.notice("Adapter " + this.getVersion() + " with Lib " + Xg + " is ready.");
    },
    /**
     * Sets a new player, removes the old listeners if needed.
     *
     * @param {Object} player Player to be registered.
     */
    setPlayer: function(t) {
      this.player && this.unregisterListeners(), typeof t == "string" && typeof document < "u" ? this.player = document.getElementById(t) : this.player = t, this.registerListeners();
    },
    /**
     * Override to create event binders.
     * It's a good practice when implementing a new Adapter to create intermediate methods and call
     * those when player events are detected instead of just calling the `fire*` methods. This
     * will allow future users of the Adapter to customize its behaviour by overriding these
     * methods.
     *
     * @example
     * registerListeners: function () {
     *  this.player.addEventListener('start', this.onStart.bind(this))
     * },
     *
     * onStart: function (e) {
     *  this.emit('start')
     * }
     */
    registerListeners: function() {
    },
    /**
     * Override to create event de-binders.
     *
     * @example
     * registerListeners: function () {
     *  this.player.removeEventListener('start', this.onStart)
     * }
     */
    /** Unregister listeners to this.player. */
    unregisterListeners: function() {
    },
    /**
     * This function disposes the currend adapter, removes player listeners and drops references.
     */
    dispose: function() {
      this.stopMonitor(), this.stopReadyStateMonitor(), this.fireStop(), this.unregisterListeners(), this.player = null, this.tag = null;
    },
    /**
     * Creates a new {@link PlayheadMonitor} at this.monitor.
     *
     * @param {bool} monitorBuffers If true, it will monitor buffers.
     * @param {bool} monitorSeeks If true, it will monitor seeks.
     * @param {number} [interval=800] The interval time in ms.
     */
    monitorPlayhead: function(t, e, r) {
      this.stopMonitor();
      var n = 0;
      t && (n |= Sd.Type.BUFFER), e && (n |= Sd.Type.SEEK), !this.monitor || !this.monitor._timer.isRunning ? this.monitor = new Sd(this, n, r) : this.monitor.skipNextTick();
    },
    stopMonitor: function() {
      this.monitor && this.monitor.stop();
    },
    /**
     *
     * @param {number} [intervalMilliseconds=300]
     */
    monitorReadyState: function(t) {
      this.stopReadyStateMonitor(), this.stateMonitor = new VL(this, t);
    },
    /**
     * Start ReadyState monitor
     */
    startReadyStateMonitor: function() {
      this.stateMonitor && this.stateMonitor.start();
    },
    /**
     * Stop ReadyState monitor
     */
    stopReadyStateMonitor: function() {
      this.stateMonitor && this.stateMonitor.stop();
    },
    /**
     * Check readyState video properties
     * @param readyState
     * @param triggeredEvent
     */
    checkReadyState: function(t, e) {
      try {
        this.plugin && this.plugin.getReadyStateMonitorEnabled() && t && (t > 3 && !this.flags.isSeeking ? this.flags.isBuffering ? this.fireBufferEnd({}, e + "-readyState") : this.flags.isJoined || this.fireJoin({}, e + "-readyState") : t < 4 && !this.flags.isBuffering && this.fireBufferBegin({}, !1, e + "-readyState", !0));
      } catch {
        bd.error("Can't check readyState property correctly");
      }
    },
    // GETTERS //
    /** Override to return current playhead of the video */
    getPlayhead: function() {
      return null;
    },
    /** Override to return video duration */
    getDuration: function() {
      return null;
    },
    /** Override to return current bitrate */
    getBitrate: function() {
      return null;
    },
    /** Override to return total downloaded bytes */
    getTotalBytes: function() {
      return null;
    },
    /** Override to return title */
    getTitle: function() {
      return null;
    },
    /** Override to return resource URL. */
    getResource: function() {
      return null;
    },
    /** Override to return player version */
    getPlayerVersion: function() {
      return null;
    },
    /** Override to return player's name */
    getPlayerName: function() {
      return null;
    },
    /** Override to return adapter version. */
    getVersion: function() {
      return Xg + "-generic-js";
    },
    /** Override to return video object */
    getVideoObject: function() {
      return null;
    },
    // FLOW //
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent init if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */
    fireInit: function(t, e) {
      this.plugin && this.plugin.fireInit(t, e);
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */
    fireStart: function(t, e) {
      if (this.plugin && this.plugin.backgroundDetector && this.plugin.backgroundDetector.canBlockStartCalls())
        return null;
      this.flags.isStarted || (this.flags.isStarted = !0, this.chronos.total.start(), this.chronos.join.start(), e && (t = t || {}, t.triggeredEvents = [e]), this.startReadyStateMonitor(), this.emit(mr.Event.START, { params: t }));
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */
    fireJoin: function(t, e) {
      !this.flags.isJoined && !this.flags.isStarted && !this._isAds() && this.plugin && this.plugin.isInitiated && this.fireStart({}, e), this.flags.isStarted && !this.flags.isJoined && (this.flags.isStarted = !0, this.monitor && this.monitor.start(), this.flags.isJoined = !0, this.chronos.join.stop(), e && (t = t || {}, t.triggeredEvents = [e]), this.emit(mr.Event.JOIN, { params: t }));
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */
    firePause: function(t, e) {
      this._discardFalseBuffers(), this.flags.isBuffering && this.fireBufferEnd(null, "firePauseCall"), this.flags.isJoined && !this.flags.isPaused && (this.flags.isPaused = !0, this.chronos.pause.start(), e && (t = t || {}, t.triggeredEvents = [e]), this.emit(mr.Event.PAUSE, { params: t }));
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */
    fireResume: function(t, e) {
      this._discardFalseBuffers(), this.flags.isJoined && this.flags.isPaused && (this.flags.isPaused = !1, this.chronos.pause.stop(), this.monitor && this.monitor.skipNextTick(), e && (t = t || {}, t.triggeredEvents = [e]), this.emit(mr.Event.RESUME, { params: t }));
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {boolean} [convertFromSeek=false] If true, will convert current seek to buffer.
     * @param {string} [triggeredEvent]
     * @param {boolean} [triggeredByStateProperty]
     */
    fireBufferBegin: function(t, e, r, n) {
      if (n = n || !1, this.flags.isJoined && !this.flags.isBuffering) {
        if (this.flags.isSeeking)
          if (e)
            bd.notice("Converting current buffer to seek"), this.chronos.buffer = this.chronos.seek.clone(), this.chronos.seek.reset(), this.flags.isSeeking = !1;
          else
            return;
        else
          this.chronos.buffer.start();
        try {
          this.fireEventsStruct.buffer = [], r ? this.fireEventsStruct.buffer.push(r) : this.fireEventsStruct.buffer.push("undefinedEvent");
        } catch {
        }
        this.flags.isBuffering = !0, this.flags.isVideoStateBuffering = n, this.emit(mr.Event.BUFFER_BEGIN, { params: t });
      }
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */
    fireBufferEnd: function(t, e) {
      if (this.flags.isJoined && this.flags.isBuffering) {
        try {
          e ? this.fireEventsStruct.buffer.push(e) : this.fireEventsStruct.buffer.push("undefinedEvent");
        } catch {
        }
        t = t || {}, t.triggeredEvents = this.fireEventsStruct.buffer, this.cancelBuffer(), this.emit(mr.Event.BUFFER_END, { params: t });
      }
    },
    /**
     * Discard false buffer events from state changed
     * @private
     */
    _discardFalseBuffers: function() {
      try {
        this.flags.isBuffering && this.flags.isVideoStateBuffering && this._getDeltaBufferTime() <= 100 && this.cancelBuffer();
      } catch {
      }
    },
    /**
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     */
    cancelBuffer: function(t) {
      this.flags.isJoined && this.flags.isBuffering && (this.flags.isBuffering = !1, this.flags.isVideoStateBuffering = !1, this.chronos.buffer.stop(), this.monitor && this.monitor.skipNextTick());
    },
    /**
     * Get Delta buffer time
     * @returns {number|number|*}
     * @private
     */
    _getDeltaBufferTime: function() {
      return this.chronos && this.chronos.buffer ? this.chronos.buffer.getDeltaTime(!1) : 0;
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */
    fireStop: function(t, e) {
      (this._isAds() || this.plugin && this.plugin._isStopReady()) && (this._isAds() && this.flags.isStarted || !this._isAds() && (this.flags.isStarted || this.plugin && this.plugin.isInitiated)) && (this.stopMonitor(), this.stopReadyStateMonitor(), this.flags.reset(), this.chronos.total.stop(), this.chronos.join.reset(), this.chronos.pause.stop(), this.chronos.buffer.stop(), this.chronos.seek.stop(), e && (t = t || {}, t.triggeredEvents = [e]), this.emit(mr.Event.STOP, { params: t }), this.chronos.pause.reset(), this.chronos.buffer.reset(), this.chronos.seek.reset(), this.chronos.viewedMax.splice(0, this.chronos.viewedMax.length));
    },
    setIsAds: function(t) {
      this._isAdsAdapter = t;
    },
    _isAds: function() {
      return this._isAdsAdapter;
    },
    /**
     * @param {Object} [params] Object of key:value params to add to the request.
     * @param {string} [triggeredEvent]
     */
    fireCasted: function(t, e) {
      t || (t = {}), t.casted = !0, this.fireStop(t, e);
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
     * @param {String} [msg] Error Message
     * @param {Object} [metadata] Object defining error metadata
     * @param {String} [level] Level of the error. Currently supports 'error' and 'fatal'
     * @param {string} [triggeredEvent]
     */
    fireError: function(t, e, r, n, i) {
      var a = yf.buildErrorParams(t, e, r, n);
      a.code && delete a.code, i && (a = a || {}, a.triggeredEvents = [i]);
      var s = this.plugin ? this.plugin.options : {};
      typeof a.errorCode < "u" && s["errors.ignore"] && s["errors.ignore"].indexOf(a.errorCode.toString()) > -1 || (this.emit(mr.Event.ERROR, { params: a }), typeof a.errorCode < "u" && s["errors.fatal"] && s["errors.fatal"].indexOf(a.errorCode.toString()) > -1 && this.fireStop({}, i));
    },
    /**
     * Emits related event and set flags if current status is valid.
     * ie: won't sent start if isStarted is already true.
     *
     * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
     * @param {String} [msg] Error Message
     * @param {Object} [metadata] Object defining error metadata
     * @param {String} [level] Level of the error. Currently supports 'error' and 'fatal'
     * @param {string} [triggeredEvent]
     */
    fireFatalError: function(t, e, r, n, i) {
      var a = this.plugin ? this.plugin.options : {};
      typeof t < "u" && a["errors.ignore"] && a["errors.ignore"].indexOf(t.toString()) > -1 || (this.monitor && this.monitor.stop(), this.fireError(t, e, r, n, i), typeof t < "u" && a["errors.nonFatal"] && a["errors.nonFatal"].indexOf(t.toString()) > -1 || this.fireStop({}, i));
    }
  },
  {
    /** @lends youbora.Adapter */
    // Static Memebers //
    /**
     * List of events that could be fired
     * @enum
     * @event
     */
    Event: mr.Event
  }
);
yf.assign(_f.prototype, ML());
yf.assign(_f.prototype, NL());
var Tf = _f, Ed, Yg;
function jL() {
  if (Yg)
    return Ed;
  Yg = 1;
  var t = bt, e = Wi, r = li, n = Tf, i = {
    /**
     * Sets an adapter for video content.
     *
     * @param {Adapter} adapter
     *
     * @memberof youbora.Plugin.prototype
     */
    setAdapter: function(a) {
      if (this.browserLoadTimes && this.browserLoadTimes.setPlayerSetupTime(), a.plugin)
        t.warn("Adapters can only be added to a single plugin");
      else {
        this.removeAdapter(), this._adapter = a, a.plugin = this, a.setIsAds(!1), this.contentAdapterListeners = {}, this.contentAdapterListeners[n.Event.START] = this._startListener.bind(this), this.contentAdapterListeners[n.Event.JOIN] = this._joinListener.bind(this), this.contentAdapterListeners[n.Event.PAUSE] = this._pauseListener.bind(this), this.contentAdapterListeners[n.Event.RESUME] = this._resumeListener.bind(this), this.contentAdapterListeners[n.Event.SEEK_BEGIN] = this._seekBufferBeginListener.bind(this), this.contentAdapterListeners[n.Event.SEEK_END] = this._seekEndListener.bind(this), this.contentAdapterListeners[n.Event.BUFFER_BEGIN] = this._seekBufferBeginListener.bind(this), this.contentAdapterListeners[n.Event.BUFFER_END] = this._bufferEndListener.bind(this), this.contentAdapterListeners[n.Event.ERROR] = this._errorListener.bind(this), this.contentAdapterListeners[n.Event.STOP] = this._stopListener.bind(this), this.contentAdapterListeners[n.Event.VIDEO_EVENT] = this._videoEventListener.bind(this);
        for (var s in this.contentAdapterListeners)
          this._adapter.on(s, this.contentAdapterListeners[s]);
      }
    },
    /**
     * Returns current adapter or null.
     *
     * @returns {Adapter}
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdapter: function() {
      return this._adapter;
    },
    /**
     * Removes the current adapter. Fires stop if needed. Calls adapter.dispose().
     *
     * @memberof youbora.Plugin.prototype
     * */
    removeAdapter: function() {
      if (this._adapter) {
        if (this._adapter.dispose(), this._adapter.plugin = null, this.contentAdapterListeners) {
          for (var a in this.contentAdapterListeners)
            this._adapter.off(a, this.contentAdapterListeners[a]);
          delete this.contentAdapterListeners;
        }
        this._adapter = null;
      }
    },
    // ---------------------------------------- LISTENERS -----------------------------------------
    _startListener: function(a) {
      this.isInitiated ? this.initChrono.startTime !== 0 && (this._adapter.chronos.join.startTime = this.initChrono.startTime) : (this.viewTransform.nextView(), this._initComm(), this._startPings());
      try {
        if (this._adapter && this.resourceTransform) {
          var s = this._getResourceForTransform();
          this.resourceTransform.init(s);
        }
      } catch {
      }
      var o = a.data.params || {}, u = this.getResource() && typeof this.getIsLive() == "boolean" && (this.getIsLive() || typeof this.getDuration() == "number" && this.getDuration() > 0) && this.getTitle();
      u = this.options.forceInit ? !1 : u && this._isExtraMetadataReady(), u && !this.isInitiated ? (this._send(e.WillSendEvent.WILL_SEND_START, e.Service.START, o), this._adSavedError(), this._adSavedManifest(), t.notice(e.Service.START + " " + (o.title || o.mediaResource)), this.isStarted = !0) : this.isInitiated || (this.isInitiated = !0, this._adapter.chronos.join.start(), this._send(e.WillSendEvent.WILL_SEND_INIT, e.Service.INIT, o), this._adSavedError(), this._adSavedManifest(), t.notice(e.Service.INIT + " " + (o.title || o.mediaResource)));
    },
    _retryStart: function(a) {
      this._isExtraMetadataReady() && (this._send(e.WillSendEvent.WILL_SEND_START, e.Service.START, {}), this.startDelayed = !1);
    },
    _joinListener: function(a) {
      var s = {};
      r.assign(s, a.data.params || {}), !this._adsAdapter || !this._adsAdapter.flags.isStarted ? (this._adapter && (this._adapter.chronos.join.startTime = Math.min(
        this._adapter.chronos.join.startTime + (this._totalPrerollsTime || 0),
        (/* @__PURE__ */ new Date()).getTime()
      ), this._totalPrerollsTime = 0), this.isInitiated && !this.isStarted && (this._isExtraMetadataReady() ? this._send(e.WillSendEvent.WILL_SEND_START, e.Service.START, s) : this.startDelayed = !0, this._adSavedError(), this._adSavedManifest(), t.notice(e.Service.START + " " + (s.title || s.mediaResource)), this.isStarted = !0), s = a.data.params || {}, this._adsAdapter && this.isBreakStarted && this._adsAdapter.fireBreakStop(), this._send(e.WillSendEvent.WILL_SEND_JOIN, e.Service.JOIN, s), t.notice(e.Service.JOIN + " " + s.joinDuration + "ms")) : (this._adapter.monitor && this._adapter.monitor.stop(), this._adapter.flags.isJoined = !1, this._adapter.chronos.join.stopTime = 0);
    },
    _pauseListener: function(a) {
      this._adapter && (this._adapter.flags.isBuffering || this._adapter.flags.isSeeking || this._adsAdapter && this._adsAdapter.flags.isStarted) && this._adapter.chronos.pause.reset();
      var s = a.data.params || {};
      this._send(e.WillSendEvent.WILL_SEND_PAUSE, e.Service.PAUSE, s), t.notice(e.Service.PAUSE + " at " + s.playhead + "s");
    },
    _resumeListener: function(a) {
      this._adsAdapter && this.isBreakStarted && !this._adsAdapter.flags.isStarted && this._adsAdapter.fireBreakStop();
      var s = a.data.params || {};
      this._send(e.WillSendEvent.WILL_SEND_RESUME, e.Service.RESUME, s), t.notice(e.Service.RESUME + " " + s.pauseDuration + "ms"), this._adapter.chronos.pause.reset();
    },
    _seekBufferBeginListener: function(a) {
      this._adapter && this._adapter.flags.isPaused && this._adapter.chronos.pause.reset(), a.type && a.type.includes("buffer") ? t.notice(a.type + ", eventsTriggered: " + this._adapter.fireEventsStruct.buffer) : t.notice(a.type + ", eventsTriggered: " + this._adapter.fireEventsStruct.seek);
    },
    _seekEndListener: function(a) {
      var s = a.data.params || {};
      this._send(e.WillSendEvent.WILL_SEND_SEEK, e.Service.SEEK, s), t.notice(
        e.Service.SEEK + " to " + s.playhead + " in " + s.seekDuration + "ms" + (s.triggeredEvents ? ", eventsTriggered: " + s.triggeredEvents : "")
      );
    },
    _bufferEndListener: function(a) {
      var s = a.data.params || {};
      this._send(e.WillSendEvent.WILL_SEND_BUFFER, e.Service.BUFFER, s), t.notice(
        e.Service.BUFFER + " to " + s.playhead + " in " + s.bufferDuration + "ms" + (s.triggeredEvents ? ", eventsTriggered: " + s.triggeredEvents : "")
      );
    },
    _errorListener: function(a) {
      this._blockError(a.data.params) || (this.fireError(a.data.params || {}), this._adSavedError(), this._adSavedManifest());
    },
    _blockError: function(a) {
      var s = Date.now(), o = this._lastErrorParams ? this._lastErrorParams.errorCode === a.errorCode && this._lastErrorParams.msg === a.msg : !1;
      return o && this._lastErrorTime + 5e3 > s ? (this._lastErrorTime = s, !0) : (this._lastErrorTime = s, this._lastErrorParams = a, !1);
    },
    _stopListener: function(a) {
      this.fireStop(a.data.params || {});
    },
    _isStopReady: function(a) {
      var s = !1;
      if (!this.requestBuilder.lastSent.live && // VOD, live have no postrolls
      this._adsAdapter && // having ads adapter connected
      this._adapter && // playhead close to the end of the content (or 0 because is already restarted)
      (!this._adapter.getPlayhead() || this._adapter.getPlayhead() >= this.requestBuilder.lastSent.mediaDuration - 1)) {
        var o = 0, u = this.options["ad.expectedPattern"];
        if (u && u.post && u.post[0])
          o = u.post[0];
        else if (this.requestBuilder.lastSent.breaksTime) {
          if (this.requestBuilder.lastSent.position === e.AdPosition.Postroll && (o = this.requestBuilder.lastSent.givenAds), !o && this.requestBuilder.lastSent.breaksTime) {
            var l = this.requestBuilder.lastSent.breaksTime;
            if (l.length > 0 && this.requestBuilder.lastSent.mediaDuration) {
              var d = Math.round(l[l.length - 1]);
              d + 1 >= this.requestBuilder.lastSent.mediaDuration && (o = 1);
            }
          }
        } else
          s = !0;
        o <= this.playedPostrolls && (s = !0);
      } else
        s = !0;
      return s;
    },
    _videoEventListener: function(a) {
      this._send(e.WillSendEvent.WILL_SEND_VIDEO_EVENT, e.Service.VIDEO_EVENT, a.data.params);
    },
    _isExtraMetadataReady: function(a) {
      if (!this.options.waitForMetadata || this.options.pendingMetadata.length < 1)
        return !0;
      var s = this.requestBuilder.getGetters();
      return this.options.pendingMetadata.map(function(o) {
        if (s.hasOwnProperty(o))
          return !!this[s[o]]();
      }.bind(this)).indexOf(!1) < 0;
    }
  };
  return Ed = i, Ed;
}
var xd, Qg;
function HL() {
  if (Qg)
    return xd;
  Qg = 1;
  var t = li, e = Zu, r = pf, n = {
    /**
       * Returns service host
       *
       * @memberof youbora.Plugin.prototype
       */
    getHost: function() {
      var i = this.options.host;
      return this.viewTransform && this.viewTransform.response && this.viewTransform.response.host && (i = this.viewTransform.response.host), t.addProtocol(t.stripProtocol(i), this.options["app.https"]);
    },
    getUserType: function() {
      return this.options["user.type"];
    },
    /**
       * Returns parse Manifest Flag
       *
       * @memberof youbora.Plugin.prototype
       */
    isParseManifest: function() {
      return this.options["parse.manifest"];
    },
    /**
       * Returns parse CdnNode Flag
       *
       * @memberof youbora.Plugin.prototype
       */
    isParseCdnNode: function() {
      return this.options["parse.cdnNode"];
    },
    /**
       * Returns parse cdn switch Flag
       *
       * @memberof youbora.Plugin.prototype
       */
    isCdnSwitch: function() {
      return this.options["parse.cdnSwitchHeader"];
    },
    /**
       * Returns Cdn list
       *
       * @memberof youbora.Plugin.prototype
       */
    getParseCdnNodeList: function() {
      return this.options["parse.cdnNode.list"];
    },
    /**
       * Returns Cdn header name
       *
       * @memberof youbora.Plugin.prototype
       */
    getParseCdnNodeNameHeader: function() {
      return this.options["parse.cdnNameHeader"];
    },
    /**
     * Returns header node name
     *
     * @memberof youbora.Plugin.prototype
     */
    getParseNodeHeader: function() {
      return this.options["parse.cdnNodeHeader"];
    },
    /**
       * Returns obfuscateIp option
       *
       * @memberof youbora.Plugin.prototype
       */
    getObfuscateIp: function() {
      return this.options["user.obfuscateIp"];
    },
    /**
     * Returns privacy protocol option
     *
     * @memberof youbora.Plugin.prototype
     */
    getPrivacyProtocol: function() {
      var i = this.options["user.privacyProtocol"];
      return typeof i == "string" && (i = i.toLowerCase()), i === "optin" || i === "optout" ? i : null;
    },
    /**
     * Returns content's custom dimensions
     *
     * @memberof youbora.Plugin.prototype
     */
    getCustomDimensions: function() {
      var i = this.options["content.customDimensions"];
      return typeof i == "object" ? i : null;
    },
    /**
       * Returns content's Extraparam1
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam1: function() {
      return this.options["content.customDimension.1"];
    },
    /**
       * Returns content's Extraparam2
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam2: function() {
      return this.options["content.customDimension.2"];
    },
    /**
       * Returns content's Extraparam3
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam3: function() {
      return this.options["content.customDimension.3"];
    },
    /**
       * Returns content's Extraparam4
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam4: function() {
      return this.options["content.customDimension.4"];
    },
    /**
       * Returns content's Extraparam5
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam5: function() {
      return this.options["content.customDimension.5"];
    },
    /**
       * Returns content's Extraparam6
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam6: function() {
      return this.options["content.customDimension.6"];
    },
    /**
       * Returns content's Extraparam7
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam7: function() {
      return this.options["content.customDimension.7"];
    },
    /**
       * Returns content's Extraparam8
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam8: function() {
      return this.options["content.customDimension.8"];
    },
    /**
       * Returns content's Extraparam9
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam9: function() {
      return this.options["content.customDimension.9"];
    },
    /**
       * Returns content's Extraparam10
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam10: function() {
      return this.options["content.customDimension.10"];
    },
    /**
       * Returns content's Extraparam11
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam11: function() {
      return this.options["content.customDimension.11"];
    },
    /**
       * Returns content's Extraparam12
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam12: function() {
      return this.options["content.customDimension.12"];
    },
    /**
       * Returns content's Extraparam13
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam13: function() {
      return this.options["content.customDimension.13"];
    },
    /**
       * Returns content's Extraparam14
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam14: function() {
      return this.options["content.customDimension.14"];
    },
    /**
       * Returns content's Extraparam15
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam15: function() {
      return this.options["content.customDimension.15"];
    },
    /**
       * Returns content's Extraparam16
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam16: function() {
      return this.options["content.customDimension.16"];
    },
    /**
       * Returns content's Extraparam17
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam17: function() {
      return this.options["content.customDimension.17"];
    },
    /**
       * Returns content's Extraparam18
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam18: function() {
      return this.options["content.customDimension.18"];
    },
    /**
       * Returns content's Extraparam19
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam19: function() {
      return this.options["content.customDimension.19"];
    },
    /**
       * Returns content's Extraparam20
       *
       * @memberof youbora.Plugin.prototype
       */
    getExtraparam20: function() {
      return this.options["content.customDimension.20"];
    },
    /**
       * Returns ad's Extraparam1
       *
       * @memberof youbora.Plugin.prototype
       */
    getAdExtraparam1: function() {
      return this.options["ad.customDimension.1"];
    },
    /**
       * Returns ad's Extraparam2
       *
       * @memberof youbora.Plugin.prototype
       */
    getAdExtraparam2: function() {
      return this.options["ad.customDimension.2"];
    },
    /**
       * Returns ad's Extraparam3
       *
       * @memberof youbora.Plugin.prototype
       */
    getAdExtraparam3: function() {
      return this.options["ad.customDimension.3"];
    },
    /**
       * Returns ad's Extraparam4
       *
       * @memberof youbora.Plugin.prototype
       */
    getAdExtraparam4: function() {
      return this.options["ad.customDimension.4"];
    },
    /**
       * Returns ad's Extraparam5
       *
       * @memberof youbora.Plugin.prototype
       */
    getAdExtraparam5: function() {
      return this.options["ad.customDimension.5"];
    },
    /**
       * Returns ad's Extraparam6
       *
       * @memberof youbora.Plugin.prototype
       */
    getAdExtraparam6: function() {
      return this.options["ad.customDimension.6"];
    },
    /**
       * Returns ad's Extraparam7
       *
       * @memberof youbora.Plugin.prototype
       */
    getAdExtraparam7: function() {
      return this.options["ad.customDimension.7"];
    },
    /**
       * Returns ad's Extraparam8
       *
       * @memberof youbora.Plugin.prototype
       */
    getAdExtraparam8: function() {
      return this.options["ad.customDimension.8"];
    },
    /**
       * Returns ad's Extraparam9
       *
       * @memberof youbora.Plugin.prototype
       */
    getAdExtraparam9: function() {
      return this.options["ad.customDimension.9"];
    },
    /**
       * Returns ad's Extraparam10
       *
       * @memberof youbora.Plugin.prototype
       */
    getAdExtraparam10: function() {
      return this.options["ad.customDimension.10"];
    },
    /**
       * Returns PluginInfo
       *
       * @memberof youbora.Plugin.prototype
       */
    getPluginInfo: function() {
      var i = {
        lib: e,
        adapter: this.getAdapterVersion(),
        adAdapter: this.getAdAdapterVersion()
      };
      return i;
    },
    /**
       * Returns Ip
       *
       * @memberof youbora.Plugin.prototype
       */
    getIp: function() {
      return this.options["network.ip"];
    },
    /**
       * Returns Isp
       *
       * @memberof youbora.Plugin.prototype
       */
    getIsp: function() {
      return this.options["network.isp"];
    },
    /**
       * Returns ConnectionType
       *
       * @memberof youbora.Plugin.prototype
       */
    getConnectionType: function() {
      return this.options["network.connectionType"];
    },
    /** Returns deviceInfo json
       *
       * @memberof youbora.Plugin.prototype
       */
    getDeviceInfo: function() {
      var i = {};
      return this.getDeviceCode() && (i.deviceCode = this.getDeviceCode()), this.getModel() && (i.model = this.getModel()), this.getBrand() && (i.brand = this.getBrand()), this.getDeviceType() && (i.deviceType = this.getDeviceType()), this.getDeviceName() && (i.deviceName = this.getDeviceName()), this.getOsName() && (i.osName = this.getOsName()), this.getOsVersion() && (i.osVersion = this.getOsVersion()), this.getBrowserName() && (i.browserName = this.getBrowserName()), this.getBrowserVersion() && (i.browserVersion = this.getBrowserVersion()), this.getBrowserType() && (i.browserType = this.getBrowserType()), this.getBrowserEngine() && (i.browserEngine = this.getBrowserEngine()), i !== {} ? i : null;
    },
    /** Returns EDID object
     *
     * @memberof youbora.Plugin.prototype
     */
    getEDID: function() {
      var i = this.options["device.EDID"];
      return i ? i.toString() : null;
    },
    /**
       * Returns DeviceCode
       *
       * @memberof youbora.Plugin.prototype
       */
    getDeviceCode: function() {
      return this.options["device.code"];
    },
    /**
       * Returns Device model
       *
       * @memberof youbora.Plugin.prototype
       */
    getModel: function() {
      return this.options["device.model"];
    },
    /**
       * Returns Device brand
       *
       * @memberof youbora.Plugin.prototype
       */
    getBrand: function() {
      return this.options["device.brand"];
    },
    /**
       * Returns Device type
       *
       * @memberof youbora.Plugin.prototype
       */
    getDeviceType: function() {
      return this.options["device.type"];
    },
    /**
       * Returns Device name
       *
       * @memberof youbora.Plugin.prototype
       */
    getDeviceName: function() {
      return this.options["device.name"];
    },
    /**
       * Returns Device OS name
       *
       * @memberof youbora.Plugin.prototype
       */
    getOsName: function() {
      return this.options["device.osName"];
    },
    /**
       * Returns Device OS Version
       *
       * @memberof youbora.Plugin.prototype
       */
    getOsVersion: function() {
      return this.options["device.osVersion"];
    },
    /**
       * Returns Device browser name
       *
       * @memberof youbora.Plugin.prototype
       */
    getBrowserName: function() {
      return this.options["device.browserName"];
    },
    /**
       * Returns Device browser version
       *
       * @memberof youbora.Plugin.prototype
       */
    getBrowserVersion: function() {
      return this.options["device.browserVersion"];
    },
    /**
       * Returns Device browser type
       *
       * @memberof youbora.Plugin.prototype
       */
    getBrowserType: function() {
      return this.options["device.browserType"];
    },
    /**
       * Returns DeviceCode
       *
       * @memberof youbora.Plugin.prototype
       */
    getBrowserEngine: function() {
      return this.options["device.browserEngine"];
    },
    /**
       * Returns AccountCode
       *
       * @memberof youbora.Plugin.prototype
       */
    getAccountCode: function() {
      return this.options.accountCode;
    },
    /**
       * Returns Username
       *
       * @memberof youbora.Plugin.prototype
       */
    getUsername: function() {
      return this.options["user.name"];
    },
    /**
       * Returns AnonymousUser
       *
       * @memberof youbora.Plugin.prototype
       */
    getAnonymousUser: function() {
      return this.options["user.anonymousId"];
    },
    /**
       * Returns user email
       *
       * @memberof youbora.Plugin.prototype
       */
    getEmail: function() {
      return this.options["user.email"];
    },
    /**
       * Get URL referer.
       *
       * @memberof youbora.Plugin.prototype
       */
    getReferer: function() {
      var i = this.options.referer || "";
      return !i && typeof window < "u" && window.location && (i = window.location.href), i;
    },
    /**
       * Get URL referral.
       * Previous page url.
       * @memberof youbora.Plugin.prototype
       */
    getReferral: function() {
      var i = this.options.referral || "";
      return !i && typeof document < "u" && (i = document.referrer), i;
    },
    /**
       * Get Browser language
       *
       * @memberof youbora.Plugin.prototype
       */
    getLanguage: function() {
      var i = null;
      return typeof navigator < "u" && (i = navigator.language), i;
    },
    /**
     * Get Screen resolution
     *
     * @memberof npaw.Plugin.prototype
     */
    getScreenResolution: function() {
      var i = null;
      try {
        if (window && window.screen) {
          var a = window.devicePixelRatio || 1;
          i = window.screen.width * a + "x" + window.screen.height * a;
        }
      } catch {
      }
      return i;
    },
    /**
       * Returns the nodehost
       *
       * @memberof youbora.Plugin.prototype
       */
    getNodeHost: function() {
      return this.options["content.cdnNode"] || this.resourceTransform.getNodeHost();
    },
    /**
       * Returns the node type id
       *
       * @memberof youbora.Plugin.prototype
       */
    getNodeType: function() {
      return this.options["content.cdnType"] || this.resourceTransform.getNodeType();
    },
    /**
       * Returns the node type string
       *
       * @memberof youbora.Plugin.prototype
       */
    getNodeTypeString: function() {
      return this.resourceTransform.getNodeTypeString();
    },
    /**
       * Returns requestNumber value, to prevent /data calls being cached
       *
       * @memberof youbora.Plugin.prototype
       */
    getRequestNumber: function() {
      return Math.random();
    },
    /**
       * Returns a whole offline view and its id.
       *
       * @memberof youbora.Plugin.prototype
       */
    getOfflineView: function() {
      var i = null;
      return this.offlineStorage && (i = this.offlineStorage.getView()), i;
    },
    getDeviceUUID: function() {
      var i = null;
      return this.options["device.isAnonymous"] || (i = this.options["device.id"] || this.uuidGenerator.getKey()), i;
    },
    getSmartswitchConfigCode: function() {
      return this.options["smartswitch.configCode"];
    },
    getSmartswitchGroupCode: function() {
      return this.options["smartswitch.groupCode"];
    },
    getSmartswitchContractCode: function() {
      return this.options["smartswitch.contractCode"];
    },
    getAppName: function() {
      return this.options["app.name"];
    },
    getAppReleaseVersion: function() {
      return this.options["app.releaseVersion"];
    },
    getIsBlocked: function() {
      return this.options["ad.blockerDetected"];
    },
    isMethodPostEnabled: function() {
      return this.options.method && this.options.method.toLowerCase() === r.POST;
    },
    getPlayheadMonitorEnabled: function() {
      return this.options["playhead.monitor"];
    },
    getReadyStateMonitorEnabled: function() {
      return this.options["readyState.monitor"];
    }
  };
  return xd = n, xd;
}
var Cd, Jg;
function WL() {
  if (Jg)
    return Cd;
  Jg = 1;
  var t = bt, e = li, r = Zu, n = il, i = P_, a = {
    /**
         * Returns content's playhead
         *
         * @memberof youbora.Plugin.prototype
         */
    getPlayhead: function() {
      var s = this._safeGetterAdapter("getPlayhead");
      return e.parseNumber(s, 0);
    },
    /**
         * Returns content's PlayRate
         *
         * @memberof youbora.Plugin.prototype
         */
    getPlayrate: function() {
      var s = 0;
      if (this._adapter && this._adapter.flags && !this._adapter.flags.isPaused)
        try {
          s = this._adapter.getPlayrate();
        } catch (o) {
          t.warn("An error occured while calling getPlayrate", o);
        }
      return s;
    },
    /**
         * Returns content's FramesPerSecond
         *
         * @memberof youbora.Plugin.prototype
         */
    getFramesPerSecond: function() {
      return this._safeGetterAdapter("getFramesPerSecond", "content.fps");
    },
    /**
     * Returns content's segment duration
     *
     * @memberof youbora.Plugin.prototype
     */
    getSegmentDuration: function() {
      return this.hybridNetwork.getSegmentDuration() || this._safeGetterAdapter("getSegmentDuration", "content.segmentDuration");
    },
    /**
         * Returns content's DroppedFrames
         *
         * @memberof youbora.Plugin.prototype
         */
    getDroppedFrames: function() {
      var s = this._safeGetterAdapter("getDroppedFrames");
      return s || (s = this.getWebkitDroppedFrames()), e.parseNumber(s, 0);
    },
    /**
         * Returns dropped frames as per webkitDroppedFrameCount
         *
         * @returns {number}
         *
         * @memberof youbora.Plugin.prototype
         */
    getWebkitDroppedFrames: function() {
      return this._adapter && this._adapter.tag && this._adapter.tag.webkitDroppedFrameCount ? this._adapter.tag.webkitDroppedFrameCount : null;
    },
    /**
         * Returns content's Duration
         *
         * @memberof youbora.Plugin.prototype
         */
    getDuration: function() {
      var s = this._safeGetterAdapter("getDuration", "content.duration") || null;
      return e.parseNumber(Math.round(s), null);
    },
    /**
         * Returns content's Bitrate
         *
         * @memberof youbora.Plugin.prototype
         */
    getBitrate: function() {
      var s = this._safeGetterAdapter("getBitrate", "content.bitrate");
      return (!s || s === -1) && (s = this.getWebkitBitrate()), e.parseNumber(s, -1);
    },
    /**
         * Returns content's total bytes downloaded
         *
         * @memberof youbora.Plugin.prototype
         */
    getTotalBytes: function() {
      return this.options["content.sendTotalBytes"] ? this._safeGetterAdapter("getTotalBytes", "content.totalBytes") : null;
    },
    /**
         * Returns bitrate as per webkitVideoDecodedByteCount
         *
         * @param {Object} tag Video tag DOM reference.
         * @returns {number}
         *
         * @memberof youbora.Plugin.prototype
         */
    getWebkitBitrate: function() {
      if (this._adapter && this._adapter.tag && this._adapter.tag.webkitVideoDecodedByteCount) {
        var s = this._adapter.tag.webkitVideoDecodedByteCount;
        if (this._lastWebkitBitrate) {
          var o = this._adapter.tag.webkitVideoDecodedByteCount - this._lastWebkitBitrate;
          s = Math.round(o / this.viewTransform.response.pingTime * 8);
        }
        return this._lastWebkitBitrate = this._adapter.tag.webkitVideoDecodedByteCount, s !== 0 ? s : -1;
      }
    },
    /**
         * Returns content's Throughput
         *
         * @memberof youbora.Plugin.prototype
         */
    getThroughput: function() {
      var s = this._safeGetterAdapter("getThroughput", "content.throughput");
      return e.parseNumber(s, -1);
    },
    /**
         * Returns content's Rendition
         *
         * @memberof youbora.Plugin.prototype
         */
    getRendition: function() {
      return this._safeGetterAdapter("getRendition", "content.rendition");
    },
    /**
         * Returns content's Title
         *
         * @memberof youbora.Plugin.prototype
         */
    getTitle: function() {
      return this._safeGetterAdapter("getTitle", "content.title");
    },
    /**
         * Returns content's Title2
         *
         * @memberof youbora.Plugin.prototype
         */
    getTitle2: function() {
      return this._safeGetterAdapter("getTitle2", "content.program");
    },
    /**
         * Returns content's IsLive
         *
         * @memberof youbora.Plugin.prototype
         */
    getIsLive: function() {
      var s = this.options["content.isLive"];
      return !s && s !== !1 && (s = this._safeGetterAdapter("getIsLive") || !1), s;
    },
    /**
         * Returns content's Resource after being parsed by the resourceTransform
         *
         * @memberof youbora.Plugin.prototype
         */
    getResource: function() {
      return this._safeGetterAdapter("getResource", "content.resource");
    },
    getParsedResource: function() {
      var s = null;
      return this.resourceTransform.isBlocking() || (s = this.resourceTransform.getResource()), s = s || this._safeGetterAdapter("getURLToParse"), s === this.getResource() ? null : s;
    },
    /**
         * Returns content's TransactionCode
         *
         * @memberof youbora.Plugin.prototype
         */
    getTransactionCode: function() {
      return this.options["content.transactionCode"];
    },
    /**
         * Returns content's Metadata
         *
         * @memberof youbora.Plugin.prototype
         */
    getMetadata: function() {
      return this.options["content.metadata"];
    },
    /**
         * Returns content's PlayerVersion
         *
         * @memberof youbora.Plugin.prototype
         */
    getPlayerVersion: function() {
      return this._safeGetterAdapter("getPlayerVersion") || "";
    },
    /**
         * Returns content's PlayerName
         *
         * @memberof youbora.Plugin.prototype
         */
    getPlayerName: function() {
      return this._safeGetterAdapter("getPlayerName") || "";
    },
    /**
         * Returns content's Cdn
         *
         * @memberof youbora.Plugin.prototype
         */
    getCdn: function() {
      var s = null;
      return this.resourceTransform.isBlocking() || (s = this.resourceTransform.getCdnName()), s || this.options["content.cdn"];
    },
    /**
         * Returns content's PluginVersion
         *
         * @memberof youbora.Plugin.prototype
         */
    getPluginVersion: function() {
      var s = this.getAdapterVersion();
      return s || (s = r + "-adapterless-js"), s;
    },
    /**
         * Returns content's PluginVersion
         *
         * @memberof youbora.Plugin.prototype
         */
    getLibVersion: function() {
      return r;
    },
    /**
         * Returns ads adapter getVersion or null
         *
         * @memberof youbora.Plugin.prototype
         */
    getAdapterVersion: function() {
      return this._safeGetterAdapter("getVersion");
    },
    /**
         * Returns cdn traffic received in bytes or null
         *
         * @memberof youbora.Plugin.prototype
         */
    getCdnTraffic: function() {
      return this._safeGetterAdapter("getCdnTraffic") || this.hybridNetwork.getCdnTraffic();
    },
    /**
     * Returns multi cdn traffic received in bytes or null
     *
     * @memberof youbora.Plugin.prototype
     */
    getMultiCdnInfo: function() {
      return this.hybridNetwork.getMultiCdnInfo();
    },
    /**
     * Returns cdn balancer response id
     *
     * @memberof youbora.Plugin.prototype
     */
    getBalancerResponseId: function() {
      return this.hybridNetwork.getBalancerResponseId();
    },
    /**
         * Returns p2p traffic received in bytes or null
         *
         * @memberof youbora.Plugin.prototype
         */
    getP2PTraffic: function() {
      return this._safeGetterAdapter("getP2PTraffic") || this.hybridNetwork.getP2PTraffic();
    },
    /**
         * Returns p2p traffic sent in bytes or null
         *
         * @memberof youbora.Plugin.prototype
         */
    getUploadTraffic: function() {
      return this._safeGetterAdapter("getUploadTraffic") || this.hybridNetwork.getUploadTraffic();
    },
    /**
         * Returns if p2p plugin is enabled or null
         *
         * @memberof youbora.Plugin.prototype
         */
    getIsP2PEnabled: function() {
      return this._safeGetterAdapter("getIsP2PEnabled") || this.hybridNetwork.getIsP2PEnabled();
    },
    /** Returns streaming protocol (DASH, HLS, HDS...) */
    getStreamingProtocol: function() {
      var s = this.options["content.streamingProtocol"];
      if (s) {
        for (var o in i)
          if (i[o] === s)
            return s;
      }
      return null;
    },
    /** Returns transport format (TS, MP4) */
    getTransportFormat: function() {
      var s = this.options["content.transportFormat"];
      if (!s && this.options["parse.manifest"] && !this.resourceTransform.isBlocking() && (s = this.resourceTransform.getTransportFormat()), s) {
        for (var o in n)
          if (n[o] === s)
            return s;
      }
      return null;
    },
    /** Returns household id */
    getHouseholdId: function() {
      return this._safeGetterAdapter("getHouseholdId");
    },
    /**
         * Returns latency of a live video, or null
         *
         * @memberof youbora.Plugin.prototype
         */
    getLatency: function() {
      return this.getIsLive() ? this._safeGetterAdapter("getLatency") : null;
    },
    /**
         * Returns the amount of packets lost, or null
         *
         * @memberof youbora.Plugin.prototype
         */
    getPacketLoss: function() {
      return this._safeGetterAdapter("getPacketLoss");
    },
    /**
         * Returns the amount of packets sent, or null
         *
         * @memberof youbora.Plugin.prototype
         */
    getPacketSent: function() {
      return this._safeGetterAdapter("getPacketSent");
    },
    /**
         * Returns a json with the metrics to be reported in pings when changed
         *
         * @memberof youbora.Plugin.prototype
         */
    getVideoMetrics: function() {
      return e.getMetricsFrom(this._adapter ? this._adapter.getMetrics() : null, this.options["content.metrics"]);
    },
    getPlayerStartupTime: function() {
      return this.browserLoadTimes.getPlayerStartupTime();
    },
    // ----------------------------------------- CHRONOS ------------------------------------------
    /**
         * Returns JoinDuration chrono delta time
         *
         * @memberof youbora.Plugin.prototype
         */
    getJoinDuration: function() {
      return this._adapter ? this._adapter.chronos.join.getDeltaTime(!1) : -1;
    },
    /**
         * Returns BufferDuration chrono delta time
         *
         * @memberof youbora.Plugin.prototype
         */
    getBufferDuration: function() {
      return this._adapter ? this._adapter.chronos.buffer.getDeltaTime(!1) : -1;
    },
    /**
         * Returns SeekDuration chrono delta time
         *
         * @memberof youbora.Plugin.prototype
         */
    getSeekDuration: function() {
      return this._adapter ? this._adapter.chronos.seek.getDeltaTime(!1) : -1;
    },
    /**
         * Returns pauseDuration chrono delta time
         *
         * @memberof youbora.Plugin.prototype
         */
    getPauseDuration: function() {
      return this._adapter ? this._adapter.chronos.pause.getDeltaTime(!1) : 0;
    },
    /**
         * Returns content's package
         *
         * @memberof youbora.Plugin.prototype
         */
    getPackage: function() {
      return this.options["content.package"];
    },
    /**
         * Returns content's saga
         *
         * @memberof youbora.Plugin.prototype
         */
    getSaga: function() {
      return this.options["content.saga"];
    },
    /**
         * Returns content's tv show
         *
         * @memberof youbora.Plugin.prototype
         */
    getTvShow: function() {
      return this.options["content.tvShow"];
    },
    /**
         * Returns content's season
         *
         * @memberof youbora.Plugin.prototype
         */
    getSeason: function() {
      return this.options["content.season"];
    },
    /**
         * Returns content's episode title
         *
         * @memberof youbora.Plugin.prototype
         */
    getEpisodeTitle: function() {
      return this.options["content.episodeTitle"];
    },
    /**
         * Returns content's channel
         *
         * @memberof youbora.Plugin.prototype
         */
    getChannel: function() {
      return this.options["content.channel"];
    },
    /**
         * Returns content's id
         *
         * @memberof youbora.Plugin.prototype
         */
    getID: function() {
      return this.options["content.id"];
    },
    /**
         * Returns content's IMDB id
         *
         * @memberof youbora.Plugin.prototype
         */
    getImdbId: function() {
      return this.options["content.imdbId"];
    },
    /**
         * Returns content's gracenote id
         *
         * @memberof youbora.Plugin.prototype
         */
    getGracenoteID: function() {
      return this.options["content.gracenoteId"];
    },
    /**
         * Returns content's type
         *
         * @memberof youbora.Plugin.prototype
         */
    getType: function() {
      return this.options["content.type"];
    },
    /**
         * Returns content's genre
         *
         * @memberof youbora.Plugin.prototype
         */
    getGenre: function() {
      return this.options["content.genre"];
    },
    /**
         * Returns content's language
         *
         * @memberof youbora.Plugin.prototype
         */
    getVideoLanguage: function() {
      return this.options["content.language"];
    },
    /**
         * Returns content's subtitles
         *
         * @memberof youbora.Plugin.prototype
         */
    getSubtitles: function() {
      return this.options["content.subtitles"];
    },
    /**
         * Returns content's contracted resolution
         *
         * @memberof youbora.Plugin.prototype
         */
    getContractedResolution: function() {
      return this.options["content.contractedResolution"];
    },
    /**
         * Returns content's cost
         *
         * @memberof youbora.Plugin.prototype
         */
    getCost: function() {
      return this.options["content.cost"];
    },
    /**
         * Returns content's price
         *
         * @memberof youbora.Plugin.prototype
         */
    getPrice: function() {
      return this.options["content.price"];
    },
    /**
         * Returns content's playback type
         *
         * @memberof youbora.Plugin.prototype
         */
    getPlaybackType: function() {
      var s = this.options["content.playbackType"];
      if (!s) {
        var o = this.options["content.isLive"];
        typeof o != "boolean" && (o = this._safeGetterAdapter("getIsLive")), typeof o == "boolean" && (s = o ? "Live" : "VoD");
      }
      return s;
    },
    /**
         * Returns content's DRM
         *
         * @memberof youbora.Plugin.prototype
         */
    getDRM: function() {
      return this.options["content.drm"];
    },
    /**
         * Returns content's video codec
         *
         * @memberof youbora.Plugin.prototype
         */
    getVideoCodec: function() {
      return this._safeGetterAdapter("getVideoCodec", "content.encoding.videoCodec");
    },
    /**
         * Returns content's audio codec
         *
         * @memberof youbora.Plugin.prototype
         */
    getAudioCodec: function() {
      return this._safeGetterAdapter("getAudioCodec", "content.encoding.audioCodec");
    },
    /**
         * Returns content's codec settings
         *
         * @memberof youbora.Plugin.prototype
         */
    getCodecSettings: function() {
      return this.options["content.encoding.codecSettings"];
    },
    /**
         * Returns content's codec profile
         *
         * @memberof youbora.Plugin.prototype
         */
    getCodecProfile: function() {
      return this.options["content.encoding.codecProfile"];
    },
    /**
         * Returns content's container format
         *
         * @memberof youbora.Plugin.prototype
         */
    getContainerFormat: function() {
      return this.options["content.encoding.containerFormat"];
    },
    /**
       * Returns linked view id string
       *
       * @memberof youbora.Plugin.prototype
       */
    getLinkedViewId: function() {
      return this.options.linkedViewId;
    },
    _safeGetterAdapter: function(s, o) {
      var u = null;
      if (o && this.options[o])
        u = this.options[o];
      else
        try {
          this._adapter && typeof this._adapter[s] == "function" && (u = this._adapter[s]());
        } catch (l) {
          t.warn("An error occured while calling " + s, l);
        }
      return u;
    }
  };
  return Cd = a, Cd;
}
var Ad, Zg;
function qL() {
  if (Zg)
    return Ad;
  Zg = 1;
  var t = bt, e = Wi, r = Tf, n = li, i = {
    /**
       * Returns current adapter or null.
       *
       * @returns {Adapter}
       *
       * @memberof youbora.Plugin.prototype
       */
    getAdsAdapter: function() {
      return this._adsAdapter;
    },
    /**
       * Sets an adapter for ads.
       *
       * @param {Adapter} adsAdapter
       *
       * @memberof youbora.Plugin.prototype
       */
    setAdsAdapter: function(a) {
      if (a.plugin)
        t.warn("Adapters can only be added to a single plugin");
      else {
        this.removeAdsAdapter(), a.plugin = this, this._adsAdapter = a, a.setIsAds(!0), this.adsAdapterListeners = {}, this.adsAdapterListeners[r.Event.START] = this._adStartListener.bind(this), this.adsAdapterListeners[r.Event.JOIN] = this._adJoinListener.bind(this), this.adsAdapterListeners[r.Event.PAUSE] = this._adPauseListener.bind(this), this.adsAdapterListeners[r.Event.RESUME] = this._adResumeListener.bind(this), this.adsAdapterListeners[r.Event.BUFFER_BEGIN] = this._adBufferBeginListener.bind(this), this.adsAdapterListeners[r.Event.BUFFER_END] = this._adBufferEndListener.bind(this), this.adsAdapterListeners[r.Event.STOP] = this._adStopListener.bind(this), this.adsAdapterListeners[r.Event.ERROR] = this._adErrorListener.bind(this), this.adsAdapterListeners[r.Event.CLICK] = this._adClickListener.bind(this), this.adsAdapterListeners[r.Event.MANIFEST] = this._adManifestListener.bind(this), this.adsAdapterListeners[r.Event.PODSTART] = this._adBreakStartListener.bind(this), this.adsAdapterListeners[r.Event.PODSTOP] = this._adBreakStopListener.bind(this), this.adsAdapterListeners[r.Event.QUARTILE] = this._adQuartileListener.bind(this);
        for (var s in this.adsAdapterListeners)
          this._adsAdapter.on(s, this.adsAdapterListeners[s]);
      }
    },
    /**
       * Removes the current adapter. Fires stop if needed. Calls adapter.dispose()
       *
       * @memberof youbora.Plugin.prototype
       */
    removeAdsAdapter: function() {
      if (this._adsAdapter) {
        if (this._adsAdapter.dispose(), this._adsAdapter.plugin = null, this.adsAdapterListeners) {
          for (var a in this.adsAdapterListeners)
            this._adsAdapter.off(a, this.adsAdapterListeners[a]);
          delete this.adsAdapterListeners;
        }
        this.resizeScrollDetector.stopDetection(), this._adsAdapter = null;
      }
    },
    // ---------------------------------------- LISTENERS -----------------------------------------
    _adStartListener: function(a) {
      this._adapter ? (this._adapter.fireBufferEnd(null, "adStartListener"), this._adapter.fireSeekEnd(null, "adStartListener"), !this.isInitiated && !this._adapter.flags.isStarted && this._adapter.fireStart(), this._adapter.flags.isPaused && this._adapter.chronos.pause.reset()) : this.fireInit(), this._adsAdapter && (this._adsAdapter.chronos.viewedMax = []);
      var s = a.data.params || {};
      s.adNumber = this.requestBuilder.getNewAdNumber();
      var o = (this.getAdResource() || this.getAdTitle()) && typeof this.getAdDuration() == "number";
      o ? (this.adStartSent = !0, this._adsAdapter.fireManifest(), this._adsAdapter.fireBreakStart(), s.adNumberInBreak = this.requestBuilder.getNewAdNumberInBreak(), this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_START, e.Service.AD_START, s)) : (this.adInitSent = !0, s.adNumberInBreak = this.requestBuilder.getNewAdNumberInBreak(), this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_INIT, e.Service.AD_INIT, s));
    },
    _adJoinListener: function(a) {
      var s = {};
      n.assign(s, a.data.params || {}), this.adInitSent && !this.adStartSent && (this._adsAdapter.fireManifest(), this._adsAdapter.fireBreakStart(), this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_START, e.Service.AD_START, s)), this._adsAdapter.startChronoView(), this.adConnected && (this._adsAdapter.chronos.join.startTime = this.adConnectedTime, this._adsAdapter.chronos.total.startTime = this.adConnectedTime, this.adConnectedTime = 0, this.adConnected = !1), s = a.data.params || {}, this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_JOIN, e.Service.AD_JOIN, s), this.adInitSent = !1, this.adStartSent = !1;
    },
    _adPauseListener: function(a) {
      var s = a.data.params || {};
      this._adsAdapter.stopChronoView(), this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_PAUSE, e.Service.AD_PAUSE, s);
    },
    _adResumeListener: function(a) {
      var s = a.data.params || {};
      this._adsAdapter.startChronoView(), this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_RESUME, e.Service.AD_RESUME, s);
    },
    _adBufferBeginListener: function(a) {
      t.notice("Ad Buffer Begin"), this._adsAdapter.stopChronoView(), this._adsAdapter && this._adsAdapter.flags.isPaused && this._adsAdapter.chronos.pause.reset();
    },
    _adBufferEndListener: function(a) {
      var s = a.data.params || {};
      this._adsAdapter.startChronoView(), this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_BUFFER, e.Service.AD_BUFFER, s);
    },
    _adStopListener: function(a) {
      this._adsAdapter.stopChronoView(), this._adsAdapter.flags.reset(), this._totalPrerollsTime = (this._totalPrerollsTime || 0) + this._adsAdapter.chronos.total.getDeltaTime();
      var s = a.data.params || {};
      if (s.position = this.requestBuilder.lastSent.position, this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_STOP, e.Service.AD_STOP, s), this.requestBuilder.lastSent.position === e.AdPosition.Postroll) {
        var o = this.options["ad.expectedPattern"];
        this.playedPostrolls++, (this.requestBuilder.lastSent.givenAds && this.requestBuilder.lastSent.givenAds <= this.playedPostrolls || // Or if we have expected (and not given!) and this was the last expected one
        !this.requestBuilder.lastSent.givenAds && o && o.post && o.post[0] && o.post[0] <= this.playedPostrolls) && this.fireStop();
      }
      this.adConnected = !0, this.adConnectedTime = (/* @__PURE__ */ new Date()).getTime();
    },
    _adErrorListener: function(a) {
      var s = a.data.params || {};
      if (this._adapter && !this._adapter.flags.isStarted && !this.isInitiated)
        return this._savedAdError = a, null;
      if (this._blockAdError(a.data.params))
        return null;
      this._adsAdapter && (this._adsAdapter.fireManifest(), this._adsAdapter.fireBreakStart()), (!this._adsAdapter || !this._adsAdapter.flags.isStarted) && (s.adNumber = this.requestBuilder.getNewAdNumber(), s.adNumberInBreak = this.requestBuilder.getNewAdNumberInBreak()), this.isBreakStarted || (s.breakNumber = this.requestBuilder.getNewBreakNumber()), this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_ERROR, e.Service.AD_ERROR, s);
    },
    _adSavedError: function() {
      this._savedAdError && (this._adErrorListener(this._savedAdError), this._savedAdError = null);
    },
    _adSavedManifest: function() {
      this._savedAdManifest && (this._adManifestListener(this._savedAdManifest), this._savedAdManifest = null);
    },
    _blockAdError: function(a) {
      var s = Date.now(), o = this._lastAdErrorParams && this._lastAdErrorParams.errorCode === a.errorCode && this._lastAdErrorParams.msg === a.msg && this._lastAdErrorParams.adCreativeId === this.getAdCreativeId();
      return o && this._lastAdErrorTime + 5e3 > s ? (this._lastAdErrorTime = s, !0) : (this._lastAdErrorTime = s, this._lastAdErrorParams = a, !1);
    },
    _adClickListener: function(a) {
      var s = a.data.params || {};
      this._adsAdapter.stopChronoView(), this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_CLICK, e.Service.AD_CLICK, s);
    },
    _adManifestListener: function(a) {
      if (!this.isAdsManifestSent) {
        if (this._adapter && !this._adapter.flags.isStarted && !this.isInitiated)
          return this._savedAdManifest = a, null;
        var s = a.data.params || {};
        this.isAdsManifestSent = !0, this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_MANIFEST, e.Service.AD_MANIFEST, s);
      }
    },
    _adBreakStartListener: function(a) {
      if (!this.isBreakStarted) {
        this.isBreakStarted = !0, this._adapter && this._adapter.firePause();
        var s = a.data.params || {};
        s.breakNumber = this.requestBuilder.getNewBreakNumber(), this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_POD_START, e.Service.AD_POD_START, s), this.adConnected = !1;
      }
    },
    _adBreakStopListener: function(a) {
      if (this.isBreakStarted) {
        this.isBreakStarted = !1;
        var s = a.data.params || {};
        s.position = this.requestBuilder.lastSent.position, this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_POD_STOP, e.Service.AD_POD_STOP, s), this.adConnected = !1, this._adapter && this._adapter.fireResume();
      }
    },
    _adQuartileListener: function(a) {
      var s = a.data.params || {};
      s.quartile && this._sendAdEventIfAllowed(e.WillSendEvent.WILL_SEND_AD_QUARTILE, e.Service.AD_QUARTILE, s);
    },
    _sendAdEventIfAllowed: function(a, s, o) {
      this.options["ad.ignore"] || this._send(a, s, o), t.notice(s);
    }
  };
  return Ad = i, Ad;
}
var wd, em;
function $L() {
  if (em)
    return wd;
  em = 1;
  var t = bt, e = li, r = Wi, n = {
    /**
     * Returns ads's PlayerVersion
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdPlayerVersion: function() {
      return this._safeGetterAdsAdapter("getPlayerVersion") || "";
    },
    /**
     * Returns ad's position
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdPosition: function() {
      var i = r.AdPosition.Preroll;
      if (this._adsAdapter)
        try {
          var a = this._adsAdapter.getPosition();
          (r.AdPosition.Preroll === a || r.AdPosition.Midroll === a || r.AdPosition.Postroll === a) && (i = a);
        } catch (s) {
          t.warn("An error occured while calling getAdPosition", s);
        }
      return !i && this._adapter && (i = this._adapter.flags.isJoined ? r.AdPosition.Midroll : r.AdPosition.Preroll), i;
    },
    getAdNumber: function() {
      return this.requestBuilder.lastSent.adNumber || 0;
    },
    getAdNumberInBreak: function() {
      return this.requestBuilder.lastSent.adNumberInBreak || 0;
    },
    getBreakNumber: function() {
      return this.requestBuilder.lastSent.breakNumber || 0;
    },
    /**
     * Returns ad's AdPlayhead
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdPlayhead: function() {
      var i = this._safeGetterAdsAdapter("getPlayhead");
      return e.parseNumber(i, 0);
    },
    /**
     * Returns ad's AdDuration
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdDuration: function() {
      var i = this._safeGetterAdsAdapter("getDuration", "ad.duration");
      return e.parseNumber(i, 0);
    },
    /**
     * Returns ad's AdBitrate
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdBitrate: function() {
      var i = this._safeGetterAdsAdapter("getBitrate");
      return (!i || i === -1) && (i = this.getWebkitAdBitrate()), e.parseNumber(i, -1);
    },
    /**
     * Returns bitrate as per webkitVideoDecodedByteCount
     *
     * @param {Object} tag Video tag DOM reference.
     * @returns {number}
     *
     * @memberof youbora.Plugin.prototype
     */
    getWebkitAdBitrate: function() {
      if (this._adsAdapter && this._adsAdapter.tag && this._adsAdapter.tag.webkitVideoDecodedByteCount) {
        var i = this._adsAdapter.tag.webkitVideoDecodedByteCount;
        if (this._lastWebkitAdBitrate) {
          var a = this._adsAdapter.tag.webkitVideoDecodedByteCount - this._lastWebkitAdBitrate;
          i = Math.round(a / this.viewTransform.response.pingTime * 8);
        }
        return this._lastWebkitAdBitrate = this._adsAdapter.tag.webkitVideoDecodedByteCount, i !== 0 ? i : -1;
      }
    },
    /**
     * Returns ad's AdTitle
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdTitle: function() {
      return this._safeGetterAdsAdapter("getTitle", "ad.title");
    },
    /**
     * Returns ad's AdResource
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdResource: function() {
      return this._safeGetterAdsAdapter("getResource", "ad.resource");
    },
    /**
     * Returns ad's campaign
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdCampaign: function() {
      return this._safeGetterAdsAdapter("getCampaign", "ad.campaign");
    },
    /**
    * Returns ad's campaign
    *
    * @memberof youbora.Plugin.prototype
    */
    getAdCreativeId: function() {
      return this._safeGetterAdsAdapter("getCreativeId", "ad.creativeId");
    },
    /**
    * Returns ad's provider
    *
    * @memberof youbora.Plugin.prototype
    */
    getAdProvider: function() {
      return this._safeGetterAdsAdapter("getProvider", "ad.provider");
    },
    /**
     * Returns ads adapter getVersion or null
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdAdapterVersion: function() {
      return this._safeGetterAdsAdapter("getVersion");
    },
    /**
     * Returns ad's AdMetadata
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdMetadata: function() {
      return this.options["ad.metadata"];
    },
    /**
     * Returns the type of ad insertion (clientside, serverside)
     * @returns {string} ad insertion type
     */
    getAdInsertionType: function() {
      return this._safeGetterAdsAdapter("getAdInsertionType");
    },
    getGivenBreaks: function() {
      return this._safeGetterAdsAdapter("getGivenBreaks", "ad.givenBreaks");
    },
    getExpectedBreaks: function() {
      var i = null, a = this.options["ad.expectedBreaks"], s = this.options["ad.expectedPattern"];
      if (a)
        i = a;
      else if (s)
        i = 0, i = s.pre ? s.pre.length : 0, i += s.mid ? s.mid.length : 0, i += s.post ? s.post.length : 0;
      else if (this._adsAdapter)
        try {
          i = this._adsAdapter.getExpectedBreaks();
        } catch (o) {
          t.warn("An error occured while calling expectedBreaks", o);
        }
      return i;
    },
    getExpectedPattern: function() {
      return this._safeGetterAdsAdapter("getExpectedPattern", "ad.expectedPattern");
    },
    getBreaksTime: function() {
      return this._safeGetterAdsAdapter("getBreaksTime", "ad.breaksTime");
    },
    getGivenAds: function() {
      return this._safeGetterAdsAdapter("getGivenAds", "ad.givenAds");
    },
    getExpectedAds: function() {
      var i = null;
      try {
        if (this._adsAdapter) {
          var a = this.options["ad.expectedPattern"];
          if (a && this.getAdPosition()) {
            var s = [];
            if (a.pre && (s = s.concat(a.pre)), a.mid && (s = s.concat(a.mid)), a.post && (s = s.concat(a.post)), s.length > 0) {
              var o = this.requestBuilder.lastSent.breakNumber;
              o > s.length && (o = s.length), i = s[o - 1];
            }
          } else
            i = this._adsAdapter.getExpectedAds();
        }
      } catch (u) {
        t.warn("An error occured while calling expectedAds", u);
      }
      return i;
    },
    getAdsExpected: function() {
      var i = null;
      try {
        i = this.getExpectedPattern() || this.getGivenAds() || !1;
      } catch (a) {
        t.warn("An error occured while calling givenAds or expectedPattern", a);
      }
      return i;
    },
    // ----------------------------------------- CHRONOS ------------------------------------------
    /**
     * Returns AdJoinDuration chrono delta time
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdJoinDuration: function() {
      return this._adsAdapter ? this._adsAdapter.chronos.join.getDeltaTime(!1) : -1;
    },
    /**
     * Returns AdBufferDuration chrono delta time
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdBufferDuration: function() {
      return this._adsAdapter ? this._adsAdapter.chronos.buffer.getDeltaTime(!1) : -1;
    },
    /**
     * Returns AdPauseDuration chrono delta time
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdPauseDuration: function() {
      return this._adsAdapter ? this._adsAdapter.chronos.pause.getDeltaTime(!1) : 0;
    },
    /**
     * Returns total totalAdDuration chrono delta time
     *
     * @memberof youbora.Plugin.prototype
     */
    getAdTotalDuration: function() {
      return this._adsAdapter ? this._adsAdapter.chronos.total.getDeltaTime(!1) : -1;
    },
    getAdViewedDuration: function() {
      return this._getTimeMaxOrAcum(!0);
    },
    getAdViewability: function() {
      return this._getTimeMaxOrAcum();
    },
    _getTimeMaxOrAcum: function(i) {
      var a = 0;
      return this._adsAdapter && this._adsAdapter.chronos.viewedMax.forEach(function(s) {
        i ? a += s.getDeltaTime(!1) : a = Math.max(s.getDeltaTime(!1), a);
      }), a;
    },
    getAudioEnabled: function() {
      return this._safeGetterAdsAdapter("getAudioEnabled");
    },
    getIsSkippable: function() {
      return this._safeGetterAdsAdapter("getIsSkippable");
    },
    getIsFullscreen: function() {
      return this._safeGetterAdsAdapter("getIsFullscreen");
    },
    _safeGetterAdsAdapter: function(i, a) {
      var s = null;
      if (a && this.options[a])
        s = this.options[a];
      else
        try {
          this._adsAdapter && typeof this._adsAdapter[i] == "function" && (s = this._adsAdapter[i]());
        } catch (o) {
          t.warn("An error occured while calling " + i, o);
        }
      return s;
    }
  };
  return wd = n, wd;
}
var Pd, tm;
function zL() {
  if (tm)
    return Pd;
  tm = 1;
  var t = bt, e = Wi, r = {
    /**
     * Starts sending pings.
     *
     * @private
     * @memberof youbora.Plugin.prototype
     */
    _startPings: function() {
      this._ping.isRunning || this._ping.start();
    },
    /**
     * Stops sending pings.
     *
     * @private
     * @memberof youbora.Plugin.prototype
     */
    _stopPings: function() {
      this._ping.stop();
    },
    /**
     * Sends ping request
     *
     * @param {number} diffTime Time since the last ping
     *
     * @private
     * @memberof youbora.Plugin.prototype
     */
    _sendPing: function(n) {
      var i = {
        diffTime: n,
        entities: this.requestBuilder.getChangedEntities()
      };
      this._adapter && (this._adapter.flags.isPaused ? i = this.requestBuilder.fetchParams(i, ["pauseDuration"]) : i = this.requestBuilder.fetchParams(i, ["bitrate", "throughput", "fps"]), this._adapter.flags.isJoined && (i = this.requestBuilder.fetchParams(i, ["playhead"])), this._adapter.flags.isBuffering && (i = this.requestBuilder.fetchParams(i, ["bufferDuration"])), this._adapter.flags.isSeeking && (i = this.requestBuilder.fetchParams(i, ["seekDuration"]))), this._adsAdapter && !this.options["ad.ignore"] && (this._adsAdapter.flags.isStarted && (i = this.requestBuilder.fetchParams(i, ["adPlayhead", "adViewedDuration", "adViewability"]), this._adsAdapter.flags.isPaused ? i = this.requestBuilder.fetchParams(i, ["adPauseDuration"]) : i = this.requestBuilder.fetchParams(i, ["adBitrate"])), this._adsAdapter.flags.isBuffering && (i = this.requestBuilder.fetchParams(i, ["adBufferDuration"]))), this._send(e.WillSendEvent.WILL_SEND_PING, e.Service.PING, i), this.startDelayed && this._retryStart(), t.verbose(e.Service.PING);
    }
  };
  return Pd = r, Pd;
}
var kd, im;
function GL() {
  if (im)
    return kd;
  im = 1;
  var t = bt, e = li, r = Wi, n = Jr, i = {
    /**
     * Sends /init. Should be called once the user has requested the content. Does not need
     * a working adapter or player to work. it won't sent start if isInitiated is true.
     *
     * @param {Object} [params] Object of key:value params.
     * @param {string} [triggeredEvent]
     *
     * @memberof youbora.Plugin.prototype
     */
    fireInit: function(a, s) {
      this.isInitiated || (!this.getAdapter() || this.getAdapter() && !this.getAdapter().flags.isStarted) && (this.viewTransform.nextView(), this._initComm(), this._startPings(), this.initChrono.start(), this.isInitiated = !0, a = a || {}, s && (a.triggeredEvents = [s]), this._send(r.WillSendEvent.WILL_SEND_INIT, r.Service.INIT, a), this._adSavedError(), this._adSavedManifest(), t.notice(r.Service.INIT + " " + (a.title || a.mediaResource)));
    },
    /**
     * Sends /error. Should be used when the error is related to out-of-player errors: like async
     * resource load or player loading errors.
     *
     * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
     * @param {String} [msg] Error Message
     * @param {Object} [metadata] Object defining error metadata
     * @param {String} [level] Level of the error. Currently supports 'error' and 'fatal'
     *
     * @memberof youbora.Plugin.prototype
     */
    fireError: function(a, s, o, u) {
      this.fireInit();
      var l = e.buildErrorParams(a, s, o, u);
      l.code && delete l.code, this._send(r.WillSendEvent.WILL_SEND_ERROR, r.Service.ERROR, l), this._adSavedError(), this._adSavedManifest(), t.notice(
        r.Service.ERROR + " " + l.errorLevel + " " + l.errorCode
      ), l.errorLevel === "fatal" && this.fireStop();
    },
    /**
     * Calls fireErrors and then stops pings.
     *
     * @param {String|Object} [code] Error Code, if an object is sent, it will be treated as params.
     * @param {String} [msg] Error Message
     * @param {Object} [metadata] Object defining error metadata
     *
     * @memberof youbora.Plugin.prototype
     */
    fireFatalError: function(a, s, o, u) {
      this.fireError(a, s, o, u), this.fireStop();
    },
    /**
     * Fires /stop. Should be used to terminate sessions once the player is gone or if
     * plugin.fireError() is called.
     *
     * @param {Object} [params] Object of key:value params.
     *
     * @memberof youbora.Plugin.prototype
     */
    fireStop: function(a) {
      if (this.isInitiated || this.isStarted) {
        this._adapter && (this._adapter.flags.isStopped = !0, this._adapter.monitor && this._adapter.monitor.stop()), this._adsAdapter && this.isBreakStarted && (this._adsAdapter.fireStop(), this._adsAdapter.fireBreakStop()), a = a || {}, this._send(r.WillSendEvent.WILL_SEND_STOP, r.Service.STOP, a);
        var s = this._adapter ? this._adapter.chronos : null;
        s && (s.total.stop(), s.join.reset(), s.pause.reset(), s.buffer.reset(), s.seek.reset()), t.notice(r.Service.STOP + " at " + a.playhead + "s"), this._reset();
      }
    },
    /**
     * Fires /offlineEvents. If offline is disabled, will try to send all the views stored.
     *
     * @param {Object} [params] Object of key:value params.
     *
     * @memberof youbora.Plugin.prototype
     */
    fireOfflineEvents: function(a) {
      this.options && !this.options.offline ? !this.isInitiated && (!this._adapter || !this._adapter.flags.isStarted) && (!this._adsAdapter || !this._adsAdapter.flags.isStarted) ? (this._offlineParams = a, this.viewTransform.response.code && this.viewTransform.response.host ? this._generateAndSendOffline() : (this.offlineReference = this._generateAndSendOffline.bind(this), this.viewTransform.on(n.Event.DONE, this.offlineReference))) : t.error("Adapters have to be stopped") : t.error("To send offline events, offline option must be disabled");
    },
    _generateAndSendOffline: function() {
      if (this.options.disableStorage)
        return null;
      var a = this._offlineParams;
      for (this._initComm(); ; ) {
        var s = this.requestBuilder.buildBody(r.Service.OFFLINE_EVENTS).viewJson;
        if (s[0] === null)
          break;
        var o = this.viewTransform.nextView(), u = s[0].replace(/CODE_PLACEHOLDER/g, o.toString()).replace(/,"sessionId":"SESSION_PLACEHOLDER"/g, "").replace(/,"sessionRoot":"ROOT_PLACEHOLDER"/g, "");
        this._send(
          r.WillSendEvent.WILL_SEND_OFFLINE_EVENTS,
          r.Service.OFFLINE_EVENTS,
          a,
          u,
          "POST",
          function(l, d) {
            this.offlineStorage.removeView(d.offlineId);
          }.bind(this),
          { offlineId: s[1] }
        );
      }
      this.offlineStorage.sent(), this._offlineParams = null;
    }
  };
  return kd = i, kd;
}
var Ld, rm;
function KL() {
  if (rm)
    return Ld;
  rm = 1;
  var t = Wi, e = bt, r = lr, n = li, i = vf, a = {
    _initInfinity: function() {
      this.infinity.on(i.Event.NAV, this._navListener.bind(this)), this.infinity.on(i.Event.SESSION_START, this._sessionStartListener.bind(this)), this.infinity.on(i.Event.SESSION_STOP, this._sessionStopListener.bind(this)), this.infinity.on(i.Event.EVENT, this._eventListener.bind(this));
    },
    _sendInfinity: function(s, o, u) {
      u = this.requestBuilder.buildParams(u, o);
      var l = {
        params: u,
        plugin: this,
        adapter: this.getAdapter(),
        adsAdapter: this.getAdsAdapter()
      };
      if (this.emit(s, l), this.infinity._comm && u !== null && this.options.enabled) {
        this.lastServeiceSent = o;
        var d = new r(null, o, u);
        this.isMethodPostEnabled() && d.setPostRequest(!0), this.infinity._comm.sendRequest(d);
      }
    },
    // ---------------------------------------- LISTENERS -----------------------------------------
    _navListener: function(s) {
      var o = s.data.params || {};
      this._sendInfinity(t.WillSendEvent.WILL_SEND_NAV, t.Service.NAV, o), this._beat.isRunning || this._beat.start(), e.notice(t.Service.NAV + " " + o.route);
    },
    _sessionStartListener: function(s) {
      var o = s.data.params || {};
      this._sendInfinity(
        t.WillSendEvent.WILL_SEND_SESSION_START,
        t.Service.SESSION_START,
        o
      ), this._beat.isRunning || this._beat.start(), e.notice(t.Service.SESSION_START + " " + o.route);
    },
    _sessionStopListener: function(s) {
      var o = s.data.params || {};
      this._sendInfinity(
        t.WillSendEvent.WILL_SEND_SESSION_STOP,
        t.Service.SESSION_STOP,
        o
      ), this._beat.isRunning && this._beat.stop(), e.notice(t.Service.SESSION_STOP + " " + o.route);
    },
    _eventListener: function(s) {
      var o = s.data.params || {};
      this._sendInfinity(t.WillSendEvent.WILL_SEND_EVENT, t.Service.EVENT, o), e.notice(t.Service.EVENT + " " + o.name);
    },
    /**
     * Sends beat request
     *
     * @param {number} diffTime Time since the last ping
     *
     * @private
     * @memberof youbora.Plugin.prototype
     */
    _sendBeat: function(s) {
      var o = {
        diffTime: s
      };
      this._sendInfinity(t.WillSendEvent.WILL_SEND_BEAT, t.Service.BEAT, o), this.infinity && this.infinity._setLastActive(), e.verbose(t.Service.BEAT);
    },
    // ---------------------------------------- GETTERS -----------------------------------------
    /**
    * Returns a json with the metrics to be reported in beats when changed
    *
    * @memberof youbora.Plugin.prototype
    */
    getSessionMetrics: function() {
      return n.getMetricsFrom(this.options["session.metrics"]);
    }
  };
  return Ld = a, Ld;
}
var Id, nm;
function XL() {
  if (nm)
    return Id;
  nm = 1;
  var t = li, e = {
    getContext: function() {
      return "Default";
    },
    getScrollDepth: function() {
      var r = this.storage.getSession("pageScrollDepth");
      return this.storage.removeSession("pageScrollDepth"), r;
    },
    getSession: function() {
      var r = this.storage.getStorages("session");
      if (r === "undefined" && (r = void 0), !r) {
        var n = this.getStoredData();
        if (n)
          try {
            r = JSON.parse(n).q.c;
          } catch {
          }
      }
      return r;
    },
    getStorageHost: function() {
      var r = null, n = this.getStoredData();
      if (n)
        try {
          r = JSON.parse(n).q.h;
        } catch {
        }
      return r && t.addProtocol(r, this.options["app.https"]);
    },
    getStoredData: function() {
      return this.storage.getStorages("data");
    },
    getDataTime: function() {
      return this.storage.getStorages("dataTime");
    },
    getLastActive: function() {
      return this.storage.getStorages("lastactive");
    },
    setStoredData: function(r) {
      this.storage.setStorages("data", r);
    },
    setSession: function(r) {
      this.storage.setStorages("session", r);
    },
    setDataTime: function(r) {
      this.storage.setStorages("dataTime", r);
    },
    setLastActive: function(r) {
      this.storage.setStorages("lastactive", r);
    },
    getPageName: function() {
      if (typeof document < "u" && document.title)
        return document.title;
    },
    getPageLoadTime: function() {
      return this.browserLoadTimes.getPageLoadTime();
    },
    getIsSessionExpired: function() {
      var r = (/* @__PURE__ */ new Date()).getTime();
      return !this.getSession() || this.infinity.getFirstActive() < r - this.sessionExpire;
    },
    getIsDataExpired: function() {
      var r = (/* @__PURE__ */ new Date()).getTime();
      return !this.storage.isEnabled() || !this.getStoredData() || this.infinity.getFirstActive() < r - this.sessionExpire;
    }
  };
  return Id = e, Id;
}
var YL = Br, Dd = ff, QL = Ha, am = Wi, Fr = li, JL = lr, ZL = gf, eI = jk, sm = __, om = A_, tI = w_, iI = k_, um = mf, rI = Gk, nI = L_, aI = vf, sI = m_, oI = aL, uI = D_, lI = R_, dI = hL, cI = O_, dr = YL.extend(
  /** @lends youbora.Plugin.prototype */
  {
    /**
     * This is the main class of video analytics. You may want to have one instance for each video
     * you want to track. Will need {@link Adapter}s for both content and ads.
     *
     * @constructs Plugin
     * @extends youbora.Emitter
     * @memberof youbora
     *
     * @param {Options} [options] An object complying with {@link Options} constructor.
     * @param {Adapter} [adapter] If an adapter is provided, setAdapter will be immediately called.
     * @param {object} [dataReq] If a data response is given, it wont request to /data anything and will use this one instead.
     */
    constructor: function(t, e, r) {
      typeof e == "string" && !r && (r = e, e = null), this.storage = new um(), this.uuidGenerator = new cI(this), this.infinity = new aI(this), this.isInitiated = !1, this.isAdsManifestSent = !1, this.playedPostrolls = 0, this.isBreakStarted = !1, this.initChrono = new QL(), this.options = new iI(t), this.storage = new um(null, this.options.disableCookies, this.options.forceCookies, this.options.disableStorage), this.options.disableStorage || (this.offlineStorage = new rI()), this._adapter = null, this._adsAdapter = null, this._ping = new Dd(this._sendPing.bind(this), 5e3), this._beat = new Dd(this._sendBeat.bind(this), 3e4), this._refreshData = new Dd(this._checkOldData.bind(this), 36e5), this._refreshData.start(), this.sessionExpire = Number(this.storage.getLocal("sessionExpire")) * 1e3 || 18e4, this.requestBuilder = new nI(this), this.resourceTransform = new om(this), this.lastEventTime = null, this.restartViewTransform(r), this._initInfinity(), this.hybridNetwork = new sI(), this.browserLoadTimes = new oI(this), this.deviceDetector = new lI(), this.backgroundDetector = new uI(this), this.resizeScrollDetector = new dI(this), this.options["background.enabled"] && this.backgroundDetector.startDetection(), e && this.setAdapter(e);
    },
    _checkOldData: function() {
      this._adapter && this._adapter.flags.isStarted || this.infinity.infinityStarted || this.restartViewTransform();
    },
    restartViewTransform: function(t) {
      if (this.viewTransform = new sm(this), this.viewTransform.on(sm.Event.DONE, this._receiveData.bind(this)), t) {
        this.viewTransform.setData(t);
        return;
      }
      this.getIsDataExpired() || !this.getStorageHost() || this.storage.getLocal("accCode") !== this.options.accountCode && this.storage.getSession("accCode") !== this.options.accountCode ? (this.storage.removeStorages("data"), this.storage.removeStorages("session"), this.storage.removeLocal("infinityStarted"), this.viewTransform.init()) : this.viewTransform.setData(this.getStoredData());
    },
    /**
    * This callback is called when a correct data response is received.
    *
    * @param {any} e Response from fastdata
    */
    _receiveData: function(t) {
      this._ping.interval = t.target.response.pingTime * 1e3, this._beat.interval = t.target.response.beatTime * 1e3, this.sessionExpire = t.target.response.sessionExpire * 1e3, this.storage.setStorages("data", t.target.response.msg), this.storage.setStorages("dataTime", (/* @__PURE__ */ new Date()).getTime()), this.storage.setStorages("accCode", this.options.accountCode), this.getIsSessionExpired() ? (this.viewTransform.setSession(this.viewTransform.response.code), this.storage.setStorages("session", this.viewTransform.response.code), this.storage.setStorages("host", this.viewTransform.response.host)) : (this.viewTransform.setSession(this.getSession()), this.viewTransform.setHost(this.getStorageHost()));
    },
    /**
    * Reset all variables and stop all timers
    * @private
    */
    _reset: function() {
      this._stopPings(), this.resourceTransform = new om(this), this._adapter && this._adapter.flags.reset(), this.isInitiated = !1, this.isStarted = !1, this.startDelayed = !1, this.isAdsManifestSent = !1, this.initChrono.reset(), this._totalPrerollsTime = 0, this.requestBuilder.lastSent.breakNumber = 0, this.requestBuilder.lastSent.adNumber = 0, this._savedAdManifest = null, this._savedAdError = null, this.playedPostrolls = 0, this.isBreakStarted = !1;
    },
    /**
    * Creates and enqueues related request using {@link Communication#sendRequest}.
    * It will fire will-send-events.
    *
    * @param {string} willSendEvent Name of the will-send event. Use {@link Plugin.Event} enum.
    * @param {string} service Name of the service. Use {@link Constants.Service} enum.
    * @param {Object} params Params of the request
    * @param {Object} body Body of the request, if it is a POST request
    * @param {string} method Request method. GET by default
    * @param {function} callback Callback method for successful request
    * @param {Object} callbackParams Json with params for callback call
    * @private
    */
    _send: function(t, e, r, n, i, a, s) {
      var o = (/* @__PURE__ */ new Date()).getTime();
      this.options.preventZombieViews && this.lastEventTime && o > this.lastEventTime + 600 * 1e3 && this.viewTransform.nextView(), this.lastEventTime = e === am.Service.STOP ? null : o, r = this.requestBuilder.buildParams(r, e), this.getIsLive() && (r.mediaDuration = this.options["content.duration"], r.playhead = void 0);
      var u = {
        params: r,
        plugin: this,
        adapter: this.getAdapter(),
        adsAdapter: this.getAdsAdapter()
      };
      if (this.emit(t, u), this._comm && (r !== null || typeof i < "u") && this.options.enabled) {
        this.lastServeiceSent = e;
        var l = {};
        typeof i < "u" && i !== "GET" && (l.method = i);
        var d = new JL(null, e, r, l);
        n && d.setBody(n), this.isMethodPostEnabled() && d.setPostRequest(!0), this._comm.sendRequest(d, a, s);
      }
    },
    /**
    * Initializes comm and its transforms.
    * @private
    */
    _initComm: function() {
      var t = this._getResourceForTransform();
      this.resourceTransform.init(t), this._comm = new ZL(), this._comm.addTransform(new eI()), this._comm.addTransform(this.viewTransform), this.options && this.options.offline ? this._comm.addTransform(new tI(this)) : this._comm.addTransform(this.resourceTransform);
    },
    _getResourceForTransform: function() {
      var t = this.getResource();
      return this._adapter && this._adapter.getURLToParse() && (t = this._adapter.getURLToParse()), t;
    },
    /**
    * Returns the current {@link youbora.Communication} instance.
    *
    * @returns {youbora.Communication} communication instance
    */
    getComm: function() {
      return this._comm;
    },
    /**
    * Modifies current options. See {@link Options.setOptions}.
    *
    * @param {any} options
    */
    setOptions: function(t) {
      t && (this.options.setOptions(t), typeof t["background.enabled"] == "boolean" && (t["background.enabled"] ? this.backgroundDetector.startDetection() : this.backgroundDetector.stopDetection()));
    },
    /**
    * Get fastdata response to set it in another plugin instance
    */
    getFastDataConfig: function() {
      return this.viewTransform.response.msg;
    },
    /**
    * Disable request sending.
    */
    disable: function() {
      this.setOptions({ enabled: !1 });
    },
    /**
    * Re-enable request sending.
    */
    enable: function() {
      this.setOptions({ enabled: !0 });
    }
  },
  /** @lends youbora.Plugin */
  {
    // Static Memebers //
    /**
    * List of events that could be fired
    * @enum
    * @event
    */
    Event: am.WillSendEvent
  }
);
Fr.assign(dr.prototype, jL());
Fr.assign(dr.prototype, HL());
Fr.assign(dr.prototype, WL());
Fr.assign(dr.prototype, qL());
Fr.assign(dr.prototype, $L());
Fr.assign(dr.prototype, zL());
Fr.assign(dr.prototype, GL());
Fr.assign(dr.prototype, KL());
Fr.assign(dr.prototype, XL());
var hI = dr, fI = Ne, Ne = {};
Ne.noConflict = function() {
  return Ne = fI, this;
};
Ne.VERSION = Zu;
Ne.polyfills = cP;
Ne.polyfills();
Ne.Object = wt;
Ne.Emitter = Br;
Ne.Log = bt;
Ne.Log.loadLevelFromUrl();
Ne.Util = li;
Ne.HybridNetwork = m_;
Ne.Chrono = Ha;
Ne.Timer = ff;
Ne.Constants = Wi;
Ne.Request = lr;
Ne.Communication = gf;
Ne.Transform = Jr;
Ne.ViewTransform = __;
Ne.ResourceTransform = A_;
Ne.CdnParser = S_;
Ne.HlsParser = b_;
Ne.DashParser = E_;
Ne.OfflineParser = w_;
Ne.LocationheaderParser = x_;
Ne.Options = k_;
Ne.Plugin = hI;
Ne.Storage = mf;
Ne.RequestBuilder = L_;
Ne.PlayheadMonitor = M_;
Ne.Adapter = Tf;
Ne.adapters = {};
Ne.Infinity = vf;
Ne.BackgroundDetector = D_;
Ne.DeviceDetector = R_;
Ne.UUIDGenerator = O_;
Ne.registerAdapter = function(t, e) {
  this.adapters[t] = e;
}.bind(Ne);
Ne.unregisterAdapter = function(t) {
  this.adapters[t] = null;
}.bind(Ne);
var pi = Ne;
const pI = "videojs", gI = "adapter", mI = "js", vI = "Jesus Lopez", yI = "6.8.12", _I = "2022-10-25", TI = "https://bitbucket.org/npaw/videojs-adapter-js.git", bI = "^6.8.33", SI = {
  buffer: "native",
  seek: "native",
  error: !0,
  stop: !0,
  pause: !0,
  resume: !0,
  getters: [
    "getPlayhead",
    "getPlayrate",
    "getDuration",
    "getBitrate",
    "getRendition",
    "getTitle",
    "getIsLive",
    "getResource",
    "getPlayerVersion"
  ]
}, EI = [
  {
    buffer: "monitor",
    seek: "monitor",
    error: !0,
    stop: !0,
    pause: !0,
    resume: !0,
    getters: [
      "getPlayhead",
      "getDuration",
      "getTitle",
      "getResource",
      "getPosition",
      "getGivenBreaks",
      "getBreaksTime",
      "getGivenAds",
      "getIsVisible",
      "getAudioEnabled",
      "getIsSkippable",
      "getIsFullscreen",
      "getCreativeId"
    ],
    filename: "bcove-freewheel.js"
  },
  {
    buffer: "monitor",
    seek: "monitor",
    error: !0,
    stop: !0,
    pause: !0,
    resume: !0,
    getters: [
      "getPlayhead",
      "getDuration",
      "getBitrate",
      "getTitle",
      "getResource",
      "getPlayerVersion",
      "getPosition",
      "getGivenBreaks",
      "getBreaksTime",
      "getGivenAds",
      "getIsVisible",
      "getAudioEnabled",
      "getIsSkippable",
      "getIsFullscreen",
      "getCreativeId"
    ],
    filename: "bcove-ima.js"
  },
  {
    buffer: "monitor",
    seek: "monitor",
    error: !1,
    stop: !1,
    pause: !1,
    resume: !1,
    getters: [],
    filename: "freewheel.js"
  },
  {
    buffer: "monitor",
    seek: "monitor",
    error: !0,
    stop: !0,
    pause: !1,
    resume: !1,
    getters: [],
    filename: "generic.js"
  },
  {
    buffer: "monitor",
    seek: "monitor",
    error: !0,
    stop: !0,
    pause: !0,
    resume: !0,
    getters: [
      "getPlayhead",
      "getDuration",
      "getTitle",
      "getIsLive",
      "getResource",
      "getPlayerVersion",
      "getPosition",
      "getGivenBreaks",
      "getBreaksTime",
      "getGivenAds",
      "getIsVisible",
      "getAudioEnabled",
      "getIsSkippable",
      "getIsFullscreen"
    ],
    filename: "ima.js"
  },
  {
    buffer: "monitor",
    seek: "monitor",
    error: !0,
    stop: !0,
    pause: !0,
    resume: !0,
    getters: [
      "getPlayhead",
      "getDuration",
      "getResource",
      "getPosition"
    ],
    filename: "onceux.js"
  }
], rl = {
  name: pI,
  type: gI,
  tech: mI,
  author: vI,
  version: yI,
  built: _I,
  repo: TI,
  libVersion: bI,
  features: SI,
  ads: EI
};
var Rd, lm;
function xI() {
  if (lm)
    return Rd;
  lm = 1;
  var t = pi, e = rl, r = t.Adapter.extend({
    isGeneric: !0,
    getVersion: function() {
      return e.version + "-videojs-ads";
    },
    registerListeners: function() {
      if (this.references = {
        adstart: this.adStartListener.bind(this),
        adend: this.adEndListener.bind(this),
        adskip: this.adSkipListener.bind(this),
        adserror: this.errorListener.bind(this),
        "ads-click": this.clickListener.bind(this)
      }, this.player)
        for (var n in this.references)
          this.player.on(n, this.references[n]);
    },
    unregisterListeners: function() {
      if (this.player && this.references) {
        for (var n in this.references)
          this.player.off(n, this.references[n]);
        delete this.references;
      }
    },
    adStartListener: function(n) {
      this.fireStart(), this.fireJoin();
    },
    adEndListener: function(n) {
      this.fireStop();
    },
    adSkipListener: function(n) {
      this.fireSkip();
    },
    errorListener: function(n) {
      this.fireError();
    },
    clickListener: function(n) {
      this.fireClick();
    }
  });
  return Rd = r, Rd;
}
var Od, dm;
function CI() {
  if (dm)
    return Od;
  dm = 1;
  var t = pi, e = t.Adapter.extend(
    {
      getVersion: function() {
        var r = null;
        return typeof google < "u" && google.ima && (r = "bcove-ima " + google.ima.VERSION), r;
      },
      getPlayhead: function() {
        var r = this.plugin.getAdapter().player;
        return this.player.ima3 && this.player.ima3 && this.player.ima3.adPlayer && (r = this.player.ima3.adPlayer), r.currentTime();
      },
      getDuration: function() {
        var r = null;
        if (this.player.ads && this.player.ads.ad && this.player.ads.ad.duration)
          r = this.player.ads.ad.duration;
        else {
          var n = this.plugin.player;
          this.player.ima3 && (n = this.player.ima3.adPlayer), r = n && n.duration ? n.duration() : null;
        }
        return r;
      },
      getPosition: function() {
        var r = t.Constants.AdPosition.Midroll;
        if (this.player.ads && this.player.ads.ad)
          switch (this.player.ads.ad.type) {
            case "PREROLL":
              r = t.Constants.AdPosition.Preroll;
              break;
            case "MIDROLL":
              r = t.Constants.AdPosition.Midroll;
              break;
            case "POSTROLL":
              r = t.Constants.AdPosition.Postroll;
              break;
          }
        else
          this.plugin._adapter.getPlayhead() >= this.plugin._adapter.getDuration() && (r = t.Constants.AdPosition.Postroll);
        return this.plugin._adapter.flags.isJoined || (r = t.Constants.AdPosition.Preroll), r;
      },
      getResource: function() {
        var r = "unknown";
        return this.player.ima3 && (r = this.player.ima3.currentAd.getMediaUrl()), r;
      },
      getTitle: function() {
        var r = null;
        return this.player.ima3 && this.player.ima3.currentAd && (r = this.player.ima3.currentAd.getTitle()), r;
      },
      getPlayerVersion: function() {
        var r = null;
        return this.player.ima3 && (r = this.player.ima3.VERSION), r;
      },
      getGivenBreaks: function() {
        var r = null;
        return this.player.ima3 && (r = this.player.ima3.adsManager.getCuePoints().length), r;
      },
      getBreaksTime: function() {
        var r = null;
        if (this.player.ima3) {
          var n = this.player.ima3.adsManager.getCuePoints();
          for (var i in n)
            (!n[i] && n[i] !== 0 || n[i] === -1) && (n[i] = this.plugin._adapter.getDuration());
          r = n;
        }
        return r;
      },
      getGivenAds: function() {
        var r = null;
        return this.player.ima3 && this.player.ima3.currentAd && this.player.ima3.currentAd.getAdPodInfo() && (r = this.player.ima3.currentAd.getAdPodInfo().getTotalAds()), r;
      },
      getAudioEnabled: function() {
        var r = null;
        return this.player.muted() ? r = !1 : r = !!this.player.volume(), r;
      },
      getIsSkippable: function() {
        var r = !1;
        return this.player.ima3 && (r = this.player.ima3.currentAd && this.player.ima3.currentAd.isSkippable()), r;
      },
      getIsFullscreen: function() {
        var r = null;
        if (this.plugin.deviceDetector.isIphone())
          r = !this.plugin.deviceDetector.isInBackground;
        else {
          var n = null;
          this.player.ima3 && (n = this.player.ima3.el), r = n ? window.innerHeight <= n.clientHeight + 30 && window.innerWidth <= n.clientWidth + 30 : !1;
        }
        return r;
      },
      getIsVisible: function() {
        var r = null;
        return this.plugin.deviceDetector.isIphone() ? r = !this.plugin.deviceDetector.isInBackground : this.player.ima3 && (r = t.Util.calculateAdViewability(this.player.ima3.el)), r;
      },
      getBitrate: function() {
        var r = -1;
        return this.player.ima3 && this.player.ima3.currentAd && this.player.ima3.currentAd.getVastMediaBitrate() && (r = this.player.ima3.currentAd.getVastMediaBitrate()), r;
      },
      getCreativeId: function() {
        var r = null;
        return this.player.ima3 && this.player.ima3.currentAd ? r = this.player.ima3.currentAd.getCreativeAdId() || this.player.ima3.currentAd.getCreativeId() : this.titles && (r = this.titles[(this.plugin.requestBuilder.lastSent.adNumber || 1) - 1]._creativeId), r;
      },
      registerListeners: function() {
        if (this.monitorPlayhead(!0, !1), this.references = {
          "ima3-started": this.startJoinListener.bind(this),
          "ima3-paused": this.pausedListener.bind(this),
          "ima3-resumed": this.resumedListener.bind(this),
          "ima3-complete": this.adEndedListener.bind(this),
          "ima3-skipped": this.skippedListener.bind(this),
          "ima3-ad-error": this.errorListener.bind(this),
          "ads-pod-ended": this.podEndListener.bind(this),
          "ads-click": this.clickListener.bind(this),
          "ads-first-quartile": this.firstQuartileListener.bind(this),
          "ads-midpoint": this.secondQuartileListener.bind(this),
          "ads-third-quartile": this.thirdQuartileListener.bind(this)
        }, this.player)
          for (var r in this.references)
            this.player.on(r, this.references[r]);
      },
      startJoinListener: function(r) {
        this.plugin._adapter && this.plugin._adapter.firePause(), this.fireStart(), this.fireJoin();
      },
      pausedListener: function(r) {
        this.firePause();
      },
      resumedListener: function(r) {
        this.fireResume();
      },
      skippedListener: function(r) {
        this.fireSkip(), this.plugin._adapter && this.plugin._adapter.fireResume();
      },
      adEndedListener: function(r) {
        var n = this.plugin.requestBuilder.lastSent.adPosition === t.Constants.AdPosition.Preroll ? 0 : this.plugin._adapter.lastPlayhead;
        this.fireStop({ playhead: n, adPlayhead: this.getDuration() });
      },
      errorListener: function(r) {
        if (this.player.ima3)
          if (r.getError && r.getError()) {
            var n = r.getError();
            this.fireError(n.getCode(), n.getMessage());
          } else
            this.fireError();
      },
      clickListener: function(r) {
        if (this.player.ima3) {
          var n = null;
          this.player.ima3.currentAd && this.player.ima3.currentAd.g && (n = this.player.ima3.currentAd.g.clickThroughUrl), this.fireClick(n);
        }
      },
      firstQuartileListener: function(r) {
        this.fireQuartile(1);
      },
      secondQuartileListener: function(r) {
        this.fireQuartile(2);
      },
      thirdQuartileListener: function(r) {
        this.fireQuartile(3);
      },
      podEndListener: function(r) {
        this.fireBreakStop();
      },
      unregisterListeners: function() {
        if (this.monitor && this.monitor.stop(), this.player && this.references) {
          for (var r in this.references)
            this.player.off(r, this.references[r]);
          delete this.references;
        }
      },
      adPlayerErrorListener: function(r) {
        var n = r.data.AdError, i = [
          1012,
          // There was a problem requesting ads from the server.
          1005,
          // There was a problem requesting ads from the server
          301,
          // The VAST URI provided, or a VAST URI provided in a subsequent wrapper element,
          // was either unavailable or reached a timeout, as defined by the video player. The timeout is 5 seconds for initial VAST requests and each subsequent wrapper.
          402,
          // Failed to load media assets from a VAST response.
          302
          // The maximum number of VAST wrapper redirects has been reached.
        ], a = [
          1007,
          // No assets were found in the VAST ad response
          1009,
          // Empty VAST response
          303
          // No Ads VAST response after one or more wrappers
        ], s = [
          403,
          // Assets were found in the VAST ad response for linear ad, but none of them matched the video player's capabilities
          100,
          // The ad response was not recognized as a valid VAST ad
          503,
          // Assets were found in the VAST ad response for nonlinear ad, but none of them matched the video player's capabilities
          101,
          // VAST schema validation error.
          102
          // The ad response contained an unsupported VAST version
        ];
        i.indexOf(n.getErrorCode()) >= 0 ? this.fireManifest(t.Constants.ManifestError.NO_RESPONSE, n.getMessage()) : a.indexOf(n.getErrorCode()) >= 0 ? this.fireManifest(t.Constants.ManifestError.EMPTY, n.getMessage()) : s.indexOf(n.getErrorCode()) >= 0 ? this.fireManifest(t.Constants.ManifestError.WRONG, n.getMessage()) : this.fireError(n.getErrorCode(), n.getMessage());
      }
    },
    // Static Members
    {
      isUsed: function(r) {
        return typeof google < "u" && r.player.ima3 && r.player.ads;
      }
    }
  );
  return Od = e, Od;
}
var Md, cm;
function AI() {
  if (cm)
    return Md;
  cm = 1;
  var t = pi, e = t.Adapter.extend(
    {
      getVersion: function() {
        var r = "unknown";
        return this.player.FreeWheelPlugin.getVersion ? r = "bcove-fw " + this.player.FreeWheelPlugin.getVersion() : this.player.FreeWheelPlugin.VERSION && (r = "bcove-ssai " + this.player.FreeWheelPlugin.VERSION), r;
      },
      getDuration: function() {
        var r = null;
        if (this.player.ads && this.player.ads.ad && this.player.ads.ad.duration)
          r = this.player.ads.ad.duration;
        else {
          var n = this.plugin.player;
          if (this.player.FreeWheelPlugin) {
            var i = this.player.FreeWheelPlugin.tech;
            this.player.FreeWheelPlugin[i].adPlayer && (n = this.player.FreeWheelPlugin[i].adPlayer);
          }
          n && n.duration && (r = n.duration());
        }
        return r;
      },
      getPosition: function() {
        var r = t.Constants.AdPosition.Midroll;
        if (this.player.ads && this.player.ads.ad)
          switch (this.player.ads.ad.type) {
            case "PREROLL":
              r = t.Constants.AdPosition.Preroll;
              break;
            case "MIDROLL":
              r = t.Constants.AdPosition.Midroll;
              break;
            case "POSTROLL":
              r = t.Constants.AdPosition.Postroll;
              break;
          }
        else
          this.plugin._adapter.flags.isJoined ? this.plugin._adapter.getPlayhead() >= this.plugin._adapter.getDuration() && (r = t.Constants.AdPosition.Postroll) : r = t.Constants.AdPosition.Preroll;
        return r;
      },
      getResource: function() {
        var r = null;
        if (this.slot) {
          var n = this.slot.getAdInstances();
          if (n) {
            var i = (this.plugin.requestBuilder.lastSent.adNumber || 1) - 1;
            if (n[i] && n[i].getActiveCreativeRendition) {
              var a = n[i].getActiveCreativeRendition();
              if (a && a.getPrimaryCreativeRenditionAsset) {
                var s = a.getPrimaryCreativeRenditionAsset();
                s && s.getUrl && s.getUrl() && (r = s.getUrl());
              }
              a && a.getWrapperUrl && !r && (r = a.getWrapperUrl());
            }
          }
        }
        return r || "unknown";
      },
      getTitle: function() {
        var r = null;
        return this.player.FreeWheelPlugin.adsManager && this.player.FreeWheelPlugin.adsManager.getCurrentAd() && this.player.FreeWheelPlugin.adsManager.getCurrentAd().getTitle() ? r = this.player.FreeWheelPlugin.adsManager.getCurrentAd().getTitle() : this.titles && (r = this.titles[(this.plugin.requestBuilder.lastSent.adNumber || 1) - 1]._adId), r;
      },
      getPlayhead: function() {
        var r = this.plugin.getAdapter().player;
        return this.player.FreeWheelPlugin.adPlayer && (r = this.player.FreeWheelPlugin.adPlayer), r.currentTime();
      },
      getGivenBreaks: function() {
        var r = this.player.FreeWheelPlugin.tech, n = this.player.FreeWheelPlugin[r]._adContext._adResponse.getTemporalSlots(), i = 0;
        for (var a in n) {
          var s = n[a];
          if (s.getAdCount() > 0) {
            var o = s.getAdInstances();
            for (var u in o)
              if (o[u]._creativeRenditions[0]._baseUnit === "video") {
                i++;
                break;
              }
          }
        }
        return i;
      },
      getBreaksTime: function() {
        var r = null, n = this.player.FreeWheelPlugin[this.player.FreeWheelPlugin.tech]._adContext._adResponse.getTemporalSlots(), i = [];
        for (var a in n) {
          var s = n[a];
          if (s.getAdCount() > 0) {
            var o = s.getAdInstances();
            for (var u in o)
              if (o[u]._creativeRenditions[0]._baseUnit === "video") {
                this.plugin.getDuration() && s.getTimePosition() > this.plugin.getDuration() ? i.push(this.plugin.getDuration()) : i.push(s.getTimePosition());
                break;
              }
          }
        }
        return r = i.sort(), r;
      },
      getGivenAds: function() {
        var r = this.player.FreeWheelPlugin.tech;
        return this.player.FreeWheelPlugin[r]._currentSlot.getAdCount();
      },
      getAudioEnabled: function() {
        var r = null;
        return this.player.muted() ? r = !1 : r = !!this.player.volume(), r;
      },
      getIsSkippable: function() {
        return !1;
      },
      getIsFullscreen: function() {
        var r = null;
        if (this.plugin.deviceDetector.isIphone())
          r = !this.plugin.deviceDetector.isInBackground;
        else {
          var n = null, i = this.player.FreeWheelPlugin.tech;
          n = this.player.FreeWheelPlugin[i]._video, r = n ? window.innerHeight <= n.clientHeight + 30 && window.innerWidth <= n.clientWidth + 30 : !1;
        }
        return r;
      },
      getIsVisible: function() {
        var r = null;
        if (this.plugin.deviceDetector.isIphone())
          r = !this.plugin.deviceDetector.isInBackground;
        else {
          if (!this.contentPlayer) {
            var n = this.player.FreeWheelPlugin.tech;
            for (var i in this.player.FreeWheelPlugin[n]) {
              var a = this.player.FreeWheelPlugin[n][i];
              if (a.videoHeight && a.clientHeight) {
                this.contentPlayer = a;
                break;
              }
            }
          }
          r = t.Util.calculateAdViewability(this.contentPlayer);
        }
        return r;
      },
      getCreativeId: function() {
        var r = null;
        return this.titles && (r = this.titles[(this.plugin.requestBuilder.lastSent.adNumber || 1) - 1]._creativeId), r;
      },
      registerListeners: function() {
        if (this.monitorPlayhead(!0, !1), this.references = {
          "ads-ad-started": this.startJoinListener.bind(this),
          "ads-pause": this.pausedListener.bind(this),
          "ads-play": this.resumedListener.bind(this),
          "ads-ad-ended": this.adEndedListener.bind(this),
          "ads-pod-ended": this.podEndListener.bind(this),
          "ads-first-quartile": this.firstQuartileListener.bind(this),
          "ads-midpoint": this.secondQuartileListener.bind(this),
          "ads-third-quartile": this.thirdQuartileListener.bind(this)
        }, typeof tv < "u") {
          var r = this.player.FreeWheelPlugin[this.player.FreeWheelPlugin.tech]._adContext;
          this.events = tv.freewheel.SDK, this.fwreferences = {}, this.fwreferences[this.events.EVENT_AD] = this.logListener.bind(this), this.fwreferences[this.events.EVENT_SLOT_STARTED] = this.slotListener.bind(this), this.fwreferences[this.events.EVENT_ERROR] = this.errorFwListener.bind(this), this.manifestNoResponse = [
            this.events.ERROR_SECURITY,
            this.events.ERROR_TIMEOUT
          ];
          for (var n in this.manifestNoResponse)
            this.fwreferences[n] = this.noResponseManifestListener.bind(this);
          this.manifestEmpty = [
            this.events.ERROR_NO_AD_AVAILABLE,
            this.events.ERROR_VAST_NO_AD
          ];
          for (var i in this.manifestEmpty)
            this.fwreferences[i] = this.manifestEmptyListener.bind(this);
          this.manifestWrong = [
            this.events.ERROR_VAST_VERSION_NOT_SUPPORTED,
            this.events.ERROR_VAST_WRAPPER_LIMIT_REACH,
            this.events.ERROR_VAST_XML_PARSING,
            this.events.ERROR_PARSE
          ];
          for (var a in this.manifestWrong)
            this.fwreferences[a] = this.manifestWrongListener.bind(this);
          if (this.player)
            for (var n in this.fwreferences)
              r.addEventListener(n, this.fwreferences[n]);
        }
        if (this.player)
          for (var n in this.references)
            this.player.on(n, this.references[n]);
      },
      logListener: function(r) {
        if (r.errorCode || r.errorInfo || r.errorModule) {
          this.errorFwListener(r);
          return;
        }
        switch (r.subType) {
          case this.events.EVENT_AD_SKIPPED:
            this.skippedListener(r);
            break;
          case this.events.EVENT_SLOT_STARTED:
            this.slotListener(r);
            break;
          case this.events.EVENT_AD_CLICK:
            this.clickFwListener(r);
            break;
        }
      },
      skippedListener: function(r) {
        this.fireSkip(), this.plugin._adapter && this.plugin._adapter.fireResume();
      },
      noResponseManifestListener: function(r) {
        this.fireManifest(t.Constants.ManifestError.NO_RESPONSE, "No response");
      },
      manifestEmptyListener: function(r) {
        this.fireManifest(t.Constants.ManifestError.EMPTY, "Empty manifest");
      },
      manifestWrongListener: function(r) {
        this.fireManifest(t.Constants.ManifestError.WRONG, "Wrong manifest format");
      },
      slotListener: function(r) {
        this.slot = r.slot, r && r.slot && r.slot.getAdInstances && (this.titles = r.slot.getAdInstances());
      },
      startJoinListener: function(r) {
        this.plugin._adapter && this.plugin._adapter.firePause(), this.fireStart(), this.fireJoin();
      },
      pausedListener: function(r) {
        this.firePause();
      },
      resumedListener: function(r) {
        this.fireResume();
      },
      adEndedListener: function(r) {
        var n = this.plugin.requestBuilder.lastSent.adPosition === t.Constants.AdPosition.Preroll ? 0 : this.plugin._adapter.lastPlayhead;
        this.fireStop({ playhead: n, adPlayhead: this.getDuration() });
      },
      errorFwListener: function(r) {
        this.fireError(r.errorCode || r.subType, r.errorInfo), this.fireStop();
      },
      clickFwListener: function(r) {
        var n = r.adInstance.getEventCallbackUrls(this.events.EVENT_AD_CLICK, this.events.EVENT_TYPE_CLICK)[0];
        this.fireClick(n);
      },
      firstQuartileListener: function(r) {
        this.fireQuartile(1);
      },
      secondQuartileListener: function(r) {
        this.fireQuartile(2);
      },
      thirdQuartileListener: function(r) {
        this.fireQuartile(3);
      },
      podEndListener: function(r) {
        this.fireBreakStop();
      },
      unregisterListeners: function() {
        if (this.monitor && this.monitor.stop(), this.player && this.references) {
          for (var r in this.references)
            this.player.off(r, this.references[r]);
          delete this.references;
        }
      }
    },
    // Static Members
    {
      isUsed: function(r) {
        return r.player.ads && r.player.FreeWheelPlugin;
      }
    }
  );
  return Md = e, Md;
}
const wI = "freewheel", PI = "adapter", kI = "js", LI = "Jesus Lopez", II = "6.8.2", DI = "2022-10-03", RI = "https://bitbucket.org/npaw/freewheel-adapter-js", OI = "^6.8.28", MI = {
  buffer: "monitor",
  seek: "monitor",
  error: !0,
  stop: !0,
  pause: !0,
  resume: !0,
  getters: [
    "getPlayhead",
    "getDuration",
    "getTitle",
    "getResource",
    "getPlayerVersion",
    "getPosition",
    "getGivenBreaks",
    "getBreaksTime",
    "getGivenAds",
    "getIsVisible",
    "getAudioEnabled",
    "getCreativeId"
  ]
}, NI = [], BI = {
  name: wI,
  type: PI,
  tech: kI,
  author: LI,
  version: II,
  built: DI,
  repo: RI,
  libVersion: OI,
  features: MI,
  ads: NI
};
var Nd, hm;
function FI() {
  if (hm)
    return Nd;
  hm = 1;
  var t = pi, e = BI;
  return t.adapters.Freewheel = t.Adapter.extend({
    /** Override to return current plugin version */
    getVersion: function() {
      return e.version + "-" + e.name + "-" + e.tech;
    },
    /** Override to return current playhead of the video */
    getPlayhead: function() {
      return this._getAdInstanceMethodCall("getPlayheadTime");
    },
    /** Override to return video duration */
    getDuration: function() {
      return this._getAdInstanceMethodCall("getDuration");
    },
    /** Override to return title */
    getTitle: function() {
      try {
        if (this.titles)
          return this.titles[this._getAdNumber()]._adId;
      } catch {
      }
      return "unknown";
    },
    /** Override to return resource URL. */
    getResource: function() {
      var r = null, n = this._getAdInstanceMethodCall("getActiveCreativeRendition");
      return n && (typeof n.getPrimaryCreativeRenditionAsset == "function" ? (asset = n.getPrimaryCreativeRenditionAsset(), asset && typeof asset.getUrl == "function" && (r = asset.getUrl())) : typeof n.getWrapperUrl == "function" && (r = n.getWrapperUrl())), r;
    },
    /** Override to return player version */
    getPlayerVersion: function() {
      var r = null;
      return typeof tv < "u" && tv.freewheel && tv.freewheel.SDK && (r = tv.freewheel.SDK.version), r;
    },
    /** Override to return player's name */
    getPlayerName: function() {
      return "Freewheel";
    },
    getPosition: function() {
      return this.position;
    },
    getIsVisible: function() {
      if (!this.contentPlayer)
        for (var r in this.player) {
          var n = this.player[r];
          if (n && n.videoHeight && n.clientHeight) {
            this.contentPlayer = n;
            break;
          }
        }
      return t.Util.calculateAdViewability(this.contentPlayer);
    },
    getAudioEnabled: function() {
      for (var r in this.player) {
        var n = this.player[r];
        if (n && n.adManager && n.adManager._context && n.adManager._context.getAdVolume)
          return !!n.adManager._context.getAdVolume();
      }
    },
    getGivenAds: function() {
      return this.slot.getAdCount();
    },
    getBreaksTime: function() {
      var r = this.getSlots();
      if (!r)
        return null;
      var n = [];
      for (var i in r) {
        var a = r[i];
        if (a.getAdCount() > 0) {
          var s = a.getAdInstances();
          for (var o in s)
            if (s[o]._creativeRenditions[0]._baseUnit === "video") {
              var u = this.plugin.getDuration(), l = a.getTimePosition();
              n.push(u && l > u ? u : l);
              break;
            }
        }
      }
      return n;
    },
    getGivenBreaks: function() {
      var r = this.getSlots();
      if (!r)
        return null;
      var n = 0;
      for (var i in r) {
        var a = r[i];
        if (a.getAdCount() > 0) {
          var s = a.getAdInstances();
          for (var o in s)
            if (s[o]._creativeRenditions[0]._baseUnit === "video") {
              n++;
              break;
            }
        }
      }
      return n;
    },
    getCreativeId: function() {
      var r = null;
      if (this.slot) {
        var n = this.slot.getAdInstances(), i = this._getAdNumber();
        n && n[i] && (r = n[i]._creativeId);
      }
      return r;
    },
    getSlots: function() {
      if (this.player.currentAdContext)
        return this.player.currentAdContext._adResponse.getTemporalSlots();
      for (var r in this.player) {
        var n = this.player[r];
        if (n && n._adResponse && n._adResponse.getTemporalSlots)
          return n;
      }
      return null;
    },
    _getAdNumber: function() {
      return (this.plugin.requestBuilder.lastSent.adNumber || 1) - 1;
    },
    _getAdInstanceMethodCall: function(r) {
      if (ret = null, this.slot) {
        var n = this.slot.getAdInstances(), i = this._getAdNumber();
        n && n[i] && typeof n[i][r] == "function" && (ret = n[i][r]());
      }
      return ret;
    },
    /** Register listeners to this.player. */
    registerListeners: function() {
      this.canRemoveListeners = !0, this.events = tv.freewheel.SDK, this.manifestNoResponse = [
        this.events.ERROR_SECURITY,
        this.events.ERROR_TIMEOUT
      ], this.manifestEmpty = [
        this.events.ERROR_NO_AD_AVAILABLE,
        this.events.ERROR_VAST_NO_AD
      ], this.manifestWrong = [
        this.events.ERROR_VAST_VERSION_NOT_SUPPORTED,
        this.events.ERROR_VAST_WRAPPER_LIMIT_REACH,
        this.events.ERROR_VAST_XML_PARSING,
        this.events.ERROR_PARSE
      ], this.ignoredErrors = [
        this.events.ERROR_ADINSTANCE_UNAVAILABLE
      ], this.references = {}, this.references[this.events.EVENT_AD] = this.logListener.bind(this), this.references[this.events.EVENT_ERROR] = this.errorListener.bind(this), this.references[this.events.EVENT_SLOT_STARTED] = this.slotListener.bind(this), this.references[this.events.EVENT_SLOT_ENDED] = this.closeListener.bind(this);
      for (var r in this.manifestNoResponse)
        this.references[r] = this.noResponseManifestListener.bind(this);
      for (var n in this.manifestEmpty)
        this.references[n] = this.manifestEmptyListener.bind(this);
      for (var i in this.manifestWrong)
        this.references[i] = this.manifestWrongListener.bind(this);
      for (var a in this.references)
        this.player.currentAdContext.addEventListener(a, this.references[a]);
    },
    /** Unregister listeners to this.player. */
    unregisterListeners: function() {
      if (this.player && this.references) {
        for (var r in this.references)
          this.player.currentAdContext.removeEventListener(r, this.references[r]);
        this.references = {};
      }
    },
    noResponseManifestListener: function(r) {
      this.fireManifest(t.Constants.ManifestError.NO_RESPONSE, "No response");
    },
    manifestEmptyListener: function(r) {
      this.fireManifest(t.Constants.ManifestError.EMPTY, "Empty manifest");
    },
    manifestWrongListener: function(r) {
      this.fireManifest(t.Constants.ManifestError.WRONG, "Wrong manifest format");
    },
    logListener: function(r) {
      if (t.Log.debug(r.subType), r.errorCode || r.errorInfo || r.errorModule) {
        this.errorListener(r);
        return;
      }
      switch (r.subType) {
        case this.events.EVENT_AD_PAUSE:
          this.pauseListener(r);
          break;
        case this.events.EVENT_AD_RESUME:
          this.resumeListener(r);
          break;
        case this.events.EVENT_AD_IMPRESSION_END:
          this.endedListener(r);
          break;
        case this.events.EVENT_AD_INITIATED:
          this.playListener(r);
          break;
        case this.events.EVENT_AD_IMPRESSION:
          this.playingListener(r);
          break;
        case this.events.EVENT_AD_SKIPPED:
          this.skipListener(r);
          break;
        case this.events.EVENT_SLOT_STARTED:
          this.slotListener(r);
          break;
        case this.events.EVENT_AD_CLOSE:
        case this.events.EVENT_SLOT_ENDED:
          this.closeListener(r);
          break;
        case this.events.EVENT_AD_CLICK:
          this.clickListener(r);
          break;
        case this.events.EVENT_AD_FIRST_QUARTILE:
          this.fireQuartile(1);
          break;
        case this.events.EVENT_AD_MIDPOINT:
          this.fireQuartile(2);
          break;
        case this.events.EVENT_AD_THIRD_QUARTILE:
          this.fireQuartile(3);
          break;
        case this.events.ERROR_SECURITY:
        case this.events.ERROR_TIMEOUT:
          this.noResponseManifestListener(r);
          break;
        case this.events.ERROR_NO_AD_AVAILABLE:
        case this.events.ERROR_VAST_NO_AD:
          this.manifestEmptyListener(r);
          break;
        case this.events.ERROR_VAST_VERSION_NOT_SUPPORTED:
        case this.events.ERROR_VAST_WRAPPER_LIMIT_REACH:
        case this.events.ERROR_VAST_XML_PARSING:
        case this.events.ERROR_PARSE:
          this.manifestWrongListener(r);
          break;
      }
    },
    slotListener: function(r) {
      this.slot = r.slot;
      var n = this.plugin.getAdapter();
      switch (this.disable = !1, slot.getTimePositionClass()) {
        case "POSTROLL":
          this.position = t.Constants.AdPosition.Postroll;
          break;
        case "MIDROLL":
          this.position = t.Constants.AdPosition.Midroll;
          break;
        case "PREROLL":
          n && n.flags.isJoined ? this.position = t.Constants.AdPosition.Midroll : this.position = t.Constants.AdPosition.Preroll;
          break;
        default:
          this.disable = !0;
      }
      this.disable || (this.titles = slot.getAdInstances(), this.unregister(), this.plugin.fireInit(), this.fireInit());
    },
    playListener: function(r) {
      this.disable || this.fireStart();
    },
    playingListener: function(r) {
      this.disable || (this.fireStart(), this.fireJoin(), this.fireResume());
    },
    pauseListener: function(r) {
      this.firePause();
    },
    resumeListener: function(r) {
      this.playListener(), this.fireResume();
    },
    endedListener: function(r) {
      this.fireStop();
    },
    skipListener: function(r) {
      this.fireSkip();
    },
    clickListener: function(r) {
      var n = r.adInstance.getEventCallbackUrls(tv.freewheel.SDK.EVENT_AD_CLICK, tv.freewheel.SDK.EVENT_TYPE_CLICK)[0], i = (/* @__PURE__ */ new Date()).getTime();
      this.lastUrl === n && i < (this.lastTime || 0) + 2e3 || (this.lastUrl = n, this.lastTime = i, this.fireClick(n));
    },
    closeListener: function(r) {
      this.register(), this.position === t.Constants.AdPosition.Postroll && !this.disable && this.plugin.fireStop();
    },
    errorListener: function(r) {
      this.fireError(r.errorCode || r.subType, r.errorInfo), this.fireStop(), this.register();
    },
    register: function(r) {
      var n = this.plugin.getAdapter();
      n && !this.canRemoveListeners && (n.registerListeners(), n.fireResume(), this.canRemoveListeners = !0);
    },
    unregister: function(r) {
      adapter && this.canRemoveListeners && (this.canRemoveListeners = !1, adapter.unregisterListeners(), adapter.firePause());
    },
    changeVideo: function(r) {
      (this.flags.isStarted || this.flags.isInited) && (this.fireStop(), this.plugin.fireStop(), this.register());
    }
  }), Nd = t.adapters.Freewheel, Nd;
}
var Bd, fm;
function UI() {
  if (fm)
    return Bd;
  fm = 1;
  var t = FI(), e = t.extend({
    register: function() {
    },
    unregister: function() {
    }
  }, {
    isUsed: function(r) {
      return r.player && r.player.freewheelAds;
    }
  });
  return Bd = e, Bd;
}
var Fd, pm;
function VI() {
  if (pm)
    return Fd;
  pm = 1;
  var t = pi, e = rl, r = t.Adapter.extend(
    {
      getVersion: function() {
        return e.version + "-videojs-ima-ads";
      },
      getDuration: function() {
        return this.ima.getAdsManager() && this.ima.getAdsManager().getCurrentAd() !== null && (this.duration = this.ima.getAdsManager().getCurrentAd().getDuration()), this.duration;
      },
      // NOT AVAILABLE AT adStart
      getResource: function() {
        var n = null, i = this.ima.getAdsManager();
        return i && (n = i.getCurrentAd().getMediaUrl()), n;
      },
      getTitle: function() {
        var n = null, i = this.ima.getAdsManager();
        return i && (n = i.getCurrentAd().getTitle()), n;
      },
      getPlayhead: function() {
        var n = null, i = this.ima.getAdsManager();
        return i && (n = this.getDuration() - i.getRemainingTime()), n;
      },
      getPlayerVersion: function() {
        return "IMA" + google.ima.VERSION + "; contrib-ads " + this.player.ads.VERSION;
      },
      getPosition: function() {
        var n = t.Constants.AdPosition.Preroll;
        return this.plugin._adapter.flags.isJoined && (!this.plugin.getIsLive() && this.plugin._adapter.getDuration() - 1 < this.plugin._adapter.getPlayhead() ? n = t.Constants.AdPosition.Postroll : this.plugin._adapter.getPlayhead() > 1 && (n = t.Constants.AdPosition.Midroll)), n;
      },
      getGivenBreaks: function() {
        var n = null;
        return this.cuepoints && (n = this.cuepoints.length), n;
      },
      getBreaksTime: function() {
        return this.cuepoints;
      },
      getGivenAds: function() {
        return this.totalAds;
      },
      getAudioEnabled: function() {
        return !this.ima.adMuted;
      },
      getIsSkippable: function() {
        return this.isSkippable;
      },
      getIsFullscreen: function() {
        var n = !1, i = this.ima.adDisplayContainer;
        for (var a in i)
          i[a] && i[a].width && i[a].height && window.innerHeight && window.innerWidth && i[a].width && i[a].height && (n = window.innerHeight <= i[a].height + 30 && window.innerWidth <= i[a].width + 30);
        return n;
      },
      getIsVisible: function() {
        return t.Util.calculateAdViewability(this.ima.adContainerDiv);
      },
      registerListeners: function() {
        this.monitorPlayhead(!0, !1);
        var n = google.ima.AdEvent.Type;
        if (this.references = {}, this.references[n.AD_METADATA] = this.metadataListener.bind(this), this.references[n.LOADED] = this.loadedListener.bind(this), this.references[n.CONTENT_PAUSE_REQUESTED] = this.contentPauseRequestedListener.bind(this), this.references[n.STARTED] = this.startedListener.bind(this), this.references[n.PAUSED] = this.pausedListener.bind(this), this.references[n.RESUMED] = this.resumedListener.bind(this), this.references[n.COMPLETE] = this.completeListener.bind(this), this.references[n.SKIPPED] = this.skippedListener.bind(this), this.references[n.CLICK] = this.clickListener.bind(this), this.references[google.ima.AdErrorEvent.Type.AD_ERROR] = this.errorListener.bind(this), this.references[n.ALL_ADS_COMPLETED] = this.adsEndedListener.bind(this), this.references[n.FIRST_QUARTILE] = this.firstQuartileListener.bind(this), this.references[n.MIDPOINT] = this.secondQuartileListener.bind(this), this.references[n.THIRD_QUARTILE] = this.thirdQuartileListener.bind(this), this.playerReferences = {
          adend: this.adEndedListener.bind(this),
          adstart: this.startedListener.bind(this),
          adskip: this.skippedListener.bind(this),
          adserror: this.errorListener.bind(this),
          "ads-click": this.clickListener.bind(this)
        }, this.player) {
          this.registerImaEvents();
          for (var i in this.playerReferences)
            this.player.on(i, this.playerReferences[i]);
        }
      },
      registerImaEvents: function() {
        if (this.player.ima.addEventListener ? this.ima = this.player.ima : this.player.ima.sdkImpl && this.player.ima.sdkImpl.addEventListener && (this.ima = this.player.ima.sdkImpl), this.ima)
          for (var n in this.references)
            this.ima.addEventListener(n, this.references[n]);
      },
      metadataListener: function(n) {
        this.cuepoints = n.getAdCuePoints().getCuePoints().slice(), this.plugin._adapter && this.cuepoints.forEach(function(i, a) {
          (this.cuepoints[a] === -1 || this.cuepoints[a] == null || this.cuepoints[a] === void 0) && (this.cuepoints[a] = this.plugin._adapter.getDuration());
        }.bind(this));
      },
      loadedListener: function(n) {
        this.isSkippable = n.getAdData().skippable, this.totalAds = n.getAdData().adPodInfo.totalAds, this.fireInit();
      },
      contentPauseRequestedListener: function(n) {
        this.fireInit();
      },
      startedListener: function(n) {
        this.fireStart(), this.fireJoin(), this.plugin.getAdapter().firePause();
      },
      pausedListener: function(n) {
        this.firePause();
      },
      resumedListener: function(n) {
        this.fireResume();
      },
      completeListener: function(n) {
        this.fireStop();
      },
      skippedListener: function(n) {
        this.fireSkip();
      },
      adEndedListener: function(n) {
        this.fireStop();
      },
      errorListener: function(n) {
        var i = null, a = null;
        typeof n.getError == "function" ? (i = n.getError(), a = i.getCode()) : n.data && n.data.AdError && (i = n.data.AdError, a = i.getErrorCode());
        var s = i ? i.getMessage() : null;
        this.fireError(a, s);
      },
      clickListener: function(n) {
        var i = null;
        try {
          if (n && typeof n.getAd == "function") {
            var a = n.getAd();
            for (prop in a)
              typeof a[prop] == "object" && a[prop].clickThroughUrl && (i = a[prop].clickThroughUrl.substring(a[prop].clickThroughUrl.indexOf("adurl=")).replace("adurl=", ""));
          }
        } catch {
          t.Log.notice("Couldnt get adclick url");
        }
        this.fireClick(i);
      },
      adsEndedListener: function(n) {
        this.plugin.getAdapter().adsEnded = !0, this.fireStop(), this.plugin.getAdapter().fireResume(), this.plugin.requestBuilder.lastSent.adPosition === t.Constants.AdPosition.Postroll && this.plugin.fireStop();
      },
      firstQuartileListener: function(n) {
        this.fireQuartile(1);
      },
      secondQuartileListener: function(n) {
        this.fireQuartile(2);
      },
      thirdQuartileListener: function(n) {
        this.fireQuartile(3);
      },
      unregisterListeners: function() {
        if (this.monitor && this.monitor.stop(), this.player && this.ima && this.references && this.playerReferences) {
          for (var n in this.references)
            ;
          for (var n in this.playerReferences)
            this.player.off(n, this.playerReferences[n]);
        }
        delete this.references, delete this.playerReferences;
      },
      adPlayerErrorListener: function(n) {
        var i = n.data.AdError, a = [
          1012,
          // There was a problem requesting ads from the server.
          1005,
          // There was a problem requesting ads from the server
          301,
          // The VAST URI provided, or a VAST URI provided in a subsequent wrapper element,
          // was either unavailable or reached a timeout, as defined by the video player. The timeout is 5 seconds for initial VAST requests and each subsequent wrapper.
          402,
          // Failed to load media assets from a VAST response.
          302
          // The maximum number of VAST wrapper redirects has been reached.
        ], s = [
          1007,
          // No assets were found in the VAST ad response
          1009,
          // Empty VAST response
          303
          // No Ads VAST response after one or more wrappers
        ], o = [
          403,
          // Assets were found in the VAST ad response for linear ad, but none of them matched the video player's capabilities
          100,
          // The ad response was not recognized as a valid VAST ad
          503,
          // Assets were found in the VAST ad response for nonlinear ad, but none of them matched the video player's capabilities
          101,
          // VAST schema validation error.
          102
          // The ad response contained an unsupported VAST version
        ], u = i.getErrorCode(), l = i.getMessage();
        a.indexOf(u) >= 0 ? this.fireManifest(t.Constants.ManifestError.NO_RESPONSE, l) : s.indexOf(u) >= 0 ? this.fireManifest(t.Constants.ManifestError.EMPTY, l) : o.indexOf(u) >= 0 ? this.fireManifest(t.Constants.ManifestError.WRONG, l) : this.fireError(u, l);
      }
    },
    // Static Members
    {
      isUsed: function(n) {
        return typeof google < "u" && google.ima && n.player.ima;
      }
    }
  );
  return Fd = r, Fd;
}
var Ud, gm;
function jI() {
  if (gm)
    return Ud;
  gm = 1;
  var t = pi, e = rl, r = t.Adapter.extend(
    {
      getVersion: function() {
        return e.version + "-videojs-onceux-ads";
      },
      getResource: function() {
        return this.player.ads.contentSrc;
      },
      getPlayhead: function() {
        return this.player.onceux.currentTime();
      },
      getDuration: function() {
        return this.player.onceux.duration();
      },
      getPosition: function() {
        var n = t.Constants.AdPosition.Preroll;
        return this.plugin.getAdapter().flags.isJoined && (this.plugin.getAdapter().getPlayhead() <= this.plugin.getAdapter().getDuration() ? n = t.Constants.AdPosition.Midroll : n = t.Constants.AdPosition.Postroll), n;
      },
      registerListeners: function() {
        if (t.Util.logAllEvents(this.player, [
          null,
          "onceux-ads-complete",
          "onceux-adroll-start",
          "onceux-adroll-complete",
          "onceux-linearad-start",
          "onceux-linearad-impression",
          "onceux-linearad-complete",
          "onceux-linearad-skipped",
          "onceux-linearad-pause",
          "onceux-linearad-resume",
          "onceux-companionad-creativeView",
          "adserror",
          "ads-click"
        ]), this.monitorPlayhead(!0, !1), this.references = {
          "onceux-linearad-start": this.startedListener.bind(this),
          "onceux-linearad-pause": this.pausedListener.bind(this),
          "onceux-linearad-resume": this.resumedListener.bind(this),
          "onceux-linearad-complete": this.completeListener.bind(this),
          "onceux-linearad-skipped": this.skippedListener.bind(this),
          adserror: this.errorListener.bind(this),
          "ads-click": this.clickListener.bind(this)
        }, this.player)
          for (var n in this.references)
            this.player.on(n, this.references[n]);
      },
      unregisterListeners: function() {
        if (this.monitor && this.monitor.stop(), this.player && this.references) {
          for (var n in this.references)
            this.player.off(n, this.references[n]);
          delete this.references;
        }
      },
      startedListener: function(n) {
        this.fireStart(), this.fireJoin();
      },
      pausedListener: function(n) {
        this.firePause();
      },
      resumedListener: function(n) {
        this.fireResume();
      },
      completeListener: function(n) {
        this.fireStop({ adPlayhead: this.getDuration() });
      },
      skippedListener: function(n) {
        this.fireSkip();
      },
      errorListener: function(n) {
        this.fireError();
      },
      clickListener: function(n) {
        this.fireClick();
      }
    },
    // Static Members
    {
      isUsed: function(n) {
        return n.player.onceux;
      }
    }
  );
  return Ud = r, Ud;
}
var Vd, mm;
function HI() {
  if (mm)
    return Vd;
  mm = 1;
  var t = pi;
  return Vd = {
    getHls: function(e) {
      return e.getTech().vhs || e.getTech().hls || e.getTech().hls_;
    },
    isUsed: function(e) {
      return !!this.getHls(e);
    },
    getBitrate: function(e) {
      var r = null, n = this.getHls(e).playlists.media();
      if (e.player.qualityLevels) {
        var i = e.player.qualityLevels(), a = i[i.selectedIndex];
        a && (r = a.bitrate);
      } else
        n && n.attributes && n.attributes.BANDWIDTH ? r = n.attributes.BANDWIDTH : e.player.tech_ && e.player.tech_.vhs && e.player.tech_.vhs.stats ? r = e.player.tech_.vhs.stats.bandwidth : e.player.tech_ && e.player.tech_.hls && e.player.tech_.hls.bandwidth ? r = e.player.tech_.hls.bandwidth : e.player.hls && e.player.hls.bandwidth && (r = e.player.hls.bandwidth);
      return r;
    },
    getRendition: function(e) {
      var r = null, n = this.getHls(e).playlists.media();
      if (e.player.qualityLevels) {
        var i = e.player.qualityLevels(), a = i[i.selectedIndex];
        a && (r = t.Util.buildRenditionString(a.width, a.height, a.bitrate));
      } else if (n && n.attributes) {
        var s = n.attributes;
        s.RESOLUTION ? r = t.Util.buildRenditionString(
          s.RESOLUTION.width,
          s.RESOLUTION.height,
          s.BANDWIDTH
        ) : s.BANDWIDTH ? r = t.Util.buildRenditionString(s.BANDWIDTH) : s.NAME && (r = s.NAME);
      }
      return r;
    },
    getTotalBytes: function(e) {
      var r = this.getHls(e), n = r.bytesReceived;
      return !n && r.stats && (n = r.stats.mediaBytesTransferred - e.acumBytes), n;
    }
  }, Vd;
}
var jd, vm;
function WI() {
  if (vm)
    return jd;
  vm = 1;
  var t = pi;
  return jd = {
    getHls: function(e) {
      return this.getTech();
    },
    isUsed: function(e) {
      return !!this.getTech(e);
    },
    getResource: function(e) {
      var r = null;
      return this.getTech(e) && this.getTech(e).url ? r = this.getTech(e).url : this.getHls(e) && this.getHls(e).source_ && (r = this.getHls(e).source_.src), r;
    },
    getBitrate: function(e) {
      var r = null, n = this.getTech(e).currentLevel;
      if (typeof n < "u" && n !== -1 && this.getTech(e).levels) {
        var i = this.getTech(e).levels[n];
        i && i.bitrate && (r = i.bitrate);
      }
      return r;
    },
    getRendition: function(e) {
      var r = null, n = this.getTech(e).currentLevel;
      if (typeof n < "u" && n !== -1 && this.getTech(e).levels) {
        var i = this.getTech(e).levels[n];
        i && (r = t.Util.buildRenditionString(i.width, i.height, i.bitrate));
      }
      return r;
    },
    getTech: function(e) {
      var r = e.getTech();
      return r.vhs || r.hls || r.hls_;
    }
  }, jd;
}
var Hd, ym;
function qI() {
  if (ym)
    return Hd;
  ym = 1;
  var t = pi;
  return Hd = {
    _getShaka: function(e) {
      var r = e.getTech();
      return r.shakaPlayer || r._shakaplayerInstance;
    },
    isUsed: function(e) {
      return !!this._getShaka(e);
    },
    getResource: function(e) {
      var r = "", n = this._getShaka(e);
      return typeof n.getManifestUri == "function" ? r = n.getManifestUri() : typeof n.getCurrentSrc == "function" && (r = n.getCurrentSrc()), r;
    },
    getBitrate: function(e) {
      var r = -1, n = this._getShaka(e);
      if (typeof n.getStats == "function")
        r = n.getStats().streamBandwidth;
      else if (typeof n.getVideoTracks == "function" && typeof n.getVideoTrackCurrentIndex == "function") {
        var i = n.getVideoTrackCurrentIndex(), a = n.getVideoTracks();
        for (var s in a) {
          var o = a[s];
          o.index == i && (r = o.bitrate);
        }
      }
      return r;
    },
    getRendition: function(e) {
      var r = this._getShaka(e), n = r.getStats(), i = t.Util.buildRenditionString(n.width, n.height, n.streamBandwidth), a = r.getVariantTracks();
      for (var s in a) {
        var o = a[s];
        if (o.active && o.type === "video") {
          i = t.Util.buildRenditionString(o.width, o.height, o.bandwidth);
          break;
        }
      }
      return i;
    }
  }, Hd;
}
var Wd, _m;
function $I() {
  if (_m)
    return Wd;
  _m = 1;
  var t = pi;
  return Wd = {
    isUsed: function(e) {
      return e.player.dash && e.player.dash.shakaPlayer;
    },
    getResource: function(e) {
      var r = "", n = e.player.dash.shakaPlayer;
      return typeof n.getManifestUri == "function" ? r = n.getManifestUri() : typeof n.getAssetUri == "function" && (r = n.getAssetUri()), r;
    },
    getBitrate: function(e) {
      return e.player.dash.shakaPlayer.getStats().streamBandwidth;
    },
    getRendition: function(e) {
      var r = e.player.dash.shakaPlayer, n = r.getStats(), i = t.Util.buildRenditionString(n.width, n.height, n.streamBandwidth), a = r.getVariantTracks();
      for (var s in a) {
        var o = a[s];
        o.active && o.type === "video" && (i = t.Util.buildRenditionString(o.width, o.height, o.bandwidth));
      }
      return i;
    }
  }, Wd;
}
var qd, Tm;
function zI() {
  if (Tm)
    return qd;
  Tm = 1;
  var t = pi;
  return qd = {
    isUsed: function(e) {
      return e.player.dash && e.player.dash.mediaPlayer && !e.player.dash.shakaPlayer;
    },
    getResource: function(e) {
      return this._getDashPlayer(e).getSource();
    },
    getBitrate: function(e) {
      var r = null, n = this._getDashPlayer(e);
      if (n) {
        var i = n.getQualityFor("video");
        i && (r = n.getBitrateInfoListFor("video")[i].bitrate);
      }
      return r;
    },
    getRendition: function(e) {
      var r = null, n = this._getDashPlayer(e);
      if (n) {
        var i = n.getQualityFor("video");
        if (i) {
          var a = n.getBitrateInfoListFor("video")[i];
          a && (r = t.Util.buildRenditionString(a.width, a.height, a.bitrate));
        }
      }
      return r;
    },
    _getDashPlayer: function(e) {
      return e.player.dash.mediaPlayer;
    }
  }, qd;
}
var la = pi, $d = rl, it = la.Adapter.extend(
  {
    getVersion: function() {
      return $d.version + "-" + $d.name + "-" + $d.tech;
    },
    getTitle: function() {
      var t = null;
      return this.player.mediainfo && (t = this.player.mediainfo.name), t;
    },
    getPlayhead: function() {
      var t = this.player.currentTime();
      return this.plugin._adsAdapter && this.plugin._adsAdapter.flags.isStarted && (t = this.lastPlayhead || t), t;
    },
    getIsLive: function() {
      var t = null;
      return this.player.mediainfo && (t = !0, typeof this.player.mediainfo.duration == "number" && (t = this.player.mediainfo.duration < 1)), t;
    },
    getDuration: function() {
      var t = this.player.duration();
      return this.player.mediainfo && typeof this.player.mediainfo.duration < "u" && (t = this.player.mediainfo.duration), t;
    },
    getResource: function() {
      var t = null, e = this.getUsedTech();
      return e && e.getResource && (t = e.getResource(this)), t || (t = this.player.currentSrc()), t;
    },
    getBitrate: function() {
      var t = null, e = this.getUsedTech();
      return e && e.getBitrate && (t = e.getBitrate(this)), t;
    },
    getRendition: function() {
      var t = null, e = this.getUsedTech();
      return e && e.getRendition && (t = e.getRendition(this)), t;
    },
    getTotalBytes: function() {
      var t = null, e = this.getUsedTech();
      return e && e.getTotalBytes && (t = e.getTotalBytes(this)), t;
    },
    getPlayerName: function() {
      var t = "videojs";
      return it.ContribHlsTech.isUsed(this) ? t += "-hls" : it.HlsJsTech.isUsed(this) ? t += "-hlsjs" : it.ShakaTech.isUsed(this) ? t += "-shaka" : it.DashShakaTech.isUsed(this) ? t += "-dash-shaka" : it.DashTech.isUsed(this) && (t += "-dash"), it.ImaAdsAdapter.isUsed(this) ? t += "-ima" : it.OnceUXAdsAdapter.isUsed(this) ? this.pluginName += "-oux" : this.player.FreeWheelPlugin && (t += "-fw"), this.player.mediainfo && (t += "-bcove"), t;
    },
    getPlayerVersion: function() {
      var t = null;
      return typeof videojs < "u" && (t = videojs.VERSION), t;
    },
    getPlayrate: function() {
      return this.player.playbackRate();
    },
    getTech: function() {
      return this.player.tech({ IWillNotUseThisInPlugins: !0 });
    },
    getUsedTech: function() {
      var t = null;
      return it.ContribHlsTech.isUsed(this) ? t = it.ContribHlsTech : it.HlsJsTech.isUsed(this) ? t = it.HlsJsTech : it.ShakaTech.isUsed(this) ? t = it.ShakaTech : it.DashShakaTech.isUsed(this) ? t = it.DashShakaTech : it.DashTech.isUsed(this) && (t = it.DashTech), t;
    },
    registerListeners: function() {
      if (this.monitorPlayhead(!0, !1, 1200), this.acumBytes = 0, this.ignoreList = [], this.fatalList = [], this.nonFatalList = [], this.references = {
        loadstart: this.loadstartListener.bind(this),
        adsready: this.loadAdsAdapter.bind(this),
        play: this.playListener.bind(this),
        timeupdate: this.timeupdateListener.bind(this),
        pause: this.pauseListener.bind(this),
        playing: this.playingListener.bind(this),
        // abort: this.conditionalStop.bind(this),
        ended: this.conditionalStop.bind(this),
        dispose: this.disposeListener.bind(this),
        seeking: this.seekingListener.bind(this),
        seeked: this.seekedListener.bind(this),
        error: this.errorListener.bind(this),
        adserror: this.aderrorListener.bind(this),
        adsEnded: this.adsEndedListener.bind(this),
        texttrackchange: this.textListener.bind(this),
        waiting: this.bufferingListener.bind(this)
      }, this.player)
        for (var t in this.references)
          this.player.on(t, this.references[t]);
      setTimeout(this.loadAdsAdapter.bind(this), 50);
    },
    unregisterListeners: function() {
      if (this.monitor && this.monitor.stop(), this.player && this.references) {
        for (var t in this.references)
          this.player.off(t, this.references[t]);
        delete this.references;
      }
    },
    textListener: function(t) {
      if (this.player.textTracks)
        for (var e = this.player.textTracks(), r = e.length, n = 0; n < r; ++n)
          e[n] && e[n].mode === "showing" && (this.plugin.options["content.subtitles"] = e[n].label || e[n].language);
    },
    aderrorListener: function(t) {
      this.loadAdsAdapter(), this.plugin.getAdsAdapter() && this.plugin.getAdsAdapter().adPlayerErrorListener && this.plugin.getAdsAdapter().adPlayerErrorListener(t);
    },
    loadstartListener: function(t) {
      this.loadAdsAdapter(), la.Log.notice("Player detected " + this.getPlayerName());
    },
    playListener: function(t) {
      this.flags.isStarted ? this.lastSrc && this.lastSrc !== this.getResource() && (this.fireStop({}, "playListenerNewResource"), this.acumBytesFunc(), this.lastPlayhead = void 0, this._startEvent("playListenerNewResource"), this.lastSrc = this.getResource()) : (this.lastSrc = this.getResource(), this._startEvent("playListenerNotStarted"));
    },
    _startEvent: function(t) {
      this.loadAdsAdapter(), this.player.options_ && this.plugin && !this.plugin.options["content.id"] && (this.plugin.options["content.id"] = this.player.options_["data-video-id"]), this.fireStart({}, t), this.flags.isJoined || (this.joinPolling || (this.joinPolling = new la.Timer(this._jointimePolling.bind(this), 500)), this.joinPolling.start());
    },
    _jointimePolling: function(t) {
      this.plugin ? (!this.plugin.getAdsAdapter() || !this.plugin.getAdsAdapter().flags.isStarted) && (this.lastPlayhead !== 0 && typeof this.lastPlayhead == "number" && this.lastPlayhead !== this.getPlayhead() && (this.fireJoin({}, "jointimePolling"), this.joinPolling && this.joinPolling.stop()), this.lastPlayhead = this.getPlayhead()) : this.joinPolling && this.joinPolling.stop();
    },
    timeupdateListener: function(t) {
      this.getPlayhead() > 0.1 && (this.fireJoin({}, "timeupdateListener"), this.joinPolling && this.joinPolling.stop(), !this.flags.isPaused && this.lastSeekPlayhead && this.lastSeekPlayhead !== this.getPlayhead() && (this.fireSeekEnd({}, "timeupdateListener"), this.lastSeekPlayhead = !1)), this.flags.isJoined || (this.lastPlayhead === void 0 && (this.lastPlayhead = this.getPlayhead()), this.lastPlayhead !== this.getPlayhead() && (this.player.options_ && this.plugin && !this.plugin.options["content.id"] && (this.plugin.options["content.id"] = this.player.options_["data-video-id"]), this.fireStart({}, "timeupdateListener"), this.fireJoin({}, "timeupdateListener"), this.joinPolling && this.joinPolling.stop(), this.lastPlayhead = void 0)), this.plugin._adsAdapter && !this.plugin._adsAdapter.flags.isStarted && (this.lastPlayhead = this.getPlayhead());
    },
    pauseListener: function(t) {
      this.firePause({}, "pauseListener");
    },
    playingListener: function(t) {
      this._startEvent("playingListener"), this.fireResume({}, "playingListener"), this.getPlayhead() < 1 && this.fireSeekEnd({}, "playingListener");
    },
    disposeListener: function(t) {
      this.plugin && (this.plugin.fireStop({}, "disposeListener"), this.plugin.removeAdsAdapter(), this.plugin.removeAdapter());
    },
    conditionalStop: function(t) {
      this.plugin && (this.adsEnded = !1, this.fireStop({}, "conditionalStop"), this.plugin && !this.plugin.options["content.id"] && (this.plugin.options["content.id"] = null), this.acumBytesFunc(), this.lastPlayhead = void 0);
    },
    adsEndedListener: function(t) {
      this.adsEnded = !0, this.plugin.requestBuilder.lastSent.adPosition === la.Constants.AdPosition.Postroll && (this.plugin.fireStop({}, "adsEndedListener"), this.acumBytesFunc(), this.lastPlayhead = void 0);
    },
    seekingListener: function(t) {
      this.fireSeekBegin({}, !1, "seekingListener");
    },
    seekedListener: function(t) {
      this.lastSeekPlayhead = this.getPlayhead();
    },
    bufferingListener: function(t) {
      this.fireBufferBegin({}, !1, "bufferingListener");
    },
    errorListener: function(t) {
      var e = !1, r = !1, n = null, i = null;
      this.player.error && this.player.error() && (n = Number(this.player.error().code), i = this.player.error().message, (n === 2 || n === 4 || n < 0) && (r = !0)), n !== null && (this.ignoreList.includes(n) && (e = !0), !r && this.fatalList.includes(n) ? r = !0 : r && this.nonFatalList.includes(n) && (r = !1)), e || (r ? (this.fireFatalError(n, i, void 0, void 0, "errorListener"), this.acumBytesFunc(), this.lastPlayhead = void 0, this.crashed = !0) : this.fireError(n, i, void 0, void 0, "errorListener"));
    },
    loadAdsAdapter: function() {
      if (this.plugin)
        if (this.plugin.getAdsAdapter() === null || this.plugin.getAdsAdapter().isGeneric) {
          var t = null;
          it.ImaAdsAdapter.isUsed(this) ? t = new it.ImaAdsAdapter(this.player) : it.OnceUXAdsAdapter.isUsed(this) ? t = new it.OnceUXAdsAdapter(this.player) : it.BcoveImaAdsAdapter.isUsed(this) ? t = new it.BcoveImaAdsAdapter(this.player) : it.BcoveFreewheelAdsAdapter.isUsed(this) ? t = new it.BcoveFreewheelAdsAdapter(this.player) : it.FreewheelAdsAdapter.isUsed(this) ? t = new it.FreewheelAdsAdapter(this.player.freewheelAds.controller) : this.plugin.getAdsAdapter() === null && (t = new it.GenericAdsAdapter(this.player)), t && this.plugin.setAdsAdapter(t);
        } else
          this.plugin.getAdsAdapter().registerImaEvents && this.plugin.getAdsAdapter().registerImaEvents();
    },
    acumBytesFunc: function() {
      this.acumBytes += this.getTotalBytes() || 0;
    },
    errorModifyer: function(t, e, r) {
      this.fatalList = t || [], this.nonFatalList = e || [], this.ignoreList = r || [];
    }
  },
  // Static members
  {
    // Ads Adaptrs
    GenericAdsAdapter: xI(),
    BcoveImaAdsAdapter: CI(),
    BcoveFreewheelAdsAdapter: AI(),
    FreewheelAdsAdapter: UI(),
    ImaAdsAdapter: VI(),
    OnceUXAdsAdapter: jI(),
    // Techs
    ContribHlsTech: HI(),
    HlsJsTech: WI(),
    ShakaTech: qI(),
    DashShakaTech: $I(),
    DashTech: zI()
  }
);
la.adapters.Videojs = it;
la.adapters.Videojs;
const bm = {
  appProjectId: "extraparam.1",
  accountCode: "accountCode"
}, Es = {
  ANALYTICS_DISABLED: "[PixellotWebSDK|Analytics]: Analytics is disabled.",
  ANALYTICS_DISABLED_UPDATE_OPTIONS_ATTEMPT: "[PixellotWebSDK|Analytics]: Analytics options will not be updated since analytics is disabled.",
  EMPTY_APP_ID: "[PixellotWebSDK|Analytics]: `appProjectId` is required",
  EMPTY_APP_PROJECT_ID: "[PixellotWebSDK|Analytics]: `appProjectId` is required",
  EMPTY_ACCOUNT_CODE: "[PixellotWebSDK|Analytics]: `accountCode` is required",
  EMPTY_PLAYER_VERSION: "[PixellotWebSDK|Analytics]: `playerVersion` is required"
}, N_ = {
  playerVersion: "extraparam.2",
  contentTitle: "content.title",
  contentIsLive: "content.isLive",
  contentResource: "content.resource",
  rendition: "content.rendition",
  userID: "username",
  userType: "userType",
  eventType: "extraparam.4",
  clubName: "extraparam.5",
  entityID: "extraparam.6",
  videoMode: "extraparam.7",
  clubID: "extraparam.8",
  sportType: "extraparam.9",
  systemID: "extraparam.12",
  tenant: "extraparam.13",
  teamName: "extraparam.14",
  systemName: "extraparam.15",
  eventID: "extraparam.16",
  categoryName: "extraparam.17",
  entityType: "extraparam.19",
  teamID: "extraparam.20"
}, GI = {
  contentTitle: null,
  userID: null,
  userType: null,
  clubName: null,
  contentIsLive: null,
  contentResource: null,
  entityID: null,
  videoMode: null,
  clubID: null,
  sportType: null,
  eventType: null,
  systemID: null,
  tenant: null,
  teamName: null,
  systemName: null,
  eventID: null,
  categoryName: null,
  entityType: null,
  teamID: null,
  rendition: null
};
function KI(t) {
  if (!t.appProjectId)
    throw new Error(Es.EMPTY_APP_PROJECT_ID);
  if (!t.accountCode)
    throw new Error(Es.EMPTY_ACCOUNT_CODE);
  if (!t.playerVersion)
    throw new Error(Es.EMPTY_PLAYER_VERSION);
  return {
    [bm.accountCode]: t.accountCode,
    [bm.appProjectId]: `web-sdk-${t.appProjectId}`,
    [N_.playerVersion]: t.playerVersion
  };
}
function XI(t) {
  return Object.entries(t).reduce(
    (e, [r, n]) => {
      const i = N_[r];
      return i && n && (e[i] = String(n)), e;
    },
    {}
  );
}
function YI(t, e) {
  if (e === !1 || e === null || e === void 0)
    return console.warn(Es.ANALYTICS_DISABLED), null;
  const r = KI(e), n = pi.adapters.Videojs.extend({
    getPlayerVersion: function() {
      return P.VERSION;
    }
  }), i = new pi.Plugin(
    r,
    new n(t)
  );
  let a = {};
  function s(h) {
    u(), o(h);
  }
  function o(h) {
    if (!i) {
      console.warn(Es.ANALYTICS_DISABLED_UPDATE_OPTIONS_ATTEMPT);
      return;
    }
    const f = XI(h);
    i.setOptions(f), a = h;
  }
  function u() {
    o(GI);
  }
  function l() {
    i == null || i.disable();
  }
  function d() {
    return a;
  }
  return s(e), {
    plugin: i,
    getOptions: d,
    setOptions: s,
    updateOptions: o,
    clearOptions: u,
    destroy: l
  };
}
P.registerPlugin(
  "analytics",
  function(t) {
    const e = P.mergeOptions(
      {},
      t,
      this.options_.analytics
    );
    return Object.keys(e).length ? (this.analyticsAPI = YI(this, e), this.analyticsAPI) : (this.analyticsAPI && (this.analyticsAPI.destroy(), this.analyticsAPI = null), null);
  }
);
var Uc = "http://www.w3.org/1999/xhtml";
const Sm = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: Uc,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function nl(t) {
  var e = t += "", r = e.indexOf(":");
  return r >= 0 && (e = t.slice(0, r)) !== "xmlns" && (t = t.slice(r + 1)), Sm.hasOwnProperty(e) ? { space: Sm[e], local: t } : t;
}
function QI(t) {
  return function() {
    var e = this.ownerDocument, r = this.namespaceURI;
    return r === Uc && e.documentElement.namespaceURI === Uc ? e.createElement(t) : e.createElementNS(r, t);
  };
}
function JI(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function B_(t) {
  var e = nl(t);
  return (e.local ? JI : QI)(e);
}
function ZI() {
}
function bf(t) {
  return t == null ? ZI : function() {
    return this.querySelector(t);
  };
}
function eD(t) {
  typeof t != "function" && (t = bf(t));
  for (var e = this._groups, r = e.length, n = new Array(r), i = 0; i < r; ++i)
    for (var a = e[i], s = a.length, o = n[i] = new Array(s), u, l, d = 0; d < s; ++d)
      (u = a[d]) && (l = t.call(u, u.__data__, d, a)) && ("__data__" in u && (l.__data__ = u.__data__), o[d] = l);
  return new xi(n, this._parents);
}
function tD(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function iD() {
  return [];
}
function F_(t) {
  return t == null ? iD : function() {
    return this.querySelectorAll(t);
  };
}
function rD(t) {
  return function() {
    return tD(t.apply(this, arguments));
  };
}
function nD(t) {
  typeof t == "function" ? t = rD(t) : t = F_(t);
  for (var e = this._groups, r = e.length, n = [], i = [], a = 0; a < r; ++a)
    for (var s = e[a], o = s.length, u, l = 0; l < o; ++l)
      (u = s[l]) && (n.push(t.call(u, u.__data__, l, s)), i.push(u));
  return new xi(n, i);
}
function U_(t) {
  return function() {
    return this.matches(t);
  };
}
function V_(t) {
  return function(e) {
    return e.matches(t);
  };
}
var aD = Array.prototype.find;
function sD(t) {
  return function() {
    return aD.call(this.children, t);
  };
}
function oD() {
  return this.firstElementChild;
}
function uD(t) {
  return this.select(t == null ? oD : sD(typeof t == "function" ? t : V_(t)));
}
var lD = Array.prototype.filter;
function dD() {
  return Array.from(this.children);
}
function cD(t) {
  return function() {
    return lD.call(this.children, t);
  };
}
function hD(t) {
  return this.selectAll(t == null ? dD : cD(typeof t == "function" ? t : V_(t)));
}
function fD(t) {
  typeof t != "function" && (t = U_(t));
  for (var e = this._groups, r = e.length, n = new Array(r), i = 0; i < r; ++i)
    for (var a = e[i], s = a.length, o = n[i] = [], u, l = 0; l < s; ++l)
      (u = a[l]) && t.call(u, u.__data__, l, a) && o.push(u);
  return new xi(n, this._parents);
}
function j_(t) {
  return new Array(t.length);
}
function pD() {
  return new xi(this._enter || this._groups.map(j_), this._parents);
}
function Eu(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
Eu.prototype = {
  constructor: Eu,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function gD(t) {
  return function() {
    return t;
  };
}
function mD(t, e, r, n, i, a) {
  for (var s = 0, o, u = e.length, l = a.length; s < l; ++s)
    (o = e[s]) ? (o.__data__ = a[s], n[s] = o) : r[s] = new Eu(t, a[s]);
  for (; s < u; ++s)
    (o = e[s]) && (i[s] = o);
}
function vD(t, e, r, n, i, a, s) {
  var o, u, l = /* @__PURE__ */ new Map(), d = e.length, h = a.length, f = new Array(d), v;
  for (o = 0; o < d; ++o)
    (u = e[o]) && (f[o] = v = s.call(u, u.__data__, o, e) + "", l.has(v) ? i[o] = u : l.set(v, u));
  for (o = 0; o < h; ++o)
    v = s.call(t, a[o], o, a) + "", (u = l.get(v)) ? (n[o] = u, u.__data__ = a[o], l.delete(v)) : r[o] = new Eu(t, a[o]);
  for (o = 0; o < d; ++o)
    (u = e[o]) && l.get(f[o]) === u && (i[o] = u);
}
function yD(t) {
  return t.__data__;
}
function _D(t, e) {
  if (!arguments.length)
    return Array.from(this, yD);
  var r = e ? vD : mD, n = this._parents, i = this._groups;
  typeof t != "function" && (t = gD(t));
  for (var a = i.length, s = new Array(a), o = new Array(a), u = new Array(a), l = 0; l < a; ++l) {
    var d = n[l], h = i[l], f = h.length, v = TD(t.call(d, d && d.__data__, l, n)), b = v.length, _ = o[l] = new Array(b), y = s[l] = new Array(b), E = u[l] = new Array(f);
    r(d, h, _, y, E, v, e);
    for (var R = 0, D = 0, C, w; R < b; ++R)
      if (C = _[R]) {
        for (R >= D && (D = R + 1); !(w = y[D]) && ++D < b; )
          ;
        C._next = w || null;
      }
  }
  return s = new xi(s, n), s._enter = o, s._exit = u, s;
}
function TD(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function bD() {
  return new xi(this._exit || this._groups.map(j_), this._parents);
}
function SD(t, e, r) {
  var n = this.enter(), i = this, a = this.exit();
  return typeof t == "function" ? (n = t(n), n && (n = n.selection())) : n = n.append(t + ""), e != null && (i = e(i), i && (i = i.selection())), r == null ? a.remove() : r(a), n && i ? n.merge(i).order() : i;
}
function ED(t) {
  for (var e = t.selection ? t.selection() : t, r = this._groups, n = e._groups, i = r.length, a = n.length, s = Math.min(i, a), o = new Array(i), u = 0; u < s; ++u)
    for (var l = r[u], d = n[u], h = l.length, f = o[u] = new Array(h), v, b = 0; b < h; ++b)
      (v = l[b] || d[b]) && (f[b] = v);
  for (; u < i; ++u)
    o[u] = r[u];
  return new xi(o, this._parents);
}
function xD() {
  for (var t = this._groups, e = -1, r = t.length; ++e < r; )
    for (var n = t[e], i = n.length - 1, a = n[i], s; --i >= 0; )
      (s = n[i]) && (a && s.compareDocumentPosition(a) ^ 4 && a.parentNode.insertBefore(s, a), a = s);
  return this;
}
function CD(t) {
  t || (t = AD);
  function e(h, f) {
    return h && f ? t(h.__data__, f.__data__) : !h - !f;
  }
  for (var r = this._groups, n = r.length, i = new Array(n), a = 0; a < n; ++a) {
    for (var s = r[a], o = s.length, u = i[a] = new Array(o), l, d = 0; d < o; ++d)
      (l = s[d]) && (u[d] = l);
    u.sort(e);
  }
  return new xi(i, this._parents).order();
}
function AD(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function wD() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function PD() {
  return Array.from(this);
}
function kD() {
  for (var t = this._groups, e = 0, r = t.length; e < r; ++e)
    for (var n = t[e], i = 0, a = n.length; i < a; ++i) {
      var s = n[i];
      if (s)
        return s;
    }
  return null;
}
function LD() {
  let t = 0;
  for (const e of this)
    ++t;
  return t;
}
function ID() {
  return !this.node();
}
function DD(t) {
  for (var e = this._groups, r = 0, n = e.length; r < n; ++r)
    for (var i = e[r], a = 0, s = i.length, o; a < s; ++a)
      (o = i[a]) && t.call(o, o.__data__, a, i);
  return this;
}
function RD(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function OD(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function MD(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function ND(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function BD(t, e) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.removeAttribute(t) : this.setAttribute(t, r);
  };
}
function FD(t, e) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, r);
  };
}
function UD(t, e) {
  var r = nl(t);
  if (arguments.length < 2) {
    var n = this.node();
    return r.local ? n.getAttributeNS(r.space, r.local) : n.getAttribute(r);
  }
  return this.each((e == null ? r.local ? OD : RD : typeof e == "function" ? r.local ? FD : BD : r.local ? ND : MD)(r, e));
}
function H_(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function VD(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function jD(t, e, r) {
  return function() {
    this.style.setProperty(t, e, r);
  };
}
function HD(t, e, r) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.style.removeProperty(t) : this.style.setProperty(t, n, r);
  };
}
function WD(t, e, r) {
  return arguments.length > 1 ? this.each((e == null ? VD : typeof e == "function" ? HD : jD)(t, e, r ?? "")) : La(this.node(), t);
}
function La(t, e) {
  return t.style.getPropertyValue(e) || H_(t).getComputedStyle(t, null).getPropertyValue(e);
}
function qD(t) {
  return function() {
    delete this[t];
  };
}
function $D(t, e) {
  return function() {
    this[t] = e;
  };
}
function zD(t, e) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? delete this[t] : this[t] = r;
  };
}
function GD(t, e) {
  return arguments.length > 1 ? this.each((e == null ? qD : typeof e == "function" ? zD : $D)(t, e)) : this.node()[t];
}
function W_(t) {
  return t.trim().split(/^|\s+/);
}
function Sf(t) {
  return t.classList || new q_(t);
}
function q_(t) {
  this._node = t, this._names = W_(t.getAttribute("class") || "");
}
q_.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function $_(t, e) {
  for (var r = Sf(t), n = -1, i = e.length; ++n < i; )
    r.add(e[n]);
}
function z_(t, e) {
  for (var r = Sf(t), n = -1, i = e.length; ++n < i; )
    r.remove(e[n]);
}
function KD(t) {
  return function() {
    $_(this, t);
  };
}
function XD(t) {
  return function() {
    z_(this, t);
  };
}
function YD(t, e) {
  return function() {
    (e.apply(this, arguments) ? $_ : z_)(this, t);
  };
}
function QD(t, e) {
  var r = W_(t + "");
  if (arguments.length < 2) {
    for (var n = Sf(this.node()), i = -1, a = r.length; ++i < a; )
      if (!n.contains(r[i]))
        return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? YD : e ? KD : XD)(r, e));
}
function JD() {
  this.textContent = "";
}
function ZD(t) {
  return function() {
    this.textContent = t;
  };
}
function eR(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function tR(t) {
  return arguments.length ? this.each(t == null ? JD : (typeof t == "function" ? eR : ZD)(t)) : this.node().textContent;
}
function iR() {
  this.innerHTML = "";
}
function rR(t) {
  return function() {
    this.innerHTML = t;
  };
}
function nR(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function aR(t) {
  return arguments.length ? this.each(t == null ? iR : (typeof t == "function" ? nR : rR)(t)) : this.node().innerHTML;
}
function sR() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function oR() {
  return this.each(sR);
}
function uR() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function lR() {
  return this.each(uR);
}
function dR(t) {
  var e = typeof t == "function" ? t : B_(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function cR() {
  return null;
}
function hR(t, e) {
  var r = typeof t == "function" ? t : B_(t), n = e == null ? cR : typeof e == "function" ? e : bf(e);
  return this.select(function() {
    return this.insertBefore(r.apply(this, arguments), n.apply(this, arguments) || null);
  });
}
function fR() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function pR() {
  return this.each(fR);
}
function gR() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function mR() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function vR(t) {
  return this.select(t ? mR : gR);
}
function yR(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function _R(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function TR(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var r = "", n = e.indexOf(".");
    return n >= 0 && (r = e.slice(n + 1), e = e.slice(0, n)), { type: e, name: r };
  });
}
function bR(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var r = 0, n = -1, i = e.length, a; r < i; ++r)
        a = e[r], (!t.type || a.type === t.type) && a.name === t.name ? this.removeEventListener(a.type, a.listener, a.options) : e[++n] = a;
      ++n ? e.length = n : delete this.__on;
    }
  };
}
function SR(t, e, r) {
  return function() {
    var n = this.__on, i, a = _R(e);
    if (n) {
      for (var s = 0, o = n.length; s < o; ++s)
        if ((i = n[s]).type === t.type && i.name === t.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = a, i.options = r), i.value = e;
          return;
        }
    }
    this.addEventListener(t.type, a, r), i = { type: t.type, name: t.name, value: e, listener: a, options: r }, n ? n.push(i) : this.__on = [i];
  };
}
function ER(t, e, r) {
  var n = TR(t + ""), i, a = n.length, s;
  if (arguments.length < 2) {
    var o = this.node().__on;
    if (o) {
      for (var u = 0, l = o.length, d; u < l; ++u)
        for (i = 0, d = o[u]; i < a; ++i)
          if ((s = n[i]).type === d.type && s.name === d.name)
            return d.value;
    }
    return;
  }
  for (o = e ? SR : bR, i = 0; i < a; ++i)
    this.each(o(n[i], e, r));
  return this;
}
function G_(t, e, r) {
  var n = H_(t), i = n.CustomEvent;
  typeof i == "function" ? i = new i(e, r) : (i = n.document.createEvent("Event"), r ? (i.initEvent(e, r.bubbles, r.cancelable), i.detail = r.detail) : i.initEvent(e, !1, !1)), t.dispatchEvent(i);
}
function xR(t, e) {
  return function() {
    return G_(this, t, e);
  };
}
function CR(t, e) {
  return function() {
    return G_(this, t, e.apply(this, arguments));
  };
}
function AR(t, e) {
  return this.each((typeof e == "function" ? CR : xR)(t, e));
}
function* wR() {
  for (var t = this._groups, e = 0, r = t.length; e < r; ++e)
    for (var n = t[e], i = 0, a = n.length, s; i < a; ++i)
      (s = n[i]) && (yield s);
}
var K_ = [null];
function xi(t, e) {
  this._groups = t, this._parents = e;
}
function Zs() {
  return new xi([[document.documentElement]], K_);
}
function PR() {
  return this;
}
xi.prototype = Zs.prototype = {
  constructor: xi,
  select: eD,
  selectAll: nD,
  selectChild: uD,
  selectChildren: hD,
  filter: fD,
  data: _D,
  enter: pD,
  exit: bD,
  join: SD,
  merge: ED,
  selection: PR,
  order: xD,
  sort: CD,
  call: wD,
  nodes: PD,
  node: kD,
  size: LD,
  empty: ID,
  each: DD,
  attr: UD,
  style: WD,
  property: GD,
  classed: QD,
  text: tR,
  html: aR,
  raise: oR,
  lower: lR,
  append: dR,
  insert: hR,
  remove: pR,
  clone: vR,
  datum: yR,
  on: ER,
  dispatch: AR,
  [Symbol.iterator]: wR
};
function Wt(t) {
  return typeof t == "string" ? new xi([[document.querySelector(t)]], [document.documentElement]) : new xi([[t]], K_);
}
function kR(t) {
  let e;
  for (; e = t.sourceEvent; )
    t = e;
  return t;
}
function Tr(t, e) {
  if (t = kR(t), e === void 0 && (e = t.currentTarget), e) {
    var r = e.ownerSVGElement || e;
    if (r.createSVGPoint) {
      var n = r.createSVGPoint();
      return n.x = t.clientX, n.y = t.clientY, n = n.matrixTransform(e.getScreenCTM().inverse()), [n.x, n.y];
    }
    if (e.getBoundingClientRect) {
      var i = e.getBoundingClientRect();
      return [t.clientX - i.left - e.clientLeft, t.clientY - i.top - e.clientTop];
    }
  }
  return [t.pageX, t.pageY];
}
var LR = { value: () => {
} };
function al() {
  for (var t = 0, e = arguments.length, r = {}, n; t < e; ++t) {
    if (!(n = arguments[t] + "") || n in r || /[\s.]/.test(n))
      throw new Error("illegal type: " + n);
    r[n] = [];
  }
  return new $o(r);
}
function $o(t) {
  this._ = t;
}
function IR(t, e) {
  return t.trim().split(/^|\s+/).map(function(r) {
    var n = "", i = r.indexOf(".");
    if (i >= 0 && (n = r.slice(i + 1), r = r.slice(0, i)), r && !e.hasOwnProperty(r))
      throw new Error("unknown type: " + r);
    return { type: r, name: n };
  });
}
$o.prototype = al.prototype = {
  constructor: $o,
  on: function(t, e) {
    var r = this._, n = IR(t + "", r), i, a = -1, s = n.length;
    if (arguments.length < 2) {
      for (; ++a < s; )
        if ((i = (t = n[a]).type) && (i = DR(r[i], t.name)))
          return i;
      return;
    }
    if (e != null && typeof e != "function")
      throw new Error("invalid callback: " + e);
    for (; ++a < s; )
      if (i = (t = n[a]).type)
        r[i] = Em(r[i], t.name, e);
      else if (e == null)
        for (i in r)
          r[i] = Em(r[i], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var r in e)
      t[r] = e[r].slice();
    return new $o(t);
  },
  call: function(t, e) {
    if ((i = arguments.length - 2) > 0)
      for (var r = new Array(i), n = 0, i, a; n < i; ++n)
        r[n] = arguments[n + 2];
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (a = this._[t], n = 0, i = a.length; n < i; ++n)
      a[n].value.apply(e, r);
  },
  apply: function(t, e, r) {
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (var n = this._[t], i = 0, a = n.length; i < a; ++i)
      n[i].value.apply(e, r);
  }
};
function DR(t, e) {
  for (var r = 0, n = t.length, i; r < n; ++r)
    if ((i = t[r]).name === e)
      return i.value;
}
function Em(t, e, r) {
  for (var n = 0, i = t.length; n < i; ++n)
    if (t[n].name === e) {
      t[n] = LR, t = t.slice(0, n).concat(t.slice(n + 1));
      break;
    }
  return r != null && t.push({ name: e, value: r }), t;
}
const Vc = { capture: !0, passive: !1 };
function jc(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function X_(t) {
  var e = t.document.documentElement, r = Wt(t).on("dragstart.drag", jc, Vc);
  "onselectstart" in e ? r.on("selectstart.drag", jc, Vc) : (e.__noselect = e.style.MozUserSelect, e.style.MozUserSelect = "none");
}
function Y_(t, e) {
  var r = t.document.documentElement, n = Wt(t).on("dragstart.drag", null);
  e && (n.on("click.drag", jc, Vc), setTimeout(function() {
    n.on("click.drag", null);
  }, 0)), "onselectstart" in r ? n.on("selectstart.drag", null) : (r.style.MozUserSelect = r.__noselect, delete r.__noselect);
}
function Ef(t, e, r) {
  t.prototype = e.prototype = r, r.constructor = t;
}
function Q_(t, e) {
  var r = Object.create(t.prototype);
  for (var n in e)
    r[n] = e[n];
  return r;
}
function eo() {
}
var Ms = 0.7, xu = 1 / Ms, ma = "\\s*([+-]?\\d+)\\s*", Ns = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", sr = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", RR = /^#([0-9a-f]{3,8})$/, OR = new RegExp(`^rgb\\(${ma},${ma},${ma}\\)$`), MR = new RegExp(`^rgb\\(${sr},${sr},${sr}\\)$`), NR = new RegExp(`^rgba\\(${ma},${ma},${ma},${Ns}\\)$`), BR = new RegExp(`^rgba\\(${sr},${sr},${sr},${Ns}\\)$`), FR = new RegExp(`^hsl\\(${Ns},${sr},${sr}\\)$`), UR = new RegExp(`^hsla\\(${Ns},${sr},${sr},${Ns}\\)$`), xm = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Ef(eo, Cn, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Cm,
  // Deprecated! Use color.formatHex.
  formatHex: Cm,
  formatHex8: VR,
  formatHsl: jR,
  formatRgb: Am,
  toString: Am
});
function Cm() {
  return this.rgb().formatHex();
}
function VR() {
  return this.rgb().formatHex8();
}
function jR() {
  return J_(this).formatHsl();
}
function Am() {
  return this.rgb().formatRgb();
}
function Cn(t) {
  var e, r;
  return t = (t + "").trim().toLowerCase(), (e = RR.exec(t)) ? (r = e[1].length, e = parseInt(e[1], 16), r === 6 ? wm(e) : r === 3 ? new fi(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : r === 8 ? Ro(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : r === 4 ? Ro(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = OR.exec(t)) ? new fi(e[1], e[2], e[3], 1) : (e = MR.exec(t)) ? new fi(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = NR.exec(t)) ? Ro(e[1], e[2], e[3], e[4]) : (e = BR.exec(t)) ? Ro(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = FR.exec(t)) ? Lm(e[1], e[2] / 100, e[3] / 100, 1) : (e = UR.exec(t)) ? Lm(e[1], e[2] / 100, e[3] / 100, e[4]) : xm.hasOwnProperty(t) ? wm(xm[t]) : t === "transparent" ? new fi(NaN, NaN, NaN, 0) : null;
}
function wm(t) {
  return new fi(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function Ro(t, e, r, n) {
  return n <= 0 && (t = e = r = NaN), new fi(t, e, r, n);
}
function HR(t) {
  return t instanceof eo || (t = Cn(t)), t ? (t = t.rgb(), new fi(t.r, t.g, t.b, t.opacity)) : new fi();
}
function Hc(t, e, r, n) {
  return arguments.length === 1 ? HR(t) : new fi(t, e, r, n ?? 1);
}
function fi(t, e, r, n) {
  this.r = +t, this.g = +e, this.b = +r, this.opacity = +n;
}
Ef(fi, Hc, Q_(eo, {
  brighter(t) {
    return t = t == null ? xu : Math.pow(xu, t), new fi(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? Ms : Math.pow(Ms, t), new fi(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new fi(En(this.r), En(this.g), En(this.b), Cu(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Pm,
  // Deprecated! Use color.formatHex.
  formatHex: Pm,
  formatHex8: WR,
  formatRgb: km,
  toString: km
}));
function Pm() {
  return `#${yn(this.r)}${yn(this.g)}${yn(this.b)}`;
}
function WR() {
  return `#${yn(this.r)}${yn(this.g)}${yn(this.b)}${yn((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function km() {
  const t = Cu(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${En(this.r)}, ${En(this.g)}, ${En(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function Cu(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function En(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function yn(t) {
  return t = En(t), (t < 16 ? "0" : "") + t.toString(16);
}
function Lm(t, e, r, n) {
  return n <= 0 ? t = e = r = NaN : r <= 0 || r >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new Bi(t, e, r, n);
}
function J_(t) {
  if (t instanceof Bi)
    return new Bi(t.h, t.s, t.l, t.opacity);
  if (t instanceof eo || (t = Cn(t)), !t)
    return new Bi();
  if (t instanceof Bi)
    return t;
  t = t.rgb();
  var e = t.r / 255, r = t.g / 255, n = t.b / 255, i = Math.min(e, r, n), a = Math.max(e, r, n), s = NaN, o = a - i, u = (a + i) / 2;
  return o ? (e === a ? s = (r - n) / o + (r < n) * 6 : r === a ? s = (n - e) / o + 2 : s = (e - r) / o + 4, o /= u < 0.5 ? a + i : 2 - a - i, s *= 60) : o = u > 0 && u < 1 ? 0 : s, new Bi(s, o, u, t.opacity);
}
function qR(t, e, r, n) {
  return arguments.length === 1 ? J_(t) : new Bi(t, e, r, n ?? 1);
}
function Bi(t, e, r, n) {
  this.h = +t, this.s = +e, this.l = +r, this.opacity = +n;
}
Ef(Bi, qR, Q_(eo, {
  brighter(t) {
    return t = t == null ? xu : Math.pow(xu, t), new Bi(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? Ms : Math.pow(Ms, t), new Bi(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * e, i = 2 * r - n;
    return new fi(
      zd(t >= 240 ? t - 240 : t + 120, i, n),
      zd(t, i, n),
      zd(t < 120 ? t + 240 : t - 120, i, n),
      this.opacity
    );
  },
  clamp() {
    return new Bi(Im(this.h), Oo(this.s), Oo(this.l), Cu(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = Cu(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${Im(this.h)}, ${Oo(this.s) * 100}%, ${Oo(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function Im(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function Oo(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function zd(t, e, r) {
  return (t < 60 ? e + (r - e) * t / 60 : t < 180 ? r : t < 240 ? e + (r - e) * (240 - t) / 60 : e) * 255;
}
const xf = (t) => () => t;
function $R(t, e) {
  return function(r) {
    return t + r * e;
  };
}
function zR(t, e, r) {
  return t = Math.pow(t, r), e = Math.pow(e, r) - t, r = 1 / r, function(n) {
    return Math.pow(t + n * e, r);
  };
}
function GR(t) {
  return (t = +t) == 1 ? Z_ : function(e, r) {
    return r - e ? zR(e, r, t) : xf(isNaN(e) ? r : e);
  };
}
function Z_(t, e) {
  var r = e - t;
  return r ? $R(t, r) : xf(isNaN(t) ? e : t);
}
const Au = function t(e) {
  var r = GR(e);
  function n(i, a) {
    var s = r((i = Hc(i)).r, (a = Hc(a)).r), o = r(i.g, a.g), u = r(i.b, a.b), l = Z_(i.opacity, a.opacity);
    return function(d) {
      return i.r = s(d), i.g = o(d), i.b = u(d), i.opacity = l(d), i + "";
    };
  }
  return n.gamma = t, n;
}(1);
function KR(t, e) {
  e || (e = []);
  var r = t ? Math.min(e.length, t.length) : 0, n = e.slice(), i;
  return function(a) {
    for (i = 0; i < r; ++i)
      n[i] = t[i] * (1 - a) + e[i] * a;
    return n;
  };
}
function XR(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function YR(t, e) {
  var r = e ? e.length : 0, n = t ? Math.min(r, t.length) : 0, i = new Array(n), a = new Array(r), s;
  for (s = 0; s < n; ++s)
    i[s] = sl(t[s], e[s]);
  for (; s < r; ++s)
    a[s] = e[s];
  return function(o) {
    for (s = 0; s < n; ++s)
      a[s] = i[s](o);
    return a;
  };
}
function QR(t, e) {
  var r = /* @__PURE__ */ new Date();
  return t = +t, e = +e, function(n) {
    return r.setTime(t * (1 - n) + e * n), r;
  };
}
function Ni(t, e) {
  return t = +t, e = +e, function(r) {
    return t * (1 - r) + e * r;
  };
}
function JR(t, e) {
  var r = {}, n = {}, i;
  (t === null || typeof t != "object") && (t = {}), (e === null || typeof e != "object") && (e = {});
  for (i in e)
    i in t ? r[i] = sl(t[i], e[i]) : n[i] = e[i];
  return function(a) {
    for (i in r)
      n[i] = r[i](a);
    return n;
  };
}
var Wc = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Gd = new RegExp(Wc.source, "g");
function ZR(t) {
  return function() {
    return t;
  };
}
function eO(t) {
  return function(e) {
    return t(e) + "";
  };
}
function eT(t, e) {
  var r = Wc.lastIndex = Gd.lastIndex = 0, n, i, a, s = -1, o = [], u = [];
  for (t = t + "", e = e + ""; (n = Wc.exec(t)) && (i = Gd.exec(e)); )
    (a = i.index) > r && (a = e.slice(r, a), o[s] ? o[s] += a : o[++s] = a), (n = n[0]) === (i = i[0]) ? o[s] ? o[s] += i : o[++s] = i : (o[++s] = null, u.push({ i: s, x: Ni(n, i) })), r = Gd.lastIndex;
  return r < e.length && (a = e.slice(r), o[s] ? o[s] += a : o[++s] = a), o.length < 2 ? u[0] ? eO(u[0].x) : ZR(e) : (e = u.length, function(l) {
    for (var d = 0, h; d < e; ++d)
      o[(h = u[d]).i] = h.x(l);
    return o.join("");
  });
}
function sl(t, e) {
  var r = typeof e, n;
  return e == null || r === "boolean" ? xf(e) : (r === "number" ? Ni : r === "string" ? (n = Cn(e)) ? (e = n, Au) : eT : e instanceof Cn ? Au : e instanceof Date ? QR : XR(e) ? KR : Array.isArray(e) ? YR : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? JR : Ni)(t, e);
}
function tO(t, e) {
  return t = +t, e = +e, function(r) {
    return Math.round(t * (1 - r) + e * r);
  };
}
var Dm = 180 / Math.PI, qc = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function tT(t, e, r, n, i, a) {
  var s, o, u;
  return (s = Math.sqrt(t * t + e * e)) && (t /= s, e /= s), (u = t * r + e * n) && (r -= t * u, n -= e * u), (o = Math.sqrt(r * r + n * n)) && (r /= o, n /= o, u /= o), t * n < e * r && (t = -t, e = -e, u = -u, s = -s), {
    translateX: i,
    translateY: a,
    rotate: Math.atan2(e, t) * Dm,
    skewX: Math.atan(u) * Dm,
    scaleX: s,
    scaleY: o
  };
}
var Mo;
function iO(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? qc : tT(e.a, e.b, e.c, e.d, e.e, e.f);
}
function rO(t) {
  return t == null || (Mo || (Mo = document.createElementNS("http://www.w3.org/2000/svg", "g")), Mo.setAttribute("transform", t), !(t = Mo.transform.baseVal.consolidate())) ? qc : (t = t.matrix, tT(t.a, t.b, t.c, t.d, t.e, t.f));
}
function iT(t, e, r, n) {
  function i(l) {
    return l.length ? l.pop() + " " : "";
  }
  function a(l, d, h, f, v, b) {
    if (l !== h || d !== f) {
      var _ = v.push("translate(", null, e, null, r);
      b.push({ i: _ - 4, x: Ni(l, h) }, { i: _ - 2, x: Ni(d, f) });
    } else
      (h || f) && v.push("translate(" + h + e + f + r);
  }
  function s(l, d, h, f) {
    l !== d ? (l - d > 180 ? d += 360 : d - l > 180 && (l += 360), f.push({ i: h.push(i(h) + "rotate(", null, n) - 2, x: Ni(l, d) })) : d && h.push(i(h) + "rotate(" + d + n);
  }
  function o(l, d, h, f) {
    l !== d ? f.push({ i: h.push(i(h) + "skewX(", null, n) - 2, x: Ni(l, d) }) : d && h.push(i(h) + "skewX(" + d + n);
  }
  function u(l, d, h, f, v, b) {
    if (l !== h || d !== f) {
      var _ = v.push(i(v) + "scale(", null, ",", null, ")");
      b.push({ i: _ - 4, x: Ni(l, h) }, { i: _ - 2, x: Ni(d, f) });
    } else
      (h !== 1 || f !== 1) && v.push(i(v) + "scale(" + h + "," + f + ")");
  }
  return function(l, d) {
    var h = [], f = [];
    return l = t(l), d = t(d), a(l.translateX, l.translateY, d.translateX, d.translateY, h, f), s(l.rotate, d.rotate, h, f), o(l.skewX, d.skewX, h, f), u(l.scaleX, l.scaleY, d.scaleX, d.scaleY, h, f), l = d = null, function(v) {
      for (var b = -1, _ = f.length, y; ++b < _; )
        h[(y = f[b]).i] = y.x(v);
      return h.join("");
    };
  };
}
var nO = iT(iO, "px, ", "px)", "deg)"), aO = iT(rO, ", ", ")", ")"), sO = 1e-12;
function Rm(t) {
  return ((t = Math.exp(t)) + 1 / t) / 2;
}
function oO(t) {
  return ((t = Math.exp(t)) - 1 / t) / 2;
}
function uO(t) {
  return ((t = Math.exp(2 * t)) - 1) / (t + 1);
}
const lO = function t(e, r, n) {
  function i(a, s) {
    var o = a[0], u = a[1], l = a[2], d = s[0], h = s[1], f = s[2], v = d - o, b = h - u, _ = v * v + b * b, y, E;
    if (_ < sO)
      E = Math.log(f / l) / e, y = function(I) {
        return [
          o + I * v,
          u + I * b,
          l * Math.exp(e * I * E)
        ];
      };
    else {
      var R = Math.sqrt(_), D = (f * f - l * l + n * _) / (2 * l * r * R), C = (f * f - l * l - n * _) / (2 * f * r * R), w = Math.log(Math.sqrt(D * D + 1) - D), k = Math.log(Math.sqrt(C * C + 1) - C);
      E = (k - w) / e, y = function(I) {
        var U = I * E, $ = Rm(w), W = l / (r * R) * ($ * uO(e * U + w) - oO(w));
        return [
          o + W * v,
          u + W * b,
          l * $ / Rm(e * U + w)
        ];
      };
    }
    return y.duration = E * 1e3 * e / Math.SQRT2, y;
  }
  return i.rho = function(a) {
    var s = Math.max(1e-3, +a), o = s * s, u = o * o;
    return t(s, o, u);
  }, i;
}(Math.SQRT2, 2, 4);
var Ia = 0, ms = 0, os = 0, rT = 1e3, wu, vs, Pu = 0, An = 0, ol = 0, Bs = typeof performance == "object" && performance.now ? performance : Date, nT = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function Cf() {
  return An || (nT(dO), An = Bs.now() + ol);
}
function dO() {
  An = 0;
}
function ku() {
  this._call = this._time = this._next = null;
}
ku.prototype = aT.prototype = {
  constructor: ku,
  restart: function(t, e, r) {
    if (typeof t != "function")
      throw new TypeError("callback is not a function");
    r = (r == null ? Cf() : +r) + (e == null ? 0 : +e), !this._next && vs !== this && (vs ? vs._next = this : wu = this, vs = this), this._call = t, this._time = r, $c();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, $c());
  }
};
function aT(t, e, r) {
  var n = new ku();
  return n.restart(t, e, r), n;
}
function cO() {
  Cf(), ++Ia;
  for (var t = wu, e; t; )
    (e = An - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --Ia;
}
function Om() {
  An = (Pu = Bs.now()) + ol, Ia = ms = 0;
  try {
    cO();
  } finally {
    Ia = 0, fO(), An = 0;
  }
}
function hO() {
  var t = Bs.now(), e = t - Pu;
  e > rT && (ol -= e, Pu = t);
}
function fO() {
  for (var t, e = wu, r, n = 1 / 0; e; )
    e._call ? (n > e._time && (n = e._time), t = e, e = e._next) : (r = e._next, e._next = null, e = t ? t._next = r : wu = r);
  vs = t, $c(n);
}
function $c(t) {
  if (!Ia) {
    ms && (ms = clearTimeout(ms));
    var e = t - An;
    e > 24 ? (t < 1 / 0 && (ms = setTimeout(Om, t - Bs.now() - ol)), os && (os = clearInterval(os))) : (os || (Pu = Bs.now(), os = setInterval(hO, rT)), Ia = 1, nT(Om));
  }
}
function Mm(t, e, r) {
  var n = new ku();
  return e = e == null ? 0 : +e, n.restart((i) => {
    n.stop(), t(i + e);
  }, e, r), n;
}
var pO = al("start", "end", "cancel", "interrupt"), gO = [], sT = 0, Nm = 1, zc = 2, zo = 3, Bm = 4, Gc = 5, Go = 6;
function ul(t, e, r, n, i, a) {
  var s = t.__transition;
  if (!s)
    t.__transition = {};
  else if (r in s)
    return;
  mO(t, r, {
    name: e,
    index: n,
    // For context during callback.
    group: i,
    // For context during callback.
    on: pO,
    tween: gO,
    time: a.time,
    delay: a.delay,
    duration: a.duration,
    ease: a.ease,
    timer: null,
    state: sT
  });
}
function Af(t, e) {
  var r = qi(t, e);
  if (r.state > sT)
    throw new Error("too late; already scheduled");
  return r;
}
function cr(t, e) {
  var r = qi(t, e);
  if (r.state > zo)
    throw new Error("too late; already running");
  return r;
}
function qi(t, e) {
  var r = t.__transition;
  if (!r || !(r = r[e]))
    throw new Error("transition not found");
  return r;
}
function mO(t, e, r) {
  var n = t.__transition, i;
  n[e] = r, r.timer = aT(a, 0, r.time);
  function a(l) {
    r.state = Nm, r.timer.restart(s, r.delay, r.time), r.delay <= l && s(l - r.delay);
  }
  function s(l) {
    var d, h, f, v;
    if (r.state !== Nm)
      return u();
    for (d in n)
      if (v = n[d], v.name === r.name) {
        if (v.state === zo)
          return Mm(s);
        v.state === Bm ? (v.state = Go, v.timer.stop(), v.on.call("interrupt", t, t.__data__, v.index, v.group), delete n[d]) : +d < e && (v.state = Go, v.timer.stop(), v.on.call("cancel", t, t.__data__, v.index, v.group), delete n[d]);
      }
    if (Mm(function() {
      r.state === zo && (r.state = Bm, r.timer.restart(o, r.delay, r.time), o(l));
    }), r.state = zc, r.on.call("start", t, t.__data__, r.index, r.group), r.state === zc) {
      for (r.state = zo, i = new Array(f = r.tween.length), d = 0, h = -1; d < f; ++d)
        (v = r.tween[d].value.call(t, t.__data__, r.index, r.group)) && (i[++h] = v);
      i.length = h + 1;
    }
  }
  function o(l) {
    for (var d = l < r.duration ? r.ease.call(null, l / r.duration) : (r.timer.restart(u), r.state = Gc, 1), h = -1, f = i.length; ++h < f; )
      i[h].call(t, d);
    r.state === Gc && (r.on.call("end", t, t.__data__, r.index, r.group), u());
  }
  function u() {
    r.state = Go, r.timer.stop(), delete n[e];
    for (var l in n)
      return;
    delete t.__transition;
  }
}
function va(t, e) {
  var r = t.__transition, n, i, a = !0, s;
  if (r) {
    e = e == null ? null : e + "";
    for (s in r) {
      if ((n = r[s]).name !== e) {
        a = !1;
        continue;
      }
      i = n.state > zc && n.state < Gc, n.state = Go, n.timer.stop(), n.on.call(i ? "interrupt" : "cancel", t, t.__data__, n.index, n.group), delete r[s];
    }
    a && delete t.__transition;
  }
}
function vO(t) {
  return this.each(function() {
    va(this, t);
  });
}
function yO(t, e) {
  var r, n;
  return function() {
    var i = cr(this, t), a = i.tween;
    if (a !== r) {
      n = r = a;
      for (var s = 0, o = n.length; s < o; ++s)
        if (n[s].name === e) {
          n = n.slice(), n.splice(s, 1);
          break;
        }
    }
    i.tween = n;
  };
}
function _O(t, e, r) {
  var n, i;
  if (typeof r != "function")
    throw new Error();
  return function() {
    var a = cr(this, t), s = a.tween;
    if (s !== n) {
      i = (n = s).slice();
      for (var o = { name: e, value: r }, u = 0, l = i.length; u < l; ++u)
        if (i[u].name === e) {
          i[u] = o;
          break;
        }
      u === l && i.push(o);
    }
    a.tween = i;
  };
}
function TO(t, e) {
  var r = this._id;
  if (t += "", arguments.length < 2) {
    for (var n = qi(this.node(), r).tween, i = 0, a = n.length, s; i < a; ++i)
      if ((s = n[i]).name === t)
        return s.value;
    return null;
  }
  return this.each((e == null ? yO : _O)(r, t, e));
}
function wf(t, e, r) {
  var n = t._id;
  return t.each(function() {
    var i = cr(this, n);
    (i.value || (i.value = {}))[e] = r.apply(this, arguments);
  }), function(i) {
    return qi(i, n).value[e];
  };
}
function oT(t, e) {
  var r;
  return (typeof e == "number" ? Ni : e instanceof Cn ? Au : (r = Cn(e)) ? (e = r, Au) : eT)(t, e);
}
function bO(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function SO(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function EO(t, e, r) {
  var n, i = r + "", a;
  return function() {
    var s = this.getAttribute(t);
    return s === i ? null : s === n ? a : a = e(n = s, r);
  };
}
function xO(t, e, r) {
  var n, i = r + "", a;
  return function() {
    var s = this.getAttributeNS(t.space, t.local);
    return s === i ? null : s === n ? a : a = e(n = s, r);
  };
}
function CO(t, e, r) {
  var n, i, a;
  return function() {
    var s, o = r(this), u;
    return o == null ? void this.removeAttribute(t) : (s = this.getAttribute(t), u = o + "", s === u ? null : s === n && u === i ? a : (i = u, a = e(n = s, o)));
  };
}
function AO(t, e, r) {
  var n, i, a;
  return function() {
    var s, o = r(this), u;
    return o == null ? void this.removeAttributeNS(t.space, t.local) : (s = this.getAttributeNS(t.space, t.local), u = o + "", s === u ? null : s === n && u === i ? a : (i = u, a = e(n = s, o)));
  };
}
function wO(t, e) {
  var r = nl(t), n = r === "transform" ? aO : oT;
  return this.attrTween(t, typeof e == "function" ? (r.local ? AO : CO)(r, n, wf(this, "attr." + t, e)) : e == null ? (r.local ? SO : bO)(r) : (r.local ? xO : EO)(r, n, e));
}
function PO(t, e) {
  return function(r) {
    this.setAttribute(t, e.call(this, r));
  };
}
function kO(t, e) {
  return function(r) {
    this.setAttributeNS(t.space, t.local, e.call(this, r));
  };
}
function LO(t, e) {
  var r, n;
  function i() {
    var a = e.apply(this, arguments);
    return a !== n && (r = (n = a) && kO(t, a)), r;
  }
  return i._value = e, i;
}
function IO(t, e) {
  var r, n;
  function i() {
    var a = e.apply(this, arguments);
    return a !== n && (r = (n = a) && PO(t, a)), r;
  }
  return i._value = e, i;
}
function DO(t, e) {
  var r = "attr." + t;
  if (arguments.length < 2)
    return (r = this.tween(r)) && r._value;
  if (e == null)
    return this.tween(r, null);
  if (typeof e != "function")
    throw new Error();
  var n = nl(t);
  return this.tween(r, (n.local ? LO : IO)(n, e));
}
function RO(t, e) {
  return function() {
    Af(this, t).delay = +e.apply(this, arguments);
  };
}
function OO(t, e) {
  return e = +e, function() {
    Af(this, t).delay = e;
  };
}
function MO(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? RO : OO)(e, t)) : qi(this.node(), e).delay;
}
function NO(t, e) {
  return function() {
    cr(this, t).duration = +e.apply(this, arguments);
  };
}
function BO(t, e) {
  return e = +e, function() {
    cr(this, t).duration = e;
  };
}
function FO(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? NO : BO)(e, t)) : qi(this.node(), e).duration;
}
function UO(t, e) {
  if (typeof e != "function")
    throw new Error();
  return function() {
    cr(this, t).ease = e;
  };
}
function VO(t) {
  var e = this._id;
  return arguments.length ? this.each(UO(e, t)) : qi(this.node(), e).ease;
}
function jO(t, e) {
  return function() {
    var r = e.apply(this, arguments);
    if (typeof r != "function")
      throw new Error();
    cr(this, t).ease = r;
  };
}
function HO(t) {
  if (typeof t != "function")
    throw new Error();
  return this.each(jO(this._id, t));
}
function WO(t) {
  typeof t != "function" && (t = U_(t));
  for (var e = this._groups, r = e.length, n = new Array(r), i = 0; i < r; ++i)
    for (var a = e[i], s = a.length, o = n[i] = [], u, l = 0; l < s; ++l)
      (u = a[l]) && t.call(u, u.__data__, l, a) && o.push(u);
  return new Dr(n, this._parents, this._name, this._id);
}
function qO(t) {
  if (t._id !== this._id)
    throw new Error();
  for (var e = this._groups, r = t._groups, n = e.length, i = r.length, a = Math.min(n, i), s = new Array(n), o = 0; o < a; ++o)
    for (var u = e[o], l = r[o], d = u.length, h = s[o] = new Array(d), f, v = 0; v < d; ++v)
      (f = u[v] || l[v]) && (h[v] = f);
  for (; o < n; ++o)
    s[o] = e[o];
  return new Dr(s, this._parents, this._name, this._id);
}
function $O(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var r = e.indexOf(".");
    return r >= 0 && (e = e.slice(0, r)), !e || e === "start";
  });
}
function zO(t, e, r) {
  var n, i, a = $O(e) ? Af : cr;
  return function() {
    var s = a(this, t), o = s.on;
    o !== n && (i = (n = o).copy()).on(e, r), s.on = i;
  };
}
function GO(t, e) {
  var r = this._id;
  return arguments.length < 2 ? qi(this.node(), r).on.on(t) : this.each(zO(r, t, e));
}
function KO(t) {
  return function() {
    var e = this.parentNode;
    for (var r in this.__transition)
      if (+r !== t)
        return;
    e && e.removeChild(this);
  };
}
function XO() {
  return this.on("end.remove", KO(this._id));
}
function YO(t) {
  var e = this._name, r = this._id;
  typeof t != "function" && (t = bf(t));
  for (var n = this._groups, i = n.length, a = new Array(i), s = 0; s < i; ++s)
    for (var o = n[s], u = o.length, l = a[s] = new Array(u), d, h, f = 0; f < u; ++f)
      (d = o[f]) && (h = t.call(d, d.__data__, f, o)) && ("__data__" in d && (h.__data__ = d.__data__), l[f] = h, ul(l[f], e, r, f, l, qi(d, r)));
  return new Dr(a, this._parents, e, r);
}
function QO(t) {
  var e = this._name, r = this._id;
  typeof t != "function" && (t = F_(t));
  for (var n = this._groups, i = n.length, a = [], s = [], o = 0; o < i; ++o)
    for (var u = n[o], l = u.length, d, h = 0; h < l; ++h)
      if (d = u[h]) {
        for (var f = t.call(d, d.__data__, h, u), v, b = qi(d, r), _ = 0, y = f.length; _ < y; ++_)
          (v = f[_]) && ul(v, e, r, _, f, b);
        a.push(f), s.push(d);
      }
  return new Dr(a, s, e, r);
}
var JO = Zs.prototype.constructor;
function ZO() {
  return new JO(this._groups, this._parents);
}
function eM(t, e) {
  var r, n, i;
  return function() {
    var a = La(this, t), s = (this.style.removeProperty(t), La(this, t));
    return a === s ? null : a === r && s === n ? i : i = e(r = a, n = s);
  };
}
function uT(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function tM(t, e, r) {
  var n, i = r + "", a;
  return function() {
    var s = La(this, t);
    return s === i ? null : s === n ? a : a = e(n = s, r);
  };
}
function iM(t, e, r) {
  var n, i, a;
  return function() {
    var s = La(this, t), o = r(this), u = o + "";
    return o == null && (u = o = (this.style.removeProperty(t), La(this, t))), s === u ? null : s === n && u === i ? a : (i = u, a = e(n = s, o));
  };
}
function rM(t, e) {
  var r, n, i, a = "style." + e, s = "end." + a, o;
  return function() {
    var u = cr(this, t), l = u.on, d = u.value[a] == null ? o || (o = uT(e)) : void 0;
    (l !== r || i !== d) && (n = (r = l).copy()).on(s, i = d), u.on = n;
  };
}
function nM(t, e, r) {
  var n = (t += "") == "transform" ? nO : oT;
  return e == null ? this.styleTween(t, eM(t, n)).on("end.style." + t, uT(t)) : typeof e == "function" ? this.styleTween(t, iM(t, n, wf(this, "style." + t, e))).each(rM(this._id, t)) : this.styleTween(t, tM(t, n, e), r).on("end.style." + t, null);
}
function aM(t, e, r) {
  return function(n) {
    this.style.setProperty(t, e.call(this, n), r);
  };
}
function sM(t, e, r) {
  var n, i;
  function a() {
    var s = e.apply(this, arguments);
    return s !== i && (n = (i = s) && aM(t, s, r)), n;
  }
  return a._value = e, a;
}
function oM(t, e, r) {
  var n = "style." + (t += "");
  if (arguments.length < 2)
    return (n = this.tween(n)) && n._value;
  if (e == null)
    return this.tween(n, null);
  if (typeof e != "function")
    throw new Error();
  return this.tween(n, sM(t, e, r ?? ""));
}
function uM(t) {
  return function() {
    this.textContent = t;
  };
}
function lM(t) {
  return function() {
    var e = t(this);
    this.textContent = e ?? "";
  };
}
function dM(t) {
  return this.tween("text", typeof t == "function" ? lM(wf(this, "text", t)) : uM(t == null ? "" : t + ""));
}
function cM(t) {
  return function(e) {
    this.textContent = t.call(this, e);
  };
}
function hM(t) {
  var e, r;
  function n() {
    var i = t.apply(this, arguments);
    return i !== r && (e = (r = i) && cM(i)), e;
  }
  return n._value = t, n;
}
function fM(t) {
  var e = "text";
  if (arguments.length < 1)
    return (e = this.tween(e)) && e._value;
  if (t == null)
    return this.tween(e, null);
  if (typeof t != "function")
    throw new Error();
  return this.tween(e, hM(t));
}
function pM() {
  for (var t = this._name, e = this._id, r = lT(), n = this._groups, i = n.length, a = 0; a < i; ++a)
    for (var s = n[a], o = s.length, u, l = 0; l < o; ++l)
      if (u = s[l]) {
        var d = qi(u, e);
        ul(u, t, r, l, s, {
          time: d.time + d.delay + d.duration,
          delay: 0,
          duration: d.duration,
          ease: d.ease
        });
      }
  return new Dr(n, this._parents, t, r);
}
function gM() {
  var t, e, r = this, n = r._id, i = r.size();
  return new Promise(function(a, s) {
    var o = { value: s }, u = { value: function() {
      --i === 0 && a();
    } };
    r.each(function() {
      var l = cr(this, n), d = l.on;
      d !== t && (e = (t = d).copy(), e._.cancel.push(o), e._.interrupt.push(o), e._.end.push(u)), l.on = e;
    }), i === 0 && a();
  });
}
var mM = 0;
function Dr(t, e, r, n) {
  this._groups = t, this._parents = e, this._name = r, this._id = n;
}
function lT() {
  return ++mM;
}
var vr = Zs.prototype;
Dr.prototype = {
  constructor: Dr,
  select: YO,
  selectAll: QO,
  selectChild: vr.selectChild,
  selectChildren: vr.selectChildren,
  filter: WO,
  merge: qO,
  selection: ZO,
  transition: pM,
  call: vr.call,
  nodes: vr.nodes,
  node: vr.node,
  size: vr.size,
  empty: vr.empty,
  each: vr.each,
  on: GO,
  attr: wO,
  attrTween: DO,
  style: nM,
  styleTween: oM,
  text: dM,
  textTween: fM,
  remove: XO,
  tween: TO,
  delay: MO,
  duration: FO,
  ease: VO,
  easeVarying: HO,
  end: gM,
  [Symbol.iterator]: vr[Symbol.iterator]
};
function vM(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var yM = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: vM
};
function _M(t, e) {
  for (var r; !(r = t.__transition) || !(r = r[e]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${e} not found`);
  return r;
}
function TM(t) {
  var e, r;
  t instanceof Dr ? (e = t._id, t = t._name) : (e = lT(), (r = yM).time = Cf(), t = t == null ? null : t + "");
  for (var n = this._groups, i = n.length, a = 0; a < i; ++a)
    for (var s = n[a], o = s.length, u, l = 0; l < o; ++l)
      (u = s[l]) && ul(u, t, e, l, s, r || _M(u, e));
  return new Dr(n, this._parents, t, e);
}
Zs.prototype.interrupt = vO;
Zs.prototype.transition = TM;
const No = (t) => () => t;
function bM(t, {
  sourceEvent: e,
  target: r,
  transform: n,
  dispatch: i
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    target: { value: r, enumerable: !0, configurable: !0 },
    transform: { value: n, enumerable: !0, configurable: !0 },
    _: { value: i }
  });
}
function Er(t, e, r) {
  this.k = t, this.x = e, this.y = r;
}
Er.prototype = {
  constructor: Er,
  scale: function(t) {
    return t === 1 ? this : new Er(this.k * t, this.x, this.y);
  },
  translate: function(t, e) {
    return t === 0 & e === 0 ? this : new Er(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var Fs = new Er(1, 0, 0);
dT.prototype = Er.prototype;
function dT(t) {
  for (; !t.__zoom; )
    if (!(t = t.parentNode))
      return Fs;
  return t.__zoom;
}
function Kd(t) {
  t.stopImmediatePropagation();
}
function us(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function SM(t) {
  return (!t.ctrlKey || t.type === "wheel") && !t.button;
}
function EM() {
  var t = this;
  return t instanceof SVGElement ? (t = t.ownerSVGElement || t, t.hasAttribute("viewBox") ? (t = t.viewBox.baseVal, [[t.x, t.y], [t.x + t.width, t.y + t.height]]) : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]]) : [[0, 0], [t.clientWidth, t.clientHeight]];
}
function Fm() {
  return this.__zoom || Fs;
}
function xM(t) {
  return -t.deltaY * (t.deltaMode === 1 ? 0.05 : t.deltaMode ? 1 : 2e-3) * (t.ctrlKey ? 10 : 1);
}
function CM() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function AM(t, e, r) {
  var n = t.invertX(e[0][0]) - r[0][0], i = t.invertX(e[1][0]) - r[1][0], a = t.invertY(e[0][1]) - r[0][1], s = t.invertY(e[1][1]) - r[1][1];
  return t.translate(
    i > n ? (n + i) / 2 : Math.min(0, n) || Math.max(0, i),
    s > a ? (a + s) / 2 : Math.min(0, a) || Math.max(0, s)
  );
}
function wM() {
  var t = SM, e = EM, r = AM, n = xM, i = CM, a = [0, 1 / 0], s = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], o = 250, u = lO, l = al("start", "zoom", "end"), d, h, f, v = 500, b = 150, _ = 0, y = 10;
  function E(j) {
    j.property("__zoom", Fm).on("wheel.zoom", U, { passive: !1 }).on("mousedown.zoom", $).on("dblclick.zoom", W).filter(i).on("touchstart.zoom", G).on("touchmove.zoom", Y).on("touchend.zoom touchcancel.zoom", re).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  E.transform = function(j, J, z, Q) {
    var te = j.selection ? j.selection() : j;
    te.property("__zoom", Fm), j !== te ? w(j, J, z, Q) : te.interrupt().each(function() {
      k(this, arguments).event(Q).start().zoom(null, typeof J == "function" ? J.apply(this, arguments) : J).end();
    });
  }, E.scaleBy = function(j, J, z, Q) {
    E.scaleTo(j, function() {
      var te = this.__zoom.k, ae = typeof J == "function" ? J.apply(this, arguments) : J;
      return te * ae;
    }, z, Q);
  }, E.scaleTo = function(j, J, z, Q) {
    E.transform(j, function() {
      var te = e.apply(this, arguments), ae = this.__zoom, ne = z == null ? C(te) : typeof z == "function" ? z.apply(this, arguments) : z, Se = ae.invert(ne), Te = typeof J == "function" ? J.apply(this, arguments) : J;
      return r(D(R(ae, Te), ne, Se), te, s);
    }, z, Q);
  }, E.translateBy = function(j, J, z, Q) {
    E.transform(j, function() {
      return r(this.__zoom.translate(
        typeof J == "function" ? J.apply(this, arguments) : J,
        typeof z == "function" ? z.apply(this, arguments) : z
      ), e.apply(this, arguments), s);
    }, null, Q);
  }, E.translateTo = function(j, J, z, Q, te) {
    E.transform(j, function() {
      var ae = e.apply(this, arguments), ne = this.__zoom, Se = Q == null ? C(ae) : typeof Q == "function" ? Q.apply(this, arguments) : Q;
      return r(Fs.translate(Se[0], Se[1]).scale(ne.k).translate(
        typeof J == "function" ? -J.apply(this, arguments) : -J,
        typeof z == "function" ? -z.apply(this, arguments) : -z
      ), ae, s);
    }, Q, te);
  };
  function R(j, J) {
    return J = Math.max(a[0], Math.min(a[1], J)), J === j.k ? j : new Er(J, j.x, j.y);
  }
  function D(j, J, z) {
    var Q = J[0] - z[0] * j.k, te = J[1] - z[1] * j.k;
    return Q === j.x && te === j.y ? j : new Er(j.k, Q, te);
  }
  function C(j) {
    return [(+j[0][0] + +j[1][0]) / 2, (+j[0][1] + +j[1][1]) / 2];
  }
  function w(j, J, z, Q) {
    j.on("start.zoom", function() {
      k(this, arguments).event(Q).start();
    }).on("interrupt.zoom end.zoom", function() {
      k(this, arguments).event(Q).end();
    }).tween("zoom", function() {
      var te = this, ae = arguments, ne = k(te, ae).event(Q), Se = e.apply(te, ae), Te = z == null ? C(Se) : typeof z == "function" ? z.apply(te, ae) : z, We = Math.max(Se[1][0] - Se[0][0], Se[1][1] - Se[0][1]), Be = te.__zoom, ge = typeof J == "function" ? J.apply(te, ae) : J, fe = u(Be.invert(Te).concat(We / Be.k), ge.invert(Te).concat(We / ge.k));
      return function(me) {
        if (me === 1)
          me = ge;
        else {
          var xe = fe(me), Ue = We / xe[2];
          me = new Er(Ue, Te[0] - xe[0] * Ue, Te[1] - xe[1] * Ue);
        }
        ne.zoom(null, me);
      };
    });
  }
  function k(j, J, z) {
    return !z && j.__zooming || new I(j, J);
  }
  function I(j, J) {
    this.that = j, this.args = J, this.active = 0, this.sourceEvent = null, this.extent = e.apply(j, J), this.taps = 0;
  }
  I.prototype = {
    event: function(j) {
      return j && (this.sourceEvent = j), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(j, J) {
      return this.mouse && j !== "mouse" && (this.mouse[1] = J.invert(this.mouse[0])), this.touch0 && j !== "touch" && (this.touch0[1] = J.invert(this.touch0[0])), this.touch1 && j !== "touch" && (this.touch1[1] = J.invert(this.touch1[0])), this.that.__zoom = J, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(j) {
      var J = Wt(this.that).datum();
      l.call(
        j,
        this.that,
        new bM(j, {
          sourceEvent: this.sourceEvent,
          target: E,
          type: j,
          transform: this.that.__zoom,
          dispatch: l
        }),
        J
      );
    }
  };
  function U(j, ...J) {
    if (!t.apply(this, arguments))
      return;
    var z = k(this, J).event(j), Q = this.__zoom, te = Math.max(a[0], Math.min(a[1], Q.k * Math.pow(2, n.apply(this, arguments)))), ae = Tr(j);
    if (z.wheel)
      (z.mouse[0][0] !== ae[0] || z.mouse[0][1] !== ae[1]) && (z.mouse[1] = Q.invert(z.mouse[0] = ae)), clearTimeout(z.wheel);
    else {
      if (Q.k === te)
        return;
      z.mouse = [ae, Q.invert(ae)], va(this), z.start();
    }
    us(j), z.wheel = setTimeout(ne, b), z.zoom("mouse", r(D(R(Q, te), z.mouse[0], z.mouse[1]), z.extent, s));
    function ne() {
      z.wheel = null, z.end();
    }
  }
  function $(j, ...J) {
    if (f || !t.apply(this, arguments))
      return;
    var z = j.currentTarget, Q = k(this, J, !0).event(j), te = Wt(j.view).on("mousemove.zoom", Te, !0).on("mouseup.zoom", We, !0), ae = Tr(j, z), ne = j.clientX, Se = j.clientY;
    X_(j.view), Kd(j), Q.mouse = [ae, this.__zoom.invert(ae)], va(this), Q.start();
    function Te(Be) {
      if (us(Be), !Q.moved) {
        var ge = Be.clientX - ne, fe = Be.clientY - Se;
        Q.moved = ge * ge + fe * fe > _;
      }
      Q.event(Be).zoom("mouse", r(D(Q.that.__zoom, Q.mouse[0] = Tr(Be, z), Q.mouse[1]), Q.extent, s));
    }
    function We(Be) {
      te.on("mousemove.zoom mouseup.zoom", null), Y_(Be.view, Q.moved), us(Be), Q.event(Be).end();
    }
  }
  function W(j, ...J) {
    if (t.apply(this, arguments)) {
      var z = this.__zoom, Q = Tr(j.changedTouches ? j.changedTouches[0] : j, this), te = z.invert(Q), ae = z.k * (j.shiftKey ? 0.5 : 2), ne = r(D(R(z, ae), Q, te), e.apply(this, J), s);
      us(j), o > 0 ? Wt(this).transition().duration(o).call(w, ne, Q, j) : Wt(this).call(E.transform, ne, Q, j);
    }
  }
  function G(j, ...J) {
    if (t.apply(this, arguments)) {
      var z = j.touches, Q = z.length, te = k(this, J, j.changedTouches.length === Q).event(j), ae, ne, Se, Te;
      for (Kd(j), ne = 0; ne < Q; ++ne)
        Se = z[ne], Te = Tr(Se, this), Te = [Te, this.__zoom.invert(Te), Se.identifier], te.touch0 ? !te.touch1 && te.touch0[2] !== Te[2] && (te.touch1 = Te, te.taps = 0) : (te.touch0 = Te, ae = !0, te.taps = 1 + !!d);
      d && (d = clearTimeout(d)), ae && (te.taps < 2 && (h = Te[0], d = setTimeout(function() {
        d = null;
      }, v)), va(this), te.start());
    }
  }
  function Y(j, ...J) {
    if (this.__zooming) {
      var z = k(this, J).event(j), Q = j.changedTouches, te = Q.length, ae, ne, Se, Te;
      for (us(j), ae = 0; ae < te; ++ae)
        ne = Q[ae], Se = Tr(ne, this), z.touch0 && z.touch0[2] === ne.identifier ? z.touch0[0] = Se : z.touch1 && z.touch1[2] === ne.identifier && (z.touch1[0] = Se);
      if (ne = z.that.__zoom, z.touch1) {
        var We = z.touch0[0], Be = z.touch0[1], ge = z.touch1[0], fe = z.touch1[1], me = (me = ge[0] - We[0]) * me + (me = ge[1] - We[1]) * me, xe = (xe = fe[0] - Be[0]) * xe + (xe = fe[1] - Be[1]) * xe;
        ne = R(ne, Math.sqrt(me / xe)), Se = [(We[0] + ge[0]) / 2, (We[1] + ge[1]) / 2], Te = [(Be[0] + fe[0]) / 2, (Be[1] + fe[1]) / 2];
      } else if (z.touch0)
        Se = z.touch0[0], Te = z.touch0[1];
      else
        return;
      z.zoom("touch", r(D(ne, Se, Te), z.extent, s));
    }
  }
  function re(j, ...J) {
    if (this.__zooming) {
      var z = k(this, J).event(j), Q = j.changedTouches, te = Q.length, ae, ne;
      for (Kd(j), f && clearTimeout(f), f = setTimeout(function() {
        f = null;
      }, v), ae = 0; ae < te; ++ae)
        ne = Q[ae], z.touch0 && z.touch0[2] === ne.identifier ? delete z.touch0 : z.touch1 && z.touch1[2] === ne.identifier && delete z.touch1;
      if (z.touch1 && !z.touch0 && (z.touch0 = z.touch1, delete z.touch1), z.touch0)
        z.touch0[1] = this.__zoom.invert(z.touch0[0]);
      else if (z.end(), z.taps === 2 && (ne = Tr(ne, this), Math.hypot(h[0] - ne[0], h[1] - ne[1]) < y)) {
        var Se = Wt(this).on("dblclick.zoom");
        Se && Se.apply(this, arguments);
      }
    }
  }
  return E.wheelDelta = function(j) {
    return arguments.length ? (n = typeof j == "function" ? j : No(+j), E) : n;
  }, E.filter = function(j) {
    return arguments.length ? (t = typeof j == "function" ? j : No(!!j), E) : t;
  }, E.touchable = function(j) {
    return arguments.length ? (i = typeof j == "function" ? j : No(!!j), E) : i;
  }, E.extent = function(j) {
    return arguments.length ? (e = typeof j == "function" ? j : No([[+j[0][0], +j[0][1]], [+j[1][0], +j[1][1]]]), E) : e;
  }, E.scaleExtent = function(j) {
    return arguments.length ? (a[0] = +j[0], a[1] = +j[1], E) : [a[0], a[1]];
  }, E.translateExtent = function(j) {
    return arguments.length ? (s[0][0] = +j[0][0], s[1][0] = +j[1][0], s[0][1] = +j[0][1], s[1][1] = +j[1][1], E) : [[s[0][0], s[0][1]], [s[1][0], s[1][1]]];
  }, E.constrain = function(j) {
    return arguments.length ? (r = j, E) : r;
  }, E.duration = function(j) {
    return arguments.length ? (o = +j, E) : o;
  }, E.interpolate = function(j) {
    return arguments.length ? (u = j, E) : u;
  }, E.on = function() {
    var j = l.on.apply(l, arguments);
    return j === l ? E : j;
  }, E.clickDistance = function(j) {
    return arguments.length ? (_ = (j = +j) * j, E) : Math.sqrt(_);
  }, E.tapDistance = function(j) {
    return arguments.length ? (y = +j, E) : y;
  }, E;
}
class cT {
  constructor(e, r, n) {
    st(this, "player");
    st(this, "playerEl");
    st(this, "videoEl");
    st(this, "config");
    st(this, "transformationTarget");
    st(this, "d3zoom", null);
    st(this, "updateD3ExtentHandler", null);
    st(this, "onFullscreenChangeHandler", null);
    st(this, "lastTransform", { x: 0, y: 0, k: 0 });
    this.config = n, this.videoEl = r, this.player = e, this.playerEl = e.el(), this.transformationTarget = this.playerEl;
  }
  onZoom(e) {
    const { x: r, y: n, k: i } = e.transform, a = this.lastTransform.x !== r || this.lastTransform.y !== n, s = this.lastTransform.k !== i;
    a && !s ? this.player.trigger("panning", { x: r, y: n }) : s && this.player.trigger("zooming", i), this.lastTransform = e.transform, this.player.trigger("d3-transform", e);
  }
  initD3Transformation() {
    var a;
    const { extent: e, scaleExtent: r, translateExtent: n } = this.getD3ExtentData(), i = this.onZoom.bind(this);
    this.updateD3ExtentHandler = this.updateD3Extent.bind(this), this.onFullscreenChangeHandler = this.onFullscreenChange.bind(this), this.d3zoom = wM().extent(e).scaleExtent(r).translateExtent(n).on("zoom", i), this.d3Target.style("overflow", "hidden"), this.updateD3Extent(), (a = this.videoEl) == null || a.addEventListener("resize", this.updateD3ExtentHandler), window.addEventListener("resize", this.onFullscreenChangeHandler);
  }
  destroyD3Transformation() {
    var e, r;
    this.d3zoom && ((e = this.d3Target) == null || e.call(this.d3zoom.on("zoom", null))), (r = this.videoEl) == null || r.removeEventListener("resize", this.updateD3ExtentHandler), window.removeEventListener("resize", this.onFullscreenChangeHandler), this.updateD3ExtentHandler = null, this.onFullscreenChangeHandler = null;
  }
  updateD3Extent() {
    const { extent: e, scaleExtent: r, translateExtent: n } = this.getD3ExtentData();
    this.d3Target.call(
      this.d3zoom.extent(e).scaleExtent(r).translateExtent(n)
    ).on("dblclick.zoom", null), this.zoomOut(50);
  }
  reset() {
    this.updateD3Extent(), this.d3Target.transition().duration(750).call(this.d3zoom.transform, Fs, [0, 0]);
  }
  onFullscreenChange() {
    this.updateD3Extent(), setTimeout(this.panToCenter.bind(this));
  }
  get d3Target() {
    return Wt(this.transformationTarget);
  }
  getD3Transform() {
    return dT(this.transformationTarget);
  }
  getD3ExtentData() {
    const e = this.transformationTarget ? this.transformationTarget.getBoundingClientRect() : { width: 0, height: 0 };
    return {
      extent: [
        [0, 0],
        [e.width, e.height]
      ],
      scaleExtent: [this.config.minZoom, this.config.maxZoom],
      translateExtent: [
        [0, 0],
        [e.width, e.height]
      ]
    };
  }
  getZoom() {
    const { k: e } = this.getD3Transform();
    return e;
  }
  getPan() {
    const { x: e, y: r } = this.getD3Transform();
    return { x: e, y: r };
  }
  panToCenter() {
    const { translateExtent: e } = this.getD3ExtentData(), r = e[1][0] / 2, n = e[1][1] / 2;
    this.d3Target.call(this.d3zoom.translateTo, r, n), setTimeout(() => this.zoomTo(1.5), 800);
  }
  panTo(e, r) {
    const n = this.getZoom();
    this.d3Target.call(
      this.d3zoom.transform,
      Fs.translate(-e, -r).scale(n)
    );
  }
  panBy(e, r, n = 750) {
    n ? this.d3Target.transition().duration(n).call(this.d3zoom.translateBy, e, r) : this.d3Target.call(this.d3zoom.translateBy, e, r);
  }
  zoomTo(e, r = 750) {
    r ? this.d3Target.transition().duration(750).call(this.d3zoom.scaleTo, e) : this.d3Target.call(this.d3zoom.scaleTo, e);
  }
  zoomBy(e, r = 750) {
    r ? this.d3Target.transition().duration(r).call(this.d3zoom.scaleBy, e) : this.d3Target.call(this.d3zoom.scaleBy, e);
  }
  zoomIn(e = 750) {
    e ? this.d3Target.transition().duration(e).call(this.d3zoom.scaleBy, this.config.zoomFactor) : this.d3Target.call(this.d3zoom.scaleBy, this.config.zoomFactor);
  }
  zoomOut(e = 750) {
    e ? this.d3Target.transition().duration(e).call(this.d3zoom.scaleBy, -this.config.zoomFactor) : this.d3Target.call(this.d3zoom.scaleBy, -this.config.zoomFactor);
  }
}
class PM extends cT {
  constructor() {
    super(...arguments);
    st(this, "__pluginName__", "d3-html");
    st(this, "__populateOnPlayer__", !1);
    st(this, "recorder", null);
  }
  init() {
    this.initD3Transformation(), setTimeout(this.reset.bind(this)), setTimeout(this.panToCenter.bind(this));
  }
  destroy() {
    this.destroyD3Transformation(), Wt(this.videoEl).style("transition", "none").style("transform-origin", "0 0").style("transform", "none");
  }
  onZoom(r) {
    super.onZoom(r);
    const { x: n, y: i, k: a } = r.transform;
    let s = "";
    !window.isNaN(n) && !window.isNaN(i) && (s = s.concat(`translate(${n}px, ${i}px)`)), window.isNaN(a) || (s = s.concat(`scale(${a})`)), Wt(this.videoEl).style("transition", "none").style("transform-origin", "0 0").style("transform", s);
  }
}
function kM(t, e, r, n) {
  let i, a, s = !1;
  function o(u) {
    i = e(o, n), t(u - (a || u)), a = u;
  }
  return {
    getState() {
      return {
        started: s
      };
    },
    start() {
      i || (s = !0, o(0));
    },
    stop() {
      s = !1, r(i), i = null, a = 0;
    }
  };
}
function LM(t) {
  return kM(t, requestAnimationFrame, cancelAnimationFrame);
}
class IM extends cT {
  constructor() {
    super(...arguments);
    st(this, "__pluginName__", "d3-canvas");
    st(this, "__populateOnPlayer__", !1);
    st(this, "canvasEl", null);
    st(this, "updater", null);
    st(this, "recorder", null);
  }
  init() {
    this.canvasEl = this.setupCanvas(), this.transformationTarget = this.canvasEl || this.playerEl, this.initD3Transformation(), setTimeout(this.reset.bind(this)), setTimeout(this.panToCenter.bind(this));
  }
  destroy() {
    var r, n;
    this.playerEl.classList.remove("vjs-canvas-active"), this.destroyD3Transformation(), (r = this.updater) == null || r.stop(), this.updater.unSubscribe(), this.updater = null, (n = this.canvasEl) == null || n.remove(), this.canvasEl = null;
  }
  onZoom(r) {
    super.onZoom(r), this.drawPlayableVideoArea(r);
  }
  setupCanvas() {
    var l, d, h, f, v, b, _;
    if (!this.videoEl || !this.videoEl.parentElement)
      return console.error("[PixellotWebSDK|Pano] Video element not found!"), null;
    const r = document.createElement("canvas");
    r.classList.add("pxlt-canvas");
    const n = this.playerEl;
    o(), this.videoEl.parentElement.insertBefore(r, this.videoEl), this.playerEl.classList.add("vjs-canvas-active");
    const i = LM(
      () => this.drawPlayableVideoArea({ transform: this.lastTransform })
    );
    this.updater = i;
    function a() {
      i.start();
    }
    function s() {
      i.stop();
    }
    function o() {
      const y = n.getBoundingClientRect();
      y && (r.width = y.width, r.height = y.height);
    }
    function u() {
      i.stop(), window.removeEventListener("resize", o);
    }
    return window.addEventListener("resize", o), (l = this.videoEl) == null || l.addEventListener("loadedmetadata", o), (d = this.videoEl) == null || d.addEventListener("playing", a), (h = this.videoEl) == null || h.addEventListener("pause", s), (f = this.videoEl) == null || f.addEventListener("abort", s), (v = this.videoEl) == null || v.addEventListener("error", s), (b = this.videoEl) == null || b.addEventListener("waiting", s), (_ = this.videoEl) == null || _.addEventListener("dispose", u), this.updater.unSubscribe = () => {
      var y, E, R, D, C, w, k;
      window.removeEventListener("resize", o), (y = this.videoEl) == null || y.removeEventListener("loadedmetadata", o), (E = this.videoEl) == null || E.removeEventListener("playing", a), (R = this.videoEl) == null || R.removeEventListener("pause", s), (D = this.videoEl) == null || D.removeEventListener("abort", s), (C = this.videoEl) == null || C.removeEventListener("error", s), (w = this.videoEl) == null || w.removeEventListener("waiting", s), (k = this.videoEl) == null || k.removeEventListener("dispose", u);
    }, r;
  }
  drawPlayableVideoArea(r) {
    var u, l;
    const { x: n, y: i, k: a } = r.transform, s = (u = this.canvasEl) == null ? void 0 : u.getContext("2d");
    if (this.videoEl && s && this.canvasEl && (s.save(), s.clearRect(0, 0, this.canvasEl.width, this.canvasEl.height), s.translate(n, i), s.scale(a, a), s.drawImage(this.videoEl, 0, 0), s.restore()), !this.updater) {
      console.warn("[PixellotWebSDK|Pano] Updater not available!");
      return;
    }
    const o = this.updater.getState();
    !((l = this.videoEl) != null && l.paused) && !o.started && this.updater.start();
  }
  getD3ExtentData() {
    var a, s, o, u;
    const r = this.transformationTarget ? this.transformationTarget.getBoundingClientRect() : { width: 0, height: 0 };
    let n = this.config.minZoom;
    r && ((a = this.videoEl) != null && a.videoWidth) && ((s = this.videoEl) != null && s.videoHeight) && (n = Math.max(
      r.width / this.videoEl.videoWidth,
      r.height / this.videoEl.videoHeight
    ));
    const i = Math.max(n, this.config.minZoom);
    return {
      extent: [
        [0, 0],
        [r.width, r.height]
      ],
      scaleExtent: [i, this.config.maxZoom],
      translateExtent: [
        [0, 0],
        [((o = this.videoEl) == null ? void 0 : o.videoWidth) || 0, ((u = this.videoEl) == null ? void 0 : u.videoHeight) || 0]
      ]
    };
  }
}
const Xd = [
  "video/webm;codecs=vp9",
  "video/webm;codecs=vp8",
  "video/mp4",
  "video/webm",
  "video/vp8",
  "video/webm;codecs=opus",
  "video/webm;codecs=daala",
  "video/webm;codecs=h264",
  "video/mpeg"
], Um = () => {
  let t = null;
  for (const e in Xd)
    if (MediaRecorder.isTypeSupported(Xd[e])) {
      t = Xd[e];
      break;
    }
  return t;
}, Bo = (t) => t && // @ts-expect-error ...
(t.mozCaptureStream && t.mozCaptureStream.bind(t) || // @ts-expect-error ...
t.captureStream && t.captureStream.bind(t)), DM = (t, e) => {
  const r = window.URL.createObjectURL(e), n = document.createElement("a");
  n.style.display = "none", n.href = r, n.download = t, document.body.appendChild(n), n.click(), setTimeout(() => {
    document.body.removeChild(n), window.URL.revokeObjectURL(r);
  }, 100);
}, RM = {
  outputFilename: "recording"
};
function OM(t, e) {
  let r = null, n = [];
  const i = Um(), a = () => (r == null ? void 0 : r.state) || null, s = document.createElement("video");
  if (s.style.display = "none", o()) {
    if (!i)
      return console.error(
        "[PixellotWebSDK|PanoRecorder]: No supported mediaType found in MediaRecorderAPI!"
      ), null;
  } else
    return console.error(
      "[PixellotWebSDK|PanoRecorder]: MediaRecorderAPI is not supported!"
    ), null;
  function o() {
    const b = t.el().querySelector("video"), _ = Bo(b), y = Bo(e), E = !!(_ && y);
    return P.browser.IS_ANY_SAFARI ? !1 : E;
  }
  function u() {
    return a() === "recording";
  }
  function l() {
    s == null || s.remove(), r = null;
  }
  function d(v) {
    const _ = t.el().querySelector("video"), y = Bo(_), E = Bo(e), R = {
      mimeType: i,
      videoBitsPerSecond: 25e5
      // 2.5Mbps
    };
    n = [];
    try {
      const D = new MediaStream(), C = y(), w = E(), k = new MediaStream();
      C.getAudioTracks().forEach((U) => k.addTrack(U)), [k, w].forEach(
        (U) => U.getTracks().forEach(($) => D.addTrack($))
      );
      try {
        r = new MediaRecorder(D, R), r.onstop = () => {
          const U = R.mimeType || "video/webm", $ = new Blob(n, { type: U });
          s.src = window.URL.createObjectURL($);
        }, r.ondataavailable = (U) => U.data && U.data.size > 0 && n.push(U.data), r.start(100);
      } catch (U) {
        console.error(
          "[PixellotWebSDK|PanoRecorder]: Exception while creating MediaRecorder:",
          U
        ), v != null && v.onError && v.onError(U);
      }
    } catch (D) {
      console.error(
        "[PixellotWebSDK|PanoRecorder]: Exception while creating MediaRecorder:",
        D
      ), v != null && v.onError && v.onError(D);
    }
  }
  function h() {
    u() && (r == null || r.stop());
  }
  function f(v) {
    const _ = `${v || RM.outputFilename}.webm`;
    if (n.length < 1) {
      console.error(
        "[PixellotWebSDK|PanoRecorder]: Recorder did not record any segment!"
      );
      return;
    }
    const y = Um() || "video/webm", E = new Blob(n, { type: y });
    DM(_, E), n = [];
  }
  return {
    saveRecording: f,
    startRecording: d,
    stopRecording: h,
    destroy: l,
    getRecordingState: a
  };
}
function MM(t) {
  let e = null;
  t.on("dispose", () => r());
  function r() {
    e && (e.destroy(), e.recorder && (e.recorder.destroy(), e.recorder = null)), e = null;
  }
  const n = {
    panoEnabled: !0,
    minZoom: 1,
    maxZoom: 5,
    defaultZoom: 1,
    zoomFactor: 1.3,
    showZoomIndicator: !0
  }, i = {
    mode: a,
    destroy: r,
    reset: u,
    switchMode: s,
    getZoom: l,
    getPan: d,
    panBy: h,
    panTo: f,
    panToCenter: v,
    zoomBy: b,
    zoomIn: _,
    zoomOut: y,
    zoomTo: E,
    getD3ExtentData: R,
    isFullPano: D,
    recorder: o,
    getConfig: () => n
  };
  t.panoAPI = i;
  function a() {
    return e ? e.__pluginName__ === "d3-html" ? "full" : e.__pluginName__ === "d3-canvas" ? "restricted" : null : null;
  }
  function s(C) {
    r();
    const k = t.el().querySelector("video");
    k && (C === "full" ? e = new PM(t, k, n) : C === "restricted" ? e = new IM(t, k, n) : console.warn("[PixellotWebSDK|Pano] Unknown mode: " + C), e && (e.init(), e.__pluginName__ === "d3-canvas" && (e.recorder = OM(t, e.canvasEl)), u(), t.one("loadedmetadata", r)), t.trigger("pano-mode-change", a()));
  }
  function o() {
    return e && e.__pluginName__ === "d3-canvas" && e.recorder ? e.recorder : null;
  }
  function u() {
    e == null || e.reset();
  }
  function l() {
    return (e == null ? void 0 : e.getZoom()) || 1;
  }
  function d() {
    return (e == null ? void 0 : e.getPan()) || { x: 0, y: 0 };
  }
  function h(C, w, k = 750) {
    e == null || e.panBy(C, w, k);
  }
  function f(C, w) {
    e == null || e.panTo(C, w);
  }
  function v() {
    e == null || e.panToCenter();
  }
  function b(C, w = 750) {
    e == null || e.zoomBy(C, w);
  }
  function _(C = 750) {
    e == null || e.zoomIn(C);
  }
  function y(C = 750) {
    e == null || e.zoomOut(C);
  }
  function E(C, w = 750) {
    return e == null ? void 0 : e.zoomTo(C, w);
  }
  function R() {
    return e == null ? void 0 : e.getD3ExtentData();
  }
  function D() {
    return (e == null ? void 0 : e.__pluginName__) === "d3-html";
  }
}
P.registerPlugin("pano", function() {
  return MM(this);
});
function NM(t) {
  const e = t.onClick || (() => {
  }), r = (i) => {
    const a = yT.html2Element(i);
    return t.wrapperEl.appendChild(a), t.onClick && a.addEventListener("click", t.onClick), a;
  };
  let n = r(t.domString);
  return {
    el: n,
    wrapperEl: t.wrapperEl,
    onClick: e,
    show: () => gT(n),
    hide: () => pT(n),
    enable: () => fT(n),
    disable: () => hT(n),
    isVisible: () => mT(n),
    setValue(i, a) {
      const s = n.querySelector(`[data-${i}]`);
      s && (s.innerHTML = `${a}`);
    },
    getValue(i) {
      var a;
      return ((a = n.querySelector(`[data-${i}]`)) == null ? void 0 : a.innerHTML) || "";
    },
    updateDom(i) {
      n.remove(), n = r(i), this.el = n, this.isVisible() ? this.hide() : this.show();
    }
  };
}
function BM(t) {
  const e = document.createElement("div");
  return e.innerHTML = t, e.children[0];
}
function FM(t, e) {
  let r = t;
  return Object.keys(e).forEach((n) => {
    r = r.replace("{{ " + n + " }}", e[n]);
  }), r;
}
function UM(t, e) {
  t.parentNode.insertBefore(e, t);
}
function VM(t, e) {
  t.parentNode.insertBefore(e, t.nextSibling);
}
function hT(t) {
  ll(t, "vjs-disabled"), t == null || t.setAttribute("disabled", "disabled"), t == null || t.setAttribute("aria-disabled", "true");
}
function fT(t) {
  dl(t, "vjs-disabled"), t == null || t.removeAttribute("disabled"), t == null || t.setAttribute("aria-disabled", "false");
}
function pT(t) {
  ll(t, "pxlt-hidden");
}
function gT(t) {
  dl(t, "pxlt-hidden");
}
function mT(t) {
  return !vT(t, "pxlt-hidden");
}
function jM(t, e, r = !1) {
  return t.classList[r ? "add" : "remove"](e);
}
function vT(t, e) {
  return t.classList.contains(e) || !1;
}
function ll(t, e) {
  return t.classList.add(e);
}
function dl(t, e) {
  return t.classList.remove(e);
}
function HM(t, e, r, n) {
  const i = n ? e : r, a = n ? r : e;
  ll(t, i), dl(t, a);
}
const yT = {
  createComponent: NM,
  html2Element: BM,
  replaceHtmlData: FM,
  insertAfter: VM,
  insertBefore: UM,
  disable: hT,
  enable: fT,
  hide: pT,
  show: gT,
  isVisible: mT,
  hasClass: vT,
  addClass: ll,
  removeClass: dl,
  toggleClass: jM,
  switchClasses: HM
};
var WM = "Expected a function", Vm = 0 / 0, qM = "[object Symbol]", $M = /^\s+|\s+$/g, zM = /^[-+]0x[0-9a-f]+$/i, GM = /^0b[01]+$/i, KM = /^0o[0-7]+$/i, XM = parseInt, YM = typeof Zi == "object" && Zi && Zi.Object === Object && Zi, QM = typeof self == "object" && self && self.Object === Object && self, JM = YM || QM || Function("return this")(), ZM = Object.prototype, eN = ZM.toString, tN = Math.max, iN = Math.min, Yd = function() {
  return JM.Date.now();
};
function rN(t, e, r) {
  var n, i, a, s, o, u, l = 0, d = !1, h = !1, f = !0;
  if (typeof t != "function")
    throw new TypeError(WM);
  e = jm(e) || 0, Kc(r) && (d = !!r.leading, h = "maxWait" in r, a = h ? tN(jm(r.maxWait) || 0, e) : a, f = "trailing" in r ? !!r.trailing : f);
  function v(k) {
    var I = n, U = i;
    return n = i = void 0, l = k, s = t.apply(U, I), s;
  }
  function b(k) {
    return l = k, o = setTimeout(E, e), d ? v(k) : s;
  }
  function _(k) {
    var I = k - u, U = k - l, $ = e - I;
    return h ? iN($, a - U) : $;
  }
  function y(k) {
    var I = k - u, U = k - l;
    return u === void 0 || I >= e || I < 0 || h && U >= a;
  }
  function E() {
    var k = Yd();
    if (y(k))
      return R(k);
    o = setTimeout(E, _(k));
  }
  function R(k) {
    return o = void 0, f && n ? v(k) : (n = i = void 0, s);
  }
  function D() {
    o !== void 0 && clearTimeout(o), l = 0, n = u = i = o = void 0;
  }
  function C() {
    return o === void 0 ? s : R(Yd());
  }
  function w() {
    var k = Yd(), I = y(k);
    if (n = arguments, i = this, u = k, I) {
      if (o === void 0)
        return b(u);
      if (h)
        return o = setTimeout(E, e), v(u);
    }
    return o === void 0 && (o = setTimeout(E, e)), s;
  }
  return w.cancel = D, w.flush = C, w;
}
function Kc(t) {
  var e = typeof t;
  return !!t && (e == "object" || e == "function");
}
function nN(t) {
  return !!t && typeof t == "object";
}
function aN(t) {
  return typeof t == "symbol" || nN(t) && eN.call(t) == qM;
}
function jm(t) {
  if (typeof t == "number")
    return t;
  if (aN(t))
    return Vm;
  if (Kc(t)) {
    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
    t = Kc(e) ? e + "" : e;
  }
  if (typeof t != "string")
    return t === 0 ? t : +t;
  t = t.replace($M, "");
  var r = GM.test(t);
  return r || KM.test(t) ? XM(t.slice(2), r ? 2 : 8) : zM.test(t) ? Vm : +t;
}
var sN = rN;
function oN(t, e) {
  e.zoomInButton.onclick = () => t.panoAPI.zoomIn(), e.zoomOutButton.onclick = () => t.panoAPI.zoomOut(), t.on("zooming", o);
  const r = t.panoAPI.getD3ExtentData(), n = t.panoAPI.getConfig(), [i, a] = r && r.scaleExtent || [n.minZoom, n.maxZoom], s = (a - i) / 100;
  e.zoomRangeInput.setAttribute("step", "" + s), e.zoomRangeInput.setAttribute("min", "" + i), e.zoomRangeInput.setAttribute("max", "" + a), e.zoomRangeInput.setAttribute("value", "" + t.panoAPI.getZoom()), e.zoomRangeInput.addEventListener("input", sN((l) => {
    const d = l.target;
    t.panoAPI.zoomTo(Number(d.value));
  }, 300));
  function o(l, d) {
    const h = d.toFixed(2) + "";
    e.zoomRangeInput && (e.zoomRangeInput.setAttribute("value", h), e.zoomRangeInput.value = h);
  }
  function u() {
    t.off("zooming", o), e.zoomAreaContainer.remove();
  }
  return { elements: e, destroy: u };
}
const Qd = (t) => () => t;
function uN(t, {
  sourceEvent: e,
  target: r,
  selection: n,
  mode: i,
  dispatch: a
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    target: { value: r, enumerable: !0, configurable: !0 },
    selection: { value: n, enumerable: !0, configurable: !0 },
    mode: { value: i, enumerable: !0, configurable: !0 },
    _: { value: a }
  });
}
function lN(t) {
  t.stopImmediatePropagation();
}
function Jd(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
var Hm = { name: "drag" }, Zd = { name: "space" }, ia = { name: "handle" }, ra = { name: "center" };
const { abs: Wm, max: zt, min: Gt } = Math;
function qm(t) {
  return [+t[0], +t[1]];
}
function Xc(t) {
  return [qm(t[0]), qm(t[1])];
}
var ec = {
  name: "x",
  handles: ["w", "e"].map(Us),
  input: function(t, e) {
    return t == null ? null : [[+t[0], e[0][1]], [+t[1], e[1][1]]];
  },
  output: function(t) {
    return t && [t[0][0], t[1][0]];
  }
}, tc = {
  name: "y",
  handles: ["n", "s"].map(Us),
  input: function(t, e) {
    return t == null ? null : [[e[0][0], +t[0]], [e[1][0], +t[1]]];
  },
  output: function(t) {
    return t && [t[0][1], t[1][1]];
  }
}, dN = {
  name: "xy",
  handles: ["n", "w", "e", "s", "nw", "ne", "sw", "se"].map(Us),
  input: function(t) {
    return t == null ? null : Xc(t);
  },
  output: function(t) {
    return t;
  }
}, yr = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
}, $m = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
}, zm = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
}, cN = {
  overlay: 1,
  selection: 1,
  n: null,
  e: 1,
  s: null,
  w: -1,
  nw: -1,
  ne: 1,
  se: 1,
  sw: -1
}, hN = {
  overlay: 1,
  selection: 1,
  n: -1,
  e: null,
  s: 1,
  w: null,
  nw: -1,
  ne: -1,
  se: 1,
  sw: 1
};
function Us(t) {
  return { type: t };
}
function fN(t) {
  return !t.ctrlKey && !t.button;
}
function pN() {
  var t = this.ownerSVGElement || this;
  return t.hasAttribute("viewBox") ? (t = t.viewBox.baseVal, [[t.x, t.y], [t.x + t.width, t.y + t.height]]) : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]];
}
function gN() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function ic(t) {
  for (; !t.__brush; )
    if (!(t = t.parentNode))
      return;
  return t.__brush;
}
function mN(t) {
  return t[0][0] === t[1][0] || t[0][1] === t[1][1];
}
function vN() {
  return yN(dN);
}
function yN(t) {
  var e = pN, r = fN, n = gN, i = !0, a = al("start", "brush", "end"), s = 6, o;
  function u(y) {
    var E = y.property("__brush", _).selectAll(".overlay").data([Us("overlay")]);
    E.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", yr.overlay).merge(E).each(function() {
      var D = ic(this).extent;
      Wt(this).attr("x", D[0][0]).attr("y", D[0][1]).attr("width", D[1][0] - D[0][0]).attr("height", D[1][1] - D[0][1]);
    }), y.selectAll(".selection").data([Us("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", yr.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
    var R = y.selectAll(".handle").data(t.handles, function(D) {
      return D.type;
    });
    R.exit().remove(), R.enter().append("rect").attr("class", function(D) {
      return "handle handle--" + D.type;
    }).attr("cursor", function(D) {
      return yr[D.type];
    }), y.each(l).attr("fill", "none").attr("pointer-events", "all").on("mousedown.brush", f).filter(n).on("touchstart.brush", f).on("touchmove.brush", v).on("touchend.brush touchcancel.brush", b).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  u.move = function(y, E, R) {
    y.tween ? y.on("start.brush", function(D) {
      d(this, arguments).beforestart().start(D);
    }).on("interrupt.brush end.brush", function(D) {
      d(this, arguments).end(D);
    }).tween("brush", function() {
      var D = this, C = D.__brush, w = d(D, arguments), k = C.selection, I = t.input(typeof E == "function" ? E.apply(this, arguments) : E, C.extent), U = sl(k, I);
      function $(W) {
        C.selection = W === 1 && I === null ? null : U(W), l.call(D), w.brush();
      }
      return k !== null && I !== null ? $ : $(1);
    }) : y.each(function() {
      var D = this, C = arguments, w = D.__brush, k = t.input(typeof E == "function" ? E.apply(D, C) : E, w.extent), I = d(D, C).beforestart();
      va(D), w.selection = k === null ? null : k, l.call(D), I.start(R).brush(R).end(R);
    });
  }, u.clear = function(y, E) {
    u.move(y, null, E);
  };
  function l() {
    var y = Wt(this), E = ic(this).selection;
    E ? (y.selectAll(".selection").style("display", null).attr("x", E[0][0]).attr("y", E[0][1]).attr("width", E[1][0] - E[0][0]).attr("height", E[1][1] - E[0][1]), y.selectAll(".handle").style("display", null).attr("x", function(R) {
      return R.type[R.type.length - 1] === "e" ? E[1][0] - s / 2 : E[0][0] - s / 2;
    }).attr("y", function(R) {
      return R.type[0] === "s" ? E[1][1] - s / 2 : E[0][1] - s / 2;
    }).attr("width", function(R) {
      return R.type === "n" || R.type === "s" ? E[1][0] - E[0][0] + s : s;
    }).attr("height", function(R) {
      return R.type === "e" || R.type === "w" ? E[1][1] - E[0][1] + s : s;
    })) : y.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
  }
  function d(y, E, R) {
    var D = y.__brush.emitter;
    return D && (!R || !D.clean) ? D : new h(y, E, R);
  }
  function h(y, E, R) {
    this.that = y, this.args = E, this.state = y.__brush, this.active = 0, this.clean = R;
  }
  h.prototype = {
    beforestart: function() {
      return ++this.active === 1 && (this.state.emitter = this, this.starting = !0), this;
    },
    start: function(y, E) {
      return this.starting ? (this.starting = !1, this.emit("start", y, E)) : this.emit("brush", y), this;
    },
    brush: function(y, E) {
      return this.emit("brush", y, E), this;
    },
    end: function(y, E) {
      return --this.active === 0 && (delete this.state.emitter, this.emit("end", y, E)), this;
    },
    emit: function(y, E, R) {
      var D = Wt(this.that).datum();
      a.call(
        y,
        this.that,
        new uN(y, {
          sourceEvent: E,
          target: u,
          selection: t.output(this.state.selection),
          mode: R,
          dispatch: a
        }),
        D
      );
    }
  };
  function f(y) {
    if (o && !y.touches || !r.apply(this, arguments))
      return;
    var E = this, R = y.target.__data__.type, D = (i && y.metaKey ? R = "overlay" : R) === "selection" ? Hm : i && y.altKey ? ra : ia, C = t === tc ? null : cN[R], w = t === ec ? null : hN[R], k = ic(E), I = k.extent, U = k.selection, $ = I[0][0], W, G, Y = I[0][1], re, j, J = I[1][0], z, Q, te = I[1][1], ae, ne, Se = 0, Te = 0, We, Be = C && w && i && y.shiftKey, ge, fe, me = Array.from(y.touches || [y], (Ee) => {
      const Qe = Ee.identifier;
      return Ee = Tr(Ee, E), Ee.point0 = Ee.slice(), Ee.identifier = Qe, Ee;
    });
    va(E);
    var xe = d(E, arguments, !0).beforestart();
    if (R === "overlay") {
      U && (We = !0);
      const Ee = [me[0], me[1] || me[0]];
      k.selection = U = [[
        W = t === tc ? $ : Gt(Ee[0][0], Ee[1][0]),
        re = t === ec ? Y : Gt(Ee[0][1], Ee[1][1])
      ], [
        z = t === tc ? J : zt(Ee[0][0], Ee[1][0]),
        ae = t === ec ? te : zt(Ee[0][1], Ee[1][1])
      ]], me.length > 1 && Ce(y);
    } else
      W = U[0][0], re = U[0][1], z = U[1][0], ae = U[1][1];
    G = W, j = re, Q = z, ne = ae;
    var Ue = Wt(E).attr("pointer-events", "none"), Xe = Ue.selectAll(".overlay").attr("cursor", yr[R]);
    if (y.touches)
      xe.moved = ke, xe.ended = $e;
    else {
      var Ke = Wt(y.view).on("mousemove.brush", ke, !0).on("mouseup.brush", $e, !0);
      i && Ke.on("keydown.brush", Nt, !0).on("keyup.brush", dt, !0), X_(y.view);
    }
    l.call(E), xe.start(y, D.name);
    function ke(Ee) {
      for (const Qe of Ee.changedTouches || [Ee])
        for (const Re of me)
          Re.identifier === Qe.identifier && (Re.cur = Tr(Qe, E));
      if (Be && !ge && !fe && me.length === 1) {
        const Qe = me[0];
        Wm(Qe.cur[0] - Qe[0]) > Wm(Qe.cur[1] - Qe[1]) ? fe = !0 : ge = !0;
      }
      for (const Qe of me)
        Qe.cur && (Qe[0] = Qe.cur[0], Qe[1] = Qe.cur[1]);
      We = !0, Jd(Ee), Ce(Ee);
    }
    function Ce(Ee) {
      const Qe = me[0], Re = Qe.point0;
      var Qt;
      switch (Se = Qe[0] - Re[0], Te = Qe[1] - Re[1], D) {
        case Zd:
        case Hm: {
          C && (Se = zt($ - W, Gt(J - z, Se)), G = W + Se, Q = z + Se), w && (Te = zt(Y - re, Gt(te - ae, Te)), j = re + Te, ne = ae + Te);
          break;
        }
        case ia: {
          me[1] ? (C && (G = zt($, Gt(J, me[0][0])), Q = zt($, Gt(J, me[1][0])), C = 1), w && (j = zt(Y, Gt(te, me[0][1])), ne = zt(Y, Gt(te, me[1][1])), w = 1)) : (C < 0 ? (Se = zt($ - W, Gt(J - W, Se)), G = W + Se, Q = z) : C > 0 && (Se = zt($ - z, Gt(J - z, Se)), G = W, Q = z + Se), w < 0 ? (Te = zt(Y - re, Gt(te - re, Te)), j = re + Te, ne = ae) : w > 0 && (Te = zt(Y - ae, Gt(te - ae, Te)), j = re, ne = ae + Te));
          break;
        }
        case ra: {
          C && (G = zt($, Gt(J, W - Se * C)), Q = zt($, Gt(J, z + Se * C))), w && (j = zt(Y, Gt(te, re - Te * w)), ne = zt(Y, Gt(te, ae + Te * w)));
          break;
        }
      }
      Q < G && (C *= -1, Qt = W, W = z, z = Qt, Qt = G, G = Q, Q = Qt, R in $m && Xe.attr("cursor", yr[R = $m[R]])), ne < j && (w *= -1, Qt = re, re = ae, ae = Qt, Qt = j, j = ne, ne = Qt, R in zm && Xe.attr("cursor", yr[R = zm[R]])), k.selection && (U = k.selection), ge && (G = U[0][0], Q = U[1][0]), fe && (j = U[0][1], ne = U[1][1]), (U[0][0] !== G || U[0][1] !== j || U[1][0] !== Q || U[1][1] !== ne) && (k.selection = [[G, j], [Q, ne]], l.call(E), xe.brush(Ee, D.name));
    }
    function $e(Ee) {
      if (lN(Ee), Ee.touches) {
        if (Ee.touches.length)
          return;
        o && clearTimeout(o), o = setTimeout(function() {
          o = null;
        }, 500);
      } else
        Y_(Ee.view, We), Ke.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      Ue.attr("pointer-events", "all"), Xe.attr("cursor", yr.overlay), k.selection && (U = k.selection), mN(U) && (k.selection = null, l.call(E)), xe.end(Ee, D.name);
    }
    function Nt(Ee) {
      switch (Ee.keyCode) {
        case 16: {
          Be = C && w;
          break;
        }
        case 18: {
          D === ia && (C && (z = Q - Se * C, W = G + Se * C), w && (ae = ne - Te * w, re = j + Te * w), D = ra, Ce(Ee));
          break;
        }
        case 32: {
          (D === ia || D === ra) && (C < 0 ? z = Q - Se : C > 0 && (W = G - Se), w < 0 ? ae = ne - Te : w > 0 && (re = j - Te), D = Zd, Xe.attr("cursor", yr.selection), Ce(Ee));
          break;
        }
        default:
          return;
      }
      Jd(Ee);
    }
    function dt(Ee) {
      switch (Ee.keyCode) {
        case 16: {
          Be && (ge = fe = Be = !1, Ce(Ee));
          break;
        }
        case 18: {
          D === ra && (C < 0 ? z = Q : C > 0 && (W = G), w < 0 ? ae = ne : w > 0 && (re = j), D = ia, Ce(Ee));
          break;
        }
        case 32: {
          D === Zd && (Ee.altKey ? (C && (z = Q - Se * C, W = G + Se * C), w && (ae = ne - Te * w, re = j + Te * w), D = ra) : (C < 0 ? z = Q : C > 0 && (W = G), w < 0 ? ae = ne : w > 0 && (re = j), D = ia), Xe.attr("cursor", yr[R]), Ce(Ee));
          break;
        }
        default:
          return;
      }
      Jd(Ee);
    }
  }
  function v(y) {
    d(this, arguments).moved(y);
  }
  function b(y) {
    d(this, arguments).ended(y);
  }
  function _() {
    var y = this.__brush || { selection: null };
    return y.extent = Xc(e.apply(this, arguments)), y.dim = t, y;
  }
  return u.extent = function(y) {
    return arguments.length ? (e = typeof y == "function" ? y : Qd(Xc(y)), u) : e;
  }, u.filter = function(y) {
    return arguments.length ? (r = typeof y == "function" ? y : Qd(!!y), u) : r;
  }, u.touchable = function(y) {
    return arguments.length ? (n = typeof y == "function" ? y : Qd(!!y), u) : n;
  }, u.handleSize = function(y) {
    return arguments.length ? (s = +y, u) : s;
  }, u.keyModifiers = function(y) {
    return arguments.length ? (i = !!y, u) : i;
  }, u.on = function() {
    var y = a.on.apply(a, arguments);
    return y === a ? u : y;
  }, u;
}
function Ko(t, e) {
  return t == null || e == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function _N(t, e) {
  return t == null || e == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function _T(t) {
  let e, r, n;
  t.length !== 2 ? (e = Ko, r = (o, u) => Ko(t(o), u), n = (o, u) => t(o) - u) : (e = t === Ko || t === _N ? t : TN, r = t, n = t);
  function i(o, u, l = 0, d = o.length) {
    if (l < d) {
      if (e(u, u) !== 0)
        return d;
      do {
        const h = l + d >>> 1;
        r(o[h], u) < 0 ? l = h + 1 : d = h;
      } while (l < d);
    }
    return l;
  }
  function a(o, u, l = 0, d = o.length) {
    if (l < d) {
      if (e(u, u) !== 0)
        return d;
      do {
        const h = l + d >>> 1;
        r(o[h], u) <= 0 ? l = h + 1 : d = h;
      } while (l < d);
    }
    return l;
  }
  function s(o, u, l = 0, d = o.length) {
    const h = i(o, u, l, d - 1);
    return h > l && n(o[h - 1], u) > -n(o[h], u) ? h - 1 : h;
  }
  return { left: i, center: s, right: a };
}
function TN() {
  return 0;
}
function bN(t) {
  return t === null ? NaN : +t;
}
const SN = _T(Ko), EN = SN.right;
_T(bN).center;
const xN = EN, CN = Math.sqrt(50), AN = Math.sqrt(10), wN = Math.sqrt(2);
function Lu(t, e, r) {
  const n = (e - t) / Math.max(0, r), i = Math.floor(Math.log10(n)), a = n / Math.pow(10, i), s = a >= CN ? 10 : a >= AN ? 5 : a >= wN ? 2 : 1;
  let o, u, l;
  return i < 0 ? (l = Math.pow(10, -i) / s, o = Math.round(t * l), u = Math.round(e * l), o / l < t && ++o, u / l > e && --u, l = -l) : (l = Math.pow(10, i) * s, o = Math.round(t / l), u = Math.round(e / l), o * l < t && ++o, u * l > e && --u), u < o && 0.5 <= r && r < 2 ? Lu(t, e, r * 2) : [o, u, l];
}
function PN(t, e, r) {
  if (e = +e, t = +t, r = +r, !(r > 0))
    return [];
  if (t === e)
    return [t];
  const n = e < t, [i, a, s] = n ? Lu(e, t, r) : Lu(t, e, r);
  if (!(a >= i))
    return [];
  const o = a - i + 1, u = new Array(o);
  if (n)
    if (s < 0)
      for (let l = 0; l < o; ++l)
        u[l] = (a - l) / -s;
    else
      for (let l = 0; l < o; ++l)
        u[l] = (a - l) * s;
  else if (s < 0)
    for (let l = 0; l < o; ++l)
      u[l] = (i + l) / -s;
  else
    for (let l = 0; l < o; ++l)
      u[l] = (i + l) * s;
  return u;
}
function Yc(t, e, r) {
  return e = +e, t = +t, r = +r, Lu(t, e, r)[2];
}
function kN(t, e, r) {
  e = +e, t = +t, r = +r;
  const n = e < t, i = n ? Yc(e, t, r) : Yc(t, e, r);
  return (n ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function LN(t, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(e).domain(t);
      break;
  }
  return this;
}
function IN(t) {
  return function() {
    return t;
  };
}
function DN(t) {
  return +t;
}
var Gm = [0, 1];
function da(t) {
  return t;
}
function Qc(t, e) {
  return (e -= t = +t) ? function(r) {
    return (r - t) / e;
  } : IN(isNaN(e) ? NaN : 0.5);
}
function RN(t, e) {
  var r;
  return t > e && (r = t, t = e, e = r), function(n) {
    return Math.max(t, Math.min(e, n));
  };
}
function ON(t, e, r) {
  var n = t[0], i = t[1], a = e[0], s = e[1];
  return i < n ? (n = Qc(i, n), a = r(s, a)) : (n = Qc(n, i), a = r(a, s)), function(o) {
    return a(n(o));
  };
}
function MN(t, e, r) {
  var n = Math.min(t.length, e.length) - 1, i = new Array(n), a = new Array(n), s = -1;
  for (t[n] < t[0] && (t = t.slice().reverse(), e = e.slice().reverse()); ++s < n; )
    i[s] = Qc(t[s], t[s + 1]), a[s] = r(e[s], e[s + 1]);
  return function(o) {
    var u = xN(t, o, 1, n) - 1;
    return a[u](i[u](o));
  };
}
function NN(t, e) {
  return e.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function BN() {
  var t = Gm, e = Gm, r = sl, n, i, a, s = da, o, u, l;
  function d() {
    var f = Math.min(t.length, e.length);
    return s !== da && (s = RN(t[0], t[f - 1])), o = f > 2 ? MN : ON, u = l = null, h;
  }
  function h(f) {
    return f == null || isNaN(f = +f) ? a : (u || (u = o(t.map(n), e, r)))(n(s(f)));
  }
  return h.invert = function(f) {
    return s(i((l || (l = o(e, t.map(n), Ni)))(f)));
  }, h.domain = function(f) {
    return arguments.length ? (t = Array.from(f, DN), d()) : t.slice();
  }, h.range = function(f) {
    return arguments.length ? (e = Array.from(f), d()) : e.slice();
  }, h.rangeRound = function(f) {
    return e = Array.from(f), r = tO, d();
  }, h.clamp = function(f) {
    return arguments.length ? (s = f ? !0 : da, d()) : s !== da;
  }, h.interpolate = function(f) {
    return arguments.length ? (r = f, d()) : r;
  }, h.unknown = function(f) {
    return arguments.length ? (a = f, h) : a;
  }, function(f, v) {
    return n = f, i = v, d();
  };
}
function FN() {
  return BN()(da, da);
}
function UN(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function Iu(t, e) {
  if ((r = (t = e ? t.toExponential(e - 1) : t.toExponential()).indexOf("e")) < 0)
    return null;
  var r, n = t.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +t.slice(r + 1)
  ];
}
function Da(t) {
  return t = Iu(Math.abs(t)), t ? t[1] : NaN;
}
function VN(t, e) {
  return function(r, n) {
    for (var i = r.length, a = [], s = 0, o = t[0], u = 0; i > 0 && o > 0 && (u + o + 1 > n && (o = Math.max(1, n - u)), a.push(r.substring(i -= o, i + o)), !((u += o + 1) > n)); )
      o = t[s = (s + 1) % t.length];
    return a.reverse().join(e);
  };
}
function jN(t) {
  return function(e) {
    return e.replace(/[0-9]/g, function(r) {
      return t[+r];
    });
  };
}
var HN = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Du(t) {
  if (!(e = HN.exec(t)))
    throw new Error("invalid format: " + t);
  var e;
  return new Pf({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
Du.prototype = Pf.prototype;
function Pf(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
Pf.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function WN(t) {
  e:
    for (var e = t.length, r = 1, n = -1, i; r < e; ++r)
      switch (t[r]) {
        case ".":
          n = i = r;
          break;
        case "0":
          n === 0 && (n = r), i = r;
          break;
        default:
          if (!+t[r])
            break e;
          n > 0 && (n = 0);
          break;
      }
  return n > 0 ? t.slice(0, n) + t.slice(i + 1) : t;
}
var TT;
function qN(t, e) {
  var r = Iu(t, e);
  if (!r)
    return t + "";
  var n = r[0], i = r[1], a = i - (TT = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, s = n.length;
  return a === s ? n : a > s ? n + new Array(a - s + 1).join("0") : a > 0 ? n.slice(0, a) + "." + n.slice(a) : "0." + new Array(1 - a).join("0") + Iu(t, Math.max(0, e + a - 1))[0];
}
function Km(t, e) {
  var r = Iu(t, e);
  if (!r)
    return t + "";
  var n = r[0], i = r[1];
  return i < 0 ? "0." + new Array(-i).join("0") + n : n.length > i + 1 ? n.slice(0, i + 1) + "." + n.slice(i + 1) : n + new Array(i - n.length + 2).join("0");
}
const Xm = {
  "%": (t, e) => (t * 100).toFixed(e),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: UN,
  e: (t, e) => t.toExponential(e),
  f: (t, e) => t.toFixed(e),
  g: (t, e) => t.toPrecision(e),
  o: (t) => Math.round(t).toString(8),
  p: (t, e) => Km(t * 100, e),
  r: Km,
  s: qN,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function Ym(t) {
  return t;
}
var Qm = Array.prototype.map, Jm = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function $N(t) {
  var e = t.grouping === void 0 || t.thousands === void 0 ? Ym : VN(Qm.call(t.grouping, Number), t.thousands + ""), r = t.currency === void 0 ? "" : t.currency[0] + "", n = t.currency === void 0 ? "" : t.currency[1] + "", i = t.decimal === void 0 ? "." : t.decimal + "", a = t.numerals === void 0 ? Ym : jN(Qm.call(t.numerals, String)), s = t.percent === void 0 ? "%" : t.percent + "", o = t.minus === void 0 ? "−" : t.minus + "", u = t.nan === void 0 ? "NaN" : t.nan + "";
  function l(h) {
    h = Du(h);
    var f = h.fill, v = h.align, b = h.sign, _ = h.symbol, y = h.zero, E = h.width, R = h.comma, D = h.precision, C = h.trim, w = h.type;
    w === "n" ? (R = !0, w = "g") : Xm[w] || (D === void 0 && (D = 12), C = !0, w = "g"), (y || f === "0" && v === "=") && (y = !0, f = "0", v = "=");
    var k = _ === "$" ? r : _ === "#" && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "", I = _ === "$" ? n : /[%p]/.test(w) ? s : "", U = Xm[w], $ = /[defgprs%]/.test(w);
    D = D === void 0 ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, D)) : Math.max(0, Math.min(20, D));
    function W(G) {
      var Y = k, re = I, j, J, z;
      if (w === "c")
        re = U(G) + re, G = "";
      else {
        G = +G;
        var Q = G < 0 || 1 / G < 0;
        if (G = isNaN(G) ? u : U(Math.abs(G), D), C && (G = WN(G)), Q && +G == 0 && b !== "+" && (Q = !1), Y = (Q ? b === "(" ? b : o : b === "-" || b === "(" ? "" : b) + Y, re = (w === "s" ? Jm[8 + TT / 3] : "") + re + (Q && b === "(" ? ")" : ""), $) {
          for (j = -1, J = G.length; ++j < J; )
            if (z = G.charCodeAt(j), 48 > z || z > 57) {
              re = (z === 46 ? i + G.slice(j + 1) : G.slice(j)) + re, G = G.slice(0, j);
              break;
            }
        }
      }
      R && !y && (G = e(G, 1 / 0));
      var te = Y.length + G.length + re.length, ae = te < E ? new Array(E - te + 1).join(f) : "";
      switch (R && y && (G = e(ae + G, ae.length ? E - re.length : 1 / 0), ae = ""), v) {
        case "<":
          G = Y + G + re + ae;
          break;
        case "=":
          G = Y + ae + G + re;
          break;
        case "^":
          G = ae.slice(0, te = ae.length >> 1) + Y + G + re + ae.slice(te);
          break;
        default:
          G = ae + Y + G + re;
          break;
      }
      return a(G);
    }
    return W.toString = function() {
      return h + "";
    }, W;
  }
  function d(h, f) {
    var v = l((h = Du(h), h.type = "f", h)), b = Math.max(-8, Math.min(8, Math.floor(Da(f) / 3))) * 3, _ = Math.pow(10, -b), y = Jm[8 + b / 3];
    return function(E) {
      return v(_ * E) + y;
    };
  }
  return {
    format: l,
    formatPrefix: d
  };
}
var Fo, bT, ST;
zN({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function zN(t) {
  return Fo = $N(t), bT = Fo.format, ST = Fo.formatPrefix, Fo;
}
function GN(t) {
  return Math.max(0, -Da(Math.abs(t)));
}
function KN(t, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Da(e) / 3))) * 3 - Da(Math.abs(t)));
}
function XN(t, e) {
  return t = Math.abs(t), e = Math.abs(e) - t, Math.max(0, Da(e) - Da(t)) + 1;
}
function YN(t, e, r, n) {
  var i = kN(t, e, r), a;
  switch (n = Du(n ?? ",f"), n.type) {
    case "s": {
      var s = Math.max(Math.abs(t), Math.abs(e));
      return n.precision == null && !isNaN(a = KN(i, s)) && (n.precision = a), ST(n, s);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(a = XN(i, Math.max(Math.abs(t), Math.abs(e)))) && (n.precision = a - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(a = GN(i)) && (n.precision = a - (n.type === "%") * 2);
      break;
    }
  }
  return bT(n);
}
function QN(t) {
  var e = t.domain;
  return t.ticks = function(r) {
    var n = e();
    return PN(n[0], n[n.length - 1], r ?? 10);
  }, t.tickFormat = function(r, n) {
    var i = e();
    return YN(i[0], i[i.length - 1], r ?? 10, n);
  }, t.nice = function(r) {
    r == null && (r = 10);
    var n = e(), i = 0, a = n.length - 1, s = n[i], o = n[a], u, l, d = 10;
    for (o < s && (l = s, s = o, o = l, l = i, i = a, a = l); d-- > 0; ) {
      if (l = Yc(s, o, r), l === u)
        return n[i] = s, n[a] = o, e(n);
      if (l > 0)
        s = Math.floor(s / l) * l, o = Math.ceil(o / l) * l;
      else if (l < 0)
        s = Math.ceil(s * l) / l, o = Math.floor(o * l) / l;
      else
        break;
      u = l;
    }
    return t;
  }, t;
}
function Jc() {
  var t = FN();
  return t.copy = function() {
    return NN(t, Jc());
  }, LN.apply(t, arguments), QN(t);
}
const Ji = { top: 10, right: 10, bottom: 10, left: 10 }, ca = { width: 400, height: 120 }, Zm = {
  width: ca.width - Ji.left - Ji.right,
  height: ca.height - Ji.top - Ji.bottom
}, ev = [
  [20, 20],
  [100, 70]
];
function JN(t, e) {
  const r = Wt(e.outerBox), n = vN().extent([
    [Ji.top, Ji.left],
    [ca.width - Ji.right, ca.height - Ji.bottom]
  ]).on("start", _).on("brush", E).on("end", y);
  r.attr("width", ca.width).attr("height", ca.height);
  function i(D) {
    const C = D.type === "mousedown" ? D.button === 0 : !0, w = D.target.className.baseVal !== "selection";
    C && w && D.stopImmediatePropagation();
  }
  const a = r.append("g").lower().on("mousedown", i).on("touchstart touchmove touchend", i).call(n).call(n.move, ev), [[s, o], [u, l]] = ev;
  f({ x0: s, y0: o, x1: u, y1: l }), r.selectAll(".handle").attr("cursor", "default"), t.on("d3-transform", b), t.on("pano-mode-changed", d), t.on("zooming", d), t.el().addEventListener("keydown", h), e.outerBox.addEventListener("keydown", h);
  function d() {
    const D = {
      k: t.panoAPI.getZoom(),
      ...t.panoAPI.getPan()
    };
    b(null, { transform: D, sourceEvent: {} });
  }
  function h(D) {
    D.preventDefault();
    const C = 5, w = 15, k = t.videoWidth() / 100 * C, I = t.videoHeight() / 100 * w;
    switch (D.which) {
      case 37: {
        t.panoAPI.panBy(k, 0);
        break;
      }
      case 39: {
        t.panoAPI.panBy(-k, 0);
        break;
      }
      case 38: {
        t.panoAPI.panBy(0, I);
        break;
      }
      case 40: {
        t.panoAPI.panBy(0, -I);
        break;
      }
    }
  }
  function f(D) {
    let C = 29;
    const w = 10, k = D.x1 - D.x0, I = D.y1 - D.y0, U = k - w, $ = I - w, W = U > $ ? $ - C : U - C;
    W <= 0 && (C += W);
    const G = (D.x1 + D.x0) / 2 - C / 2, Y = (D.y1 + D.y0) / 2 - C / 2;
    Wt(e.innerIcon).attr("x", G).attr("y", Y).attr("width", C).attr("height", C);
  }
  function v(D) {
    const C = D.k, w = t.panoAPI.isFullPano(), [k, I] = w ? [t.el().clientWidth, t.el().clientHeight] : [t.videoWidth(), t.videoHeight()], U = Jc().domain([0, k * C]).range([Ji.left, Zm.width]), $ = Jc().domain([0, I * C]).range([Ji.top, Zm.height]);
    return { x: U, y: $ };
  }
  function b(D, C) {
    var G, Y;
    if (!C.sourceEvent)
      return;
    const w = (G = C.transform) == null ? void 0 : G.x, k = (Y = C.transform) == null ? void 0 : Y.y, { x: I, y: U } = v(C.transform), $ = {
      width: I(t.el().clientWidth),
      height: U(t.el().clientHeight)
    }, W = {
      x0: I(Math.abs(w)),
      y0: U(Math.abs(k)),
      x1: I(Math.abs(w)) + $.width,
      y1: U(Math.abs(k)) + $.height
    };
    f(W), a.call(n.move, [
      [W.x0, W.y0],
      [W.x1, W.y1]
    ]);
  }
  function _(D) {
    D.sourceEvent && r.classed("brushing", !0);
  }
  function y() {
    r.classed("brushing", !1);
  }
  function E(D) {
    if (!D.sourceEvent || !D.selection || !Array.isArray(D == null ? void 0 : D.selection[0]))
      return;
    const [[C, w], [k, I]] = D.selection, U = {
      k: t.panoAPI.getZoom(),
      ...t.panoAPI.getPan()
    }, { x: $, y: W } = v(U);
    f({ x0: C, y0: w, x1: k, y1: I }), t.panoAPI.panTo($.invert(C), W.invert(w));
  }
  function R() {
    t.off("d3-transform", b), t.off("pano-mode-changed", d), t.off("zooming", d), t.el().removeEventListener("keydown", h), e.outerBox.removeEventListener("keydown", h);
  }
  return { elements: e, destroy: R };
}
const ZN = `
  <div class="pxlt-navigation-area">
    <div class="pxlt-navigation-area-container">
      <div class="pxlt-navigation-area-svg-wrap">
        <svg class="pxlt-navigation-area-svg" tabindex="0">
          <svg class="brush-arrows" height="29" viewBox="0 0 29 29" width="29" x="0" y="0">
            <path d="M16.6492 3.34996C16.8357 3.53918 17.1387 3.53991 17.326 3.35158C17.5133 3.16323 17.514 2.85718 17.3276 2.66796L14.8392 0.142216L14.8126 0.117211C14.6249 -0.0466166 14.3398 -0.0389531 14.1612 0.141757L11.6723 2.66794C11.4859 2.85713 11.4866 3.16321 11.674 3.35156C11.8613 3.53988 12.1643 3.53916 12.3507 3.34994L14.0214 1.6542L14.0214 11.8911C14.0214 12.1581 14.2357 12.3745 14.5 12.3745C14.7643 12.3745 14.9785 12.1581 14.9785 11.8911L14.9785 1.65418L16.6492 3.34996ZM0.140364 14.3042L0.140795 14.3037L2.6413 11.7902C2.82863 11.6019 3.13162 11.6026 3.31809 11.7918C3.50453 11.981 3.50381 12.2871 3.31649 12.4754L1.63764 14.163L11.7723 14.163C12.0366 14.163 12.2508 14.3794 12.2508 14.6463C12.2508 14.9133 12.0366 15.1297 11.7723 15.1297L1.63767 15.1297L3.31646 16.8173C3.50379 17.0056 3.50451 17.3117 3.31806 17.5009C3.1316 17.6901 2.82858 17.6908 2.64128 17.5025L0.140771 14.989L0.140341 14.9885C-0.0470839 14.7995 -0.0464849 14.4925 0.140364 14.3042ZM28.8596 14.3042L28.8592 14.3037L26.3587 11.7902C26.1714 11.6019 25.8684 11.6026 25.6819 11.7918C25.4955 11.981 25.4962 12.2871 25.6835 12.4754L27.3624 14.163L17.2277 14.163C16.9634 14.163 16.7492 14.3794 16.7492 14.6463C16.7492 14.9133 16.9634 15.1297 17.2277 15.1297L27.3623 15.1297L25.6835 16.8173C25.4962 17.0056 25.4955 17.3117 25.6819 17.5009C25.8684 17.6901 26.1714 17.6908 26.3587 17.5025L28.8592 14.989L28.8597 14.9885C29.0471 14.7995 29.0465 14.4925 28.8596 14.3042ZM17.3519 26.5983C17.5136 26.408 17.5048 26.1209 17.326 25.9412C17.1387 25.7528 16.8357 25.7536 16.6492 25.9428L14.9785 27.6386L14.9785 17.4016L14.9774 17.3685C14.9606 17.117 14.7533 16.9182 14.5 16.9182C14.2357 16.9182 14.0214 17.1346 14.0214 17.4016L14.0214 27.6385L12.3507 25.9428L12.3246 25.9182C12.137 25.7539 11.8528 25.7614 11.674 25.9412C11.4866 26.1295 11.4859 26.4356 11.6723 26.6248L14.1608 29.1505L14.1874 29.1756C14.3757 29.3398 14.6608 29.3311 14.8392 29.1505L17.3276 26.6248L17.3519 26.5983Z" fill="#646464" fill-rule="evenodd" stroke="none" />
          </svg>
        </svg>
      </div>
      <div class="pxlt-zoom-area">
        <div class="pxlt-zoom-area-action">
          <span class="pxlt-icon-plus">
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M5 5V8H3V5H0V3H3V0H5V3H8V5H5Z" fill="white"/>
            </svg>
          </span>
        </div>
        <div class="pxlt-zoom-area-slider-range-wrap">
          <input class="pxlt-zoom-area-slider-range" type="range" />
        </div>
        <div class="pxlt-zoom-area-action">
          <span class="pxlt-icon-minus">
            <svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="8" height="2" fill="white"/>
            </svg>
          </span>
        </div>
      </div>
    </div>
  </div>
`;
function e2(t, e) {
  let r = null, n = null, i = null;
  t.on("loadedmetadata", a);
  function a() {
    const u = document.querySelector(e.elSelector);
    if (!u) {
      console.error(`The element matching selector ${e.elSelector} for 'panoControlsSelector' prop cannot be found.`);
      return;
    }
    s(u), o(), r = yT.createComponent({
      wrapperEl: u,
      domString: ZN
    });
    const l = {
      zoomAreaContainer: r.el.querySelector(".pxlt-zoom-area"),
      zoomInButton: r.el.querySelector(".pxlt-icon-plus"),
      zoomOutButton: r.el.querySelector(".pxlt-icon-minus"),
      zoomRangeInput: r.el.querySelector(".pxlt-zoom-area-slider-range")
    }, d = {
      outerBox: r.el.querySelector(".pxlt-navigation-area-svg"),
      innerIcon: r.el.querySelector(".pxlt-navigation-area-svg .brush-arrows")
    };
    n = oN(t, l), i = JN(t, d), r.wrapperEl.appendChild(r.el), r.show();
  }
  function s(u) {
    ["click", "scroll", "mousedown", "mousemove", "mouseup", "mouseleave"].forEach((d) => u.addEventListener(d, (h) => h.stopPropagation()));
  }
  function o() {
    var u;
    r && (r.hide(), (u = r.el) == null || u.remove(), r = null), n && (n.destroy(), n = null), i && (i.destroy(), i = null);
  }
  return {
    component: () => r,
    zoomArea: () => n,
    brushArea: () => i
  };
}
P.registerPlugin("panoControls", function(t) {
  return e2(this, t);
});
var Vs = {}, t2 = {
  get exports() {
    return Vs;
  },
  set exports(t) {
    Vs = t;
  }
};
(function(t, e) {
  (function(r, n) {
    n(e);
  })(Zi, function(r) {
    r.PipsMode = void 0, function(F) {
      F.Range = "range", F.Steps = "steps", F.Positions = "positions", F.Count = "count", F.Values = "values";
    }(r.PipsMode || (r.PipsMode = {})), r.PipsType = void 0, function(F) {
      F[F.None = -1] = "None", F[F.NoValue = 0] = "NoValue", F[F.LargeValue = 1] = "LargeValue", F[F.SmallValue = 2] = "SmallValue";
    }(r.PipsType || (r.PipsType = {}));
    function n(F) {
      return i(F) && typeof F.from == "function";
    }
    function i(F) {
      return typeof F == "object" && typeof F.to == "function";
    }
    function a(F) {
      F.parentElement.removeChild(F);
    }
    function s(F) {
      return F != null;
    }
    function o(F) {
      F.preventDefault();
    }
    function u(F) {
      return F.filter(function(A) {
        return this[A] ? !1 : this[A] = !0;
      }, {});
    }
    function l(F, A) {
      return Math.round(F / A) * A;
    }
    function d(F, A) {
      var ue = F.getBoundingClientRect(), ve = F.ownerDocument, ie = ve.documentElement, je = D(ve);
      return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (je.x = 0), A ? ue.top + je.y - ie.clientTop : ue.left + je.x - ie.clientLeft;
    }
    function h(F) {
      return typeof F == "number" && !isNaN(F) && isFinite(F);
    }
    function f(F, A, ue) {
      ue > 0 && (y(F, A), setTimeout(function() {
        E(F, A);
      }, ue));
    }
    function v(F) {
      return Math.max(Math.min(F, 100), 0);
    }
    function b(F) {
      return Array.isArray(F) ? F : [F];
    }
    function _(F) {
      F = String(F);
      var A = F.split(".");
      return A.length > 1 ? A[1].length : 0;
    }
    function y(F, A) {
      F.classList && !/\s/.test(A) ? F.classList.add(A) : F.className += " " + A;
    }
    function E(F, A) {
      F.classList && !/\s/.test(A) ? F.classList.remove(A) : F.className = F.className.replace(new RegExp("(^|\\b)" + A.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function R(F, A) {
      return F.classList ? F.classList.contains(A) : new RegExp("\\b" + A + "\\b").test(F.className);
    }
    function D(F) {
      var A = window.pageXOffset !== void 0, ue = (F.compatMode || "") === "CSS1Compat", ve = A ? window.pageXOffset : ue ? F.documentElement.scrollLeft : F.body.scrollLeft, ie = A ? window.pageYOffset : ue ? F.documentElement.scrollTop : F.body.scrollTop;
      return {
        x: ve,
        y: ie
      };
    }
    function C() {
      return window.navigator.pointerEnabled ? {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup"
      } : window.navigator.msPointerEnabled ? {
        start: "MSPointerDown",
        move: "MSPointerMove",
        end: "MSPointerUp"
      } : {
        start: "mousedown touchstart",
        move: "mousemove touchmove",
        end: "mouseup touchend"
      };
    }
    function w() {
      var F = !1;
      try {
        var A = Object.defineProperty({}, "passive", {
          get: function() {
            F = !0;
          }
        });
        window.addEventListener("test", null, A);
      } catch {
      }
      return F;
    }
    function k() {
      return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }
    function I(F, A) {
      return 100 / (A - F);
    }
    function U(F, A, ue) {
      return A * 100 / (F[ue + 1] - F[ue]);
    }
    function $(F, A) {
      return U(F, F[0] < 0 ? A + Math.abs(F[0]) : A - F[0], 0);
    }
    function W(F, A) {
      return A * (F[1] - F[0]) / 100 + F[0];
    }
    function G(F, A) {
      for (var ue = 1; F >= A[ue]; )
        ue += 1;
      return ue;
    }
    function Y(F, A, ue) {
      if (ue >= F.slice(-1)[0])
        return 100;
      var ve = G(ue, F), ie = F[ve - 1], je = F[ve], Oe = A[ve - 1], ct = A[ve];
      return Oe + $([ie, je], ue) / I(Oe, ct);
    }
    function re(F, A, ue) {
      if (ue >= 100)
        return F.slice(-1)[0];
      var ve = G(ue, A), ie = F[ve - 1], je = F[ve], Oe = A[ve - 1], ct = A[ve];
      return W([ie, je], (ue - Oe) * I(Oe, ct));
    }
    function j(F, A, ue, ve) {
      if (ve === 100)
        return ve;
      var ie = G(ve, F), je = F[ie - 1], Oe = F[ie];
      return ue ? ve - je > (Oe - je) / 2 ? Oe : je : A[ie - 1] ? F[ie - 1] + l(ve - F[ie - 1], A[ie - 1]) : ve;
    }
    var J = (
      /** @class */
      function() {
        function F(A, ue, ve) {
          this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [ve || !1], this.xNumSteps = [!1], this.snap = ue;
          var ie, je = [];
          for (Object.keys(A).forEach(function(Oe) {
            je.push([b(A[Oe]), Oe]);
          }), je.sort(function(Oe, ct) {
            return Oe[0][0] - ct[0][0];
          }), ie = 0; ie < je.length; ie++)
            this.handleEntryPoint(je[ie][1], je[ie][0]);
          for (this.xNumSteps = this.xSteps.slice(0), ie = 0; ie < this.xNumSteps.length; ie++)
            this.handleStepPoint(ie, this.xNumSteps[ie]);
        }
        return F.prototype.getDistance = function(A) {
          for (var ue = [], ve = 0; ve < this.xNumSteps.length - 1; ve++)
            ue[ve] = U(this.xVal, A, ve);
          return ue;
        }, F.prototype.getAbsoluteDistance = function(A, ue, ve) {
          var ie = 0;
          if (A < this.xPct[this.xPct.length - 1])
            for (; A > this.xPct[ie + 1]; )
              ie++;
          else
            A === this.xPct[this.xPct.length - 1] && (ie = this.xPct.length - 2);
          !ve && A === this.xPct[ie + 1] && ie++, ue === null && (ue = []);
          var je, Oe = 1, ct = ue[ie], Ie = 0, jt = 0, $t = 0, Pt = 0;
          for (ve ? je = (A - this.xPct[ie]) / (this.xPct[ie + 1] - this.xPct[ie]) : je = (this.xPct[ie + 1] - A) / (this.xPct[ie + 1] - this.xPct[ie]); ct > 0; )
            Ie = this.xPct[ie + 1 + Pt] - this.xPct[ie + Pt], ue[ie + Pt] * Oe + 100 - je * 100 > 100 ? (jt = Ie * je, Oe = (ct - 100 * je) / ue[ie + Pt], je = 1) : (jt = ue[ie + Pt] * Ie / 100 * Oe, Oe = 0), ve ? ($t = $t - jt, this.xPct.length + Pt >= 1 && Pt--) : ($t = $t + jt, this.xPct.length - Pt >= 1 && Pt++), ct = ue[ie + Pt] * Oe;
          return A + $t;
        }, F.prototype.toStepping = function(A) {
          return A = Y(this.xVal, this.xPct, A), A;
        }, F.prototype.fromStepping = function(A) {
          return re(this.xVal, this.xPct, A);
        }, F.prototype.getStep = function(A) {
          return A = j(this.xPct, this.xSteps, this.snap, A), A;
        }, F.prototype.getDefaultStep = function(A, ue, ve) {
          var ie = G(A, this.xPct);
          return (A === 100 || ue && A === this.xPct[ie - 1]) && (ie = Math.max(ie - 1, 1)), (this.xVal[ie] - this.xVal[ie - 1]) / ve;
        }, F.prototype.getNearbySteps = function(A) {
          var ue = G(A, this.xPct);
          return {
            stepBefore: {
              startValue: this.xVal[ue - 2],
              step: this.xNumSteps[ue - 2],
              highestStep: this.xHighestCompleteStep[ue - 2]
            },
            thisStep: {
              startValue: this.xVal[ue - 1],
              step: this.xNumSteps[ue - 1],
              highestStep: this.xHighestCompleteStep[ue - 1]
            },
            stepAfter: {
              startValue: this.xVal[ue],
              step: this.xNumSteps[ue],
              highestStep: this.xHighestCompleteStep[ue]
            }
          };
        }, F.prototype.countStepDecimals = function() {
          var A = this.xNumSteps.map(_);
          return Math.max.apply(null, A);
        }, F.prototype.hasNoSize = function() {
          return this.xVal[0] === this.xVal[this.xVal.length - 1];
        }, F.prototype.convert = function(A) {
          return this.getStep(this.toStepping(A));
        }, F.prototype.handleEntryPoint = function(A, ue) {
          var ve;
          if (A === "min" ? ve = 0 : A === "max" ? ve = 100 : ve = parseFloat(A), !h(ve) || !h(ue[0]))
            throw new Error("noUiSlider: 'range' value isn't numeric.");
          this.xPct.push(ve), this.xVal.push(ue[0]);
          var ie = Number(ue[1]);
          ve ? this.xSteps.push(isNaN(ie) ? !1 : ie) : isNaN(ie) || (this.xSteps[0] = ie), this.xHighestCompleteStep.push(0);
        }, F.prototype.handleStepPoint = function(A, ue) {
          if (ue) {
            if (this.xVal[A] === this.xVal[A + 1]) {
              this.xSteps[A] = this.xHighestCompleteStep[A] = this.xVal[A];
              return;
            }
            this.xSteps[A] = U([this.xVal[A], this.xVal[A + 1]], ue, 0) / I(this.xPct[A], this.xPct[A + 1]);
            var ve = (this.xVal[A + 1] - this.xVal[A]) / this.xNumSteps[A], ie = Math.ceil(Number(ve.toFixed(3)) - 1), je = this.xVal[A] + this.xNumSteps[A] * ie;
            this.xHighestCompleteStep[A] = je;
          }
        }, F;
      }()
    ), z = {
      to: function(F) {
        return F === void 0 ? "" : F.toFixed(2);
      },
      from: Number
    }, Q = {
      target: "target",
      base: "base",
      origin: "origin",
      handle: "handle",
      handleLower: "handle-lower",
      handleUpper: "handle-upper",
      touchArea: "touch-area",
      horizontal: "horizontal",
      vertical: "vertical",
      background: "background",
      connect: "connect",
      connects: "connects",
      ltr: "ltr",
      rtl: "rtl",
      textDirectionLtr: "txt-dir-ltr",
      textDirectionRtl: "txt-dir-rtl",
      draggable: "draggable",
      drag: "state-drag",
      tap: "state-tap",
      active: "active",
      tooltip: "tooltip",
      pips: "pips",
      pipsHorizontal: "pips-horizontal",
      pipsVertical: "pips-vertical",
      marker: "marker",
      markerHorizontal: "marker-horizontal",
      markerVertical: "marker-vertical",
      markerNormal: "marker-normal",
      markerLarge: "marker-large",
      markerSub: "marker-sub",
      value: "value",
      valueHorizontal: "value-horizontal",
      valueVertical: "value-vertical",
      valueNormal: "value-normal",
      valueLarge: "value-large",
      valueSub: "value-sub"
    }, te = {
      tooltips: ".__tooltips",
      aria: ".__aria"
    };
    function ae(F, A) {
      if (!h(A))
        throw new Error("noUiSlider: 'step' is not numeric.");
      F.singleStep = A;
    }
    function ne(F, A) {
      if (!h(A))
        throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
      F.keyboardPageMultiplier = A;
    }
    function Se(F, A) {
      if (!h(A))
        throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
      F.keyboardMultiplier = A;
    }
    function Te(F, A) {
      if (!h(A))
        throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
      F.keyboardDefaultStep = A;
    }
    function We(F, A) {
      if (typeof A != "object" || Array.isArray(A))
        throw new Error("noUiSlider: 'range' is not an object.");
      if (A.min === void 0 || A.max === void 0)
        throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
      F.spectrum = new J(A, F.snap || !1, F.singleStep);
    }
    function Be(F, A) {
      if (A = b(A), !Array.isArray(A) || !A.length)
        throw new Error("noUiSlider: 'start' option is incorrect.");
      F.handles = A.length, F.start = A;
    }
    function ge(F, A) {
      if (typeof A != "boolean")
        throw new Error("noUiSlider: 'snap' option must be a boolean.");
      F.snap = A;
    }
    function fe(F, A) {
      if (typeof A != "boolean")
        throw new Error("noUiSlider: 'animate' option must be a boolean.");
      F.animate = A;
    }
    function me(F, A) {
      if (typeof A != "number")
        throw new Error("noUiSlider: 'animationDuration' option must be a number.");
      F.animationDuration = A;
    }
    function xe(F, A) {
      var ue = [!1], ve;
      if (A === "lower" ? A = [!0, !1] : A === "upper" && (A = [!1, !0]), A === !0 || A === !1) {
        for (ve = 1; ve < F.handles; ve++)
          ue.push(A);
        ue.push(!1);
      } else {
        if (!Array.isArray(A) || !A.length || A.length !== F.handles + 1)
          throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
        ue = A;
      }
      F.connect = ue;
    }
    function Ue(F, A) {
      switch (A) {
        case "horizontal":
          F.ort = 0;
          break;
        case "vertical":
          F.ort = 1;
          break;
        default:
          throw new Error("noUiSlider: 'orientation' option is invalid.");
      }
    }
    function Xe(F, A) {
      if (!h(A))
        throw new Error("noUiSlider: 'margin' option must be numeric.");
      A !== 0 && (F.margin = F.spectrum.getDistance(A));
    }
    function Ke(F, A) {
      if (!h(A))
        throw new Error("noUiSlider: 'limit' option must be numeric.");
      if (F.limit = F.spectrum.getDistance(A), !F.limit || F.handles < 2)
        throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
    function ke(F, A) {
      var ue;
      if (!h(A) && !Array.isArray(A))
        throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (Array.isArray(A) && !(A.length === 2 || h(A[0]) || h(A[1])))
        throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (A !== 0) {
        for (Array.isArray(A) || (A = [A, A]), F.padding = [F.spectrum.getDistance(A[0]), F.spectrum.getDistance(A[1])], ue = 0; ue < F.spectrum.xNumSteps.length - 1; ue++)
          if (F.padding[0][ue] < 0 || F.padding[1][ue] < 0)
            throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        var ve = A[0] + A[1], ie = F.spectrum.xVal[0], je = F.spectrum.xVal[F.spectrum.xVal.length - 1];
        if (ve / (je - ie) > 1)
          throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
      }
    }
    function Ce(F, A) {
      switch (A) {
        case "ltr":
          F.dir = 0;
          break;
        case "rtl":
          F.dir = 1;
          break;
        default:
          throw new Error("noUiSlider: 'direction' option was not recognized.");
      }
    }
    function $e(F, A) {
      if (typeof A != "string")
        throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
      var ue = A.indexOf("tap") >= 0, ve = A.indexOf("drag") >= 0, ie = A.indexOf("fixed") >= 0, je = A.indexOf("snap") >= 0, Oe = A.indexOf("hover") >= 0, ct = A.indexOf("unconstrained") >= 0, Ie = A.indexOf("drag-all") >= 0, jt = A.indexOf("smooth-steps") >= 0;
      if (ie) {
        if (F.handles !== 2)
          throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        Xe(F, F.start[1] - F.start[0]);
      }
      if (ct && (F.margin || F.limit))
        throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
      F.events = {
        tap: ue || je,
        drag: ve,
        dragAll: Ie,
        smoothSteps: jt,
        fixed: ie,
        snap: je,
        hover: Oe,
        unconstrained: ct
      };
    }
    function Nt(F, A) {
      if (A !== !1)
        if (A === !0 || i(A)) {
          F.tooltips = [];
          for (var ue = 0; ue < F.handles; ue++)
            F.tooltips.push(A);
        } else {
          if (A = b(A), A.length !== F.handles)
            throw new Error("noUiSlider: must pass a formatter for all handles.");
          A.forEach(function(ve) {
            if (typeof ve != "boolean" && !i(ve))
              throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
          }), F.tooltips = A;
        }
    }
    function dt(F, A) {
      if (A.length !== F.handles)
        throw new Error("noUiSlider: must pass a attributes for all handles.");
      F.handleAttributes = A;
    }
    function Ee(F, A) {
      if (!i(A))
        throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
      F.ariaFormat = A;
    }
    function Qe(F, A) {
      if (!n(A))
        throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
      F.format = A;
    }
    function Re(F, A) {
      if (typeof A != "boolean")
        throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
      F.keyboardSupport = A;
    }
    function Qt(F, A) {
      F.documentElement = A;
    }
    function Zr(F, A) {
      if (typeof A != "string" && A !== !1)
        throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
      F.cssPrefix = A;
    }
    function qa(F, A) {
      if (typeof A != "object")
        throw new Error("noUiSlider: 'cssClasses' must be an object.");
      typeof F.cssPrefix == "string" ? (F.cssClasses = {}, Object.keys(A).forEach(function(ue) {
        F.cssClasses[ue] = F.cssPrefix + A[ue];
      })) : F.cssClasses = A;
    }
    function Ci(F) {
      var A = {
        margin: null,
        limit: null,
        padding: null,
        animate: !0,
        animationDuration: 300,
        ariaFormat: z,
        format: z
      }, ue = {
        step: { r: !1, t: ae },
        keyboardPageMultiplier: { r: !1, t: ne },
        keyboardMultiplier: { r: !1, t: Se },
        keyboardDefaultStep: { r: !1, t: Te },
        start: { r: !0, t: Be },
        connect: { r: !0, t: xe },
        direction: { r: !0, t: Ce },
        snap: { r: !1, t: ge },
        animate: { r: !1, t: fe },
        animationDuration: { r: !1, t: me },
        range: { r: !0, t: We },
        orientation: { r: !1, t: Ue },
        margin: { r: !1, t: Xe },
        limit: { r: !1, t: Ke },
        padding: { r: !1, t: ke },
        behaviour: { r: !0, t: $e },
        ariaFormat: { r: !1, t: Ee },
        format: { r: !1, t: Qe },
        tooltips: { r: !1, t: Nt },
        keyboardSupport: { r: !0, t: Re },
        documentElement: { r: !1, t: Qt },
        cssPrefix: { r: !0, t: Zr },
        cssClasses: { r: !0, t: qa },
        handleAttributes: { r: !1, t: dt }
      }, ve = {
        connect: !1,
        direction: "ltr",
        behaviour: "tap",
        orientation: "horizontal",
        keyboardSupport: !0,
        cssPrefix: "noUi-",
        cssClasses: Q,
        keyboardPageMultiplier: 5,
        keyboardMultiplier: 1,
        keyboardDefaultStep: 10
      };
      F.format && !F.ariaFormat && (F.ariaFormat = F.format), Object.keys(ue).forEach(function(Ie) {
        if (!s(F[Ie]) && ve[Ie] === void 0) {
          if (ue[Ie].r)
            throw new Error("noUiSlider: '" + Ie + "' is required.");
          return;
        }
        ue[Ie].t(A, s(F[Ie]) ? F[Ie] : ve[Ie]);
      }), A.pips = F.pips;
      var ie = document.createElement("div"), je = ie.style.msTransform !== void 0, Oe = ie.style.transform !== void 0;
      A.transformRule = Oe ? "transform" : je ? "msTransform" : "webkitTransform";
      var ct = [
        ["left", "top"],
        ["right", "bottom"]
      ];
      return A.style = ct[A.dir][A.ort], A;
    }
    function $a(F, A, ue) {
      var ve = C(), ie = k(), je = ie && w(), Oe = F, ct, Ie, jt, $t, Pt, ze = A.spectrum, ki = [], yt = [], ut = [], Dn = 0, Li = {}, Ur = F.ownerDocument, Rn = A.documentElement || Ur.documentElement, On = Ur.body, cl = Ur.dir === "rtl" || A.ort === 1 ? 0 : 100;
      function Jt(N, q) {
        var K = Ur.createElement("div");
        return q && y(K, q), N.appendChild(K), K;
      }
      function Zt(N, q) {
        var K = Jt(N, A.cssClasses.origin), Z = Jt(K, A.cssClasses.handle);
        if (Jt(Z, A.cssClasses.touchArea), Z.setAttribute("data-handle", String(q)), A.keyboardSupport && (Z.setAttribute("tabindex", "0"), Z.addEventListener("keydown", function(de) {
          return Hn(de, q);
        })), A.handleAttributes !== void 0) {
          var he = A.handleAttributes[q];
          Object.keys(he).forEach(function(de) {
            Z.setAttribute(de, he[de]);
          });
        }
        return Z.setAttribute("role", "slider"), Z.setAttribute("aria-orientation", A.ort ? "vertical" : "horizontal"), q === 0 ? y(Z, A.cssClasses.handleLower) : q === A.handles - 1 && y(Z, A.cssClasses.handleUpper), K.handle = Z, K;
      }
      function to(N, q) {
        return q ? Jt(N, A.cssClasses.connect) : !1;
      }
      function hl(N, q) {
        var K = Jt(q, A.cssClasses.connects);
        Ie = [], jt = [], jt.push(to(K, N[0]));
        for (var Z = 0; Z < A.handles; Z++)
          Ie.push(Zt(q, Z)), ut[Z] = Z, jt.push(to(K, N[Z + 1]));
      }
      function Mn(N) {
        y(N, A.cssClasses.target), A.dir === 0 ? y(N, A.cssClasses.ltr) : y(N, A.cssClasses.rtl), A.ort === 0 ? y(N, A.cssClasses.horizontal) : y(N, A.cssClasses.vertical);
        var q = getComputedStyle(N).direction;
        return q === "rtl" ? y(N, A.cssClasses.textDirectionRtl) : y(N, A.cssClasses.textDirectionLtr), Jt(N, A.cssClasses.base);
      }
      function Ii(N, q) {
        return !A.tooltips || !A.tooltips[q] ? !1 : Jt(N.firstChild, A.cssClasses.tooltip);
      }
      function en() {
        return Oe.hasAttribute("disabled");
      }
      function Je(N) {
        var q = Ie[N];
        return q.hasAttribute("disabled");
      }
      function fl(N) {
        N != null ? (Ie[N].setAttribute("disabled", ""), Ie[N].handle.removeAttribute("tabindex")) : (Oe.setAttribute("disabled", ""), Ie.forEach(function(q) {
          q.handle.removeAttribute("tabindex");
        }));
      }
      function Nn(N) {
        N != null ? (Ie[N].removeAttribute("disabled"), Ie[N].handle.setAttribute("tabindex", "0")) : (Oe.removeAttribute("disabled"), Ie.forEach(function(q) {
          q.removeAttribute("disabled"), q.handle.setAttribute("tabindex", "0");
        }));
      }
      function Vr() {
        Pt && (pr("update" + te.tooltips), Pt.forEach(function(N) {
          N && a(N);
        }), Pt = null);
      }
      function io() {
        Vr(), Pt = Ie.map(Ii), Hr("update" + te.tooltips, function(N, q, K) {
          if (!(!Pt || !A.tooltips) && Pt[q] !== !1) {
            var Z = N[q];
            A.tooltips[q] !== !0 && (Z = A.tooltips[q].to(K[q])), Pt[q].innerHTML = Z;
          }
        });
      }
      function fr() {
        pr("update" + te.aria), Hr("update" + te.aria, function(N, q, K, Z, he) {
          ut.forEach(function(de) {
            var Pe = Ie[de], be = qr(yt, de, 0, !0, !0, !0), Ze = qr(yt, de, 100, !0, !0, !0), et = he[de], at = String(A.ariaFormat.to(K[de]));
            be = ze.fromStepping(be).toFixed(1), Ze = ze.fromStepping(Ze).toFixed(1), et = ze.fromStepping(et).toFixed(1), Pe.children[0].setAttribute("aria-valuemin", be), Pe.children[0].setAttribute("aria-valuemax", Ze), Pe.children[0].setAttribute("aria-valuenow", et), Pe.children[0].setAttribute("aria-valuetext", at);
          });
        });
      }
      function ht(N) {
        if (N.mode === r.PipsMode.Range || N.mode === r.PipsMode.Steps)
          return ze.xVal;
        if (N.mode === r.PipsMode.Count) {
          if (N.values < 2)
            throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
          for (var q = N.values - 1, K = 100 / q, Z = []; q--; )
            Z[q] = q * K;
          return Z.push(100), tn(Z, N.stepped);
        }
        return N.mode === r.PipsMode.Positions ? tn(N.values, N.stepped) : N.mode === r.PipsMode.Values ? N.stepped ? N.values.map(function(he) {
          return ze.fromStepping(ze.getStep(ze.toStepping(he)));
        }) : N.values : [];
      }
      function tn(N, q) {
        return N.map(function(K) {
          return ze.fromStepping(q ? ze.getStep(K) : K);
        });
      }
      function Ot(N) {
        function q(et, at) {
          return Number((et + at).toFixed(7));
        }
        var K = ht(N), Z = {}, he = ze.xVal[0], de = ze.xVal[ze.xVal.length - 1], Pe = !1, be = !1, Ze = 0;
        return K = u(K.slice().sort(function(et, at) {
          return et - at;
        })), K[0] !== he && (K.unshift(he), Pe = !0), K[K.length - 1] !== de && (K.push(de), be = !0), K.forEach(function(et, at) {
          var ft, Ye, Et, xt = et, pt = K[at + 1], Ct, Di, Ka, $n, Xa, sn, fo, po = N.mode === r.PipsMode.Steps;
          for (po && (ft = ze.xNumSteps[at]), ft || (ft = pt - xt), pt === void 0 && (pt = xt), ft = Math.max(ft, 1e-7), Ye = xt; Ye <= pt; Ye = q(Ye, ft)) {
            for (Ct = ze.toStepping(Ye), Di = Ct - Ze, Xa = Di / (N.density || 1), sn = Math.round(Xa), fo = Di / sn, Et = 1; Et <= sn; Et += 1)
              Ka = Ze + Et * fo, Z[Ka.toFixed(5)] = [ze.fromStepping(Ka), 0];
            $n = K.indexOf(Ye) > -1 ? r.PipsType.LargeValue : po ? r.PipsType.SmallValue : r.PipsType.NoValue, !at && Pe && Ye !== pt && ($n = 0), Ye === pt && be || (Z[Ct.toFixed(5)] = [Ye, $n]), Ze = Ct;
          }
        }), Z;
      }
      function pl(N, q, K) {
        var Z, he, de = Ur.createElement("div"), Pe = (Z = {}, Z[r.PipsType.None] = "", Z[r.PipsType.NoValue] = A.cssClasses.valueNormal, Z[r.PipsType.LargeValue] = A.cssClasses.valueLarge, Z[r.PipsType.SmallValue] = A.cssClasses.valueSub, Z), be = (he = {}, he[r.PipsType.None] = "", he[r.PipsType.NoValue] = A.cssClasses.markerNormal, he[r.PipsType.LargeValue] = A.cssClasses.markerLarge, he[r.PipsType.SmallValue] = A.cssClasses.markerSub, he), Ze = [A.cssClasses.valueHorizontal, A.cssClasses.valueVertical], et = [A.cssClasses.markerHorizontal, A.cssClasses.markerVertical];
        y(de, A.cssClasses.pips), y(de, A.ort === 0 ? A.cssClasses.pipsHorizontal : A.cssClasses.pipsVertical);
        function at(Ye, Et) {
          var xt = Et === A.cssClasses.value, pt = xt ? Ze : et, Ct = xt ? Pe : be;
          return Et + " " + pt[A.ort] + " " + Ct[Ye];
        }
        function ft(Ye, Et, xt) {
          if (xt = q ? q(Et, xt) : xt, xt !== r.PipsType.None) {
            var pt = Jt(de, !1);
            pt.className = at(xt, A.cssClasses.marker), pt.style[A.style] = Ye + "%", xt > r.PipsType.NoValue && (pt = Jt(de, !1), pt.className = at(xt, A.cssClasses.value), pt.setAttribute("data-value", String(Et)), pt.style[A.style] = Ye + "%", pt.innerHTML = String(K.to(Et)));
          }
        }
        return Object.keys(N).forEach(function(Ye) {
          ft(Ye, N[Ye][0], N[Ye][1]);
        }), de;
      }
      function za() {
        $t && (a($t), $t = null);
      }
      function Bn(N) {
        za();
        var q = Ot(N), K = N.filter, Z = N.format || {
          to: function(he) {
            return String(Math.round(he));
          }
        };
        return $t = Oe.appendChild(pl(q, K, Z)), $t;
      }
      function Fn() {
        var N = ct.getBoundingClientRect(), q = "offset" + ["Width", "Height"][A.ort];
        return A.ort === 0 ? N.width || ct[q] : N.height || ct[q];
      }
      function $i(N, q, K, Z) {
        var he = function(Pe) {
          var be = ro(Pe, Z.pageOffset, Z.target || q);
          if (!be || en() && !Z.doNotReject || R(Oe, A.cssClasses.tap) && !Z.doNotReject || N === ve.start && be.buttons !== void 0 && be.buttons > 1 || Z.hover && be.buttons)
            return !1;
          je || be.preventDefault(), be.calcPoint = be.points[A.ort], K(be, Z);
        }, de = [];
        return N.split(" ").forEach(function(Pe) {
          q.addEventListener(Pe, he, je ? { passive: !0 } : !1), de.push([Pe, he]);
        }), de;
      }
      function ro(N, q, K) {
        var Z = N.type.indexOf("touch") === 0, he = N.type.indexOf("mouse") === 0, de = N.type.indexOf("pointer") === 0, Pe = 0, be = 0;
        if (N.type.indexOf("MSPointer") === 0 && (de = !0), N.type === "mousedown" && !N.buttons && !N.touches)
          return !1;
        if (Z) {
          var Ze = function(ft) {
            var Ye = ft.target;
            return Ye === K || K.contains(Ye) || N.composed && N.composedPath().shift() === K;
          };
          if (N.type === "touchstart") {
            var et = Array.prototype.filter.call(N.touches, Ze);
            if (et.length > 1)
              return !1;
            Pe = et[0].pageX, be = et[0].pageY;
          } else {
            var at = Array.prototype.find.call(N.changedTouches, Ze);
            if (!at)
              return !1;
            Pe = at.pageX, be = at.pageY;
          }
        }
        return q = q || D(Ur), (he || de) && (Pe = N.clientX + q.x, be = N.clientY + q.y), N.pageOffset = q, N.points = [Pe, be], N.cursor = he || de, N;
      }
      function Ga(N) {
        var q = N - d(ct, A.ort), K = q * 100 / Fn();
        return K = v(K), A.dir ? 100 - K : K;
      }
      function Un(N) {
        var q = 100, K = !1;
        return Ie.forEach(function(Z, he) {
          if (!Je(he)) {
            var de = yt[he], Pe = Math.abs(de - N), be = Pe === 100 && q === 100, Ze = Pe < q, et = Pe <= q && N > de;
            (Ze || et || be) && (K = he, q = Pe);
          }
        }), K;
      }
      function gl(N, q) {
        N.type === "mouseout" && N.target.nodeName === "HTML" && N.relatedTarget === null && jn(N, q);
      }
      function Vn(N, q) {
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && N.buttons === 0 && q.buttonsProperty !== 0)
          return jn(N, q);
        var K = (A.dir ? -1 : 1) * (N.calcPoint - q.startCalcPoint), Z = K * 100 / q.baseSize;
        no(K > 0, Z, q.locations, q.handleNumbers, q.connect);
      }
      function jn(N, q) {
        q.handle && (E(q.handle, A.cssClasses.active), Dn -= 1), q.listeners.forEach(function(K) {
          Rn.removeEventListener(K[0], K[1]);
        }), Dn === 0 && (E(Oe, A.cssClasses.drag), Wn(), N.cursor && (On.style.cursor = "", On.removeEventListener("selectstart", o))), A.events.smoothSteps && (q.handleNumbers.forEach(function(K) {
          zi(K, yt[K], !0, !0, !1, !1);
        }), q.handleNumbers.forEach(function(K) {
          _t("update", K);
        })), q.handleNumbers.forEach(function(K) {
          _t("change", K), _t("set", K), _t("end", K);
        });
      }
      function jr(N, q) {
        if (!q.handleNumbers.some(Je)) {
          var K;
          if (q.handleNumbers.length === 1) {
            var Z = Ie[q.handleNumbers[0]];
            K = Z.children[0], Dn += 1, y(K, A.cssClasses.active);
          }
          N.stopPropagation();
          var he = [], de = $i(ve.move, Rn, Vn, {
            // The event target has changed so we need to propagate the original one so that we keep
            // relying on it to extract target touches.
            target: N.target,
            handle: K,
            connect: q.connect,
            listeners: he,
            startCalcPoint: N.calcPoint,
            baseSize: Fn(),
            pageOffset: N.pageOffset,
            handleNumbers: q.handleNumbers,
            buttonsProperty: N.buttons,
            locations: yt.slice()
          }), Pe = $i(ve.end, Rn, jn, {
            target: N.target,
            handle: K,
            listeners: he,
            doNotReject: !0,
            handleNumbers: q.handleNumbers
          }), be = $i("mouseout", Rn, gl, {
            target: N.target,
            handle: K,
            listeners: he,
            doNotReject: !0,
            handleNumbers: q.handleNumbers
          });
          he.push.apply(he, de.concat(Pe, be)), N.cursor && (On.style.cursor = getComputedStyle(N.target).cursor, Ie.length > 1 && y(Oe, A.cssClasses.drag), On.addEventListener("selectstart", o, !1)), q.handleNumbers.forEach(function(Ze) {
            _t("start", Ze);
          });
        }
      }
      function ml(N) {
        N.stopPropagation();
        var q = Ga(N.calcPoint), K = Un(q);
        K !== !1 && (A.events.snap || f(Oe, A.cssClasses.tap, A.animationDuration), zi(K, q, !0, !0), Wn(), _t("slide", K, !0), _t("update", K, !0), A.events.snap ? jr(N, { handleNumbers: [K] }) : (_t("change", K, !0), _t("set", K, !0)));
      }
      function vl(N) {
        var q = Ga(N.calcPoint), K = ze.getStep(q), Z = ze.fromStepping(K);
        Object.keys(Li).forEach(function(he) {
          he.split(".")[0] === "hover" && Li[he].forEach(function(de) {
            de.call(qn, Z);
          });
        });
      }
      function Hn(N, q) {
        if (en() || Je(q))
          return !1;
        var K = ["Left", "Right"], Z = ["Down", "Up"], he = ["PageDown", "PageUp"], de = ["Home", "End"];
        A.dir && !A.ort ? K.reverse() : A.ort && !A.dir && (Z.reverse(), he.reverse());
        var Pe = N.key.replace("Arrow", ""), be = Pe === he[0], Ze = Pe === he[1], et = Pe === Z[0] || Pe === K[0] || be, at = Pe === Z[1] || Pe === K[1] || Ze, ft = Pe === de[0], Ye = Pe === de[1];
        if (!et && !at && !ft && !Ye)
          return !0;
        N.preventDefault();
        var Et;
        if (at || et) {
          var xt = et ? 0 : 1, pt = co(q), Ct = pt[xt];
          if (Ct === null)
            return !1;
          Ct === !1 && (Ct = ze.getDefaultStep(yt[q], et, A.keyboardDefaultStep)), Ze || be ? Ct *= A.keyboardPageMultiplier : Ct *= A.keyboardMultiplier, Ct = Math.max(Ct, 1e-7), Ct = (et ? -1 : 1) * Ct, Et = ki[q] + Ct;
        } else
          Ye ? Et = A.spectrum.xVal[A.spectrum.xVal.length - 1] : Et = A.spectrum.xVal[0];
        return zi(q, ze.toStepping(Et), !0, !0), _t("slide", q), _t("update", q), _t("change", q), _t("set", q), !1;
      }
      function rn(N) {
        N.fixed || Ie.forEach(function(q, K) {
          $i(ve.start, q.children[0], jr, {
            handleNumbers: [K]
          });
        }), N.tap && $i(ve.start, ct, ml, {}), N.hover && $i(ve.move, ct, vl, {
          hover: !0
        }), N.drag && jt.forEach(function(q, K) {
          if (!(q === !1 || K === 0 || K === jt.length - 1)) {
            var Z = Ie[K - 1], he = Ie[K], de = [q], Pe = [Z, he], be = [K - 1, K];
            y(q, A.cssClasses.draggable), N.fixed && (de.push(Z.children[0]), de.push(he.children[0])), N.dragAll && (Pe = Ie, be = ut), de.forEach(function(Ze) {
              $i(ve.start, Ze, jr, {
                handles: Pe,
                handleNumbers: be,
                connect: q
              });
            });
          }
        });
      }
      function Hr(N, q) {
        Li[N] = Li[N] || [], Li[N].push(q), N.split(".")[0] === "update" && Ie.forEach(function(K, Z) {
          _t("update", Z);
        });
      }
      function Wr(N) {
        return N === te.aria || N === te.tooltips;
      }
      function pr(N) {
        var q = N && N.split(".")[0], K = q ? N.substring(q.length) : N;
        Object.keys(Li).forEach(function(Z) {
          var he = Z.split(".")[0], de = Z.substring(he.length);
          (!q || q === he) && (!K || K === de) && (!Wr(de) || K === de) && delete Li[Z];
        });
      }
      function _t(N, q, K) {
        Object.keys(Li).forEach(function(Z) {
          var he = Z.split(".")[0];
          N === he && Li[Z].forEach(function(de) {
            de.call(
              // Use the slider public API as the scope ('this')
              qn,
              // Return values as array, so arg_1[arg_2] is always valid.
              ki.map(A.format.to),
              // Handle index, 0 or 1
              q,
              // Un-formatted slider values
              ki.slice(),
              // Event is fired by tap, true or false
              K || !1,
              // Left offset of the handle, in relation to the slider
              yt.slice(),
              // add the slider public API to an accessible parameter when this is unavailable
              qn
            );
          });
        });
      }
      function qr(N, q, K, Z, he, de, Pe) {
        var be;
        return Ie.length > 1 && !A.events.unconstrained && (Z && q > 0 && (be = ze.getAbsoluteDistance(N[q - 1], A.margin, !1), K = Math.max(K, be)), he && q < Ie.length - 1 && (be = ze.getAbsoluteDistance(N[q + 1], A.margin, !0), K = Math.min(K, be))), Ie.length > 1 && A.limit && (Z && q > 0 && (be = ze.getAbsoluteDistance(N[q - 1], A.limit, !1), K = Math.min(K, be)), he && q < Ie.length - 1 && (be = ze.getAbsoluteDistance(N[q + 1], A.limit, !0), K = Math.max(K, be))), A.padding && (q === 0 && (be = ze.getAbsoluteDistance(0, A.padding[0], !1), K = Math.max(K, be)), q === Ie.length - 1 && (be = ze.getAbsoluteDistance(100, A.padding[1], !0), K = Math.min(K, be))), Pe || (K = ze.getStep(K)), K = v(K), K === N[q] && !de ? !1 : K;
      }
      function _i(N, q) {
        var K = A.ort;
        return (K ? q : N) + ", " + (K ? N : q);
      }
      function no(N, q, K, Z, he) {
        var de = K.slice(), Pe = Z[0], be = A.events.smoothSteps, Ze = [!N, N], et = [N, !N];
        Z = Z.slice(), N && Z.reverse(), Z.length > 1 ? Z.forEach(function(ft, Ye) {
          var Et = qr(de, ft, de[ft] + q, Ze[Ye], et[Ye], !1, be);
          Et === !1 ? q = 0 : (q = Et - de[ft], de[ft] = Et);
        }) : Ze = et = [!0];
        var at = !1;
        Z.forEach(function(ft, Ye) {
          at = zi(ft, K[ft] + q, Ze[Ye], et[Ye], !1, be) || at;
        }), at && (Z.forEach(function(ft) {
          _t("update", ft), _t("slide", ft);
        }), he != null && _t("drag", Pe));
      }
      function nn(N, q) {
        return A.dir ? 100 - N - q : N;
      }
      function ao(N, q) {
        yt[N] = q, ki[N] = ze.fromStepping(q);
        var K = nn(q, 0) - cl, Z = "translate(" + _i(K + "%", "0") + ")";
        Ie[N].style[A.transformRule] = Z, so(N), so(N + 1);
      }
      function Wn() {
        ut.forEach(function(N) {
          var q = yt[N] > 50 ? -1 : 1, K = 3 + (Ie.length + q * N);
          Ie[N].style.zIndex = String(K);
        });
      }
      function zi(N, q, K, Z, he, de) {
        return he || (q = qr(yt, N, q, K, Z, !1, de)), q === !1 ? !1 : (ao(N, q), !0);
      }
      function so(N) {
        if (jt[N]) {
          var q = 0, K = 100;
          N !== 0 && (q = yt[N - 1]), N !== jt.length - 1 && (K = yt[N]);
          var Z = K - q, he = "translate(" + _i(nn(q, Z) + "%", "0") + ")", de = "scale(" + _i(Z / 100, "1") + ")";
          jt[N].style[A.transformRule] = he + " " + de;
        }
      }
      function an(N, q) {
        return N === null || N === !1 || N === void 0 || (typeof N == "number" && (N = String(N)), N = A.format.from(N), N !== !1 && (N = ze.toStepping(N)), N === !1 || isNaN(N)) ? yt[q] : N;
      }
      function Gi(N, q, K) {
        var Z = b(N), he = yt[0] === void 0;
        q = q === void 0 ? !0 : q, A.animate && !he && f(Oe, A.cssClasses.tap, A.animationDuration), ut.forEach(function(be) {
          zi(be, an(Z[be], be), !0, !1, K);
        });
        var de = ut.length === 1 ? 0 : 1;
        if (he && ze.hasNoSize() && (K = !0, yt[0] = 0, ut.length > 1)) {
          var Pe = 100 / (ut.length - 1);
          ut.forEach(function(be) {
            yt[be] = be * Pe;
          });
        }
        for (; de < ut.length; ++de)
          ut.forEach(function(be) {
            zi(be, yt[be], !0, !0, K);
          });
        Wn(), ut.forEach(function(be) {
          _t("update", be), Z[be] !== null && q && _t("set", be);
        });
      }
      function oo(N) {
        Gi(A.start, N);
      }
      function yl(N, q, K, Z) {
        if (N = Number(N), !(N >= 0 && N < ut.length))
          throw new Error("noUiSlider: invalid handle number, got: " + N);
        zi(N, an(q, N), !0, !0, Z), _t("update", N), K && _t("set", N);
      }
      function uo(N) {
        if (N === void 0 && (N = !1), N)
          return ki.length === 1 ? ki[0] : ki.slice(0);
        var q = ki.map(A.format.to);
        return q.length === 1 ? q[0] : q;
      }
      function lo() {
        for (pr(te.aria), pr(te.tooltips), Object.keys(A.cssClasses).forEach(function(N) {
          E(Oe, A.cssClasses[N]);
        }); Oe.firstChild; )
          Oe.removeChild(Oe.firstChild);
        delete Oe.noUiSlider;
      }
      function co(N) {
        var q = yt[N], K = ze.getNearbySteps(q), Z = ki[N], he = K.thisStep.step, de = null;
        if (A.snap)
          return [
            Z - K.stepBefore.startValue || null,
            K.stepAfter.startValue - Z || null
          ];
        he !== !1 && Z + he > K.stepAfter.startValue && (he = K.stepAfter.startValue - Z), Z > K.thisStep.startValue ? de = K.thisStep.step : K.stepBefore.step === !1 ? de = !1 : de = Z - K.stepBefore.highestStep, q === 100 ? he = null : q === 0 && (de = null);
        var Pe = ze.countStepDecimals();
        return he !== null && he !== !1 && (he = Number(he.toFixed(Pe))), de !== null && de !== !1 && (de = Number(de.toFixed(Pe))), [de, he];
      }
      function _l() {
        return ut.map(co);
      }
      function ho(N, q) {
        var K = uo(), Z = [
          "margin",
          "limit",
          "padding",
          "range",
          "animate",
          "snap",
          "step",
          "format",
          "pips",
          "tooltips"
        ];
        Z.forEach(function(de) {
          N[de] !== void 0 && (ue[de] = N[de]);
        });
        var he = Ci(ue);
        Z.forEach(function(de) {
          N[de] !== void 0 && (A[de] = he[de]);
        }), ze = he.spectrum, A.margin = he.margin, A.limit = he.limit, A.padding = he.padding, A.pips ? Bn(A.pips) : za(), A.tooltips ? io() : Vr(), yt = [], Gi(s(N.start) ? N.start : K, q);
      }
      function Tl() {
        ct = Mn(Oe), hl(A.connect, ct), rn(A.events), Gi(A.start), A.pips && Bn(A.pips), A.tooltips && io(), fr();
      }
      Tl();
      var qn = {
        destroy: lo,
        steps: _l,
        on: Hr,
        off: pr,
        get: uo,
        set: Gi,
        setHandle: yl,
        reset: oo,
        disable: fl,
        enable: Nn,
        // Exposed for unit testing, don't use this in your application.
        __moveHandles: function(N, q, K) {
          no(N, q, yt, K);
        },
        options: ue,
        updateOptions: ho,
        target: Oe,
        removePips: za,
        removeTooltips: Vr,
        getPositions: function() {
          return yt.slice();
        },
        getTooltips: function() {
          return Pt;
        },
        getOrigins: function() {
          return Ie;
        },
        pips: Bn
        // Issue #594
      };
      return qn;
    }
    function Ln(F, A) {
      if (!F || !F.nodeName)
        throw new Error("noUiSlider: create requires a single element, got: " + F);
      if (F.noUiSlider)
        throw new Error("noUiSlider: Slider was already initialized.");
      var ue = Ci(A), ve = $a(F, ue, A);
      return F.noUiSlider = ve, ve;
    }
    var In = {
      // Exposed for unit testing, don't use this in your application.
      __spectrum: J,
      // A reference to the default classes, allows global changes.
      // Use the cssClasses option for changes to one slider.
      cssClasses: Q,
      create: Ln
    };
    r.create = Ln, r.cssClasses = Q, r.default = In, Object.defineProperty(r, "__esModule", { value: !0 });
  });
})(t2, Vs);
const i2 = /* @__PURE__ */ fb(Vs);
const r2 = {
  sliderBehaviour: "tap-drag",
  sliderMargin: 5,
  // 5 seconds
  sliderLimit: 120
  // 2 minutes
};
function iv(t, e) {
  let r = P.mergeOptions(r2, e), n = null, i = null;
  const a = {
    setRange: l,
    getRange: d,
    show: h,
    hide: f,
    toggle: b,
    setup: s,
    destroy: u,
    getElement: () => n,
    getSlider: () => i,
    updateOptions: o
  };
  function s() {
    n = E(), i = y(n), r.createRangeIndicators && R(n, i), r.onCreated && r.onCreated();
  }
  function o(D) {
    return u(), r = P.mergeOptions(r, D), s(), r;
  }
  function u() {
    i == null || i.destroy(), n == null || n.remove(), i = null, n = null, r.onDestroyed && r.onDestroyed();
  }
  function l(D, C) {
    const w = a.getSlider();
    w && w.set([D, C]);
  }
  function d() {
    const D = a.getSlider();
    if (!D)
      return [0, 0];
    const [C, w] = D.get();
    return [Number(C), Number(w)];
  }
  function h() {
    a.setup();
  }
  function f() {
    a.destroy();
  }
  function v() {
    return !!(n && i);
  }
  function b(D) {
    return D ? v() ? void 0 : h() : f();
  }
  function _(D, C) {
    const w = C - D, k = w * 0.33, I = w * 0.66;
    return [D + k, D + I];
  }
  function y(D) {
    const C = () => t.liveTracker.isLive() ? t.liveTracker.seekableEnd() : t.duration(), w = () => {
      const G = window.innerWidth;
      return Math.min(Math.max(Math.floor(G / 100), 2), 10);
    }, k = {
      // Slider can select '0' to 'duration'
      min: r.sliderRange ? r.sliderRange.min : 0,
      max: r.sliderRange ? r.sliderRange.max : C() || 0
    }, I = r.sliderStart || _(k.min, k.max), U = i2.create(D, {
      direction: "ltr",
      start: I,
      // Handle start position
      step: 1,
      // Slider moves in increments of '1'
      margin: r.sliderMargin,
      // Handles must be more than 'margin' apart
      limit: r.sliderLimit,
      // Handles must be less than 'limit'
      connect: !0,
      // Display a colored bar between the handles
      behaviour: r.sliderBehaviour,
      // Move handle on tap, bar is draggable
      range: k,
      tooltips: r.showTooltips ? [{ to: t.utils.formatTime }, { to: t.utils.formatTime }] : void 0,
      pips: r.showPips ? {
        mode: Vs.PipsMode.Count,
        values: w(),
        // density: 5,
        format: { to: t.utils.formatTime }
      } : void 0
    });
    let $, W = k.min;
    return k.max, U.on("update", function(G, Y) {
      Y ? $ = G[Y] || 0 : ($ = G[Y] || 0, W != $ && (W = Number($), t.currentTime(W))), r.onChanged && r.onChanged();
    }), U;
  }
  function E() {
    const D = document.createElement("div");
    let C = document.body;
    return r.rootElement && (typeof r.rootElement == "function" ? C = r.rootElement() : C = r.rootElement), C.appendChild(D), D;
  }
  function R(D, C) {
    const w = document.createElement("div"), k = document.createElement("div"), I = document.createElement("div");
    w.classList.add("videojs-trimming-range-duration"), k.classList.add("videojs-trimming-range-start"), I.classList.add("videojs-trimming-range-end"), k.innerText = t.utils.formatTime(
      C.options.range.min
    ), I.innerText = t.utils.formatTime(
      C.options.range.max
    ), D.appendChild(k), D.appendChild(I), D.appendChild(w), C.on("update", function(U, $) {
      const [W, G] = U, Y = Number(G) - Number(W);
      w.innerText = t.utils.formatTime(Y);
    });
  }
  return a;
}
function n2(t, e) {
  function r() {
    return t.controlBar.progressControl.el();
  }
  function n() {
    t.addClass("videojs-trimming-range-active");
  }
  function i() {
    t.trigger("trim:changed");
  }
  function a() {
    t.removeClass("videojs-trimming-range-active");
  }
  const s = P.mergeOptions(
    {
      rootElement: r,
      onCreated: n,
      onChanged: i,
      onDestroyed: a,
      createRangeIndicators: !0,
      showTooltips: !0
    },
    e
  );
  t.trimAPI = iv(t, s), t.createAPI = iv.bind(null, t);
}
P.registerPlugin(
  "trim",
  function(t) {
    const e = P.mergeOptions({}, t, this.options_.trim);
    n2(this, e);
  }
);
const Zc = function() {
  const t = this.currentTime();
  t < 0 && (this.currentTime(0), this.play()), this._offsetEnd > 0 && t > this._offsetEnd - this._offsetStart && (this.off("timeupdate", Zc), this.pause(), this.trigger("ended"), this.one("play", () => {
    this.on("timeupdate", Zc);
  }), this._restartBeginning ? (this.trigger("loadstart"), this.currentTime(0)) : this.currentTime(this._offsetEnd - this._offsetStart));
}, a2 = (t) => {
  t.one("play", () => {
    t.on("timeupdate", Zc);
  });
}, s2 = {}, o2 = function(t) {
  t = t || {};
  const e = this.constructor;
  this._offsetStart = parseFloat(t.start || "0"), this._offsetEnd = parseFloat(t.end || "0"), this._restartBeginning = t.restart_beginning || !1, (!e.__super__ || !e.__super__.__offsetInit) && (e.__super__ = {
    __offsetInit: !0,
    duration: e.prototype.duration,
    currentTime: e.prototype.currentTime,
    bufferedPercent: e.prototype.bufferedPercent,
    remainingTime: e.prototype.remainingTime,
    buffered: e.prototype.buffered
  }, e.prototype.duration = function() {
    return this._offsetEnd !== void 0 && this._offsetStart !== void 0 ? this._offsetEnd > 0 ? this._offsetEnd - this._offsetStart : e.__super__.duration.apply(this, arguments) - this._offsetStart : e.__super__.duration.apply(this, arguments);
  }, e.prototype.currentTime = function(r) {
    if (r !== void 0)
      return this._offsetStart !== void 0 ? e.__super__.currentTime.call(this, r + this._offsetStart) : e.__super__.currentTime.call(this, r);
    if (this._offsetStart !== void 0) {
      const n = e.__super__.currentTime.apply(this) - this._offsetStart;
      return this.getCache().currentTime = n, n;
    }
    return e.__super__.currentTime.apply(this);
  }, e.prototype.remainingTime = function() {
    return this.duration() - this.currentTime();
  }, e.prototype.startOffset = function() {
    return this._offsetStart;
  }, e.prototype.endOffset = function() {
    return this._offsetEnd > 0 ? this._offsetEnd : this.duration();
  }, e.prototype.buffered = function() {
    const r = e.__super__.buffered.call(this), n = [];
    for (let i = 0; i < r.length; i++)
      n[i] = [
        Math.max(0, r.start(i) - this._offsetStart),
        Math.min(Math.max(0, r.end(i) - this._offsetStart), this.duration())
      ];
    return P.createTimeRanges(n);
  }), this.ready(() => {
    a2(this, P.mergeOptions(s2, t));
  });
};
P.registerPlugin("clip", o2);
function u2(t, e) {
  let r = (e == null ? void 0 : e.data) || [];
  const n = { data: s, add: v, set: b, hide: f, show: l };
  t.on("loadedmetadata", i), t.tagsAPI = n;
  function i() {
    const _ = JSON.parse(JSON.stringify(r));
    b(_);
  }
  function a(_) {
    return Number((_.time / t.duration() * 100).toFixed(2));
  }
  function s(_) {
    return _ && Array.isArray(_) && (r = _), r;
  }
  function o() {
    var y;
    const _ = (y = t.controlBar) == null ? void 0 : y.el_;
    return _ || console.error("[PixellotWebSDK|Tags]: Failed to render tags! ProgressControl component not found."), _;
  }
  function u() {
    const _ = o();
    if (!_)
      return null;
    let y = _.querySelector(".vjs-marker-wrapper");
    return y || (y = document.createElement("div"), y.classList.add("vjs-marker-wrapper"), _.append(y)), y;
  }
  function l() {
    if (!u())
      return;
    const y = e != null && e.renderGroups ? d(r) : r;
    for (let E = 0; E < y.length; E++)
      h(y[E]);
  }
  function d(_) {
    const E = [...Array(21).keys()].map((D) => [D * 5 - 5, D * 5]).slice(1), R = _.reduce((D, C) => {
      const w = a(C), k = E.find((U) => U[0] <= w && U[1] >= w) || E[E.length - 1], I = `${k[0]}, ${k[1]}`;
      return D[I] || (D[I] = []), D[I].push(C), D;
    }, {});
    return Object.values(R).map((D) => ({ tags: D, time: D[0].time, label: D[0].label }));
  }
  function h(_) {
    const y = document.createElement("div");
    y.classList.add("vjs-marker"), y.style.left = a(_) + "%", y.setAttribute("data-time", String(_.time)), _.label && (y.innerHTML = `<span class="vjs-marker-label">${_.label}</span>`), _.tags && _.tags.length > 1 && (y.classList.add("vjs-marker-group"), y.innerHTML = y.innerHTML.concat(`<span class="vjs-marker-group-count">${_.tags.length}</span>`)), y.addEventListener("click", (R) => {
      t.currentTime(_.time), e != null && e.onTagClick && (e == null || e.onTagClick(R, _));
    });
    const E = u();
    E && E.append(y);
  }
  function f() {
    const _ = u();
    _ && (_.querySelectorAll(".vjs-marker").forEach((y) => y.remove()), _.remove(), r = []);
  }
  function v(_) {
    r.push(_), l();
  }
  function b(_) {
    f(), r = _, l();
  }
}
P.registerPlugin(
  "tags",
  function(t) {
    const e = P.mergeOptions({}, t, this.options_.tags);
    this.tagsAPI || u2(this, e);
  }
);
const l2 = (t, e, r) => {
  const n = () => {
    const k = e.state.options;
    return {
      url: k.url,
      height: k.height,
      width: k.width,
      interval: k.interval,
      responsive: k.responsive,
      downlink: k.downlink
    };
  };
  let i = n().url, a = n().height, s = n().width, o, u;
  const l = window.navigator, d = l.connection || l.mozConnection || l.webkitConnection, h = {}, f = P.dom || P, v = t.controlBar, b = v && v.progressControl, _ = b && b.seekBar, y = _ && _.mouseTimeDisplay && _.mouseTimeDisplay.timeTooltip, E = y && y.el(), R = E && E.style, D = () => {
    E && R && (E.style = R);
  }, C = (k) => {
    const I = h[i], U = I.naturalWidth, $ = I.naturalHeight, W = _.el();
    if (I.complete && U && $) {
      let G = f.getPointerPosition(W, k).x * t.duration();
      G = G / n().interval;
      const Y = n().responsive, re = t.currentWidth(), j = Y && re < Y ? re / Y : 1, J = U / s, z = s * j, Q = a * j, te = Math.floor(G % J) * -z, ae = Math.floor(G / J) * -Q, ne = U * j + "px " + $ * j + "px", Se = f.findPosition(v.el()).top, Te = f.findPosition(W).top, We = -Q - Math.max(0, Te - Se), Be = {
        width: z + "px",
        height: Q + "px",
        "background-image": "url(" + i + ")",
        "background-repeat": "no-repeat",
        "background-position": te + "px " + ae + "px",
        "background-size": ne,
        top: We + "px",
        color: "#fff",
        "text-shadow": "1px 1px #000",
        border: "1px solid #000",
        margin: "0 1px"
      };
      Object.keys(Be).forEach((ge) => {
        E.style.setProperty(ge, Be[ge]);
      });
    } else
      D();
  }, w = () => {
    i = n().url, a = n().height, s = n().width;
  };
  e.on("statechanged", () => {
    w();
    const k = e.state, I = ["mousemove", "touchmove"], U = e.log || P.log, $ = U.debug || U;
    if (k.ready) {
      let W = "loading " + i;
      $("ready to show thumbnails"), o ? W = "re" + W : h[i] = f.createEl("img", {
        src: i
      }), $(W), b.on(I, C);
    } else
      b.off(I, C), D(), k.diagnostics && ($("resetting"), ["url", "width", "height"].forEach((G) => {
        n()[G] || U("no thumbnails " + G + " given");
      }), d && !u && U.warn("connection.downlink < " + n().downlink));
  }), t.on("loadstart", () => {
    e.setState({ ready: !1, diagnostics: !1 }), t.currentSources().forEach((k) => {
      const I = k.spriteThumbnails;
      I && (e.setState({ options: P.mergeOptions(r, I) }), i = n().url, a = n().height, s = n().width);
    }), u = !d || d.downlink >= n().downlink, o = h[i], e.setState({
      ready: y && s && a && i && (u || o),
      diagnostics: !0
    });
  }), t.addClass("vjs-sprite-thumbnails");
}, d2 = P.getPlugin("plugin"), c2 = {
  url: "",
  width: 0,
  height: 0,
  interval: 1,
  responsive: 600,
  downlink: 2
};
class ET extends d2 {
  /**
   * Create a SpriteThumbnails plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   */
  constructor(r, n) {
    super(r, n);
    st(this, "options");
    this.options = P.mergeOptions(c2, n), this.setState({ options: this.options }), this.player.ready(() => {
      l2(this.player, this);
    });
  }
  updateOptions(r) {
    const n = P.mergeOptions(this.state.options, r);
    this.setState({ options: n });
  }
}
ET.defaultState = {};
P.registerPlugin("spriteThumbnails", ET);
function h2(t) {
  const e = t.getComponent("Button");
  class r extends e {
    /**
     * This class is a button component designed to be displayed in the
     * player UI's control bar. It opens the Chromecast menu when clicked.
     *
     * @constructs
     * @extends external:Button
     * @param player {Player} the video.js player instance
     */
    constructor(i, a) {
      super(i, a), i.on("chromecastConnected", this._onChromecastConnected.bind(this)), i.on("chromecastDisconnected", this._onChromecastDisconnected.bind(this)), i.on("chromecastDevicesAvailable", this._onChromecastDevicesAvailable.bind(this)), i.on("chromecastDevicesUnavailable", this._onChromecastDevicesUnavailable.bind(this)), i.chromecastSessionManager && i.chromecastSessionManager.hasAvailableDevices() ? this._onChromecastDevicesAvailable() : this._onChromecastDevicesUnavailable(), a.addCastLabelToButton ? (this.el().classList.add("vjs-chromecast-button-lg"), this._labelEl = document.createElement("span"), this._labelEl.classList.add("vjs-chromecast-button-label"), this._updateCastLabelText(), this.el().appendChild(this._labelEl)) : this.controlText("Open Chromecast menu");
    }
    /**
     * Overrides Button#buildCSSClass to return the classes used on the button element.
     *
     * @param el {DOMElement}
     * @see {@link http://docs.videojs.com/Button.html#buildCSSClass|Button#buildCSSClass}
     */
    buildCSSClass() {
      return "vjs-chromecast-button " + (this._isChromecastConnected ? "vjs-chromecast-casting-state " : "") + (this.options_.addCastLabelToButton ? "vjs-chromecast-button-lg " : "") + e.prototype.buildCSSClass();
    }
    /**
     * Overrides Button#handleClick to handle button click events. Chromecast
     * functionality is handled outside of this class, which should be limited
     * to UI related logic.  This function simply triggers an event on the player.
     *
     * @fires ChromecastButton#chromecastRequested
     * @param el {DOMElement}
     * @see {@link http://docs.videojs.com/Button.html#handleClick|Button#handleClick}
     */
    handleClick() {
      this.player().trigger("chromecastRequested");
    }
    /**
     * Handles `chromecastConnected` player events.
     *
     * @private
     */
    _onChromecastConnected() {
      this._isChromecastConnected = !0, this._reloadCSSClasses(), this._updateCastLabelText();
    }
    /**
     * Handles `chromecastDisconnected` player events.
     *
     * @private
     */
    _onChromecastDisconnected() {
      this._isChromecastConnected = !1, this._reloadCSSClasses(), this._updateCastLabelText();
    }
    /**
     * Handles `chromecastDevicesAvailable` player events.
     *
     * @private
     */
    _onChromecastDevicesAvailable() {
      this.show();
    }
    /**
     * Handles `chromecastDevicesUnavailable` player events.
     *
     * @private
     */
    _onChromecastDevicesUnavailable() {
      this.hide();
    }
    /**
     * Re-calculates which CSS classes the button needs and sets them on the buttons'
     * DOMElement.
     *
     * @private
     */
    _reloadCSSClasses() {
      this.el_ && (this.el_.className = this.buildCSSClass());
    }
    /**
     * Updates the optional cast label text based on whether the chromecast is connected
     * or disconnected.
     *
     * @private
     */
    _updateCastLabelText() {
      this._labelEl && (this._labelEl.textContent = this._isChromecastConnected ? this.localize("Disconnect Cast") : this.localize("Cast"));
    }
  }
  t.registerComponent("chromecastButton", r);
}
const ha = class {
  /**
   * Stores the state of the current Chromecast session and its associated objects such
   * as the
   * [RemotePlayerController](https://developers.google.com/cast/docs/reference/chrome/cast.framework.RemotePlayerController),
   * and the
   * [RemotePlayer](https://developers.google.com/cast/docs/reference/chrome/cast.framework.RemotePlayer).
   *
   * WARNING: Do not instantiate this class until the
   * [CastContext](https://developers.google.com/cast/docs/reference/chrome/cast.framework.CastContext)
   * has been configured.
   *
   * For an undocumented (and thus unknown) reason, RemotePlayer and
   * RemotePlayerController instances created before the cast context has been configured
   * or after requesting a session or loading media will not stay in sync with media
   * items that are loaded later.
   *
   * For example, the first item that you cast will work as expected: events on
   * RemotePlayerController will fire and the state (currentTime, duration, etc) of the
   * RemotePlayer instance will update as the media item plays. However, if a new media
   * item is loaded via a `loadMedia` request, the media item will play, but the
   * remotePlayer will be in a "media unloaded" state where the duration is 0, the
   * currentTime does not update, and no change events are fired (except, strangely,
   * displayStatus updates).
   *
   * @param player {object} Video.js Player
   * @constructs ChromecastSessionManager
   */
  constructor(e) {
    this.player = e, this._sessionListener = this._onSessionStateChange.bind(this), this._castListener = this._onCastStateChange.bind(this), this._addCastContextEventListeners(), this.player.on("dispose", () => {
      this._removeCastContextEventListeners.bind(this), ha.isChromecastConnected() && this.getCastContext().endCurrentSession(!0);
    }), this._notifyPlayerOfDevicesAvailabilityChange(this.getCastContext().getCastState()), this.remotePlayer = new cast.framework.RemotePlayer(), this.remotePlayerController = new cast.framework.RemotePlayerController(this.remotePlayer);
  }
  /**
   * Add event listeners for events triggered on the current CastContext.
   *
   * @private
   */
  _addCastContextEventListeners() {
    var e = cast.framework.CastContextEventType.SESSION_STATE_CHANGED, r = cast.framework.CastContextEventType.CAST_STATE_CHANGED;
    this.getCastContext().addEventListener(e, this._sessionListener), this.getCastContext().addEventListener(r, this._castListener);
  }
  /**
   * Remove event listeners that were added in {@link
   * ChromecastSessionManager#_addCastContextEventListeners}.
   *
   * @private
   */
  _removeCastContextEventListeners() {
    var e = cast.framework.CastContextEventType.SESSION_STATE_CHANGED, r = cast.framework.CastContextEventType.CAST_STATE_CHANGED;
    this.getCastContext().removeEventListener(e, this._sessionListener), this.getCastContext().removeEventListener(r, this._castListener);
  }
  /**
   * Handle the CastContext's SessionState change event.
   *
   * @private
   */
  _onSessionStateChange(e) {
    e.sessionState === cast.framework.SessionState.SESSION_ENDED && (this.player.trigger("chromecastDisconnected"), this._reloadTech());
  }
  /**
   * Handle the CastContext's CastState change event.
   *
   * @private
   */
  _onCastStateChange(e) {
    this._notifyPlayerOfDevicesAvailabilityChange(e.castState);
  }
  /**
   * Triggers player events that notifies listeners that Chromecast devices are
   * either available or unavailable.
   *
   * @private
   */
  _notifyPlayerOfDevicesAvailabilityChange(e) {
    this.hasAvailableDevices(e) ? this.player.trigger("chromecastDevicesAvailable") : this.player.trigger("chromecastDevicesUnavailable");
  }
  /**
   * Returns whether or not there are Chromecast devices available to cast to.
   *
   * @see https://developers.google.com/cast/docs/reference/chrome/cast.framework#.CastState
   * @param {String} castState
   * @return {boolean} true if there are Chromecast devices available to cast to.
   */
  hasAvailableDevices(e) {
    return e = e || this.getCastContext().getCastState(), e === cast.framework.CastState.NOT_CONNECTED || e === cast.framework.CastState.CONNECTING || e === cast.framework.CastState.CONNECTED;
  }
  /**
   * Opens the Chromecast casting menu by requesting a CastSession. Does nothing if the
   * Video.js player does not have a source.
   */
  openCastMenu() {
    var e;
    this.player.currentSource() && (e = function() {
      ha.hasConnected = !0, this.player.trigger("chromecastConnected"), this._reloadTech();
    }.bind(this), this.getCastContext().requestSession().then(e, function() {
    }));
  }
  /**
   * Reloads the Video.js player's Tech. This causes the player to re-evaluate which
   * Tech should be used for the current source by iterating over available Tech and
   * calling `Tech.isSupported` and `Tech.canPlaySource`. Video.js uses the first
   * Tech that returns true from both of those functions. This is what allows us to
   * switch back and forth between the Chromecast Tech and other available Tech when a
   * CastSession is connected or disconnected.
   *
   * @private
   */
  _reloadTech() {
    var e = this.player, r = e.currentTime(), n = e.paused(), i = e.currentSources();
    e.src(i), e.ready(function() {
      n ? e.pause() : e.play(), e.currentTime(r || 0);
    });
  }
  /**
   * @see https://developers.google.com/cast/docs/reference/chrome/cast.framework.CastContext
   * @returns {object} the current CastContext, if one exists
   */
  getCastContext() {
    return cast.framework.CastContext.getInstance();
  }
  /**
   * @see https://developers.google.com/cast/docs/reference/chrome/cast.framework.RemotePlayer
   * @returns {object} the current RemotePlayer, if one exists
   */
  getRemotePlayer() {
    return this.remotePlayer;
  }
  /**
   * @see https://developers.google.com/cast/docs/reference/chrome/cast.framework.RemotePlayerController
   * @returns {object} the current RemotePlayerController, if one exists
   */
  getRemotePlayerController() {
    return this.remotePlayerController;
  }
  /**
   * Returns whether or not the current Chromecast API is available (that is,
   * `window.chrome`, `window.chrome.cast`, and `window.cast` exist).
   *
   * @static
   * @returns {boolean} true if the Chromecast API is available
   */
  static isChromecastAPIAvailable() {
    return window.chrome && window.chrome.cast && window.cast;
  }
  /**
   * Returns whether or not there is a current CastSession and it is connected.
   *
   * @static
   * @returns {boolean} true if the current CastSession exists and is connected
   */
  static isChromecastConnected() {
    return ha.isChromecastAPIAvailable() && cast.framework.CastContext.getInstance().getCastState() === cast.framework.CastState.CONNECTED && ha.hasConnected;
  }
};
let zr = ha;
st(zr, "hasConnected", !1);
class f2 {
  constructor() {
    this._el = this._createDOMElement();
  }
  /**
   * Creates and returns a single DOMElement that contains the UI. This implementation
   * of the Chromecast Tech's UI displays a poster image, a title and a subtitle.
   *
   * @private
   * @returns {DOMElement}
   */
  _createDOMElement() {
    var e = this._createElement("div", "vjs-tech vjs-tech-chromecast"), r = this._createElement("div", "vjs-tech-chromecast-poster"), n = this._createElement("img", "vjs-tech-chromecast-poster-img"), i = this._createElement("div", "vjs-tech-chromecast-title"), a = this._createElement("div", "vjs-tech-chromecast-subtitle"), s = this._createElement("div", "vjs-tech-chromecast-title-container");
    return r.appendChild(n), s.appendChild(i), s.appendChild(a), e.appendChild(s), e.appendChild(r), e;
  }
  /**
   * A helper method for creating DOMElements of the given type and with the given class
   * name(s).
   *
   * @param type {string} the kind of DOMElement to create (ex: 'div')
   * @param className {string} the class name(s) to give to the DOMElement. May also be
   * a space-delimited list of class names.
   * @returns {DOMElement}
   */
  _createElement(e, r) {
    var n = document.createElement(e);
    return n.className = r, n;
  }
  /**
   * Gets the root DOMElement to be shown in the player's UI.
   *
   * @returns {DOMElement}
   */
  getDOMElement() {
    return this._el;
  }
  /**
   * Finds the poster's DOMElement in the root UI element.
   *
   * @private
   * @returns {DOMElement}
   */
  _findPosterEl() {
    return this._el.querySelector(".vjs-tech-chromecast-poster");
  }
  /**
   * Finds the poster's <img> DOMElement in the root UI element.
   *
   * @private
   * @returns {DOMElement}
   */
  _findPosterImageEl() {
    return this._el.querySelector(".vjs-tech-chromecast-poster-img");
  }
  /**
   * Finds the title's DOMElement in the root UI element.
   *
   * @private
   * @returns {DOMElement}
   */
  _findTitleEl() {
    return this._el.querySelector(".vjs-tech-chromecast-title");
  }
  /**
   * Finds the subtitle's DOMElement in the root UI element.
   *
   * @private
   * @returns {DOMElement}
   */
  _findSubtitleEl() {
    return this._el.querySelector(".vjs-tech-chromecast-subtitle");
  }
  /**
   * Sets the current poster image URL and updates the poster image DOMElement with the
   * new poster image URL.
   *
   * @param poster {string} a URL for a poster image
   */
  updatePoster(e) {
    var r = this._findPosterImageEl();
    this._poster = e || null, e ? (r.setAttribute("src", e), r.classList.remove("vjs-tech-chromecast-poster-img-empty")) : (r.removeAttribute("src"), r.classList.add("vjs-tech-chromecast-poster-img-empty"));
  }
  /**
   * Gets the current poster image URL.
   *
   * @returns {string} the URL for th current poster image
   */
  getPoster() {
    return this._poster;
  }
  /**
   * Sets the current title and updates the title's DOMElement with the new text.
   *
   * @param title {string} a title to show
   */
  updateTitle(e) {
    var r = this._findTitleEl();
    this._title = e, e ? (r.innerHTML = e, r.classList.remove("vjs-tech-chromecast-title-empty")) : r.classList.add("vjs-tech-chromecast-title-empty");
  }
  /**
   * Sets the current subtitle and updates the subtitle's DOMElement with the new text.
   *
   * @param subtitle {string} a subtitle to show
   */
  updateSubtitle(e) {
    var r = this._findSubtitleEl();
    this._subtitle = e, e ? (r.innerHTML = e, r.classList.remove("vjs-tech-chromecast-subtitle-empty")) : r.classList.add("vjs-tech-chromecast-subtitle-empty");
  }
}
function p2(t) {
  var e = t.getComponent("Tech"), r = 10 * 1e3;
  class n extends e {
    /**
     * Implements Video.js playback {@link http://docs.videojs.com/tutorial-tech_.html|Tech}
     * for {@link https://developers.google.com/cast/|Google's Chromecast}.
     *
     * @constructs ChromecastTech
     * @extends external:Tech
     * @param options {object} The options to use for configuration
     * @see {@link https://developers.google.com/cast/|Google Cast}
     */
    constructor(a) {
      super(a), this.featuresVolumeControl = !0, this.featuresPlaybackRate = !1, this.movingMediaElementInDOM = !1, this.featuresFullscreenResize = !0, this.featuresTimeupdateEvents = !0, this.featuresProgressEvents = !1, this.featuresNativeTextTracks = !1, this.featuresNativeAudioTracks = !1, this.featuresNativeVideoTracks = !1, this.videojs = t, this._eventListeners = [], this.videojsPlayer = this.videojs(a.playerId), this._chromecastSessionManager = this.videojsPlayer.chromecastSessionManager, this._ui.updatePoster(this.videojsPlayer.poster()), this._remotePlayer = this._chromecastSessionManager.getRemotePlayer(), this._remotePlayerController = this._chromecastSessionManager.getRemotePlayerController(), this._listenToPlayerControllerEvents(), this.on("dispose", this._removeAllEventListeners.bind(this)), this._hasPlayedAnyItem = !1, this._requestTitle = a.requestTitleFn || function() {
      }, this._requestSubtitle = a.requestSubtitleFn || function() {
      }, this._requestCustomData = a.requestCustomDataFn || function() {
      }, this._modifyLoadRequestFn = a.modifyLoadRequestFn || function(s) {
        return s;
      }, this._initialStartTime = a.startTime || 0, this._isScrubbing = !1, this._isSeeking = !1, this._scrubbingTime = this._initialStartTime, this._playSource(a.source, this._initialStartTime), this.ready(function() {
        this.setMuted(a.muted);
      }.bind(this));
    }
    /**
     * Creates a DOMElement that Video.js displays in its player UI while this Tech is
     * active.
     *
     * @returns {DOMElement}
     * @see {@link http://docs.videojs.com/Tech.html#createEl}
     */
    createEl() {
      return this._ui = this._ui || new f2(), this._ui.getDOMElement();
    }
    /**
     * Resumes playback if a media item is paused or restarts an item from
     * its beginning if the item has played and ended.
     *
     * @see {@link http://docs.videojs.com/Player.html#play}
     */
    play() {
      this.paused() && (this.ended() && !this._isMediaLoading ? this._playSource({ src: this.videojsPlayer.src() }, 0) : this._remotePlayerController.playOrPause());
    }
    /**
     * Pauses playback if the player is not already paused and if the current media item
     * has not ended yet.
     *
     * @see {@link http://docs.videojs.com/Player.html#pause}
     */
    pause() {
      !this.paused() && this._remotePlayer.canPause && this._remotePlayerController.playOrPause();
    }
    /**
     * Returns whether or not the player is "paused". Video.js'
     * definition of "paused" is "playback paused" OR "not playing".
     *
     * @returns {boolean} true if playback is paused
     * @see {@link http://docs.videojs.com/Player.html#paused}
     */
    paused() {
      return this._remotePlayer.isPaused || this.ended() || this._remotePlayer.playerState === null;
    }
    /**
     * Stores the given source and begins playback, starting at the beginning
     * of the media item.
     *
     * @param source {object} the source to store and play
     * @see {@link http://docs.videojs.com/Player.html#src}
     */
    setSource(a) {
      this._currentSource && this._currentSource.src === a.src && this._currentSource.type === a.type || (this._currentSource = a, this._playSource(a, 0));
    }
    /**
     * Plays the given source, beginning at an optional starting time.
     *
     * @private
     * @param source {object} the source to play
     * @param [startTime] The time to start playback at, in seconds
     * @see {@link http://docs.videojs.com/Player.html#src}
     */
    _playSource(a, s) {
      var o = this._getCastSession(), u = new chrome.cast.media.MediaInfo(a.src, a.type), l = this._requestTitle(a), d = this._requestSubtitle(a), h = this.poster(), f = this._requestCustomData(a), v;
      this.trigger("waiting"), this._clearSessionTimeout(), u.metadata = new chrome.cast.media.GenericMediaMetadata(), u.metadata.metadataType = chrome.cast.media.MetadataType.GENERIC, u.metadata.title = l, u.metadata.subtitle = d, u.streamType = this.videojsPlayer.liveTracker && this.videojsPlayer.liveTracker.isLive() ? chrome.cast.media.StreamType.LIVE : chrome.cast.media.StreamType.BUFFERED, h && (u.metadata.images = [{ url: h }]), f && (u.customData = f), this._ui.updateTitle(l), this._ui.updateSubtitle(d), v = new chrome.cast.media.LoadRequest(u), v.autoplay = !0, v.currentTime = s, v = this._modifyLoadRequestFn(v), this._isMediaLoading = !0, this._hasPlayedCurrentItem = !1, o.loadMedia(v).then(function() {
        this._hasPlayedAnyItem || this.triggerReady(), this.trigger("loadstart"), this.trigger("loadeddata"), this.trigger("play"), this.trigger("playing"), this._hasPlayedAnyItem = !0, this._isMediaLoading = !1, this._getMediaSession().addUpdateListener(this._onMediaSessionStatusChanged.bind(this));
      }.bind(this), this._triggerErrorEvent.bind(this));
    }
    /**
     * Manually updates the current time. The playback position will jump to
     * the given time and continue playing if the item was playing when `setCurrentTime`
     * was called, or remain paused if the item was paused.
     *
     * @param time {number} the playback time position to jump to
     * @see {@link http://docs.videojs.com/Tech.html#setCurrentTime}
     */
    setCurrentTime(a) {
      if (this.scrubbing() || this.seeking())
        return this._scrubbingTime = a, !1;
      var s = this.duration();
      a > s || !this._remotePlayer.canSeek || (this._isSeeking = !0, setTimeout(() => {
        this._remotePlayer.currentTime = Math.min(s - 1, a), this._remotePlayerController.seek(), this._isSeeking = !1;
      }, 500), this._triggerTimeUpdateEvent());
    }
    seeking() {
      return this._isSeeking;
    }
    scrubbing() {
      return this._isScrubbing;
    }
    setScrubbing(a) {
      a === !0 ? (this._scrubbingTime = this.currentTime(), this._isScrubbing = !0) : (this._isScrubbing = !1, this.setCurrentTime(this._scrubbingTime));
    }
    /**
     * Returns the current playback time position.
     *
     * @returns {number} the current playback time position
     * @see {@link http://docs.videojs.com/Player.html#currentTime}
     */
    currentTime() {
      return this._hasPlayedAnyItem ? this.scrubbing() || this.seeking() ? this._scrubbingTime : this._remotePlayer.currentTime : this._initialStartTime;
    }
    /**
     * Returns the duration of the current media item, or `0` if the source
     * is not set or if the duration of the item is not available from the
     * Chromecast API yet.
     *
     * @returns {number} the duration of the current media item
     * @see {@link http://docs.videojs.com/Player.html#duration}
     */
    duration() {
      return this._hasPlayedAnyItem ? this._remotePlayer.duration : this.videojsPlayer.duration();
    }
    /**
     * Returns whether or not the current media item has finished playing.
     * Returns `false` if a media item has not been loaded, has not been played,
     * or has not yet finished playing.
     *
     * @returns {boolean} true if the current media item has finished playing
     * @see {@link http://docs.videojs.com/Player.html#ended}
     */
    ended() {
      var a = this._getMediaSession();
      return !a && this._hasMediaSessionEnded ? !0 : a ? a.idleReason === chrome.cast.media.IdleReason.FINISHED : !1;
    }
    /**
     * Returns the current volume level setting as a decimal number between `0` and `1`.
     *
     * @returns {number} the current volume level
     * @see {@link http://docs.videojs.com/Player.html#volume}
     */
    volume() {
      return this._remotePlayer.volumeLevel;
    }
    /**
     * Sets the current volume level. Volume level is a decimal number
     * between `0` and `1`, where `0` is muted and `1` is the loudest volume level.
     *
     * @param volumeLevel {number}
     * @returns {number} the current volume level
     * @see {@link http://docs.videojs.com/Player.html#volume}
     */
    setVolume(a) {
      this._remotePlayer.volumeLevel = a, this._remotePlayerController.setVolumeLevel(), this._triggerVolumeChangeEvent();
    }
    /**
     * Returns whether or not the player is currently muted.
     *
     * @returns {boolean} true if the player is currently muted
     * @see {@link http://docs.videojs.com/Player.html#muted}
     */
    muted() {
      return this._remotePlayer.isMuted;
    }
    /**
     * Mutes or un-mutes the player. Does nothing if the player is currently
     * muted and the `isMuted` parameter is true or if the player is not muted and
     * `isMuted` is false.
     *
     * @param isMuted {boolean} whether or not the player should be muted
     * @see {@link http://docs.videojs.com/Html5.html#setMuted} for an example
     */
    setMuted(a) {
      (this._remotePlayer.isMuted && !a || !this._remotePlayer.isMuted && a) && this._remotePlayerController.muteOrUnmute();
    }
    /**
     * Gets the URL to the current poster image.
     *
     * @returns {string} URL to the current poster image or `undefined` if none exists
     * @see {@link http://docs.videojs.com/Player.html#poster}
     */
    poster() {
      return this._ui.getPoster();
    }
    /**
     * Sets the URL to the current poster image. The poster image shown
     * in the Chromecast Tech UI view is updated with this new URL.
     *
     * @param poster {string} the URL to the new poster image
     * @see {@link http://docs.videojs.com/Tech.html#setPoster}
     */
    setPoster(a) {
      this._ui.updatePoster(a);
    }
    /**
     * This function is "required" when implementing {@link external:Tech}
     * and is supposed to return a mock
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges|TimeRanges}
     * object that represents the portions of the current media item that have been
     * buffered. However, the Chromecast API does not currently provide a way
     * to determine how much the media item has buffered, so we always
     * return `undefined`.
     *
     * Returning `undefined` is safe: the player will simply not display
     * the buffer amount indicator in the scrubber UI.
     *
     * @returns {undefined} always returns `undefined`
     * @see {@link http://docs.videojs.com/Player.html#buffered}
     */
    buffered() {
    }
    /**
     * This function is "required" when implementing {@link external:Tech}
     * and is supposed to return a mock
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges|TimeRanges}
     * object that represents the portions of the current media item that has playable
     * content. However, the Chromecast API does not currently provide a
     * way to determine how much the media item has playable content, so
     * we'll just assume the entire video is an available seek target.
     *
     * The risk here lies with live streaming, where there may exist a sliding window of
     * playable content and seeking is only possible within the last X number of
     * minutes, rather than for the entire video.
     *
     * Unfortunately we have no way of detecting when this is the case. Returning
     * anything other than the full range of the video means that we lose the ability
     * to seek during VOD.
     *
     * @returns {TimeRanges} always returns a `TimeRanges` object with one
     * `TimeRange` that starts at `0` and ends at the `duration` of the
     * current media item
     * @see {@link http://docs.videojs.com/Player.html#seekable}
     */
    seekable() {
      return this.videojs.createTimeRange(0, this.duration());
    }
    /**
     * Returns whether the native media controls should be shown (`true`) or hidden
     * (`false`). Not applicable to this Tech.
     *
     * @returns {boolean} always returns `false`
     * @see {@link http://docs.videojs.com/Html5.html#controls} for an example
     */
    controls() {
      return !1;
    }
    /**
     * Returns whether or not the browser should show the player
     * "inline" (non-fullscreen) by default. This function always
     * returns true to tell the browser that non-fullscreen playback is preferred.
     *
     * @returns {boolean} always returns `true`
     * @see {@link http://docs.videojs.com/Html5.html#playsinline} for an example
     */
    playsinline() {
      return !0;
    }
    /**
     * Returns whether or not fullscreen is supported by this Tech.
     * Always returns `true` because fullscreen is always supported.
     *
     * @returns {boolean} always returns `true`
     * @see {@link http://docs.videojs.com/Html5.html#supportsFullScreen} for an example
     */
    supportsFullScreen() {
      return !0;
    }
    /**
     * Sets a flag that determines whether or not the media should automatically begin
     * playing on page load. This is not supported because a Chromecast session must be
     * initiated by casting via the casting menu and cannot autoplay.
     *
     * @see {@link http://docs.videojs.com/Html5.html#setAutoplay} for an example
     */
    setAutoplay() {
    }
    /**
     * @returns {number} the chromecast player's playback rate, if available. Otherwise,
     * the return value defaults to `1`.
     */
    playbackRate() {
      var a = this._getMediaSession();
      return a ? a.playbackRate : 1;
    }
    /**
     * Does nothing. Changing the playback rate is not supported.
     */
    setPlaybackRate() {
    }
    /**
     * Does nothing. Satisfies calls to the missing preload method.
     */
    preload() {
    }
    /**
     * Causes the Tech to begin loading the current source. `load`
     * is not supported in this ChromecastTech because setting the
     * source on the `Chromecast` automatically causes it to begin loading.
     */
    load() {
    }
    loop() {
    }
    /**
     * Gets the Chromecast equivalent of HTML5 Media Element's `readyState`.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState
     */
    readyState() {
      return this._remotePlayer.playerState === "IDLE" || this._remotePlayer.playerState === "BUFFERING" ? 0 : 4;
    }
    networkState() {
      return this._remotePlayer.playerState === "IDLE" || this._remotePlayer.playerState === "BUFFERING" ? 0 : 4;
    }
    /**
     * Wires up event listeners for
     * [RemotePlayerController](https://developers.google.com/cast/docs/reference/chrome/cast.framework.RemotePlayerController)
     * events.
     *
     * @private
     */
    _listenToPlayerControllerEvents() {
      var a = cast.framework.RemotePlayerEventType;
      this._addEventListener(this._remotePlayerController, a.PLAYER_STATE_CHANGED, this._onPlayerStateChanged, this), this._addEventListener(this._remotePlayerController, a.VOLUME_LEVEL_CHANGED, this._triggerVolumeChangeEvent, this), this._addEventListener(this._remotePlayerController, a.IS_MUTED_CHANGED, this._triggerVolumeChangeEvent, this), this._addEventListener(this._remotePlayerController, a.CURRENT_TIME_CHANGED, this._triggerTimeUpdateEvent, this), this._addEventListener(this._remotePlayerController, a.DURATION_CHANGED, this._triggerDurationChangeEvent, this);
    }
    /**
     * Registers an event listener on the given target object.
     * Because many objects in the Chromecast API are either singletons
     * or must be shared between instances of `ChromecastTech` for the
     * lifetime of the player, we must unbind the listeners when this Tech
     * instance is destroyed to prevent memory leaks. To do that, we need to keep
     * a reference to listeners that are added to global objects so that we can
     * use those references to remove the listener when this Tech is destroyed.
     *
     * @param target {object} the object to register the event listener on
     * @param type {string} the name of the event
     * @param callback {Function} the listener's callback function that
     * executes when the event is emitted
     * @param context {object} the `this` context to use when executing the `callback`
     * @private
     */
    _addEventListener(a, s, o, u) {
      var l;
      l = {
        target: a,
        type: s,
        callback: o,
        context: u,
        listener: o.bind(u)
      }, a.addEventListener(s, l.listener), this._eventListeners.push(l);
    }
    /**
     * Removes all event listeners that were registered with global objects during the
     * lifetime of this Tech. See {@link _addEventListener} for more information
     * about why this is necessary.
     *
     * @private
     */
    _removeAllEventListeners() {
      for (; this._eventListeners.length > 0; )
        this._removeEventListener(this._eventListeners[0]);
      this._eventListeners = [];
    }
    /**
     * Removes a single event listener that was registered with global objects
     * during the lifetime of this Tech. See {@link _addEventListener} for
     * more information about why this is necessary.
     *
     * @private
     */
    _removeEventListener(a) {
      var s = -1, o = !1, u;
      for (a.target.removeEventListener(a.type, a.listener), u = 0; u < this._eventListeners.length; u++)
        if (o = this._eventListeners[u].target === a.target && this._eventListeners[u].type === a.type && this._eventListeners[u].callback === a.callback && this._eventListeners[u].context === a.context, o) {
          s = u;
          break;
        }
      s !== -1 && this._eventListeners.splice(s, 1);
    }
    /**
     * Handles Chromecast player state change events. The player may "change state" when
     * paused, played, buffering, etc.
     *
     * @private
     */
    _onPlayerStateChanged() {
      var a = chrome.cast.media.PlayerState, s = this._remotePlayer.playerState;
      s === a.PLAYING ? (this._hasPlayedCurrentItem = !0, this.trigger("play"), this.trigger("playing")) : s === a.PAUSED ? this.trigger("pause") : s === a.IDLE && this.ended() || s === null && this._hasPlayedCurrentItem ? (this._hasPlayedCurrentItem = !1, this._closeSessionOnTimeout(), this.trigger("ended"), this._triggerTimeUpdateEvent()) : s === a.BUFFERING && this.trigger("waiting");
    }
    /**
     * Handles Chromecast MediaSession state change events. The only property sent
     * to this event is whether the session is alive. This is useful for determining
     * if an item has ended as the MediaSession will fire this event with `false` then
     * be immediately destroyed. This means that we cannot trust `idleReason` to show
     * whether an item has ended since we may no longer have access to the MediaSession.
     *
     * @private
     */
    _onMediaSessionStatusChanged(a) {
      this._hasMediaSessionEnded = !!a;
    }
    /**
     * Ends the session after a certain number of seconds of inactivity.
     *
     * If the Chromecast player is in the "IDLE" state after an item has ended, and no
     * further items are queued up to play, the session is considered inactive. Once a
     * period of time (currently 10 seconds) has elapsed with no activity, we manually
     * end the session to prevent long periods of a blank Chromecast screen that is
     * shown at the end of item playback.
     *
     * @private
     */
    _closeSessionOnTimeout() {
      this._clearSessionTimeout(), this._sessionTimeoutID = setTimeout(function() {
        var a = this._getCastSession();
        a && a.endSession(!0), this._clearSessionTimeout();
      }.bind(this), r);
    }
    /**
     * Stops the timeout that is waiting during a period of inactivity in order to close
     * the session.
     *
     * @private
     * @see _closeSessionOnTimeout
     */
    _clearSessionTimeout() {
      this._sessionTimeoutID && (clearTimeout(this._sessionTimeoutID), this._sessionTimeoutID = !1);
    }
    /**
     * @private
     * @return {object} the current CastContext, if one exists
     */
    _getCastContext() {
      return this._chromecastSessionManager.getCastContext();
    }
    /**
     * @private
     * @return {object} the current CastSession, if one exists
     */
    _getCastSession() {
      return this._getCastContext().getCurrentSession();
    }
    /**
     * @private
     * @return {object} the current MediaSession, if one exists
     * @see https://developers.google.com/cast/docs/reference/chrome/chrome.cast.media.Media
     */
    _getMediaSession() {
      var a = this._getCastSession();
      return a ? a.getMediaSession() : null;
    }
    /**
     * Triggers a 'volumechange' event
     * @private
     * @see http://docs.videojs.com/Player.html#event:volumechange
     */
    _triggerVolumeChangeEvent() {
      this.trigger("volumechange");
    }
    /**
     * Triggers a 'timeupdate' event
     * @private
     * @see http://docs.videojs.com/Player.html#event:timeupdate
     */
    _triggerTimeUpdateEvent() {
      this.trigger("timeupdate");
    }
    /**
     * Triggers a 'durationchange' event
     * @private
     * @see http://docs.videojs.com/Player.html#event:durationchange
     */
    _triggerDurationChangeEvent() {
      this.trigger("durationchange");
    }
    /**
     * Triggers an 'error' event
     * @private
     * @see http://docs.videojs.com/Player.html#event:error
     */
    _triggerErrorEvent() {
      this.trigger("error");
    }
  }
  n.canPlaySource = () => zr.isChromecastConnected(), n.isSupported = () => zr.isChromecastConnected(), t.registerTech("chromecast", n);
}
const rv = 1e3, g2 = 30 * 1e3;
function m2(t) {
  cast.framework.CastContext.getInstance().setOptions({
    receiverApplicationId: t.receiverAppID || chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
    // Setting autoJoinPolicy to ORIGIN_SCOPED prevents this plugin from automatically
    // trying to connect to a preexisting Chromecast session, if one exists. The user
    // must end any existing session before trying to cast from this player instance.
    autoJoinPolicy: chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED
  });
}
function v2(t) {
  t.chromecastSessionManager.openCastMenu();
}
function y2(t, e) {
  let r;
  e.addButtonToControlBar && !t.controlBar.getChild("chromecastButton") && (r = t.controlBar.children().length, typeof e.buttonPositionIndex < "u" && (r = e.buttonPositionIndex >= 0 ? e.buttonPositionIndex : t.controlBar.children().length + e.buttonPositionIndex), t.controlBar.addChild("chromecastButton", e, r)), t.on("chromecastRequested", v2.bind(null, t));
}
function _2(t) {
  t.chromecastSessionManager || (t.chromecastSessionManager = new zr(t));
}
function xT(t, e) {
  m2(e), _2(t), y2(t, e);
}
function T2(t, e) {
  let r = g2 / rv, n = 1, i;
  i = setInterval(function() {
    if (n > r) {
      clearInterval(i);
      return;
    }
    zr.isChromecastAPIAvailable() && (clearInterval(i), xT(t, e)), n = n + 1;
  }, rv);
}
function b2(t) {
  t.registerPlugin("chromecast", function(e) {
    const r = Object.assign({ addButtonToControlBar: !0 }, e || {});
    this.ready(function() {
      this.controlBar && (zr.isChromecastAPIAvailable() ? xT(this, r) : T2(this, r));
    }.bind(this));
  });
}
function S2(t, e) {
  h2(t), p2(t), b2(t);
}
function eh() {
  return !!window.WebKitPlaybackTargetAvailabilityEvent;
}
function E2(t) {
  const e = t.getComponent("Button");
  class r extends e {
    /**
     * This class is a button component designed to be displayed in the player UI's control
     * bar. It displays an Apple AirPlay selection list when clicked.
     *
     * @constructs
     * @extends external:Button
     */
    constructor(i, a) {
      super(i, a), eh() || this.hide(), this._reactToAirPlayAvailableEvents(), a.addAirPlayLabelToButton ? (this.el().classList.add("vjs-airplay-button-lg"), this._labelEl = document.createElement("span"), this._labelEl.classList.add("vjs-airplay-button-label"), this._labelEl.textContent = this.localize("AirPlay"), this.el().appendChild(this._labelEl)) : this.controlText("Start AirPlay");
    }
    /**
     * Overrides Button#buildCSSClass to return the classes used on the button element.
     *
     * @param {DOMElement} el
     * @see {@link http://docs.videojs.com/Button.html#buildCSSClass|Button#buildCSSClass}
     */
    buildCSSClass() {
      return this.constructor.super_ ? "vjs-airplay-button " + this.constructor.super_.prototype.buildCSSClass() : "vjs-airplay-button";
    }
    /**
     * Overrides Button#handleClick to handle button click events. AirPlay functionality is
     * handled outside of this class, which should be limited to UI related logic. This
     * function simply triggers an event on the player.
     *
     * @fires AirPlayButton#airPlayRequested
     * @param {DOMElement} el
     * @see {@link http://docs.videojs.com/Button.html#handleClick|Button#handleClick}
     */
    handleClick() {
      this.player().trigger("airPlayRequested");
    }
    /**
     * Gets the underlying DOMElement used by the player.
     *
     * @private
     * @returns {DOMElement} either an <audio> or <video> tag, depending on the type of
     * player
     */
    _getMediaEl() {
      var i = this.player().el();
      return i.querySelector("video, audio");
    }
    /**
     * Binds a listener to the `webkitplaybacktargetavailabilitychanged` event, if it is
     * supported, that will show or hide this button Component based on the availability
     * of the AirPlay function.
     *
     * @private
     */
    _reactToAirPlayAvailableEvents() {
      const i = this._getMediaEl(), a = this;
      if (!i || !eh())
        return;
      function s(o) {
        o.availability === "available" ? a.show() : a.hide();
      }
      i.addEventListener("webkitplaybacktargetavailabilitychanged", s), this.on("dispose", function() {
        i.removeEventListener("webkitplaybacktargetavailabilitychanged", s);
      });
    }
  }
  t.registerComponent("airPlayButton", r);
}
function x2(t) {
  return t.controlBar.getChild("airPlayButton");
}
function C2(t, e) {
  var r = x2(t), n;
  e.addButtonToControlBar && !r && (n = t.controlBar.children().length, typeof e.buttonPositionIndex < "u" && (n = e.buttonPositionIndex >= 0 ? e.buttonPositionIndex : t.controlBar.children().length + e.buttonPositionIndex), t.controlBar.addChild("airPlayButton", e, n));
}
function A2(t) {
  var e = t.el().querySelector("video, audio");
  e && e.webkitShowPlaybackTargetPicker && e.webkitShowPlaybackTargetPicker();
}
function w2(t) {
  t.on("airPlayRequested", A2.bind(null, t));
}
function P2(t, e) {
  t.controlBar && eh() && (w2(t), C2(t, e));
}
function k2(t) {
  t.registerPlugin("airPlay", function(e) {
    var r = Object.assign({ addButtonToControlBar: !0 }, e || {});
    this.ready(P2.bind(this, this, r));
  });
}
function L2(t) {
  E2(t), k2(t);
}
/*! @name videojs-contrib-ads @version 6.9.0 @license Apache-2.0 */
var CT = "6.9.0";
function I2(t) {
  return {
    disableNextSnapshotRestore: !1,
    // This is true if we have finished actual content playback but haven't
    // dealt with postrolls and officially ended yet
    _contentEnding: !1,
    // This is set to true if the content has officially ended at least once.
    // After that, the user can seek backwards and replay content, but _contentHasEnded
    // remains true.
    _contentHasEnded: !1,
    // Tracks if loadstart has happened yet for the initial source. It is not reset
    // on source changes because loadstart is the event that signals to the ad plugin
    // that the source has changed. Therefore, no special signaling is needed to know
    // that there has been one for subsequent sources.
    _hasThereBeenALoadStartDuringPlayerLife: !1,
    // Tracks if loadeddata has happened yet for the current source.
    _hasThereBeenALoadedData: !1,
    // Tracks if loadedmetadata has happened yet for the current source.
    _hasThereBeenALoadedMetaData: !1,
    // Are we after startLinearAdMode and before endLinearAdMode?
    _inLinearAdMode: !1,
    // Should we block calls to play on the content player?
    _shouldBlockPlay: !1,
    // Was play blocked by the plugin's playMiddleware feature?
    _playBlocked: !1,
    // Tracks whether play has been requested for this source,
    // either by the play method or user interaction
    _playRequested: !1,
    // This is an estimation of the current ad type being played
    // This is experimental currently. Do not rely on its presence or behavior!
    adType: null,
    VERSION: CT,
    reset: function() {
      t.ads.disableNextSnapshotRestore = !1, t.ads._contentEnding = !1, t.ads._contentHasEnded = !1, t.ads.snapshot = null, t.ads.adType = null, t.ads._hasThereBeenALoadedData = !1, t.ads._hasThereBeenALoadedMetaData = !1, t.ads._cancelledPlay = !1, t.ads._shouldBlockPlay = !1, t.ads._playBlocked = !1, t.ads.nopreroll_ = !1, t.ads.nopostroll_ = !1, t.ads._playRequested = !1;
    },
    // Call this when an ad response has been received and there are
    // linear ads ready to be played.
    startLinearAdMode: function() {
      t.ads._state.startLinearAdMode();
    },
    // Call this when a linear ad pod has finished playing.
    endLinearAdMode: function() {
      t.ads._state.endLinearAdMode();
    },
    // Call this when an ad response has been received but there are no
    // linear ads to be played (i.e. no ads available, or overlays).
    // This has no effect if we are already in an ad break.  Always
    // use endLinearAdMode() to exit from linear ad-playback state.
    skipLinearAdMode: function() {
      t.ads._state.skipLinearAdMode();
    },
    // With no arguments, returns a boolean value indicating whether or not
    // contrib-ads is set to treat ads as stitched with content in a single
    // stream. With arguments, treated as a setter, but this behavior is
    // deprecated.
    stitchedAds: function(r) {
      return r !== void 0 && (P.log.warn("Using player.ads.stitchedAds() as a setter is deprecated, it should be set as an option upon initialization of contrib-ads."), this.settings.stitchedAds = !!r), this.settings.stitchedAds;
    },
    // Returns whether the video element has been modified since the
    // snapshot was taken.
    // We test both src and currentSrc because changing the src attribute to a URL that
    // AdBlocker is intercepting doesn't update currentSrc.
    videoElementRecycled: function() {
      if (t.ads.shouldPlayContentBehindAd(t))
        return !1;
      if (!this.snapshot)
        throw new Error("You cannot use videoElementRecycled while there is no snapshot.");
      var r = t.tech_.src() !== this.snapshot.src, n = t.currentSrc() !== this.snapshot.currentSrc;
      return r || n;
    },
    // Returns a boolean indicating if given player is in live mode.
    // One reason for this: https://github.com/videojs/video.js/issues/3262
    // Also, some live content can have a duration.
    isLive: function(r) {
      return r === void 0 && (r = t), typeof r.ads.settings.contentIsLive == "boolean" ? r.ads.settings.contentIsLive : r.duration() === 1 / 0 ? !0 : P.browser.IOS_VERSION === "8" && r.duration() === 0;
    },
    // Return true if content playback should mute and continue during ad breaks.
    // This is only done during live streams on platforms where it's supported.
    // This improves speed and accuracy when returning from an ad break.
    shouldPlayContentBehindAd: function(r) {
      if (r === void 0 && (r = t), r)
        return r.ads.settings.liveCuePoints ? !P.browser.IS_IOS && !P.browser.IS_ANDROID && r.duration() === 1 / 0 : !1;
      throw new Error("shouldPlayContentBehindAd requires a player as a param");
    },
    // Return true if the ads plugin should save and restore snapshots of the
    // player state when moving into and out of ad mode.
    shouldTakeSnapshots: function(r) {
      return r === void 0 && (r = t), !this.shouldPlayContentBehindAd(r) && !this.stitchedAds();
    },
    // Returns true if player is in ad mode.
    //
    // Ad mode definition:
    // If content playback is blocked by the ad plugin.
    //
    // Examples of ad mode:
    //
    // * Waiting to find out if an ad is going to play while content would normally be
    //   playing.
    // * Waiting for an ad to start playing while content would normally be playing.
    // * An ad is playing (even if content is also playing)
    // * An ad has completed and content is about to resume, but content has not resumed
    //   yet.
    //
    // Examples of not ad mode:
    //
    // * Content playback has not been requested
    // * Content playback is paused
    // * An asynchronous ad request is ongoing while content is playing
    // * A non-linear ad is active
    isInAdMode: function() {
      return this._state.isAdState();
    },
    // Returns true if in ad mode but an ad break hasn't started yet.
    isWaitingForAdBreak: function() {
      return this._state.isWaitingForAdBreak();
    },
    // Returns true if content is resuming after an ad. This is part of ad mode.
    isContentResuming: function() {
      return this._state.isContentResuming();
    },
    // Deprecated because the name was misleading. Use inAdBreak instead.
    isAdPlaying: function() {
      return this._state.inAdBreak();
    },
    // Returns true if an ad break is ongoing. This is part of ad mode.
    // An ad break is the time between startLinearAdMode and endLinearAdMode.
    inAdBreak: function() {
      return this._state.inAdBreak();
    },
    /*
     * Remove the poster attribute from the video element tech, if present. When
     * reusing a video element for multiple videos, the poster image will briefly
     * reappear while the new source loads. Removing the attribute ahead of time
     * prevents the poster from showing up between videos.
     *
     * @param {Object} player The videojs player object
     */
    removeNativePoster: function() {
      var r = t.$(".vjs-tech");
      r && r.removeAttribute("poster");
    },
    debug: function() {
      if (this.settings.debug) {
        for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++)
          n[i] = arguments[i];
        n.length === 1 && typeof n[0] == "string" ? P.log("ADS: " + n[0]) : P.log.apply(P, ["ADS:"].concat(n));
      }
    }
  };
}
var AT = function(e, r) {
  r.isImmediatePropagationStopped = function() {
    return !0;
  }, r.cancelBubble = !0, r.isPropagationStopped = function() {
    return !0;
  };
}, ur = function(e, r, n) {
  AT(e, n), e.trigger({
    type: r + n.type,
    originalEvent: n
  });
}, D2 = function(e, r) {
  e.ads.isInAdMode() && (e.ads.isContentResuming() ? e.ads._contentEnding && ur(e, "content", r) : ur(e, "ad", r));
}, R2 = function(e, r) {
  e.ads.isInAdMode() ? e.ads.isContentResuming() ? (AT(e, r), e.trigger("resumeended")) : ur(e, "ad", r) : !e.ads._contentHasEnded && !e.ads.stitchedAds() && (ur(e, "content", r), e.trigger("readyforpostroll"));
}, O2 = function(e, r) {
  if (!(r.type === "loadstart" && !e.ads._hasThereBeenALoadStartDuringPlayerLife || r.type === "loadeddata" && !e.ads._hasThereBeenALoadedData || r.type === "loadedmetadata" && !e.ads._hasThereBeenALoadedMetaData))
    if (e.ads.inAdBreak())
      ur(e, "ad", r);
    else {
      if (e.currentSrc() !== e.ads.contentSrc)
        return;
      ur(e, "content", r);
    }
}, M2 = function(e, r) {
  e.ads.inAdBreak() ? ur(e, "ad", r) : e.ads.isContentResuming() && ur(e, "content", r);
};
function N2(t) {
  t.type === "playing" ? D2(this, t) : t.type === "ended" ? R2(this, t) : t.type === "loadstart" || t.type === "loadeddata" || t.type === "loadedmetadata" ? O2(this, t) : t.type === "play" ? M2(this, t) : this.ads.isInAdMode() && (this.ads.isContentResuming() ? ur(this, "content", t) : ur(this, "ad", t));
}
function B2(t) {
  t.ads.contentSrc = t.currentSrc(), t.ads._seenInitialLoadstart = !1;
  var e = function() {
    if (!t.ads.inAdBreak()) {
      var n = t.currentSrc();
      n !== t.ads.contentSrc && (t.ads._seenInitialLoadstart && t.trigger({
        type: "contentchanged"
      }), t.trigger({
        type: "contentupdate",
        oldValue: t.ads.contentSrc,
        newValue: n
      }), t.ads.contentSrc = n), t.ads._seenInitialLoadstart = !0;
    }
  };
  t.on("loadstart", e);
}
var Xo = {}, F2 = function(e) {
  if (P.dom.isInFrame() && typeof M.__tcfapi != "function") {
    for (var r = M, n, i = {}; r; ) {
      try {
        if (r.frames.__tcfapiLocator) {
          n = r;
          break;
        }
      } catch {
      }
      if (r === M.top)
        break;
      r = r.parent;
    }
    if (!n)
      return;
    M.__tcfapi = function(a, s, o, u) {
      var l = Math.random() + "", d = {
        __tcfapiCall: {
          command: a,
          parameter: u,
          version: s,
          callId: l
        }
      };
      i[l] = o, n.postMessage(d, "*");
    }, M.addEventListener("message", function(a) {
      var s = {};
      try {
        s = typeof a.data == "string" ? JSON.parse(a.data) : a.data;
      } catch {
      }
      var o = s.__tcfapiReturn;
      o && typeof i[o.callId] == "function" && (i[o.callId](o.returnValue, o.success), i[o.callId] = null);
    }, !1);
  }
}, nv = function() {
  F2(), typeof M.__tcfapi == "function" && M.__tcfapi("addEventListener", 2, function(e, r) {
    r && (Xo = e);
  });
}, av = function(e, r) {
  return r ? encodeURIComponent(e) : e;
}, sv = function(e, r, n) {
  if (e && e[n])
    for (var i = e[n], a = Object.keys(i), s = 0; s < a.length; s++) {
      var o = "{mediainfo." + n + "." + a[s] + "}";
      r[o] = i[a[s]];
    }
};
function U2(t, e, r) {
  var n = this, i = {};
  t = t.replace(/{([^}=]+)=([^}]+)}/g, function(u, l, d) {
    return i["{" + l + "}"] = d, "{" + l + "}";
  }), e === void 0 && (e = !1);
  var a = {};
  r !== void 0 && (a = r), a["{player.id}"] = this.options_["data-player"] || this.id_, a["{player.height}"] = this.currentHeight(), a["{player.width}"] = this.currentWidth(), a["{mediainfo.id}"] = this.mediainfo ? this.mediainfo.id : "", a["{mediainfo.name}"] = this.mediainfo ? this.mediainfo.name : "", a["{mediainfo.duration}"] = this.mediainfo ? this.mediainfo.duration : "", a["{player.duration}"] = this.duration(), a["{player.pageUrl}"] = P.dom.isInFrame() ? oe.referrer : M.location.href, a["{playlistinfo.id}"] = this.playlistinfo ? this.playlistinfo.id : "", a["{playlistinfo.name}"] = this.playlistinfo ? this.playlistinfo.name : "", a["{timestamp}"] = (/* @__PURE__ */ new Date()).getTime(), a["{document.referrer}"] = oe.referrer, a["{window.location.href}"] = M.location.href, a["{random}"] = Math.floor(Math.random() * 1e12), ["description", "tags", "reference_id", "ad_keys"].forEach(function(u) {
    n.mediainfo && n.mediainfo[u] ? a["{mediainfo." + u + "}"] = n.mediainfo[u] : i["{mediainfo." + u + "}"] ? a["{mediainfo." + u + "}"] = i["{mediainfo." + u + "}"] : a["{mediainfo." + u + "}"] = "";
  }), sv(this.mediainfo, a, "custom_fields"), sv(this.mediainfo, a, "customFields"), Object.keys(Xo).forEach(function(u) {
    a["{tcf." + u + "}"] = Xo[u];
  }), a["{tcf.gdprAppliesInt}"] = Xo.gdprApplies ? 1 : 0;
  for (var s in a)
    t = t.split(s).join(av(a[s], e));
  t = t.replace(/{pageVariable\.([^}]+)}/g, function(u, l) {
    for (var d, h = M, f = l.split("."), v = 0; v < f.length; v++)
      v === f.length - 1 ? d = h[f[v]] : h = h[f[v]];
    var b = typeof d;
    return d === null ? "null" : d === void 0 ? i["{pageVariable." + l + "}"] ? i["{pageVariable." + l + "}"] : (P.log.warn('Page variable "' + l + '" not found'), "") : b !== "string" && b !== "number" && b !== "boolean" ? (P.log.warn('Page variable "' + l + '" is not a supported type'), "") : av(String(d), e);
  });
  for (var o in i)
    t = t.replace(o, i[o]);
  return t;
}
var kn = {};
kn.processMetadataTracks = function(t, e) {
  for (var r = t.textTracks(), n = function(s) {
    s.kind === "metadata" && (t.ads.cueTextTracks.setMetadataTrackMode(s), e(t, s));
  }, i = 0; i < r.length; i++)
    n(r[i]);
  r.addEventListener("addtrack", function(a) {
    n(a.track);
  });
};
kn.setMetadataTrackMode = function(t) {
};
kn.getSupportedAdCue = function(t, e) {
  return e;
};
kn.isSupportedAdCue = function(t, e) {
  return !0;
};
kn.getCueId = function(t, e) {
  return e.id;
};
var V2 = function(e, r) {
  return r !== void 0 && e.ads.includedCues[r];
}, j2 = function(e, r) {
  r !== void 0 && r !== "" && (e.ads.includedCues[r] = !0);
};
kn.processAdTrack = function(t, e, r, n) {
  t.ads.includedCues = {};
  for (var i = 0; i < e.length; i++) {
    var a = e[i], s = this.getSupportedAdCue(t, a);
    if (!this.isSupportedAdCue(t, a)) {
      P.log.warn("Skipping as this is not a supported ad cue.", a);
      return;
    }
    var o = this.getCueId(t, a), u = a.startTime;
    if (V2(t, o)) {
      P.log("Skipping ad already seen with ID " + o);
      return;
    }
    n && n(t, s, o, u), r(t, s, o, u), j2(t, o);
  }
};
function H2(t, e) {
  e && P.log("Using cancelContentPlay to block content playback"), t.on("play", W2);
}
function W2() {
  this.ads._shouldBlockPlay !== !1 && (this.paused() || (this.ads.debug("Playback was canceled by cancelContentPlay"), this.pause()), this.ads._cancelledPlay = !0);
}
var Wa = {}, mn = P;
Wa.isMiddlewareMediatorSupported = function() {
  return mn.browser.IS_IOS || mn.browser.IS_ANDROID ? !1 : (
    // added when middleware was introduced in video.js
    !!(mn.use && // added when mediators were introduced in video.js
    mn.middleware && mn.middleware.TERMINATOR)
  );
};
Wa.playMiddleware = function(t) {
  return {
    setSource: function(r, n) {
      n(null, r);
    },
    callPlay: function() {
      if (t.ads && t.ads._shouldBlockPlay === !0)
        return t.ads.debug("Using playMiddleware to block content playback"), t.ads._playBlocked = !0, mn.middleware.TERMINATOR;
    },
    play: function(r, n) {
      t.ads && t.ads._playBlocked && r ? (t.ads.debug("Play call to Tech was terminated."), t.trigger("play"), t.addClass("vjs-has-started"), t.ads._playBlocked = !1) : n && n.catch && n.catch(function(i) {
        i.name === "NotAllowedError" && !P.browser.IS_SAFARI && t.trigger("pause");
      });
    }
  };
};
Wa.testHook = function(t) {
  mn = t;
};
var q2 = Wa.playMiddleware, $2 = Wa.isMiddlewareMediatorSupported, z2 = function() {
  if (P.getPlugin)
    return !!P.getPlugin("ads");
  var e = P.getComponent("Player");
  return !!(e && e.prototype.ads);
};
function G2(t) {
  if (z2())
    return !1;
  var e = P.registerPlugin || P.plugin;
  return e("ads", t), $2() && !P.usingContribAdsMiddleware_ && (P.use("*", q2), P.usingContribAdsMiddleware_ = !0, P.log.debug("Play middleware has been registered with videojs")), !0;
}
var qe = /* @__PURE__ */ function() {
  function t() {
  }
  return t.getState = function(r) {
    if (r && t.states_ && t.states_[r])
      return t.states_[r];
  }, t.registerState = function(r, n) {
    if (typeof r != "string" || !r)
      throw new Error('Illegal state name, "' + r + '"; must be a non-empty string.');
    return t.states_ || (t.states_ = {}), t.states_[r] = n, n;
  }, t;
}(), kf = /* @__PURE__ */ function() {
  t._getName = function() {
    return "Anonymous State";
  };
  function t(r) {
    this.player = r;
  }
  var e = t.prototype;
  return e.transitionTo = function(n) {
    var i = this.player;
    this.cleanup(i);
    var a = new n(i);
    i.ads._state = a, i.ads.debug(this.constructor._getName() + " -> " + a.constructor._getName());
    for (var s = arguments.length, o = new Array(s > 1 ? s - 1 : 0), u = 1; u < s; u++)
      o[u - 1] = arguments[u];
    a.init.apply(a, [i].concat(o));
  }, e.init = function() {
  }, e.cleanup = function() {
  }, e.onPlay = function() {
  }, e.onPlaying = function() {
  }, e.onEnded = function() {
  }, e.onAdEnded = function() {
  }, e.onAdsReady = function() {
    P.log.warn("Unexpected adsready event");
  }, e.onAdsError = function() {
  }, e.onAdsCanceled = function() {
  }, e.onAdTimeout = function() {
  }, e.onAdStarted = function() {
  }, e.onContentChanged = function() {
  }, e.onContentResumed = function() {
  }, e.onReadyForPostroll = function() {
    P.log.warn("Unexpected readyforpostroll event");
  }, e.onNoPreroll = function() {
  }, e.onNoPostroll = function() {
  }, e.startLinearAdMode = function() {
    P.log.warn("Unexpected startLinearAdMode invocation (State via " + this.constructor._getName() + ")");
  }, e.endLinearAdMode = function() {
    P.log.warn("Unexpected endLinearAdMode invocation (State via " + this.constructor._getName() + ")");
  }, e.skipLinearAdMode = function() {
    P.log.warn("Unexpected skipLinearAdMode invocation (State via " + this.constructor._getName() + ")");
  }, e.isAdState = function() {
    throw new Error("isAdState unimplemented for " + this.constructor._getName());
  }, e.isWaitingForAdBreak = function() {
    return !1;
  }, e.isContentResuming = function() {
    return !1;
  }, e.inAdBreak = function() {
    return !1;
  }, e.handleEvent = function(n) {
    var i = this.player;
    n === "play" ? this.onPlay(i) : n === "adsready" ? this.onAdsReady(i) : n === "adserror" ? this.onAdsError(i) : n === "adscanceled" ? this.onAdsCanceled(i) : n === "adtimeout" ? this.onAdTimeout(i) : n === "ads-ad-started" ? this.onAdStarted(i) : n === "contentchanged" ? this.onContentChanged(i) : n === "contentresumed" ? this.onContentResumed(i) : n === "readyforpostroll" ? this.onReadyForPostroll(i) : n === "playing" ? this.onPlaying(i) : n === "ended" ? this.onEnded(i) : n === "nopreroll" ? this.onNoPreroll(i) : n === "nopostroll" ? this.onNoPostroll(i) : n === "adended" && this.onAdEnded(i);
  }, t;
}();
qe.registerState("State", kf);
function hr(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
var K2 = /* @__PURE__ */ function(t) {
  hr(e, t);
  function e(n) {
    var i;
    return i = t.call(this, n) || this, i.contentResuming = !1, i.waitingForAdBreak = !1, i;
  }
  var r = e.prototype;
  return r.isAdState = function() {
    return !0;
  }, r.onPlaying = function() {
    var i = qe.getState("ContentPlayback");
    this.contentResuming && this.transitionTo(i);
  }, r.onContentResumed = function() {
    var i = qe.getState("ContentPlayback");
    this.contentResuming && this.transitionTo(i);
  }, r.isWaitingForAdBreak = function() {
    return this.waitingForAdBreak;
  }, r.isContentResuming = function() {
    return this.contentResuming;
  }, r.inAdBreak = function() {
    return this.player.ads._inLinearAdMode === !0;
  }, e;
}(kf);
qe.registerState("AdState", K2);
var X2 = /* @__PURE__ */ function(t) {
  hr(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  var r = e.prototype;
  return r.isAdState = function() {
    return !1;
  }, r.onContentChanged = function(i) {
    var a = qe.getState("BeforePreroll"), s = qe.getState("Preroll");
    i.ads.debug("Received contentchanged event (ContentState)"), i.paused() ? this.transitionTo(a) : (this.transitionTo(s, !1), i.pause(), i.ads._pausedOnContentupdate = !0);
  }, e;
}(kf);
qe.registerState("ContentState", X2);
var Y2 = qe.getState("ContentState"), Q2 = /* @__PURE__ */ function(t) {
  hr(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  e._getName = function() {
    return "AdsDone";
  };
  var r = e.prototype;
  return r.init = function(i) {
    i.ads._contentHasEnded = !0, i.trigger("ended");
  }, r.startLinearAdMode = function() {
    P.log.warn("Unexpected startLinearAdMode invocation (AdsDone)");
  }, e;
}(Y2);
qe.registerState("AdsDone", Q2);
var rc;
function J2(t) {
  var e;
  P.browser.IS_IOS && t.ads.isLive(t) && t.seekable().length > 0 ? e = t.currentTime() - t.seekable().end(0) : e = t.currentTime();
  var r = t.$(".vjs-tech"), n = t.textTracks ? t.textTracks() : [], i = [], a = {
    ended: t.ended(),
    currentSrc: t.currentSrc(),
    sources: t.currentSources(),
    src: t.tech_.src(),
    currentTime: e,
    type: t.currentType()
  };
  r && (a.style = r.getAttribute("style"));
  for (var s = 0; s < n.length; s++) {
    var o = n[s];
    i.push({
      track: o,
      mode: o.mode
    }), o.mode = "disabled";
  }
  return a.suppressedTracks = i, a;
}
function Z2(t, e) {
  var r = t.ads.snapshot;
  if (e === void 0 && (e = function() {
  }), t.ads.disableNextSnapshotRestore === !0) {
    t.ads.disableNextSnapshotRestore = !1, delete t.ads.snapshot, e();
    return;
  }
  var n = t.$(".vjs-tech"), i = 20, a = r.suppressedTracks, s, o = function() {
    for (var f = 0; f < a.length; f++)
      s = a[f], s.track.mode = s.mode;
  }, u = function() {
    var f;
    if (P.browser.IS_IOS && t.ads.isLive(t)) {
      if (r.currentTime < 0 && (t.seekable().length > 0 ? f = t.seekable().end(0) + r.currentTime : f = t.currentTime(), t.currentTime(f)), t.paused()) {
        var v = t.play();
        v && v.catch && v.catch(function(_) {
          P.log.warn("Play promise rejected in IOS snapshot resume", _);
        });
      }
    } else if (r.ended)
      t.currentTime(t.duration());
    else {
      t.currentTime(r.currentTime);
      var b = t.play();
      b && b.catch && b.catch(function(_) {
        P.log.warn("Play promise rejected in snapshot resume", _);
      });
    }
    t.ads.shouldRemoveAutoplay_ && (t.autoplay(!1), t.ads.shouldRemoveAutoplay_ = !1);
  }, l = function h() {
    if (t.off("contentcanplay", h), rc && t.clearTimeout(rc), n = t.el().querySelector(".vjs-tech"), n.readyState > 1 || n.seekable === void 0 || n.seekable.length > 0)
      return u();
    if (i--)
      t.setTimeout(h, 50);
    else
      try {
        u();
      } catch (f) {
        P.log.warn("Failed to resume the content after an advertisement", f);
      }
  };
  if ("style" in r && n.setAttribute("style", r.style || ""), t.ads.videoElementRecycled())
    t.one("resumeended", function() {
      delete t.ads.snapshot, e();
    }), t.one("contentloadedmetadata", o), P.browser.IS_IOS && !t.autoplay() && (t.autoplay(!0), t.ads.shouldRemoveAutoplay_ = !0), t.src(r.sources), t.one("contentcanplay", l), rc = t.setTimeout(l, 2e3);
  else {
    if (o(), !t.ended()) {
      var d = t.play();
      d && d.catch && d.catch(function(h) {
        P.log.warn("Play promise rejected in snapshot restore", h);
      });
    }
    delete t.ads.snapshot, e();
  }
}
function eB(t) {
  t.ads.debug("Starting ad break"), t.ads._inLinearAdMode = !0, t.trigger("adstart"), t.ads.shouldTakeSnapshots() && (t.ads.snapshot = J2(t)), t.ads.shouldPlayContentBehindAd(t) && (t.ads.preAdVolume_ = t.volume(), t.volume(0)), t.addClass("vjs-ad-playing"), t.hasClass("vjs-live") && t.removeClass("vjs-live"), t.ads.removeNativePoster();
}
function tB(t, e) {
  t.ads.debug("Ending ad break"), e === void 0 && (e = function() {
  }), t.ads.adType = null, t.ads._inLinearAdMode = !1, t.trigger("adend"), t.removeClass("vjs-ad-playing"), t.ads.isLive(t) && t.addClass("vjs-live"), t.ads.shouldTakeSnapshots() ? Z2(t, e) : (t.volume(t.ads.preAdVolume_), e());
}
var Yr = {
  start: eB,
  end: tB
}, iB = qe.getState("AdState"), rB = /* @__PURE__ */ function(t) {
  hr(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  e._getName = function() {
    return "Preroll";
  };
  var r = e.prototype;
  return r.init = function(i, a, s) {
    if (this.waitingForAdBreak = !0, i.addClass("vjs-ad-loading"), s || i.ads.nopreroll_)
      return this.resumeAfterNoPreroll(i);
    var o = i.ads.settings.timeout;
    typeof i.ads.settings.prerollTimeout == "number" && (o = i.ads.settings.prerollTimeout), this._timeout = i.setTimeout(function() {
      i.trigger("adtimeout");
    }, o), a ? this.handleAdsReady() : this.adsReady = !1;
  }, r.onAdsReady = function(i) {
    i.ads.inAdBreak() ? P.log.warn("Unexpected adsready event (Preroll)") : (i.ads.debug("Received adsready event (Preroll)"), this.handleAdsReady());
  }, r.handleAdsReady = function() {
    this.adsReady = !0, this.readyForPreroll();
  }, r.afterLoadStart = function(i) {
    var a = this.player;
    a.ads._hasThereBeenALoadStartDuringPlayerLife ? i() : (a.ads.debug("Waiting for loadstart..."), a.one("loadstart", function() {
      a.ads.debug("Received loadstart event"), i();
    }));
  }, r.noPreroll = function() {
    var i = this;
    this.afterLoadStart(function() {
      i.player.ads.debug("Skipping prerolls due to nopreroll event (Preroll)"), i.resumeAfterNoPreroll(i.player);
    });
  }, r.readyForPreroll = function() {
    var i = this.player;
    this.afterLoadStart(function() {
      i.ads.debug("Triggered readyforpreroll event (Preroll)"), i.trigger("readyforpreroll");
    });
  }, r.onAdsCanceled = function(i) {
    var a = this;
    i.ads.debug("adscanceled (Preroll)"), this.afterLoadStart(function() {
      a.resumeAfterNoPreroll(i);
    });
  }, r.onAdsError = function(i) {
    var a = this;
    P.log("adserror (Preroll)"), this.inAdBreak() ? i.ads.endLinearAdMode() : this.afterLoadStart(function() {
      a.resumeAfterNoPreroll(i);
    });
  }, r.startLinearAdMode = function() {
    var i = this.player;
    this.adsReady && !i.ads.inAdBreak() && !this.isContentResuming() ? (this.clearTimeout(i), i.ads.adType = "preroll", this.waitingForAdBreak = !1, Yr.start(i), i.ads._shouldBlockPlay = !1) : P.log.warn("Unexpected startLinearAdMode invocation (Preroll)");
  }, r.onAdStarted = function(i) {
    i.removeClass("vjs-ad-loading");
  }, r.endLinearAdMode = function() {
    var i = this.player;
    this.inAdBreak() && (i.removeClass("vjs-ad-loading"), i.addClass("vjs-ad-content-resuming"), this.contentResuming = !0, Yr.end(i));
  }, r.skipLinearAdMode = function() {
    var i = this, a = this.player;
    a.ads.inAdBreak() || this.isContentResuming() ? P.log.warn("Unexpected skipLinearAdMode invocation") : this.afterLoadStart(function() {
      a.trigger("adskip"), a.ads.debug("skipLinearAdMode (Preroll)"), i.resumeAfterNoPreroll(a);
    });
  }, r.onAdTimeout = function(i) {
    var a = this;
    this.afterLoadStart(function() {
      i.ads.debug("adtimeout (Preroll)"), a.resumeAfterNoPreroll(i);
    });
  }, r.onNoPreroll = function(i) {
    i.ads.inAdBreak() || this.isContentResuming() ? P.log.warn("Unexpected nopreroll event (Preroll)") : this.noPreroll();
  }, r.resumeAfterNoPreroll = function(i) {
    if (this.contentResuming = !0, i.ads._shouldBlockPlay = !1, this.cleanupPartial(i), i.ads._playRequested || i.ads._pausedOnContentupdate)
      if (i.paused()) {
        i.ads.debug("resumeAfterNoPreroll: attempting to resume playback (Preroll)");
        var a = i.play();
        a && a.then && a.then(null, function(s) {
        });
      } else
        i.ads.debug("resumeAfterNoPreroll: already playing (Preroll)"), i.trigger("play"), i.trigger("playing");
  }, r.cleanup = function(i) {
    i.ads._hasThereBeenALoadStartDuringPlayerLife || P.log.warn("Leaving Preroll state before loadstart event can cause issues."), this.cleanupPartial(i);
  }, r.cleanupPartial = function(i) {
    i.removeClass("vjs-ad-loading"), i.removeClass("vjs-ad-content-resuming"), this.clearTimeout(i);
  }, r.clearTimeout = function(i) {
    i.clearTimeout(this._timeout), this._timeout = null;
  }, e;
}(iB);
qe.registerState("Preroll", rB);
var nB = qe.getState("ContentState"), aB = /* @__PURE__ */ function(t) {
  hr(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  e._getName = function() {
    return "BeforePreroll";
  };
  var r = e.prototype;
  return r.init = function(i) {
    this.adsReady = !1, this.shouldResumeToContent = !1, i.ads._shouldBlockPlay = i.ads.settings.allowVjsAutoplay ? !i.autoplay() : !0;
  }, r.onAdsReady = function(i) {
    i.ads.debug("Received adsready event (BeforePreroll)"), this.adsReady = !0;
  }, r.onPlay = function(i) {
    var a = qe.getState("Preroll");
    i.ads.debug("Received play event (BeforePreroll)"), this.transitionTo(a, this.adsReady, this.shouldResumeToContent);
  }, r.onAdsCanceled = function(i) {
    i.ads.debug("adscanceled (BeforePreroll)"), this.shouldResumeToContent = !0;
  }, r.onAdsError = function() {
    this.player.ads.debug("adserror (BeforePreroll)"), this.shouldResumeToContent = !0;
  }, r.onNoPreroll = function() {
    this.player.ads.debug("Skipping prerolls due to nopreroll event (BeforePreroll)"), this.shouldResumeToContent = !0;
  }, r.skipLinearAdMode = function() {
    var i = this.player;
    i.trigger("adskip"), i.ads.debug("skipLinearAdMode (BeforePreroll)"), this.shouldResumeToContent = !0;
  }, r.onContentChanged = function() {
    this.init(this.player);
  }, e;
}(nB);
qe.registerState("BeforePreroll", aB);
var sB = qe.getState("AdState"), oB = /* @__PURE__ */ function(t) {
  hr(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  e._getName = function() {
    return "Midroll";
  };
  var r = e.prototype;
  return r.init = function(i) {
    i.ads.adType = "midroll", Yr.start(i), i.addClass("vjs-ad-loading");
  }, r.onAdStarted = function(i) {
    i.removeClass("vjs-ad-loading");
  }, r.endLinearAdMode = function() {
    var i = this.player;
    this.inAdBreak() && (this.contentResuming = !0, i.addClass("vjs-ad-content-resuming"), i.removeClass("vjs-ad-loading"), Yr.end(i));
  }, r.onAdsError = function(i) {
    this.inAdBreak() && i.ads.endLinearAdMode();
  }, r.cleanup = function(i) {
    i.removeClass("vjs-ad-loading"), i.removeClass("vjs-ad-content-resuming");
  }, e;
}(sB);
qe.registerState("Midroll", oB);
var uB = qe.getState("AdState"), lB = /* @__PURE__ */ function(t) {
  hr(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  e._getName = function() {
    return "Postroll";
  };
  var r = e.prototype;
  return r.init = function(i) {
    if (this.waitingForAdBreak = !0, i.ads._contentEnding = !0, i.ads.nopostroll_) {
      this.resumeContent(i);
      var s = qe.getState("AdsDone");
      this.transitionTo(s);
    } else {
      i.addClass("vjs-ad-loading");
      var a = i.ads.settings.timeout;
      typeof i.ads.settings.postrollTimeout == "number" && (a = i.ads.settings.postrollTimeout), this._postrollTimeout = i.setTimeout(function() {
        i.trigger("adtimeout");
      }, a);
    }
  }, r.startLinearAdMode = function() {
    var i = this.player;
    !i.ads.inAdBreak() && !this.isContentResuming() ? (i.ads.adType = "postroll", i.clearTimeout(this._postrollTimeout), this.waitingForAdBreak = !1, Yr.start(i)) : P.log.warn("Unexpected startLinearAdMode invocation (Postroll)");
  }, r.onAdStarted = function(i) {
    i.removeClass("vjs-ad-loading");
  }, r.endLinearAdMode = function() {
    var i = this, a = this.player, s = qe.getState("AdsDone");
    this.inAdBreak() && (a.removeClass("vjs-ad-loading"), this.resumeContent(a), Yr.end(a, function() {
      i.transitionTo(s);
    }));
  }, r.skipLinearAdMode = function() {
    var i = this.player;
    i.ads.inAdBreak() || this.isContentResuming() ? P.log.warn("Unexpected skipLinearAdMode invocation") : (i.ads.debug("Postroll abort (skipLinearAdMode)"), i.trigger("adskip"), this.abort(i));
  }, r.onAdTimeout = function(i) {
    i.ads.debug("Postroll abort (adtimeout)"), this.abort(i);
  }, r.onAdsError = function(i) {
    i.ads.debug("Postroll abort (adserror)"), i.ads.inAdBreak() ? i.ads.endLinearAdMode() : this.abort(i);
  }, r.onContentChanged = function(i) {
    if (this.isContentResuming()) {
      var a = qe.getState("BeforePreroll");
      this.transitionTo(a);
    } else if (!this.inAdBreak()) {
      var s = qe.getState("Preroll");
      this.transitionTo(s);
    }
  }, r.onNoPostroll = function(i) {
    !this.isContentResuming() && !this.inAdBreak() ? this.abort(i) : P.log.warn("Unexpected nopostroll event (Postroll)");
  }, r.resumeContent = function(i) {
    this.contentResuming = !0, i.addClass("vjs-ad-content-resuming");
  }, r.abort = function(i) {
    var a = qe.getState("AdsDone");
    this.resumeContent(i), i.removeClass("vjs-ad-loading"), this.transitionTo(a);
  }, r.cleanup = function(i) {
    i.removeClass("vjs-ad-content-resuming"), i.clearTimeout(this._postrollTimeout), i.ads._contentEnding = !1;
  }, e;
}(uB);
qe.registerState("Postroll", lB);
var dB = qe.getState("ContentState"), cB = /* @__PURE__ */ function(t) {
  hr(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  e._getName = function() {
    return "ContentPlayback";
  };
  var r = e.prototype;
  return r.init = function(i) {
    i.ads._shouldBlockPlay = !1;
  }, r.onAdsReady = function(i) {
    i.ads.debug("Received adsready event (ContentPlayback)"), i.ads.nopreroll_ || (i.ads.debug("Triggered readyforpreroll event (ContentPlayback)"), i.trigger("readyforpreroll"));
  }, r.onReadyForPostroll = function(i) {
    var a = qe.getState("Postroll");
    i.ads.debug("Received readyforpostroll event"), this.transitionTo(a);
  }, r.startLinearAdMode = function() {
    var i = qe.getState("Midroll");
    this.transitionTo(i);
  }, e;
}(dB);
qe.registerState("ContentPlayback", cB);
var hB = qe.getState("ContentState"), fB = /* @__PURE__ */ function(t) {
  hr(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  e._getName = function() {
    return "StitchedContentPlayback";
  };
  var r = e.prototype;
  return r.init = function() {
    this.player.ads._shouldBlockPlay = !1;
  }, r.onContentChanged = function() {
    this.player.ads.debug("Received contentchanged event (" + this.constructor._getName() + ")");
  }, r.startLinearAdMode = function() {
    var i = qe.getState("StitchedAdRoll");
    this.transitionTo(i);
  }, e;
}(hB);
qe.registerState("StitchedContentPlayback", fB);
var pB = qe.getState("AdState"), gB = /* @__PURE__ */ function(t) {
  hr(e, t);
  function e() {
    return t.apply(this, arguments) || this;
  }
  e._getName = function() {
    return "StitchedAdRoll";
  };
  var r = e.prototype;
  return r.init = function() {
    this.waitingForAdBreak = !1, this.contentResuming = !1, this.player.ads.adType = "stitched", Yr.start(this.player);
  }, r.onPlaying = function() {
  }, r.onContentResumed = function() {
  }, r.onAdEnded = function() {
    this.endLinearAdMode(), this.player.trigger("ended");
  }, r.endLinearAdMode = function() {
    var i = qe.getState("StitchedContentPlayback");
    Yr.end(this.player), this.transitionTo(i);
  }, e;
}(pB);
qe.registerState("StitchedAdRoll", gB);
var mB = Wa.isMiddlewareMediatorSupported, vB = P.getTech("Html5").Events, yB = {
  // Maximum amount of time in ms to wait to receive `adsready` from the ad
  // implementation after play has been requested. Ad implementations are
  // expected to load any dynamic libraries and make any requests to determine
  // ad policies for a video during this time.
  timeout: 5e3,
  // Maximum amount of time in ms to wait for the ad implementation to start
  // linear ad mode after `readyforpreroll` has fired. This is in addition to
  // the standard timeout.
  prerollTimeout: void 0,
  // Maximum amount of time in ms to wait for the ad implementation to start
  // linear ad mode after `readyforpostroll` has fired.
  postrollTimeout: void 0,
  // When truthy, instructs the plugin to output additional information about
  // plugin state to the video.js log. On most devices, the video.js log is
  // the same as the developer console.
  debug: !1,
  // Set this to true when using ads that are part of the content video
  stitchedAds: !1,
  // Force content to be treated as live or not live
  // if not defined, the code will try to infer if content is live,
  // which can have limitations.
  contentIsLive: void 0,
  // If set to true, content will play muted behind ads on supported platforms. This is
  // to support ads on video metadata cuepoints during a live stream. It also results in
  // more precise resumes after ads during a live stream.
  liveCuePoints: !0,
  // If set to true, callPlay middleware will not terminate the first play request in
  // BeforePreroll if the player intends to autoplay. This allows the manual autoplay
  // attempt made by video.js to resolve/reject naturally and trigger an 'autoplay-success'
  // or 'autoplay-failure' event with which other plugins can interface.
  allowVjsAutoplay: P.options.normalizeAutoplay || !1
}, wT = function(e) {
  var r = this, n = P.mergeOptions(yB, e), i = [];
  vB.concat(["firstplay", "loadedalldata"]).forEach(function(o) {
    i.indexOf(o) === -1 && i.push(o);
  }), r.on(i, N2), mB() || H2(r, n.debug), r.setTimeout(function() {
    !r.ads._hasThereBeenALoadStartDuringPlayerLife && r.src() !== "" && P.log.error("videojs-contrib-ads has not seen a loadstart event 5 seconds after being initialized, but a source is present. This indicates that videojs-contrib-ads was initialized too late. It must be initialized immediately after video.js in the same tick. As a result, some ads will not play and some media events will be incorrect. For more information, see http://videojs.github.io/videojs-contrib-ads/integrator/getting-started.html");
  }, 5e3), r.on("ended", function() {
    r.hasClass("vjs-has-started") || r.addClass("vjs-has-started");
  }), r.on("contenttimeupdate", function() {
    r.removeClass("vjs-waiting");
  }), r.on(["addurationchange", "adcanplay"], function() {
    if (!r.ads.settings.stitchedAds && !r.hasStarted() && !(r.ads.snapshot && r.currentSrc() === r.ads.snapshot.currentSrc) && r.ads.inAdBreak()) {
      var o = r.play();
      o && o.catch && o.catch(function(u) {
        P.log.warn("Play promise rejected when playing ad", u);
      });
    }
  }), r.on("nopreroll", function() {
    r.ads.debug("Received nopreroll event"), r.ads.nopreroll_ = !0;
  }), r.on("nopostroll", function() {
    r.ads.debug("Received nopostroll event"), r.ads.nopostroll_ = !0;
  }), r.on("playing", function() {
    r.ads._cancelledPlay = !1, r.ads._pausedOnContentupdate = !1;
  }), r.on("play", function() {
    r.ads._playRequested = !0;
  }), r.one("loadstart", function() {
    r.ads._hasThereBeenALoadStartDuringPlayerLife = !0;
  }), r.on("loadeddata", function() {
    r.ads._hasThereBeenALoadedData = !0;
  }), r.on("loadedmetadata", function() {
    r.ads._hasThereBeenALoadedMetaData = !0;
  }), r.ads = I2(r), r.ads.settings = n, n.stitchedAds = !!n.stitchedAds, n.stitchedAds ? r.ads._state = new (qe.getState("StitchedContentPlayback"))(r) : r.ads._state = new (qe.getState("BeforePreroll"))(r), r.ads._state.init(r), r.ads.cueTextTracks = kn, r.ads.adMacroReplacement = U2.bind(r), B2(r), r.on("contentchanged", r.ads.reset);
  var a = function() {
    return !r.ads.shouldPlayContentBehindAd(r) && r.ads.inAdBreak() && r.tech_.featuresNativeTextTracks && P.browser.IS_IOS && // older versions of video.js did not use an emulated textTrackList
    !Array.isArray(r.textTracks());
  }, s = function() {
    var u = r.textTracks();
    if (a())
      for (var l = 0; l < u.length; l++) {
        var d = u[l];
        d.mode === "showing" && (d.mode = "disabled");
      }
  };
  r.ready(function() {
    r.textTracks().addEventListener("change", s);
  }), r.on(["play", "playing", "ended", "adsready", "adscanceled", "adskip", "adserror", "adtimeout", "adended", "ads-ad-started", "contentchanged", "dispose", "contentresumed", "readyforpostroll", "nopreroll", "nopostroll"], function(o) {
    r.ads._state.handleEvent(o.type);
  }), r.on("dispose", function() {
    r.ads.reset(), r.textTracks().removeEventListener("change", s);
  }), nv(), r.ads.listenToTcf = nv;
};
wT.VERSION = CT;
G2(wT);
var Ve = function(e, r, n) {
  this.vjsPlayer = e, this.controller = n, this.contentTrackingTimer = null, this.contentComplete = !1, this.updateTimeIntervalHandle = null, this.updateTimeInterval = 1e3, this.seekCheckIntervalHandle = null, this.seekCheckInterval = 1e3, this.resizeCheckIntervalHandle = null, this.resizeCheckInterval = 250, this.seekThreshold = 100, this.contentEndedListeners = [], this.contentSource = "", this.contentSourceType = "", this.contentPlayheadTracker = {
    currentTime: 0,
    previousTime: 0,
    seeking: !1,
    duration: 0
  }, this.vjsPlayerDimensions = {
    width: this.getPlayerWidth(),
    height: this.getPlayerHeight()
  }, this.vjsControls = this.vjsPlayer.getChild("controlBar"), this.h5Player = null, this.vjsPlayer.one("play", this.setUpPlayerIntervals.bind(this)), this.boundContentEndedListener = this.localContentEndedListener.bind(this), this.vjsPlayer.on("contentended", this.boundContentEndedListener), this.vjsPlayer.on("dispose", this.playerDisposedListener.bind(this)), this.vjsPlayer.on("readyforpreroll", this.onReadyForPreroll.bind(this)), this.vjsPlayer.on("adtimeout", this.onAdTimeout.bind(this)), this.vjsPlayer.ready(this.onPlayerReady.bind(this)), this.controller.getSettings().requestMode === "onPlay" && this.vjsPlayer.one("play", this.controller.requestAds.bind(this.controller)), this.vjsPlayer.ads || window.console.warn("You may be using a version of videojs-contrib-ads that is not compatible with your version of video.js."), this.vjsPlayer.ads(r);
};
Ve.prototype.setUpPlayerIntervals = function() {
  this.updateTimeIntervalHandle = setInterval(this.updateCurrentTime.bind(this), this.updateTimeInterval), this.seekCheckIntervalHandle = setInterval(this.checkForSeeking.bind(this), this.seekCheckInterval), this.resizeCheckIntervalHandle = setInterval(this.checkForResize.bind(this), this.resizeCheckInterval);
};
Ve.prototype.updateCurrentTime = function() {
  this.contentPlayheadTracker.seeking || (this.contentPlayheadTracker.currentTime = this.vjsPlayer.currentTime());
};
Ve.prototype.checkForSeeking = function() {
  var t = this.vjsPlayer.currentTime(), e = (t - this.contentPlayheadTracker.previousTime) * 1e3;
  Math.abs(e) > this.seekCheckInterval + this.seekThreshold ? this.contentPlayheadTracker.seeking = !0 : this.contentPlayheadTracker.seeking = !1, this.contentPlayheadTracker.previousTime = this.vjsPlayer.currentTime();
};
Ve.prototype.checkForResize = function() {
  var t = this.getPlayerWidth(), e = this.getPlayerHeight();
  (t != this.vjsPlayerDimensions.width || e != this.vjsPlayerDimensions.height) && (this.vjsPlayerDimensions.width = t, this.vjsPlayerDimensions.height = e, this.controller.onPlayerResize(t, e));
};
Ve.prototype.localContentEndedListener = function() {
  this.contentComplete || (this.contentComplete = !0, this.controller.onContentComplete());
  for (var t in this.contentEndedListeners)
    typeof this.contentEndedListeners[t] == "function" && this.contentEndedListeners[t]();
  clearInterval(this.updateTimeIntervalHandle), clearInterval(this.seekCheckIntervalHandle), clearInterval(this.resizeCheckIntervalHandle), this.vjsPlayer.el() && this.vjsPlayer.one("play", this.setUpPlayerIntervals.bind(this));
};
Ve.prototype.onNoPostroll = function() {
  this.vjsPlayer.trigger("nopostroll");
};
Ve.prototype.playerDisposedListener = function() {
  this.contentEndedListeners = [], this.controller.onPlayerDisposed(), this.contentComplete = !0, this.vjsPlayer.off("contentended", this.boundContentEndedListener), this.vjsPlayer.ads.adTimeoutTimeout && clearTimeout(this.vjsPlayer.ads.adTimeoutTimeout);
  var t = [this.updateTimeIntervalHandle, this.seekCheckIntervalHandle, this.resizeCheckIntervalHandle];
  for (var e in t)
    t[e] && clearInterval(t[e]);
};
Ve.prototype.onReadyForPreroll = function() {
  this.controller.onPlayerReadyForPreroll();
};
Ve.prototype.onAdTimeout = function() {
  this.controller.onAdTimeout();
};
Ve.prototype.onPlayerReady = function() {
  this.h5Player = document.getElementById(this.getPlayerId()).getElementsByClassName("vjs-tech")[0], this.h5Player.hasAttribute("autoplay") && this.controller.setSetting("adWillAutoPlay", !0), this.onVolumeChange(), this.vjsPlayer.on("fullscreenchange", this.onFullscreenChange.bind(this)), this.vjsPlayer.on("volumechange", this.onVolumeChange.bind(this)), this.controller.onPlayerReady();
};
Ve.prototype.onFullscreenChange = function() {
  this.vjsPlayer.isFullscreen() ? this.controller.onPlayerEnterFullscreen() : this.controller.onPlayerExitFullscreen();
};
Ve.prototype.onVolumeChange = function() {
  var t = this.vjsPlayer.muted() ? 0 : this.vjsPlayer.volume();
  this.controller.onPlayerVolumeChanged(t);
};
Ve.prototype.injectAdContainerDiv = function(t) {
  this.vjsControls.el().parentNode.appendChild(t);
};
Ve.prototype.getContentPlayer = function() {
  return this.h5Player;
};
Ve.prototype.getVolume = function() {
  return this.vjsPlayer.muted() ? 0 : this.vjsPlayer.volume();
};
Ve.prototype.setVolume = function(t) {
  this.vjsPlayer.volume(t), t == 0 ? this.vjsPlayer.muted(!0) : this.vjsPlayer.muted(!1);
};
Ve.prototype.unmute = function() {
  this.vjsPlayer.muted(!1);
};
Ve.prototype.mute = function() {
  this.vjsPlayer.muted(!0);
};
Ve.prototype.play = function() {
  this.vjsPlayer.play();
};
Ve.prototype.togglePlayback = function() {
  this.vjsPlayer.paused() ? this.vjsPlayer.play() : this.vjsPlayer.pause();
};
Ve.prototype.getPlayerWidth = function() {
  var t = (getComputedStyle(this.vjsPlayer.el()) || {}).width;
  return (!t || parseFloat(t) === 0) && (t = (this.vjsPlayer.el().getBoundingClientRect() || {}).width), parseFloat(t) || this.vjsPlayer.width();
};
Ve.prototype.getPlayerHeight = function() {
  var t = (getComputedStyle(this.vjsPlayer.el()) || {}).height;
  return (!t || parseFloat(t) === 0) && (t = (this.vjsPlayer.el().getBoundingClientRect() || {}).height), parseFloat(t) || this.vjsPlayer.height();
};
Ve.prototype.getPlayerOptions = function() {
  return this.vjsPlayer.options_;
};
Ve.prototype.getPlayerId = function() {
  return this.vjsPlayer.id();
};
Ve.prototype.toggleFullscreen = function() {
  this.vjsPlayer.isFullscreen() ? this.vjsPlayer.exitFullscreen() : this.vjsPlayer.requestFullscreen();
};
Ve.prototype.getContentPlayheadTracker = function() {
  return this.contentPlayheadTracker;
};
Ve.prototype.onAdError = function(t) {
  this.vjsControls.show();
  var e = t.getError !== void 0 ? t.getError() : t.stack;
  this.vjsPlayer.trigger({ type: "adserror", data: {
    AdError: e,
    AdErrorEvent: t
  } });
};
Ve.prototype.onAdLog = function(t) {
  var e = t.getAdData(), r = e.adError !== void 0 ? e.adError.getMessage() : void 0;
  this.vjsPlayer.trigger({ type: "adslog", data: {
    AdError: r,
    AdEvent: t
  } });
};
Ve.prototype.onAdBreakStart = function() {
  this.contentSource = this.vjsPlayer.currentSrc(), this.contentSourceType = this.vjsPlayer.currentType(), this.vjsPlayer.off("contentended", this.boundContentEndedListener), this.vjsPlayer.ads.startLinearAdMode(), this.vjsControls.hide(), this.vjsPlayer.pause();
};
Ve.prototype.onAdBreakEnd = function() {
  this.vjsPlayer.on("contentended", this.boundContentEndedListener), this.vjsPlayer.ads.inAdBreak() && this.vjsPlayer.ads.endLinearAdMode(), this.vjsControls.show();
};
Ve.prototype.onAdStart = function() {
  this.vjsPlayer.trigger("ads-ad-started");
};
Ve.prototype.onAllAdsCompleted = function() {
  this.contentComplete == !0 && (this.contentSource && this.vjsPlayer.currentSrc() != this.contentSource && this.vjsPlayer.src({
    src: this.contentSource,
    type: this.contentSourceType
  }), this.controller.onContentAndAdsCompleted());
};
Ve.prototype.onAdsReady = function() {
  this.vjsPlayer.trigger("adsready");
};
Ve.prototype.changeSource = function(t) {
  this.vjsPlayer.currentSrc() && (this.vjsPlayer.currentTime(0), this.vjsPlayer.pause()), t && this.vjsPlayer.src(t), this.vjsPlayer.one("loadedmetadata", this.seekContentToZero.bind(this));
};
Ve.prototype.seekContentToZero = function() {
  this.vjsPlayer.currentTime(0);
};
Ve.prototype.triggerPlayerEvent = function(t, e) {
  this.vjsPlayer.trigger(t, e);
};
Ve.prototype.addContentEndedListener = function(t) {
  this.contentEndedListeners.push(t);
};
Ve.prototype.reset = function() {
  this.vjsPlayer.off("contentended", this.boundContentEndedListener), this.vjsPlayer.on("contentended", this.boundContentEndedListener), this.vjsControls.show(), this.vjsPlayer.ads.inAdBreak() && this.vjsPlayer.ads.endLinearAdMode(), this.contentPlayheadTracker.currentTime = 0, this.contentComplete = !1;
};
var He = function(e) {
  this.controller = e, this.adContainerDiv = document.createElement("div"), this.controlsDiv = document.createElement("div"), this.countdownDiv = document.createElement("div"), this.seekBarDiv = document.createElement("div"), this.progressDiv = document.createElement("div"), this.playPauseDiv = document.createElement("div"), this.muteDiv = document.createElement("div"), this.sliderDiv = document.createElement("div"), this.sliderLevelDiv = document.createElement("div"), this.fullscreenDiv = document.createElement("div"), this.boundOnMouseUp = this.onMouseUp.bind(this), this.boundOnMouseMove = this.onMouseMove.bind(this), this.adPlayheadTracker = {
    currentTime: 0,
    duration: 0,
    isPod: !1,
    adPosition: 0,
    totalAds: 0
  }, this.controlPrefix = this.controller.getPlayerId() + "_", this.showCountdown = !0, this.controller.getSettings().showCountdown === !1 && (this.showCountdown = !1), this.isAdNonlinear = !1, this.createAdContainer();
};
He.prototype.createAdContainer = function() {
  this.assignControlAttributes(this.adContainerDiv, "ima-ad-container"), this.adContainerDiv.style.position = "absolute", this.adContainerDiv.style.zIndex = 1111, this.adContainerDiv.addEventListener("mouseenter", this.showAdControls.bind(this), !1), this.adContainerDiv.addEventListener("mouseleave", this.hideAdControls.bind(this), !1), this.adContainerDiv.addEventListener("click", this.onAdContainerClick.bind(this), !1), this.createControls(), this.controller.injectAdContainerDiv(this.adContainerDiv);
};
He.prototype.createControls = function() {
  this.assignControlAttributes(this.controlsDiv, "ima-controls-div"), this.controlsDiv.style.width = "100%", this.controller.getIsMobile() ? this.countdownDiv.style.display = "none" : (this.assignControlAttributes(this.countdownDiv, "ima-countdown-div"), this.countdownDiv.innerHTML = this.controller.getSettings().adLabel, this.countdownDiv.style.display = this.showCountdown ? "block" : "none"), this.assignControlAttributes(this.seekBarDiv, "ima-seek-bar-div"), this.seekBarDiv.style.width = "100%", this.assignControlAttributes(this.progressDiv, "ima-progress-div"), this.assignControlAttributes(this.playPauseDiv, "ima-play-pause-div"), this.addClass(this.playPauseDiv, "ima-playing"), this.playPauseDiv.addEventListener("click", this.onAdPlayPauseClick.bind(this), !1), this.assignControlAttributes(this.muteDiv, "ima-mute-div"), this.addClass(this.muteDiv, "ima-non-muted"), this.muteDiv.addEventListener("click", this.onAdMuteClick.bind(this), !1), this.assignControlAttributes(this.sliderDiv, "ima-slider-div"), this.sliderDiv.addEventListener("mousedown", this.onAdVolumeSliderMouseDown.bind(this), !1), this.controller.getIsIos() && (this.sliderDiv.style.display = "none"), this.assignControlAttributes(this.sliderLevelDiv, "ima-slider-level-div"), this.assignControlAttributes(this.fullscreenDiv, "ima-fullscreen-div"), this.addClass(this.fullscreenDiv, "ima-non-fullscreen"), this.fullscreenDiv.addEventListener("click", this.onAdFullscreenClick.bind(this), !1), this.adContainerDiv.appendChild(this.controlsDiv), this.controlsDiv.appendChild(this.countdownDiv), this.controlsDiv.appendChild(this.seekBarDiv), this.controlsDiv.appendChild(this.playPauseDiv), this.controlsDiv.appendChild(this.muteDiv), this.controlsDiv.appendChild(this.sliderDiv), this.controlsDiv.appendChild(this.fullscreenDiv), this.seekBarDiv.appendChild(this.progressDiv), this.sliderDiv.appendChild(this.sliderLevelDiv);
};
He.prototype.onAdPlayPauseClick = function() {
  this.controller.onAdPlayPauseClick();
};
He.prototype.onAdMuteClick = function() {
  this.controller.onAdMuteClick();
};
He.prototype.onAdFullscreenClick = function() {
  this.controller.toggleFullscreen();
};
He.prototype.onAdsPaused = function() {
  this.controller.sdkImpl.adPlaying = !1, this.addClass(this.playPauseDiv, "ima-paused"), this.removeClass(this.playPauseDiv, "ima-playing"), this.showAdControls();
};
He.prototype.onAdsResumed = function() {
  this.onAdsPlaying(), this.showAdControls();
};
He.prototype.onAdsPlaying = function() {
  this.controller.sdkImpl.adPlaying = !0, this.addClass(this.playPauseDiv, "ima-playing"), this.removeClass(this.playPauseDiv, "ima-paused");
};
He.prototype.updateAdUi = function(t, e, r, n, i) {
  var a = Math.floor(e / 60), s = Math.floor(e % 60);
  s.toString().length < 2 && (s = "0" + s);
  var o = ": ";
  i > 1 && (o = " (" + n + " " + this.controller.getSettings().adLabelNofN + " " + i + "): "), this.countdownDiv.innerHTML = this.controller.getSettings().adLabel + o + a + ":" + s;
  var u = t / r, l = u * 100;
  this.progressDiv.style.width = l + "%";
};
He.prototype.unmute = function() {
  this.addClass(this.muteDiv, "ima-non-muted"), this.removeClass(this.muteDiv, "ima-muted"), this.sliderLevelDiv.style.width = this.controller.getPlayerVolume() * 100 + "%";
};
He.prototype.mute = function() {
  this.addClass(this.muteDiv, "ima-muted"), this.removeClass(this.muteDiv, "ima-non-muted"), this.sliderLevelDiv.style.width = "0%";
};
He.prototype.onAdVolumeSliderMouseDown = function() {
  document.addEventListener("mouseup", this.boundOnMouseUp, !1), document.addEventListener("mousemove", this.boundOnMouseMove, !1);
};
He.prototype.onMouseMove = function(t) {
  this.changeVolume(t);
};
He.prototype.onMouseUp = function(t) {
  this.changeVolume(t), document.removeEventListener("mouseup", this.boundOnMouseUp), document.removeEventListener("mousemove", this.boundOnMouseMove);
};
He.prototype.changeVolume = function(t) {
  var e = (t.clientX - this.sliderDiv.getBoundingClientRect().left) / this.sliderDiv.offsetWidth;
  e *= 100, e = Math.min(Math.max(e, 0), 100), this.sliderLevelDiv.style.width = e + "%", this.percent == 0 ? (this.addClass(this.muteDiv, "ima-muted"), this.removeClass(this.muteDiv, "ima-non-muted")) : (this.addClass(this.muteDiv, "ima-non-muted"), this.removeClass(this.muteDiv, "ima-muted")), this.controller.setVolume(e / 100);
};
He.prototype.showAdContainer = function() {
  this.adContainerDiv.style.display = "block";
};
He.prototype.hideAdContainer = function() {
  this.adContainerDiv.style.display = "none";
};
He.prototype.onAdContainerClick = function() {
  this.isAdNonlinear && this.controller.togglePlayback();
};
He.prototype.reset = function() {
  this.hideAdContainer();
};
He.prototype.onAdError = function() {
  this.hideAdContainer();
};
He.prototype.onAdBreakStart = function(t) {
  this.showAdContainer();
  var e = t.getAd().getContentType();
  e === "application/javascript" && !this.controller.getSettings().showControlsForJSAds ? this.controlsDiv.style.display = "none" : this.controlsDiv.style.display = "block", this.onAdsPlaying(), this.hideAdControls();
};
He.prototype.onAdBreakEnd = function() {
  var t = this.controller.getCurrentAd();
  (t == null || // hide for post-roll only playlist
  t.isLinear()) && this.hideAdContainer(), this.controlsDiv.style.display = "none", this.countdownDiv.innerHTML = "";
};
He.prototype.onAllAdsCompleted = function() {
  this.hideAdContainer();
};
He.prototype.onLinearAdStart = function() {
  this.removeClass(this.adContainerDiv, "bumpable-ima-ad-container"), this.isAdNonlinear = !1;
};
He.prototype.onNonLinearAdLoad = function() {
  this.adContainerDiv.style.display = "block", this.addClass(this.adContainerDiv, "bumpable-ima-ad-container"), this.isAdNonlinear = !0;
};
He.prototype.onPlayerEnterFullscreen = function() {
  this.addClass(this.fullscreenDiv, "ima-fullscreen"), this.removeClass(this.fullscreenDiv, "ima-non-fullscreen");
};
He.prototype.onPlayerExitFullscreen = function() {
  this.addClass(this.fullscreenDiv, "ima-non-fullscreen"), this.removeClass(this.fullscreenDiv, "ima-fullscreen");
};
He.prototype.onPlayerVolumeChanged = function(t) {
  t == 0 ? (this.addClass(this.muteDiv, "ima-muted"), this.removeClass(this.muteDiv, "ima-non-muted"), this.sliderLevelDiv.style.width = "0%") : (this.addClass(this.muteDiv, "ima-non-muted"), this.removeClass(this.muteDiv, "ima-muted"), this.sliderLevelDiv.style.width = t * 100 + "%");
};
He.prototype.showAdControls = function() {
  var t = this.controller.getSettings(), e = t.disableAdControls;
  e || this.addClass(this.controlsDiv, "ima-controls-div-showing");
};
He.prototype.hideAdControls = function() {
  this.removeClass(this.controlsDiv, "ima-controls-div-showing");
};
He.prototype.assignControlAttributes = function(t, e) {
  t.id = this.controlPrefix + e, t.className = this.controlPrefix + e + " " + e;
};
He.prototype.getClassRegexp = function(t) {
  return new RegExp("(^|[^A-Za-z-])" + t + "((?![A-Za-z-])|$)", "gi");
};
He.prototype.elementHasClass = function(t, e) {
  var r = this.getClassRegexp(e);
  return r.test(t.className);
};
He.prototype.addClass = function(t, e) {
  t.className = t.className.trim() + " " + e;
};
He.prototype.removeClass = function(t, e) {
  var r = this.getClassRegexp(e);
  t.className = t.className.trim().replace(r, "");
};
He.prototype.getAdContainerDiv = function() {
  return this.adContainerDiv;
};
He.prototype.setShowCountdown = function(t) {
  this.showCountdown = t, this.countdownDiv.style.display = this.showCountdown ? "block" : "none";
};
var _B = "videojs-ima", TB = "2.2.0", bB = "Apache-2.0", SB = "./dist/videojs.ima.js", EB = "./dist/videojs.ima.es.js", xB = { name: "Google Inc." }, CB = { node: ">=0.8.0" }, AB = { contBuild: "watch 'npm run rollup:max' src", predevServer: 'echo "Starting up server on localhost:8000."', devServer: "npm-run-all -p testServer contBuild", lint: 'eslint "src/**/*.js"', rollup: "npm-run-all rollup:*", "rollup:max": "rollup -c configs/rollup.config.js", "rollup:es": "rollup -c configs/rollup.config.es.js", "rollup:min": "rollup -c configs/rollup.config.min.js", pretest: "npm run rollup", start: "npm run devServer", test: "npm-run-all test:*", "test:vjs6": "npm install video.js@6 --no-save && npm-run-all -p -r testServer webdriver", "test:vjs7": "npm install video.js@7 --no-save && npm-run-all -p -r testServer webdriver", testServer: "http-server --cors -p 8000 --silent", preversion: "node scripts/preversion.js && npm run lint && npm test", version: "node scripts/version.js", postversion: "node scripts/postversion.js", webdriver: "mocha test/webdriver/*.js --no-timeouts" }, wB = { type: "git", url: "https://github.com/googleads/videojs-ima" }, PB = ["CHANGELOG.md", "LICENSE", "README.md", "dist/", "src/"], kB = { "video.js": "^5.19.2 || ^6 || ^7 || ^8" }, LB = { "@hapi/cryptiles": "^5.1.0", "can-autoplay": "^3.0.2", extend: ">=3.0.2", "videojs-contrib-ads": "^6.9.0 || ^7" }, IB = { axios: "^0.25.0", "babel-core": "^6.26.3", "babel-preset-env": "^1.7.0", child_process: "^1.0.2", chromedriver: "^114.0.2", "conventional-changelog-cli": "^2.2.2", "conventional-changelog-videojs": "^3.0.2", ecstatic: "^4.1.4", eslint: "^8.8.0", "eslint-config-google": "^0.9.1", "eslint-plugin-jsdoc": "^3.15.1", geckodriver: "^2.0.4", "http-server": "^14.1.0", ini: ">=1.3.7", mocha: "^9.2.0", "npm-run-all": "^4.1.5", path: "^0.12.7", protractor: "^7.0.0", rimraf: "^2.7.1", rollup: "^0.51.8", "rollup-plugin-babel": "^3.0.7", "rollup-plugin-copy": "^0.2.3", "rollup-plugin-json": "^2.3.1", "rollup-plugin-uglify": "^2.0.1", "selenium-webdriver": "^3.6.0", "uglify-es": "^3.3.9", "video.js": "^7.17.0", watch: "^0.13.0", "webdriver-manager": "^12.1.7", xmldom: "^0.6.0" }, DB = ["videojs", "videojs-plugin"], RB = {
  name: _B,
  version: TB,
  license: bB,
  main: SB,
  module: EB,
  author: xB,
  engines: CB,
  scripts: AB,
  repository: wB,
  files: PB,
  peerDependencies: kB,
  dependencies: LB,
  devDependencies: IB,
  keywords: DB
}, OB = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
  return typeof t;
} : function(t) {
  return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
}, Me = function(e) {
  this.controller = e, this.adDisplayContainer = null, this.adDisplayContainerInitialized = !1, this.adsLoader = null, this.adsManager = null, this.adsRenderingSettings = null, this.adsResponse = null, this.currentAd = null, this.adTrackingTimer = null, this.allAdsCompleted = !1, this.adsActive = !1, this.adPlaying = !1, this.adMuted = !1, this.adBreakReadyListener = void 0, this.contentCompleteCalled = !1, this.isAdTimedOut = !1, this.adsManagerDimensions = {
    width: 0,
    height: 0
  }, this.autoPlayAdBreaks = !0, this.controller.getSettings().autoPlayAdBreaks === !1 && (this.autoPlayAdBreaks = !1), this.controller.getSettings().locale && google.ima.settings.setLocale(this.controller.getSettings().locale), this.controller.getSettings().disableFlashAds && google.ima.settings.setDisableFlashAds(this.controller.getSettings().disableFlashAds), this.controller.getSettings().disableCustomPlaybackForIOS10Plus && google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.controller.getSettings().disableCustomPlaybackForIOS10Plus), this.controller.getSettings().ppid && google.ima.settings.setPpid(this.controller.getSettings().ppid), this.controller.getSettings().featureFlags && google.ima.settings.setFeatureFlags(this.controller.getSettings().featureFlags);
};
Me.prototype.initAdObjects = function() {
  this.adDisplayContainer = new google.ima.AdDisplayContainer(this.controller.getAdContainerDiv(), this.controller.getContentPlayer()), this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer), this.adsLoader.getSettings().setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), this.controller.getSettings().vpaidAllowed == !1 && this.adsLoader.getSettings().setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.DISABLED), this.controller.getSettings().vpaidMode !== void 0 && this.adsLoader.getSettings().setVpaidMode(this.controller.getSettings().vpaidMode), this.controller.getSettings().locale && this.adsLoader.getSettings().setLocale(this.controller.getSettings().locale), this.controller.getSettings().numRedirects && this.adsLoader.getSettings().setNumRedirects(this.controller.getSettings().numRedirects), this.controller.getSettings().sessionId && this.adsLoader.getSettings().setSessionId(this.controller.getSettings().sessionId), this.adsLoader.getSettings().setPlayerType("videojs-ima"), this.adsLoader.getSettings().setPlayerVersion(RB.version), this.adsLoader.getSettings().setAutoPlayAdBreaks(this.autoPlayAdBreaks), this.adsLoader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, this.onAdsManagerLoaded.bind(this), !1), this.adsLoader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdsLoaderError.bind(this), !1), this.controller.playerWrapper.vjsPlayer.trigger({
    type: "ads-loader",
    adsLoader: this.adsLoader
  });
};
Me.prototype.requestAds = function() {
  var t = new google.ima.AdsRequest();
  if (this.controller.getSettings().adTagUrl ? t.adTagUrl = this.controller.getSettings().adTagUrl : t.adsResponse = this.controller.getSettings().adsResponse, this.controller.getSettings().forceNonLinearFullSlot && (t.forceNonLinearFullSlot = !0), this.controller.getSettings().vastLoadTimeout && (t.vastLoadTimeout = this.controller.getSettings().vastLoadTimeout), this.controller.getSettings().omidMode && window.console.warn("The additional setting `omidMode` has been removed. Use `omidVendorAccess` instead."), this.controller.getSettings().omidVendorAccess) {
    t.omidAccessModeRules = {};
    var e = this.controller.getSettings().omidVendorAccess;
    Object.keys(e).forEach(function(n) {
      t.omidAccessModeRules[n] = e[n];
    });
  }
  t.linearAdSlotWidth = this.controller.getPlayerWidth(), t.linearAdSlotHeight = this.controller.getPlayerHeight(), t.nonLinearAdSlotWidth = this.controller.getSettings().nonLinearWidth || this.controller.getPlayerWidth(), t.nonLinearAdSlotHeight = this.controller.getSettings().nonLinearHeight || this.controller.getPlayerHeight(), t.setAdWillAutoPlay(this.controller.adsWillAutoplay()), t.setAdWillPlayMuted(this.controller.adsWillPlayMuted());
  var r = this.controller.getSettings().adsRequest;
  r && (typeof r > "u" ? "undefined" : OB(r)) === "object" && Object.keys(r).forEach(function(n) {
    t[n] = r[n];
  }), this.adsLoader.requestAds(t), this.controller.playerWrapper.vjsPlayer.trigger({
    type: "ads-request",
    AdsRequest: t
  });
};
Me.prototype.onAdsManagerLoaded = function(t) {
  this.createAdsRenderingSettings(), this.adsManager = t.getAdsManager(this.controller.getContentPlayheadTracker(), this.adsRenderingSettings), this.adsManager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, this.onAdError.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.AD_BREAK_READY, this.onAdBreakReady.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED, this.onContentPauseRequested.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, this.onContentResumeRequested.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, this.onAllAdsCompleted.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.LOADED, this.onAdLoaded.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, this.onAdStarted.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, this.onAdComplete.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.SKIPPED, this.onAdComplete.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.LOG, this.onAdLog.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.PAUSED, this.onAdPaused.bind(this)), this.adsManager.addEventListener(google.ima.AdEvent.Type.RESUMED, this.onAdResumed.bind(this)), this.controller.playerWrapper.vjsPlayer.trigger({
    type: "ads-manager",
    adsManager: this.adsManager
  }), this.autoPlayAdBreaks || this.initAdsManager();
  var e = this.controller.getSettings(), r = e.preventLateAdStart;
  r ? r && !this.isAdTimedOut && this.controller.onAdsReady() : this.controller.onAdsReady(), this.controller.getSettings().adsManagerLoadedCallback && this.controller.getSettings().adsManagerLoadedCallback();
};
Me.prototype.onAdsLoaderError = function(t) {
  window.console.warn("AdsLoader error: " + t.getError()), this.controller.onErrorLoadingAds(t), this.adsManager && this.adsManager.destroy();
};
Me.prototype.initAdsManager = function() {
  try {
    var t = this.controller.getPlayerWidth(), e = this.controller.getPlayerHeight();
    this.adsManagerDimensions.width = t, this.adsManagerDimensions.height = e, this.adsManager.init(t, e, google.ima.ViewMode.NORMAL), this.adsManager.setVolume(this.controller.getPlayerVolume()), this.initializeAdDisplayContainer();
  } catch (r) {
    this.onAdError(r);
  }
};
Me.prototype.createAdsRenderingSettings = function() {
  if (this.adsRenderingSettings = new google.ima.AdsRenderingSettings(), this.adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = !0, this.controller.getSettings().adsRenderingSettings)
    for (var t in this.controller.getSettings().adsRenderingSettings)
      t !== "" && (this.adsRenderingSettings[t] = this.controller.getSettings().adsRenderingSettings[t]);
};
Me.prototype.onAdError = function(t) {
  var e = t.getError !== void 0 ? t.getError() : t.stack;
  window.console.warn("Ad error: " + e), this.adsManager.destroy(), this.controller.onAdError(t), this.adsActive = !1, this.adPlaying = !1;
};
Me.prototype.onAdBreakReady = function(t) {
  this.adBreakReadyListener(t);
};
Me.prototype.onContentPauseRequested = function(t) {
  this.adsActive = !0, this.adPlaying = !0, this.controller.onAdBreakStart(t);
};
Me.prototype.onContentResumeRequested = function(t) {
  this.adsActive = !1, this.adPlaying = !1, this.controller.onAdBreakEnd();
};
Me.prototype.onAllAdsCompleted = function(t) {
  this.allAdsCompleted = !0, this.controller.onAllAdsCompleted();
};
Me.prototype.onAdLoaded = function(t) {
  t.getAd().isLinear() || (this.controller.onNonLinearAdLoad(), this.controller.playContent());
};
Me.prototype.onAdStarted = function(t) {
  this.currentAd = t.getAd(), this.currentAd.isLinear() ? (this.adTrackingTimer = setInterval(this.onAdPlayheadTrackerInterval.bind(this), 250), this.controller.onLinearAdStart()) : this.controller.onNonLinearAdStart();
};
Me.prototype.onAdPaused = function() {
  this.controller.onAdsPaused();
};
Me.prototype.onAdResumed = function(t) {
  this.controller.onAdsResumed();
};
Me.prototype.onAdComplete = function() {
  this.currentAd.isLinear() && clearInterval(this.adTrackingTimer);
};
Me.prototype.onAdLog = function(t) {
  this.controller.onAdLog(t);
};
Me.prototype.onAdPlayheadTrackerInterval = function() {
  if (this.adsManager !== null) {
    var t = this.adsManager.getRemainingTime(), e = this.currentAd.getDuration(), r = e - t;
    r = r > 0 ? r : 0;
    var n = 0, i = void 0;
    this.currentAd.getAdPodInfo() && (i = this.currentAd.getAdPodInfo().getAdPosition(), n = this.currentAd.getAdPodInfo().getTotalAds()), this.controller.onAdPlayheadUpdated(r, t, e, i, n);
  }
};
Me.prototype.onContentComplete = function() {
  this.adsLoader && (this.adsLoader.contentComplete(), this.contentCompleteCalled = !0), (this.adsManager && this.adsManager.getCuePoints() && !this.adsManager.getCuePoints().includes(-1) || !this.adsManager) && this.controller.onNoPostroll(), this.allAdsCompleted && this.controller.onContentAndAdsCompleted();
};
Me.prototype.onPlayerDisposed = function() {
  this.adTrackingTimer && clearInterval(this.adTrackingTimer), this.adsManager && (this.adsManager.destroy(), this.adsManager = null);
};
Me.prototype.onPlayerReadyForPreroll = function() {
  if (this.autoPlayAdBreaks) {
    this.initAdsManager();
    try {
      this.controller.showAdContainer(), this.adsManager.setVolume(this.controller.getPlayerVolume()), this.adsManager.start();
    } catch (t) {
      this.onAdError(t);
    }
  }
};
Me.prototype.onAdTimeout = function() {
  this.isAdTimedOut = !0;
};
Me.prototype.onPlayerReady = function() {
  this.initAdObjects(), (this.controller.getSettings().adTagUrl || this.controller.getSettings().adsResponse) && this.controller.getSettings().requestMode === "onLoad" && this.requestAds();
};
Me.prototype.onPlayerEnterFullscreen = function() {
  this.adsManager && this.adsManager.resize(window.screen.width, window.screen.height, google.ima.ViewMode.FULLSCREEN);
};
Me.prototype.onPlayerExitFullscreen = function() {
  this.adsManager && this.adsManager.resize(this.controller.getPlayerWidth(), this.controller.getPlayerHeight(), google.ima.ViewMode.NORMAL);
};
Me.prototype.onPlayerVolumeChanged = function(t) {
  this.adsManager && this.adsManager.setVolume(t), t == 0 ? this.adMuted = !0 : this.adMuted = !1;
};
Me.prototype.onPlayerResize = function(t, e) {
  this.adsManager && (this.adsManagerDimensions.width = t, this.adsManagerDimensions.height = e, this.adsManager.resize(t, e, google.ima.ViewMode.NORMAL));
};
Me.prototype.getCurrentAd = function() {
  return this.currentAd;
};
Me.prototype.setAdBreakReadyListener = function(t) {
  this.adBreakReadyListener = t;
};
Me.prototype.isAdPlaying = function() {
  return this.adPlaying;
};
Me.prototype.isAdMuted = function() {
  return this.adMuted;
};
Me.prototype.pauseAds = function() {
  this.adsManager.pause(), this.adPlaying = !1;
};
Me.prototype.resumeAds = function() {
  this.adsManager.resume(), this.adPlaying = !0;
};
Me.prototype.unmute = function() {
  this.adsManager.setVolume(1), this.adMuted = !1;
};
Me.prototype.mute = function() {
  this.adsManager.setVolume(0), this.adMuted = !0;
};
Me.prototype.setVolume = function(t) {
  this.adsManager.setVolume(t), t == 0 ? this.adMuted = !0 : this.adMuted = !1;
};
Me.prototype.initializeAdDisplayContainer = function() {
  this.adDisplayContainer && (this.adDisplayContainerInitialized || (this.adDisplayContainer.initialize(), this.adDisplayContainerInitialized = !0));
};
Me.prototype.playAdBreak = function() {
  this.autoPlayAdBreaks || (this.controller.showAdContainer(), this.adsManager.setVolume(this.controller.getPlayerVolume()), this.adsManager.start());
};
Me.prototype.addEventListener = function(t, e) {
  this.adsManager && this.adsManager.addEventListener(t, e);
};
Me.prototype.getAdsManager = function() {
  return this.adsManager;
};
Me.prototype.reset = function() {
  this.adsActive = !1, this.adPlaying = !1, this.adTrackingTimer && clearInterval(this.adTrackingTimer), this.adsManager && (this.adsManager.destroy(), this.adsManager = null), this.adsLoader && !this.contentCompleteCalled && this.adsLoader.contentComplete(), this.contentCompleteCalled = !1, this.allAdsCompleted = !1;
};
var _e = function(e, r) {
  this.settings = {}, this.contentAndAdsEndedListeners = [], this.isMobile = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/Android/i), this.isIos = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i), this.initWithSettings(r);
  var n = {
    debug: this.settings.debug,
    timeout: this.settings.timeout,
    prerollTimeout: this.settings.prerollTimeout
  }, i = Object.assign({}, n, r.contribAdsSettings || {});
  this.playerWrapper = new Ve(e, i, this), this.adUi = new He(this), this.sdkImpl = new Me(this);
};
_e.IMA_DEFAULTS = {
  adLabel: "Advertisement",
  adLabelNofN: "of",
  debug: !1,
  disableAdControls: !1,
  prerollTimeout: 1e3,
  preventLateAdStart: !1,
  requestMode: "onLoad",
  showControlsForJSAds: !0,
  timeout: 5e3
};
_e.prototype.initWithSettings = function(t) {
  this.settings = Object.assign({}, _e.IMA_DEFAULTS, t || {}), this.warnAboutDeprecatedSettings(), this.showCountdown = !0, this.settings.showCountdown === !1 && (this.showCountdown = !1);
};
_e.prototype.warnAboutDeprecatedSettings = function() {
  var t = this, e = ["adWillAutoplay", "adsWillAutoplay", "adWillPlayMuted", "adsWillPlayMuted"];
  e.forEach(function(r) {
    t.settings[r] !== void 0 && console.warn("WARNING: videojs.ima setting " + r + " is deprecated");
  });
};
_e.prototype.getSettings = function() {
  return this.settings;
};
_e.prototype.getIsMobile = function() {
  return this.isMobile;
};
_e.prototype.getIsIos = function() {
  return this.isIos;
};
_e.prototype.injectAdContainerDiv = function(t) {
  this.playerWrapper.injectAdContainerDiv(t);
};
_e.prototype.getAdContainerDiv = function() {
  return this.adUi.getAdContainerDiv();
};
_e.prototype.getContentPlayer = function() {
  return this.playerWrapper.getContentPlayer();
};
_e.prototype.getContentPlayheadTracker = function() {
  return this.playerWrapper.getContentPlayheadTracker();
};
_e.prototype.requestAds = function() {
  this.sdkImpl.requestAds();
};
_e.prototype.setSetting = function(t, e) {
  this.settings[t] = e;
};
_e.prototype.onErrorLoadingAds = function(t) {
  this.adUi.onAdError(), this.playerWrapper.onAdError(t);
};
_e.prototype.onAdPlayPauseClick = function() {
  this.sdkImpl.isAdPlaying() ? (this.adUi.onAdsPaused(), this.sdkImpl.pauseAds()) : (this.adUi.onAdsPlaying(), this.sdkImpl.resumeAds());
};
_e.prototype.onAdMuteClick = function() {
  this.sdkImpl.isAdMuted() ? (this.playerWrapper.unmute(), this.adUi.unmute(), this.sdkImpl.unmute()) : (this.playerWrapper.mute(), this.adUi.mute(), this.sdkImpl.mute());
};
_e.prototype.setVolume = function(t) {
  this.playerWrapper.setVolume(t), this.sdkImpl.setVolume(t);
};
_e.prototype.getPlayerVolume = function() {
  return this.playerWrapper.getVolume();
};
_e.prototype.toggleFullscreen = function() {
  this.playerWrapper.toggleFullscreen();
};
_e.prototype.onAdError = function(t) {
  this.adUi.onAdError(), this.playerWrapper.onAdError(t);
};
_e.prototype.onAdBreakStart = function(t) {
  this.playerWrapper.onAdBreakStart(), this.adUi.onAdBreakStart(t);
};
_e.prototype.showAdContainer = function() {
  this.adUi.showAdContainer();
};
_e.prototype.onAdBreakEnd = function() {
  this.playerWrapper.onAdBreakEnd(), this.adUi.onAdBreakEnd();
};
_e.prototype.onAllAdsCompleted = function() {
  this.adUi.onAllAdsCompleted(), this.playerWrapper.onAllAdsCompleted();
};
_e.prototype.onAdsPaused = function() {
  this.adUi.onAdsPaused();
};
_e.prototype.onAdsResumed = function() {
  this.adUi.onAdsResumed();
};
_e.prototype.onAdPlayheadUpdated = function(t, e, r, n, i) {
  this.adUi.updateAdUi(t, e, r, n, i);
};
_e.prototype.onAdLog = function(t) {
  this.playerWrapper.onAdLog(t);
};
_e.prototype.getCurrentAd = function() {
  return this.sdkImpl.getCurrentAd();
};
_e.prototype.playContent = function() {
  this.playerWrapper.play();
};
_e.prototype.onLinearAdStart = function() {
  this.adUi.onLinearAdStart(), this.playerWrapper.onAdStart();
};
_e.prototype.onNonLinearAdLoad = function() {
  this.adUi.onNonLinearAdLoad();
};
_e.prototype.onNonLinearAdStart = function() {
  this.adUi.onNonLinearAdLoad(), this.playerWrapper.onAdStart();
};
_e.prototype.getPlayerWidth = function() {
  return this.playerWrapper.getPlayerWidth();
};
_e.prototype.getPlayerHeight = function() {
  return this.playerWrapper.getPlayerHeight();
};
_e.prototype.onAdsReady = function() {
  this.playerWrapper.onAdsReady();
};
_e.prototype.onPlayerResize = function(t, e) {
  this.sdkImpl.onPlayerResize(t, e);
};
_e.prototype.onContentComplete = function() {
  this.sdkImpl.onContentComplete();
};
_e.prototype.onNoPostroll = function() {
  this.playerWrapper.onNoPostroll();
};
_e.prototype.onContentAndAdsCompleted = function() {
  for (var t in this.contentAndAdsEndedListeners)
    typeof this.contentAndAdsEndedListeners[t] == "function" && this.contentAndAdsEndedListeners[t]();
};
_e.prototype.onPlayerDisposed = function() {
  this.contentAndAdsEndedListeners = [], this.sdkImpl.onPlayerDisposed();
};
_e.prototype.onPlayerReadyForPreroll = function() {
  this.sdkImpl.onPlayerReadyForPreroll();
};
_e.prototype.onAdTimeout = function() {
  this.sdkImpl.onAdTimeout();
};
_e.prototype.onPlayerReady = function() {
  this.sdkImpl.onPlayerReady();
};
_e.prototype.onPlayerEnterFullscreen = function() {
  this.adUi.onPlayerEnterFullscreen(), this.sdkImpl.onPlayerEnterFullscreen();
};
_e.prototype.onPlayerExitFullscreen = function() {
  this.adUi.onPlayerExitFullscreen(), this.sdkImpl.onPlayerExitFullscreen();
};
_e.prototype.onPlayerVolumeChanged = function(t) {
  this.adUi.onPlayerVolumeChanged(t), this.sdkImpl.onPlayerVolumeChanged(t);
};
_e.prototype.setContentWithAdTag = function(t, e) {
  this.reset(), this.settings.adTagUrl = e || this.settings.adTagUrl, this.playerWrapper.changeSource(t);
};
_e.prototype.setContentWithAdsResponse = function(t, e) {
  this.reset(), this.settings.adsResponse = e || this.settings.adsResponse, this.playerWrapper.changeSource(t);
};
_e.prototype.setContentWithAdsRequest = function(t, e) {
  this.reset(), this.settings.adsRequest = e || this.settings.adsRequest, this.playerWrapper.changeSource(t);
};
_e.prototype.reset = function() {
  this.sdkImpl.reset(), this.playerWrapper.reset(), this.adUi.reset();
};
_e.prototype.addContentEndedListener = function(t) {
  this.playerWrapper.addContentEndedListener(t);
};
_e.prototype.addContentAndAdsEndedListener = function(t) {
  this.contentAndAdsEndedListeners.push(t);
};
_e.prototype.setAdBreakReadyListener = function(t) {
  this.sdkImpl.setAdBreakReadyListener(t);
};
_e.prototype.setShowCountdown = function(t) {
  this.adUi.setShowCountdown(t), this.showCountdown = t, this.adUi.countdownDiv.style.display = this.showCountdown ? "block" : "none";
};
_e.prototype.initializeAdDisplayContainer = function() {
  this.sdkImpl.initializeAdDisplayContainer();
};
_e.prototype.playAdBreak = function() {
  this.sdkImpl.playAdBreak();
};
_e.prototype.addEventListener = function(t, e) {
  this.sdkImpl.addEventListener(t, e);
};
_e.prototype.getAdsManager = function() {
  return this.sdkImpl.getAdsManager();
};
_e.prototype.getPlayerId = function() {
  return this.playerWrapper.getPlayerId();
};
_e.prototype.changeAdTag = function(t) {
  this.reset(), this.settings.adTagUrl = t;
};
_e.prototype.pauseAd = function() {
  this.adUi.onAdsPaused(), this.sdkImpl.pauseAds();
};
_e.prototype.resumeAd = function() {
  this.adUi.onAdsPlaying(), this.sdkImpl.resumeAds();
};
_e.prototype.togglePlayback = function() {
  this.playerWrapper.togglePlayback();
};
_e.prototype.adsWillAutoplay = function() {
  return this.settings.adsWillAutoplay !== void 0 ? this.settings.adsWillAutoplay : this.settings.adWillAutoplay !== void 0 ? this.settings.adWillAutoplay : !!this.playerWrapper.getPlayerOptions().autoplay;
};
_e.prototype.adsWillPlayMuted = function() {
  return this.settings.adsWillPlayMuted !== void 0 ? this.settings.adsWillPlayMuted : this.settings.adWillPlayMuted !== void 0 ? this.settings.adWillPlayMuted : this.playerWrapper.getPlayerOptions().muted !== void 0 ? this.playerWrapper.getPlayerOptions().muted : this.playerWrapper.getVolume() == 0;
};
_e.prototype.triggerPlayerEvent = function(t, e) {
  this.playerWrapper.triggerPlayerEvent(t, e);
};
var vi = function(e, r, n) {
  this.vjsPlayer = e, this.daiController = n, this.vjsControls = this.vjsPlayer.getChild("controlBar"), this.h5Player = null, this.vjsPlayer.on("dispose", this.playerDisposedListener.bind(this)), this.vjsPlayer.on("pause", this.onPause.bind(this)), this.vjsPlayer.on("play", this.onPlay.bind(this)), this.vjsPlayer.on("seeked", this.onSeekEnd.bind(this)), this.vjsPlayer.ready(this.onPlayerReady.bind(this)), this.vjsPlayer.ads || window.console.warn("You may be using a version of videojs-contrib-ads that is not compatible with your version of video.js."), this.vjsPlayer.ads(r);
};
vi.prototype.playerDisposedListener = function() {
  this.contentEndedListeners = [], this.daiController.onPlayerDisposed();
};
vi.prototype.onPause = function() {
  this.daiController.isInAdBreak() && this.vjsControls.show();
};
vi.prototype.onPlay = function() {
  this.daiController.isInAdBreak() && this.vjsControls.hide();
};
vi.prototype.onSeekEnd = function() {
  this.daiController.onSeekEnd(this.vjsPlayer.currentTime());
};
vi.prototype.onPlayerReady = function() {
  this.h5Player = document.getElementById(this.getPlayerId()).getElementsByClassName("vjs-tech")[0], this.daiController.onPlayerReady();
};
vi.prototype.getStreamPlayer = function() {
  return this.h5Player;
};
vi.prototype.getVjsPlayer = function() {
  return this.vjsPlayer;
};
vi.prototype.getPlayerOptions = function() {
  return this.vjsPlayer.options_;
};
vi.prototype.getPlayerId = function() {
  return this.vjsPlayer.id();
};
vi.prototype.onAdError = function(t) {
  this.vjsControls.show();
  var e = t.getError !== void 0 ? t.getError() : t.stack;
  this.vjsPlayer.trigger({ type: "adserror", data: {
    AdError: e,
    AdErrorEvent: t
  } });
};
vi.prototype.onAdBreakStart = function() {
  this.vjsControls.hide();
};
vi.prototype.onAdBreakEnd = function() {
  this.vjsControls.show();
};
vi.prototype.reset = function() {
  this.vjsControls.show();
};
var yi = function(e) {
  this.daiController = e, this.streamPlayer = null, this.vjsPlayer = null, this.streamManager = null, this.uiSettings = new google.ima.dai.api.UiSettings(), this.isAdBreak = !1, this.isSnapback = !1, this.snapForwardTime = 0, this.timedMetadata, this.metadataLoaded = {}, this.SOURCE_TYPES = {
    hls: "application/x-mpegURL",
    dash: "application/dash+xml"
  };
};
yi.prototype.initImaDai = function() {
  this.streamPlayer = this.daiController.getStreamPlayer(), this.vjsPlayer = this.daiController.getVjsPlayer(), this.createAdUiDiv(), this.daiController.getSettings().locale && this.uiSettings.setLocale(this.daiController.getSettings().locale), this.streamManager = new google.ima.dai.api.StreamManager(this.streamPlayer, this.adUiDiv, this.uiSettings), this.streamPlayer.addEventListener("pause", this.onStreamPause), this.streamPlayer.addEventListener("play", this.onStreamPlay), this.streamManager.addEventListener([google.ima.dai.api.StreamEvent.Type.LOADED, google.ima.dai.api.StreamEvent.Type.ERROR, google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED, google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED], this.onStreamEvent.bind(this), !1), this.vjsPlayer.textTracks().onaddtrack = this.onAddTrack.bind(this), this.vjsPlayer.trigger({
    type: "stream-manager",
    StreamManager: this.streamManager
  }), this.requestStream();
};
yi.prototype.onAddTrack = function(t) {
  var e = this, r = t.track;
  r.kind === "metadata" && (r.mode = "hidden", r.oncuechange = function(n) {
    var i = !0, a = !1, s = void 0;
    try {
      for (var o = r.activeCues_[Symbol.iterator](), u; !(i = (u = o.next()).done); i = !0) {
        var l = u.value, d = {};
        d[l.value.key] = l.value.data, e.streamManager.onTimedMetadata(d);
      }
    } catch (h) {
      a = !0, s = h;
    } finally {
      try {
        !i && o.return && o.return();
      } finally {
        if (a)
          throw s;
      }
    }
  });
};
yi.prototype.createAdUiDiv = function() {
  var t = document.createElement("div");
  t.id = "ad-ui", t.style.height = "calc(100% - 3em)", this.streamPlayer.parentNode.appendChild(t), this.adUiDiv = t;
};
yi.prototype.onStreamPause = function() {
  this.isAdBreak && (this.adUiDiv.style.display = "none");
};
yi.prototype.onStreamPlay = function() {
  this.isAdBreak && (this.adUiDiv.style.display = "block");
};
yi.prototype.onSeekEnd = function(t) {
  var e = this.daiController.getSettings().streamType;
  if (e !== "live") {
    if (this.isSnapback) {
      this.isSnapback = !1;
      return;
    }
    var r = this.streamManager.previousCuePointForStreamTime(t);
    r && !r.played && (this.isSnapback = !0, this.snapForwardTime = t, this.vjsPlayer.currentTime(r.start));
  }
};
yi.prototype.onStreamEvent = function(t) {
  switch (t.type) {
    case google.ima.dai.api.StreamEvent.Type.LOADED:
      this.loadUrl(t.getStreamData().url);
      break;
    case google.ima.dai.api.StreamEvent.Type.ERROR:
      window.console.warn("Error loading stream, attempting to play backup stream. " + t.getStreamData().errorMessage), this.daiController.onErrorLoadingAds(t), this.daiController.getSettings().fallbackStreamUrl && this.loadurl(this.daiController.getSettings().fallbackStreamUrl);
      break;
    case google.ima.dai.api.StreamEvent.Type.AD_BREAK_STARTED:
      this.isAdBreak = !0, this.adUiDiv.style.display = "block", this.daiController.onAdBreakStart();
      break;
    case google.ima.dai.api.StreamEvent.Type.AD_BREAK_ENDED:
      this.isAdBreak = !1, this.adUiDiv.style.display = "none", this.daiController.onAdBreakEnd(), this.snapForwardTime && this.snapForwardTime > this.vjsPlayer.currentTime() && (this.vjsPlayer.currentTime(this.snapForwardTime), this.snapForwardTime = 0);
      break;
  }
};
yi.prototype.loadUrl = function(t) {
  this.vjsPlayer.ready(function() {
    var e = this.daiController.getSettings().streamFormat;
    this.vjsPlayer.src({
      src: t,
      type: this.SOURCE_TYPES[e]
    });
    var r = this.daiController.getSettings().bookmarkTime;
    if (r) {
      var n = this.streamManager.streamTimeForContentTime(r);
      this.isSnapback = !0, this.vjsPlayer.currentTime(n);
    }
  }.bind(this));
};
yi.prototype.requestStream = function() {
  var t = void 0, e = this.daiController.getSettings().streamType;
  if (e === "vod" ? (t = new google.ima.dai.api.VODStreamRequest(), t.contentSourceId = this.daiController.getSettings().cmsId, t.videoId = this.daiController.getSettings().videoId) : e === "live" ? (t = new google.ima.dai.api.LiveStreamRequest(), t.assetKey = this.daiController.getSettings().assetKey) : window.console.warn("No valid stream type selected"), t.format = this.daiController.getSettings().streamFormat, this.daiController.getSettings().apiKey && (t.apiKey = this.daiController.getSettings().apiKey), this.daiController.getSettings().authToken && (t.authToken = this.daiController.getSettings().authToken), this.daiController.getSettings().adTagParameters && (t.adTagParameters = this.daiController.getSettings().adTagParameters), this.daiController.getSettings().streamActivityMonitorId && (t.streamActivityMonitorId = this.daiController.getSettings().streamActivityMonitorId), this.daiController.getSettings().omidMode) {
    t.omidAccessModeRules = {};
    var r = this.daiController.getSettings().omidMode;
    r.FULL && (t.omidAccessModeRules[google.ima.OmidAccessMode.FULL] = r.FULL), r.DOMAIN && (t.omidAccessModeRules[google.ima.OmidAccessMode.DOMAIN] = r.DOMAIN), r.LIMITED && (t.omidAccessModeRules[google.ima.OmidAccessMode.LIMITED] = r.LIMITED);
  }
  this.streamManager.requestStream(t), this.vjsPlayer.trigger({
    type: "stream-request",
    StreamRequest: t
  });
};
yi.prototype.onPlayerReady = function() {
  this.initImaDai();
};
yi.prototype.onPlayerDisposed = function() {
  this.streamManager && this.streamManager.reset();
};
yi.prototype.getStreamManager = function() {
  return this.StreamManager;
};
yi.prototype.reset = function() {
  this.StreamManager && this.StreamManager.reset();
};
var lt = function(e, r) {
  this.inAdBreak = !1, this.settings = {}, this.isMobile = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/Android/i), this.isIos = navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i), this.initWithSettings(r);
  var n = {
    debug: this.settings.debug,
    timeout: this.settings.timeout,
    prerollTimeout: this.settings.prerollTimeout
  }, i = Object.assign({}, n, r.contribAdsSettings || {});
  this.playerWrapper = new vi(e, i, this), this.sdkImpl = new yi(this);
};
lt.IMA_DEFAULTS = {
  adLabel: "Advertisement",
  adLabelNofN: "of",
  debug: !1,
  disableAdControls: !1,
  showControlsForJSAds: !0
};
lt.prototype.initWithSettings = function(t) {
  this.settings = Object.assign({}, lt.IMA_DEFAULTS, t || {}), this.warnAboutDeprecatedSettings(), this.showCountdown = !0, this.settings.showCountdown === !1 && (this.showCountdown = !1);
};
lt.prototype.warnAboutDeprecatedSettings = function() {
  var t = this, e = [
    // Currently no DAI plugin settings are deprecated.
  ];
  e.forEach(function(r) {
    t.settings[r] !== void 0 && console.warn("WARNING: videojs.imaDai setting " + r + " is deprecated");
  });
};
lt.prototype.getSettings = function() {
  return this.settings;
};
lt.prototype.getIsMobile = function() {
  return this.isMobile;
};
lt.prototype.getIsIos = function() {
  return this.isIos;
};
lt.prototype.getStreamPlayer = function() {
  return this.playerWrapper.getStreamPlayer();
};
lt.prototype.getVjsPlayer = function() {
  return this.playerWrapper.getVjsPlayer();
};
lt.prototype.requestStream = function() {
  this.sdkImpl.requestStream();
};
lt.prototype.setSetting = function(t, e) {
  this.settings[t] = e;
};
lt.prototype.onErrorLoadingAds = function(t) {
  this.playerWrapper.onAdError(t);
};
lt.prototype.onAdError = function(t) {
  this.playerWrapper.onAdError(t);
};
lt.prototype.onAdBreakStart = function() {
  this.inAdBreak = !0, this.playerWrapper.onAdBreakStart();
};
lt.prototype.onAdBreakEnd = function() {
  this.inAdBreak = !1, this.playerWrapper.onAdBreakEnd();
};
lt.prototype.onPlayerDisposed = function() {
  this.contentAndAdsEndedListeners = [], this.sdkImpl.onPlayerDisposed();
};
lt.prototype.isInAdBreak = function() {
  return this.inAdBreak;
};
lt.prototype.onSeekEnd = function(t) {
  this.sdkImpl.onSeekEnd(t);
};
lt.prototype.onPlayerReady = function() {
  this.sdkImpl.onPlayerReady();
};
lt.prototype.reset = function() {
  this.sdkImpl.reset(), this.playerWrapper.reset();
};
lt.prototype.addEventListener = function(t, e) {
  this.sdkImpl.addEventListener(t, e);
};
lt.prototype.getStreamManager = function() {
  return this.sdkImpl.getStreamManager();
};
lt.prototype.getPlayerId = function() {
  return this.playerWrapper.getPlayerId();
};
lt.prototype.streamWillAutoplay = function() {
  return this.settings.streamWillAutoplay !== void 0 ? this.settings.streamWillAutoplay : !!this.playerWrapper.getPlayerOptions().autoplay;
};
lt.prototype.triggerPlayerEvent = function(t, e) {
  this.playerWrapper.triggerPlayerEvent(t, e);
};
function PT(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var MB = function(e, r) {
  this.controller = new _e(e, r), this.addContentAndAdsEndedListener = function(n) {
    this.controller.addContentAndAdsEndedListener(n);
  }.bind(this), this.addContentEndedListener = function(n) {
    this.controller.addContentEndedListener(n);
  }.bind(this), this.addEventListener = function(n, i) {
    this.controller.addEventListener(n, i);
  }.bind(this), this.changeAdTag = function(n) {
    this.controller.changeAdTag(n);
  }.bind(this), this.getAdsManager = function() {
    return this.controller.getAdsManager();
  }.bind(this), this.initializeAdDisplayContainer = function() {
    this.controller.initializeAdDisplayContainer();
  }.bind(this), this.pauseAd = function() {
    this.controller.pauseAd();
  }.bind(this), this.playAdBreak = function() {
    this.controller.playAdBreak();
  }.bind(this), this.requestAds = function() {
    this.controller.requestAds();
  }.bind(this), this.resumeAd = function() {
    this.controller.resumeAd();
  }.bind(this), this.setAdBreakReadyListener = function(n) {
    this.controller.setAdBreakReadyListener(n);
  }.bind(this), this.setContentWithAdTag = function(n, i) {
    this.controller.setContentWithAdTag(n, i);
  }.bind(this), this.setContentWithAdsResponse = function(n, i) {
    this.controller.setContentWithAdsResponse(n, i);
  }.bind(this), this.setContentWithAdsRequest = function(n, i) {
    this.controller.setContentWithAdsRequest(n, i);
  }.bind(this), this.setShowCountdown = function(n) {
    this.controller.setShowCountdown(n);
  }.bind(this);
}, NB = function(e, r) {
  this.controller = new lt(e, r), this.streamEndedListener = function(n) {
    this.controller.addStreamEndedListener(n);
  }.bind(this), this.addEventListener = function(n, i) {
    this.controller.addEventListener(n, i);
  }.bind(this), this.getStreamManager = function() {
    return this.controller.getStreamManager();
  }.bind(this);
}, BB = function(e) {
  this.ima = new MB(this, e);
}, FB = (
  /**
   * LiveStream class constructor used for DAI live streams.
   * @param {string} streamFormat stream format, plugin currently supports only
   * 'hls' streams.
   * @param {string} assetKey live stream's asset key.
   */
  function t(e, r) {
    if (PT(this, t), e = e.toLowerCase(), e !== "hls" && e !== "dash") {
      window.console.error("VodStream error: incorrect streamFormat.");
      return;
    } else if (e === "dash") {
      window.console.error("streamFormat error: DASH streams are notcurrently supported by this plugin.");
      return;
    } else if (typeof r != "string") {
      window.console.error("assetKey error: value must be string.");
      return;
    }
    this.streamFormat = e, this.assetKey = r;
  }
), UB = (
  /**
   * VodStream class constructor used for DAI VOD streams.
   * @param {string} streamFormat stream format, plugin currently supports only
   * 'hls' streams.
   * @param {string} cmsId VOD stream's CMS ID.
   * @param {string} videoId VOD stream's video ID.
   */
  function t(e, r, n) {
    if (PT(this, t), e = e.toLowerCase(), e !== "hls" && e !== "dash") {
      window.console.error("VodStream error: incorrect streamFormat.");
      return;
    } else if (e === "dash") {
      window.console.error("streamFormat error: DASH streams are notcurrently supported by this plugin.");
      return;
    } else if (typeof r != "string") {
      window.console.error("cmsId error: value must be string.");
      return;
    } else if (typeof n != "string") {
      window.console.error("videoId error: value must be string.");
      return;
    }
    this.streamFormat = e, this.cmsId = r, this.videoId = n;
  }
), VB = function(e, r) {
  if (e instanceof FB)
    r.streamType = "live", r.assetKey = e.assetKey;
  else if (e instanceof UB)
    r.streamType = "vod", r.cmsId = e.cmsId, r.videoId = e.videoId;
  else {
    window.console.error("initDai() first parameter must be an instance of LiveStream or VodStream.");
    return;
  }
  r.streamFormat = e.streamFormat, this.imaDai = new NB(this, r);
}, kT = P.registerPlugin || P.plugin;
kT("ima", BB);
kT("imaDai", VB);
function jB(t) {
  const e = /* @__PURE__ */ new Map(), r = !!(window.google && window.google.ima), n = {
    autoPlayAdBreaks: !1
  };
  r && (t.ima(n), t.ima.initializeAdDisplayContainer(), t.ima.setAdBreakReadyListener(() => {
  }));
  function i() {
    const l = !!e.size;
    a(), l || t.off("timeupdate", i);
  }
  function a() {
    const l = Math.ceil(t.currentTime()), d = e.get(l);
    d && (o(d), e.delete(l));
  }
  function s(l) {
    r && (t.one("play", a), t.on("timeupdate", i), l.forEach((d) => {
      const h = d.timeOffset === "start" ? 0 : Math.round(d.timeOffset);
      e.set(h, d.source);
    }));
  }
  function o(l) {
    if (r)
      try {
        t.ima.changeAdTag(l), t.pause(), t.ima.requestAds(), t.one("adsready", () => {
          t.liveTracker.isLive() && (t.ima.addEventListener(
            window.google.ima.AdEvent.Type.SKIPPED,
            () => t.play()
          ), t.ima.addEventListener(
            window.google.ima.AdEvent.Type.COMPLETE,
            () => t.play()
          )), t.ima.playAdBreak();
        });
      } catch (d) {
        console.error("An error occurred while playing the ad:", d);
      }
  }
  function u() {
    e.clear();
  }
  return {
    scheduleAds: s,
    playAd: o,
    resetAd: u
  };
}
function zB(t) {
  return t.adsAPI = jB(t), t.adsAPI;
}
S2(P);
L2(P);
const GB = "4.0.32", KB = "Wed, 08 Jan 2025 15:09:16 GMT", HB = {
  // autoplay: true,
  aspectRatio: "16:9",
  liveui: !0,
  controls: !0,
  techOrder: ["chromecast", "html5"],
  controlBar: {
    currentTimeDisplay: !0,
    durationDisplay: !0,
    customControlSpacer: !0,
    remainingTimeDisplay: !1
  },
  plugins: {
    pano: !0,
    trim: !0,
    tags: !0,
    chromecast: {
      addButtonToControlBar: !0,
      buttonPositionIndex: 16
      //   modifyLoadRequestFn: function (loadRequest: any) { // HLS fMP4 support
      //     console.log(loadRequest);
      //     loadRequest.media.hlsSegmentFormat = "fmp4";
      //     loadRequest.media.hlsVideoSegmentFormat = "fmp4";
      //     return loadRequest;
      //  }
      // addCastLabelToButton: true,
    },
    airPlay: {
      addButtonToControlBar: !0,
      // defaults to `true`
      buttonPositionIndex: 16
    },
    hotkeys: {
      volumeStep: 0.1,
      seekStep: 5,
      enableModifiersForNumbers: !1
    },
    spriteThumbnails: {}
  }
};
function XB(t, e) {
  const r = P.mergeOptions(HB, e), n = P(t, r);
  return n.el().id = n.id(), typeof r.defaultVolume == "number" && n.volume(r.defaultVolume), n;
}
export {
  KB as buildDate,
  zB as setupAdvertisementPlugin,
  XB as setupPlayer,
  GB as version
};
